webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getFocusedElementId */
/* unused harmony export findElementAndFocus */
/* unused harmony export isPromise */
/* harmony export (immutable) */ __webpack_exports__["d"] = getParameterByName;
/* harmony export (immutable) */ __webpack_exports__["e"] = removeURLParameter;
/* unused harmony export facebookPixel */
/* harmony export (immutable) */ __webpack_exports__["a"] = isEditMode;
/* harmony export (immutable) */ __webpack_exports__["b"] = getNameByDonationType;
/* harmony export (immutable) */ __webpack_exports__["c"] = getNameByPaymentType;
/* harmony export (immutable) */ __webpack_exports__["i"] = getProductTypeMapping;
/* harmony export (immutable) */ __webpack_exports__["h"] = getTaxBrackeList;
/* harmony export (immutable) */ __webpack_exports__["g"] = getCountriesList;
/* harmony export (immutable) */ __webpack_exports__["j"] = getCountriesListForMenu;
/* harmony export (immutable) */ __webpack_exports__["k"] = getAustralianStateByPostcode;
/* harmony export (immutable) */ __webpack_exports__["f"] = luhnCheck;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);


function getFocusedElementId() {
    return document.activeElement.id;
}
function findElementAndFocus(elemId) {
    var elem = document.getElementById(elemId);
    elem.focus();
}
function isPromise(func) {
    return func.then && typeof func.then === 'function';
}
function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
function removeURLParameter(parameter) {
    var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.href;

    //prefer to use l.search if you have a location/link object
    var urlparts = url.split('?');
    if (urlparts.length >= 2) {

        var prefix = encodeURIComponent(parameter) + '=';
        var pars = urlparts[1].split(/[&;]/g);

        //reverse iteration as may be destructive
        for (var i = pars.length; i-- > 0;) {
            //idiom for string.startsWith
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                pars.splice(i, 1);
            }
        }

        return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
    }
    return url;
}
function facebookPixel(_eventName) {
    $window.fbq('trackCustom', _eventName, { myParam: _eventName });
}

function isEditMode() {
    var url = window.location.pathname;
    var filename = url.substring(url.lastIndexOf('/') + 1);
    return filename == "edit.aspx" || filename == "Edit.aspx";
}

function getNameByDonationType(type) {

    var typename = null;

    switch (type) {
        case "Single":
            typename = "Single Donation";
            break;
        case "Regular":
            typename = "Monthly Donation";
            break;
        case "Annual":
            typename = "Annual Donation";
            break;
        default:
            typename = "Other Donation";
    }
    return typename;
}

function getNameByPaymentType(type) {

    var typename = null;

    switch (type) {
        case "wwf_purchasetokenise":
            typename = "Credit card";
            break;
        case "wwf_directdebit":
            typename = "Direct debit";
            break;
        case "wwf_paypal":
            typename = "Paypal";
            break;
        default:
            typename = "Other";
    }
    return typename;
}

function getProductTypeMapping(type) {
    var lowered = type.toLowerCase();

    switch (lowered) {
        case 'appeal':
        case 'donation':
            return 'Donate';
        case 'adoption':
            return 'Adopt';
        default:
            return type;
    }
}

function getTaxBrackeList() {
    return [{ bracket: '$18201 - $45000', tax: '0.19' }, { bracket: '$45001 - $120000', tax: '0.325' }, { bracket: '$120001 - $180000', tax: '0.37' }, { bracket: 'Over $180000', tax: '0.45' }];
}

function getCountriesList() {

    var countries = __webpack_require__(747);

    return countries;
}
function getCountriesListForMenu() {
    var countriesForMenu = __webpack_require__(748);

    return countriesForMenu;
}

var POSTCODE_RANGES = __webpack_require__(746);

// https://en.wikipedia.org/wiki/Postcodes_in_Australia
function getAustralianStateByPostcode(postcode) {
    if (isNaN(postcode)) {
        throw new Error('Postcode is not a number');
    }

    postcode = Number(postcode);
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(POSTCODE_RANGES)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var state = _step.value;

            var ranges = POSTCODE_RANGES[state];

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(ranges), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var r = _step2.value;

                    if (postcode >= r[0] && postcode <= r[1]) {
                        return state;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return null;
}

// https://www.creditcardvalidator.org/developer
function luhnCheck(input) {
    var luhnArr = [0, 2, 4, 6, 8, 1, 3, 5, 7, 9];
    var counter = 0;
    var incNum = void 0;
    var odd = false;
    var temp = String(input).replace(/[^\d]/g, "");

    if (temp.length == 0) return false;

    for (var i = temp.length - 1; i >= 0; --i) {
        incNum = parseInt(temp.charAt(i), 10);
        counter += (odd = !odd) ? incNum : luhnArr[incNum];
    }

    return counter % 10 == 0;
}

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function pushProductDetail(name, productId, productType, donationType) {
  if (window.dataLayer != undefined) {
    window.dataLayer.push({
      ecommerce: {
        detail: {
          products: [{
            // List of productFieldObjects.
            name: name, // Name or ID is required.
            id: productType + "|" + donationType + "|" + productId,
            quantity: '1',
            'category': productType,
            'variant': donationType
          }]
        }
      }
    });
  }
}

function pushProductImpression(name, productId, productType, donationType) {
  if (window.dataLayer != undefined) {
    window.dataLayer.push({
      ecommerce: {
        impressions: {
          products: [{
            // List of productFieldObjects.
            name: name, // Name or ID is required.
            id: productType + "|" + donationType + "|" + productId,
            quantity: '1',
            'category': productType,
            'variant': donationType
          }]
        }
      }
    });
  }
}

function pushAddToCart(name, productId, price, productType, donationType) {
  if (window.dataLayer != undefined) {
    window.dataLayer.push({
      event: "addToCart",
      ecommerce: {
        currencyCode: "AUD",
        add: {
          products: [{
            // List of productFieldObjects.
            name: name, // Name or ID is required.
            id: productType + "|" + donationType + "|" + productId,
            price: price,
            quantity: "1",
            'category': productType,
            'variant': donationType
          }]
        }
      }
    });
  }
}

function pushRemoveFromCart(name, productId, price, productType, donationType) {
  if (window.dataLayer != undefined) {
    window.dataLayer.push({
      event: "removeFromCart",
      ecommerce: {
        currencyCode: "AUD",
        add: {
          products: [{
            // List of productFieldObjects.
            name: name, // Name or ID is required.
            id: productType + "|" + donationType + "|" + productId,
            price: price,
            quantity: "1",
            'category': productType,
            'variant': donationType
          }]
        }
      }
    });
  }
}

function pushCheckout(name, productId, price, productType, donationType) {
  if (window.dataLayer != undefined) {
    window.dataLayer.push({
      event: "checkout",
      ecommerce: {
        currencyCode: "AUD",
        checkout: {
          products: [{
            // List of productFieldObjects.
            name: name, // Name or ID is required.
            id: productType + "|" + donationType + "|" + productId,
            price: price,
            quantity: "1",
            'category': productType,
            'variant': donationType
          }]
        }
      }
    });
  }
}

function pushPurchase(transactionId, name, productId, productType, donationType, price, postcode, paymentType, callback) {
  if (window.dataLayer != undefined) {
    window.dataLayer.push({
      'event': 'purchase',
      'ecommerce': {
        'purchase': {
          'actionField': {
            'id': transactionId,
            'affiliation': 'WWF Online Shop',
            'revenue': price,
            'tax': '0.00',
            'shipping': '0.00'
          },
          'products': [{ // List of productFieldObjects.
            'name': name, // Name or ID is required.
            'id': productType + "|" + donationType + "|" + productId,
            'price': price,
            'category': productType,
            'variant': donationType,
            'quantity': '1',
            'dimension4': postcode,
            'dimension5': paymentType
          }]
        }
      },
      'eventCallback': callback ? callback() : function () {}
    });
  }
}

function formSubmitEvent(formName) {
  if (window.dataLayer != undefined) {
    window.dataLayer.push({
      formName: formName,
      event: "formSubmitEvent"
    });
  }
}

function formSubmitSuccessEvent(formName) {
  if (window.dataLayer != undefined) {
    window.dataLayer.push({
      formName: formName,
      event: "formSubmitSuccessEvent"
    });
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  pushProductDetail: pushProductDetail,
  pushProductImpression: pushProductImpression,
  pushAddToCart: pushAddToCart,
  pushRemoveFromCart: pushRemoveFromCart,
  pushCheckout: pushCheckout,
  pushPurchase: pushPurchase,
  formSubmitEvent: formSubmitEvent,
  formSubmitSuccessEvent: formSubmitSuccessEvent
});

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(463)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(315),
  /* template */
  __webpack_require__(685),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-48293ce1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(422)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(327),
  /* template */
  __webpack_require__(643),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0ebdb0a4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */,
/* 63 */,
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(332),
  /* template */
  __webpack_require__(704),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(480)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(364),
  /* template */
  __webpack_require__(700),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-71255a36",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(501)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(399),
  /* template */
  __webpack_require__(723),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b5799bdc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(428)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(316),
  /* template */
  __webpack_require__(650),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-19c3abbe",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(444)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(319),
  /* template */
  __webpack_require__(666),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2cc6eae8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(454)
  __webpack_require__(453)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(330),
  /* template */
  __webpack_require__(676),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3a97ffa1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(429)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(331),
  /* template */
  __webpack_require__(651),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1a1b73bb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(522)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(394),
  /* template */
  __webpack_require__(743),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-faa290c0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(521)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(395),
  /* template */
  __webpack_require__(742),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fa8661be",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(519)
  __webpack_require__(520)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(396),
  /* template */
  __webpack_require__(741),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fa6a32bc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(469)
  __webpack_require__(470)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(397),
  /* template */
  __webpack_require__(691),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-51eb3470",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_campaign__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_products__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_ecommerce__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_packages__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_donate__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_update_details__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_loyalty__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_popup__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_sensis__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_search__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_earth_hour__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_auth__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_leaf_relief__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_amplitude__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_kickbox__ = __webpack_require__(298);
/**
 * Register vue and vuex components
 * @requires Vue vuejs
 * @requires Vuex state management
 */


















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* default */].Store({
  strict: false,
  modules: {
    campaign: __WEBPACK_IMPORTED_MODULE_2__modules_campaign__["a" /* default */],
    product: __WEBPACK_IMPORTED_MODULE_3__modules_products__["a" /* default */],
    packages: __WEBPACK_IMPORTED_MODULE_5__modules_packages__["a" /* default */],
    donation: __WEBPACK_IMPORTED_MODULE_6__modules_donate__["a" /* default */],
    updates: __WEBPACK_IMPORTED_MODULE_7__modules_update_details__["a" /* default */],
    loyalty: __WEBPACK_IMPORTED_MODULE_8__modules_loyalty__["a" /* default */],
    popup: __WEBPACK_IMPORTED_MODULE_9__modules_popup__["a" /* default */],
    sensis: __WEBPACK_IMPORTED_MODULE_10__modules_sensis__["a" /* default */],
    search: __WEBPACK_IMPORTED_MODULE_11__modules_search__["a" /* default */],
    earthHour: __WEBPACK_IMPORTED_MODULE_12__modules_earth_hour__["a" /* default */],
    auth: __WEBPACK_IMPORTED_MODULE_13__modules_auth__["a" /* default */],
    leafRelief: __WEBPACK_IMPORTED_MODULE_14__modules_leaf_relief__["a" /* default */],
    ecommerce: __WEBPACK_IMPORTED_MODULE_4__modules_ecommerce__["a" /* default */],
    amplitude: __WEBPACK_IMPORTED_MODULE_15__modules_amplitude__["a" /* default */],
    kickbox: __WEBPACK_IMPORTED_MODULE_16__modules_kickbox__["a" /* default */]
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

// Read Environment Variables and assign them to a global window variable
window.wwfconfigs = __webpack_require__.i({"NODE_ENV":"production","FIREBASE":'https://wwf-australia-prod-default-rtdb.firebaseio.com/',"CLOUDFUNCTION":'https://australia-southeast1-wwf-australia-prod.cloudfunctions.net',"ASSETS_BUCKET":'https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/',"CHECKOUT":'checkout',"SKY":'sky',"PAYPAL":'paypal',"PAYPALEXECUTE":'paypalExecute',"PAYMENT":'https://www.ippayments.com.au/access/index.aspx',"NEWSLETTERSUBSCRIBELIST":'ENG 2017-08-21 Subscribe form',"DONATEURL":'https://donate.wwf.org.au',"MERCHANTID":'0be3c421-fcb3-4c91-bfb9-8d7d1087cc8f',"BAMBORA_CUSTOM_CHECKOUT_SCRIPT":'https://customcheckout.bambora.com.au/2.0.0/customcheckout.min.js',"PAYMENTCREDITCARD":'creditCardPurchase',"PAYMENTDIRECTDEBIT":'directDebitPurchase',"PAYPALCHECKOUT":'paypalCheckout',"PAYMENTPAYPAL":'paypalPurchase',"FUNNELBACK_SEARCH_URL":'https://wwf-au-search.clients.funnelback.com/s',"FUNNELBACK_COLLECTION":'wwf-au-search',"SEARCH_RESULTS":'/search',"CREATE_DONATION":'createDonation',"UPDATE_DONATION":'updateDonation',"FIREBASE_API_KEY":'AIzaSyAmTsZbt0BRRj1t6OxV2_4K8RYBfLJJHtQ',"FIREBASE_PROJECT_ID":'wwf-australia-prod',"FIREBASE_AUTH_API_KEY":'AIzaSyDUAGmkHeEYDaYvz-nDsWUqP2vVE5As2YA',"FIREBASE_AUTH_PROJECT_ID":'wwf-australia-auth-prod',"AMPLITUDE_API_KEY":'8cc4d32a34ae240651205818cbc2101e',"WEB_API":'https://web-api-prod-flpcd3m6xq-ts.a.run.app/v1'});

/***/ }),
/* 216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 218 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 219 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 220 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 221 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 222 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 223 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 224 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 225 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 226 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 227 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 228 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 229 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 230 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 231 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(505)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(308),
  /* template */
  __webpack_require__(728),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c828248e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(447)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(309),
  /* template */
  __webpack_require__(669),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-32ad82aa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(433)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(310),
  /* template */
  __webpack_require__(656),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-207712ec",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(311),
  /* template */
  __webpack_require__(670),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(500)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(312),
  /* template */
  __webpack_require__(722),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ae13deb4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(474)
  __webpack_require__(475)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(313),
  /* template */
  __webpack_require__(695),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5c271fff",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(496)
  __webpack_require__(497)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(314),
  /* template */
  __webpack_require__(719),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-aa06f2d2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(437)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(317),
  /* template */
  __webpack_require__(660),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-223e1212",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(516)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(318),
  /* template */
  __webpack_require__(738),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-dcc81d88",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(421)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(320),
  /* template */
  __webpack_require__(642),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0dd69dfc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(507)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(321),
  /* template */
  __webpack_require__(730),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ca944456",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(322),
  /* template */
  __webpack_require__(712),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(434)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(324),
  /* template */
  __webpack_require__(657),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(419)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(325),
  /* template */
  __webpack_require__(640),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(326),
  /* template */
  __webpack_require__(731),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(503)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(340),
  /* template */
  __webpack_require__(726),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c25a392a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(485)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(343),
  /* template */
  __webpack_require__(706),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7ff9704f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(502)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(345),
  /* template */
  __webpack_require__(724),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-baffded8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(495)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(346),
  /* template */
  __webpack_require__(718),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a8f488e0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(511)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(347),
  /* template */
  __webpack_require__(735),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d522fa7e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(476)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(348),
  /* template */
  __webpack_require__(696),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5d656a98",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(483)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(349),
  /* template */
  __webpack_require__(703),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-76a2384c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(523)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(350),
  /* template */
  __webpack_require__(744),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fac4a766",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(462)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(353),
  /* template */
  __webpack_require__(684),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-474999a5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(517)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(357),
  /* template */
  __webpack_require__(739),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e7be150c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(514)
  __webpack_require__(515)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(358),
  /* template */
  __webpack_require__(737),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d8d6b0aa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(508)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(359),
  /* template */
  __webpack_require__(732),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-cdf3681e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(458)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(360),
  /* template */
  __webpack_require__(680),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3d94d83e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(446)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(361),
  /* template */
  __webpack_require__(668),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-322fb19d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(423)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(362),
  /* template */
  __webpack_require__(644),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-116c63e8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(464)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(363),
  /* template */
  __webpack_require__(686),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4d6c2553",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(431)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(365),
  /* template */
  __webpack_require__(654),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1ae921bd",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(477)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(366),
  /* template */
  __webpack_require__(697),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-604b0107",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(493)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(367),
  /* template */
  __webpack_require__(715),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a34706fa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(445)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(371),
  /* template */
  __webpack_require__(667),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2ce57914",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(491)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(372),
  /* template */
  __webpack_require__(713),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9c754f2a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(436)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(373),
  /* template */
  __webpack_require__(659),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-21c11e58",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(448)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(374),
  /* template */
  __webpack_require__(671),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-34d8144e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(460)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(377),
  /* template */
  __webpack_require__(682),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4308e4dc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(487)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(379),
  /* template */
  __webpack_require__(708),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8c687b5a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(486)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(384),
  /* template */
  __webpack_require__(707),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8269dc7a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(461)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(386),
  /* template */
  __webpack_require__(683),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4414d9ea",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(489)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(387),
  /* template */
  __webpack_require__(710),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-970ee786",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(465)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(388),
  /* template */
  __webpack_require__(687),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4e68387d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(443)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(389),
  /* template */
  __webpack_require__(665),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2c461cb8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(390),
  /* template */
  __webpack_require__(717),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(512)
  __webpack_require__(513)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(391),
  /* template */
  __webpack_require__(736),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d7f2be86",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(440)
  __webpack_require__(439)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(392),
  /* template */
  __webpack_require__(662),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2495e1f4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(456)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(393),
  /* template */
  __webpack_require__(678),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3b64632e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(466)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(410),
  /* template */
  __webpack_require__(688),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4f387d47",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(413),
  /* template */
  __webpack_require__(725),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(424)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(415),
  /* template */
  __webpack_require__(645),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1438cf98",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_amplitude_js__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_amplitude_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_amplitude_js__);




var client = __WEBPACK_IMPORTED_MODULE_2_amplitude_js___default.a.getInstance('wwfMain');

// Name conventions for Amplitude charting
var paymentName = {
  'wwf_purchasetokenise': 'CC',
  'wwf_directdebit': 'DD',
  'wwf_paypal': 'Paypal'
};

// Helper functions required for specific pages/products
function isImpactProductPage() {
  return !!document.getElementById('impact-product-header');
}
function isChampionsPage() {
  return !!document.getElementById('amplitude-ra-champions');
}
function isHubPage() {
  return !!document.getElementById("amplitude-ra-hub");
}
function isLeafReliefPage() {
  return !!document.getElementById("amplitude-leaf-relief");
}
function isEarthHourPage() {
  return !!document.getElementById("amplitude-earth-hour");
}

function checkAdoptionType(product) {
  // Check if adoption product is within native, international or ecommerce page
  var isEcommerce = product.extrasetting && product.extrasetting.isEcommerce;
  var isInternational = window.location.href.includes("international");

  if (isEcommerce) return "single";
  if (isInternational) return "international";
  return "native";
}

function checkFilterPage() {
  // Check what page the ecommerce filter is used on
  var isAdoption = window.location.href.includes("adopt");
  var isWildcard = window.location.href.includes("wildcard");

  if (isAdoption) return "Adoption";
  if (isWildcard) return "Wildcard";
  return "Regenerator store";
}

function getPageName() {
  // Get page name from h1 heading or generate one from url path
  return $('h1').first().text().trim() || window.location.pathname.split('/').splice(-1)[0];
}

var state = {
  sessionId: null,
  capturedEvents: []
};

var getters = {
  amplitudeId: function amplitudeId(state) {
    return state.sessionId;
  }
};

var mutations = {
  setSessionId: function setSessionId(state, sessionId) {
    state.sessionId = sessionId;
  },
  pushCapturedEvent: function pushCapturedEvent(state, event) {
    state.capturedEvents.push(event);
  },
  clearCapturedEvents: function clearCapturedEvents(state) {
    state.capturedEvents = [];
  }
};

var actions = {
  initAmplitude: function initAmplitude(_ref) {
    var getters = _ref.getters,
        dispatch = _ref.dispatch,
        commit = _ref.commit;

    try {
      var apiKey = wwfconfigs.AMPLITUDE_API_KEY;
      var userId = getters.ssoId;
      var options = {
        includeReferrer: true,
        saveEvents: true,
        includeUtm: true,
        includeGclid: true,
        saveParamsReferrerOncePerSession: false
      };

      client.init(apiKey, userId, options);

      commit('setSessionId', client.getSessionId());
      dispatch('sendCapturedEvents');
    } catch (err) {
      console.error(err);
    }
  },
  captureEvent: function captureEvent(_ref2, _ref3) {
    var commit = _ref2.commit;
    var eventName = _ref3.eventName,
        eventProperties = _ref3.eventProperties;

    try {
      // Shape - { timestamp, eventName, eventProperties }
      var eventDetails = { timestamp: Date.now(), eventName: eventName, eventProperties: eventProperties };
      commit('pushCapturedEvent', eventDetails);
    } catch (err) {
      console.error(err);
    }
  },
  sendCapturedEvents: function sendCapturedEvents(_ref4) {
    var state = _ref4.state,
        commit = _ref4.commit;

    try {
      state.capturedEvents.forEach(function (event) {
        client.logEventWithTimestamp(event.eventName, event.eventProperties, event.timestamp);
      });
      commit('clearCapturedEvents');
    } catch (err) {
      console.error(err);
    }
  },


  // AMPLITUDE PAGE VISIT ACTIONS

  logLandingVisit: function logLandingVisit(_ref5, id) {
    var getters = _ref5.getters,
        dispatch = _ref5.dispatch;

    try {
      var pageName = id || getPageName();
      var donation = getters.donation;

      var eventName = 'page viewed';
      var eventProperties = {
        'Source': document.referrer,
        'Page name': pageName,
        'Page Path': window.location.pathname,
        'Page URL': window.location.href
      };

      // Don't log if processing paypal payment & earth hour 
      if (donation.isProcessing || window.location.href.includes("PayerID")) return;
      if (pageName === "earth-hour" && window.location.pathname === "/") return;

      // Capture event if ssoId or amplitude not ready, will be sent once amplitude is initialized with ssoId
      if (!getters.ssoId || !getters.amplitudeId) {
        dispatch('captureEvent', { eventName: eventName, eventProperties: eventProperties });
        return;
      }
      client.logEvent(eventName, eventProperties);
    } catch (err) {
      console.error(err);
    }
  },
  logProductVisit: function logProductVisit(_ref6) {
    var getters = _ref6.getters,
        dispatch = _ref6.dispatch;

    try {
      var product = getters.product,
          donation = getters.donation;

      var eventName = isImpactProductPage() ? 'project viewed' : 'product viewed';
      var eventProperties = {
        'Product ID': product.id,
        'Source': document.referrer
      };

      // Don't log if processing paypal payment
      if (donation.isProcessing || window.location.href.includes("PayerID")) return;

      // Champions page doesn't require this log
      if (isChampionsPage()) return;

      // Capture event if ssoId or amplitude not ready, will be sent once amplitude is initialized with ssoId
      if (!getters.ssoId || !getters.amplitudeId) {
        dispatch('captureEvent', { eventName: eventName, eventProperties: eventProperties });
        return;
      }

      client.logEvent(eventName, eventProperties);
    } catch (err) {
      console.error(err);
    }
  },


  // AMPLITUDE ECOMMERCE ACTIONS

  logProductFilter: function logProductFilter(context, filter) {
    try {
      var eventProperties = {
        'Page name': checkFilterPage(),
        'Filter Type': filter
      };
      client.logEvent('product filtered', eventProperties);
    } catch (err) {
      console.error(err);
    }
  },


  // AMPLITUDE FORM FLOW ACTIONS

  logFormBegin: function logFormBegin(_ref7, fieldName) {
    var getters = _ref7.getters,
        dispatch = _ref7.dispatch;

    try {
      var product = getters.product,
          donation = getters.donation;

      var eventName = 'donation form started';
      var eventProperties = {
        'Product ID': product.id,
        'Donation Type': donation.type,
        'Amount': donation.amount,
        'Field': fieldName
      };

      if (product.producttype == 'wildcard') {
        eventName = 'wildcard form started';
      }

      if (product.producttype == 'adoption') {
        var type = checkAdoptionType(product);
        eventName = type + ' adoption form started';
      }

      if (isImpactProductPage()) {
        eventName = 'impact project form started';
      }

      // Capture event if ssoId or amplitude not ready, will be sent once amplitude is initialized with ssoId
      if (!getters.ssoId || !getters.amplitudeId) {
        dispatch('captureEvent', { eventName: eventName, eventProperties: eventProperties });
        return;
      }

      client.logEvent(eventName, eventProperties);
    } catch (err) {
      console.error(err);
    }
  },
  logFormProduct: function logFormProduct(_ref8) {
    var getters = _ref8.getters;

    try {
      var product = getters.product,
          donation = getters.donation;

      var eventProperties = {
        'Donation Type': donation.type,
        'Product ID': product.id,
        'Payment Type': paymentName[donation.payementType],
        'Amount': donation.amount
      };

      if (product.producttype == 'wildcard') {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(eventProperties, {
          'Occasion ID': product.productname,
          'Design ID': donation.packagecode
        });
      }

      if (product.producttype == 'adoption') {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(eventProperties, {
          'Species name': product.productname,
          'Pack ID': donation.packagecode,
          'Adoption as Gift': donation.isGift ? 'yes' : 'no'
        });
      }

      // Attach extra info on user for Amplitude charting
      client.setUserProperties({
        'Amount': donation.amount,
        'Donation Type': donation.type,
        'Product Type': product.producttype
      });

      client.logEvent('product selected', eventProperties);
    } catch (err) {
      console.error(err);
    }
  },
  logFormRecipient: function logFormRecipient(_ref9) {
    var getters = _ref9.getters;

    try {
      var product = getters.product,
          donation = getters.donation;

      var eventProperties = { 'Product ID': product.id };

      if (donation.gift.postcode) {
        eventProperties['Post Code'] = donation.gift.postcode;
      }

      client.logEvent('recipient details provided', eventProperties);
    } catch (err) {
      console.error(err);
    }
  },
  logFormSupporter: function logFormSupporter(_ref10) {
    var getters = _ref10.getters;

    try {
      var product = getters.product,
          donation = getters.donation;

      var eventProperties = {
        'Product ID': product.id,
        'Post Code': donation.billing.postcode,
        'Marketing opt-in': donation.optin ? 'yes' : 'no',
        'Business': donation.isBehalfBusiness ? 'yes' : 'no',
        'Bequest': donation.bequest ? 'yes' : 'no'
      };

      // Attach extra info on user for Amplitude charting
      client.setUserProperties({
        'Post Code': donation.billing.postcode,
        'Marketing opt-in': donation.optin ? 'yes' : 'no'
      });

      client.logEvent('supporter details provided', eventProperties);
    } catch (err) {
      console.error(err);
    }
  },
  logFormPayAttempt: function logFormPayAttempt(_ref11) {
    var getters = _ref11.getters;

    try {
      var donation = getters.donation,
          product = getters.product;

      var eventProperties = {
        'Product ID': product.id,
        'Donation Type': donation.type,
        'Amount': donation.amount,
        'Payment Type': paymentName[donation.payementType]
      };

      if (isHubPage() || isLeafReliefPage()) {
        eventProperties['Form Placement'] = isHubPage() ? "RA Hub" : "Leaf Relief Landing";
      }

      client.logEvent('payment details provided', eventProperties);
    } catch (err) {
      console.error(err);
    }
  },
  logFormPayFail: function logFormPayFail(_ref12, errorMessage) {
    var getters = _ref12.getters;

    try {
      var product = getters.product,
          donation = getters.donation;

      var eventProperties = {
        'Product ID': product.id,
        'Amount': donation.amount,
        'Donation Type': donation.type,
        'Payment failed type': errorMessage
      };

      if (isHubPage() || isLeafReliefPage()) {
        eventProperties['Form Placement'] = isHubPage() ? "RA Hub" : "Leaf Relief Landing";
      }

      client.logEvent('payment failed', eventProperties);
    } catch (err) {
      console.error(err);
    }
  },
  logFormPaySuccess: function logFormPaySuccess(_ref13, transactionId) {
    var getters = _ref13.getters;

    try {
      var product = getters.product,
          donation = getters.donation;

      var eventProperties = {
        'Product ID': product.id,
        'Amount': donation.amount,
        'Transaction ID': transactionId,
        'Donation Type': donation.type
      };

      if (isHubPage() || isLeafReliefPage()) {
        eventProperties['Form Placement'] = isHubPage() ? "RA Hub" : "Leaf Relief Landing";
      }

      var revenue = new __WEBPACK_IMPORTED_MODULE_2_amplitude_js___default.a.Revenue().setProductId(product.id).setPrice(parseFloat(donation.amount)).setQuantity(1);
      client.logRevenueV2(revenue);
      client.logEvent('payment successful', eventProperties);
    } catch (err) {
      console.error(err);
    }
  },
  logDonationComplete: function logDonationComplete(_ref14, paypalDonate) {
    var getters = _ref14.getters;

    try {
      var product = getters.product,
          donation = getters.donation;

      var eventProperties = {
        'Product ID': paypalDonate ? paypalDonate.productid : product.id,
        'Donation Type': paypalDonate ? paypalDonate.type : donation.type
      };

      client.logEvent('donation confirmation sent', eventProperties);
    } catch (err) {
      console.error(err);
    }
  },


  // AMPLITUDE LEAF RELIEF FORM ACTIONS

  logLeafBegin: function logLeafBegin(_ref15, fieldName) {
    var getters = _ref15.getters,
        dispatch = _ref15.dispatch;

    try {
      var product = getters.product,
          treeCount = getters.treeCount;

      var eventName = 'leaf relief form started';
      var eventProperties = {
        'Product ID': product.id,
        'Counter Total': treeCount,
        'Form Placement': isHubPage() ? "RA Hub" : "Leaf Relief Landing",
        'Field': fieldName
      };

      // Capture event if ssoId or amplitude not ready, will be sent once amplitude is initialized with ssoId
      if (!getters.ssoId || !getters.amplitudeId) {
        dispatch('captureEvent', { eventName: eventName, eventProperties: eventProperties });
        return;
      }

      client.logEvent(eventName, eventProperties);
    } catch (err) {
      console.error(err);
    }
  },
  logLeafProduct: function logLeafProduct(_ref16, postcode) {
    var getters = _ref16.getters;

    try {
      var product = getters.product,
          donation = getters.donation,
          isDonation = getters.isDonation;

      var type = isDonation ? 'Restore a forest' : 'Plant a tree';

      // Attach extra info on user for Amplitude charting
      client.setUserProperties({
        'Post Code': postcode
      });

      client.logEvent('product selected', {
        'Leaf relief type': type,
        'Amount': isDonation ? donation.amount : '',
        'Form Placement': isHubPage() ? "RA Hub" : "Leaf Relief Landing"
      });
      client.logEvent('supporter details provided', {
        'Leaf relief type': type,
        'Product ID': product.id,
        'Post Code': postcode,
        'Form Placement': isHubPage() ? "RA Hub" : "Leaf Relief Landing"
      });
    } catch (err) {
      console.error(err);
    }
  },
  logLeafComplete: function logLeafComplete(_ref17) {
    var getters = _ref17.getters;

    try {
      var product = getters.product,
          isDonation = getters.isDonation,
          treeCount = getters.treeCount;

      var type = isDonation ? 'Restore a forest' : 'Plant a tree';
      var eventName = isDonation ? "lr donation confirmation sent" : "registration successful";
      var eventProperties = {
        'Leaf relief type': type,
        'Product ID': product.id,
        'Form Placement': isHubPage() ? "RA Hub" : "Leaf Relief Landing"
      };

      if (!isDonation) {
        eventProperties["Counter Total"] = treeCount;
      }

      client.logEvent(eventName, eventProperties);
    } catch (err) {
      console.error(err);
    }
  },


  // AMPLITUDE RA HUB ACTIONS

  logTabView: function logTabView(context, name) {
    try {
      client.logEvent('priority tabs viewed', {
        'Tab name': name
      });
    } catch (err) {
      console.error(err);
    }
  },
  logTabAction: function logTabAction(context, _ref18) {
    var name = _ref18.name,
        link = _ref18.link;

    try {
      client.logEvent('priority tab actioned', {
        'Tab name': name,
        'Link ID': link
      });
    } catch (err) {
      console.error(err);
    }
  },
  logProductLink: function logProductLink(context, _ref19) {
    var id = _ref19.id,
        link = _ref19.link;

    try {
      client.logEvent("ra product link clicked", {
        "Link ID": id,
        "Destination url": link
      });
    } catch (err) {
      console.error(err);
    }
  },
  logContentLink: function logContentLink(context, link) {
    try {
      client.logEvent("ra content link clicked", {
        "Destination url": link
      });
    } catch (err) {
      console.error(err);
    }
  },


  // AMPLITUDE EARTH HOUR

  logEarthHourStart: function logEarthHourStart(_ref20, _ref21) {
    var getters = _ref20.getters,
        dispatch = _ref20.dispatch;
    var fieldName = _ref21.fieldName,
        productName = _ref21.productName;

    try {
      var eventName = 'earth hour form started';
      var eventProperties = {
        'Product name': productName,
        'Form Placement': isEarthHourPage() ? "Homepage" : "Register",
        'First touch': fieldName
      };

      // Capture event if ssoId or amplitude not ready, will be sent once amplitude is initialized with ssoId
      if (!getters.ssoId || !getters.amplitudeId) {
        dispatch('captureEvent', { eventName: eventName, eventProperties: eventProperties });
        return;
      }

      client.logEvent(eventName, eventProperties);
    } catch (err) {
      console.error(err);
    }
  },
  logEarthHourDetails: function logEarthHourDetails(_ref22, _ref23) {
    var getters = _ref22.getters,
        dispatch = _ref22.dispatch;
    var fieldName = _ref23.fieldName,
        content = _ref23.content,
        productName = _ref23.productName;

    try {
      var eventName = 'supporter details provided';
      var eventProperties = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'Product name': productName,
        'Form Placement': isEarthHourPage() ? "Homepage" : "Register"
      }, fieldName, content);

      client.logEvent(eventName, eventProperties);
    } catch (err) {
      console.error(err);
    }
  },
  logEarthHourDownArrow: function logEarthHourDownArrow(_ref24, link) {
    var getters = _ref24.getters,
        dispatch = _ref24.dispatch;

    try {
      var eventName = 'down arrow clicked';
      var eventProperties = {
        "Source page": getPageName(),
        "URL name": link
      };

      client.logEvent(eventName, eventProperties);
    } catch (err) {
      console.error(err);
    }
  },
  logEarthHourPopup: function logEarthHourPopup(_ref25, _ref26) {
    var getters = _ref25.getters,
        dispatch = _ref25.dispatch;
    var name = _ref26.name,
        url = _ref26.url;

    try {
      var eventProperties = {
        "Source page": getPageName(),
        "URL name": url
      };

      client.logEvent(name, eventProperties);
    } catch (err) {
      console.error(err);
    }
  },
  logEarthHourVisit: function logEarthHourVisit(_ref27, _ref28) {
    var getters = _ref27.getters,
        dispatch = _ref27.dispatch;
    var eventName = _ref28.eventName,
        id = _ref28.id;

    try {
      var eventProperties = {
        'Source': document.referrer,
        'Page name': id
      };

      // Capture event if ssoId or amplitude not ready, will be sent once amplitude is initialized with ssoId
      if (!getters.ssoId || !getters.amplitudeId) {
        dispatch('captureEvent', { eventName: eventName, eventProperties: eventProperties });
        return;
      }
      client.logEvent(eventName, eventProperties);
    } catch (err) {
      console.error(err);
    }
  },


  // AMPLITUDE MISC ACTIONS

  logFaq: function logFaq(context, faq) {
    try {
      client.logEvent("faqs clicked", {
        "FAQ ID": faq
      });
    } catch (err) {
      console.error(err);
    }
  },
  logStepUp: function logStepUp(_ref29, stepupId) {
    var getters = _ref29.getters;

    try {
      var product = getters.product;


      client.logEvent("step-up viewed", {
        "Page path": window.location.pathname,
        'Product ID': product && product.id,
        "Step-up name": stepupId,
        "Source": document.referrer,
        "Page URL": window.location.href
      });
    } catch (err) {
      console.error(err);
    }
  },
  logStepUpActioned: function logStepUpActioned(_ref30, _ref31) {
    var getters = _ref30.getters;
    var stepupId = _ref31.stepupId,
        link = _ref31.link;

    try {
      var product = getters.product;


      client.logEvent("step-up actioned", {
        "Page path": window.location.pathname,
        'Product ID': product && product.id,
        "Step-up name": stepupId,
        "Source": document.referrer,
        "Destination url": link
      });
    } catch (err) {
      console.error(err);
    }
  },
  logStepUpDeclined: function logStepUpDeclined(_ref32, stepupId) {
    var getters = _ref32.getters;

    try {
      var product = getters.product;


      client.logEvent("step-up declined", {
        "Page path": window.location.pathname,
        'Product ID': product && product.id,
        "Step-up name": stepupId,
        "Source": document.referrer,
        "Page URL": window.location.href
      });
    } catch (err) {
      console.error(err);
    }
  },
  logPopup: function logPopup() {
    try {
      client.logEvent("pop-up viewed", {
        "Pop-up type": "exit intent",
        "Source": document.referrer,
        "Page URL": window.location.href
      });
    } catch (err) {
      console.error(err);
    }
  },
  logPopupDeclined: function logPopupDeclined() {
    try {
      client.logEvent("pop-up declined", {
        "Pop-up type": "exit intent",
        "Source": document.referrer,
        "Page URL": window.location.href
      });
    } catch (err) {
      console.error(err);
    }
  },
  logPopupActioned: function logPopupActioned() {
    try {
      client.logEvent("pop-up cta clicked", {
        "Pop-up type": "exit intent",
        "Source": document.referrer,
        "Page URL": window.location.href
      });
    } catch (err) {
      console.error(err);
    }
  },
  logPageLink: function logPageLink(context, link) {
    try {
      client.logEvent("link clicked", {
        "Source page": getPageName(),
        "URL name": link
      });
    } catch (err) {
      console.error(err);
    }
  },
  logPageButton: function logPageButton(context, label) {
    try {
      var name = getPageName();
      var eventProperties = {
        "Source page": name,
        "URL name": label
      };

      client.logEvent('button clicked', eventProperties);
    } catch (err) {
      console.error(err);
    }
  },


  // AMPLITUDE PETITION ACTIONS

  logPetitionBegin: function logPetitionBegin(context, data) {
    try {
      var eventName = data.id + ' form started';
      var eventProperties = {
        "Product ID": data.id,
        "Field": data.fieldName,
        "Counter Total": data.count
      };

      client.logEvent(eventName, eventProperties);
    } catch (err) {
      console.error(err);
    }
  },
  logPetitionSupporter: function logPetitionSupporter(context, data) {
    try {
      var eventProperties = {
        "Product ID": data.id,
        "Post Code": data.postcode,
        "Form type": "registration"
      };

      client.logEvent("supporter details provided", eventProperties);
    } catch (err) {
      console.error(err);
    }
  },
  logPetitionComplete: function logPetitionComplete(context, _ref33) {
    var id = _ref33.id,
        count = _ref33.count;

    try {
      var eventProperties = {
        "Page name": id,
        "Source": document.referrer,
        "Counter Total": count,
        "Product ID": id
      };

      client.logEvent("registration successful", eventProperties);
    } catch (err) {
      console.error(err);
    }
  },


  // AMPLITUDE NAV MENU ACTIONS
  logNavClick: function logNavClick(context, data) {
    try {
      var eventProperties = {
        "Nav name": data.subMenuName || data.topMenuName,
        "Parent nav": data.topMenuName,
        "Source page": getPageName()
      };

      client.logEvent('Navigated to', eventProperties);
    } catch (err) {
      console.error(err);
    }
  },


  // AMPLITUDE SEARCH ACTIONS
  logSearchClick: function logSearchClick() {
    try {
      var eventProperties = {
        "Source page": getPageName()
      };

      client.logEvent("Search clicked", eventProperties);
    } catch (err) {
      console.error(err);
    }
  },
  logSearchEnter: function logSearchEnter(context, data) {
    try {
      var eventProperties = {
        "Search input": data.searchValue,
        "Source page": getPageName()
      };

      client.logEvent("Searched for", eventProperties);
    } catch (err) {
      console.error(err);
    }
  },
  logSearchFilter: function logSearchFilter(context, filter) {
    try {
      var eventProperties = {
        "Filter type": filter,
        "Source page": getPageName()
      };

      client.logEvent("Search filtered", eventProperties);
    } catch (err) {
      console.error(err);
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_auth__ = __webpack_require__(63);




var firebaseConfig = {
  apiKey: wwfconfigs.FIREBASE_AUTH_API_KEY,
  projectId: wwfconfigs.FIREBASE_AUTH_PROJECT_ID
};
var firebaseAuth = __WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].initializeApp(firebaseConfig, 'firebaseAuth');

// Set persisitance to 
firebaseAuth.auth().setPersistence(__WEBPACK_IMPORTED_MODULE_1_firebase_app__["a" /* default */].auth.Auth.Persistence.LOCAL);

var state = {
  user: null,
  ssoId: null
};

function readCookie(name) {
  return (name = new RegExp('(?:^|;\\s*)' + ('' + name).replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&') + '=([^;]*)').exec(document.cookie)) && name[1];
}

function setCookie(cookieName, id) {
  // Set the cookie
  var expiry = new Date().setMonth(new Date().getMonth() + 12);
  var domain = wwfconfigs.NODE_ENV === 'development' ? 'localhost' : 'domain=.wwf.org.au';
  document.cookie = cookieName + '=' + id + ';expires=' + expiry + ';' + domain + ';path=/';
}

var actions = {
  login: function login(_ref) {
    var commit = _ref.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      // Read the cookie if it exists
      var cookieName = '_wwf-token';
      var cookieContent = readCookie(cookieName);

      if (cookieContent != null) {
        setCookie(cookieName, cookieContent);

        commit('login', {
          ssoId: cookieContent
        });
        resolve({
          data: {
            ssoId: cookieContent
          }
        });
      } else {

        // If it doesn't exists, create auth
        firebaseAuth.auth().signInAnonymously().then(function (userCredential) {
          console.log('Firebase Anon Auth - ' + userCredential.user.uid);

          setCookie(cookieName, userCredential.user.uid);

          commit('login', {
            ssoId: userCredential.user.uid,
            user: userCredential.user
          });
          resolve({
            data: {
              ssoId: userCredential.user.uid,
              data: userCredential.user
            }
          });
        }).catch(function (err) {
          console.error('Firebase auth Error', err);
          reject(err);
        });
      }
    });
  }
};

var mutations = {
  login: function login(state, response) {
    console.log('Firebase Login - ' + response.ssoId);
    state.ssoId = response.ssoId;
    state.user = response.user;
  }
};

var getters = {
  isLoggedIn: function isLoggedIn(state) {
    return !!state.user;
  },
  currentUser: function currentUser(state) {
    return state.user;
  },
  ssoId: function ssoId(state) {
    return state.ssoId ? state.ssoId : state.user ? state.user.uid : null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(11);




// initial state
var state = {
  counter: 0,
  edo: {
    firstName: "",
    lastName: "",
    email: "",
    message: "",
    postcode: "",
    phoneNumber: ""
  }
};

var getters = {
  counter: function counter(state) {
    return state.counter;
  },
  edo: function edo(state) {
    return state.edo;
  }
};

var mutations = {
  setCounter: function setCounter(state, counter) {
    state.counter = counter;
  }
};

var actions = {
  getCounterByCampaignId: function getCounterByCampaignId(context, campaignId) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.get(wwfconfigs.WEB_API + "/campaign/counter?campaignId=" + campaignId).then(function (response) {
      context.commit('setCounter', response.body.count);
    });
  },
  getContentMessageById: function getContentMessageById(context, id) {
    return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.get(wwfconfigs.WEB_API + "/campaign/message?messageId=" + id).then(function (response) {
      return response.body;
    });
  },
  saveLead: function saveLead(context, data) {
    data.lead.sourceUrl = window.location.href;
    data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, data);
    return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post(wwfconfigs.WEB_API + "/campaign/lead", data);
  },
  saveSignature: function saveSignature(context, data) {
    return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post(wwfconfigs.WEB_API + "/campaign/signatures", data);
  },
  savePartnershipForm: function savePartnershipForm(context, data) {
    return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post(wwfconfigs.WEB_API + "/partnership/create", data);
  },
  checkEmail: function checkEmail(context, data) {
    if (!data.email || data.email.length === 0 || !data.email.includes('@')) {
      return false;
    }

    // Check if the mail already exist for this particular campaign
    return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post(wwfconfigs.WEB_API + "/campaign/check-email?campaignId=" + data.campaignId + "&email=" + data.email).then(function (response) {
      return response.body.exist;
    }, function (error) {
      console.error(error);
      return false;
    });
  },
  getEPBCRecipients: function getEPBCRecipients(context, data) {
    return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.get(wwfconfigs.WEB_API + "/campaign/epbc/recipients?postcode=" + data.postcode).then(function (response) {
      return response.body;
    }, function (error) {
      console.error(error);
      return false;
    });
  },
  uploadEarthhourLogo: function uploadEarthhourLogo(context, data) {
    return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post(wwfconfigs.WEB_API + "/earth-hour/upload-logo?organisationName=" + data.organisationName, data.file).then(function (response) {
      return response.body.url;
    }, function (error) {
      console.error(error);
    });
  },
  createEarthhourLogo: function createEarthhourLogo(context, data) {
    return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post(wwfconfigs.WEB_API + "/earth-hour/logos", data).then(function (response) {
      return response.body;
    }, function (error) {
      console.error(error);
    });
  },
  getLogos: function getLogos(context, _ref) {
    var page = _ref.page,
        size = _ref.size,
        section = _ref.section,
        campaignId = _ref.campaignId;

    return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.get(wwfconfigs.WEB_API + "/logos?page=" + page + "&size=" + size + "&campaignId=" + campaignId + (section ? "&section=" + section : '')).then(function (response) {
      return response.body;
    }, function (error) {
      console.error(error);
    });
  },
  getEarthHourLogos: function getEarthHourLogos(context, _ref2) {
    var page = _ref2.page,
        size = _ref2.size,
        section = _ref2.section;

    return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.get(wwfconfigs.WEB_API + "/earth-hour/logos?page=" + page + "&size=" + size + (section ? "&section=" + section : '')).then(function (response) {
      return response.body;
    }, function (error) {
      console.error(error);
    });
  },
  getPartnersLogos: function getPartnersLogos(context, _ref3) {
    var page = _ref3.page,
        size = _ref3.size;

    return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.get(wwfconfigs.WEB_API + "/partnership/logos?page=" + page + "&size=" + size).then(function (response) {
      return response.body;
    }, function (error) {
      console.error(error);
    });
  },
  purifyText: function purifyText(context, text) {
    var endPoint = 'https://api1.webpurify.com/services/rest';
    var apiKey = 'b7c6af7e5259ce74f099897deb9dcf29';
    var url = endPoint + "?api_key=" + apiKey + "&text=" + encodeURIComponent(text) + "&method=webpurify.live.check&format=json";
    return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.jsonp(url).then(function (response) {
      if (response.data) {
        if (response.data.rsp.found == "0" || response.data.rsp.err) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    }, function (error) {
      console.error(error);
      return true;
    });
  },
  uploadEDOVideo: function uploadEDOVideo(context, data) {
    return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post(wwfconfigs.WEB_API + "/campaign/edo/videos", data).then(function (response) {
      return response.body.url;
    }, function (error) {
      console.error(error);
    });
  },
  createFile: function createFile(context, data) {
    return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post(wwfconfigs.WEB_API + "/campaign/files", data).then(function (response) {
      return response.body;
    }, function (error) {
      console.error(error);
    });
  },
  getFeatureSwitch: function getFeatureSwitch(_ref4, id) {
    var commit = _ref4.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.get(wwfconfigs.WEB_API + "/setting?settingId=" + id).then(function (response) {
        var setting = response.body;
        resolve(!!setting ? setting.value : true);
      }, function (error) {
        console.error("getFeatureSwitch", error);
        reject(error);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);










function initialDonationState() {
    return {
        key: null,
        updateddate: null,
        createddate: null,
        formWizardCurrentStep: 0,
        url: null,
        method: null,
        isLoading: false,
        // Step1
        isGift: false,
        packagecode: null,
        type: null, // Single/Regular selected
        campaignid: null,
        fundid: null,
        amount: null,
        dollarhandle: null,
        email: null,
        optin: true,
        // Step2
        isBehalfBusiness: false,
        bussiness: {
            name: null
        },
        title: null,
        firstname: null,
        lastname: null,
        phone: null,
        billing: {
            unitnumber: null,
            streetno: null,
            streetname: null,
            postcode: null,
            state: '',
            suburb: null,
            country: 'Australia'
        },
        isSameAddress: true,
        gift: {
            title: null,
            firstname: null,
            lastname: null,
            unitnumber: null,
            streetno: null,
            streetname: null,
            postcode: null,
            state: null,
            suburb: null,
            country: null
        },
        wildcard: {
            dear: null,
            message: null,
            email: null,
            scheduledate: null,
            img: null,
            pdf: null
        },
        payementType: 'wwf_purchasetokenise',
        transactionid: null,
        isProcessing: false,
        step2Data: {
            addressSelected: null,
            addressgiftSelected: null,
            showAddressSuggestions: true,
            showAddressGiftSuggestions: true,
            showFullAddress: false,
            showFullAddressGifts: false
        },
        thankYouUrl: null,
        isImpact: false,
        emailValidation: null,
        addressInput: {
            country: 'Australia'
        }
    };
}

var state = {
    donation: initialDonationState()
};

var getters = {
    donation: function donation(state) {
        return state.donation;
    },
    step2Data: function step2Data(state) {
        return state.donation.step2Data;
    }
};

var mutations = {
    updateDonation: function updateDonation(state, _ref) {
        var field = _ref.field,
            value = _ref.value;

        if (value != undefined) {
            __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()(state.donation, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()({}, field, value));
        }
    },
    updateDonationBussiness: function updateDonationBussiness(state, _ref2) {
        var field = _ref2.field,
            value = _ref2.value;

        if (value != undefined) {
            __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()(state.donation.bussiness, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()({}, field, value));
        }
    },
    updateDonationBilling: function updateDonationBilling(state, _ref3) {
        var field = _ref3.field,
            value = _ref3.value;

        if (value != undefined) {
            __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()(state.donation.billing, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()({}, field, value));
        }
    },
    updateDonationGift: function updateDonationGift(state, _ref4) {
        var field = _ref4.field,
            value = _ref4.value;

        if (value != undefined) {
            __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()(state.donation.gift, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()({}, field, value));
        }
    },
    updateDonationWildcard: function updateDonationWildcard(state, _ref5) {
        var field = _ref5.field,
            value = _ref5.value;

        if (value != undefined) {
            __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()(state.donation.wildcard, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()({}, field, value));
        }
    },
    updateStep2Data: function updateStep2Data(state, _ref6) {
        var field = _ref6.field,
            value = _ref6.value;

        if (value != undefined) {
            __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()(state.donation.step2Data, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()({}, field, value));
        }
    },
    resetDonation: function resetDonation() {
        console.log("resetDonation mutation", state);
        var s = initialDonationState();
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(s).forEach(function (key) {
            state.donation[key] = s[key];
        });
    },
    setTransactionId: function setTransactionId(state, id) {
        console.log('donate - setTransactionId - ', id);
        state.donation = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, state.donation, { transactionid: id });
    }
};

var actions = {
    saveDonation: function saveDonation(_ref7, extra) {
        var state = _ref7.state,
            getters = _ref7.getters,
            commit = _ref7.commit;

        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

            // Define Thank you url based on donation type
            var donationType = state.donation.type;
            var donationTypeSettings = getters.product.donationsettings[donationType];
            var thankYouUrl = donationTypeSettings ? donationTypeSettings.thankYouUrl : null;
            commit('updateDonation', { field: 'thankYouUrl', value: thankYouUrl });

            // Build the payload
            var donation = {
                key: state.donation.key,
                ssoId: getters.ssoId,

                amount: state.donation.amount,
                dollarhandle: state.donation.dollarhandle,
                type: state.donation.type, // Single/Regular selected
                payementType: state.donation.payementType,

                // Supporter's details
                email: state.donation.email,
                bussiness: state.donation.isBehalfBusiness ? {
                    name: state.donation.bussiness.name
                } : null,
                title: state.donation.title,
                firstname: state.donation.firstname,
                lastname: state.donation.lastname,
                phone: state.donation.phone,

                // Flags
                optin: state.donation.optin,
                isGift: state.donation.isGift,
                bequest: state.donation.bequest,
                compliance: state.donation.compliance,
                isSameAddress: state.donation.isSameAddress,

                // Fundraising ids
                appealid: getters.product.appealcodesetting.appealid,
                campaignid: state.donation.campaignid,
                fundid: getters.queryParams.fundid ? getters.queryParams.fundid : state.donation.fundid,
                packagecode: state.donation.packagecode,

                // Product
                producttype: getters.product.producttype,
                productname: getters.product.productname,
                productid: getters.product.id,

                certificateurl: !!getters.product.certificateurl ? getters.product.certificateurl : null,

                source: getters.product.source,
                formWizardCurrentStep: state.donation.formWizardCurrentStep,
                thankYouUrl: thankYouUrl,
                extra: extra,

                // Impact Project
                isImpact: getters.product.extrasetting.isImpact,

                // Email Validation
                emailValidation: state.donation.emailValidation
            };

            // Set the addresses
            donation.billing = {
                unitnumber: state.donation.billing.unitnumber,
                streetno: state.donation.billing.streetno,
                streetname: state.donation.billing.streetname,
                postcode: state.donation.billing.postcode,
                state: state.donation.billing.state,
                suburb: state.donation.billing.suburb,
                country: state.donation.billing.country,
                isVerified: state.donation.billing.isVerified
            };

            if (donation.isGift) {
                donation.gift = {
                    title: state.donation.gift.title,
                    firstname: state.donation.gift.firstname,
                    lastname: state.donation.gift.lastname
                };

                if (!donation.isSameAddress) {
                    donation.gift = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, donation.gift, {
                        unitnumber: state.donation.gift.unitnumber,
                        streetno: state.donation.gift.streetno,
                        streetname: state.donation.gift.streetname,
                        postcode: state.donation.gift.postcode,
                        state: state.donation.gift.state,
                        suburb: state.donation.gift.suburb,
                        country: state.donation.gift.country
                    });
                }
            }

            // Set the wildcard
            if (getters.product.producttype === "wildcard" && state.donation.wildcard) {
                donation.wildcard = {
                    dear: state.donation.wildcard.dear,
                    message: state.donation.wildcard.message,
                    email: state.donation.wildcard.email,
                    scheduledate: state.donation.wildcard.scheduledate ? __WEBPACK_IMPORTED_MODULE_8_moment___default()(state.donation.wildcard.scheduledate).format('YYYY-MM-DD') : null,
                    img: state.donation.wildcard.img,
                    pdf: state.donation.wildcard.pdf
                };
            }

            console.log('donation', donation);

            __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].http.post(wwfconfigs.WEB_API + '/donation', donation).then(function (response) {
                console.log('Save doantion - Success');

                // If the key was not define, set the key we just received
                if (!donation.key) {
                    commit("updateDonation", { field: 'key', value: response.body.key });
                }

                resolve();
            }, function (error) {
                console.error('Save doantion - Error - ', error);
                reject(error);
            });
        });
    },
    saveDonationStep1: function saveDonationStep1(_ref8) {
        var dispatch = _ref8.dispatch,
            state = _ref8.state,
            commit = _ref8.commit,
            rootState = _ref8.rootState,
            getters = _ref8.getters;

        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

            var donationType = state.donation.type;
            var donationTypeSettings = getters.product.donationsettings[donationType];
            var thankYouUrl = donationTypeSettings ? donationTypeSettings.thankYouUrl : null;

            commit('updateDonation', { field: 'thankYouUrl', value: thankYouUrl });

            // queryParams.fundid is the fundid set by query params. Always use this one if available
            var donation = {
                key: state.donation.key,
                isGift: state.donation.isGift,
                packagecode: state.donation.packagecode,
                type: state.donation.type, // Single/Regular selected
                amount: state.donation.amount,
                dollarhandle: state.donation.dollarhandle,
                email: state.donation.email,
                optin: state.donation.optin,
                appealid: rootState.product.product.appealcodesetting.appealid,
                campaignid: state.donation.campaignid,
                fundid: rootState.product.queryParams.fundid ? rootState.product.queryParams.fundid : state.donation.fundid,
                producttype: rootState.product.product.producttype,
                productname: rootState.product.product.productname,
                productid: rootState.product.product.id,
                certificateurl: rootState.product.product.certificateurl ? rootState.product.product.certificateurl : null,
                source: rootState.product.product.source,
                formWizardCurrentStep: state.donation.formWizardCurrentStep,
                ssoId: getters.ssoId,
                thankYouUrl: thankYouUrl,
                emailValidation: state.donation.emailValidation
            };

            console.log('Save donation Step 1', donation);

            // if donation already exist
            if (state.donation.key) {
                console.log('Save donation with key', state.donation.key);
                __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].http.post(wwfconfigs.WEB_API + '/donation', donation).then(function (response) {
                    console.log('saveDonation Step 1: Update Success');
                    resolve();
                }, function (error) {
                    console.log('Error has occured during saving step1 update process', error);
                    reject(error);
                });
            } else {
                console.log('Save donation without key');
                __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].http.post(wwfconfigs.WEB_API + '/donation', donation).then(function (response) {
                    console.log('saveDonation Step 1: Creation Success');
                    commit("updateDonation", { field: 'key', value: response.body.key });
                    resolve();
                }, function (error) {
                    console.log('Error has occured during saving step1 create process', error);
                    reject(error);
                });
            }
        });
    },
    saveDonationStep2: function saveDonationStep2(_ref9) {
        var dispatch = _ref9.dispatch,
            state = _ref9.state,
            commit = _ref9.commit;

        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            console.log('saveDonationStep2 State donation', state.donation);
            console.log('saveDonationStep2 State product', state.product);

            var donation = {
                key: state.donation.key,
                isGift: state.donation.isGift,
                email: state.donation.email,
                optin: state.donation.optin,
                type: state.donation.type, // Single/Regular selected
                bussiness: state.donation.isBehalfBusiness ? {
                    name: state.donation.bussiness.name
                } : null,
                title: state.donation.title,
                firstname: state.donation.firstname,
                lastname: state.donation.lastname,
                phone: state.donation.phone,
                billing: {
                    unitnumber: state.donation.billing.unitnumber,
                    streetno: state.donation.billing.streetno,
                    streetname: state.donation.billing.streetname,
                    postcode: state.donation.billing.postcode,
                    state: state.donation.billing.state,
                    suburb: state.donation.billing.suburb,
                    country: state.donation.billing.country,
                    isVerified: state.donation.billing.isVerified
                },
                isSameAddress: state.donation.isSameAddress,
                gift: state.donation.isGift ? {
                    title: state.donation.gift.title,
                    firstname: state.donation.gift.firstname,
                    lastname: state.donation.gift.lastname,
                    unitnumber: !state.donation.isSameAddress ? state.donation.gift.unitnumber : null,
                    streetno: !state.donation.isSameAddress ? state.donation.gift.streetno : null,
                    streetname: !state.donation.isSameAddress ? state.donation.gift.streetname : null,
                    postcode: !state.donation.isSameAddress ? state.donation.gift.postcode : null,
                    state: !state.donation.isSameAddress ? state.donation.gift.state : null,
                    suburb: !state.donation.isSameAddress ? state.donation.gift.suburb : null,
                    country: !state.donation.isSameAddress ? state.donation.gift.country : null
                } : null,
                wildcard: state.donation.wildcard ? {
                    dear: state.donation.wildcard.dear,
                    message: state.donation.wildcard.message,
                    email: state.donation.wildcard.email,
                    scheduledate: state.donation.wildcard.scheduledate ? __WEBPACK_IMPORTED_MODULE_8_moment___default()(state.donation.wildcard.scheduledate).format('YYYY-MM-DD') : null,
                    img: state.donation.wildcard.img,
                    pdf: state.donation.wildcard.pdf
                } : null,
                payementType: state.donation.payementType,
                formWizardCurrentStep: state.donation.formWizardCurrentStep,
                bequest: state.donation.bequest
            };

            console.log('saveDonationStep2 Donation', donation);
            __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].http.post(wwfconfigs.WEB_API + '/donation', donation).then(function (response) {
                console.log('saveDonation Step 2 set success', response);
                resolve();
            }, function (error) {
                console.log('Error has occured during saving step2 set process', error);
                reject(error);
            });
        });
    },
    paymentCreditCard: function paymentCreditCard(_ref10, data) {
        var dispatch = _ref10.dispatch,
            state = _ref10.state,
            commit = _ref10.commit,
            rootState = _ref10.rootState;

        state.donation.isLoading = true;
        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].http.post(wwfconfigs.WEB_API + '/payment/credit-card/checkout', {
                token: data.token,
                cardHolderName: data.cardHolderName,
                uid: state.donation.key
            }).then(function (response) {
                console.log("payment", response);
                state.donation.isLoading = false;
                resolve(response);
            }, function (error) {
                console.error("payment", error);
                //Todo reset id firebase
                state.donation.isLoading = false;
                reject(error);
            });
        });
    },
    paymentDirectDebit: function paymentDirectDebit(_ref11, data) {
        var dispatch = _ref11.dispatch,
            state = _ref11.state,
            commit = _ref11.commit,
            rootState = _ref11.rootState;

        state.donation.isLoading = true;
        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].http.post(wwfconfigs.WEB_API + '/payment/direct-debit/checkout', {
                accno: data.accno,
                accrouting: data.accrouting,
                acctitle: data.acctitle,
                uid: state.donation.key
            }).then(function (response) {
                console.log("payment", response);
                state.donation.isLoading = false;
                resolve(response);
            }, function (error) {
                console.error("payment", error);
                //Todo reset id firebase
                state.donation.isLoading = false;
                reject(error);
            });
        });
    },
    checkoutPaypal: function checkoutPaypal(_ref12, data) {
        var dispatch = _ref12.dispatch,
            state = _ref12.state,
            commit = _ref12.commit,
            rootState = _ref12.rootState;

        state.donation.isLoading = true;
        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].http.post(wwfconfigs.WEB_API + '/payment/paypal/checkout', {
                uid: state.donation.key
            }).then(function (response) {
                console.log("checkoutPaypal", response);
                state.donation.isLoading = false;
                resolve(response.body);
            }, function (error) {
                console.error("checkoutPaypal", error);
                //Todo reset id firebase
                state.donation.isLoading = false;
                reject(error);
            });
        });
    },
    paymentPaypal: function paymentPaypal(_ref13, data) {
        var dispatch = _ref13.dispatch,
            state = _ref13.state,
            commit = _ref13.commit,
            rootState = _ref13.rootState;

        state.donation.isProcessing = true;
        console.log('paymentPaypal', data);
        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].http.post(wwfconfigs.WEB_API + '/payment/paypal/purchase', {
                paymentid: data.paymentid,
                payerid: data.payerid
            }).then(function (response) {
                console.log("paymentPaypal", response);
                state.donation.isProcessing = false;
                resolve(response.body);
            }, function (error) {
                console.error("paymentPaypal", error);
                //Todo reset id firebase
                state.donation.isProcessing = false;
                reject(error);
            });
        });
    },
    retryDonation: function () {
        var _ref14 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref15) {
            var commit = _ref15.commit,
                dispatch = _ref15.dispatch;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            // Set the value to empty because the previous donation is failed
                            commit("updateDonation", { field: "key", value: '' });
                            _context.next = 3;
                            return dispatch("saveDonationStep1");

                        case 3:
                            _context.next = 5;
                            return dispatch("saveDonationStep2");

                        case 5:
                            return _context.abrupt('return', _context.sent);

                        case 6:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function retryDonation(_x) {
            return _ref14.apply(this, arguments);
        }

        return retryDonation;
    }(),
    resetDonation: function resetDonation(_ref16) {
        var commit = _ref16.commit;

        commit("resetDonation");
    },
    getCustomCheckoutFeatureSwitch: function getCustomCheckoutFeatureSwitch(_ref17, productId) {
        var commit = _ref17.commit;

        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].http.get(wwfconfigs.WEB_API + '/setting?settingId=bambora-checkout').then(function (response) {
                var setting = response.body;
                var productSetting = setting.products[productId];
                var active = productSetting !== undefined && productSetting !== null ? productSetting : setting.default;
                resolve(active);
            }, function (error) {
                console.error("getCustomCheckoutFeatureSwitch", error);
                reject(error);
            });
        });
    },


    // OLD BAMBORA CHECKOUT
    checkout: function checkout(_ref18) {
        var dispatch = _ref18.dispatch,
            state = _ref18.state,
            commit = _ref18.commit,
            rootState = _ref18.rootState;

        console.log('checkout', state);
        commit("updateDonation", { field: 'method', value: '' });
        commit("updateDonation", { field: 'url', value: '' });
        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].http.post(wwfconfigs.CLOUDFUNCTION + '/' + wwfconfigs.CHECKOUT, {
                // The method doesnt like the amount with. 
                amount: state.donation.amount.replace(',', ''),
                //amount: state.donation.amount
                paymentType: state.donation.payementType,
                email: state.donation.email,
                custRef: state.donation.key,
                productid: rootState.product.product.id, // ok
                productname: rootState.product.product.productname, // ok
                producttype: rootState.product.product.producttype, // Ok
                campaignid: rootState.product.product.appealcodesetting.campaignid, // ok
                fundid: rootState.product.product.appealcodesetting.fundid, //ok 
                appealid: rootState.product.product.appealcodesetting.appealid, //ok
                type: state.donation.type,
                source: rootState.product.product.source
            }).then(function (response) {
                console.log("checkout", response);
                commit("updateDonation", { field: 'method', value: response.body.method });
                commit("updateDonation", { field: 'url', value: response.body.url });
                resolve(response);
            }, function (error) {
                console.error("checkout", error);
                reject(error);
            });
        });
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    getters: getters,
    mutations: mutations
});

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  postCode: '',
  iAmA: '',
  layout: 'ind-donation' // ind-wildcard, ind-petition, ind-donation, business, school, community
};

var getters = {
  lead: function lead(state) {
    return state;
  }
};

var mutations = {
  setIAmA: function setIAmA(state, value) {
    state.iAmA = value;
  }
};

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(11);




// initial state
var state = {
  categories: {
    wildcard: [],
    adoption: []
  },
  products: {
    wildcard: [],
    adoption: []
  },
  filteredProducts: [],
  selectedCategories: [],
  selectedProductType: 'wildcard', // 'wildcard' or 'adoption'
  isSeeingAll: false
};

// getters
var getters = {
  categories: function categories(state) {
    return state.categories;
  },
  ecommerceProducts: function ecommerceProducts(state) {
    return state.products;
  },
  filteredProducts: function filteredProducts(state) {
    return state.filteredProducts;
  },
  selectedCategories: function selectedCategories(state) {
    return state.selectedCategories;
  },
  selectedProductType: function selectedProductType(state) {
    return state.selectedProductType;
  },
  isSeeingAll: function isSeeingAll(state) {
    return state.isSeeingAll;
  }
};

// mutations
var mutations = {
  categoriesLoaded: function categoriesLoaded(state, categories) {
    state.categories = categories;
  },
  productsLoaded: function productsLoaded(state, products) {
    state.products = products;
  },
  selectedProductTypeUpdated: function selectedProductTypeUpdated(state, value) {
    state.selectedProductType = value;
  },
  selectedCategoriesUpdated: function selectedCategoriesUpdated(state, value) {
    state.selectedCategories = value;
  },
  filteredProductsUpdated: function filteredProductsUpdated(state, filteredProducts) {
    state.filteredProducts = filteredProducts;
  },
  isSeeingAllUpdated: function isSeeingAllUpdated(state, value) {
    state.isSeeingAll = value;
  }
};

// actions
var actions = {
  getEcommerceProducts: function getEcommerceProducts(_ref) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.get(wwfconfigs.WEB_API + '/product/ecommerce').then(function (response) {
        var products = {
          wildcard: [],
          adoption: []
        };
        var categories = {
          wildcard: [],
          adoption: []
        };

        // Load and categorise ecommerce products
        // id: product.id,
        // name: product.meta.projectTitle,
        // image: product.meta.image,
        // url: product.meta.productUrl,
        // description: product.meta.description,
        // categories: productCategories,
        // type: product.producttype,

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(response.body), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var product = _step.value;

            if (product.type === 'wildcard') {
              products.wildcard.push(product);

              var _loop = function _loop(category) {
                if (!categories.wildcard.some(function (c) {
                  return c.id === category.id;
                })) {
                  categories.wildcard.push(category);
                }
              };

              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(product.categories), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var category = _step2.value;

                  _loop(category);
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            }

            if (product.type === 'adoption') {
              products.adoption.push(product);

              var _loop2 = function _loop2(_category) {
                if (!categories.adoption.some(function (c) {
                  return c.id === _category.id;
                })) {
                  categories.adoption.push(_category);
                }
              };

              var _iteratorNormalCompletion3 = true;
              var _didIteratorError3 = false;
              var _iteratorError3 = undefined;

              try {
                for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(product.categories), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  var _category = _step3.value;

                  _loop2(_category);
                }
              } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                  }
                } finally {
                  if (_didIteratorError3) {
                    throw _iteratorError3;
                  }
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        categories.wildcard.sort(function (a, b) {
          return a.index - b.index;
        });
        categories.adoption.sort(function (a, b) {
          return a.index - b.index;
        });

        commit('productsLoaded', products);
        commit('categoriesLoaded', categories);
        dispatch('filterProducts');
        resolve();
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  getAllEcommerceProducts: function getAllEcommerceProducts() {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.get(wwfconfigs.WEB_API + '/product/ecommerce').then(function (response) {
        resolve(response.body);
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  filterProducts: function filterProducts(_ref2) {
    var commit = _ref2.commit,
        state = _ref2.state;

    if (state.selectedCategories.length == 0) {
      commit('filteredProductsUpdated', state.products[state.selectedProductType]);
    } else {
      var filteredProducts = [];

      var _loop3 = function _loop3(product) {
        var _loop4 = function _loop4(category) {
          // If the product has one of the selected category and
          // the filtered product list doesn't contain the product
          // add it to the filtered product list
          if (product.categories.some(function (c) {
            return c.id === category.id;
          }) && !filteredProducts.some(function (p) {
            return p.id === product.id;
          })) {
            filteredProducts.push(product);
          }
        };

        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(state.selectedCategories), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var category = _step5.value;

            _loop4(category);
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }
      };

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(state.products[state.selectedProductType]), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var product = _step4.value;

          _loop3(product);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      commit('filteredProductsUpdated', filteredProducts);
    }
  },
  updateSelectedCategories: function updateSelectedCategories(_ref3, value) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    commit('selectedCategoriesUpdated', value);
    dispatch('filterProducts');
  },
  updateSelectedProductType: function updateSelectedProductType(_ref4, value) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;

    commit('selectedProductTypeUpdated', value);
    dispatch('filterProducts');
  },
  updateIsSeeingAll: function updateIsSeeingAll(_ref5, value) {
    var commit = _ref5.commit;

    commit('isSeeingAllUpdated', value);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(11);





var state = {};

var getters = {};

var mutations = {};

var actions = {
  validateEmail: function validateEmail(_, email) {
    var _this = this;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      try {
        __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].http.get(wwfconfigs.WEB_API + '/kickbox/validate/email?email=' + email).then(function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    resolve(response.body);

                  case 1:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }(), function (error) {
          reject(error);
        });
      } catch (err) {
        reject(err);
      }
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  selection: 'petition',
  details: {
    firstName: null,
    lastName: null,
    email: null,
    postcode: null,
    phoneNumber: null,
    agreesDisplayName: true
  },
  currentStep: 0,
  treeCount: 0,
  isBForm: false
};

var getters = {
  selection: function selection(state) {
    return state.selection;
  },
  isPetition: function isPetition(state) {
    return state.selection === 'petition';
  },
  isDonation: function isDonation(state) {
    return state.selection === 'donation';
  },
  treeCount: function treeCount(state) {
    return state.treeCount;
  },
  isBForm: function isBForm(state) {
    return state.isBForm;
  }
};

var mutations = {
  updateSelection: function updateSelection(state, selection) {
    if (state.selection != selection) {
      state.selection = selection;
    }
  },
  updateLeafRelief: function updateLeafRelief(state, _ref) {
    var field = _ref.field,
        value = _ref.value;

    if (state[field] != value) {
      state[field] = value;
    }
  },
  updateLeafReliefPaymentType: function updateLeafReliefPaymentType(state, type) {
    state.donation.paymentType = type;
  },
  updateTreeCount: function updateTreeCount(state, value) {
    state.treeCount = value;
  },
  resetLeafRelief: function resetLeafRelief(state) {
    state.details = {
      firstName: null,
      lastName: null,
      email: null,
      postcode: null,
      phoneNumber: null,
      agreesDisplayName: true
    };
  },
  enableBForm: function enableBForm(state, value) {
    state.isBForm = value;
  }
};

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(11);



// initial state
var state = {
    points: 0,
    code: null,
    rewards: []
};

var getters = {
    points: function points(state) {
        return state.points;
    },
    rewards: function rewards(state) {
        return state.rewards;
    },
    code: function code(state) {
        return state.code;
    }
};

var mutations = {
    setPoints: function setPoints(state, points) {
        state.points = points;
    },
    setRewards: function setRewards(state, rewards) {
        state.rewards = rewards;
    },
    setCode: function setCode(state, code) {
        state.code = code;
    }
};

var actions = {
    getLoyaltyDataByUniqueCode: function getLoyaltyDataByUniqueCode(context, code) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.get(wwfconfigs.WEB_API + "/loyalty/get?code=" + code).then(function (response) {
                console.log("getLoyaltyDataByUniqueCode", response);
                context.commit("setPoints", response.body.points);
                context.commit("setRewards", response.body.rewards);
                context.commit("setCode", code);
                resolve();
            }, function (error) {
                console.error("getLoyaltyDataByUniqueCode", error);
                reject(error);
            });
        });
    },
    saveReward: function saveReward(context, data) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            wwfconfigs.WEB_API + "/loyalty/save";
            __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.post(wwfconfigs.WEB_API + "/loyalty/save", { code: context.state.code, email: data.email, firstname: data.firstname, lastname: data.lastname, phone: data.phone, rewardid: data.rewardid, address: data.address }).then(function (response) {
                console.log("saveReward", response);
                resolve();
            }, function (error) {
                console.error("saveReward", error);
                reject(error);
            });
        });
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);


// initial state
var state = {
    allPackages: [],
    package: null

    // getters
};var getters = {
    allPackages: function allPackages(state) {
        return state.allPackages;
    },
    allPackagesByIds: function allPackagesByIds(state) {
        return function (ids) {
            console.log('ids allPackagesByIds', ids);
            console.log('state allPackagesByIds', state);
            var packages = ids.map(function (id) {
                return state.allPackages.find(function (p) {
                    return p.value.id == id;
                }).value;
            });
            console.log('packages allPackagesByIds', packages);
            return packages;
        };
    }
};

// mutations
var mutations = {
    setPackages: function setPackages(state, packages) {
        state.allPackages = packages;
    }
};

// actions
var actions = {
    getPackagesById: function getPackagesById(context, id) {
        return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(wwfconfigs.WEB_API + '/package?packageId=' + id).then(function (response) {
            return response.body;
        });
    },
    getAllPackages: function getAllPackages(context) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(wwfconfigs.WEB_API + '/package/all').then(function (response) {
            context.commit('setPackages', response.body);
        });
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);


var state = {
  content: {
    firstname: null,
    lastname: null,
    amount: null,
    certificatename: null,
    showCertificate: false,
    showWildcard: false,
    wildcardurl: null,
    certificateurl: null,
    isMonthly: false,
    isOpen: false,
    title: '',
    message: '',
    shareButton: false,
    recommendedReading: false,
    component: null,
    componentparams: {
      layout: 'wwf'
    },
    showHeader: true
  },
  openDonationPopup: false,
  openPetitionPopup: false,
  openPetitionMessagePopup: false,
  openEarthHourPopup: false,
  openCustomContentPopup: false,
  openStepUpPopup: false
};

var getters = {
  content: function content(state) {
    return state.content;
  },
  openDonationPopup: function openDonationPopup(state) {
    return state.openDonationPopup;
  },
  openPetitionPopup: function openPetitionPopup(state) {
    return state.openPetitionPopup;
  },
  openPetitionMessagePopup: function openPetitionMessagePopup(state) {
    return state.openPetitionMessagePopup;
  },
  openEarthHourPopup: function openEarthHourPopup(state) {
    return state.openEarthHourPopup;
  },
  openCustomContentPopup: function openCustomContentPopup(state) {
    return state.openCustomContentPopup;
  },
  openStepUpPopup: function openStepUpPopup(state) {
    return state.openStepUpPopup;
  }
};

var mutations = {
  setPopupContent: function setPopupContent(state, data) {
    state.content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, state.content, data);
  },
  openDonationPopup: function openDonationPopup(state, openPopup) {
    state.openDonationPopup = openPopup;
  },
  openPetitionPopup: function openPetitionPopup(state, openPopup) {
    state.openPetitionPopup = openPopup;
  },
  openPetitionMessagePopup: function openPetitionMessagePopup(state, openPopup) {
    state.openPetitionMessagePopup = openPopup;
  },
  openEarthHourPopup: function openEarthHourPopup(state, openPopup) {
    state.openEarthHourPopup = openPopup;
  },
  openCustomContentPopup: function openCustomContentPopup(state, openPopup) {
    state.openCustomContentPopup = openPopup;
  },
  openStepUpPopup: function openStepUpPopup(state, openPopup) {
    state.openStepUpPopup = openPopup;
  }
};

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectDestructuringEmpty__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectDestructuringEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectDestructuringEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(11);









// initial state
var state = {
  allProducts: [],
  product: null,
  packagesProduct: [],
  queryParams: {
    fundid: null
  },
  products: []

  // getters
};var getters = {
  allProducts: function allProducts(state) {
    return state.allProducts;
  },
  product: function product(state) {
    return state.product;
  },
  products: function products(state) {
    return state.products;
  },
  packagesProduct: function packagesProduct(state) {
    return state.packagesProduct;
  },
  queryParams: function queryParams(state) {
    return state.queryParams;
  }

  // mutations
};var mutations = {
  setProducts: function setProducts(state, products) {
    state.allProducts = products;
  },
  setProduct: function setProduct(state, product) {
    state.product = product;
  },
  setPackagesProduct: function setPackagesProduct(state, packages) {
    state.packagesProduct = packages;
  },
  setProductQueryParam: function setProductQueryParam(state, _ref) {
    var field = _ref.field,
        value = _ref.value;

    state.queryParams[field] = value;
  }
};

// actions
var actions = {
  getProductById: function getProductById(_ref2, data) {
    var commit = _ref2.commit;

    return new __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].http.get(wwfconfigs.WEB_API + '/product?productId=' + data.id).then(function (response) {
        var product = response.body;
        product.id = data.id;
        product.source = data.source;

        // Map the old structure to the new one
        // Need to populate the donationsettings object
        if (product) {

          var keys = product.donationsettings ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(product.donationsettings) : [];

          // Only map to the new structure if the structure is empty
          if (keys.length === 0) {
            product.donationsettings = {};

            if (product.donationtypes.length > 0) {
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(product.donationtypes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var type = _step.value;

                  product.donationsettings[type] = {
                    campaignid: product.appealcodesetting.campaignid,
                    fundid: product.appealcodesetting.fundid
                  };
                }

                // Set the defaultdonationtype as the first of the array
                // Always take the first one in alphabetical order
                // In FormProduct, the default donation type is the first of this array. Just following the same structure.
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }

              var defualtType = product.donationtypes[0];
              product.appealcodesetting.defaultdonationtype = defualtType;
              product.appealcodesetting.campaignid = product.donationsettings[defualtType].campaignid;
              product.appealcodesetting.fundid = product.donationsettings[defualtType].fundid;
            }
          }
        }

        // Override appealid and fundid
        // Suspected use only with Paypal after payment
        if (data.appealid) {
          product.appealcodesetting.appealid = data.appealid;
        }

        if (data.fundid) {
          commit('setProductQueryParam', { field: "fundid", value: data.fundid });
        }

        commit('setProduct', product);
        resolve();
      }, function (error) {
        console.log("getProductById error", error);
        reject(error);
      });
    });
  },
  getProductsByIds: function getProductsByIds(_ref3, productIds) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref3);

    var ids = productIds.join(',');
    return new __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].http.get(wwfconfigs.WEB_API + '/products?productId=' + ids).then(function (response) {
        var product = response.body;
        resolve(product);
      }, function (error) {
        console.error("getProductsByIds error", error);
        reject(error);
      });
    });
  },
  getProductByIds: function getProductByIds(_ref4, ids, rootState) {
    var dispatch = _ref4.dispatch;

    var products = [];
    return new __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (ids) {
        var promises = [];
        for (var i = 0; i < ids.length; ++i) {
          promises.push(dispatch('getOriginalProductById', ids[i]));
        }

        __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a.all(promises).then(function (response) {
          resolve(response);
        }, function (error) {
          console.error("getProductById error", error);
        });
      }
    });
  },
  getOriginalProductById: function getOriginalProductById(_ref5, id) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref5);

    return new __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].http.get(wwfconfigs.WEB_API + '/product?productId=' + id).then(function (response) {
        var product = response.body;
        product.id = id;
        resolve(product);
      }, function (error) {
        console.log("getOriginalProductById error", error);
        reject(error);
      });
    });
  },
  getAllPackagesForProduct: function () {
    var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref7) {
      var dispatch = _ref7.dispatch,
          state = _ref7.state,
          commit = _ref7.commit;

      var packageIds, calls, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, id, packages;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(state.product.packages && state.product.packages.length > 0)) {
                _context.next = 28;
                break;
              }

              packageIds = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.product.packages));
              calls = [];
              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _iteratorError2 = undefined;
              _context.prev = 6;


              for (_iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(packageIds); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                id = _step2.value;

                calls.push(dispatch('getPackagesById', id));
              }

              _context.next = 14;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context['catch'](6);
              _didIteratorError2 = true;
              _iteratorError2 = _context.t0;

            case 14:
              _context.prev = 14;
              _context.prev = 15;

              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }

            case 17:
              _context.prev = 17;

              if (!_didIteratorError2) {
                _context.next = 20;
                break;
              }

              throw _iteratorError2;

            case 20:
              return _context.finish(17);

            case 21:
              return _context.finish(14);

            case 22:
              _context.next = 24;
              return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a.all(calls);

            case 24:
              packages = _context.sent;


              commit('setPackagesProduct', packages);

              _context.next = 29;
              break;

            case 28:
              commit('setPackagesProduct', []);

            case 29:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[6, 10, 14, 22], [15,, 17, 21]]);
    }));

    function getAllPackagesForProduct(_x) {
      return _ref6.apply(this, arguments);
    }

    return getAllPackagesForProduct;
  }(),
  loadMultipleProducts: function loadMultipleProducts(_ref8, ids) {
    var _this = this;

    var dispatch = _ref8.dispatch,
        state = _ref8.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var calls, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, id;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              calls = [];
              _iteratorNormalCompletion3 = true;
              _didIteratorError3 = false;
              _iteratorError3 = undefined;
              _context2.prev = 4;


              for (_iterator3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(ids); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                id = _step3.value;

                calls.push(dispatch("getOriginalProductById", id));
              }

              _context2.next = 12;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2['catch'](4);
              _didIteratorError3 = true;
              _iteratorError3 = _context2.t0;

            case 12:
              _context2.prev = 12;
              _context2.prev = 13;

              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }

            case 15:
              _context2.prev = 15;

              if (!_didIteratorError3) {
                _context2.next = 18;
                break;
              }

              throw _iteratorError3;

            case 18:
              return _context2.finish(15);

            case 19:
              return _context2.finish(12);

            case 20:
              _context2.next = 22;
              return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a.all(calls);

            case 22:
              state.products = _context2.sent;

            case 23:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this, [[4, 8, 12, 20], [13,, 15, 19]]);
    }))();
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);








var FILTER_SORTING = ['Today', 'Yesterday', 'Past week', 'Past fortnight', 'Past month', 'Past 3 months', 'Past 6 months', 'Past year'];

var state = {
  searchInput: '',
  tabs: {
    selected: {
      label: 'All Results',
      numberOfResults: 0,
      queryStringParam: 'f.Tabs%7CAllDocumentsFill=All+Results'
    },
    selection: [{
      label: 'All Results',
      numberOfResults: 0
    }, {
      label: 'Website',
      numberOfResults: 0
    }, {
      label: 'News',
      numberOfResults: 0
    }, {
      label: 'FAQs',
      numberOfResults: 0
    }, {
      label: 'Social Media',
      numberOfResults: 0
    }]
  },

  options: {
    totalResults: 0,
    selectedLimit: 10,
    limits: [10, 25, 50],
    indexStart: 1,
    indexEnd: 10,
    currentPage: 1,
    selectedSort: {
      label: 'Relevance',
      type: ''
    },
    sorts: [{
      label: 'Relevance',
      type: ''
    }, {
      label: 'Date (Newest first)',
      type: 'date'
    }, {
      label: 'Date (Oldest first)',
      type: 'adate'
    }, {
      label: 'Title (A-Z)',
      type: 'title'
    }, {
      label: 'Title (Z-A)',
      type: 'atitle'
    }]
  },

  filters: {
    selected: [],
    selection: []
  },

  results: [],

  relatedSearches: []
};

var getters = {
  searchInput: function searchInput() {
    return state.searchInput;
  },
  selectedSort: function selectedSort() {
    return state.options.selectedSort;
  },
  selectedLimit: function selectedLimit() {
    return state.options.selectedLimit;
  }
};

var mutations = {
  setSearchInput: function setSearchInput(state, newInput) {
    state.searchInput = newInput;
  },
  setSelectedSort: function setSelectedSort(state, newSelectedSort) {
    state.options.selectedSort = newSelectedSort;
  },
  setselectedLimit: function setselectedLimit(state, newSelectedLimit) {
    state.options.selectedLimit = newSelectedLimit;
  },
  setNewPage: function setNewPage(state, newPage) {
    state.options.currentPage = newPage;
    var element = document.querySelector("div.search-results");
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 250,
        behavior: "smooth"
      });
    }
  },
  setNewTab: function setNewTab(state, newTab) {
    state.tabs.selected = newTab;
  },
  addFilter: function addFilter(state, filter) {
    var existing = state.filters.selected.find(function (e) {
      return e.category === filter.category;
    });
    if (existing) {
      var index = state.filters.selected.findIndex(function (e) {
        return e.category === filter.category;
      });
      state.filters.selected.splice(index, 1);
    }

    state.filters.selected.push(filter);
  },
  removeFilter: function removeFilter(state, filter) {
    var existing = state.filters.selected.find(function (e) {
      return e.category === filter.category;
    });
    if (existing) {
      var index = state.filters.selected.findIndex(function (e) {
        return e.category === filter.category;
      });
      state.filters.selected.splice(index, 1);
    }
  },
  emptySelectedFilter: function emptySelectedFilter(state) {
    state.filters.selected = [];
  }
};

var actions = {
  fetchQuickLinks: function fetchQuickLinks() {
    return __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].http.get(wwfconfigs.WEB_API + '/search/quick-links').then(function (response) {
      return response.body;
    }, function (error) {
      console.error(error);
      return error;
    });
  },
  fetchSearchSuggestions: function fetchSearchSuggestions(_ref, input) {
    var commit = _ref.commit,
        state = _ref.state;

    return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      try {
        var queryInput = input ? input : state.searchInput;
        __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].http.get(wwfconfigs.FUNNELBACK_SEARCH_URL + '/suggest.json?collection=' + wwfconfigs.FUNNELBACK_COLLECTION + '&partial_query=' + queryInput).then(function (response) {
          resolve(response.body);
        }, function (error) {
          reject(error);
        });
      } catch (err) {
        reject(err);
      }
    });
  },
  fetchSearchResultsWithPrebuiltQuery: function fetchSearchResultsWithPrebuiltQuery(_ref2, query) {
    var _this = this;

    var commit = _ref2.commit,
        state = _ref2.state,
        dispatch = _ref2.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(resolve, reject) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                try {
                  __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].http.get(wwfconfigs.FUNNELBACK_SEARCH_URL + '/search.json' + query).then(function (response) {
                    dispatch('processSearchResponse', response.body).then(function () {
                      return resolve(response.body);
                    });
                  }, function (error) {
                    reject(error);
                  });
                } catch (err) {
                  reject(err);
                }

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function (_x, _x2) {
        return _ref3.apply(this, arguments);
      };
    }());
  },
  fetchSearchResults: function fetchSearchResults(_ref4, userQuery) {
    var _this2 = this;

    var commit = _ref4.commit,
        state = _ref4.state,
        dispatch = _ref4.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2(resolve, reject) {
        var urlQuery, startRank, tabParam, query, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, f;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                if (!(state.searchInput && state.searchInput.length > 0)) {
                  _context2.next = 33;
                  break;
                }

                // Set variables
                urlQuery = userQuery ? userQuery : state.searchInput;
                startRank = state.options.selectedLimit * (state.options.currentPage - 1) + 1;
                tabParam = state.tabs.selected.queryStringParam ? state.tabs.selected.queryStringParam : '';

                // Build the query

                query = 'collection=' + wwfconfigs.FUNNELBACK_COLLECTION + '&query=' + urlQuery;

                query += '&sort=' + state.options.selectedSort.type;
                query += '&num_ranks=' + state.options.selectedLimit;
                query += '&start_rank=' + startRank;
                query += '&' + tabParam;

                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 13;
                for (_iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.filters.selected); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  f = _step.value;

                  query += '&' + f.queryStringParam;
                }
                _context2.next = 21;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2['catch'](13);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 21:
                _context2.prev = 21;
                _context2.prev = 22;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 24:
                _context2.prev = 24;

                if (!_didIteratorError) {
                  _context2.next = 27;
                  break;
                }

                throw _iteratorError;

              case 27:
                return _context2.finish(24);

              case 28:
                return _context2.finish(21);

              case 29:
                console.log('query', query);

                __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].http.get(wwfconfigs.FUNNELBACK_SEARCH_URL + '/search.json?' + query).then(function (response) {
                  dispatch('processSearchResponse', response.body).then(function () {
                    return resolve(response.body);
                  });
                }, function (error) {
                  reject(error);
                });
                _context2.next = 34;
                break;

              case 33:
                resolve({});

              case 34:
                _context2.next = 39;
                break;

              case 36:
                _context2.prev = 36;
                _context2.t1 = _context2['catch'](0);

                reject(_context2.t1);

              case 39:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 36], [13, 17, 21, 29], [22,, 24, 28]]);
      }));

      return function (_x3, _x4) {
        return _ref5.apply(this, arguments);
      };
    }());
  },
  processSearchResponse: function processSearchResponse(_ref6, data) {
    var commit = _ref6.commit,
        state = _ref6.state;

    return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      try {
        // EXTRACT DATA if we have results
        if (data.response.resultPacket.results && data.response.resultPacket.results.length > 0) {

          // Tabs
          var tabs = data.response.facets.find(function (e) {
            return e.name === 'Tabs';
          });
          state.tabs.selection = tabs.allValues.map(function (e) {
            return {
              label: e.label,
              numberOfResults: e.count,
              queryStringParam: e.queryStringParam
            };
          });

          // Pages
          state.options.totalResults = data.response.resultPacket.resultsSummary.fullyMatching;
          state.options.indexStart = data.response.resultPacket.resultsSummary.currStart;
          state.options.indexEnd = data.response.resultPacket.resultsSummary.currEnd;

          // Results
          state.results = data.response.resultPacket.results;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.results), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var r = _step2.value;

              if (r.date) {
                r.date = __WEBPACK_IMPORTED_MODULE_6_moment___default()(r.date).format('DD MMM YYYY');
              }
            }

            // Fitlers
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          var usedFilters = ['Date'];
          state.filters.selection = data.response.facets.filter(function (e) {
            return usedFilters.includes(e.name);
          }).map(function (e) {
            var label = e.name;
            var values = e.allValues.map(function (f) {
              return {
                label: f.label,
                count: f.count,
                queryStringParam: f.queryStringParam,
                category: e.name
              };
            });
            if (values.length > 0) {
              return {
                label: label,
                values: values
              };
            }
          }).filter(function (e) {
            return e;
          });

          // Sort the filters like the set list and the rest in reverse alphabetical order. with uncertain at the end
          state.filters.selection.forEach(function (e) {
            var result = [];
            var items = e.values;

            // To fit the list
            FILTER_SORTING.forEach(function (e) {
              var found = false;
              items = items.filter(function (item) {
                if (!found && item.label == e) {
                  result.push(item);
                  found = true;
                  return false;
                } else {
                  return true;
                }
              });
            });

            // Reverse alphabetique for the rest
            items.sort(function (a, b) {
              if (a.label === 'Uncertain') return 1;
              if (b.label === 'Uncertain') return -1;
              if (a.label > b.label) return -1;
              if (a.label < b.label) return 1;
              return 0;
            });
            result.push.apply(result, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(items));

            e.values = result;
          });

          // Related searches
          state.relatedSearches = data.response.resultPacket.contextualNavigation.categories;
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.relatedSearches), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var topic = _step3.value;
              var _iteratorNormalCompletion4 = true;
              var _didIteratorError4 = false;
              var _iteratorError4 = undefined;

              try {
                for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(topic.clusters), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                  var cluster = _step4.value;

                  cluster.label = cluster.label.replace('...', ' ' + state.searchInput + ' ');
                }
              } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion4 && _iterator4.return) {
                    _iterator4.return();
                  }
                } finally {
                  if (_didIteratorError4) {
                    throw _iteratorError4;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        } else {
          // Reset to empty
          state.results = [];
        }
        resolve();
      } catch (err) {
        reject(err);
      }
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(11);






var state = {};

var getters = {};

var mutations = {};

var actions = {
  parseAddress: function parseAddress(_ref, address) {
    var commit = _ref.commit;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      try {
        __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].http.get(wwfconfigs.WEB_API + '/sensis/address/parse?address=' + address).then(function (response) {
          resolve(response.body);
        }, function (error) {
          reject(error);
        });
      } catch (err) {
        reject(err);
      }
    });
  },
  getAddressDetails: function getAddressDetails(_ref2, addressId) {
    var commit = _ref2.commit;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      try {
        __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].http.get(wwfconfigs.WEB_API + '/sensis/address/detail?addressId=' + addressId).then(function (response) {
          resolve(response.body);
        }, function (error) {
          reject(error);
        });
      } catch (err) {
        reject(err);
      }
    });
  },
  validatePhone: function validatePhone(_ref3, phone) {
    var _this = this;

    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      try {
        __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].http.get(wwfconfigs.WEB_API + '/sensis/validate/phone?phone=' + phone).then(function () {
          var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(response) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.t0 = resolve;
                    _context.next = 3;
                    return dispatch('processSensisPhoneResponse', response.body);

                  case 3:
                    _context.t1 = _context.sent;
                    (0, _context.t0)(_context.t1);

                  case 5:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this);
          }));

          return function (_x) {
            return _ref4.apply(this, arguments);
          };
        }(), function (error) {
          reject(error);
        });
      } catch (err) {
        reject(err);
      }
    });
  },
  processSensisPhoneResponse: function processSensisPhoneResponse(_ref5, sensisResponse) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref5);

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (sensisResponse.status === "OK") {
        var result = sensisResponse.result;

        if (result.phone_status !== "Active" && result.phone_status !== "Unknown") {
          resolve({
            valid: false,
            data: { message: "Invalid phone number, try again" }
          });
        } else {
          // Valid
          resolve({
            valid: true
          });
        }
      } else {
        // If the call failed, do not keep the user from donati
        resolve({
          valid: true
        });
      }
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__(7);


/**
 * Update donor details
 */



var state = {
    update_details: {
        email: null,
        title: null,
        firstname: null,
        lastname: null,
        phone: null,
        address: null,
        state: null,
        city: null,
        postalcode: null,
        country: null,
        isProcessing: false
    }
};

var getters = {
    update_details: function update_details(state) {
        return state.update_details;
    }
};

var mutations = {
    mutate_firebase_user: function mutate_firebase_user(state, user) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state.update_details, user);
    },
    updateDetail: function updateDetail(state, _ref) {
        var field = _ref.field,
            value = _ref.value;

        __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.update_details, field, value);
    }
};

var actions = {
    create_firebase_record_from_emailaddress: function create_firebase_record_from_emailaddress(state) {
        return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post(wwfconfigs.WEB_API + "/update-details/create", {
            email: state.getters.update_details.email,
            ssoId: state.getters.ssoId
        });
    },

    get_data_from_email_link: function get_data_from_email_link(context) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            var n = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["d" /* getParameterByName */])("n");

            var decoden = "?" + window.atob(n);
            console.log("decodeq", decoden);
            var id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["d" /* getParameterByName */])("id", decoden);
            var token = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["d" /* getParameterByName */])("token", decoden);
            if (id && token) {
                context.commit('updateDetail', {
                    field: "key",
                    value: id
                });
                context.commit('updateDetail', {
                    field: "token",
                    value: token
                });
                console.log('context.getters.update_details.key', context.getters.update_details.key);

                __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.get(wwfconfigs.WEB_API + "/update-details/public?detailsId=" + id).then(function (response) {
                    if (response.body && response.body.email) {
                        console.log(response.body);
                        context.commit('mutate_firebase_user', response.body);
                        resolve(true);
                    } else {
                        console.log("empty", response.body);
                        resolve(false);
                    }
                }).catch(function (err) {
                    reject(err);
                });
            } else {
                resolve(false);
            }
        });
    },

    update_new_details_to_firebase: function update_new_details_to_firebase(context) {
        return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post(wwfconfigs.WEB_API + "/update-details/commit", {
            id: context.getters.update_details.key,
            public: {
                id: context.getters.update_details.key,
                email: context.getters.update_details.email,
                address: context.getters.update_details.address,
                city: context.getters.update_details.city,
                country: context.getters.update_details.country,
                state: context.getters.update_details.state,
                postalcode: context.getters.update_details.postalcode,
                firstname: context.getters.update_details.firstname,
                lastname: context.getters.update_details.lastname,
                phone: context.getters.update_details.phone,
                title: context.getters.update_details.title,
                isChanged: true
            }
        });
    },

    updateCreditCardDetails: function updateCreditCardDetails(context, data) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post(wwfconfigs.WEB_API + "/payment/tokenize", {
                token: data.token,
                cardHolderName: data.cardHolderName,
                custRef: state.update_details.key
            }).then(function (response) {
                console.log("updateCreditCardDetails - SUCCESS - ", response);
                resolve(response.body);
            }).catch(function (error) {
                console.error("updateCreditCardDetails - ERROR - ", error);
                state.update_details.isProcessing = false;
                reject(error);
            });
        });
    },


    // Old Bambora checkout
    update_details_checkout: function update_details_checkout(_ref2) {
        var dispatch = _ref2.dispatch,
            state = _ref2.state,
            commit = _ref2.commit;

        state.update_details.isProcessing = true;
        console.log('update_details_checkout', state);
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post(wwfconfigs.CLOUDFUNCTION + '/updatedetailscheckout', {
                email: state.update_details.email,
                custRef: state.update_details.key
            }).then(function (response) {
                console.log("update_details_checkout", response);
                state.update_details.isProcessing = false;
                // commit("updateDonation", {field : 'method', value: response.body.method});
                // commit("updateDonation", {field : 'url', value: response.body.url});
                resolve(response);
            }, function (error) {
                console.error("update_details_checkout", error);
                state.update_details.isProcessing = false;
                reject(error);
            });
        });
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wwfconfigs__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wwfconfigs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__wwfconfigs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_index__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vee_validate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_config__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_filter__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_resource__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_form_wizard__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_form_wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_print_js__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_print_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_print_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_youtube_embed__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_youtube_embed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_youtube_embed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_cookie__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_firebase_app__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_firebase_auth__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_utils_Amplitude_vue__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_utils_Amplitude_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_utils_Amplitude_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_ContactUs_vue__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_ContactUs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_ContactUs_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_LoyaltyForm_vue__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_LoyaltyForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_LoyaltyForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_NewsletterSignup_vue__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_NewsletterSignup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_NewsletterSignup_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_SocialMedia_vue__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_SocialMedia_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_SocialMedia_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_PetitionForm_vue__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_PetitionForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_PetitionForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_PetitionEpbc_vue__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_PetitionEpbc_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_PetitionEpbc_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_TwitchForm__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_TwitchForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_TwitchForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_WwfMenuCountryListBtn_vue__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_WwfMenuCountryListBtn_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_WwfMenuCountryListBtn_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_WwfRichmondFcForm_vue__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_WwfRichmondFcForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_WwfRichmondFcForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_YoutubeVideo_vue__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_YoutubeVideo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_YoutubeVideo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_ThankYouDonation_vue__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_ThankYouDonation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_ThankYouDonation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_ThankYouMultiAction_vue__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_ThankYouMultiAction_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_ThankYouMultiAction_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_utils_RichContentDisplay_vue__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_utils_RichContentDisplay_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_utils_RichContentDisplay_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_forms_Bequest_vue__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_forms_Bequest_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_forms_Bequest_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_forms_Edo_vue__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_forms_Edo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_forms_Edo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_forms_EdoPopup_vue__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_forms_EdoPopup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_forms_EdoPopup_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_forms_EdoVideoUpload_vue__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_forms_EdoVideoUpload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_forms_EdoVideoUpload_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_forms_PartnershipsForm_vue__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_forms_PartnershipsForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_forms_PartnershipsForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_forms_Petition_vue__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_forms_Petition_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_forms_Petition_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_forms_PetitionBio_vue__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_forms_PetitionBio_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_forms_PetitionBio_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_newsletter_Newsletter_vue__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_newsletter_Newsletter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_newsletter_Newsletter_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_forms_WorkplaceContactUs_vue__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_forms_WorkplaceContactUs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__components_forms_WorkplaceContactUs_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_forms_GatheredHerePopup_vue__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_forms_GatheredHerePopup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__components_forms_GatheredHerePopup_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_earth_hour_EarthhourRegistration_vue__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_earth_hour_EarthhourRegistration_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__components_earth_hour_EarthhourRegistration_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_earth_hour_EarthhourCompetition_vue__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_earth_hour_EarthhourCompetition_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__components_earth_hour_EarthhourCompetition_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_earth_hour_EarthhourLogoWall_vue__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_earth_hour_EarthhourLogoWall_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__components_earth_hour_EarthhourLogoWall_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_earth_hour_EarthhourPopup_vue__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_earth_hour_EarthhourPopup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__components_earth_hour_EarthhourPopup_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_search_SearchAutocomplete_vue__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_search_SearchAutocomplete_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__components_search_SearchAutocomplete_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_search_SearchResult_vue__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_search_SearchResult_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__components_search_SearchResult_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_product_FormProduct_vue__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_product_FormProduct_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__components_product_FormProduct_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_product_DollarHandleWidget_vue__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_product_DollarHandleWidget_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__components_product_DollarHandleWidget_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_donor_UpdateDetails_vue__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_donor_UpdateDetails_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__components_donor_UpdateDetails_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_product_DonateWidget_vue__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_product_DonateWidget_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__components_product_DonateWidget_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_product_DonateRgForm_vue__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_product_DonateRgForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__components_product_DonateRgForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_product_DonateTitle_vue__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_product_DonateTitle_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__components_product_DonateTitle_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_product_ProductSelector_vue__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_product_ProductSelector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__components_product_ProductSelector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_product_DonationListenner_vue__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_product_DonationListenner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__components_product_DonationListenner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_LogoWall_vue__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_LogoWall_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__components_LogoWall_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_donation_Donate_vue__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_donation_Donate_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__components_donation_Donate_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_leaf_relief_LeafRelief_vue__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_leaf_relief_LeafRelief_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__components_leaf_relief_LeafRelief_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_leaf_relief_ThankYouPopup_vue__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_leaf_relief_ThankYouPopup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__components_leaf_relief_ThankYouPopup_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_leaf_relief_IntentPopup_vue__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_leaf_relief_IntentPopup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__components_leaf_relief_IntentPopup_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_impact_project_ImpactProject_vue__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_impact_project_ImpactProject_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__components_impact_project_ImpactProject_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_impact_project_ImpactProjectHeader_vue__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_impact_project_ImpactProjectHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__components_impact_project_ImpactProjectHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_ecommerce_filter_EcommerceFilter_vue__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_ecommerce_filter_EcommerceFilter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60__components_ecommerce_filter_EcommerceFilter_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_ecommerce_EcommerceCarousel_vue__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_ecommerce_EcommerceCarousel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61__components_ecommerce_EcommerceCarousel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_ecommerce_EcommerceSlider_vue__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_ecommerce_EcommerceSlider_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62__components_ecommerce_EcommerceSlider_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_impact_project_ImpactProjectMilestones_vue__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_impact_project_ImpactProjectMilestones_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63__components_impact_project_ImpactProjectMilestones_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_impact_project_ImpactDonateWrapper_vue__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_impact_project_ImpactDonateWrapper_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64__components_impact_project_ImpactDonateWrapper_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_hub_RaHubSolutions_vue__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_hub_RaHubSolutions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65__components_hub_RaHubSolutions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_hub_RaHubCarousel_vue__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_hub_RaHubCarousel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66__components_hub_RaHubCarousel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_StepUp_vue__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_StepUp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67__components_StepUp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_DonationWidget_vue__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_DonationWidget_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68__components_DonationWidget_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__components_dynamic_petition_DynamicPetition_vue__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__components_dynamic_petition_DynamicPetition_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69__components_dynamic_petition_DynamicPetition_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__styles_global_css__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__styles_global_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70__styles_global_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__styles_unknown_css__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__styles_unknown_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71__styles_unknown_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__styles_form_css__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__styles_form_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72__styles_form_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__styles_donation_form_css__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__styles_donation_form_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73__styles_donation_form_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__styles_thankyou_popup_css__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__styles_thankyou_popup_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74__styles_thankyou_popup_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__styles_popup_petition_message_css__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__styles_popup_petition_message_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75__styles_popup_petition_message_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__styles_vdp_datepicker_css__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__styles_vdp_datepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76__styles_vdp_datepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__styles_autocomplete_css__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__styles_autocomplete_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77__styles_autocomplete_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__styles_search_bar_css__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__styles_search_bar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78__styles_search_bar_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__styles_earth_hour_popup_css__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__styles_earth_hour_popup_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79__styles_earth_hour_popup_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__styles_edo_supporter_messages_css__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__styles_edo_supporter_messages_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80__styles_edo_supporter_messages_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__styles_donation_css__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__styles_donation_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81__styles_donation_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__styles_donation_carousel_css__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__styles_donation_carousel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82__styles_donation_carousel_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__styles_leaf_relief_css__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__styles_leaf_relief_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83__styles_leaf_relief_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__styles_stepup_popup_css__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__styles_stepup_popup_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_84__styles_stepup_popup_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__styles_carousel_css__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__styles_carousel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_85__styles_carousel_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__utils_gtm__ = __webpack_require__(10);



// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





// Libraries
 // Validations library http://vee-validate.logaretm.com/


 // Vue resource library https://github.com/pagekit/vue-resource/blob/develop/docs/http.md


 // https://github.com/kaorun343/vue-youtube-embed




// Amplitude


// Components














// Forms











// Earth Hour





// Components - Search



// Components - Donation related









//


// RA
















// Dynamic Petition


// CSS
















// Website related CSS


// Helpers




__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_vue_youtube_embed___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vee_validate__["a" /* default */], { events: '' });
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_config___default.a, wwfconfigs);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_form_wizard___default.a); // Vue form wizard register
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_filter___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_12_vue_cookie___default.a);

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].directive('click-outside', {
  bind: function bind(el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his children
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unbind: function unbind(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  }
});

var firebaseConfig = {
  apiKey: wwfconfigs.FIREBASE_API_KEY,
  projectId: wwfconfigs.FIREBASE_PROJECT_ID
};
__WEBPACK_IMPORTED_MODULE_13_firebase_app__["a" /* default */].initializeApp(firebaseConfig);

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;

var vm = new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
  el: '#bodyapp',
  store: __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */],
  data: function data() {
    return {
      revealDonation: null,
      revealPetition: null,
      revealPetitionMessage: null,
      revealEarthHour: null,
      revealCustomContent: null,
      revealStepUp: null,
      revealLetter: null,
      isProcessing: false
    };
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])({
    donation: function donation(state) {
      return state.donation.donation;
    },
    product: function product(state) {
      return state.product.product;
    },
    update_details: function update_details(state) {
      return state.updates.update_details;
    },
    thankYouPopup: function thankYouPopup(state) {
      return state.popup.content;
    },
    openDonationPopup: function openDonationPopup(state) {
      return state.popup.openDonationPopup;
    },
    openPetitionPopup: function openPetitionPopup(state) {
      return state.popup.openPetitionPopup;
    },
    openPetitionMessagePopup: function openPetitionMessagePopup(state) {
      return state.popup.openPetitionMessagePopup;
    },
    openEarthHourPopup: function openEarthHourPopup(state) {
      return state.popup.openEarthHourPopup;
    },
    openCustomContentPopup: function openCustomContentPopup(state) {
      return state.popup.openCustomContentPopup;
    },
    openStepUpPopup: function openStepUpPopup(state) {
      return state.popup.openStepUpPopup;
    }
  }),
  created: function created() {
    var _this = this;

    this.$store.dispatch('login').then(function () {
      _this.$store.dispatch('initAmplitude');
    });
  },
  mounted: function mounted() {
    // Don't mount the reveal if edit mode
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_86__helpers__["a" /* isEditMode */])()) {
      this.revealDonation = new Foundation.Reveal($('#reveal-dialog-donation'), { animationIn: 'fade-in-up fast' });
      this.revealPetition = new Foundation.Reveal($('#reveal-dialog-petition'), { animationIn: 'fade-in-up fast' });
      this.revealPetitionMessage = new Foundation.Reveal($('#reveal-popup-petition-message'), { animationIn: 'fade-in-up fast', additionalOverlayClasses: 'popup-no-scroll' });
      this.revealEarthHour = new Foundation.Reveal($('#reveal-dialog'), { animationIn: 'fade-in-up fast', additionalOverlayClasses: 'popup-black-background' });
      this.revealCustomContent = new Foundation.Reveal($('#reveal-popup-custom-content'), { animationIn: 'fade-in-up fast' });
      this.revealStepUp = new Foundation.Reveal($('#reveal-popup-stepup'), { animationIn: 'fade-in-up fast' });
    }

    // Amplitude event tracking, site wide
    try {
      // Run when child components have mounted
      this.$nextTick(function () {
        var _this2 = this;

        // Skip pages with an amplitude id or donation form, as these already have their own specific amplitude events
        if (!$('[id^=amplitude-], #donate-form, .dynamic-petition').length) {
          this.$store.dispatch('logLandingVisit');
        }

        // Add tracking to WWF & Donate navigation menus
        $('#ra-menu .item, .b-nav .b-nav__item, #MobileNav .b-mobile-nav__item').on('click', 'a', function (e) {
          _this2.$store.dispatch('logNavClick', {
            topMenuName: $(e.delegateTarget).find('a').first().text(),
            subMenuName: $(e.target).text()
          });
        });

        // Add tracking to Earth Hour navigation menus
        $('.desktop-navigation ul.hmenu').on('click', 'a', function (e) {
          _this2.$store.dispatch('logNavClick', {
            topMenuName: $(e.delegateTarget).find('a').first().text(),
            subMenuName: $(e.target).text()
          });
        });

        // Track Earth Hour Mobile nav
        $('.eh-mobile-navigation .eh-menu ul.hmenu').on('click', 'a', function (e) {
          _this2.$store.dispatch('logNavClick', {
            topMenuName: $(e.delegateTarget).find('a').first().text(),
            subMenuName: $(e.target).text()
          });
        });

        // Add tracking to WWF mobile navigation menu
        $('#ra-menu-popup').on('click', 'a', function (e) {
          _this2.$store.dispatch('logNavClick', {
            topMenuName: $(e.target).text()
          });
        });

        // Add tracking on navigation search
        $('#wwf-search, .search-mob, #search-autocomplete-input').on('focus', function (e) {
          _this2.$store.dispatch('logSearchClick');
        });

        $('#wwf-search, .search-mob').on('keydown', function (e) {
          if (e.keyCode == 13) {
            _this2.$store.dispatch('logSearchEnter', {
              searchValue: $(e.target).val()
            });
          }
        });

        // Add tracking to all page links
        $('#bodyapp').on('click', 'a', function (e) {
          _this2.$store.dispatch('logPageLink', e.target.href);
        });

        // Exclude navigation menu from above event delegation
        $('#ra-menu, .ra-menu-mobile, .b-header, #MobileNav').on('click', function (e) {
          e.stopPropagation();
        });

        // Add tracking to all page buttons
        $('#bodyapp').on('click', 'button', function (e) {
          _this2.$store.dispatch('logPageButton', $(e.target).text().trim());
        });
      });
    } catch (error) {
      console.log(error);
    }
  },

  watch: {
    openDonationPopup: function openDonationPopup(val) {
      var _this3 = this;

      if (val === true && this.revealDonation) {
        var payload = {
          amount: this.donation.amount,
          donationtype: this.donation.type,
          payementType: this.donation.payementType,
          transactionid: this.donation.transactionid,
          productname: this.product.productname,
          producttype: this.product.producttype,
          productid: this.product.id,
          postcode: this.donation.billing.postcode,
          firstname: this.donation.firstname,
          lastname: this.donation.lastname,
          certificateurl: this.product.certificateurl,
          wildcardurl: this.donation.wildcard && this.donation.wildcard.pdf ? this.donation.wildcard.pdf : null,
          showCertificate: this.product.producttype === 'adoption',
          isMonthly: this.donation.type === 'Regular',
          showWildcard: this.product.producttype === 'wildcard'
        };

        // Send data to Google Tag Manager
        __WEBPACK_IMPORTED_MODULE_87__utils_gtm__["a" /* default */].pushPurchase(payload.transactionid, payload.productname, payload.productid, payload.producttype, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_86__helpers__["b" /* getNameByDonationType */])(payload.donationtype), payload.amount, payload.postcode, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_86__helpers__["c" /* getNameByPaymentType */])(payload.payementType));

        // Set the data to display in the popup
        this.thankYouPopup.firstname = payload.firstname;
        this.thankYouPopup.lastname = payload.lastname;
        this.thankYouPopup.amount = payload.amount;
        this.thankYouPopup.showCertificate = payload.showCertificate;
        this.thankYouPopup.certificateurl = payload.certificateurl;
        this.thankYouPopup.isMonthly = payload.isMonthly;
        this.thankYouPopup.showWildcard = payload.showWildcard;
        this.thankYouPopup.wildcardurl = payload.wildcardurl;

        this.revealDonation.open();
        setTimeout(function () {
          _this3.thankYouPopup.isOpen = true;
          _this3.$store.commit('openDonationPopup', false);
        }, 200);

        if (this.$refs.formproduct && payload.paymenttype != "wwf_paypal") {
          this.$refs.formproduct.reset();
        }
      }
    },
    openPetitionPopup: function openPetitionPopup(val) {
      var _this4 = this;

      if (val === true && this.revealPetition) {
        this.revealPetition.open();
        setTimeout(function () {
          _this4.thankYouPopup.isOpen = true;
          _this4.$store.commit('openPetitionPopup', false);
        }, 200);
      }
    },
    openPetitionMessagePopup: function openPetitionMessagePopup(val) {
      var _this5 = this;

      if (val === true && this.revealPetitionMessage) {
        this.revealPetitionMessage.open();
        setTimeout(function () {
          _this5.thankYouPopup.isOpen = true;
          _this5.$store.commit('openPetitionMessagePopup', false);
        }, 200);
      }
    },
    openEarthHourPopup: function openEarthHourPopup(val) {
      var _this6 = this;

      if (val === true && this.revealEarthHour) {
        this.revealEarthHour.open();
        setTimeout(function () {
          _this6.thankYouPopup.isOpen = true;
          _this6.$store.commit('openEarthHourPopup', false);
        }, 200);
      }
    },
    openCustomContentPopup: function openCustomContentPopup(val) {
      var _this7 = this;

      if (val === true && this.revealCustomContent) {
        this.revealCustomContent.open();
        setTimeout(function () {
          _this7.thankYouPopup.isOpen = true;
          _this7.$store.commit('openCustomContentPopup', false);
        }, 200);
      }
    },
    openStepUpPopup: function openStepUpPopup(val) {
      var _this8 = this;

      if (val === true && this.revealStepUp) {
        this.revealStepUp.open();
        setTimeout(function () {
          _this8.thankYouPopup.isOpen = true;
          _this8.$store.commit('openStepUpPopup', false);
        }, 200);
      }
    }
  },
  methods: {
    openThankYouPopup: function openThankYouPopup(e) {
      var _this9 = this;

      var _e = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(e, 8);

      this.thankYouPopup.firstname = _e[0];
      this.thankYouPopup.lastname = _e[1];
      this.thankYouPopup.amount = _e[2];
      this.thankYouPopup.showCertificate = _e[3];
      this.thankYouPopup.certificateurl = _e[4];
      this.thankYouPopup.isMonthly = _e[5];
      this.thankYouPopup.showWildcard = _e[6];
      this.thankYouPopup.wildcardurl = _e[7];

      if (this.revealDonation) {
        this.revealDonation.open();
        setTimeout(function () {
          return _this9.thankYouPopup.isOpen = true;
        }, 200);
      }
    },
    openThankYouPopupPetition: function openThankYouPopupPetition(e) {
      var _this10 = this;

      var _e2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(e, 6);

      this.thankYouPopup.title = _e2[0];
      this.thankYouPopup.message = _e2[1];
      this.thankYouPopup.shareButton = _e2[2];
      this.thankYouPopup.recommendedReading = _e2[3];
      this.thankYouPopup.component = _e2[4];
      this.thankYouPopup.componentparams = _e2[5];

      this.revealPetition.open();
      setTimeout(function () {
        return _this10.thankYouPopup.isOpen = true;
      }, 200);
    },
    thankyou: function thankyou(amount, donationtype, transactionid, productname, postcode, firstname, lastname, producttype, certificateurl, productid, paymenttype, wildcardurl) {
      __WEBPACK_IMPORTED_MODULE_87__utils_gtm__["a" /* default */].pushPurchase(transactionid, productname, productid, producttype, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_86__helpers__["b" /* getNameByDonationType */])(donationtype), amount, postcode, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_86__helpers__["c" /* getNameByPaymentType */])(paymenttype));
      this.openThankYouPopup([firstname, lastname, amount, producttype == 'adoption', certificateurl, donationtype == 'Regular', producttype == 'wildcard', wildcardurl]);
      if (this.$refs.formproduct && paymenttype != "wwf_paypal") {
        this.$refs.formproduct.reset();
      }
    },
    confirmtransaction: function confirmtransaction(transactionid) {
      console.log('confirmtransaction::transactionid', transactionid);
      this.thankyou(this.donation.amount, this.donation.type, transactionid, this.product.productname, this.donation.billing.postcode, this.donation.firstname, this.donation.lastname, this.product.producttype, this.product.certificateurl, this.product.id, this.donation.payementType, this.donation.wildcard && this.donation.wildcard.pdf ? this.donation.wildcard.pdf : null);
    },
    confirmtransactionupdatedetail: function confirmtransactionupdatedetail(maskedcard, name, date, type) {
      if (this.$refs.updatedetail) {
        this.$refs.updatedetail.confirmtransaction(maskedcard, name, date, type);
      }
    },
    retryupdatedetail: function retry() {
      if (this.$refs.updatedetail) {
        this.$refs.updatedetail.retry();
      }
    },
    retry: function retry() {
      if (this.$refs.formproduct) {
        this.$refs.formproduct.retry();
      }
    },
    disablesteps: function disablesteps() {
      if (this.$refs.formproduct) {
        this.$refs.formproduct.disablesteps();
      }
    },
    printCertificate: function printCertificate() {
      __WEBPACK_IMPORTED_MODULE_10_print_js___default()({ printable: 'certificate', type: 'html', targetStyles: ['*'] });
    },
    printCertificateNew: function printCertificateNew() {
      console.log('This is a print');
      __WEBPACK_IMPORTED_MODULE_10_print_js___default()({ printable: 'thank-you-certificate', type: 'html', targetStyles: ['*'] });
    }
  },
  components: {
    DonateRgForm: __WEBPACK_IMPORTED_MODULE_49__components_product_DonateRgForm_vue___default.a,
    YoutubeVideo: __WEBPACK_IMPORTED_MODULE_25__components_YoutubeVideo_vue___default.a,
    NewsletterSignup: __WEBPACK_IMPORTED_MODULE_18__components_NewsletterSignup_vue___default.a,
    MyPetitionForm: __WEBPACK_IMPORTED_MODULE_20__components_PetitionForm_vue___default.a,
    MyPetitionEpbc: __WEBPACK_IMPORTED_MODULE_21__components_PetitionEpbc_vue___default.a,
    MyTwitchForm: __WEBPACK_IMPORTED_MODULE_22__components_TwitchForm___default.a,
    ContactUs: __WEBPACK_IMPORTED_MODULE_16__components_ContactUs_vue___default.a,
    LoyaltyForm: __WEBPACK_IMPORTED_MODULE_17__components_LoyaltyForm_vue___default.a,
    WwfRichmondFcForm: __WEBPACK_IMPORTED_MODULE_24__components_WwfRichmondFcForm_vue___default.a,
    WwfMenuCountryListBtn: __WEBPACK_IMPORTED_MODULE_23__components_WwfMenuCountryListBtn_vue___default.a,
    PartnershipsForm: __WEBPACK_IMPORTED_MODULE_33__components_forms_PartnershipsForm_vue___default.a,
    FormProduct: __WEBPACK_IMPORTED_MODULE_45__components_product_FormProduct_vue___default.a,
    DollarHandleWidget: __WEBPACK_IMPORTED_MODULE_46__components_product_DollarHandleWidget_vue___default.a,
    UpdateDetails: __WEBPACK_IMPORTED_MODULE_47__components_donor_UpdateDetails_vue___default.a,
    DonateWidget: __WEBPACK_IMPORTED_MODULE_48__components_product_DonateWidget_vue___default.a,
    Bequest: __WEBPACK_IMPORTED_MODULE_29__components_forms_Bequest_vue___default.a,
    SearchAutocomplete: __WEBPACK_IMPORTED_MODULE_43__components_search_SearchAutocomplete_vue___default.a,
    SearchResult: __WEBPACK_IMPORTED_MODULE_44__components_search_SearchResult_vue___default.a,
    SocialMedia: __WEBPACK_IMPORTED_MODULE_19__components_SocialMedia_vue___default.a,
    ThankYouDonation: __WEBPACK_IMPORTED_MODULE_26__components_ThankYouDonation_vue___default.a,
    ThankYouMultiAction: __WEBPACK_IMPORTED_MODULE_27__components_ThankYouMultiAction_vue___default.a,
    DonationTitle: __WEBPACK_IMPORTED_MODULE_50__components_product_DonateTitle_vue___default.a,
    EarthhourRegistration: __WEBPACK_IMPORTED_MODULE_39__components_earth_hour_EarthhourRegistration_vue___default.a,
    EarthhourCompetition: __WEBPACK_IMPORTED_MODULE_40__components_earth_hour_EarthhourCompetition_vue___default.a,
    EdoForm: __WEBPACK_IMPORTED_MODULE_30__components_forms_Edo_vue___default.a,
    EdoPopup: __WEBPACK_IMPORTED_MODULE_31__components_forms_EdoPopup_vue___default.a,
    EdoVideoUpload: __WEBPACK_IMPORTED_MODULE_32__components_forms_EdoVideoUpload_vue___default.a,
    EarthhourLogoWall: __WEBPACK_IMPORTED_MODULE_41__components_earth_hour_EarthhourLogoWall_vue___default.a,
    EarthhourPopup: __WEBPACK_IMPORTED_MODULE_42__components_earth_hour_EarthhourPopup_vue___default.a,
    Petition: __WEBPACK_IMPORTED_MODULE_34__components_forms_Petition_vue___default.a,
    PetitionBio: __WEBPACK_IMPORTED_MODULE_35__components_forms_PetitionBio_vue___default.a,
    ProductSelector: __WEBPACK_IMPORTED_MODULE_51__components_product_ProductSelector_vue___default.a,
    DonationListenner: __WEBPACK_IMPORTED_MODULE_52__components_product_DonationListenner_vue___default.a,
    RichContentDisplay: __WEBPACK_IMPORTED_MODULE_28__components_utils_RichContentDisplay_vue___default.a,
    Donate: __WEBPACK_IMPORTED_MODULE_54__components_donation_Donate_vue___default.a,
    LeafRelief: __WEBPACK_IMPORTED_MODULE_55__components_leaf_relief_LeafRelief_vue___default.a,
    LeafReliefThankYouPopup: __WEBPACK_IMPORTED_MODULE_56__components_leaf_relief_ThankYouPopup_vue___default.a,
    LeafReliefIntentPopup: __WEBPACK_IMPORTED_MODULE_57__components_leaf_relief_IntentPopup_vue___default.a,
    ImpactProject: __WEBPACK_IMPORTED_MODULE_58__components_impact_project_ImpactProject_vue___default.a,
    ImpactProjectHeader: __WEBPACK_IMPORTED_MODULE_59__components_impact_project_ImpactProjectHeader_vue___default.a,
    EcommerceFilter: __WEBPACK_IMPORTED_MODULE_60__components_ecommerce_filter_EcommerceFilter_vue___default.a,
    EcommerceCarousel: __WEBPACK_IMPORTED_MODULE_61__components_ecommerce_EcommerceCarousel_vue___default.a,
    EcommerceSlider: __WEBPACK_IMPORTED_MODULE_62__components_ecommerce_EcommerceSlider_vue___default.a,
    ImpactProjectMilestones: __WEBPACK_IMPORTED_MODULE_63__components_impact_project_ImpactProjectMilestones_vue___default.a,
    ImpactDonateWrapper: __WEBPACK_IMPORTED_MODULE_64__components_impact_project_ImpactDonateWrapper_vue___default.a,
    RaHubSolutions: __WEBPACK_IMPORTED_MODULE_65__components_hub_RaHubSolutions_vue___default.a,
    RaHubCarousel: __WEBPACK_IMPORTED_MODULE_66__components_hub_RaHubCarousel_vue___default.a,
    Newsletter: __WEBPACK_IMPORTED_MODULE_36__components_newsletter_Newsletter_vue___default.a,
    Amplitude: __WEBPACK_IMPORTED_MODULE_15__components_utils_Amplitude_vue___default.a,
    StepUp: __WEBPACK_IMPORTED_MODULE_67__components_StepUp_vue___default.a,
    DonationWidget: __WEBPACK_IMPORTED_MODULE_68__components_DonationWidget_vue___default.a,
    DynamicPetition: __WEBPACK_IMPORTED_MODULE_69__components_dynamic_petition_DynamicPetition_vue___default.a,
    WorkplaceContactUs: __WEBPACK_IMPORTED_MODULE_37__components_forms_WorkplaceContactUs_vue___default.a,
    GatheredHerePopup: __WEBPACK_IMPORTED_MODULE_38__components_forms_GatheredHerePopup_vue___default.a,
    LogoWall: __WEBPACK_IMPORTED_MODULE_53__components_LogoWall_vue___default.a
  }
});

window.app = vm;

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "contactUs",
  data: function data() {
    return {
      isShake: false,
      step1: true,
      step2: false,
      serverErrors: false,
      emailAddress: "",
      subject: "",
      phone: "",
      message: "",
      isLoading: false
    };
  },

  methods: {
    postTicket: function postTicket() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          if (!_this.isLoading) {
            _this.isLoading = true;
            _this.$http.post(wwfconfigs.WEB_API + "/zendesk/create", {
              emailAddress: _this.emailAddress,
              subject: _this.subject,
              phone: _this.phone,
              message: _this.message
            }).then(function (response) {
              _this.step1 = false;
              _this.step2 = true;
              _this.isLoading = false;
              console.log(response);
            }).catch(function (err) {
              _this.step1 = false;
              _this.step2 = true;
              _this.serverErrors = true;
              _this.isLoading = false;
              console.error(err);
            });
          }
        } else {
          console.log("form invalid");
          _this.isShake = true;
          setTimeout(function () {
            this.isShake = false;
          }.bind(_this), 500);
        }
      });
    }
  }
});

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "DonationWidget",

  computed: {
    formWizardCurrentStep: function formWizardCurrentStep() {
      return this.$store.getters.donation.formWizardCurrentStep;
    },

    dollarhandle: {
      get: function get() {
        return this.$store.getters.donation.dollarhandle;
      },
      set: function set(value) {
        this.amount = value == "custom" ? null : value;
        this.$store.commit("updateDonation", { field: "dollarhandle", value: value });
      }
    },
    type: {
      get: function get() {
        return this.$store.getters.donation.type;
      },
      set: function set(value) {
        this.$store.commit("updateDonation", { field: "type", value: value });
      }
    },
    amount: {
      get: function get() {
        return this.$store.getters.donation.amount;
      },
      set: function set(value) {
        this.$store.commit("updateDonation", { field: "amount", value: value });
      }
    },

    product: function product() {
      return this.$store.getters.product;
    }
  },

  methods: {
    updateDollarHandle: function updateDollarHandle(value) {
      if (this.formWizardCurrentStep == 0) {
        this.dollarhandle = value;
      }
    }
  }
});

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "LogoWall",
  data: function data() {
    return {
      logos: [],
      showLoadMore: true,
      currentPage: 1,
      fetching: false
    };
  },

  props: {
    section: {
      type: String,
      default: null
    },
    size: {
      type: Number,
      default: 5
    },
    campaignId: {
      type: String,
      required: true
    }
  },

  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this.$store.dispatch("getLogos", {
                section: _this.section,
                page: _this.currentPage,
                size: _this.size,
                campaignId: _this.campaignId
              });

            case 3:
              _this.logos = _context.sent;


              if (_this.logos.length < _this.size) {
                _this.showLoadMore = false;
              }
              _context.next = 11;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);

              console.error(_context.t0);
              _this.logos = [];

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 7]]);
    }))();
  },


  methods: {
    fetchLogos: function fetchLogos() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _logos, newLogos;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this2.fetching = true;
                _context2.next = 4;
                return _this2.$store.dispatch("getLogos", {
                  section: _this2.section,
                  page: ++_this2.currentPage,
                  size: _this2.size,
                  campaignId: _this2.campaignId
                });

              case 4:
                newLogos = _context2.sent;


                if (newLogos && newLogos.length < _this2.size) {
                  _this2.showLoadMore = false;
                }

                (_logos = _this2.logos).push.apply(_logos, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(newLogos));
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);

                console.error(_context2.t0);

              case 12:
                _context2.prev = 12;

                _this2.fetching = false;
                return _context2.finish(12);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 9, 12, 15]]);
      }))();
    }
  }
});

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "loyaltyForm",
  created: function created() {

    var code = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* getParameterByName */])("code");
    console.log(code);

    this.$store.dispatch("getLoyaltyDataByUniqueCode", code);
  },
  props: {
    isActive: {
      //:is-active="false"
      type: Boolean,
      required: true
    },
    thankyoutitle: {
      //thankyoutitle="Test thankyou title"
      type: String,
      required: true
    },
    thankyoumessage: {
      //thankyoumessage="Test thankyou message"
      type: String,
      required: true
    },
    closingmessage: {
      //closingmessage="Test the compatition has closed."
      type: String,
      default: "This petition has now closed."
    }
  },
  data: function data() {
    return {
      points: 0,
      rewards: [],
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      address: '',
      rewardid: '',
      isLoading: false,
      error: false,
      isFlip: false,
      isCollapse: false,
      isShake: false };
  },
  methods: {
    save: function save() {
      var _this = this;

      this.$validator.validate().then(function (result) {
        if (result) {
          _this.$store.dispatch("saveReward", {
            email: _this.email,
            firstname: _this.firstName,
            lastname: _this.lastName,
            phone: _this.phone,
            rewardid: _this.rewardid,
            address: _this.address
          }).then(function (response) {
            console.log("save reward submit success", response);

            if (window.dataLayer != undefined) {
              window.dataLayer.push({
                formName: "loyaltyform",
                event: "formSubmitSuccessEvent"
              });
            }

            // Reset form
            _this.firstName = "";
            _this.lastName = "";
            _this.email = "";
            _this.phone = "";
            _this.rewardid = "";
            _this.address = "";
            _this.$store.dispatch("getLoyaltyDataByUniqueCode", _this.$store.getters.code);
          }, function (error) {
            console.error("save reward failed");
          });

          _this.$store.commit("setPopupContent", {
            title: _this.thankyoutitle,
            message: _this.thankyoumessage,
            shareButton: false,
            recommendedReading: true,
            component: null,
            componentparams: null
          });
          _this.$store.commit("openPetitionPopup", true);
        } else {
          console.log("form invalid");
          // GTM Tracking
          if (window.dataLayer != undefined) {
            window.dataLayer.push({
              formName: "loyaltyform",
              event: "formSubmitEvent"
            });
          }
          _this.isShake = true;
          setTimeout(function () {
            this.isShake = false;
          }.bind(_this), 500);
        }
      });
    }
  }
});

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'newsletterSignup',
    data: function data() {
        return {
            firstName: '',
            lastName: '',
            email: '',
            postCode: '',
            isOpen: '',
            timeout: null,
            lastTimestamp: Date.now(),
            checkEmailLoading: false,
            emailRegex: /.+\@.+\..+/
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])({
        user: function user(state) {
            return state.auth.user;
        }
    })),

    created: function created() {
        var _this = this;

        var newsletterCheckEmail = function newsletterCheckEmail(email) {
            if (email.length > 0 && _this.emailRegex.test(email)) {
                return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                    var timestamp = Date.now(); // timestamp for this api call
                    _this.lastTimestamp = timestamp; // 1 , 2 , 3
                    _this.checkEmailLoading = true;
                    // Fetch Suggestions
                    _this.$store.dispatch("validateEmail", email).then(function (response) {
                        if (response && timestamp >= _this.lastTimestamp) {
                            _this.checkEmailLoading = false;
                            resolve(response);
                        }
                    }).catch(function (err) {
                        console.error(err);
                        _this.checkEmailLoading = false;
                        // If the call failed, do not keep the user from donating
                        resolve({
                            valid: true
                        });
                    });
                });
            } else {
                return {
                    valid: false,
                    data: { message: "Email invalid" }
                };
            }
        };

        __WEBPACK_IMPORTED_MODULE_2_vee_validate__["b" /* Validator */].extend("newsletterCheckEmail", {
            validate: newsletterCheckEmail,
            getMessage: function getMessage(field, params, data) {
                return data.message;
            }
        });
    },


    methods: {
        postForm: function postForm() {
            var _this2 = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    var postBody = {
                        email: _this2.email,
                        firstName: _this2.firstName,
                        lastName: _this2.lastName,
                        postcode: _this2.postCode,
                        programName: _this2.$config.NEWSLETTERSUBSCRIBELIST,
                        cookieID: _this2.$cookie.get("_mkto_trk"),
                        ssoId: _this2.$store.getters.ssoId
                    };

                    _this2.$store.dispatch("saveLead", {
                        campaignId: 'newsletter-signup',
                        lead: postBody
                    }).then(function (response) {
                        console.log("subscribeNewsletter success");

                        if (window.dataLayer != undefined) {
                            window.dataLayer.push({
                                formName: 'newsletter-signup',
                                event: "formSubmitSuccessEvent"
                            });
                        }

                        //Reset form
                        _this2.firstName = "";
                        _this2.lastName = "";
                        _this2.email = "";
                        _this2.phone = "";
                        _this2.postCode = "";
                    }, function (error) {
                        console.error("subscribeNewsletter failed");
                    });

                    _this2.$store.commit("setPopupContent", {
                        title: 'Hi ' + _this2.firstName + ', welcome to WWF-Australia!',
                        message: 'We\'ll send an email to ' + _this2.email + ' to you soon.',
                        shareButton: false,
                        recommendedReading: true,
                        component: null,
                        componentparams: null
                    });
                    _this2.$store.commit("openPetitionPopup", true);
                } else {
                    console.log('form invalid');
                    // GTM Tracking
                    if (window.dataLayer != undefined) {
                        window.dataLayer.push({ 'formName': 'newsletter-signup', 'event': 'formSubmitEvent' });
                    }
                }
            });
        }
    }
});

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vee_validate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_count_to__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_count_to___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_count_to__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Progressbar_vue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Progressbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Progressbar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers__ = __webpack_require__(7);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var _require = __webpack_require__(22),
    detect = _require.detect;

var browser = detect();


/* harmony default export */ __webpack_exports__["default"] = ({
  components: { countTo: __WEBPACK_IMPORTED_MODULE_7_vue_count_to___default.a, progressbar: __WEBPACK_IMPORTED_MODULE_8__Progressbar_vue___default.a },
  name: "my-petitionEpbc",
  created: function created() {
    var _this = this;

    // Define some mandatory fields with the query params
    var uri = window.location.search.substring(1);
    if (uri.length > 0) {
      var params = new URLSearchParams(uri);

      // TYPE
      var typeParam = params.get("type");
      this.queryCampaign = typeParam ? typeParam : '';

      if (this.queryCampaign.includes('epbc')) {
        this.manatoryFields.push('phoneNumber');
      }

      // utm_source
      this.utmSourceParam = params.get("utm_source");
      this.isFromRokt = this.utmSourceParam && this.utmSourceParam.includes('rokt') ? true : false;
    }

    // Check if there are some query string in URL to prefill the form, Query from donate widget
    var q = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__helpers__["d" /* getParameterByName */])("q");
    if (q) {
      var decodeq = "?" + window.atob(q);
      console.log("decodeq", decodeq);
      this.firstName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__helpers__["d" /* getParameterByName */])("firstname", decodeq);
      this.lastName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__helpers__["d" /* getParameterByName */])("lastname", decodeq);
      this.email = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__helpers__["d" /* getParameterByName */])("email", decodeq);
      this.postCode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__helpers__["d" /* getParameterByName */])("postcode", decodeq);
      this.phoneNumber = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__helpers__["d" /* getParameterByName */])("phone", decodeq);

      if (this.postCode != null && this.postCode != undefined && this.postCode.length > 0) {
        this.postcodeUpdated();
      }
    }

    var o = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__helpers__["d" /* getParameterByName */])("o");
    if (o) {
      this.origin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__helpers__["d" /* getParameterByName */])("o");
    }

    // Query if we're coming back from step up
    var b = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__helpers__["d" /* getParameterByName */])("b");
    if (b) {
      this.isThankYou = true;
    }

    // Define if we show the counter
    if (this.showcounter || this.showprogressbar) {
      this.$store.dispatch("getCounterByCampaignId", this.datalayername);
    }

    // Check the email
    var petitionEmailIsValid = function petitionEmailIsValid(email) {
      return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a.all([_this.checkEmailDuplicate(), _this.checkEmail()]).then(function (results) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(results), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var r = _step.value;

              if (!r.valid) {
                return resolve(r);
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          _this.errors.remove("email");
          resolve({ valid: true });
        }).catch(function (err) {
          console.error(err);
          _this.errors.remove("email");
          resolve({ valid: true });
        });
      });
    };

    __WEBPACK_IMPORTED_MODULE_6_vee_validate__["b" /* Validator */].extend("petitionEmailIsValid", {
      validate: petitionEmailIsValid,
      getMessage: function getMessage(field, params, data) {
        return data.message;
      }
    });

    // Check the postcode
    var petitionPostCodeIsValid = function petitionPostCodeIsValid(postCode) {
      if (_this.restrictedPostcode && (!_this.state || _this.state.length === 0)) {
        return {
          valid: false,
          data: { message: "Please enter a postcode between 0000 and 9999" }
        };
      } else {
        return {
          valid: true
        };
      }
    };

    __WEBPACK_IMPORTED_MODULE_6_vee_validate__["b" /* Validator */].extend("petitionPostCodeIsValid", {
      validate: petitionPostCodeIsValid,
      getMessage: function getMessage(field, params, data) {
        return data.message;
      }
    });

    // Check Phone Number
    var petitionPhoneNumberIsValid = function petitionPhoneNumberIsValid(phoneNumber) {
      var validationRegex = /^(\+?61|0)([0-9]{8,9})/;
      if (!phoneNumber.replace(/ /g, '').match(validationRegex)) {
        return {
          valid: false,
          data: { message: "Invalid phone number" }
        };
      } else {
        return {
          valid: true
        };
      }
    };

    __WEBPACK_IMPORTED_MODULE_6_vee_validate__["b" /* Validator */].extend("petitionPhoneNumberIsValid", {
      validate: petitionPhoneNumberIsValid,
      getMessage: function getMessage(field, params, data) {
        return data.message;
      }
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.showcounter && this.$refs.counter) {
      this.$refs.counter.start();
    }

    // Fetch the content of the messages
    if (this.lettermessage) {
      this.$store.dispatch('getContentMessageById', this.lettermessage).then(function (value) {
        if (value) {
          _this2.letterContent = value.content;
        } else {
          _this2.letterContent = '';
        }
        _this2.selectedFixedMessage = _this2.letterContent;
      });
    }

    if (this.lettermessages) {
      var values = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(this.lettermessages);

      this.$store.dispatch("getContentMessageById", values.join(',')).then(function (response) {
        response = response.filter(function (e) {
          return e;
        });
        _this2.letterContents = {};

        var _loop = function _loop(s) {
          var contentId = _this2.lettermessages[s];
          var content = response.find(function (e) {
            return e.id === contentId;
          });

          // Display empty if the content do not exist
          if (content) {
            _this2.letterContents[s] = _this2.formatMessageContent(content.content);
          } else {
            _this2.letterContents[s] = '';
          }
        };

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this2.lettermessages)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var s = _step2.value;

            _loop(s);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapState */])({
    user: function user(state) {
      return state.auth.user;
    }
  }), {
    endcounter: function endcounter() {
      return this.$store.getters.counter ? this.$store.getters.counter : 0;
    },
    getextracampaignsList: function getextracampaignsList() {
      var extracampaignsList = [];
      for (var i = 0; i < this.extracampaigns.length; i++) {
        var array = this.extracampaigns[i].split("|");
        var obj = { name: array[0], datalayer: array[1], title: array[2] };
        extracampaignsList.push(obj);
      }
      return extracampaignsList;
    }
  }),
  watch: {
    // use the watch to react on the value change.
    endcounter: function endcounter(newValue) {
      if (this.showcounter && this.$refs.counter) {
        this.startcounter = newValue;
        this.$refs.counter.start();
        console.log("endcounter:newValue", newValue);
      }
    }
  },
  props: {
    limit: {
      type: Number,
      default: 1000
    },
    isActive: {
      //:is-active="false"
      type: Boolean,
      required: true
    },
    title: {
      //thankyoutitle="Test title"
      type: String,
      required: true
    },
    intro: {
      //intro="Test intro"
      type: String,
      required: true
    },
    thankyoutitle: {
      //thankyoutitle="Test thankyou title"
      type: String,
      required: true
    },
    thankyoumessage: {
      //thankyoumessage="Test thankyou message"
      type: String,
      required: true
    },
    datalayername: {
      //datalayername="Test datalayer name"
      type: String,
      required: true
    },
    closingmessage: {
      //closingmessage="Test the compatition has closed."
      type: String,
      default: "This petition has now closed."
    },
    programname: {
      //petitionname="Test petition name"
      type: String,
      required: true
    },
    extracampaigns: {
      // program Name | datalyer | title
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    showcounter: {
      //showcounter="true"
      type: Boolean,
      default: true
    },
    showprogressbar: {
      type: Boolean,
      default: false
    },
    revdirection: {
      type: Boolean,
      default: false
    },
    countertitle: {
      //countertitle="Test message sent"
      type: String,
      default: "message sent"
    },
    messageplaceholder: {
      //countertitle="Test message placeholder"
      type: String,
      default: "Message"
    },
    lettertitle: {
      //lettertitle="Test letter title"
      type: String,
      required: true
    },
    lettermessage: {
      //lettermessage="Test letter message"
      type: String,
      required: false
    },
    lettermessages: {
      //lettermessage="Test letter message"
      type: Object,
      required: false
    },
    keepData: {
      type: Boolean,
      default: false
    },
    scheduledLead: {
      type: Boolean,
      default: false
    },
    showmessage: {
      //showcounter="true"
      type: Boolean,
      default: true
    },
    showcountry: {
      //showcounter="true"
      type: Boolean,
      default: false
    },
    extraMandatoryFields: {
      // Attribute for the productID
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    showstate: {
      //showstate="true"
      type: Boolean,
      default: false
    },
    useState: {
      type: Boolean,
      default: false
    },
    showpermission: {
      //showpermission="true"
      type: Boolean,
      default: false
    },
    hidepostcode: {
      //hidepostcode="true"
      type: Boolean,
      default: false
    },
    productIds: {
      // Attribute for the productID
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    thankYouUrl: {
      // Attribute for the productID
      type: String,
      required: false
    },
    automaticStateUpdate: {
      type: Boolean,
      default: false
    },
    seeMessageButtonBottom: {
      type: Boolean,
      default: false
    },
    stateDependentButtons: {
      type: Boolean,
      default: false
    },
    restrictedPostcode: {
      type: Boolean,
      default: false
    },
    showphonenumber: {
      type: Boolean,
      default: false
    },
    showrecipientslist: {
      type: Boolean,
      default: false
    },
    colorThemes: {
      type: String,
      default: null
    },
    donateURL: {
      type: String,
      default: 'https://donate.wwf.org.au/donate/one-off-donation/one-off-donation'
    }
  },
  data: function data() {
    return {
      utmSourceParam: '',
      percentage: 0,
      startcounter: 0,
      selectedCampaign: [],
      firstName: '',
      lastName: '',
      email: '',
      postCode: '',
      phoneNumber: '',
      country: 'Australia',
      message: '',
      isLoading: false,
      error: false,
      isProfanity: false,
      isFlip: false,
      isCollapse: false,
      isShake: false,
      newmintarget: this.mintarget,
      countriesList: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__helpers__["g" /* getCountriesList */])(),
      permission: '',
      state: '',
      selectedFixedMessage: null,
      letterContent: null,
      letterContents: null,
      queryCampaign: '',
      manatoryFields: [],
      recipients: null,
      selectedMP: null,
      selectedSenator: null,
      timeout: null,
      isSaving: false,
      isFromRokt: false,
      origin: null,
      lastEpbcApiTimestamp: Date.now(),
      emailCheckSensis: {
        timeout: null,
        lastTimestamp: Date.now(),
        checkEmailLoading: false,
        emailRegex: /.+\@.+\..+/
      },
      isThankYou: false,

      formTouched: false
    };
  },
  methods: {
    updateMessage: function updateMessage() {
      if (this.letterContents && this.state) {
        this.selectedFixedMessage = this.letterContents[this.state];
      }
    },
    postcodeUpdated: function postcodeUpdated() {
      this.updateState();
      if (this.postCode && this.postCode.toString().length >= 3) {
        this.updateRecipients();
      }
    },
    updateRecipients: function updateRecipients() {
      var _this3 = this;

      if (this.showrecipientslist) {

        var timestamp = Date.now(); // timestamp for this api call
        this.lastEpbcApiTimestamp = timestamp; // 1 , 2 , 3

        this.$store.dispatch("getEPBCRecipients", { postcode: this.postCode }).then(function (result) {

          if (result && timestamp >= _this3.lastEpbcApiTimestamp) {
            _this3.recipients = result;
            if (_this3.recipients.mps) {
              _this3.selectedMP = _this3.recipients.mps[0];
            }
            if (_this3.recipients.senators && _this3.recipients.senators.length > 0) {
              _this3.selectedSenator = _this3.recipients.senators[0];
            }
          }
        });
      }
    },
    updateState: function updateState() {
      if (this.automaticStateUpdate && this.postCode && this.postCode.toString().length >= 3) {
        var state = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__helpers__["k" /* getAustralianStateByPostcode */])(this.postCode);
        if (state && this.state != "Outside Australia") {
          this.state = state;
          this.updateMessage();
          this.errors.remove('postCode');
        }
      } else if (this.automaticStateUpdate) {
        // if this.automaticStateUpdate is true but the postcode is not valid, reset the state
        this.state = '';
      }
    },
    onEmailInput: function onEmailInput() {
      var _this4 = this;

      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }

      // Only call if not input for 500 ms
      this.timeout = setTimeout(function () {
        _this4.checkEmailDuplicate().then(function (result) {
          if (!result.valid) {
            _this4.errors.add({
              field: "email",
              msg: "Your email has already been submitted"
            });
          }
        }).catch(function (err) {
          // If it fails, let the user free to continue
          console.log(err);
        });
      }, 500);
    },
    checkEmailDuplicate: function checkEmailDuplicate() {
      var _this5 = this;

      return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this5.$store.dispatch("checkEmail", {
          campaignId: _this5.datalayername,
          email: _this5.email
        }).then(function (result) {
          if (result) {
            resolve({
              valid: false,
              field: 'email',
              data: { message: "Your email has already been submitted" }
            });
          } else {
            resolve({ valid: true });
          }
        });
      });
    },
    checkEmail: function checkEmail() {
      var _this6 = this;

      return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var timestamp = Date.now(); // timestamp for this api call
        _this6.emailCheckSensis.lastTimestamp = timestamp; // 1 , 2 , 3
        _this6.emailCheckSensis.checkEmailLoading = true;
        // Fetch Suggestions
        _this6.$store.dispatch("validateEmail", _this6.email).then(function (response) {
          if (response && timestamp >= _this6.emailCheckSensis.lastTimestamp) {
            _this6.emailCheckSensis.checkEmailLoading = false;
            resolve(response);
          }
        }).catch(function (err) {
          console.error(err);
          _this6.emailCheckSensis.checkEmailLoading = false;
          // If it fails, let the user free to continue
          resolve({ valid: true });
        });
      });
    },
    updatePercentage: function updatePercentage(e, t) {
      this.percentage = e * 100 / this.limit;
    },
    openReadLetterPage: function openReadLetterPage() {
      if (this.stateDependentButtons && (!this.state || this.state.length === 0)) {
        this.errors.add({
          field: 'postCode',
          msg: "Please enter a valid Postcode between 0000 and 9999"
        });
        return;
      } else {
        this.errors.remove('postCode');
      }

      if (!this.selectedFixedMessage) {
        if (this.letterContents) {
          if (this.state) {
            this.selectedFixedMessage = this.letterContents[this.state];
          } else {
            var keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.letterContents);
            this.selectedFixedMessage = this.letterContents[keys[0]];
          }
        }
      }

      this.$store.commit("setPopupContent", {
        title: this.lettertitle,
        message: this.selectedFixedMessage,
        shareButton: false,
        recommendedReading: false,
        component: null,
        componentparams: null
      });
      this.$store.commit("openPetitionMessagePopup", true);
    },
    save: function save() {
      var _postBody,
          _this7 = this;

      // Exit the function if it's busy
      if (this.isSaving) {
        return;
      }
      this.isSaving = true;

      if ((this.showstate || this.useState) && (!this.state || this.state.length === 0)) {
        this.updateState();
        if (!this.state || this.state.length === 0) {
          this.errors.add({
            field: "postCode",
            msg: "Please enter a valid Postcode between 0000 and 9999"
          });
          this.isSaving = false;
          return;
        }
      } else {
        this.errors.remove("postCode");
      }

      var epbc = null;
      if (this.recipients) {
        epbc = {
          mp: this.selectedMP,
          senator: this.selectedSenator,
          mainMP: this.recipients.mainMP
        };
      }

      var postBody = (_postBody = {
        email: this.email,
        firstName: this.firstName,
        lastName: this.lastName,
        postcode: !this.hidepostcode ? this.postCode : null,
        programName: this.programname,
        message: this.message ? this.message : "",
        cookieID: this.$cookie.get("_mkto_trk"),
        keepData: this.keepData,
        scheduledLead: this.scheduledLead,
        country: this.showcountry ? this.country : this.showstate ? this.state == "Outside Australia" ? this.state : "Australia" : null,
        permission: this.showpermission ? this.permission : null,
        state: this.showstate || this.useState ? this.state == "Outside Australia" ? "" : this.state : null
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_postBody, "country", this.state == "Outside Australia" ? this.state : "Australia"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_postBody, "phone", this.phoneNumber), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_postBody, "isPhoneNumberMandatory", true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_postBody, "isFromRokt", this.isFromRokt), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_postBody, "utmSource", this.utmSourceParam), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_postBody, "epbc", epbc), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_postBody, "origin", this.origin), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_postBody, "ssoId", this.$store.getters.ssoId), _postBody);

      if (browser) {
        postBody.browsername = browser.name;
        postBody.browserversion = browser.version;
        postBody.browseros = browser.os;
      }

      console.log(postBody);

      this.$validator.validate().then(function (result) {
        if (result) {
          if (_this7.showmessage) {
            _this7.$http.jsonp("https://api1.webpurify.com/services/rest/?api_key=b7c6af7e5259ce74f099897deb9dcf29&method=webpurify.live.check&text=" + encodeURIComponent(postBody.message) + "&format=json").then(function (response) {
              if (response.data) {
                _this7.isProfanity = response.data.rsp.found != "0";
                if (!_this7.isProfanity) {
                  console.log("Message clean");
                  _this7.saveLead(postBody);

                  // Log step to Amplitude
                  _this7.$store.dispatch("logPetitionSupporter", {
                    id: postBody.programName,
                    postcode: postBody.postcode
                  });
                } else {
                  console.log("Message not clean");
                  _this7.isSaving = false;
                }
              } else {
                _this7.isSaving = false;
              }
            });
          } else {
            _this7.saveLead(postBody);

            // Log step to Amplitude
            _this7.$store.dispatch("logPetitionSupporter", {
              id: postBody.programName,
              postcode: postBody.postcode
            });
          }
        } else {
          console.log("form invalid");
          // GTM Tracking
          if (window.dataLayer != undefined) {
            window.dataLayer.push({
              formName: _this7.datalayername,
              event: "formSubmitEvent"
            });
          }
          _this7.isSaving = false;
          _this7.isShake = true;
          setTimeout(function () {
            this.isShake = false;
          }.bind(_this7), 500);
        }
      });
    },
    saveLead: function saveLead(postBody) {
      var _this8 = this;

      this.$store.dispatch("saveLead", {
        campaignId: this.datalayername,
        lead: postBody
      }).then(function (response) {
        console.log("petition submit success");

        if (window.dataLayer != undefined) {
          window.dataLayer.push({
            formName: _this8.datalayername,
            event: "formSubmitSuccessEvent"
          });
        }

        _this8.selectedCampaign.forEach(function (element) {
          postBody.programName = element.name;

          _this8.$store.dispatch("saveLead", {
            campaignId: element.datalayer,
            lead: postBody
          }).then(function (response) {
            console.log("petition submit success");

            if (window.dataLayer != undefined) {
              window.dataLayer.push({
                formName: element.datalayer,
                event: "formSubmitSuccessEvent"
              });
            }
          }, function (error) {
            console.error("Petition submit failed");
          }).catch(function (err) {
            console.error("Petition submit failed");
            _this8.isSaving = false;
          });
        });

        // Log registration to Amplitude
        _this8.$store.dispatch("logPetitionComplete", {
          id: _this8.programname,
          count: _this8.endcounter
        });

        //Reset form
        _this8.firstName = "";
        _this8.lastName = "";
        _this8.email = "";
        _this8.postCode = "";
        _this8.message = "";
        _this8.country = "Australia";
        _this8.checked = false;
        _this8.state = "";
        _this8.permission = "";
        _this8.phoneNumber = "";
        _this8.recipients = null;
        _this8.selectedMP = null;
        _this8.selectedSenator = null;
        _this8.isSaving = false;
      }, function (error) {
        console.error("Petition submit failed");
        _this8.isSaving = false;
      }).catch(function (err) {
        console.error("Petition submit failed");
        _this8.isSaving = false;
      });

      console.log("openthankyoupopup", this.productIds);

      if (this.thankYouUrl) {
        var params = '?q=' + window.btoa("email=" + this.email + "&firstname=" + this.firstName + "&lastname=" + this.lastName + "&source=" + document.URL);
        this.thankYouUrl += params;
        window.open(this.thankYouUrl, "_self");
      } else {
        this.$store.commit("setPopupContent", {
          title: this.thankyoutitle,
          message: this.thankyoumessage,
          shareButton: true,
          recommendedReading: false
          // component: "donate-rg-form",
          // componentparams: {
          //   productIds: this.productIds,
          //   emailprefill: postBody.email,
          //   currentpage: true,
          //   dollarhandleclick: false,
          // }
        });
        this.$store.commit("openPetitionPopup", true);
      }
    },
    donateNow: function donateNow() {
      window.open(this.donateURL, "_self");
    },
    logFirstTouch: function logFirstTouch(fieldName) {
      if (!this.formTouched) {
        this.$store.dispatch("logPetitionBegin", {
          id: this.programname,
          fieldName: fieldName,
          count: this.endcounter
        });
        this.formTouched = true;
      }
    }
  }
});

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vee_validate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_count_to__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_count_to___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_count_to__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Progressbar_vue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Progressbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Progressbar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers__ = __webpack_require__(7);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var _require = __webpack_require__(22),
    detect = _require.detect;

var browser = detect();


/* harmony default export */ __webpack_exports__["default"] = ({
  components: { countTo: __WEBPACK_IMPORTED_MODULE_7_vue_count_to___default.a, progressbar: __WEBPACK_IMPORTED_MODULE_8__Progressbar_vue___default.a },
  name: "my-petitionForm",
  created: function created() {
    var _this = this;

    // Define some mandatory fields with the query params
    var uri = window.location.search.substring(1);
    if (uri.length > 0) {
      var params = new URLSearchParams(uri);

      // TYPE
      var typeParam = params.get("type");
      this.queryCampaign = typeParam ? typeParam : '';

      if (this.queryCampaign.includes('epbc')) {
        this.manatoryFields.push('phoneNumber');
      }

      // utm_source
      this.utmSourceParam = params.get("utm_source");
      this.isFromRokt = this.utmSourceParam && this.utmSourceParam.includes('rokt') ? true : false;
    }

    if (this.showcounter || this.showprogressbar) {
      this.$store.dispatch("getCounterByCampaignId", this.datalayername);
    }

    // Check the email
    var petitionEmailIsValid = function petitionEmailIsValid(email) {
      return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a.all([_this.checkEmailDuplicate(), _this.checkEmail()]).then(function (results) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(results), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var r = _step.value;

              if (!r.valid) {
                return resolve(r);
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          _this.errors.remove("email");
          resolve({ valid: true });
        }).catch(function (err) {
          console.error(err);
          _this.errors.remove("email");
          resolve({ valid: true });
        });
      });
    };

    __WEBPACK_IMPORTED_MODULE_6_vee_validate__["b" /* Validator */].extend("petitionEmailIsValid", {
      validate: petitionEmailIsValid,
      getMessage: function getMessage(field, params, data) {
        return data.message;
      }
    });

    // Check the postcode
    var petitionPostCodeIsValid = function petitionPostCodeIsValid(postCode) {
      if (_this.restrictedPostcode && (!_this.state || _this.state.length === 0)) {
        return {
          valid: false,
          data: { message: "Please enter a postcode between 0000 and 9999" }
        };
      } else {
        return {
          valid: true
        };
      }
    };

    __WEBPACK_IMPORTED_MODULE_6_vee_validate__["b" /* Validator */].extend("petitionPostCodeIsValid", {
      validate: petitionPostCodeIsValid,
      getMessage: function getMessage(field, params, data) {
        return data.message;
      }
    });

    // Check Phone Number
    var petitionPhoneNumberIsValid = function petitionPhoneNumberIsValid(phoneNumber) {
      var validationRegex = /^(\+?61|0)([0-9]{8,9})/;
      if (!phoneNumber.replace(/ /g, '').match(validationRegex)) {
        return {
          valid: false,
          data: { message: "Invalid phone number" }
        };
      } else {
        return {
          valid: true
        };
      }
    };

    __WEBPACK_IMPORTED_MODULE_6_vee_validate__["b" /* Validator */].extend("petitionPhoneNumberIsValid", {
      validate: petitionPhoneNumberIsValid,
      getMessage: function getMessage(field, params, data) {
        return data.message;
      }
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.showcounter) {
      this.$refs.counter.start();
    }

    // Fetch the content of the messages
    if (this.lettermessage) {
      this.$store.dispatch('getContentMessageById', this.lettermessage).then(function (value) {
        if (value) {
          _this2.letterContent = _this2.formatMessageContent(value.content);
        } else {
          _this2.letterContent = '';
        }
        _this2.selectedFixedMessage = _this2.letterContent;
      });
    }

    if (this.lettermessages) {
      var values = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(this.lettermessages);

      this.$store.dispatch("getContentMessageById", values.join(',')).then(function (response) {
        response = response.filter(function (e) {
          return e;
        });
        _this2.letterContents = {};

        var _loop = function _loop(s) {
          var contentId = _this2.lettermessages[s];
          var content = response.find(function (e) {
            return e.id === contentId;
          });

          // Display empty if the content do not exist
          if (content) {
            _this2.letterContents[s] = _this2.formatMessageContent(content.content);
          } else {
            _this2.letterContents[s] = '';
          }
        };

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this2.lettermessages)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var s = _step2.value;

            _loop(s);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapState */])({
    user: function user(state) {
      return state.auth.user;
    }
  }), {
    endcounter: function endcounter() {
      return this.$store.getters.counter ? this.$store.getters.counter : 0;
    },
    getextracampaignsList: function getextracampaignsList() {
      var extracampaignsList = [];
      for (var i = 0; i < this.extracampaigns.length; i++) {
        var array = this.extracampaigns[i].split("|");
        var obj = { name: array[0], datalayer: array[1], title: array[2] };
        extracampaignsList.push(obj);
      }
      return extracampaignsList;
    }
  }),
  watch: {
    // use the watch to react on the value change.
    endcounter: function endcounter(newValue) {
      if (this.showcounter) {
        this.startcounter = newValue;
        this.$refs.counter.start();
        console.log("endcounter:newValue", newValue);
      }
    }
  },
  props: {
    limit: {
      type: Number,
      default: 1000
    },
    isActive: {
      //:is-active="false"
      type: Boolean,
      required: true
    },
    title: {
      //thankyoutitle="Test title"
      type: String,
      required: true
    },
    intro: {
      //intro="Test intro"
      type: String,
      required: true
    },
    thankyoutitle: {
      //thankyoutitle="Test thankyou title"
      type: String,
      required: true
    },
    thankyoumessage: {
      //thankyoumessage="Test thankyou message"
      type: String,
      required: true
    },
    datalayername: {
      //datalayername="Test datalayer name"
      type: String,
      required: true
    },
    closingmessage: {
      //closingmessage="Test the compatition has closed."
      type: String,
      default: "This petition has now closed."
    },
    programname: {
      //petitionname="Test petition name"
      type: String,
      required: true
    },
    extracampaigns: {
      // program Name | datalyer | title
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    showcounter: {
      //showcounter="true"
      type: Boolean,
      default: true
    },
    showprogressbar: {
      type: Boolean,
      default: false
    },
    revdirection: {
      type: Boolean,
      default: false
    },
    countertitle: {
      //countertitle="Test message sent"
      type: String,
      default: "message sent"
    },
    messageplaceholder: {
      //countertitle="Test message placeholder"
      type: String,
      default: "Message"
    },
    lettertitle: {
      //lettertitle="Test letter title"
      type: String,
      required: true
    },
    lettermessage: {
      //lettermessage="Test letter message"
      type: String,
      required: false
    },
    lettermessages: {
      //lettermessage="Test letter message"
      type: Object,
      required: false
    },
    keepData: {
      type: Boolean,
      default: false
    },
    scheduledLead: {
      type: Boolean,
      default: false
    },
    showmessage: {
      //showcounter="true"
      type: Boolean,
      default: true
    },
    showcountry: {
      //showcounter="true"
      type: Boolean,
      default: false
    },
    extraMandatoryFields: {
      // Attribute for the productID
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    showstate: {
      //showstate="true"
      type: Boolean,
      default: false
    },
    useState: {
      type: Boolean,
      default: false
    },
    showpermission: {
      //showpermission="true"
      type: Boolean,
      default: false
    },
    hidepostcode: {
      //hidepostcode="true"
      type: Boolean,
      default: false
    },
    productIds: {
      // Attribute for the productID
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    thankYouUrl: {
      // Attribute for the productID
      type: String,
      required: false
    },
    automaticStateUpdate: {
      type: Boolean,
      default: false
    },
    seeMessageButtonBottom: {
      type: Boolean,
      default: false
    },
    stateDependentButtons: {
      type: Boolean,
      default: false
    },
    restrictedPostcode: {
      type: Boolean,
      default: false
    },
    showphonenumber: {
      type: Boolean,
      default: false
    },
    showrecipientslist: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      utmSourceParam: '',
      percentage: 0,
      startcounter: 0,
      selectedCampaign: [],
      firstName: '',
      lastName: '',
      email: '',
      postCode: '',
      phoneNumber: '',
      country: 'Australia',
      message: '',
      isLoading: false,
      error: false,
      isProfanity: false,
      isFlip: false,
      isCollapse: false,
      isShake: false,
      newmintarget: this.mintarget,
      countriesList: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__helpers__["g" /* getCountriesList */])(),
      permission: '',
      state: '',
      selectedFixedMessage: null,
      letterContent: null,
      letterContents: null,
      queryCampaign: '',
      manatoryFields: [],
      recipients: null,
      selectedMP: null,
      selectedSenator: null,
      timeout: null,
      isSaving: false,
      isFromRokt: false,
      lastEpbcApiTimestamp: Date.now(),
      emailCheckSensis: {
        timeout: null,
        lastTimestamp: Date.now(),
        checkEmailLoading: false,
        emailRegex: /.+\@.+\..+/
      },

      formTouched: false
    };
  },
  methods: {
    formatMessageContent: function formatMessageContent(content) {
      return "<style> .letter-content { text-align:left; border: 4px double #c1c1c1; padding: 25px; } .letter-content p { margin: 1em; text-align: left !important; } </style> <div class=\"letter-content\">" + content + "</div>";
    },

    updateMessage: function updateMessage() {
      if (this.letterContents && this.state) {
        this.selectedFixedMessage = this.letterContents[this.state];
      }
    },
    postcodeUpdated: function postcodeUpdated() {
      this.updateState();
      if (this.postCode && this.postCode.toString().length >= 3) {
        this.updateRecipients();
      }
    },
    updateRecipients: function updateRecipients() {
      var _this3 = this;

      if (this.showrecipientslist) {

        var timestamp = Date.now(); // timestamp for this api call
        this.lastEpbcApiTimestamp = timestamp; // 1 , 2 , 3

        this.$store.dispatch("getEPBCRecipients", { postcode: this.postCode }).then(function (result) {

          if (result && timestamp >= _this3.lastEpbcApiTimestamp) {
            _this3.recipients = result;
            if (_this3.recipients.mps) {
              _this3.selectedMP = _this3.recipients.mps[0];
            }
            if (_this3.recipients.senators && _this3.recipients.senators.length > 0) {
              _this3.selectedSenator = _this3.recipients.senators[0];
            }
          }
        });
      }
    },
    updateState: function updateState() {
      if (this.automaticStateUpdate && this.postCode && this.postCode.toString().length >= 3) {
        var state = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__helpers__["k" /* getAustralianStateByPostcode */])(this.postCode);
        if (state && this.state != "Outside Australia") {
          this.state = state;
          this.updateMessage();
          this.errors.remove('postCode');
        }
      } else if (this.automaticStateUpdate) {
        // if this.automaticStateUpdate is true but the postcode is not valid, reset the state
        this.state = '';
      }
    },
    onEmailInput: function onEmailInput() {
      var _this4 = this;

      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }

      // Only call if not input for 500 ms
      this.timeout = setTimeout(function () {
        _this4.checkEmailDuplicate().then(function (result) {
          if (!result.valid) {
            _this4.errors.add({
              field: "email",
              msg: "Your email has already been submitted"
            });
          }
        }).catch(function (err) {
          // If it fails, let the user free to continue
          console.log(err);
        });
      }, 500);
    },
    checkEmailDuplicate: function checkEmailDuplicate() {
      var _this5 = this;

      return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this5.$store.dispatch("checkEmail", {
          campaignId: _this5.datalayername,
          email: _this5.email
        }).then(function (result) {
          if (result) {
            resolve({
              valid: false,
              field: 'email',
              data: { message: "Your email has already been submitted" }
            });
          } else {
            resolve({ valid: true });
          }
        });
      });
    },
    checkEmail: function checkEmail() {
      var _this6 = this;

      return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var timestamp = Date.now(); // timestamp for this api call
        _this6.emailCheckSensis.lastTimestamp = timestamp; // 1 , 2 , 3
        _this6.emailCheckSensis.checkEmailLoading = true;
        // Fetch Suggestions
        _this6.$store.dispatch("validateEmail", _this6.email).then(function (response) {
          if (response && timestamp >= _this6.emailCheckSensis.lastTimestamp) {
            _this6.emailCheckSensis.checkEmailLoading = false;
            resolve(response);
          }
        }).catch(function (err) {
          console.error(err);
          _this6.emailCheckSensis.checkEmailLoading = false;
          // If it fails, let the user free to continue
          resolve({ valid: true });
        });
      });
    },
    updatePercentage: function updatePercentage(e, t) {
      this.percentage = e * 100 / this.limit;
    },
    openReadLetterPage: function openReadLetterPage() {
      if (this.stateDependentButtons && (!this.state || this.state.length === 0)) {
        this.errors.add({
          field: 'postCode',
          msg: "Please enter a valid Postcode between 0000 and 9999"
        });
        return;
      } else {
        this.errors.remove('postCode');
      }

      if (!this.selectedFixedMessage) {
        if (this.letterContents) {
          if (this.state) {
            this.selectedFixedMessage = this.letterContents[this.state];
          } else {
            var keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.letterContents);
            this.selectedFixedMessage = this.letterContents[keys[0]];
          }
        }
      }

      this.$store.commit("setPopupContent", {
        title: this.lettertitle,
        message: this.selectedFixedMessage,
        shareButton: false,
        recommendedReading: false,
        component: null,
        componentparams: null
      });
      this.$store.commit("openPetitionPopup", true);
    },
    save: function save() {
      var _postBody,
          _this7 = this;

      // Exit the function if it's busy
      if (this.isSaving) {
        return;
      }
      this.isSaving = true;

      if ((this.showstate || this.useState) && (!this.state || this.state.length === 0)) {
        this.updateState();
        if (!this.state || this.state.length === 0) {
          this.errors.add({
            field: "postCode",
            msg: "Please enter a valid Postcode between 0000 and 9999"
          });
          this.isSaving = false;
          return;
        }
      } else {
        this.errors.remove("postCode");
      }

      var epbc = null;
      if (this.recipients) {
        epbc = {
          mp: this.selectedMP,
          senator: this.selectedSenator,
          mainMP: this.recipients.mainMP
        };
      }

      var postBody = (_postBody = {
        email: this.email,
        firstName: this.firstName,
        lastName: this.lastName,
        postcode: !this.hidepostcode ? this.postCode : null,
        programName: this.programname,
        message: this.message ? this.message : "",
        cookieID: this.$cookie.get("_mkto_trk"),
        keepData: this.keepData,
        scheduledLead: this.scheduledLead,
        country: this.showcountry ? this.country : this.showstate ? this.state == "Outside Australia" ? this.state : "Australia" : null,
        permission: this.showpermission ? this.permission : null,
        state: this.showstate || this.useState ? this.state == "Outside Australia" ? "" : this.state : null
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_postBody, "country", this.state == "Outside Australia" ? this.state : "Australia"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_postBody, "phone", this.phoneNumber), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_postBody, "isPhoneNumberMandatory", this.extraMandatoryFields && this.extraMandatoryFields.indexOf("phoneNumber") > -1 || this.manatoryFields && this.manatoryFields.indexOf("phoneNumber") > -1), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_postBody, "isFromRokt", this.isFromRokt), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_postBody, "utmSource", this.utmSourceParam), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_postBody, "epbc", epbc), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_postBody, "ssoId", this.$store.getters.ssoId), _postBody);

      if (browser) {
        postBody.browsername = browser.name;
        postBody.browserversion = browser.version;
        postBody.browseros = browser.os;
      }

      console.log(postBody);

      this.$validator.validate().then(function (result) {
        if (result) {
          if (_this7.showmessage) {
            _this7.$http.jsonp("https://api1.webpurify.com/services/rest/?api_key=b7c6af7e5259ce74f099897deb9dcf29&method=webpurify.live.check&text=" + encodeURIComponent(postBody.message) + "&format=json").then(function (response) {
              if (response.data) {
                _this7.isProfanity = response.data.rsp.found != "0";
                if (!_this7.isProfanity) {
                  console.log("Message clean");
                  _this7.saveLead(postBody);

                  // Log step to Amplitude
                  _this7.$store.dispatch("logPetitionSupporter", {
                    id: postBody.programName,
                    postcode: postBody.postcode
                  });
                } else {
                  console.log("Message not clean");
                  _this7.isSaving = false;
                }
              } else {
                _this7.isSaving = false;
              }
            });
          } else {
            _this7.saveLead(postBody);

            // Log step to Amplitude
            _this7.$store.dispatch("logPetitionSupporter", {
              id: postBody.programName,
              postcode: postBody.postcode
            });
          }
        } else {
          console.log("form invalid");
          // GTM Tracking
          if (window.dataLayer != undefined) {
            window.dataLayer.push({
              formName: _this7.datalayername,
              event: "formSubmitEvent"
            });
          }
          _this7.isSaving = false;
          _this7.isShake = true;
          setTimeout(function () {
            this.isShake = false;
          }.bind(_this7), 500);
        }
      });
    },
    saveLead: function saveLead(postBody) {
      var _this8 = this;

      this.$store.dispatch("saveLead", {
        campaignId: this.datalayername,
        lead: postBody
      }).then(function (response) {
        console.log("petition submit success");

        if (window.dataLayer != undefined) {
          window.dataLayer.push({
            formName: _this8.datalayername,
            event: "formSubmitSuccessEvent"
          });
        }

        _this8.selectedCampaign.forEach(function (element) {
          postBody.programName = element.name;

          _this8.$store.dispatch("saveLead", {
            campaignId: element.datalayer,
            lead: postBody
          }).then(function (response) {
            console.log("petition submit success");

            if (window.dataLayer != undefined) {
              window.dataLayer.push({
                formName: element.datalayer,
                event: "formSubmitSuccessEvent"
              });
            }
          }, function (error) {
            console.error("Petition submit failed");
          }).catch(function (err) {
            console.error("Petition submit failed");
            _this8.isSaving = false;
          });
        });

        // Log registration to Amplitude
        _this8.$store.dispatch("logPetitionComplete", {
          id: _this8.programname,
          count: _this8.endcounter
        });

        //Reset form
        _this8.firstName = "";
        _this8.lastName = "";
        _this8.email = "";
        _this8.postCode = "";
        _this8.message = "";
        _this8.country = "Australia";
        _this8.checked = false;
        _this8.state = "";
        _this8.permission = "";
        _this8.phoneNumber = "";
        _this8.recipients = null;
        _this8.selectedMP = null;
        _this8.selectedSenator = null;
        _this8.isSaving = false;
      }, function (error) {
        console.error("Petition submit failed");
        _this8.isSaving = false;
      }).catch(function (err) {
        console.error("Petition submit failed");
        _this8.isSaving = false;
      });

      console.log("openthankyoupopup", this.productIds);

      if (this.thankYouUrl) {
        window.open(this.thankYouUrl, "_self");
      } else {
        this.$store.commit("setPopupContent", {
          title: this.thankyoutitle,
          message: this.thankyoumessage,
          shareButton: true,
          recommendedReading: false,
          component: "donate-rg-form",
          componentparams: {
            productIds: this.productIds,
            emailprefill: postBody.email,
            currentpage: true,
            dollarhandleclick: false
          }
        });
        this.$store.commit("openPetitionPopup", true);
      }
    },
    logFirstTouch: function logFirstTouch(fieldName) {
      if (!this.formTouched) {
        this.$store.dispatch("logPetitionBegin", {
          id: this.programname,
          fieldName: fieldName,
          count: this.endcounter
        });
        this.formTouched = true;
      }
    }
  }
});

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        percentage: Number,
        revdirection: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        percent: function percent() {
            return this.percentage.toFixed();
        }
    }
});

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SensisAutocomplete",

  props: {
    classname: String,
    id: String,
    showNotFound: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ""
    }
  },

  data: function data() {
    return {
      inputText: "",
      suggestions: [],
      cursor: 1,
      displaySuggestions: false,
      isLoading: false,
      timeout: null,
      delay: 600, // ms
      minInputLength: 4,
      lastTimestamp: Date.now(),
      fetchingDetails: false,
      isClean: false,
      hasError: false
    };
  },


  methods: {
    clickInside: function clickInside() {
      if (this.inputText && this.inputText.length >= this.minInputLength) {
        this.displaySuggestions = true;
      }
    },
    checkAddress: function checkAddress() {
      var _this = this;

      // Reset flags
      this.isClean = false;
      this.hasError = false;

      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }

      // In any case, if the input changed, the suggestions will change
      this.suggestions = [];

      if (this.inputText && this.inputText.length >= this.minInputLength) {
        this.isLoading = true;
        var timestamp = Date.now(); // timestamp for this api call
        this.lastTimestamp = timestamp; // 1 , 2 , 3
        this.timeout = setTimeout(function () {
          _this.displaySuggestions = true;
          var input = _this.inputText;

          // Fetch Suggestions
          _this.$store.dispatch("parseAddress", input).then(function (response) {
            if (response && timestamp >= _this.lastTimestamp) {
              if (response.status === "OK") {
                _this.suggestions = response.results;
              }

              // If we show the not found, add the options even if the result is not correct
              if (_this.showNotFound) {
                _this.suggestions.push({
                  index: _this.suggestions.length + 1,
                  formatted_address: "I can't find my address",
                  addressNotFound: true
                });
              }
              _this.isLoading = false;
            }
          }).catch(function (err) {
            _this.isLoading = false;
            console.error(err);
          });
        }, this.delay);
      } else {
        this.displaySuggestions = false;
        this.isLoading = false;
      }
    },
    selectAddress: function selectAddress(item) {
      var _this2 = this;

      this.inputText = item.formatted_address;
      this.displaySuggestions = false;
      this.isLoading = false;
      this.suggestions = [];
      this.fetchingDetails = true;

      if (item.addressNotFound) {
        this.fetchingDetails = false;
        this.isLoading = false;
        this.$emit("addressSelected", null, null, true);
        return;
      }

      this.$store.dispatch("getAddressDetails", item.search_result_id).then(function (response) {
        if (response.result) {
          // Format with First letter in uppercase to match our format
          var country = response.result.country.charAt(0) + response.result.country.slice(1).toLowerCase();

          var selectedAddress = {
            unitnumber: response.result.subpremise,
            streetno: response.result.street_number,
            streetname: response.result.street_name + " " + response.result.street_type,
            postcode: response.result.postcode,
            state: response.result.state,
            suburb: response.result.suburb,
            country: country
          };

          _this2.fetchingDetails = false;
          _this2.isClean = true;
          _this2.hasError = false;
          _this2.$emit("addressSelected", selectedAddress, item.formatted_address);
        }
      }).catch(function (err) {
        _this2.suggestions = [];
        _this2.isLoading = false;
        _this2.fetchingDetails = false;
        console.error(err);
      });
    },
    keyUp: function keyUp() {
      if (this.displaySuggestions) {
        event.preventDefault();
        if (this.cursor > 1) {
          this.cursor -= 1;
          this.scrollToIndex(this.cursor);
        } else if (this.cursor === 1) {
          this.cursor = this.suggestions.length;
          this.scrollToIndex(this.cursor);
        }
      }
    },
    keyDown: function keyDown() {
      if (this.displaySuggestions) {
        event.preventDefault();
        if (this.cursor < this.suggestions.length) {
          this.cursor += 1;
          this.scrollToIndex(this.cursor);
        } else if (this.cursor === this.suggestions.length) {
          this.cursor = 1;
          this.scrollToIndex(this.cursor);
        }
      }
    },
    keyEnter: function keyEnter() {
      if (this.displaySuggestions && this.suggestions[this.cursor - 1]) {
        this.selectAddress(this.suggestions[this.cursor - 1]);
        this.displaySuggestions = false;
      }
    },
    keyEscape: function keyEscape() {
      this.displaySuggestions = false;
    },
    scrollToIndex: function scrollToIndex(index) {
      var listElement = document.getElementById("sensis-suggestion-list");
      var itemElement = document.querySelector("#sensis-suggestion-list .suggestion-item");
      var itemHeight = itemElement.offsetHeight;
      var scrollTop = listElement.scrollTop;
      var viewport = scrollTop + listElement.offsetHeight;
      var scrollOffset = itemHeight * index - itemHeight;

      if (scrollOffset < scrollTop || scrollOffset + itemHeight > viewport) {
        listElement.scrollTo({
          top: scrollOffset,
          behavior: "smooth"
        });
      }
    },
    validate: function validate() {
      this.hasError = !this.isClean;
      return this.isClean;
    }
  }
});

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SocialMedia"
});

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "StepUp",

  props: {
    id: {
      type: String
    },
    // Content
    title: {
      type: String
    },
    content: {
      type: String
    },
    // Donation/Petition details
    details: {
      type: Object
    }
  },
  computed: {
    thankyouText: function thankyouText() {
      if (this.details && this.details.amount) {
        return this.details.firstname + " " + this.details.lastname + ", thank you for your " + this.details.type + " donation of $" + this.details.amount;
      }
      return "";
    }
  },

  mounted: function mounted() {
    // Attach amplitude event to hyperlink button in content
    var stepupButton = this.$refs.stepup.querySelector("a");
    try {
      $(stepupButton).click({ callback: this.handleClick }, function (e) {
        e.preventDefault();
        e.data.callback(this.href);
      });
    } catch (err) {
      console.error(err);
    }
  },


  methods: {
    handleClose: function handleClose() {
      this.$store.dispatch("logStepUpDeclined", this.id);
    },
    handleClick: function handleClick(link) {
      this.$store.dispatch("logStepUpActioned", { stepupId: this.id, link: link }).then(function () {
        return window.location.href = link;
      });
    }
  }
});

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "my-taxCalculator",
  props: {
    amount: {
      // Attribute for the productID
      type: String,
      required: false,
      default: null
    }
  },
  created: function created() {
    console.log("created", this.amount);
    if (this.amount) {
      this.isCalculator = false;
    }
  },
  data: function data() {
    return {
      //amount: null,
      income: "",
      saving: null,
      pay: null,
      getTaxBrackeList: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers__["h" /* getTaxBrackeList */])(),
      isShowResult: false,
      isCalculator: true
    };
  },

  methods: {
    calculate: function calculate() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (!result) {
          console.log("The form on step1 product is invalid");
          //reject("The form on step1 product is invalid");
        } else {
          _this.setShowResult(true);
        }
      });
    },
    setShowResult: function setShowResult(value) {
      this.isShowResult = value;
    },
    donate: function donate() {
      if (window.dataLayer != undefined) {
        window.dataLayer.push({ 'formName': 'taxcalculator', 'event': 'formSubmitSuccessEvent' });
      }

      window.open(wwfconfigs.DONATEURL + '/donate/one-off-donation/tax-2018' + '?q=' + window.btoa('dollarhandle=custom&amount=' + this.amount), "_blank");
    }
  }
});

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ThankYouDonation",
  data: function data() {
    return {
      firstName: null,
      lastName: null,
      frequency: null,
      amount: null
    };
  },
  created: function created() {
    var q = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* getParameterByName */])("q");
    if (q) {
      var decodeq = "?" + window.atob(q);
      console.log("decodeq", decodeq);
      this.firstName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* getParameterByName */])("firstname", decodeq);
      this.lastName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* getParameterByName */])("lastname", decodeq);
      this.frequency = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* getParameterByName */])("frequency", decodeq);
      this.amount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* getParameterByName */])("amount", decodeq);

      console.log("firstname", this.firstName);
    }
  }
});

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ThankYouMultiAction",
  data: function data() {
    return {
      firstName: null,
      lastName: null,
      frequency: null,
      amount: null,
      replacedText: ""
    };
  },
  props: {
    title: {
      type: String,
      default: "Thank You!"
    },
    text: {
      type: String,
      default: "{{firstName}} {{lastName}}, thank you for your {{frequency}} donation of ${{amount}}."
    },
    titleColor: {
      type: String
    },
    textColor: {
      type: String
    }
  },
  created: function created() {
    var q = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* getParameterByName */])("q");
    if (q) {
      var decodeq = "?" + window.atob(q);
      console.log("decodeq", decodeq);
      this.firstName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* getParameterByName */])("firstname", decodeq);
      this.lastName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* getParameterByName */])("lastname", decodeq);
      this.frequency = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* getParameterByName */])("frequency", decodeq);
      this.amount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* getParameterByName */])("amount", decodeq);

      this.frequency = this.frequency ? this.frequency.toLowerCase() : this.frequency;

      console.log("firstname", this.firstName);

      this.replacedText = this.text.replace(/{{firstName}}/gi, this.firstName ? this.firstName : "").replace(/{{lastName}}/gi, this.lastName ? this.lastName : "").replace(/{{frequency}}/gi, this.frequency ? this.frequency : "").replace(/{{amount}}/gi, this.amount ? this.amount : "");
    }
  }
});

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "my-twitchForm",
  props: {
    title: {
      //thankyoutitle="Test title"
      type: String,
      required: false
    },
    intro: {
      //intro="Test intro"
      type: String,
      required: false
    },
    isActive: {
      //:is-active="false"
      type: Boolean,
      required: true
    },
    thankyoutitle: {
      //thankyoutitle="Test title"
      type: String,
      required: true
    },
    thankyoumessage: {
      //thankyoumessage="Test message"
      type: String,
      required: true
    },
    datalayername: {
      //datalayername="Test datalayer name"
      type: String,
      required: true
    },
    closingmessage: {
      //closingmessage="Test the compatition has closed."
      type: String,
      default: "This competition has now closed."
    },
    programname: {
      //petitionname="Test petition name"
      type: String,
      required: true
    },
    keepData: {
      //:keep-data="false"
      type: Boolean,
      required: false
    }
  },
  data: function data() {
    return {
      isShake: false,
      firstName: "",
      lastName: "",
      twitchName: "",
      email: "",
      phone: "",
      postCode: "",
      isLoading: false
    };
  },

  methods: {
    save: function save() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          console.log("Twitch form valid", result);

          var date = new Date();

          var postBody = {
            email: _this.email,
            firstName: _this.firstName,
            lastName: _this.lastName,
            twitchName: _this.twitchName,
            postcode: _this.postCode,
            phone: _this.phone,
            programName: _this.programname,
            createdDate: date.toISOString(),
            cookieID: _this.$cookie.get("_mkto_trk"),
            keepData: _this.keepData
          };

          _this.$store.dispatch("saveLead", {
            campaignId: _this.datalayername,
            lead: postBody
          }).then(function (response) {
            console.log("Twitch success");

            if (window.dataLayer != undefined) {
              window.dataLayer.push({
                formName: _this.datalayername,
                event: "formSubmitSuccessEvent"
              });
            }

            //Reset form
            _this.firstName = "";
            _this.lastName = "";
            _this.email = "";
            _this.twitchName = "";
            _this.phone = "";
            _this.postCode = "";
          }, function (error) {
            console.error("Twitch error:", error);
          });

          _this.$store.commit("setPopupContent", {
            title: _this.thankyoutitle,
            message: _this.thankyoumessage,
            shareButton: true,
            recommendedReading: false,
            component: null,
            componentparams: null
          });
          _this.$store.commit("openPetitionPopup", true);
        } else {
          console.log("Twitch form invalid", result);
          // GTM Tracking
          if (window.dataLayer != undefined) {
            window.dataLayer.push({
              formName: _this.datalayername,
              event: "formSubmitEvent"
            });
          }
          _this.isShake = true;
          setTimeout(function () {
            this.isShake = false;
          }.bind(_this), 500);
        }
      });
    }
  }
});

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
        name: 'wwf-country-list',
        data: function data() {
                return {
                        countriesList: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers__["j" /* getCountriesListForMenu */])()
                };
        }
});

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WwfCountryList__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WwfCountryList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__WwfCountryList__);
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    components: { WwfCountryList: __WEBPACK_IMPORTED_MODULE_1__WwfCountryList___default.a },
    name: "wwf-menu-country-list-btn",

    methods: {
        countryListModel: function countryListModel() {
            var ComponentClass = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_1__WwfCountryList___default.a);
            var instance = new ComponentClass();
            instance.$mount();
            var vueContainer = document.getElementById('country');

            // if DOM is not there create it
            if (!vueContainer.children[1]) vueContainer.appendChild(instance.$el);
        }
    }
});

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_count_to__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_count_to___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_count_to__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var _require = __webpack_require__(22),
    detect = _require.detect;

var browser = detect();

/* harmony default export */ __webpack_exports__["default"] = ({
  components: { countTo: __WEBPACK_IMPORTED_MODULE_0_vue_count_to___default.a, Datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__["a" /* default */] },
  name: "wwfRichmondFcForm",
  created: function created() {
    if (this.showcounter) {
      this.$store.dispatch("getCounterByCampaignId", this.datalayername);
    }
  },
  mounted: function mounted() {
    if (this.showcounter) {
      console.log(this.$refs.counter);
      this.$refs.counter.start();
    }
  },
  computed: {
    endcounter: function endcounter() {
      return this.$store.getters.counter ? this.$store.getters.counter : 0;
    }
  },
  watch: {
    // use the watch to react on the value change.
    endcounter: function endcounter(newValue) {
      if (this.showcounter) {
        this.startcounter = newValue;
        this.$refs.counter.start();
        console.log("newValue", newValue);
      }
    }
  },
  props: {
    isActive: {
      //:is-active="false"
      type: Boolean,
      required: true
    },
    title: {
      //thankyoutitle="Test title"
      type: String,
      required: true
    },
    intro: {
      //intro="Test intro"
      type: String,
      required: true
    },
    thankyoutitle: {
      //thankyoutitle="Test thankyou title"
      type: String,
      required: true
    },
    thankyoumessage: {
      //thankyoumessage="Test thankyou message"
      type: String,
      required: true
    },
    datalayername: {
      //datalayername="Test datalayer name"
      type: String,
      required: true
    },
    closingmessage: {
      //closingmessage="Test the compatition has closed."
      type: String,
      default: "This petition has now closed."
    },
    programname: {
      //petitionname="Test petition name"
      type: String,
      required: true
    },
    showcounter: {
      //showcounter="true"
      type: Boolean,
      default: true
    },
    countertitle: {
      //countertitle="Test message sent"
      type: String,
      default: "message sent"
    },
    messageplaceholder: {
      //countertitle="Test message placeholder"
      type: String,
      default: "Message"
    }
  },
  data: function data() {
    return {
      startcounter: 0,
      firstName: "",
      lastName: "",
      childFirstName: "",
      childLastName: "",
      childDob: null,
      phone: "",
      email: "",
      postCode: "",
      message: "",
      isProfanity: false,
      isShake: false,
      disabledFn: {
        customPredictor: function customPredictor(date) {
          if (__WEBPACK_IMPORTED_MODULE_2_moment___default()().isBefore(date, "day")) {
            return true;
          }
        }
      }
    };
  },
  methods: {
    save: function save() {
      var _this = this;

      var postBody = {
        email: this.email,
        firstName: this.firstName,
        lastName: this.lastName,
        childFirstName: this.childFirstName,
        childLastName: this.childLastName,
        childDob: __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.childDob).format('YYYY-MM-DD'),
        phone: this.phone,
        postcode: this.postCode,
        programName: this.programname,
        childmessage: this.message ? this.message : "",
        cookieID: this.$cookie.get("_mkto_trk"),
        keepData: true
      };

      if (browser) {
        postBody.browsername = browser.name;
        postBody.browserversion = browser.version;
        postBody.browseros = browser.os;
      }

      console.log(postBody);

      this.$validator.validate().then(function (result) {
        if (result) {
          _this.$http.jsonp("https://api1.webpurify.com/services/rest/?api_key=b7c6af7e5259ce74f099897deb9dcf29&method=webpurify.live.check&text=" + encodeURIComponent(postBody.childmessage) + "&format=json").then(function (response) {
            if (response.data) {
              _this.isProfanity = response.data.rsp.found != "0";
              if (!_this.isProfanity) {
                console.log("Message clean");
                _this.saveLead(postBody);
              } else {
                console.log("Message not clean");
              }
            }
          });
        } else {
          console.log("form invalid");
          // GTM Tracking
          if (window.dataLayer != undefined) {
            window.dataLayer.push({
              formName: _this.datalayername,
              event: "formSubmitEvent"
            });
          }
          _this.isShake = true;
          setTimeout(function () {
            this.isShake = false;
          }.bind(_this), 500);
        }
      });
    },
    saveLead: function saveLead(postBody) {
      var _this2 = this;

      this.$store.dispatch("saveLead", {
        campaignId: this.datalayername,
        lead: postBody
      }).then(function (response) {
        console.log("petition submit success");

        if (window.dataLayer != undefined) {
          window.dataLayer.push({
            formName: _this2.datalayername,
            event: "formSubmitSuccessEvent"
          });
        }

        //Reset form
        _this2.firstName = "";
        _this2.lastName = "";
        _this2.childFirstName = "";
        _this2.childLastName = "";
        _this2.childDob = null;
        _this2.phone = "";
        _this2.email = "";
        _this2.postCode = "";
        _this2.message = "";
      }, function (error) {
        console.error("Petition submit failed");
      });
      this.$store.commit("setPopupContent", {
        title: this.thankyoutitle,
        message: this.thankyoumessage,
        shareButton: true,
        recommendedReading: false,
        component: null,
        componentparams: null
      });
      this.$store.commit("openPetitionPopup", true);
    }
  }
});

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'myyoutubeVideo',
  props: {
    videoid: {
      type: String,
      required: true
    }
  },
  mounted: function mounted() {
    var _this = this;

    var el = $('#modal-ytvideo');
    this.reveal = new Foundation.Reveal(el, {
      // These options can be declarative using the data attributes
      animationIn: 'fade-in-up fast'
    });
    el.on('closed.zf.reveal', function () {
      _this.player.stopVideo();
    });
  },
  data: function data() {
    return {
      title: '',
      description: '',
      img: '',
      videoId: '',
      embededUrl: ''
    };
  },

  created: function created() {
    var _this2 = this;

    var urlApi;

    if (this.videoid) {
      urlApi = 'https://www.googleapis.com/youtube/v3/videos?part=snippet&key=AIzaSyDXIMBUGd3h8aWTMguq31XuklzNZWmS7OA&id=' + this.videoid;
    } else {
      urlApi = 'https://www.googleapis.com/youtube/v3/search?part=snippet&channelId=UC8O8LUiVMLWwTSyyiYlLD0g&maxResults=1&order=date&type=video&key=AIzaSyDXIMBUGd3h8aWTMguq31XuklzNZWmS7OA';
    }

    this.$http.get(urlApi).then(function (response) {
      _this2.videoId = response.body.items[0].id.videoId ? response.body.items[0].id.videoId : response.body.items[0].id;
      _this2.title = response.body.items[0].snippet.title;
      _this2.description = response.body.items[0].snippet.description;
      _this2.embededUrl = 'http://www.youtube.com/embed/' + _this2.videoId;
      _this2.img = response.body.items[0].snippet.thumbnails.high.url;
    });
  },
  methods: {
    ready: function ready(player) {
      this.player = player;
    },
    ended: function ended() {
      if (window.dataLayer != undefined) {
        window.dataLayer.push({ 'videoName': this.title, 'event': 'videoCompleteEvent' });
      }
      console.log('We watched the video!');
    },

    play: function play() {
      // reveal ty modal here
      this.reveal.open();
      this.player.playVideo();
      if (window.dataLayer != undefined) {
        window.dataLayer.push({ 'videoName': this.title, 'event': 'videoPlayEvent' });
      }
    }
  }
});

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SensisAutocomplete_vue__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SensisAutocomplete_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SensisAutocomplete_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers__ = __webpack_require__(7);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "AddressInput",
  components: {
    SensisAutocomplete: __WEBPACK_IMPORTED_MODULE_2__SensisAutocomplete_vue___default.a
  },

  data: function data() {
    return {
      countryList: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers__["g" /* getCountriesList */])(),
      manualInput: false,
      autocompleteAddress: null,
      formattedAddress: null,
      address: {
        unitNumber: null,
        streetNumber: null,
        streetName: null,
        suburb: null,
        postcode: null,
        state: null
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    showManualInput: function showManualInput() {
      return this.manualInput || this.country !== "Australia";
    },
    isAustralia: function isAustralia() {
      return this.country === "Australia";
    },
    isAutocompleteAvailable: function isAutocompleteAvailable() {
      return this.country === "Australia" && !this.manualInput;
    },
    canFindMyAddress: function canFindMyAddress() {
      return this.country === "Australia";
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])({
    donation: function donation(state) {
      return state.donation.donation;
    },
    country: function country(state) {
      return state.donation.donation.addressInput.country;
    }
  })),

  watch: {
    country: function country() {
      this.address.state = null;
    }
  },
  methods: {
    addressSelected: function addressSelected(address, formatted, addressNotFound) {
      console.log("addressNotFound", addressNotFound);
      if (addressNotFound) {
        this.manualInput = true;
      }

      if (!addressNotFound) {
        this.formattedAddress = formatted;
        this.autocompleteAddress = address;
      }
    },
    changeAddress: function changeAddress() {
      this.formattedAddress = null;
      this.autocompleteAddress = null;
    },
    validate: function validate() {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (_this.isAutocompleteAvailable) {
          // Autocomplete
          if (!!_this.autocompleteAddress) {
            resolve(true);
          } else {
            _this.$refs.donateSensisAutocomplete.validate();
            reject(false);
          }
        } else {
          _this.validateManual().then(function (val) {
            return resolve(val);
          }).catch(function (err) {
            return reject(err);
          });
        }
      });
    },
    validateManual: function validateManual() {
      var _this2 = this;

      console.log("Validating manual address");
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this2.$validator.validateAll().then(function (result) {
          // Will return true if valid and false if not
          if (result) {
            resolve(result);
          } else {
            console.error("Address Input not valid - result", result);
            reject(result);
          }
        }).catch(function (err) {
          console.error("Address Input Validation - Error - ", err);
          reject(err);
        });
      });
    },
    getAddressDetails: function getAddressDetails() {
      if (!!this.autocompleteAddress) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.autocompleteAddress, {
          isVerified: true
        });
      }
      return {
        unitnumber: this.address.unitNumber,
        streetno: this.address.streetNumber,
        streetname: this.address.streetName,
        postcode: this.address.postcode,
        state: this.address.state,
        suburb: this.address.suburb,
        country: this.country,
        isVerified: false
      };
    }
  }
});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_slick_carousel__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_slick_carousel__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Carousel",
  components: {
    VueSlickCarousel: __WEBPACK_IMPORTED_MODULE_2_vue_slick_carousel___default.a
  },

  data: function data() {
    return {
      slideIndex: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    ready: function ready() {
      return !!this.packages && this.packages.length > 0;
    },
    selectedPackage: function selectedPackage() {
      return this.packages[this.slideIndex];
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    donation: function donation(state) {
      return state.donation.donation;
    },
    packages: function packages(state) {
      return state.product.packagesProduct;
    }
  })),

  methods: {
    updateSelectedPackage: function updateSelectedPackage(slideIndex) {
      this.slideIndex = slideIndex;
      this.donation.packagecode = this.packages[slideIndex].code;
    },
    radioChanged: function radioChanged(index) {
      this.$refs.adoptionCarousel.goTo(index);
      this.updateSelectedPackage(index);
    }
  }
});

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AddressInput_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AddressInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__AddressInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "AdoptionRecipient",
  components: {
    AddressInput: __WEBPACK_IMPORTED_MODULE_4__AddressInput_vue___default.a
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    cannotDeliver: function cannotDeliver() {
      return this.country != "Australia";
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])({
    donation: function donation(state) {
      return state.donation.donation;
    },
    country: function country(state) {
      return state.donation.donation.addressInput.country;
    }
  })),

  methods: {
    next: function next() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([_this.validate(), _this.$refs.AddressInput.validate()]);

              case 3:

                _this.donation.gift = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, _this.donation.gift, _this.$refs.AddressInput.getAddressDetails());

                // Commit the current step (Push to database)
                _context.next = 6;
                return _this.commit();

              case 6:

                _this.$store.dispatch("logFormRecipient");

                _this.$emit("success");
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);

                console.error("Next - Error - ", _context.t0);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 10]]);
      }))();
    },
    validate: function validate() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this2.$validator.validateAll().then(function (result) {
          // Will return true if valid and false if not
          if (result) {
            resolve(result);
          } else {
            console.error("Recipient Details not valid - result", result);
            reject(result);
          }
        }).catch(function (err) {
          console.error("Recipient Details Validation - Error - ", err);
          reject(err);
        });
      });
    },
    commit: function commit() {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this3.$store.dispatch("saveDonation").then(function (response) {
          resolve();
        }).catch(function (error) {
          console.error("saveDonation1 error", error);
          reject(error);
        });
      });
    }
  }
});

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vee_validate__ = __webpack_require__(8);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "CreditCard",
  data: function data() {
    return {
      customCheckout: customcheckout(),
      isCardNumberComplete: false,
      isCVVComplete: false,
      isExpiryComplete: false,
      isCardNumberEmpty: true,
      isCVVEmpty: true,
      isExpiryEmpty: true,
      isCardNumberFocused: false,
      isCVVFocused: false,
      isExpiryFocused: false,
      cardHolderName: "",
      cardHolderNameError: undefined,
      cardNumberError: undefined,
      cardCVVError: undefined,
      cardExpiryError: undefined,
      isLoading: false,
      isPayButtonDisabled: false,
      serverError: undefined,
      failedPayment: false,
      bamboraInputs: {
        cardNumber: undefined,
        expiryTime: undefined,
        cvvNumber: undefined
      },
      isHolderNameCCNumber: false
    };
  },

  props: {
    submitButtonMessage: {
      type: String,
      default: "pay Now"
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.initForm();
    this.initCustomCheckoutEvents();

    // People are putting the CC number in the card holder name
    // So we add a validation to make sure the value in the card holder name
    // is not a CC number.
    var ccPaymentCardHolderValidation = function ccPaymentCardHolderValidation(cardHolderName) {
      if (cardHolderName.length > 0) {
        var isCCNumber = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers__["f" /* luhnCheck */])(cardHolderName);
        _this.isHolderNameCCNumber = isCCNumber;
        if (!isCCNumber) {
          return { valid: true };
        } else {
          return {
            valid: false,
            data: {
              message: "Card Holder Name cannot be a Credit Card Number."
            }
          };
        }
      } else {
        return {
          valid: false,
          data: { message: "Card Holder Name empty" }
        };
      }
    };

    __WEBPACK_IMPORTED_MODULE_3_vee_validate__["b" /* Validator */].extend("ccPaymentCardHolderValidation", {
      validate: ccPaymentCardHolderValidation,
      getMessage: function getMessage(field, params, data) {
        return data.message;
      }
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    hasErrors: function hasErrors() {
      return this.cardNumberError || this.cardCVVError || this.cardExpiryError || this.serverError;
    },
    isCardHolderNameValid: function isCardHolderNameValid() {
      return this.cardHolderName && this.cardHolderName.length > 3 && !this.isHolderNameCCNumber;
    },
    canSubmit: function canSubmit() {
      // Activate pay Button only if all the field are complete and there is no errors
      return this.isCardNumberComplete && this.isExpiryComplete && this.isCVVComplete && !this.cardNumberError && !this.cardCVVError && !this.cardExpiryError && !this.serverError && this.isCardHolderNameValid && !this.isPayButtonDisabled;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    donation: function donation(state) {
      return state.donation.donation;
    }
  })),
  methods: {
    initForm: function initForm() {
      // Set the font size for the inputs inside the injected iframes
      var style = {
        base: {
          fontSize: "15px"
        }
      };
      var options = {
        style: style
      };

      this.cardHolderName = "";

      // Create and mount the inputs
      this.bamboraInputs.cardNumber = this.customCheckout.create("card-number", options);
      this.bamboraInputs.cardNumber.mount("#card-number");
      this.bamboraInputs.cvvNumber = this.customCheckout.create("cvv", options);
      this.bamboraInputs.cvvNumber.mount("#card-cvv");
      this.bamboraInputs.expiryTime = this.customCheckout.create("expiry", options);
      this.bamboraInputs.expiryTime.mount("#card-expiry");
    },
    initCustomCheckoutEvents: function initCustomCheckoutEvents() {
      var _this2 = this;

      // Setup empty input state
      this.customCheckout.on("empty", function (event) {
        if (event.empty) {
          if (event.field === "card-number") {
            _this2.isCardNumberEmpty = true;
            _this2.toggleCardNumberComplete(false);
          } else if (event.field === "cvv") {
            _this2.isCVVEmpty = true;
            _this2.toggleCVVComplete(false);
          } else if (event.field === "expiry") {
            _this2.isExpiryEmpty = true;
            _this2.toggleExpiryComplete(false);
          }
        } else {
          if (event.field === "card-number") {
            _this2.isCardNumberEmpty = false;
          } else if (event.field === "cvv") {
            _this2.isCVVEmpty = false;
          } else if (event.field === "expiry") {
            _this2.isExpiryEmpty = false;
          }
        }
      });

      // Setup focus input state
      this.customCheckout.on("focus", function (event) {
        if (event.field === "card-number") {
          _this2.isCardNumberFocused = true;
        } else if (event.field === "cvv") {
          _this2.isCVVFocused = true;
        } else if (event.field === "expiry") {
          _this2.isExpiryFocused = true;
        }
      });

      // Setup blur input state
      this.customCheckout.on("blur", function (event) {
        if (event.field === "card-number") {
          _this2.isCardNumberFocused = false;
        } else if (event.field === "cvv") {
          _this2.isCVVFocused = false;
        } else if (event.field === "expiry") {
          _this2.isExpiryFocused = false;
        }
      });

      // Setup error input state
      this.customCheckout.on("error", function (event) {
        if (event.field === "card-number") {
          console.log("Card number has errors: ", event);
          _this2.cardNumberError = event.message;
        } else if (event.field === "cvv") {
          console.log("CVV has errors: ", event);
          _this2.cardCVVError = event.message;
        } else if (event.field === "expiry") {
          console.log("Expiry has errors: ", event);
          _this2.cardExpiryError = event.message;
        }
      });

      // Display card brand logo in the card number input
      this.customCheckout.on("brand", function (event) {
        var cardLogo = "none";
        if (event.brand && event.brand !== "unknown") {
          var filePath = "https://cdn.na.bambora.com/downloads/images/cards/" + event.brand + ".svg";
          cardLogo = "url(" + filePath + ")";
        }
        document.getElementById("card-number").style.backgroundImage = cardLogo;
      });

      this.customCheckout.on("complete", function (event) {
        if (event.field === "card-number") {
          _this2.cardNumberError = undefined;
          _this2.serverError = "";
          _this2.toggleCardNumberComplete(true);
          console.log("Card number is complete: ", event);
        } else if (event.field === "cvv") {
          _this2.toggleCVVComplete(true);
          _this2.serverError = "";
          _this2.cardCVVError = undefined;
          console.log("CVV is complete: ", event);
        } else if (event.field === "expiry") {
          _this2.toggleExpiryComplete(true);
          _this2.cardExpiryError = undefined;
          _this2.serverError = "";
          console.log("Expiry is complete: ", event);
        }
      });
    },
    resetForm: function resetForm() {
      this.bamboraInputs.expiryTime.clear();
      this.bamboraInputs.cardNumber.clear();
      this.bamboraInputs.cvvNumber.clear();
      this.cardHolderName = "";

      // No need to reset the "complete" flags. In case of copy paste of a good card, the "complete" trigger won't fire.
      // If the user enter a wrong card number, the "error" trigger will fire anyway.
      // Trying to pay with empty field will just fail the payment.

      document.getElementById("card-number").style.backgroundImage = "";
    },
    resetFormErrors: function resetFormErrors() {
      this.cardNumberError = undefined;
      this.cardCVVError = undefined;
      this.cardExpiryError = undefined;
      this.serverError = undefined;
      this.cardHolderName = "";
    },
    togglePayButtonDisabled: function togglePayButtonDisabled(value) {
      //disable pay-button
      this.isPayButtonDisabled = value;
    },
    toggleCardNumberComplete: function toggleCardNumberComplete(value) {
      this.isCardNumberComplete = value;
    },
    toggleCVVComplete: function toggleCVVComplete(value) {
      this.isCVVComplete = value;
    },
    toggleExpiryComplete: function toggleExpiryComplete(value) {
      this.isExpiryComplete = value;
    },
    pay: function pay() {
      this.togglePayButtonDisabled(true);
      this.isLoading = true;
      console.log("Pay - Create one time token");
      this.customCheckout.createOneTimeToken(wwfconfigs.MERCHANTID, this.processToken);

      this.$store.dispatch("logFormPayAttempt");
    },
    processToken: function processToken(result) {
      console.log("token result : ", result);
      this.isLoading = false;
      if (result.error) {
        this.processTokenError(result.error);
      } else {
        this.processTokenSuccess(result.token);
      }
    },
    processTokenError: function processTokenError(error) {
      console.log("processTokenError: ", error);
      if (error.message) {
        this.serverError = error.message;
      } else {
        this.serverError = "Unable to process transaction. Please try again later.";
      }
      this.$store.dispatch("logFormPayFail", this.serverError);
      this.togglePayButtonDisabled(false);
      this.failedPayment = true;
    },
    processTokenSuccess: function processTokenSuccess(token) {
      console.log("processTokenSuccess: " + token);
      this.serverError = undefined;
      this.$emit("success", {
        token: token,
        cardHolderName: this.cardHolderName
      });
    },
    retry: function retry() {
      this.isLoading = true;
      this.$emit("retry");
      this.resetForm();
      this.resetFormErrors();
      this.isLoading = false;
    },
    reset: function reset(error) {
      this.resetForm();
      if (error) {
        this.serverError = error;
        this.failedPayment = true;
      } else {
        this.resetFormErrors();
        this.failedPayment = false;
      }
      this.togglePayButtonDisabled(false);
    }
  }
});

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "DirectDebit",
  data: function data() {
    return {
      accountNumber: "",
      accountRouting: "",
      accountTitle: "",
      serverError: "",
      failedPayment: false
    };
  },
  mounted: function mounted() {},

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    donation: function donation(state) {
      return state.donation.donation;
    }
  }),
  methods: {
    enablePayButton: function enablePayButton() {
      return this.accountTitle && this.accountNumber && this.accountRouting && (!this.errors || !this.errors.items || this.errors.items.length === 0) ? true : false;
    },
    pay: function pay() {
      var _this = this;

      this.$store.dispatch('logFormPayAttempt');

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.serverError = "";
        _this.$validator.validateAll().then(function (result) {
          if (!result) {
            var errMessage = "Direct Debit checkout is invalid.";
            _this.$store.dispatch('logFormPayFail', errMessage);
            reject(errMessage);
          } else {
            _this.$emit("success", {
              accno: _this.accountNumber,
              accrouting: _this.accountRouting,
              acctitle: _this.accountTitle
            });
          }
        });
      });
    },
    retry: function retry() {
      this.$emit("retry");
      this.resetForm();
    },
    resetForm: function resetForm() {
      this.accountNumber = "";
      this.accountRouting = "";
      this.accountTitle = "";
      this.serverError = undefined;
    },
    reset: function reset(error) {
      this.resetForm();
      if (error) {
        this.serverError = error;
        this.failedPayment = true;
      } else {
        this.failedPayment = false;
      }
    }
  }
});

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Stepper_vue__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Stepper_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Stepper_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_gtm__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Donate",
  components: {
    Stepper: __WEBPACK_IMPORTED_MODULE_2__Stepper_vue___default.a
  },

  props: {
    productId: {
      type: String,
      required: true
    },
    thankYouUrl: {
      type: String,
      default: null
    },
    useProductThankYouUrl: {
      type: Boolean,
      default: true
    },
    blacklistUrl: {
      type: String
    }
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])({
    donation: function donation(state) {
      return state.donation.donation;
    },
    product: function product(state) {
      return state.product.product;
    }
  }),

  created: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _this = this;

      var dt, defaultTypeExists, defaultType, settings, handles, q, paramsPrefill, amount, email, firstname, lastname, salutation, wildcardCode, dollarhandle, dollarhandles, newDollarHandles;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.setLoading(true);

              this.checkPaypalCallback();

              // Fetch product informations
              // We can have query params to override the appeal and fund id
              _context.next = 4;
              return this.$store.dispatch("getProductById", {
                id: this.productId,
                source: window.location.href,
                appealid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["d" /* getParameterByName */])("t"),
                fundid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["d" /* getParameterByName */])("f")
              });

            case 4:

              // Set default donation type by query param
              dt = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["d" /* getParameterByName */])("dt");

              if (dt && (dt === "Single" || dt === "Regular")) {
                this.defaultDonationType = dt;
              }

              // DONATION TYPE - Pre-select the doallar handle and the package (rule: first item on the list)
              // As we only have Single and Regular, always set Single as the first option
              defaultTypeExists = this.product.donationtypes.filter(function (e) {
                return e === _this.defaultDonationType;
              }).length === 1;
              defaultType = defaultTypeExists && this.defaultDonationType ? this.defaultDonationType : this.product.appealcodesetting.defaultdonationtype;

              // Reverse alphabetical order

              this.product.donationtypes = this.product.donationtypes.sort(function (a, b) {
                if (a === defaultType) {
                  return -1;
                }
                if (b === defaultType) {
                  return 1;
                }
                return 0;
              });

              this.donation.type = defaultType;
              settings = this.product.donationsettings[defaultType];

              if (settings) {
                this.donation.campaignid = settings.campaignid;
                this.donation.fundid = settings.fundid;
              }

              // DOLLAR HANDLE - Select first element
              handles = this.product.dollarhandles[defaultType];

              if (handles) {
                this.donation.amount = handles[0].amount;
                this.donation.dollarhandle = handles[0].amount;
              }

              if (!(this.product.producttype != "wildcard")) {
                _context.next = 18;
                break;
              }

              // Pre-select the package (rule: first item on the list)
              this.donation.packagecode = this.product.packages && this.product.packages.length > 0 ? this.product.packages[0] : null;
              _context.next = 18;
              return this.$store.dispatch("getAllPackagesForProduct");

            case 18:

              // PURL: Check if there are some query string in URL to prefill the form, Query from donate widget
              q = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["d" /* getParameterByName */])("q");

              if (q) {
                paramsPrefill = "?" + window.atob(q);

                console.log("paramsPrefill", paramsPrefill);
                amount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["d" /* getParameterByName */])("amount", paramsPrefill);
                email = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["d" /* getParameterByName */])("email", paramsPrefill);
                firstname = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["d" /* getParameterByName */])("firstname", paramsPrefill);
                lastname = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["d" /* getParameterByName */])("lastname", paramsPrefill);
                salutation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["d" /* getParameterByName */])("salutation", paramsPrefill);
                wildcardCode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["d" /* getParameterByName */])("wildcardCode", paramsPrefill);

                if (wildcardCode) {
                  this.donation.packagecode = wildcardCode;
                }
                dollarhandle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["d" /* getParameterByName */])("dollarhandle", paramsPrefill) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["d" /* getParameterByName */])("dollarhandle", paramsPrefill).replace("$", "") : undefined;
                dollarhandles = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["d" /* getParameterByName */])("dollarhandles", paramsPrefill);

                if (dollarhandles) {
                  // get dollarhandles from query params
                  dollarhandles = dollarhandles.replace(/[^0-9\. ]+/g, "").split(" ");
                  newDollarHandles = [];

                  dollarhandles.forEach(function (v, index) {
                    // Check if there is a product dollar handles index
                    if (_this.product.dollarhandles.Single[index]) {
                      newDollarHandles.push({
                        amount: v,
                        img: _this.product.dollarhandles.Single[index].img,
                        text: _this.product.dollarhandles.Single[index].text
                      });
                    }
                  });
                  this.product.dollarhandles.Single = newDollarHandles;
                }
                this.donation.dollarhandle = dollarhandle;
                this.donation.amount = amount;
                this.donation.email = email;
                this.donation.firstname = firstname;
                this.donation.lastname = lastname;
                this.donation.title = salutation;
              }

              // GTM: Push datalayer add to cart
              __WEBPACK_IMPORTED_MODULE_4__utils_gtm__["a" /* default */].pushProductDetail(this.product.productname, this.product.id, this.product.producttype, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["b" /* getNameByDonationType */])(this.donation.type));

              this.$store.dispatch("logProductVisit");

              this.setLoading(false);

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _ref.apply(this, arguments);
    }

    return created;
  }(),
  methods: {
    checkPaypalCallback: function checkPaypalCallback() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var paymentId, payerId, donation, querylessUrl;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                // Check if there payment paypal pending to excecute
                paymentId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["d" /* getParameterByName */])("token");
                payerId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["d" /* getParameterByName */])("PayerID");

                if (!(payerId && paymentId)) {
                  _context2.next = 12;
                  break;
                }

                console.log("Paypal Callback - Payment found");
                _context2.next = 7;
                return _this2.$store.dispatch("paymentPaypal", {
                  payerid: payerId,
                  paymentid: paymentId
                });

              case 7:
                donation = _context2.sent;

                _this2.donation.amount = donation.amount;
                console.log("Paypal Callback - Donaion", donation);
                _this2.$store.dispatch("logFormPaySuccess", donation.key);
                if (donation) {
                  // Remove the query params from the URL
                  querylessUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["e" /* removeURLParameter */])("token");

                  querylessUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["e" /* removeURLParameter */])("payerId", querylessUrl);
                  window.history.pushState({}, document.title, querylessUrl);
                  _this2.thanksUser(donation);
                  _this2.reset();
                }

              case 12:
                _context2.next = 17;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2["catch"](0);

                console.error("Paypal Callback - error", _context2.t0);

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 14]]);
      }))();
    },
    thanksUser: function thanksUser(donation) {
      this.$store.dispatch("logDonationComplete", donation);

      var donateThankYouUrl = donation.thankYouUrl;
      if (this.useProductThankYouUrl && donateThankYouUrl || this.thankYouUrl) {
        var query = "firstname=" + donation.firstname;
        query += "&lastname=" + donation.lastname;
        query += "&frequency=" + donation.type;
        query += "&amount=" + donation.amount;
        query += "&source=" + document.URL;

        var params = "?q=" + window.btoa(query);

        var baseUrl = this.useProductThankYouUrl && donateThankYouUrl ? donateThankYouUrl : this.thankYouUrl;
        var url = baseUrl + params;

        // Send data to Google Tag Manager
        __WEBPACK_IMPORTED_MODULE_4__utils_gtm__["a" /* default */].pushPurchase(donation.key, donation.productname, donation.productid, donation.producttype, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["b" /* getNameByDonationType */])(donation.type), donation.amount, donation.postcode, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["c" /* getNameByPaymentType */])("wwf_paypal"), function () {
          setTimeout(function () {
            window.open(url, "_self");
          }, 1000);
        });
      } else {
        window.app.thankyou(donation.amount, donation.type, donation.key, donation.productname, donation.postcode, donation.firstname, donation.lastname, donation.producttype, donation.certificateurl, donation.productid, "wwf_paypal", donation.wildcard ? donation.wildcard.pdf : null);
      }
    },
    setLoading: function setLoading(value) {
      this.donation.isLoading = value;
    },
    reset: function reset() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var defaultTypeExists, defaultType, settings;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.$store.dispatch("resetDonation");

                defaultTypeExists = _this3.product.donationtypes.filter(function (e) {
                  return e === _this3.defaultDonationType;
                }).length === 1;
                defaultType = defaultTypeExists && _this3.defaultDonationType ? _this3.defaultDonationType : _this3.product.appealcodesetting.defaultdonationtype;


                _this3.donation.type = defaultType;
                settings = _this3.product.donationsettings[defaultType];

                if (settings) {
                  _this3.donation.campaignid = settings.campaignid;
                  _this3.donation.fundid = settings.fundid;
                }

                if (!(_this3.product.producttype != "wildcard")) {
                  _context3.next = 10;
                  break;
                }

                // Pre-select the package (rule: first item on the list)
                _this3.donation.packagecode = _this3.product.packages && _this3.product.packages.length > 0 ? _this3.product.packages[0] : null;
                _context3.next = 10;
                return _this3.$store.dispatch("getAllPackagesForProduct");

              case 10:

                console.log("Reset donate form");

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    }
  }
});

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CreditCard_vue__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CreditCard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CreditCard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DirectDebit_vue__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DirectDebit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__DirectDebit_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_gtm__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers__ = __webpack_require__(7);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Payment",
  components: {
    CreditCard: __WEBPACK_IMPORTED_MODULE_3__CreditCard_vue___default.a,
    DirectDebit: __WEBPACK_IMPORTED_MODULE_4__DirectDebit_vue___default.a
  },

  props: {
    thankYouUrl: {
      type: String,
      default: null
    },
    useProductThankYouUrl: {
      type: Boolean,
      default: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    paymentform: function paymentform() {
      if (this.$store.state.donation.donation.payementType == "wwf_purchasetokenise") {
        return "CreditCard";
      } else {
        return "DirectDebit";
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])({
    donation: function donation(state) {
      return state.donation.donation;
    },
    product: function product(state) {
      return state.product.product;
    }
  })),
  methods: {
    getFrequency: function getFrequency(donationType) {
      switch (donationType) {
        case "Regular":
          return "monthly";
        default:
        case "Single":
          return "one-off";
      }
    },
    processSuccess: function processSuccess(data) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var isRestrictedIP;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (!(_this.donation.payementType === "wwf_purchasetokenise")) {
                  _context.next = 6;
                  break;
                }

                _context.next = 4;
                return _this.$store.dispatch("paymentCreditCard", {
                  token: data.token,
                  cardHolderName: data.cardHolderName
                });

              case 4:
                _context.next = 8;
                break;

              case 6:
                _context.next = 8;
                return _this.$store.dispatch("paymentDirectDebit", {
                  accno: data.accno,
                  accrouting: data.accrouting,
                  acctitle: data.acctitle
                });

              case 8:

                console.log("Payment success");
                _this.$store.commit("setTransactionId", _this.donation.key);

                _this.$store.dispatch('logFormPaySuccess', _this.donation.key);

                _this.thanksUser();

                _this.$refs.checkout.reset();

                // Make sure the data about the supporter has been transfered to the main
                // to be displayed on the thank you popup or other before reseting the data.
                setTimeout(function () {
                  _this.$emit("reset");
                }, 1000);
                _context.next = 22;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](0);

                console.error("Server Error", _context.t0);
                isRestrictedIP = _context.t0.status == 403 && _context.t0.body;

                _this.$store.dispatch("logFormPayFail", "Server Error");
                _this.$refs.checkout.reset(isRestrictedIP ? _context.t0.body.message : "Oops something happened and we were not able to process your payment, please try again.");

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 16]]);
      }))();
    },
    thanksUser: function thanksUser() {
      var _this2 = this;

      // Check query params for step up override
      var stepupId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers__["d" /* getParameterByName */])("stepup");
      if (stepupId) {
        this.$store.dispatch("getContentMessageById", stepupId).then(function (response) {
          var title = response.description;
          var content = response.content;
          var details = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this2.donation);

          _this2.$store.commit("setPopupContent", {
            component: "step-up",
            componentparams: {
              id: stepupId,
              title: title,
              content: content,
              details: details
            }
          });

          _this2.$store.commit("openStepUpPopup", true);

          // Log to amplitude
          _this2.$store.dispatch("logStepUp", stepupId);
        }).catch(function (err) {
          console.error(err);
        });

        this.sendToGTM();
        return;
      }

      // If no step up override, continue with regular thank you flow
      var donateThankYouUrl = this.donation.thankYouUrl;
      if (this.useProductThankYouUrl && donateThankYouUrl || this.thankYouUrl) {
        var query = "firstname=" + this.donation.firstname;
        query += "&lastname=" + this.donation.lastname;
        query += "&frequency=" + this.donation.type;
        query += "&amount=" + this.donation.amount;
        query += "&source=" + document.URL;

        var params = "?q=" + window.btoa(query);
        var baseUrl = this.useProductThankYouUrl && donateThankYouUrl ? donateThankYouUrl : this.thankYouUrl;
        var url = baseUrl + params;

        this.$store.dispatch("logDonationComplete");

        // Send data to Google Tag Manager
        var callback = function callback() {
          setTimeout(function () {
            window.open(url, "_self");
          }, 1000);
        };
        this.sendToGTM(callback);
      } else {
        this.$store.dispatch("logDonationComplete");
        this.$store.commit("openDonationPopup", true);
      }
    },

    retryPayment: function retryPayment() {
      var _this3 = this;

      this.$store.dispatch("retryDonation").then(function (response) {
        _this3.$refs.checkout.reset();
      }).catch(function (error) {
        console.error("Retry donation error", error);
      });
    },
    sendToGTM: function sendToGTM(callback) {
      __WEBPACK_IMPORTED_MODULE_6__utils_gtm__["a" /* default */].pushPurchase(this.donation.transactionid, this.product.productname, this.product.id, this.product.producttype, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers__["b" /* getNameByDonationType */])(this.donation.type), this.donation.amount, this.donation.billing.postcode, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers__["c" /* getNameByPaymentType */])(this.donation.payementType), callback);
    }
  }
});

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AdoptionRecipient_vue__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AdoptionRecipient_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__AdoptionRecipient_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WildcardRecipient_vue__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WildcardRecipient_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__WildcardRecipient_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "RecipientDetails",
  components: {
    AdoptionRecipient: __WEBPACK_IMPORTED_MODULE_1__AdoptionRecipient_vue___default.a,
    WildcardRecipient: __WEBPACK_IMPORTED_MODULE_2__WildcardRecipient_vue___default.a
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    recipientForm: function recipientForm() {
      if (this.product.producttype == "adoption") {
        return "AdoptionRecipient";
      }
      if (this.product.producttype == "wildcard") {
        return "WildcardRecipient";
      }
      return null;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])({
    product: function product(state) {
      return state.product.product;
    }
  })),

  methods: {
    processSuccess: function processSuccess() {
      this.$emit("next");
    }
  }
});

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vee_validate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TaxCalculator_vue__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TaxCalculator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__TaxCalculator_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AdoptionCarousel_vue__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AdoptionCarousel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__AdoptionCarousel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__WildcardCarousel_vue__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__WildcardCarousel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__WildcardCarousel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_gtm__ = __webpack_require__(10);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Selection",
  components: {
    TaxCalculator: __WEBPACK_IMPORTED_MODULE_5__TaxCalculator_vue___default.a,
    AdoptionCarousel: __WEBPACK_IMPORTED_MODULE_6__AdoptionCarousel_vue___default.a,
    WildcardCarousel: __WEBPACK_IMPORTED_MODULE_7__WildcardCarousel_vue___default.a
  },

  data: function data() {
    return {
      maxAmount: 75000,
      selectedDollarHandle: null,
      formTouched: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    packageCarousel: function packageCarousel() {
      if (this.isAdoption) {
        return "AdoptionCarousel";
      }
      if (this.isWildcard) {
        return "WildcardCarousel";
      }
      return null;
    },
    isAdoption: function isAdoption() {
      return this.product.producttype == "adoption";
    },
    isWildcard: function isWildcard() {
      return this.product.producttype == "wildcard";
    },
    dollarHandles: function dollarHandles() {
      return this.product.dollarhandles[this.currentDonationType];
    },
    isGiftSelected: function isGiftSelected() {
      return this.donation.isGift;
    },
    isDollarHandleSelected: function isDollarHandleSelected() {
      return this.selectedDollarHandle != null && this.selectedDollarHandle != "custom" && this.selectedDollarHandle != "";
    },
    isCustomSelected: function isCustomSelected() {
      return this.selectedDollarHandle != null && this.selectedDollarHandle === "custom";
    },
    isPayPalAvailable: function isPayPalAvailable() {
      return this.donation.type == "Single";
    },
    isDirectDebitAvailable: function isDirectDebitAvailable() {
      return this.product.producttype != "wildcard";
    },
    showTaxCalculator: function showTaxCalculator() {
      return this.donation.amount && this.product.extrasetting && this.product.extrasetting.displaytaxcalculator;
    },
    showMaxAmountMessage: function showMaxAmountMessage() {
      return this.selectedDollarHandle === "custom" && !!this.donation.amount && !isNaN(this.donation.amount) && +this.donation.amount > this.maxAmount;
    },
    minAmount: function minAmount() {
      if (!!this.product && !!this.product.donationsettings && !!this.currentDonationType && !!this.product.donationsettings[this.currentDonationType]) {
        return this.product.donationsettings[this.currentDonationType].minimumAmount;
      } else {
        return null;
      }
    },
    proposeCustomAmount: function proposeCustomAmount() {
      return !(this.product.extrasetting && this.product.extrasetting.hidecustomhandle);
    },
    paymentTypeText: function paymentTypeText() {
      return this.isAdoption ? "Adopt with" : "Donate by";
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* mapState */])({
    donation: function donation(state) {
      return state.donation.donation;
    },
    currentDonationType: function currentDonationType(state) {
      return state.donation.donation.type;
    },
    currentDollarHandle: function currentDollarHandle(state) {
      return state.donation.donation.dollarhandle;
    },
    currentPackage: function currentPackage(state) {
      return state.donation.donation.packagecode;
    },
    product: function product(state) {
      return state.product.product;
    }
  })),
  watch: {
    selectedDollarHandle: function selectedDollarHandle(newVal, oldVal) {
      if (this.isDollarHandleSelected) {
        this.donation.dollarhandle = this.selectedDollarHandle.amount;
        this.donation.amount = this.selectedDollarHandle.amount;
      } else {
        this.donation.dollarhandle = null;
        this.donation.amount = null;
        if (newVal === "custom") {
          // Give the focus to the input
          setTimeout(function () {
            this.$refs.customAmount.focus();
          }.bind(this), 1);
        }
      }
    },
    currentDonationType: function currentDonationType(newVal) {
      /// Pre select the first dollar handle
      if (!!newVal && !!this.product && !!this.product.dollarhandles && !!this.product.dollarhandles[newVal]) {
        this.selectedDollarHandle = this.product.dollarhandles[newVal][0];
      }
    },
    currentDollarHandle: function currentDollarHandle(newVal) {
      // Listen for the changes from the widget
      var dh = this.dollarHandles.find(function (e) {
        return e.amount === newVal;
      });
      if (!!dh) {
        this.selectedDollarHandle = dh;
      }
    },
    currentPackage: function currentPackage(newVal, oldVal) {
      // Listen for package change after initial value is set
      if (oldVal) {
        // Log to Amplitude when this is the first user interaction on the form
        this.logFirstTouch("choose package");
      }
    }
  },

  created: function created() {
    var _this = this;

    // Custom validation for amount (regular/single)
    var donationCustomAmountIsValid = function donationCustomAmountIsValid(amount) {
      if (amount <= 0) {
        return {
          valid: false,
          data: { message: "The amount must be positive." }
        };
      }

      // Get the min amount from the settings of the selected type or the default one if not set
      var minimumAmount = !!_this.minAmount ? parseFloat(_this.minAmount) : _this.type === "Regular" ? 15 : 2;

      var inputAmount = parseInt(amount.replace(/ /g, ""));
      if (inputAmount < minimumAmount) {
        return {
          valid: false,
          data: { message: "The minimum amount is $" + minimumAmount }
        };
      } else if (inputAmount > _this.maxAmount) {
        return {
          valid: false,
          data: { message: "The maximum amount is $75,000" }
        };
      } else {
        return {
          valid: true
        };
      }
    };

    __WEBPACK_IMPORTED_MODULE_4_vee_validate__["b" /* Validator */].extend("donationCustomAmountIsValid", {
      validate: donationCustomAmountIsValid,
      getMessage: function getMessage(field, params, data) {
        return data.message;
      }
    });
  },
  mounted: function mounted() {
    /// Pre select the first dollar handle
    if (!!this.currentDonationType && !!this.product && !!this.product.dollarhandles && !!this.product.dollarhandles[this.currentDonationType]) {
      this.selectedDollarHandle = this.product.dollarhandles[this.currentDonationType][0];
    }
  },

  methods: {
    selectDonationType: function selectDonationType(type) {
      if (this.currentDonationType === type) {
        return;
      }

      this.$store.commit("updateDonation", { field: "type", value: type });

      // Reset any previous selection like if it was new
      this.$store.commit("updateDonation", {
        field: "dollarhandle",
        value: ""
      });
      this.$store.commit("updateDonation", {
        field: "amount",
        value: ""
      });

      // Update the Campaign ID and the Fund ID with the one of the selected Donation Type
      var settings = this.product.donationsettings[type];
      if (settings) {
        this.$store.commit("updateDonation", {
          field: "campaignid",
          value: settings.campaignid
        });
        this.$store.commit("updateDonation", {
          field: "fundid",
          value: settings.fundid
        });
      }
    },
    toggleIsGift: function toggleIsGift(value) {
      this.donation.isGift = value;
    },
    formatDollarHandle: function formatDollarHandle(handle) {
      return "$" + (handle.indexOf(".00") >= 0 ? handle.slice(0, -3) : handle);
    },
    selectPaymentType: function selectPaymentType(paymentType) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                console.log("Selected Payment Type", paymentType);

                // Update donation with the payment type
                _this2.$store.commit("updateDonation", {
                  field: "payementType",
                  value: paymentType
                });

                _this2.logFirstTouch('payment type');

                // Validate form
                _context.next = 6;
                return _this2.validate();

              case 6:
                _context.next = 8;
                return _this2.commit();

              case 8:

                // Fire GTM Event
                __WEBPACK_IMPORTED_MODULE_10__utils_gtm__["a" /* default */].pushAddToCart(_this2.product.productname, _this2.product.id, _this2.donation.amount, _this2.product.producttype, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helpers__["b" /* getNameByDonationType */])(_this2.donation.type));

                // Go to next step
                _this2.$emit("next");

                _this2.$store.dispatch('logFormProduct');
                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](0);

                console.error("selectPaymentType - Error - ", _context.t0);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 13]]);
      }))();
    },
    validate: function validate() {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this3.$validator.validateAll().then(function (result) {
          // Will return true if valid and false if not
          if (result) {
            resolve(result);
          } else {
            console.error("Form Selection not valid - result", result);
            reject(result);
          }
        }).catch(function (err) {
          console.error("Step 1 Validation - Error - ", err);
          reject(err);
        });
      });
    },
    commit: function commit() {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        // Add .00 if no . and add 0 if no 0 (eg 42.6)
        _this4.donation.amount = _this4.donation.amount.indexOf(".") == -1 ? _this4.donation.amount.concat(".00") : /^\d+(\.\d{1})+$/.test(_this4.donation.amount) ? _this4.donation.amount.concat("0") : _this4.donation.amount;

        _this4.$store.dispatch("saveDonation").then(function (response) {
          resolve();
        }).catch(function (error) {
          console.error("saveDonation1 error", error);
          reject(error);
        });
      });
    },
    logFirstTouch: function logFirstTouch(fieldName) {
      if (!this.formTouched) {
        this.$store.dispatch("logFormBegin", fieldName);
        this.formTouched = true;
      }
    }
  }
});

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Selection_vue__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Selection_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Selection_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RecipientDetails_vue__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RecipientDetails_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__RecipientDetails_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SupporterDetails_vue__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SupporterDetails_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SupporterDetails_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Payment_vue__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Payment_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Payment_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 // Step 1
 // Step 2
 // Step 3
 // Step 4



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Stepper",
  components: {
    Selection: __WEBPACK_IMPORTED_MODULE_1__Selection_vue___default.a,
    RecipientDetails: __WEBPACK_IMPORTED_MODULE_2__RecipientDetails_vue___default.a,
    SupporterDetails: __WEBPACK_IMPORTED_MODULE_3__SupporterDetails_vue___default.a,
    Payment: __WEBPACK_IMPORTED_MODULE_4__Payment_vue___default.a
  },

  data: function data() {
    return {
      currentStep: 0
    };
  },

  props: {
    thankYouUrl: {
      type: String,
      default: null
    },
    useProductThankYouUrl: {
      type: Boolean,
      default: true
    },
    blacklistUrl: {
      type: String
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    maxSteps: function maxSteps() {
      if (this.isAdoption && !this.isGiftSelected) return 3;
      if (this.isAdoption && this.isGiftSelected) return 4;
      if (this.isWildcard) return 4;
      return 3;
    },
    isGiftSelected: function isGiftSelected() {
      return this.donation.isGift;
    },
    isAdoption: function isAdoption() {
      return this.product.producttype == "adoption";
    },
    isWildcard: function isWildcard() {
      return this.product.producttype == "wildcard";
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])({
    donation: function donation(state) {
      return state.donation.donation;
    },
    product: function product(state) {
      return state.product.product;
    }
  })),

  methods: {
    next: function next(oldStep) {
      // this.currentStep = 3;
      if (this.maxSteps === 3 && oldStep === 0) {
        this.currentStep = 2;
      } else {
        this.currentStep = ++oldStep;
      }

      this.donation.formWizardCurrentStep = this.currentStep;

      // Move to top of the form
      var el = document.getElementById("donate-form");
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    },
    reset: function reset() {
      this.currentStep = 0;
      this.$emit("reset");
    }
  }
});

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AddressInput_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AddressInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__AddressInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vee_validate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_gtm__ = __webpack_require__(10);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SupporterDetails",
  components: {
    AddressInput: __WEBPACK_IMPORTED_MODULE_5__AddressInput_vue___default.a
  },

  data: function data() {
    return {
      isSaving: false,
      emailCheck: {
        timeout: null,
        lastTimestamp: Date.now(),
        emailRegex: /.+\@.+\..+/,
        checkEmailLoading: false
      },
      phoneNumberCheck: {
        timeout: null,
        lastTimestamp: Date.now(),
        checkEmailLoading: false
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({
    showCompliance: function showCompliance() {
      return this.product.extrasetting.showCompliance;
    },
    showRecipientCheckbox: function showRecipientCheckbox() {
      return this.product.producttype == "adoption" && this.donation.isGift;
    },
    cannotDeliver: function cannotDeliver() {
      return this.country != "Australia" && this.product.producttype == "adoption" && !this.donation.isGift // Display the message if there's no recipient and only the supporter
      ;
    },
    isAustralia: function isAustralia() {
      if (this.donation.isGift && this.donation.isSameAddress) {
        return this.donation.gift.country === "Australia";
      }
      return this.country === "Australia";
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])({
    donation: function donation(state) {
      return state.donation.donation;
    },
    product: function product(state) {
      return state.product.product;
    },
    country: function country(state) {
      return state.donation.donation.addressInput.country;
    }
  })),
  props: {
    blacklistUrl: {
      type: String,
      default: "https://www.wwf.org.au/get-involved/partnerships/who-we-partner-with#blacklist"
    }
  },

  created: function created() {
    var _this = this;

    // EMAIL VALIDATION

    var donationValidateEmail = function donationValidateEmail(email) {
      if (email.length > 0 && _this.emailCheck.emailRegex.test(email)) {
        return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          var timestamp = Date.now(); // timestamp for this api call
          _this.emailCheck.lastTimestamp = timestamp; // 1 , 2 , 3
          _this.emailCheck.checkEmailLoading = true;
          // Fetch Suggestions
          _this.$store.dispatch("validateEmail", email).then(function (response) {
            if (response && timestamp >= _this.emailCheck.lastTimestamp) {
              _this.emailCheck.checkEmailLoading = false;
              _this.donation.emailValidation = response;
              resolve(response);
            }
          }).catch(function (err) {
            console.error(err);
            _this.emailCheck.checkEmailLoading = false;
            // If the call failed, do not keep the user from donating
            resolve({
              valid: true
            });
          });
        });
      } else {
        return {
          valid: false,
          data: { message: "Email invalid" }
        };
      }
    };

    __WEBPACK_IMPORTED_MODULE_7_vee_validate__["b" /* Validator */].extend("donationValidateEmail", {
      validate: donationValidateEmail,
      getMessage: function getMessage(field, params, data) {
        return data.message;
      }
    });

    // PHONE NUMBER VALIDATION
    var donationValidatePhone = function donationValidatePhone(phone) {
      // Only check for australian numbers
      if (!_this.isAustralia) {
        var regex = /^\+?[0-9\s]*$/;
        if (phone.match(regex)) {
          return { valid: true };
        }
        return {
          valid: false,
          data: { message: "Please only use a plus sign, spaces and numeric values" }
        };
      } else if (phone.length > 0) {
        return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          var timestamp = Date.now(); // timestamp for this api call
          _this.phoneNumberCheck.lastTimestamp = timestamp; // 1 , 2 , 3
          _this.phoneNumberCheck.checkPhoneLoading = true;
          // Fetch Suggestions
          _this.$store.dispatch("validatePhone", phone).then(function (response) {
            if (response && timestamp >= _this.phoneNumberCheck.lastTimestamp) {
              _this.phoneNumberCheck.checkPhoneLoading = false;
              resolve(response);
            }
          }).catch(function (err) {
            console.error(err);
            _this.phoneNumberCheck.checkPhoneLoading = false;
            // If the call failed, do not keep the user from donating
            resolve({
              valid: true
            });
          });
        });
      } else {
        return {
          valid: false,
          data: { message: "Invalid phone number, try again" }
        };
      }
    };

    __WEBPACK_IMPORTED_MODULE_7_vee_validate__["b" /* Validator */].extend("donationValidatePhone", {
      validate: donationValidatePhone,
      getMessage: function getMessage(field, params, data) {
        return data.message;
      }
    });

    // Turn on 'Donate on behalf of business' by default if displaying compliance checkbox
    if (this.showCompliance) {
      this.donation.isBehalfBusiness = true;
    }
  },

  methods: {
    next: function next() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this2.isSaving) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _this2.isSaving = true;

                _context.prev = 3;

                if (!(_this2.showRecipientCheckbox && _this2.donation.isSameAddress)) {
                  _context.next = 10;
                  break;
                }

                _context.next = 7;
                return _this2.validate();

              case 7:

                // Transfer
                _this2.transferRecipientAddress();
                _context.next = 13;
                break;

              case 10:
                _context.next = 12;
                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([_this2.validate(), _this2.$refs.AddressInput.validate()]);

              case 12:

                // Transfer
                _this2.donation.billing = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, _this2.donation.billing, _this2.$refs.AddressInput.getAddressDetails());

              case 13:
                _context.next = 15;
                return _this2.commit();

              case 15:

                // Fire GTM Event
                __WEBPACK_IMPORTED_MODULE_9__utils_gtm__["a" /* default */].pushCheckout(_this2.product.productname, _this2.product.id, _this2.donation.amount, _this2.product.producttype, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__helpers__["b" /* getNameByDonationType */])(_this2.donation.type));

                _this2.$store.dispatch("logFormSupporter");

                // Go to checkout
                // For Paypal, redirect to payment page
                // For other, go to next step
                if (_this2.donation.payementType == "wwf_paypal") {
                  _this2.$store.dispatch("logFormPayAttempt");
                  _this2.$store.dispatch("checkoutPaypal").then(function (response) {
                    _this2.isSaving = false;
                    window.location.href = response;
                  }).catch(function (error) {
                    _this2.isSaving = false;
                    console.error("Checkout Paypal - Error - ", error);
                    _this2.$store.dispatch("logFormPayFail", "Paypal checkout error");
                    reject(error);
                  });
                } else {
                  _this2.$emit("next");
                  _this2.isSaving = false;
                }
                _context.next = 24;
                break;

              case 20:
                _context.prev = 20;
                _context.t0 = _context["catch"](3);

                _this2.isSaving = false;
                console.error("Next - Error - ", _context.t0);

              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[3, 20]]);
      }))();
    },
    validate: function validate() {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this3.$validator.validateAll().then(function (result) {
          // Will return true if valid and false if not
          if (result) {
            resolve(result);
          } else {
            console.error("Supporter Details not valid - result", result);
            reject(result);
          }
        }).catch(function (err) {
          console.error("Supporter Details Validation - Error - ", err);
          reject(err);
        });
      });
    },
    commit: function commit() {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this4.$store.dispatch("saveDonation").then(function (response) {
          resolve();
        }).catch(function (error) {
          console.error("saveDonation1 error", error);
          reject(error);
        });
      });
    },
    transferRecipientAddress: function transferRecipientAddress() {
      var _donation$gift = this.donation.gift,
          title = _donation$gift.title,
          firstname = _donation$gift.firstname,
          lastname = _donation$gift.lastname,
          address = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_donation$gift, ["title", "firstname", "lastname"]);

      this.donation.billing = address;
      this.donation.gift = {
        title: title,
        firstname: firstname,
        lastname: lastname,
        unitnumber: null,
        streetno: null,
        streetname: null,
        postcode: null,
        state: null,
        suburb: null,
        country: null
      };
    }
  }
});

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_slick_carousel__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_slick_carousel__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "WildcardCarousel",
  components: {
    VueSlickCarousel: __WEBPACK_IMPORTED_MODULE_2_vue_slick_carousel___default.a
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    ready: function ready() {
      // Single wildcard product should not be displayed
      return this.product.packages.length > 1;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    donation: function donation(state) {
      return state.donation.donation;
    },
    product: function product(state) {
      return state.product.product;
    }
  })),

  created: function created() {
    this.updateSelectedPackage();
  },

  methods: {
    updateSelectedPackage: function updateSelectedPackage(slideIndex) {
      var _product$packages = this.product.packages[slideIndex || 0],
          code = _product$packages.code,
          img = _product$packages.img,
          pdf = _product$packages.pdf;

      this.donation.packagecode = code;
      this.donation.wildcard.img = img;
      this.donation.wildcard.pdf = pdf;
    }
  }
});

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AddressInput_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AddressInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__AddressInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(2);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "WildcardRecipient",
  components: {
    AddressInput: __WEBPACK_IMPORTED_MODULE_6__AddressInput_vue___default.a,
    Datepicker: __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__["a" /* default */]
  },

  data: function data() {
    return {
      disabledFn: {
        customPredictor: function customPredictor(date) {
          if (__WEBPACK_IMPORTED_MODULE_4_moment___default()(new Date()).isAfter(date, "day")) {
            return true;
          }
        }
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapState */])({
    donation: function donation(state) {
      return state.donation.donation;
    }
  })),

  methods: {
    next: function next() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([_this.validate()]);

              case 3:
                _context.next = 5;
                return _this.commit();

              case 5:

                _this.$store.dispatch('logFormRecipient');

                _this.$emit("success");
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);

                console.error("Next - Error - ", _context.t0);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 9]]);
      }))();
    },
    validate: function validate() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this2.$validator.validateAll().then(function (result) {
          // Will return true if valid and false if not
          if (result) {
            resolve(result);
          } else {
            console.error("Recipient Details not valid - result", result);
            reject(result);
          }
        }).catch(function (err) {
          console.error("Recipient Details Validation - Error - ", err);
          reject(err);
        });
      });
    },
    commit: function commit() {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this3.$store.dispatch("saveDonation").then(function (response) {
          resolve();
        }).catch(function (error) {
          console.error("saveDonation1 error", error);
          reject(error);
        });
      });
    }
  }
});

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__product_VueBamboraCustomCheckout__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__product_VueBamboraCustomCheckout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__product_VueBamboraCustomCheckout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers__ = __webpack_require__(7);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "updateDetails",
  components: {
    VueBamboraCustomCheckout: __WEBPACK_IMPORTED_MODULE_3__product_VueBamboraCustomCheckout___default.a
  },
  data: function data() {
    return {
      productId: "update-details",
      isInitialRequest: false,
      isInitialSubmitted: false,
      iframeSrc: '',
      reveal: null,
      maskedcard: null,
      name: null,
      date: null,
      type: null,
      hasCredidCardChanged: false,
      isPopupOpen: false,
      useNewCheckout: false
    };
  },

  created: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return this.$store.dispatch("getCustomCheckoutFeatureSwitch", this.productId);

            case 3:
              this.useNewCheckout = _context.sent;

              console.log('this.useNewCheckout', this.useNewCheckout);
              _context.next = 11;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);

              this.useNewCheckout = false;
              console.error("Cannot get feature switch - Back to old checkout");

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[0, 7]]);
    }));

    function created() {
      return _ref.apply(this, arguments);
    }

    return created;
  }(),
  mounted: function mounted() {
    var _this = this;

    // reveal-dialog-credit-card

    this.$store.dispatch("get_data_from_email_link").then(function (response) {
      // TODO: display message if not found
      // true/false
      _this.isInitialRequest = response;
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* isEditMode */])()) {
        console.log('no editmode');
        _this.reveal = new Foundation.Reveal($('#reveal-dialog-credit-card'));
      }
    }, function (error) {
      console.error("get_firebase_data_from_quertstring_id error", error);
    });
  },
  computed: {
    email: {
      get: function get() {
        return this.$store.getters.update_details.email;
      },
      set: function set(value) {
        this.$store.commit("updateDetail", { field: "email", value: value });
      }
    },
    title: {
      get: function get() {
        return this.$store.getters.update_details.title;
      },
      set: function set(value) {
        this.$store.commit("updateDetail", { field: "title", value: value });
      }
    },
    firstname: {
      get: function get() {
        return this.$store.getters.update_details.firstname;
      },
      set: function set(value) {
        this.$store.commit("updateDetail", { field: "firstname", value: value });
      }
    },
    lastname: {
      get: function get() {
        return this.$store.getters.update_details.lastname;
      },
      set: function set(value) {
        this.$store.commit("updateDetail", { field: "lastname", value: value });
      }
    },
    phone: {
      get: function get() {
        return this.$store.getters.update_details.phone;
      },
      set: function set(value) {
        this.$store.commit("updateDetail", { field: "phone", value: value });
      }
    },
    address: {
      get: function get() {
        return this.$store.getters.update_details.address;
      },
      set: function set(value) {
        this.$store.commit("updateDetail", { field: "address", value: value });
      }
    },
    state: {
      get: function get() {
        return this.$store.getters.update_details.state;
      },
      set: function set(value) {
        this.$store.commit("updateDetail", { field: "state", value: value });
      }
    },
    city: {
      get: function get() {
        return this.$store.getters.update_details.city;
      },
      set: function set(value) {
        this.$store.commit("updateDetail", { field: "city", value: value });
      }
    },
    postcode: {
      get: function get() {
        return this.$store.getters.update_details.postalcode;
      },
      set: function set(value) {
        this.$store.commit("updateDetail", { field: "postalcode", value: value });
      }
    },
    country: {
      get: function get() {
        return this.$store.getters.update_details.country;
      },
      set: function set(value) {
        this.$store.commit("updateDetail", { field: "country", value: value });
      }
    }
  },
  methods: {
    saveDetails: function saveDetails() {
      var _this2 = this;

      return this.$validator.validateAll().then(function (result) {
        if (result) {
          // Check what field is mandatory
          _this2.$store.dispatch("update_new_details_to_firebase");
          _this2.isInitialSubmitted = true;
        }
      });
    },
    updateDetails: function updateDetails() {
      var _this3 = this;

      return this.$validator.validateAll().then(function (result) {
        if (result) {
          _this3.$store.dispatch("create_firebase_record_from_emailaddress");
          _this3.isInitialSubmitted = true;
        }
      });
    },
    updateCreditCard: function updateCreditCard() {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        // BAMBORA CUSTOM CHECKOUT
        if (_this4.useNewCheckout) {
          _this4.reveal.open();
          // We need to wait for the popup to be fully displayed before init the component
          setTimeout(function () {
            _this4.isPopupOpen = true;
          }, 400);
        } else {
          // OLD BAMBORA CHECKOUT
          _this4.$store.dispatch('update_details_checkout').then(function (response) {
            _this4.reveal.open();
            _this4.iframeSrc = response.body.url;
            _this4.isPopupOpen = true;
          });
        }
      });
    },
    confirmtransaction: function confirmtransaction(maskedcard, name, date, type) {
      // OLD BAMBORA CHECKOUT
      console.log("maskedcard", maskedcard);
      console.log("name", name);
      console.log("date", date);
      console.log("type", type);
      this.maskedcard = maskedcard;
      this.name = name;
      this.date = date;
      this.type = type;
      this.hasCredidCardChanged = true;
      this.reveal.close();
    },
    processSuccess: function processSuccess(event) {
      var _this5 = this;

      this.$store.dispatch("updateCreditCardDetails", event).then(function (result) {
        console.log('processSuccess - updateCreditCardDetails - result', result);
        _this5.maskedcard = result.TruncatedCard;
        _this5.name = result.cardHolderName;
        _this5.date = result.ExpM + " / " + result.ExpY;
        _this5.type = result.CardType;
        _this5.hasCredidCardChanged = true;

        _this5.reveal.close();
        setTimeout(function () {
          _this5.isPopupOpen = false;
        }, 400);
      }).catch(function (err) {
        _this5.$refs.checkout.reset("We couldn't process your creadit card. Please try again.");
      });
    }

  }
});

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Code taken and modified from vue-twentytwenty
// MIT License | https://github.com/mhayes/vue-twentytwenty

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "BeforeAfterSlider",

  data: function data() {
    return {
      imgOffset: null,
      slideOffset: this.offset,
      sliding: false,
      containerStyle: {},
      overlayStyle: {}
    };
  },

  props: {
    before: {
      type: String,
      required: true
    },
    beforeLabel: {
      type: String
    },
    after: {
      type: String,
      required: true
    },
    afterLabel: {
      type: String
    },
    offset: {
      type: [String, Number],
      default: 0.5,
      validator: function validator(value) {
        return value > 0 && value <= 1;
      }
    },
    keyboardStep: {
      type: [String, Number],
      default: 0.2,
      validator: function validator(value) {
        return value > 0 && value <= 1;
      }
    },
    overlay: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    setDimensions: function setDimensions() {
      var img = this.$el.querySelector("img");
      this.imgOffset = img.getBoundingClientRect();
      this.containerStyle = { width: this.w + "px", height: this.h + "px" };
    },
    startSlide: function startSlide(event) {
      this.sliding = true;
      this.moveSlide(event);
      this.overlayStyle = { opacity: 0 };
    },
    handleArrowNavigation: function handleArrowNavigation(event) {
      return this.moveSlide(event);
    },
    moveSlide: function moveSlide(event) {
      if (this.sliding) {
        var x = (event.touches ? event.touches[0].pageX : event.pageX) - this.imgOffset.left;
        x = x < 0 ? 0 : x > this.w ? this.w : x;
        return this.slideOffset = x / this.w;
      }
      if (event.key) {
        switch (event.key) {
          case "Left": // IE/Edge key
          case "ArrowLeft":
            this.slideOffset = this.floatOffset - this.floatKeyboardStep >= 0 ? this.floatOffset - this.floatKeyboardStep : 0;break;
          case "Right": // IE/Edge key
          case "ArrowRight":
            this.slideOffset = this.floatOffset + this.floatKeyboardStep <= 1 ? this.floatOffset + this.floatKeyboardStep : 1;break;
          default:
            return;
        }
      }
    },
    endSlide: function endSlide() {
      this.sliding = false;
      this.overlayStyle = {};
    },
    resize: function resize() {
      var _this = this;

      this.containerStyle = {};
      this.$nextTick(function () {
        return _this.setDimensions();
      });
    }
  },
  computed: {
    beforeImgStyle: function beforeImgStyle() {
      return { clip: "rect(0, " + this.x + "px, " + this.h + "px, 0)" };
    },
    handleStyle: function handleStyle() {
      var size = 40;
      return {
        width: size + "px",
        height: size + "px",
        top: "calc(50% - " + size / 2 + "px)",
        left: "calc(" + this.slideOffset * 100 + "% - " + size / 2 + "px)"
      };
    },
    x: function x() {
      return this.w * this.slideOffset;
    },
    w: function w() {
      return this.imgOffset ? this.imgOffset.width : null;
    },
    h: function h() {
      return this.imgOffset ? this.imgOffset.height : null;
    },
    floatOffset: function floatOffset() {
      return parseFloat(this.slideOffset);
    },
    floatKeyboardStep: function floatKeyboardStep() {
      return parseFloat(this.keyboardStep);
    }
  },
  mounted: function mounted() {
    document.addEventListener("touchmove", this.moveSlide);
    document.addEventListener("touchend", this.endSlide);
    document.addEventListener("mousemove", this.moveSlide);
    document.addEventListener("mouseup", this.endSlide);
    window.addEventListener("resize", this.resize);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener("touchmove", this.moveSlide);
    document.removeEventListener("touchend", this.endSlide);
    document.removeEventListener("mousemove", this.moveSlide);
    document.removeEventListener("mouseup", this.endSlide);
    window.removeEventListener("resize", this.resize);
  }
});

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "DynamicContent",

  props: {
    content: {
      type: String
    }
  }
});

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Header__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Content__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Content___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Content__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__forms_PetitionBio__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__forms_PetitionBio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__forms_PetitionBio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers__ = __webpack_require__(7);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "DynamicPetition",
  components: {
    DynamicHeader: __WEBPACK_IMPORTED_MODULE_2__Header___default.a,
    DynamicContent: __WEBPACK_IMPORTED_MODULE_3__Content___default.a,
    PetitionBio: __WEBPACK_IMPORTED_MODULE_4__forms_PetitionBio___default.a
  },

  data: function data() {
    return {
      isLoading: true,

      headerContent: null,
      mainContent: null,

      programName: null,

      counterTitle: null,
      signButtonValue: null,
      viewMessageButtonValue: null,
      viewMessagePosition: null,
      letterMessage: null,
      letterTitle: null,
      stepupId: null,

      sendToIve: false,
      iveSupplier: null,
      iveSource: null
    };
  },

  props: {
    datalayerName: {
      type: String,
      default: "cop21"
    },
    counterLimit: {
      type: Number,
      default: 10000
    },
    defaultPetitionId: {
      type: String,
      default: "petition-cop-oceans"
    }
  },
  computed: {},

  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var petitionId, data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              petitionId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers__["d" /* getParameterByName */])("p") || _this.defaultPetitionId;
              _context.next = 3;
              return _this.$store.dispatch("getContentMessageById", petitionId);

            case 3:
              data = _context.sent;


              _this.headerContent = data.petition;
              _this.mainContent = data.content;
              _this.programName = data.petition.programName;
              _this.counterTitle = data.petition.formDescription;
              _this.signButtonValue = data.petition.submitText;
              _this.viewMessageButtonValue = data.petition.viewLetterText;
              _this.viewMessagePosition = data.petition.viewLetterPosition;
              _this.letterTitle = data.petition.letterHeading;
              _this.letterMessage = data.petition.letterId;
              _this.stepupId = data.petition.stepupId;

              _this.sendToIve = !!data.petition.sendToIve;
              _this.iveSupplier = data.petition.iveSupplier;
              _this.iveSource = data.petition.iveSource;

              _this.isLoading = false;

              _this.$store.dispatch("logLandingVisit", _this.programName);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BeforeAfterSlider__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BeforeAfterSlider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__BeforeAfterSlider__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "DynamicHeader",
  components: {
    BeforeAfterSlider: __WEBPACK_IMPORTED_MODULE_0__BeforeAfterSlider___default.a
  },

  props: {
    content: {
      type: Object
    }
  },
  computed: {
    hasVideo: function hasVideo() {
      return this.content.bgWebm || this.content.bgMp4 || this.content.bgOgg;
    },
    useSlider: function useSlider() {
      return !!this.content.bgImage && this.content.bgImage2;
    }
  }
});

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EarthhourCompetition",
  props: {
    title: {
      type: String,
      required: true
    },
    intro: {
      type: String,
      required: true
    },
    datalayername: {
      //datalayername="Test datalayer name"
      type: String,
      required: true
    },
    termsandconditionurl: {
      //datalayername="/privacy-policy/privacy-policy"
      type: String,
      required: true
    },
    programname: {
      //petitionname="Test petition name"
      type: String,
      required: true
    },
    buttontitle: {
      //countertitle="Test message sent"
      type: String,
      default: "submit"
    },
    keepData: {
      //:keep-data="false"
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      firstName: null,
      lastName: null,
      email: null,
      phone: null,
      postCode: null,
      isLoading: false,
      error: false,
      isShake: false,
      optIns: []
    };
  },

  methods: {
    save: function save() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          var postBody = {
            email: _this.email,
            firstName: _this.firstName,
            lastName: _this.lastName,
            postcode: _this.postCode,
            phone: _this.phone != "" ? _this.phone : null,
            programName: _this.programname,
            cookieID: _this.$cookie.get("_mkto_trk"),
            keepData: _this.keepData,
            optIns: _this.optIns.length > 0 ? _this.optIns : ""
          };

          console.log("postBody", postBody);

          _this.$store.dispatch("saveLead", {
            campaignId: _this.datalayername,
            lead: postBody
          }).then(function (response) {
            console.log("petition submit success");

            if (window.dataLayer != undefined) {
              window.dataLayer.push({
                formName: _this.datalayername,
                event: "formSubmitSuccessEvent"
              });
            }

            try {
              //Reset form
              _this.firstName = "";
              _this.lastName = "";
              _this.email = "";
              _this.phone = "";
              _this.postCode = "";
              _this.optIns = [];

              //Reset errors
              _this.$validator.errors.clear();
            } catch (error) {
              console.error(error);
            }
          }, function (error) {
            console.error("Petition submit failed");
          });

          _this.$emit("openthankyoucompetitionpopup");
        } else {
          console.log("form invalid");
          // GTM Trackingss
          if (window.dataLayer != undefined) {
            window.dataLayer.push({
              formName: _this.datalayername,
              event: "formSubmitEvent"
            });
          }
          _this.isShake = true;
          setTimeout(function () {
            this.isShake = false;
          }.bind(_this), 500);
        }
      });
    }
  }
});

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EarthhourLogoWall",
  data: function data() {
    return {
      logos: [],
      showLoadMore: true,
      currentPage: 1,
      fetching: false
    };
  },

  props: {
    section: {
      type: String,
      default: "school"
    },
    size: {
      type: Number,
      default: 5
    },
    campaign: {
      type: String,
      default: "earth-hour"
    }
  },

  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this.$store.dispatch(_this.getCollection, {
                section: _this.section,
                page: _this.currentPage,
                size: _this.size
              });

            case 3:
              _this.logos = _context.sent;


              if (_this.logos.length < _this.size) {
                _this.showLoadMore = false;
              }
              _context.next = 11;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);

              console.error(_context.t0);
              _this.logos = [];

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 7]]);
    }))();
  },


  computed: {
    getCollection: function getCollection() {
      // Default is for Earth Hour, otherwise get logos for Partners
      return this.campaign === "earth-hour" ? "getEarthHourLogos" : "getPartnersLogos";
    }
  },

  methods: {
    fetchLogos: function fetchLogos() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _logos, newLogos;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this2.fetching = true;
                _context2.next = 4;
                return _this2.$store.dispatch(_this2.getCollection, {
                  section: _this2.section,
                  page: ++_this2.currentPage,
                  size: _this2.size
                });

              case 4:
                newLogos = _context2.sent;


                if (newLogos && newLogos.length < _this2.size) {
                  _this2.showLoadMore = false;
                }

                (_logos = _this2.logos).push.apply(_logos, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(newLogos));
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);

                console.error(_context2.t0);

              case 12:
                _context2.prev = 12;

                _this2.fetching = false;
                return _context2.finish(12);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 9, 12, 15]]);
      }))();
    }
  }
});

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EarthhourPopup",
  data: function data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      postCode: ""
    };
  },

  props: {
    mediaPackUrl: {
      type: String,
      default: "/documents/social-assets"
    },
    individualTitle: {
      type: String,
      default: "Want to do even more this Earth Hour?"
    },
    individualText: {
      type: String,
      default: "Donate to WWF's Regenerate Australia campaign to support the plan to make Australia a Renewable Energy Exports Powerhouse."
    },
    individualImageUrl: {
      type: String,
      default: "https://www.earthhour.org.au/images/UserUploadedImages/624/Solar-installation.jpg"
    },
    individualButtonLabel: {
      type: String,
      default: "Donate Now"
    },
    individualButtonLink: {
      type: String,
      default: "https://donate.wwf.org.au/donate/one-off-donation/renewables-nation"
    },
    businessTitle: {
      type: String,
      default: "Want to do even more this Earth Hour?"
    },
    businessText: {
      type: String,
      default: "Donate to WWF's Regenerate Australia campaign to support the plan to make Australia a Renewable Energy Exports Powerhouse."
    },
    businessImageUrl: {
      type: String,
      default: "https://www.earthhour.org.au/images/UserUploadedImages/624/Solar-installation.jpg"
    },
    businessButtonLabel: {
      type: String,
      default: "Donate Now"
    },
    businessButtonLink: {
      type: String,
      default: "https://donate.wwf.org.au/donate/one-off-donation/renewables-nation"
    },
    schoolTitle: {
      type: String,
      default: "Want to do even more this Earth Hour?"
    },
    schoolText: {
      type: String,
      default: "Donate to WWF's Regenerate Australia campaign to support the plan to make Australia a Renewable Energy Exports Powerhouse."
    },
    schoolImageUrl: {
      type: String,
      default: "https://www.earthhour.org.au/images/UserUploadedImages/624/Solar-installation.jpg"
    },
    schoolButtonLabel: {
      type: String,
      default: "Donate Now"
    },
    schoolButtonLink: {
      type: String,
      default: "https://donate.wwf.org.au/donate/one-off-donation/renewables-nation"
    },
    communityTitle: {
      type: String,
      default: "Want to do even more this Earth Hour?"
    },
    communityText: {
      type: String,
      default: "Donate to WWF's Regenerate Australia campaign to support the plan to make Australia a Renewable Energy Exports Powerhouse."
    },
    communityImageUrl: {
      type: String,
      default: "https://www.earthhour.org.au/images/UserUploadedImages/624/Solar-installation.jpg"
    },
    communityButtonLabel: {
      type: String,
      default: "Donate Now"
    },
    communityButtonLink: {
      type: String,
      default: "https://donate.wwf.org.au/donate/one-off-donation/renewables-nation"
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    product: function product(state) {
      return state.product.product;
    },
    lead: function lead(state) {
      return state.earthHour;
    },
    leadFirstName: function leadFirstName(state) {
      return state.earthHour.firstName;
    },
    leadLastName: function leadLastName(state) {
      return state.earthHour.lastName;
    },
    leadEmail: function leadEmail(state) {
      return state.earthHour.email;
    },
    leadPhone: function leadPhone(state) {
      return state.earthHour.phone;
    },
    leadPostCode: function leadPostCode(state) {
      return state.earthHour.postCode;
    },
    leadIAmA: function leadIAmA(state) {
      return state.earthHour.iAmA;
    }
  }), {
    title: function title() {
      return this[this.leadIAmA + "Title"];
    },
    text: function text() {
      return this[this.leadIAmA + "Text"];
    },
    buttonLabel: function buttonLabel() {
      return this[this.leadIAmA + "ButtonLabel"];
    },
    imageUrl: function imageUrl() {
      return this[this.leadIAmA + "ImageUrl"];
    },
    buttonLink: function buttonLink() {
      return this[this.leadIAmA + "ButtonLink"];
    }
  }),

  watch: {
    leadFirstName: function leadFirstName(newVal, oldVal) {
      if (newVal && newVal.length > 0) {
        this.firstName = newVal;
      }
    },
    leadLastName: function leadLastName(newVal, oldVal) {
      if (newVal && newVal.length > 0) {
        this.lastName = newVal;
      }
    },
    leadEmail: function leadEmail(newVal, oldVal) {
      if (newVal && newVal.length > 0) {
        this.email = newVal;
      }
    },
    leadPhone: function leadPhone(newVal, oldVal) {
      if (newVal && newVal.length > 0) {
        this.phone = newVal;
      }
    },
    leadPostCode: function leadPostCode(newVal, oldVal) {
      if (newVal && newVal.length > 0) {
        this.postCode = newVal;
      }
    }
  },

  mounted: function mounted() {
    console.log("mounted popup");
    $("button.close-button").click({ callback: this.logCloseButton }, function (e) {
      e.preventDefault();
      try {
        e.data.callback();
      } catch (err) {
        console.error(err);
      }
    });
  },


  methods: {
    donate: function donate() {
      var query = "firstname=" + this.firstName;
      query += "&lastname=" + this.lastName;
      query += "&email=" + this.email;
      query += "&source=" + document.URL;

      var params = "?q=" + window.btoa(query);

      try {
        var gaTag = ga.getAll()[0].get("linkerParam");
        if (gaTag) {
          params += "&" + gaTag;
        }
      } catch (err) {
        console.error(err);
      }

      var url = this.buttonLink + params;

      // Log Amplitude
      this.$store.dispatch("logEarthHourPopup", {
        name: "pop-up cta clicked",
        url: url
      });

      window.open(url, "_self");
    },
    logCloseButton: function logCloseButton() {
      this.$store.dispatch("logEarthHourPopup", {
        name: "pop-up declined"
      });
    }
  }
});

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vee_validate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_count_to__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_count_to___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_count_to__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_gtm__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_firebase__ = __webpack_require__(32);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EarthhourRegistration",
  components: { countTo: __WEBPACK_IMPORTED_MODULE_6_vue_count_to___default.a },
  created: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _this = this;

      var earthhourEmailIsValid, earthhourPhoneNumberIsValid;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // Get the query param for the popup
              this.queryParam = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helpers__["d" /* getParameterByName */])("su");

              // Subscribe to real-time counter

              if (!this.showcounter) {
                _context.next = 7;
                break;
              }

              _context.t0 = this.subscriptions;
              _context.next = 5;
              return __WEBPACK_IMPORTED_MODULE_11_firebase__["a" /* default */].firestore().collection("campaigns").doc(this.datalayername).onSnapshot(function (snapshot) {
                var data = snapshot.data();
                if (!!data) {
                  _this.setCounter(data.count);
                }
              }, function (error) {
                console.error(err);
              });

            case 5:
              _context.t1 = _context.sent;

              _context.t0.push.call(_context.t0, _context.t1);

            case 7:

              // Check the email
              earthhourEmailIsValid = function earthhourEmailIsValid(email) {
                return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this.errors.remove("email");
                  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([_this.checkEmailDuplicate(), _this.checkEmail()]).then(function (results) {
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                      for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(results), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var r = _step.value;

                        if (!r.valid) {
                          return resolve(r);
                        }
                      }
                    } catch (err) {
                      _didIteratorError = true;
                      _iteratorError = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                          _iterator.return();
                        }
                      } finally {
                        if (_didIteratorError) {
                          throw _iteratorError;
                        }
                      }
                    }

                    _this.errors.remove("email");
                    resolve({ valid: true });
                  }).catch(function (err) {
                    console.error(err);
                    _this.errors.remove("email");
                    resolve({ valid: true });
                  });
                });
              };

              __WEBPACK_IMPORTED_MODULE_5_vee_validate__["b" /* Validator */].extend("earthhourEmailIsValid", {
                validate: earthhourEmailIsValid,
                getMessage: function getMessage(field, params, data) {
                  return data.message;
                }
              });

              // Check Phone Number

              earthhourPhoneNumberIsValid = function earthhourPhoneNumberIsValid(phone) {
                var validationRegex = /^(\+?61|0)([0-9]{8,9})/;
                if (!phone.replace(/ /g, "").match(validationRegex)) {
                  return {
                    valid: false,
                    field: "phone",
                    data: { message: "Invalid phone number" }
                  };
                } else {
                  return {
                    valid: true
                  };
                }
              };

              __WEBPACK_IMPORTED_MODULE_5_vee_validate__["b" /* Validator */].extend("earthhourPhoneNumberIsValid", {
                validate: earthhourPhoneNumberIsValid,
                getMessage: function getMessage(field, params, data) {
                  return data.message;
                }
              });

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _ref.apply(this, arguments);
    }

    return created;
  }(),
  beforeDestroy: function beforeDestroy() {
    // Unsubscript from all subscriptions
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.subscriptions), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var s = _step2.value;

        s();
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  },
  mounted: function mounted() {
    if (this.showcounter && this.$refs.counter) {
      this.$refs.counter.start();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    endcounter: function endcounter() {
      return this.$store.getters.counter ? this.$store.getters.counter : 1;
    },
    isClean: function isClean() {
      return !this.fileUpload.fileName || this.fileUpload.fileName.length === 0;
    },
    hasError: function hasError() {
      return this.fileUpload.error != null;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* mapState */])({
    lead: function lead(state) {
      return state.earthHour;
    },
    user: function user(state) {
      return state.auth.user;
    }
  })),
  watch: {
    // use the watch to react on the value change.
    endcounter: function endcounter(newValue) {
      if (this.showcounter) {
        this.startcounter = newValue;
        this.$refs.counter.start();
      }
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    intro: {
      type: String,
      required: true
    },
    datalayername: {
      type: String,
      required: true
    },
    programname: {
      type: String,
      required: true
    },
    showcounter: {
      type: Boolean,
      default: true
    },
    countertitle: {
      type: String,
      default: "message sent"
    },
    buttontitle: {
      type: String,
      default: "Submit"
    },
    keepData: {
      type: Boolean,
      required: false,
      default: false
    },
    iAmADefault: {
      type: String,
      default: "individual"
    },
    competitionText: {
      type: String,
      default: "Enter the competition to win an electric scooter"
    },
    showCompetition: {
      type: Boolean,
      default: false
    },
    competitionPrivacyPolicy: {
      type: String,
      default: "/terms-and-conditions"
    },
    partnerOptinLabel: {
      type: String,
      default: "Receive inspiration and special offers from Intrepid Travel"
    }
  },
  data: function data() {
    return {
      formTouched: false,
      iAmAProvided: false,
      startcounter: 1,
      othername: null,
      isSaving: false,
      isProfanity: false,
      error: false,
      isShake: false,
      iAmA: this.iAmADefault,
      isInCompetition: true,
      acceptContactFromPartner: false,
      queryParam: null,
      extensions: [".png", ".jpg", ".jpeg", ".gif"],
      subscriptions: [],
      emailCheckSensis: {
        timeout: null,
        lastTimestamp: Date.now(),
        checkEmailLoading: false,
        emailRegex: /.+\@.+\..+/
      },
      emailCheckDuplicate: {
        timeout: null,
        lastTimestamp: Date.now(),
        checkEmailLoading: false,
        emailRegex: /.+\@.+\..+/
      },
      fileUpload: {
        fileUploaded: null,
        fileName: "",
        error: null,
        maxSize: 1000000,
        source: null
      }
    };
  },

  methods: {
    setCounter: function setCounter(value) {
      this.$store.commit("setCounter", value);
    },
    filesChange: function filesChange(fileList) {
      var _this2 = this;

      try {
        if (!fileList.length) return;
        var file = fileList[0];

        if (file.size <= this.fileUpload.maxSize) {
          // Check extension of the file
          var dotIndex = file.name.lastIndexOf(".");

          if (dotIndex < 0) {
            this.fileUpload.error = "File name is missing extension";
            return;
          }

          var extension = file.name.substring(dotIndex).toLowerCase();
          if (!this.extensions.includes(extension)) {
            this.fileUpload.error = "Please use only these formats: .png, .jpg, jpeg, .gif";
            return;
          }

          this.logFilled("Upload Logo", true);

          this.fileUpload.fileName = file.name;
          this.fileUpload.fileUploaded = file;
          this.fileUpload.error = null;

          // Allow to preview
          var reader = new FileReader();
          reader.onload = function (e) {
            _this2.fileUpload.source = e.target.result;
          };
          reader.readAsDataURL(file); // convert to base64 string
        } else {
          this.fileUpload.error = "File too big!";
        }
      } catch (err) {
        this.fileUpload.error = "Cannot read the file, please try another one.";
      }
    },
    removeImage: function removeImage() {
      var _this3 = this;

      // Give the time to the dom to render (When coming from individual to other)
      setTimeout(function () {
        if (_this3.$refs.logoInput) _this3.$refs.logoInput.value = "";
        _this3.fileUpload.fileName = "";
        _this3.fileUpload.fileUploaded = null;
      }, 10);
    },

    openReadLetterPage: function openReadLetterPage() {
      this.$store.commit("openLetterPopup", true);
    },
    onEmailInput: function onEmailInput() {
      var _this4 = this;

      if (this.emailCheckDuplicate.timeout) {
        clearTimeout(this.emailCheckDuplicate.timeout);
        this.emailCheckDuplicate.timeout = null;
      }

      // Only call if not input for 500 ms
      this.emailCheckDuplicate.timeout = setTimeout(function () {
        _this4.checkEmailDuplicate().then(function (result) {
          if (!result.valid) {
            _this4.errors.add({
              field: "email",
              msg: "Your email has already been submitted"
            });
          }
        }).catch(function (err) {
          // If it fails, let the user free to continue
          console.error(err);
        });
      }, 500);
    },
    checkEmailDuplicate: function checkEmailDuplicate() {
      var _this5 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var timestamp = Date.now(); // timestamp for this api call
        _this5.emailCheckDuplicate.lastTimestamp = timestamp; // 1 , 2 , 3
        _this5.emailCheckDuplicate.checkEmailLoading = true;
        // Fetch Suggestions
        _this5.$store.dispatch("checkEmail", {
          campaignId: _this5.datalayername,
          email: _this5.lead.email
        }).then(function (result) {
          if (timestamp >= _this5.emailCheckDuplicate.lastTimestamp) {
            if (result) {
              resolve({
                valid: false,
                field: "email",
                data: { message: "Your email has already been submitted" }
              });
            } else {
              resolve({ valid: true });
            }
          }
          _this5.emailCheckDuplicate.checkEmailLoading = false;
        }).catch(function (err) {
          console.error(err);
          _this5.emailCheckDuplicate.checkEmailLoading = false;
          // If it fails, let the user free to continue
          resolve({ valid: true });
        });
      });
    },
    checkEmail: function checkEmail() {
      var _this6 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var timestamp = Date.now(); // timestamp for this api call
        _this6.emailCheckSensis.lastTimestamp = timestamp; // 1 , 2 , 3
        _this6.emailCheckSensis.checkEmailLoading = true;
        // Fetch Suggestions
        _this6.$store.dispatch("validateEmail", _this6.lead.email).then(function (response) {
          if (response && timestamp >= _this6.emailCheckSensis.lastTimestamp) {
            _this6.emailCheckSensis.checkEmailLoading = false;
            resolve(response);
          }
        }).catch(function (err) {
          console.error(err);
          _this6.emailCheckSensis.checkEmailLoading = false;
          // If it fails, let the user free to continue
          resolve({ valid: true });
        });
      });
    },
    save: function save() {
      var _this7 = this;

      // Exit function if already saving
      if (this.isSaving) {
        return;
      }
      this.isSaving = true;

      // Create post body
      var postBody = {
        email: this.lead.email,
        firstName: this.lead.firstName,
        lastName: this.lead.lastName,
        postcode: this.lead.postCode,
        phone: this.lead.phone,
        programName: this.programname,
        iAmA: this.iAmA,
        other: this.othername,
        cookieID: this.$cookie.get("_mkto_trk"),
        keepData: this.keepData,
        ssoId: this.$store.getters.ssoId,
        sourceUrl: window.location.href
      };

      if (this.iAmA === "individual") {
        postBody.isInCompetition = this.isInCompetition;
        postBody.acceptContactFromPartner = this.acceptContactFromPartner;
      }
      console.log("postBody", postBody);

      // Purify the inputs
      this.$validator.validate().then(function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(result) {
          var results, inError, isPure, formName;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!result) {
                    _context2.next = 35;
                    break;
                  }

                  _context2.next = 3;
                  return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([_this7.$store.dispatch("purifyText", postBody.firstName), _this7.$store.dispatch("purifyText", postBody.lastName)]);

                case 3:
                  results = _context2.sent;
                  inError = results.filter(function (e) {
                    return e === false;
                  });
                  isPure = inError.length === 0;

                  _this7.isProfanity = !isPure;

                  if (!isPure) {
                    _context2.next = 32;
                    break;
                  }

                  if (!_this7.iAmAProvided) {
                    _this7.logFilled("User category", _this7.iAmA);
                  }

                  // Save logo if uploaded

                  if (!(_this7.fileUpload.fileUploaded && _this7.iAmA != "individual")) {
                    _context2.next = 12;
                    break;
                  }

                  _context2.next = 12;
                  return _this7.saveLogo();

                case 12:
                  _context2.next = 14;
                  return _this7.$store.dispatch("saveLead", {
                    campaignId: _this7.datalayername,
                    lead: postBody
                  });

                case 14:

                  // Log step to Amplitude
                  _this7.$store.dispatch("logPetitionComplete", {
                    id: window.location.pathname,
                    count: _this7.startcounter
                  });

                  // GTM Tracking
                  formName = _this7.datalayername + (_this7.iAmA != "individual" ? "-others" : "");

                  __WEBPACK_IMPORTED_MODULE_10__utils_gtm__["a" /* default */].formSubmitSuccessEvent(formName);

                  // Reset form
                  _this7.lead.firstName = "";
                  _this7.lead.lastName = "";
                  _this7.lead.email = "";
                  _this7.lead.phone = "";
                  _this7.lead.postCode = "";
                  _this7.iAmA = _this7.iAmADefault;
                  _this7.othername = "";
                  _this7.isSaving = false;
                  _this7.isInCompetition = false;
                  _this7.acceptContactFromPartner = false;

                  _this7.fileUpload.error = null;

                  // Reset errors
                  _this7.$validator.errors.clear();

                  // Create Popup
                  _this7.earthHourPopup(postBody);
                  _context2.next = 33;
                  break;

                case 32:
                  _this7.formInvalid();

                case 33:
                  _context2.next = 36;
                  break;

                case 35:
                  _this7.formInvalid();

                case 36:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, _this7);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    formInvalid: function formInvalid() {
      console.log("form invalid");
      // GTM Tracking
      __WEBPACK_IMPORTED_MODULE_10__utils_gtm__["a" /* default */].formSubmitEvent(this.datalayerName);
      this.isSaving = false;
      this.isShake = true;

      setTimeout(function () {
        this.isShake = false;
      }.bind(this), 500);
    },
    saveLogo: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var formData, url, meta;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log("Uploading file");

                // Upload the logo
                formData = new FormData();

                formData.append("organisation-logo", this.fileUpload.fileUploaded, this.fileUpload.fileName);
                _context3.next = 5;
                return this.$store.dispatch("uploadEarthhourLogo", {
                  file: formData,
                  organisationName: this.othername
                });

              case 5:
                url = _context3.sent;


                // Save the meta data to be reviewed
                meta = {
                  date: __WEBPACK_IMPORTED_MODULE_7_moment___default()().format("DD-MM-YYYY"),
                  senderEmail: this.lead.email,
                  firstName: this.lead.firstName,
                  lastName: this.lead.lastName,
                  section: this.iAmA,
                  organisationName: this.othername,
                  imageSize: this.fileUpload.fileUploaded.size,
                  url: url
                };
                _context3.next = 9;
                return this.$store.dispatch("createEarthhourLogo", meta);

              case 9:

                // Remove the image after uploading
                this.removeImage();
                console.log("File Uploaded");

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function saveLogo() {
        return _ref3.apply(this, arguments);
      }

      return saveLogo;
    }(),
    earthHourPopup: function earthHourPopup(postBody) {
      if (postBody.iAmA !== "individual" && postBody.iAmA !== "business" && postBody.iAmA !== "school") {
        postBody.iAmA = "community";
      }
      this.$store.commit("setIAmA", postBody.iAmA);

      // Log Popup to Amplitude
      this.$store.dispatch("logEarthHourPopup", {
        name: "pop-up viewed"
      });

      this.$store.commit("openEarthHourPopup", true);
    },
    logFirstTouch: function logFirstTouch(fieldName) {
      if (!this.formTouched) {
        this.$store.dispatch("logEarthHourStart", {
          fieldName: fieldName,
          productName: this.programname
        });
        this.formTouched = true;
      }
    },
    logProvided: function logProvided(fieldName, content) {
      if (content && content.length > 0) {
        this.$store.dispatch("logEarthHourDetails", {
          fieldName: fieldName,
          content: true
        });
      }
    },
    logFilled: function logFilled(fieldName, content) {
      if (fieldName === "User category") this.iAmAProvided = true;
      this.$store.dispatch("logEarthHourDetails", {
        fieldName: fieldName,
        content: content,
        productName: this.programname
      });
    }
  }
});

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_slick_carousel__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_slick_carousel__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EcommerceCarousel",
  components: {
    VueSlickCarousel: __WEBPACK_IMPORTED_MODULE_2_vue_slick_carousel___default.a
  },

  props: {
    productType: {
      type: String,
      validator: function validator(value) {
        return ['adoption', 'wildcard'].includes(value) || !value;
      }
    }
  },
  data: function data() {
    return {
      products: null,
      settings: {
        "infinite": true,
        "slidesToShow": 4,
        "responsive": [{
          "breakpoint": 1024,
          "settings": {
            "slidesToShow": 3,
            "arrows": false
          }
        }, {
          "breakpoint": 600,
          "settings": {
            "slidesToShow": 1,
            "centerMode": true,
            "arrows": false
          }
        }]
      }
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$store.dispatch('getAllEcommerceProducts');

            case 2:
              data = _context.sent;

              if (!(_this.productType == 'adoption')) {
                _context.next = 6;
                break;
              }

              _this.products = data.filter(function (x) {
                return x.type === 'adoption';
              });
              return _context.abrupt('return');

            case 6:
              if (!(_this.productType == 'wildcard')) {
                _context.next = 9;
                break;
              }

              _this.products = data.filter(function (x) {
                return x.type === 'wildcard';
              });
              return _context.abrupt('return');

            case 9:
              _this.products = data;

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slick_carousel__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_slick_carousel__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EcommerceSlider",
  components: {
    VueSlickCarousel: __WEBPACK_IMPORTED_MODULE_0_vue_slick_carousel___default.a
  },

  props: {
    images: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      settings: {
        infinite: true,
        responsive: [{
          breakpoint: 5000,
          settings: "unslick"
        }, {
          breakpoint: 640,
          settings: {
            slidesToShow: 1
          }
        }]
      }
    };
  }
});

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EcommerceFilterCard',
  components: {},
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  methods: {
    redirectTo: function redirectTo(url) {
      window.location.href = url;
    }
  }
});

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EcommerceFilterCategories",

  data: function data() {
    return {
      singleChoice: {
        padding: 0,
        "background-color": "transparent",
        border: 0
      }
    };
  },

  props: {
    categorySelection: {
      type: String,
      default: "multiple",
      validator: function validator(value) {
        return ["multiple", "single"].includes(value);
      }
    },
    productType: {
      type: String
    },
    preSelectedCategories: {
      type: Array
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    isSingle: function isSingle() {
      return this.categorySelection === "single";
    },
    isMultiple: function isMultiple() {
      return this.categorySelection === "multiple";
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])({
    categories: function categories(state) {
      return state.ecommerce.categories;
    },
    selectedProductType: function selectedProductType(state) {
      return state.ecommerce.selectedProductType;
    },
    selectedCategories: function selectedCategories(state) {
      return state.ecommerce.selectedCategories;
    }
  })),

  watch: {
    categories: function categories(newVal, oldVal) {
      this.loadPreSelected();
    },
    selectedProductType: function selectedProductType(newVal, oldVal) {
      this.loadPreSelected();
    }
  },
  created: function created() {
    if (this.categorySelection === "single") {
      if (this.categories[this.productType].length > 0) {
        var firstCategory = this.categories[this.productType][0];
        this.$store.dispatch("updateSelectedCategories", [firstCategory]);
      }
    }
  },

  methods: {
    isSelected: function isSelected(id) {
      return this.selectedCategories.some(function (c) {
        return c.id === id;
      });
    },
    loadPreSelected: function loadPreSelected() {
      var _this = this;

      // Default selection
      if (!!this.preSelectedCategories) {
        var foundCategories = [];

        var _loop = function _loop(c) {
          // Find it in the categories
          var cat = _this.categories[_this.selectedProductType].find(function (e) {
            return e.name === c;
          });

          if (!!cat) {
            foundCategories.push(cat);
          }
        };

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.preSelectedCategories), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var c = _step.value;

            _loop(c);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        var ca = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.selectedCategories), foundCategories);
        this.$store.dispatch("updateSelectedCategories", ca);
      }
    },
    filterMultiple: function filterMultiple(event, category) {
      if (event.target.checked) {
        this.$store.dispatch("updateSelectedCategories", [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.selectedCategories), [category]));
        this.$store.dispatch("logProductFilter", category.name);
      } else {
        this.$store.dispatch("updateSelectedCategories", this.selectedCategories.filter(function (c) {
          return c.id !== category.id;
        }));
      }
    },
    filterSingle: function filterSingle(category) {
      this.$store.dispatch("updateSelectedCategories", [category]);
      this.$store.dispatch("logProductFilter", category.name);
    },
    isChecked: function isChecked(category) {
      return this.selectedCategories.some(function (c) {
        return c.id === category.id;
      });
    }
  }
});

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Header__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ResultList__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ResultList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ResultList__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EcommerceFilter",
  components: {
    EcommerceFilterHeader: __WEBPACK_IMPORTED_MODULE_4__Header___default.a,
    EcommerceFilterResultList: __WEBPACK_IMPORTED_MODULE_5__ResultList___default.a
  },
  props: {
    numberOfRows: {
      type: [String, Number],
      default: 2,
      validator: function validator(value) {
        return !isNaN(value);
      }
    },
    numberOfColumns: {
      type: [String, Number],
      default: 4,
      validator: function validator(value) {
        return !isNaN(value);
      }
    },
    checkboxesPosition: {
      // This prop doesn't work with productType != null and categorySelection = 'single'
      type: String,
      default: "right-side",
      validator: function validator(value) {
        return ["right-side", "below"].includes(value);
      }
    },
    categorySelection: {
      type: String,
      default: "multiple",
      validator: function validator(value) {
        return ["multiple", "single"].includes(value);
      }
    },
    productType: {
      type: String,
      validator: function validator(value) {
        return ["adoption", "wildcard"].includes(value) || !value;
      }
    },
    preSelectedCategories: {
      type: Array
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])({
    products: function products(state) {
      return state.ecommerce.ecommerceProducts;
    }
  })),
  data: function data() {
    return {};
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$store.dispatch("getEcommerceProducts");

            case 2:
              if (_this.productType) {
                _this.$store.dispatch("updateSelectedProductType", _this.productType);
              }

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {}
});

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductType_vue__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductType_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ProductType_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Categories_vue__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Categories_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Categories_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EcommerceFilterHeader",
  props: {
    checkboxesPosition: {
      // This prop doesn't work with productType != null and categorySelection = 'single'
      type: String,
      default: "right-side",
      validator: function validator(value) {
        return ["right-side", "below"].includes(value);
      }
    },
    categorySelection: {
      type: String,
      default: "multiple",
      validator: function validator(value) {
        return ["multiple", "single"].includes(value);
      }
    },
    productType: {
      type: String,
      validator: function validator(value) {
        return ["adoption", "wildcard"].includes(value) || !value;
      }
    },
    preSelectedCategories: {
      type: Array
    }
  },
  data: function data() {
    return {
      showMobileFilter: false
    };
  },

  components: {
    EcommerceFilterProductType: __WEBPACK_IMPORTED_MODULE_0__ProductType_vue___default.a,
    EcommerceFilterCategories: __WEBPACK_IMPORTED_MODULE_1__Categories_vue___default.a
  }
});

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EcommerceFilterProductType',
  components: {},

  props: {
    productType: {
      type: String
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    selectedProductType: function selectedProductType(state) {
      return state.ecommerce.selectedProductType;
    },
    selectedCategories: function selectedCategories(state) {
      return state.ecommerce.selectedCategories;
    }
  })),
  methods: {
    changeTypeTo: function changeTypeTo(value) {
      if (this.selectedProductType !== value) {
        this.$store.dispatch('logProductFilter', value);
        this.$store.dispatch('updateSelectedProductType', value);
        this.$store.dispatch('updateSelectedCategories', []);
        this.$store.dispatch('updateIsSeeingAll', false);
      }
    }
  }
});

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Card__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Card__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EcommerceFilterResultList',
  components: {
    EcommerceFilterCard: __WEBPACK_IMPORTED_MODULE_3__Card___default.a
  },
  props: {
    numberOfRows: {
      type: Number,
      required: true
    },
    numberOfColumns: {
      type: Number,
      required: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])({
    filteredProducts: function filteredProducts(state) {
      return state.ecommerce.filteredProducts;
    },
    isSeeingAll: function isSeeingAll(state) {
      return state.ecommerce.isSeeingAll;
    }
  }), {
    shownFilteredProducts: function shownFilteredProducts() {
      if (this.isSeeingAll) {
        return this.filteredProducts;
      }

      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.filteredProducts)).splice(0, this.numberOfRows * this.numberOfColumns);
    },
    gridConfig: function gridConfig() {
      var templateColumns = new Array(this.numberOfColumns).fill('1fr').join(' ');
      return {
        'grid-template-columns': templateColumns
      };
    }
  })
});

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vee_validate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(2);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "bequest",
  data: function data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      postcode: "",
      address: "",
      enquiryType: "",
      comments: "",
      isSaving: false,
      timeout: null,
      lastTimestamp: Date.now(),
      checkEmailLoading: false,
      emailRegex: /.+\@.+\..+/,
      phoneCheck: {
        timeout: null,
        lastTimestamp: Date.now(),
        checkPhoneLoading: false
      }
    };
  },
  props: {
    enquiryLabel: {
      type: String,
      default: "Which of the following best describes you?"
    },
    enquiryOptions: {
      type: Array,
      default: function _default() {
        return ["I would like a free Will Guide", "I have already left a gift to WWF in my Will", "I am planning to leave a gift in my Will", "I am advising someone else about leaving a Gift in their Will"];
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])({
    user: function user(state) {
      return state.auth.user;
    }
  })),

  created: function created() {
    var _this = this;

    // CHECK EMAIL
    var bequestCheckEmail = function bequestCheckEmail(email) {
      if (email.length > 0 && _this.emailRegex.test(email)) {
        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          var timestamp = Date.now(); // timestamp for this api call
          _this.lastTimestamp = timestamp; // 1 , 2 , 3
          _this.checkEmailLoading = true;
          // Fetch Suggestions
          _this.$store.dispatch("validateEmail", email).then(function (response) {
            if (response && timestamp >= _this.lastTimestamp) {
              _this.checkEmailLoading = false;
              resolve(response);
            }
          }).catch(function (err) {
            console.error(err);
            _this.checkEmailLoading = false;
            // If the call failed, do not keep the user from donating
            resolve({
              valid: true
            });
          });
        });
      } else {
        return {
          valid: false,
          data: { message: "Email invalid" }
        };
      }
    };

    __WEBPACK_IMPORTED_MODULE_5_vee_validate__["b" /* Validator */].extend("bequestCheckEmail", {
      validate: bequestCheckEmail,
      getMessage: function getMessage(field, params, data) {
        return data.message;
      }
    });

    // CHECK PHONE NUMBER
    var bequestCheckPhone = function bequestCheckPhone(phone) {
      if (phone.length > 0) {
        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          var timestamp = Date.now(); // timestamp for this api call
          _this.phoneCheck.lastTimestamp = timestamp; // 1 , 2 , 3
          _this.phoneCheck.checkPhoneLoading = true;
          // Fetch Suggestions
          _this.$store.dispatch("validatePhone", phone).then(function (response) {
            if (response && timestamp >= _this.phoneCheck.lastTimestamp) {
              _this.phoneCheck.checkPhoneLoading = false;
              resolve(response);
            }
          }).catch(function (err) {
            console.error(err);
            _this.phoneCheck.checkPhoneLoading = false;
            // If the call failed, do not keep the user from donating
            resolve({
              valid: true
            });
          });
        });
      } else {
        return {
          valid: false,
          data: { message: "Invalid phone number, try again" }
        };
      }
    };

    __WEBPACK_IMPORTED_MODULE_5_vee_validate__["b" /* Validator */].extend("bequestCheckPhone", {
      validate: bequestCheckPhone,
      getMessage: function getMessage(field, params, data) {
        return data.message;
      }
    });
  },


  methods: {
    save: function save() {
      var _this2 = this;

      // Exit the function if it's busy
      if (this.isSaving) {
        return;
      }

      this.$validator.validateAll().then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(result) {
          var response;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;

                  if (result) {
                    _context.next = 3;
                    break;
                  }

                  return _context.abrupt("return");

                case 3:
                  _this2.isSaving = true;

                  _context.next = 6;
                  return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].http.post(wwfconfigs.WEB_API + "/bequest", {
                    firstName: _this2.firstName,
                    lastName: _this2.lastName,
                    email: _this2.email,
                    postcode: _this2.postcode,
                    phone: _this2.phone,
                    address: _this2.address,
                    enquiryType: _this2.enquiryType,
                    comments: _this2.comments,
                    source: "website-bequest",
                    ssoId: _this2.$store.getters.ssoId,
                    sourceUrl: window.location.href
                  });

                case 6:
                  response = _context.sent;


                  _this2.isSaving = false;

                  // Redirect to thank you page
                  window.location.href = "/donate/give-in-your-will/gifts-in-will-thank-you";
                  _context.next = 14;
                  break;

                case 11:
                  _context.prev = 11;
                  _context.t0 = _context["catch"](0);

                  console.error(_context.t0);

                case 14:

                  // Reset form
                  _this2.firstName = "";
                  _this2.lastName = "";
                  _this2.email = "";
                  _this2.postcode = "";
                  _this2.phone = "";
                  _this2.address = "";
                  _this2.enquiryType = "";
                  _this2.comments = "";

                  _this2.isSaving = false;

                case 23:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, _this2, [[0, 11]]);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
});

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vee_validate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_count_to__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_count_to___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_count_to__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Progressbar_vue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Progressbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Progressbar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_LastSignatures__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_LastSignatures___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__utils_LastSignatures__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers__ = __webpack_require__(7);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var _require = __webpack_require__(22),
    detect = _require.detect;

var browser = detect();

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "edo-form",
  components: {
    countTo: __WEBPACK_IMPORTED_MODULE_7_vue_count_to___default.a,
    progressbar: __WEBPACK_IMPORTED_MODULE_8__Progressbar_vue___default.a,
    lastSignatures: __WEBPACK_IMPORTED_MODULE_10__utils_LastSignatures___default.a
  },
  data: function data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      startcounter: 0,
      currentCounter: 0,
      error: false,
      isShake: false,
      timeout: null,
      acceptToUseMessage: false,
      isSaving: false,
      emailCheckSensis: {
        timeout: null,
        lastTimestamp: Date.now(),
        checkEmailLoading: false,
        emailRegex: /.+\@.+\..+/
      },
      leadKeepData: true,
      subscriptions: [],
      privacyPolicy: "wwf",
      progress: 0,
      curr: 100,

      formTouched: false
    };
  },
  props: {
    // Header
    intro: {
      type: String
    },
    counterLimit: {
      type: Number,
      default: 10000
    },
    counterTitle: {
      type: String,
      default: "submitions"
    },
    isActive: {
      //:is-active="false"
      type: Boolean,
      required: true
    },
    closingmessage: {
      //closingmessage="Test the compatition has closed."
      type: String,
      default: "This petition has now closed."
    },
    datalayerName: {
      type: String,
      required: true,
      default: "edo"
    },

    // Lead (Marketo, IVE, ...)
    programName: {
      type: String,
      required: true
    },
    nationBuilderTag: {
      type: String,
      default: "unburntsix-petition"
    },
    sendToIve: {
      type: Boolean,
      default: true
    },
    iveSupplier: {
      type: String,
      default: "WWF-Aus-unburnt-six-phone-mandatory"
    },
    iveSource: {
      type: String,
      default: "EDO"
    },

    // Hide or show fields
    showHeader: {
      type: Boolean,
      default: true
    },
    showCounter: {
      type: Boolean,
      default: false
    },
    showViewLetter: {
      type: Boolean,
      default: true
    },

    // Content
    submitButtonText: {
      type: String,
      default: "SIGN ME UP"
    },
    concentUseMessage: {
      type: String,
      default: "I accept that my message can be used"
    },
    viewLetterText: {
      type: String,
      default: "VIEW THE MESSAGE"
    },

    // Letter content
    letterTitle: {
      type: String,
      required: false
    },
    letterMessage: {
      type: String,
      required: false
    },

    // Thank you content
    wwfThankYouTitle: {
      type: String,
      default: "Thanks for protecting the unburnt six!"
    },
    wwfThankYouMessage: {
      type: String,
      default: "Defending these precious habitats is crucial in the fight against extinction. Your voice is vital to ensuring they are protected."
    },
    maxFileSize: {
      type: Number,
      default: 40
    },

    numberOfSignatures: {
      type: Number,
      default: 3
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapState */])({
    lead: function lead(state) {
      return state.campaign.edo;
    },
    user: function user(state) {
      return state.auth.user;
    }
  }), {
    isFromEDO: function isFromEDO() {
      return this.privacyPolicy === "edo";
    }
  }),
  created: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _this = this;

      var edoEmailIsValid, edoPhoneNumberIsValid, o, cnt, updateHeaderInterval, ele;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = this.subscriptions;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_5_firebase__["a" /* default */].firestore().collection("campaigns").doc(this.datalayerName).onSnapshot(function (snapshot) {
                _this.currentCounter = snapshot.data().count;
                _this.$refs.counter.count(_this.currentCounter);
              }, function (error) {
                console.error(err);
              });

            case 3:
              _context.t1 = _context.sent;

              _context.t0.push.call(_context.t0, _context.t1);

              // Check the email
              edoEmailIsValid = function edoEmailIsValid(email) {
                return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([_this.checkEmailDuplicate(), _this.checkEmail()]).then(function (results) {
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                      for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(results), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var r = _step.value;

                        if (!r.valid) {
                          return resolve(r);
                        }
                      }
                    } catch (err) {
                      _didIteratorError = true;
                      _iteratorError = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                          _iterator.return();
                        }
                      } finally {
                        if (_didIteratorError) {
                          throw _iteratorError;
                        }
                      }
                    }

                    _this.errors.remove("email");
                    resolve({ valid: true });
                  }).catch(function (err) {
                    console.error(err);
                    _this.errors.remove("email");
                    resolve({ valid: true });
                  });
                });
              };

              __WEBPACK_IMPORTED_MODULE_6_vee_validate__["b" /* Validator */].extend("edoEmailIsValid", {
                validate: edoEmailIsValid,
                getMessage: function getMessage(field, params, data) {
                  return data.message;
                }
              });

              // Check Phone Number

              edoPhoneNumberIsValid = function edoPhoneNumberIsValid(phoneNumber) {
                var validationRegex = /^(\+?61|0)([0-9]{8,9})/;
                if (!phoneNumber.replace(/ /g, "").match(validationRegex)) {
                  return {
                    valid: false,
                    data: { message: "Invalid phone number" }
                  };
                } else {
                  return {
                    valid: true
                  };
                }
              };

              __WEBPACK_IMPORTED_MODULE_6_vee_validate__["b" /* Validator */].extend("edoPhoneNumberIsValid", {
                validate: edoPhoneNumberIsValid,
                getMessage: function getMessage(field, params, data) {
                  return data.message;
                }
              });

              // Read query params to define the right privacy policy
              o = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__helpers__["d" /* getParameterByName */])("o");

              if (o === "edo") {
                this.privacyPolicy = "edo";

                cnt = 0;
                updateHeaderInterval = setInterval(function () {
                  var nav = document.querySelector("nav");

                  if (nav) {
                    nav.classList.add("edo-hide-nav");
                  }

                  var navCenter = document.querySelector(".desktop-menu ul.hmenu");
                  if (navCenter && navCenter.style.display !== "none") {
                    navCenter.style.display = "none";
                  }

                  // Hide the navigation
                  var navBackground = document.querySelector(".desktop-menu ul.hmenu.right");
                  if (navBackground) {
                    navBackground.style.display = "none";
                  }

                  if (navCenter.style.display === "none" && navBackground.style.display === "none" && nav.classList.contains("edo-hide-nav") || ++cnt >= 50) {
                    clearInterval(updateHeaderInterval);
                  }
                }, 200);
                ele = document.querySelector("nav");


                ele = document.querySelector(".user-bttns");
                if (ele) {
                  ele.style.display = "none";
                }

                ele = document.querySelector(".open-menu-ub");
                if (ele) {
                  ele.style.display = "none";
                }

                ele = document.querySelector(".c-hamburger");
                if (ele) {
                  ele.style.display = "none";
                }

                ele = document.querySelector(".mob-mbar");
                if (ele) {
                  ele.style.background = "transparent";
                  ele.style.top = "-40px";
                }
              }

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _ref.apply(this, arguments);
    }

    return created;
  }(),
  mounted: function mounted() {
    var _this2 = this;

    if (this.showCounter && this.$refs.counter) {
      this.$refs.counter.start();
    }

    // Fetch the content of the messages
    if (this.letterMessage) {
      this.$store.dispatch("getContentMessageById", this.letterMessage).then(function (value) {
        if (value) {
          _this2.letterContent = value.content;
        } else {
          _this2.letterContent = "";
        }
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    // Unsubscript from all subscriptions
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.subscriptions), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var s = _step2.value;

        s();
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  },
  methods: {
    updatePercentage: function updatePercentage(val) {
      var curr = Math.abs(val);

      if (curr === this.curr) {
        return;
      }

      this.curr = curr;
      var percent = val / this.counterLimit * 100;
      if (percent > 100) {
        percent = 100;
      }
      this.progress = percent;
    },

    onEmailInput: function onEmailInput() {
      var _this3 = this;

      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }

      // Only call if not input for 500 ms
      this.timeout = setTimeout(function () {
        _this3.checkEmailDuplicate().then(function (result) {
          if (!result.valid) {
            _this3.errors.add({
              field: "email",
              msg: "Your email has already been submitted"
            });
          }
        }).catch(function (err) {
          // If it fails, let the user free to continue
          console.log(err);
        });
      }, 500);
    },
    checkEmailDuplicate: function checkEmailDuplicate() {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this4.$store.dispatch("checkEmail", {
          campaignId: _this4.datalayerName,
          email: _this4.email
        }).then(function (result) {
          if (result) {
            resolve({
              valid: false,
              field: "email",
              data: { message: "Your email has already been submitted" }
            });
          } else {
            resolve({ valid: true });
          }
        });
      });
    },
    checkEmail: function checkEmail() {
      var _this5 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var timestamp = Date.now(); // timestamp for this api call
        _this5.emailCheckSensis.lastTimestamp = timestamp; // 1 , 2 , 3
        _this5.emailCheckSensis.checkEmailLoading = true;
        // Fetch Suggestions
        _this5.$store.dispatch("validateEmail", _this5.email).then(function (response) {
          if (response && timestamp >= _this5.emailCheckSensis.lastTimestamp) {
            _this5.emailCheckSensis.checkEmailLoading = false;
            resolve(response);
          }
        }).catch(function (err) {
          console.error(err);
          _this5.emailCheckSensis.checkEmailLoading = false;
          // If it fails, let the user free to continue
          resolve({ valid: true });
        });
      });
    },
    openReadLetterPage: function openReadLetterPage() {
      this.$store.commit("setPopupContent", {
        title: this.letterTitle,
        message: this.letterContent,
        shareButton: false,
        recommendedReading: false,
        component: null,
        componentparams: null
      });
      this.$store.commit("openPetitionMessagePopup", true);
    },
    save: function save() {
      var _this6 = this;

      // Exit the function if it's busy
      if (this.isSaving) {
        return;
      }
      this.isSaving = true;

      var postBody = {
        email: this.email,
        firstName: this.firstName,
        lastName: this.lastName,
        postcode: this.lead.postcode,
        message: this.lead.message,
        phone: this.phoneNumber,
        programName: this.programName,
        acceptToUseMessage: this.acceptToUseMessage,
        cookieID: this.$cookie.get("_mkto_trk"),
        keepData: this.leadKeepData,
        nationBuilderTag: this.nationBuilderTag,
        sendToIve: this.sendToIve,
        iveSupplier: this.iveSupplier,
        iveSource: this.iveSource,
        isFromEDO: this.isFromEDO,
        origin: this.privacyPolicy,
        ssoId: this.$store.getters.ssoId,
        sourceUrl: window.location.href
      };

      if (browser) {
        postBody.browsername = browser.name;
        postBody.browserversion = browser.version;
        postBody.browseros = browser.os;
      }

      console.log(postBody);

      this.$validator.validate().then(function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(result) {
          var results, inError, isPure;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!result) {
                    _context2.next = 9;
                    break;
                  }

                  _context2.next = 3;
                  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([_this6.$store.dispatch("purifyText", _this6.firstName), _this6.$store.dispatch("purifyText", _this6.lastName), _this6.$store.dispatch("purifyText", _this6.lead.message)]);

                case 3:
                  results = _context2.sent;
                  inError = results.filter(function (e) {
                    return e === false;
                  });
                  isPure = inError.length === 0;


                  if (isPure) {
                    _this6.saveLead(postBody);

                    // Log step to Amplitude
                    _this6.$store.dispatch("logPetitionSupporter", {
                      id: postBody.programName,
                      postcode: postBody.postcode
                    });
                  } else {
                    _this6.formInvalid();
                  }
                  _context2.next = 10;
                  break;

                case 9:
                  _this6.formInvalid();

                case 10:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, _this6);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    formInvalid: function formInvalid() {
      console.log("form invalid");
      // GTM Tracking
      if (window.dataLayer != undefined) {
        window.dataLayer.push({
          formName: this.datalayerName,
          event: "formSubmitEvent"
        });
      }
      this.isSaving = false;
      this.isShake = true;

      setTimeout(function () {
        this.isShake = false;
      }.bind(this), 500);
    },
    saveLead: function saveLead(postBody) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                data = {
                  campaignId: _this7.datalayerName,
                  lead: postBody,
                  saveSignature: true,
                  isFromEDO: _this7.isFromEDO
                };
                _context3.next = 4;
                return _this7.$http.post(wwfconfigs.WEB_API + "/campaign/edo", data);

              case 4:

                console.log("EDO submit success");

                if (window.dataLayer != undefined) {
                  window.dataLayer.push({
                    formName: _this7.datalayerName,
                    event: "formSubmitSuccessEvent"
                  });
                }

                _this7.lead.firstName = _this7.firstName;
                _this7.lead.lastName = _this7.lastName;
                _this7.lead.email = _this7.email;
                _this7.lead.phoneNumber = _this7.phoneNumber;

                // Reset form
                _this7.firstName = "";
                _this7.lastName = "";
                _this7.email = "";
                _this7.lead.message = "";
                _this7.lead.postcode = "";
                _this7.phoneNumber = "";
                _this7.isSaving = false;
                _this7.acceptToUseMessage = false;

                // Open thank you popup
                _this7.openThankYouPopup();

                // Log registration to Amplitude
                _this7.$store.dispatch("logPetitionComplete", {
                  id: _this7.programName,
                  count: _this7.currentCounter
                });
                _context3.next = 27;
                break;

              case 22:
                _context3.prev = 22;
                _context3.t0 = _context3["catch"](0);

                console.error(_context3.t0);
                console.error("EDO submit failed");
                _this7.isSaving = false;

              case 27:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this7, [[0, 22]]);
      }))();
    },
    openThankYouPopup: function openThankYouPopup() {
      var _this8 = this;

      var stepupId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__helpers__["d" /* getParameterByName */])("stepup");
      // Check query params for step up override
      if (stepupId) {
        this.$store.dispatch("getContentMessageById", stepupId).then(function (response) {
          var title = response.description;
          var content = response.content;

          _this8.$store.commit("setPopupContent", {
            component: "step-up",
            componentparams: {
              id: stepupId,
              title: title,
              content: content
            }
          });

          _this8.$store.commit("openStepUpPopup", true);

          // Log to amplitude
          _this8.$store.dispatch("logStepUp", stepupId);
        }).catch(function (err) {
          console.error(err);
        });
      } else {
        // If no step up, continue with thank you popup
        this.$store.commit("setPopupContent", {
          component: "edo-popup",
          componentparams: {
            layout: this.privacyPolicy,
            wwfThankYouTitle: this.wwfThankYouTitle,
            wwfThankYouMessage: this.wwfThankYouMessage,
            maxFileSize: this.maxFileSize
          },
          showHeader: !this.isFromEDO
        });

        this.$store.commit("openCustomContentPopup", true);
      }
    },
    logFirstTouch: function logFirstTouch(fieldName) {
      if (!this.formTouched) {
        this.$store.dispatch("logPetitionBegin", {
          id: this.programName,
          fieldName: fieldName,
          count: this.currentCounter
        });
        this.formTouched = true;
      }
    }
  }
});

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers__ = __webpack_require__(7);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "edo-popup",

  data: function data() {
    return {
      error: null,
      extensions: [".mp4", ".mkv"],
      fileName: "",
      source: null,
      sourceType: null,
      file: null,
      fileContent: null,
      fileKey: null,
      uploading: false,
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      layout: "wwf"
    };
  },

  props: {

    // EDO Content
    edoDonateUrl: {
      type: String,
      default: "https://www.edo.org.au/unburntsix-nextstep"
    },

    // WWF Content
    wwfThankYouTitle: {
      type: String,
      default: "Thanks for protecting the unburnt six!"
    },
    wwfThankYouMessage: {
      type: String,
      default: "Defending these precious habitats is crucial in the fight against extinction. Your voice is vital to ensuring they are protected."
    },
    maxFileSize: {
      type: Number,
      default: 15
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    isClean: function isClean() {
      return this.file === null;
    },
    hasError: function hasError() {
      return this.error != null && this.error.length > 0;
    },
    isUploading: function isUploading() {
      return this.uploading;
    },
    maxSize: function maxSize() {
      return this.maxFileSize * 1000000;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])({
    product: function product(state) {
      return state.product.product;
    },
    lead: function lead(state) {
      return state.campaign.edo;
    },
    leadFirstName: function leadFirstName(state) {
      return state.campaign.edo.firstName;
    },
    leadLastName: function leadLastName(state) {
      return state.campaign.edo.lastName;
    },
    leadEmail: function leadEmail(state) {
      return state.campaign.edo.email;
    },
    leadPhoneNumber: function leadPhoneNumber(state) {
      return state.campaign.edo.phoneNumber;
    }
  })),

  watch: {
    leadFirstName: function leadFirstName(newVal, oldVal) {
      if (newVal && newVal.length > 0) {
        this.firstName = newVal;
      }
    },
    leadLastName: function leadLastName(newVal, oldVal) {
      if (newVal && newVal.length > 0) {
        this.lastName = newVal;
      }
    },
    leadEmail: function leadEmail(newVal, oldVal) {
      if (newVal && newVal.length > 0) {
        this.email = newVal;
      }
    },
    leadPhoneNumber: function leadPhoneNumber(newVal, oldVal) {
      if (newVal && newVal.length > 0) {
        this.phoneNumber = newVal;
      }
    }
  },

  created: function created() {
    var queryParamLayout = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers__["d" /* getParameterByName */])("o");
    if (queryParamLayout === "edo") {
      this.layout = "edo";
    }

    this.firstName = this.leadFirstName;
    this.lastName = this.leadLastName;
    this.email = this.leadEmail;
    this.phoneNumber = this.leadPhoneNumber;
  },

  methods: {
    filesChange: function filesChange(fileList) {
      try {
        if (!fileList.length) return;
        var file = fileList[0];

        if (file.size <= this.maxSize) {
          // Check extension of the file
          var dotIndex = file.name.lastIndexOf(".");

          if (dotIndex < 0) {
            this.error = "File name is missing extension";
            return;
          }

          var extension = file.name.substring(dotIndex).toLowerCase();
          if (!this.extensions.includes(extension)) {
            this.error = "Please use only these formats: " + this.extensions.join(", ");
            return;
          }

          this.file = file;
          this.fileName = file.name;
          this.error = null;

          // This key will force Vue.js to update the video component
          // Otherwise, only the source is changed and it doesn't trigger
          // The update of the video component
          this.fileKey = new Date().getTime();

          // Allow to preview
          this.sourceType = file.type;
          this.source = URL.createObjectURL(file);
        } else {
          this.error = "File too big!";
        }
      } catch (err) {
        this.error = "Cannot read the file, please try another one.";
      }
    },
    clearVideo: function clearVideo() {
      this.$refs.videoInput.value = "";
      this.fileName = "";
      this.source = null;
      this.sourceType = null;
      this.file = null;
      this.fileKey = null;
    },
    uploadVideo: function uploadVideo() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var formData, url, meta;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                console.log("Upload");

                if (!_this.file) {
                  _context.next = 13;
                  break;
                }

                _this.uploading = true;

                // Upload the logo
                formData = new FormData();

                formData.append("edo-video", _this.file, _this.fileName);
                _context.next = 8;
                return _this.$store.dispatch("uploadEDOVideo", formData);

              case 8:
                url = _context.sent;


                // Save the meta data to be reviewed
                meta = {
                  campaignId: "edo",
                  uploadDate: new Date().toISOString(),
                  email: _this.email,
                  phoneNumber: _this.phoneNumber,
                  firstName: _this.firstName,
                  lastName: _this.lastName,
                  url: url,
                  mimeType: _this.sourceType,
                  fileName: _this.fileName
                };
                _context.next = 12;
                return _this.$store.dispatch("createFile", meta);

              case 12:

                // Clear the input
                _this.clearVideo();

              case 13:
                _context.next = 18;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](0);

                console.error(_context.t0);

              case 18:
                _context.prev = 18;

                _this.uploading = false;
                return _context.finish(18);

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 15, 18, 21]]);
      }))();
    }
  }
});

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "edo-video-upload",

  data: function data() {
    return {
      error: null,
      extensions: [".mp4", ".mkv", ".png", ".jpg", ".jpeg", ".gif"],
      fileName: "",
      source: null,
      sourceType: null,
      file: null,
      fileContent: null,
      fileKey: null,
      uploading: false,
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      isSuccessful: false
    };
  },

  props: {
    title: {
      type: String,
      default: "Help us make a bigger impact"
    },
    content: {
      type: String,
      default: '<p>&nbsp;</p><p class="text-center">Take a photo, create an artwork or film a short video explaining why you&rsquo;re raising your voice for our unburnt forests.</p>'
    },
    maxFileSize: {
      type: Number,
      default: 80
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    isClean: function isClean() {
      return this.file === null;
    },
    hasError: function hasError() {
      return this.error != null && this.error.length > 0;
    },
    isUploading: function isUploading() {
      return this.uploading;
    },
    maxSize: function maxSize() {
      return this.maxFileSize * 1000000;
    },
    isImage: function isImage() {
      return !!this.sourceType && this.sourceType.includes("image");
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])({
    product: function product(state) {
      return state.product.product;
    },
    lead: function lead(state) {
      return state.campaign.edo;
    },
    leadFirstName: function leadFirstName(state) {
      return state.campaign.edo.firstName;
    },
    leadLastName: function leadLastName(state) {
      return state.campaign.edo.lastName;
    },
    leadEmail: function leadEmail(state) {
      return state.campaign.edo.email;
    },
    leadPhoneNumber: function leadPhoneNumber(state) {
      return state.campaign.edo.phoneNumber;
    }
  })),

  watch: {
    leadFirstName: function leadFirstName(newVal, oldVal) {
      if (newVal && newVal.length > 0) {
        this.firstName = newVal;
      }
    },
    leadLastName: function leadLastName(newVal, oldVal) {
      if (newVal && newVal.length > 0) {
        this.lastName = newVal;
      }
    },
    leadEmail: function leadEmail(newVal, oldVal) {
      if (newVal && newVal.length > 0) {
        this.email = newVal;
      }
    },
    leadPhoneNumber: function leadPhoneNumber(newVal, oldVal) {
      if (newVal && newVal.length > 0) {
        this.phoneNumber = newVal;
      }
    }
  },

  created: function created() {
    this.firstName = this.leadFirstName;
    this.lastName = this.leadLastName;
    this.email = this.leadEmail;
    this.phoneNumber = this.leadPhoneNumber;
  },

  methods: {
    filesChange: function filesChange(fileList) {
      var _this = this;

      try {
        if (!fileList.length) return;
        var file = fileList[0];

        if (file.size <= this.maxSize) {
          // Check extension of the file
          var dotIndex = file.name.lastIndexOf(".");

          if (dotIndex < 0) {
            this.error = "File name is missing extension";
            return;
          }

          var extension = file.name.substring(dotIndex).toLowerCase();
          if (!this.extensions.includes(extension)) {
            this.error = "Please use only these formats: " + this.extensions.join(", ");
            return;
          }

          this.file = file;
          this.fileName = file.name;
          this.error = null;

          this.sourceType = file.type;

          if (!this.isImage) {
            // This key will force Vue.js to update the video component
            // Otherwise, only the source is changed and it doesn't trigger
            // The update of the video component
            this.fileKey = new Date().getTime();

            // Allow to preview
            this.source = URL.createObjectURL(file);
          }

          if (this.isImage) {
            // Allow to preview
            var reader = new FileReader();
            reader.onload = function (e) {
              _this.source = e.target.result;
            };
            reader.readAsDataURL(file); // convert to base64 string
          }
        } else {
          this.error = "File too big!";
        }
      } catch (err) {
        this.error = "Cannot read the file, please try another one.";
      }
    },
    clearVideo: function clearVideo() {
      this.$refs.videoInput.value = "";
      this.fileName = "";
      this.source = null;
      this.sourceType = null;
      this.file = null;
      this.fileKey = null;
    },
    uploadVideo: function uploadVideo() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var formData, url, meta;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                console.log("Upload");

                if (!_this2.file) {
                  _context.next = 14;
                  break;
                }

                _this2.uploading = true;

                // Upload the logo
                formData = new FormData();

                formData.append("edo-video", _this2.file, _this2.fileName);
                _context.next = 8;
                return _this2.$store.dispatch("uploadEDOVideo", formData);

              case 8:
                url = _context.sent;


                // Save the meta data to be reviewed
                meta = {
                  campaignId: "edo",
                  uploadDate: new Date().toISOString(),
                  email: _this2.email,
                  phoneNumber: _this2.phoneNumber,
                  firstName: _this2.firstName,
                  lastName: _this2.lastName,
                  url: url,
                  mimeType: _this2.sourceType,
                  fileName: _this2.fileName
                };
                _context.next = 12;
                return _this2.$store.dispatch("createFile", meta);

              case 12:

                // Clear the input
                _this2.clearVideo();

                _this2.isSuccessful = true;

              case 14:
                _context.next = 19;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](0);

                console.error(_context.t0);

              case 19:
                _context.prev = 19;

                _this2.uploading = false;

                setTimeout(function () {
                  _this2.isSuccessful = false;
                }, 20000);
                return _context.finish(19);

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 16, 19, 23]]);
      }))();
    }
  }
});

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "GatheredHerePopup",

  data: function data() {
    return {
      email: null,
      isSubmitting: false,
      isInvalid: false
    };
  },

  props: {
    image: {
      type: String,
      default: "https://wwf-staging.wwf.org.au/ecThemes/3/Images/snow-leopard-sm.jpg"
    },
    credit: {
      type: String,
      default: "© Connie Nicolas Photography / WWF-Aus"
    },
    redirectUrl: {
      type: String,
      default: "https://wills.gatheredhere.com.au/c/wwf"
    },
    privacyPolicyUrl: {
      type: String,
      default: "https://www.wwf.org.au/privacy-policy"
    },
    showGraphic: {
      type: Boolean,
      default: true
    },
    ghLogo: {
      type: String,
      default: "https://wwf-staging.wwf.org.au/ecThemes/3/Images/gatheredhere-logo.jpg"
    }
  },

  methods: {
    submit: function submit() {
      var _this = this;

      // Email registration is optional, just redirect if field left blank
      if (!this.email) {
        window.location.href = this.redirectUrl;
        return;
      }

      this.isSubmitting = true;
      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this.$http.post(wwfconfigs.WEB_API + "/bequest", {
            email: _this.email,
            source: "GH pop-up"
          }).then(function (response) {
            window.location.href = _this.redirectUrl;
          }).catch(function (err) {
            _this.isInvalid = true;
            _this.isSubmitting = false;
            console.error(err);
          });
        } else {
          _this.isInvalid = true;
          _this.isSubmitting = false;
        }
      });
    }
  }
});

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vee_validate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var _require = __webpack_require__(22),
    detect = _require.detect;

var browser = detect();

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "my-partnershipsForm",
  props: {
    datalayername: {
      //datalayername="Test datalayer name"
      type: String,
      required: true
    },
    productIds: {
      // Attribute for the productID
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    title: {
      type: String,
      default: "Want to learn how we can work together? Get in touch with us today."
    },
    showEnquiry: {
      type: Boolean,
      default: true
    },
    showOptin: {
      type: Boolean,
      default: true
    },
    inlineThankyou: {
      type: Boolean,
      default: false
    },
    thankyouMessage: {
      type: String,
      default: "Thank you for your message. A team member will be in touch shortly."
    },
    messagePlaceholder: {
      type: String,
      default: "Message"
    }
  },
  data: function data() {
    return {
      name: '',
      email: '',
      phone: '',
      organisation: '',
      enquiry: '',
      message: '',
      optin: false,
      largeProject: false,
      error: false,
      isProfanity: false,
      isShake: false,
      emailCheck: {
        timeout: null,
        lastTimestamp: Date.now(),
        checkEmailLoading: false,
        emailRegex: /.+\@.+\..+/
      },
      showThankyou: false
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    titleText: function titleText() {
      if (this.showThankyou) {
        return this.thankyouMessage;
      }
      return this.title;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])({
    user: function user(state) {
      return state.auth.user;
    }
  })),

  created: function created() {
    var _this = this;

    // CHECK EMAIL
    var partnershipCheckEmail = function partnershipCheckEmail(email) {
      if (email.length > 0 && _this.emailCheck.emailRegex.test(email)) {
        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          var timestamp = Date.now(); // timestamp for this api call
          _this.emailCheck.lastTimestamp = timestamp; // 1 , 2 , 3
          _this.emailCheck.checkEmailLoading = true;
          // Fetch Suggestions
          _this.$store.dispatch("validateEmail", email).then(function (response) {
            if (response && timestamp >= _this.emailCheck.lastTimestamp) {
              _this.emailCheck.checkEmailLoading = false;
              resolve(response);
            }
          }).catch(function (err) {
            console.error(err);
            _this.emailCheck.checkEmailLoading = false;
            // If the call failed, do not keep the user from donating
            resolve({
              valid: true
            });
          });
        });
      } else {
        return {
          valid: false,
          data: { message: "Email invalid" }
        };
      }
    };

    __WEBPACK_IMPORTED_MODULE_4_vee_validate__["b" /* Validator */].extend("partnershipCheckEmail", {
      validate: partnershipCheckEmail,
      getMessage: function getMessage(field, params, data) {
        return data.message;
      }
    });
  },


  methods: {
    save: function save() {
      var _this2 = this;

      var postBody = {
        name: this.name,
        email: this.email,
        phone: this.phone,
        organisation: this.organisation,
        enquiry: this.enquiry,
        message: this.message ? this.message : "",
        optin: this.optin,
        largeProject: this.largeProject,
        ssoId: this.$store.getters.ssoId,
        type: this.datalayername,
        sourceUrl: window.location.href
      };

      if (browser) {
        postBody.browsername = browser.name;
        postBody.browserversion = browser.version;
        postBody.browseros = browser.os;
      }

      console.log(postBody);

      this.$validator.validate().then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(result) {
          var isPure;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!result) {
                    _context.next = 8;
                    break;
                  }

                  _context.next = 3;
                  return _this2.$store.dispatch("purifyText", postBody.message);

                case 3:
                  isPure = _context.sent;

                  _this2.isProfanity = !isPure;
                  if (isPure) {
                    _this2.saveLead(postBody);
                  }
                  _context.next = 12;
                  break;

                case 8:
                  console.log("form invalid");
                  // GTM Tracking
                  if (window.dataLayer != undefined) {
                    window.dataLayer.push({
                      formName: _this2.datalayername,
                      event: "formSubmitEvent"
                    });
                  }
                  _this2.isShake = true;
                  setTimeout(function () {
                    this.isShake = false;
                  }.bind(_this2), 500);

                case 12:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, _this2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    saveLead: function saveLead(postBody) {
      var _this3 = this;

      console.log('postBody', postBody);
      this.$store.dispatch("savePartnershipForm", { lead: postBody }).then(function (response) {
        console.log("form submit success");

        if (window.dataLayer != undefined) {
          window.dataLayer.push({
            formName: _this3.datalayername,
            event: "formSubmitSuccessEvent"
          });
        }

        //Reset form
        _this3.name = "";
        _this3.email = "";
        _this3.phone = "";
        _this3.organisation = "", _this3.enquiry = "";
        _this3.message = "";
        _this3.optin = false;
        _this3.largeProject = false;
      }).catch(function (err) {
        console.error("form submit failed");
      });

      if (this.inlineThankyou) {
        this.showThankyou = true;
      } else {
        this.$store.commit("setPopupContent", {
          title: this.thankyouMessage,
          message: "",
          shareButton: false,
          recommendedReading: false,
          component: "donate-rg-form",
          componentparams: {
            productIds: this.productIds,
            emailprefill: postBody.email,
            currentpage: true,
            dollarhandleclick: false,
            isDark: false
          }
        });
        this.$store.commit("openPetitionPopup", true);
      }
    }
  }
});

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vee_validate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_count_to__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_count_to___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_count_to__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers__ = __webpack_require__(7);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var _require = __webpack_require__(22),
    detect = _require.detect;

var browser = detect();

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "petition",
  components: {
    countTo: __WEBPACK_IMPORTED_MODULE_5_vue_count_to___default.a
  },
  created: function created() {
    var _this = this;

    // Define some mandatory fields with the query params
    var uri = window.location.search.substring(1);
    if (uri.length > 0) {
      var params = new URLSearchParams(uri);

      // utm_source
      this.utmSourceParam = params.get("utm_source");
      this.isFromRokt = this.utmSourceParam && this.utmSourceParam.includes("rokt") ? true : false;
    }

    // Check if there are some query string in URL to prefill the form, Query from donate widget
    var q = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("q");
    if (q) {
      var decodeq = "?" + window.atob(q);
      console.log("decodeq", decodeq);
      this.firstName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("firstname", decodeq);
      this.lastName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("lastname", decodeq);
      this.email = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("email", decodeq);
      this.postcode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("postcode", decodeq);
      this.phoneNumber = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("phone", decodeq);
    }

    var o = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("o");
    if (o) {
      this.origin = o;
    }

    // Define if we show the counter
    if (this.showCounter) {
      this.$store.dispatch("getCounterByCampaignId", this.datalayerName);
    }

    // Check the email
    var petitionEmailIsValid = function petitionEmailIsValid(email) {
      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([_this.checkEmailDuplicate(), _this.checkEmail()]).then(function (results) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(results), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var r = _step.value;

              if (!r.valid) {
                return resolve(r);
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          _this.errors.remove("email");
          resolve({ valid: true });
        }).catch(function (err) {
          console.error(err);
          _this.errors.remove("email");
          resolve({ valid: true });
        });
      });
    };

    __WEBPACK_IMPORTED_MODULE_4_vee_validate__["b" /* Validator */].extend("petitionEmailIsValid", {
      validate: petitionEmailIsValid,
      getMessage: function getMessage(field, params, data) {
        return data.message;
      }
    });

    // Check Phone Number
    var petitionPhoneNumberIsValid = function petitionPhoneNumberIsValid(phoneNumber) {
      var validationRegex = /^(\+?61|0)([0-9]{8,9})/;
      if (!phoneNumber.replace(/ /g, "").match(validationRegex)) {
        return {
          valid: false,
          data: { message: "Invalid phone number" }
        };
      } else {
        return {
          valid: true
        };
      }
    };

    __WEBPACK_IMPORTED_MODULE_4_vee_validate__["b" /* Validator */].extend("petitionPhoneNumberIsValid", {
      validate: petitionPhoneNumberIsValid,
      getMessage: function getMessage(field, params, data) {
        return data.message;
      }
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.showCounter && this.$refs.counter) {
      this.$refs.counter.start();
    }

    // Fetch the content of the messages
    if (this.letterMessage) {
      this.$store.dispatch("getContentMessageById", this.letterMessage).then(function (value) {
        if (value) {
          _this2.letterContent = value.content;
        } else {
          _this2.letterContent = "";
        }
      });
    }
  },
  computed: {
    endcounter: function endcounter() {
      return this.$store.getters.counter ? this.$store.getters.counter : 0;
    }
  },
  watch: {
    // use the watch to react on the value change.
    endcounter: function endcounter(newValue) {
      if (this.showCounter && this.$refs.counter) {
        this.startcounter = newValue;
        this.$refs.counter.start();
        console.log("endcounter:newValue", newValue);
      }
    }
  },
  props: {
    // Header
    title: {
      type: String,
      required: true
    },
    intro: {
      type: String,
      default: ""
    },
    counterTitle: {
      type: String,
      default: "message sent"
    },

    datalayerName: {
      type: String,
      required: true
    },

    // Letter content
    letterTitle: {
      type: String,
      required: false
    },
    letterMessage: {
      type: String,
      required: false
    },

    // Thank you content
    thankYouTitle: {
      type: String,
      required: true
    },
    thankYouMessage: {
      type: String,
      required: false
    },
    thankYouUrl: {
      type: String,
      required: false
    },

    // Lead (Marketo, IVE, ...)
    programName: {
      type: String,
      required: true
    },
    keepData: {
      type: Boolean,
      default: true
    },
    scheduledLead: {
      type: Boolean,
      default: false
    },
    sendToIve: {
      type: Boolean,
      default: false
    },
    iveSupplier: {
      type: String,
      required: false
    },
    iveSupplierPhoneNotMandatory: {
      type: String,
      required: false
    },
    iveSource: {
      type: String,
      required: false
    },

    // Hide or show fields
    showCounter: {
      type: Boolean,
      default: true
    },
    showMessage: {
      type: Boolean,
      default: false
    },
    showPhoneNumber: {
      type: Boolean,
      default: false
    },
    showCountry: {
      type: Boolean,
      default: false
    },
    showState: {
      type: Boolean,
      default: false
    },
    showPostcode: {
      type: Boolean,
      default: false
    },

    // Mandatory Fields
    isPhoneMandatory: {
      type: Boolean,
      default: true
    },

    // Buttons positions and contents
    signButtonValue: {
      type: String,
      default: "Sign the petition"
    },
    viewMessageButtonValue: {
      type: String,
      default: "View the petition"
    },
    viewMessagePosition: {
      type: String,
      default: "bottom"
    },

    colorThemes: {
      type: String,
      default: null
    },
    donateURL: {
      type: String,
      default: "https://donate.wwf.org.au/donate/one-off-donation/one-off-donation"
    }
  },
  data: function data() {
    return {
      utmSourceParam: "",
      startcounter: 0,
      firstName: "",
      lastName: "",
      email: "",
      postcode: "",
      phoneNumber: "",
      state: "",
      country: "Australia",
      message: "",
      isPure: true,
      isShake: false,
      countriesList: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["g" /* getCountriesList */])(),
      letterContent: null,
      timeout: null,
      isSaving: false,
      isFromRokt: false,
      origin: null,
      emailCheckSensis: {
        timeout: null,
        lastTimestamp: Date.now(),
        checkEmailLoading: false,
        emailRegex: /.+\@.+\..+/
      },

      formTouched: false
    };
  },
  methods: {
    onEmailInput: function onEmailInput() {
      var _this3 = this;

      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }

      // Only call if not input for 500 ms
      this.timeout = setTimeout(function () {
        _this3.checkEmailDuplicate().then(function (result) {
          if (!result.valid) {
            _this3.errors.add({
              field: "email",
              msg: "Your email has already been submitted"
            });
          }
        }).catch(function (err) {
          // If it fails, let the user free to continue
          console.log(err);
        });
      }, 500);
    },
    checkEmailDuplicate: function checkEmailDuplicate() {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this4.$store.dispatch("checkEmail", {
          campaignId: _this4.datalayerName,
          email: _this4.email
        }).then(function (result) {
          if (result) {
            resolve({
              valid: false,
              field: "email",
              data: { message: "Your email has already been submitted" }
            });
          } else {
            resolve({ valid: true });
          }
        });
      });
    },
    checkEmail: function checkEmail() {
      var _this5 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var timestamp = Date.now(); // timestamp for this api call
        _this5.emailCheckSensis.lastTimestamp = timestamp; // 1 , 2 , 3
        _this5.emailCheckSensis.checkEmailLoading = true;
        // Fetch Suggestions
        _this5.$store.dispatch("validateEmail", _this5.email).then(function (response) {
          if (response && timestamp >= _this5.emailCheckSensis.lastTimestamp) {
            _this5.emailCheckSensis.checkEmailLoading = false;
            resolve(response);
          }
        }).catch(function (err) {
          console.error(err);
          _this5.emailCheckSensis.checkEmailLoading = false;
          // If it fails, let the user free to continue
          resolve({ valid: true });
        });
      });
    },
    updatePercentage: function updatePercentage(e, t) {
      this.percentage = e * 100 / this.limit;
    },
    openReadLetterPage: function openReadLetterPage() {
      this.$store.commit("setPopupContent", {
        title: this.letterTitle,
        message: this.letterContent,
        shareButton: false,
        recommendedReading: false,
        component: null,
        componentparams: null
      });
      this.$store.commit("openPetitionMessagePopup", true);
    },
    save: function save() {
      var _this6 = this;

      // Exit the function if it's busy
      if (this.isSaving) {
        return;
      }
      this.isSaving = true;

      // If we have a supplier for the phone not mandatory, use it, otherwise, use the default one
      var iveSupplier = this.isPhoneMandatory ? this.iveSupplier : this.iveSupplierPhoneNotMandatory ? this.iveSupplierPhoneNotMandatory : this.iveSupplier;

      var postBody = {
        email: this.email,
        firstName: this.firstName,
        lastName: this.lastName,
        postcode: !this.hidepostcode ? this.postcode : null,
        programName: this.programName,
        message: this.message ? this.message : "",
        cookieID: this.$cookie.get("_mkto_trk"),
        keepData: this.keepData,
        scheduledLead: this.scheduledLead,
        phone: this.phoneNumber,
        state: this.state,
        country: this.country,
        isFromRokt: this.isFromRokt,
        utmSource: this.utmSourceParam,
        origin: this.origin,
        sendToIve: this.sendToIve,
        iveSupplier: iveSupplier,
        iveSource: this.iveSource,
        ssoId: this.$store.getters.ssoId
      };

      if (browser) {
        postBody.browsername = browser.name;
        postBody.browserversion = browser.version;
        postBody.browseros = browser.os;
      }

      console.log("postBody", postBody);

      this.$validator.validate().then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(result) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!result) {
                    _context.next = 13;
                    break;
                  }

                  if (!(_this6.showMessage && _this6.message && _this6.message.length > 0)) {
                    _context.next = 9;
                    break;
                  }

                  console.log("Purify Message");

                  _context.next = 5;
                  return _this6.$store.dispatch("purifyText", _this6.message);

                case 5:
                  _this6.isPure = _context.sent;


                  if (_this6.isPure) {
                    console.log("Message clean");
                    _this6.saveLead(postBody);

                    // Log step to Amplitude
                    _this6.$store.dispatch("logPetitionSupporter", {
                      id: postBody.programName,
                      postcode: postBody.postcode
                    });
                  } else {
                    console.log("Message not clean");
                    _this6.isSaving = false;
                  }
                  _context.next = 11;
                  break;

                case 9:
                  _this6.saveLead(postBody);

                  // Log step to Amplitude
                  _this6.$store.dispatch("logPetitionSupporter", {
                    id: postBody.programName,
                    postcode: postBody.postcode
                  });

                case 11:
                  _context.next = 18;
                  break;

                case 13:
                  console.log("Form invalid");
                  // GTM Tracking
                  if (window.dataLayer != undefined) {
                    window.dataLayer.push({
                      formName: _this6.datalayerName,
                      event: "formSubmitEvent"
                    });
                  }
                  _this6.isSaving = false;
                  _this6.isShake = true;
                  setTimeout(function () {
                    this.isShake = false;
                  }.bind(_this6), 500);

                case 18:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, _this6);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    saveLead: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(postBody) {
        var query, params;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.$store.dispatch("saveLead", {
                  campaignId: this.datalayerName,
                  lead: postBody
                });

              case 3:

                console.log("Petition - submit success");

                if (window.dataLayer != undefined) {
                  window.dataLayer.push({
                    formName: this.datalayerName,
                    event: "formSubmitSuccessEvent"
                  });
                }

                // Reset form
                this.firstName = "";
                this.lastName = "";
                this.email = "";
                this.postcode = "";
                this.message = "";
                this.phoneNumber = "";
                this.state = "";
                this.country = "Australia";
                this.isSaving = false;

                console.log("Open Thank you popup");

                // Log registration to Amplitude
                this.$store.dispatch("logPetitionComplete", {
                  id: this.programName,
                  count: this.endcounter
                });

                if (this.thankYouUrl) {
                  query = "email=" + this.email + "&firstname=" + this.firstName + "&lastname=" + this.lastName + "&source=" + document.URL;
                  params = "?q=" + window.btoa(query);


                  this.thankYouUrl += params;
                  window.open(this.thankYouUrl, "_self");
                } else {
                  this.$store.commit("setPopupContent", {
                    title: this.thankYouTitle,
                    message: this.thankYouMessage,
                    shareButton: true,
                    recommendedReading: false
                    // component: "donate-rg-form",
                    // componentparams: {
                    //   emailprefill: postBody.email,
                    //   currentpage: true,
                    //   dollarhandleclick: false,
                    // },
                  });
                  this.$store.commit("openPetitionPopup", true);
                }
                _context2.next = 23;
                break;

              case 19:
                _context2.prev = 19;
                _context2.t0 = _context2["catch"](0);

                console.error("Petition submit failed");
                this.isSaving = false;

              case 23:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 19]]);
      }));

      function saveLead(_x2) {
        return _ref2.apply(this, arguments);
      }

      return saveLead;
    }(),
    donateNow: function donateNow() {
      window.open(this.donateURL, "_self");
    },
    logFirstTouch: function logFirstTouch(fieldName) {
      if (!this.formTouched) {
        this.$store.dispatch("logPetitionBegin", {
          id: this.programName,
          fieldName: fieldName,
          count: this.endcounter
        });
        this.formTouched = true;
      }
    }
  }
});

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vee_validate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_count_to__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_count_to___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_count_to__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers__ = __webpack_require__(7);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var _require = __webpack_require__(22),
    detect = _require.detect;

var browser = detect();

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "PetitionBio",
  components: {
    countTo: __WEBPACK_IMPORTED_MODULE_6_vue_count_to___default.a
  },
  created: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _this = this;

      var uri, params, q, decodeq, o, petitionEmailIsValid, petitionPhoneNumberIsValid;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // Define some mandatory fields with the query params
              uri = window.location.search.substring(1);

              if (uri.length > 0) {
                params = new URLSearchParams(uri);

                // utm_source

                this.utmSourceParam = params.get("utm_source");
                this.isFromRokt = this.utmSourceParam && this.utmSourceParam.includes("rokt") ? true : false;
              }

              // Check if there are some query string in URL to prefill the form, Query from donate widget
              q = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers__["d" /* getParameterByName */])("q");

              if (q) {
                decodeq = "?" + window.atob(q);

                console.log("decodeq", decodeq);
                this.firstName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers__["d" /* getParameterByName */])("firstname", decodeq);
                this.lastName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers__["d" /* getParameterByName */])("lastname", decodeq);
                this.email = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers__["d" /* getParameterByName */])("email", decodeq);
                this.postcode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers__["d" /* getParameterByName */])("postcode", decodeq);
                this.phoneNumber = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers__["d" /* getParameterByName */])("phone", decodeq);
              }

              o = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers__["d" /* getParameterByName */])("o");

              if (o) {
                this.origin = o;
              }

              // Define if we show the counter

              if (!this.showCounter) {
                _context.next = 12;
                break;
              }

              _context.t0 = this.subscriptions;
              _context.next = 10;
              return __WEBPACK_IMPORTED_MODULE_4_firebase__["a" /* default */].firestore().collection("campaigns").doc(this.datalayerName).onSnapshot(function (snapshot) {
                _this.currentCounter = snapshot.data().count;
                _this.$refs.counter.count(_this.currentCounter);
              }, function (error) {
                console.error(err);
              });

            case 10:
              _context.t1 = _context.sent;

              _context.t0.push.call(_context.t0, _context.t1);

            case 12:

              // Check the email
              petitionEmailIsValid = function petitionEmailIsValid(email) {
                return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([_this.checkEmailDuplicate(), _this.checkEmail()]).then(function (results) {
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                      for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(results), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var r = _step.value;

                        if (!r.valid) {
                          return resolve(r);
                        }
                      }
                    } catch (err) {
                      _didIteratorError = true;
                      _iteratorError = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                          _iterator.return();
                        }
                      } finally {
                        if (_didIteratorError) {
                          throw _iteratorError;
                        }
                      }
                    }

                    _this.errors.remove("email");
                    resolve({ valid: true });
                  }).catch(function (err) {
                    console.error(err);
                    _this.errors.remove("email");
                    resolve({ valid: true });
                  });
                });
              };

              __WEBPACK_IMPORTED_MODULE_5_vee_validate__["b" /* Validator */].extend("petitionEmailIsValid", {
                validate: petitionEmailIsValid,
                getMessage: function getMessage(field, params, data) {
                  return data.message;
                }
              });

              // Check Phone Number

              petitionPhoneNumberIsValid = function petitionPhoneNumberIsValid(phoneNumber) {
                var validationRegex = /^(\+?61|0)([0-9]{8,9})/;
                if (!phoneNumber.replace(/ /g, "").match(validationRegex)) {
                  return {
                    valid: false,
                    data: { message: "Invalid phone number" }
                  };
                } else {
                  return {
                    valid: true
                  };
                }
              };

              __WEBPACK_IMPORTED_MODULE_5_vee_validate__["b" /* Validator */].extend("petitionPhoneNumberIsValid", {
                validate: petitionPhoneNumberIsValid,
                getMessage: function getMessage(field, params, data) {
                  return data.message;
                }
              });

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _ref.apply(this, arguments);
    }

    return created;
  }(),
  mounted: function mounted() {
    var _this2 = this;

    if (this.showCounter && this.$refs.counter) {
      this.$refs.counter.start();
    }

    // Fetch the content of the messages
    if (this.letterMessage) {
      this.$store.dispatch("getContentMessageById", this.letterMessage).then(function (value) {
        if (value) {
          _this2.letterContent = value.content;
        } else {
          _this2.letterContent = "";
        }
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    // Unsubscript from all subscriptions
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.subscriptions), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var s = _step2.value;

        s();
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  },
  computed: {},
  watch: {},
  props: {
    // Header
    intro: {
      type: String,
      required: false
    },
    counterLimit: {
      type: Number,
      default: 10000
    },
    counterTitle: {
      type: String,
      default: "Australians have sent an urgent message! Add your voice now."
    },

    datalayerName: {
      type: String,
      required: true
    },

    // Letter content
    letterTitle: {
      type: String,
      required: true
    },
    letterMessage: {
      type: String,
      required: false
    },

    // Thank you content
    thankYouTitle: {
      type: String,
      default: "Thank you!"
    },
    thankYouMessage: {
      type: String,
      default: "Thank you for adding your voice!"
    },

    // Lead (Marketo, IVE, ...)
    programName: {
      type: String,
      required: true
    },
    keepData: {
      type: Boolean,
      default: true
    },
    scheduledLead: {
      type: Boolean,
      default: false
    },
    sendToIve: {
      type: Boolean,
      default: false
    },
    iveSupplier: {
      type: String,
      required: false
    },
    iveSupplierPhoneNotMandatory: {
      type: String,
      required: false
    },
    iveSource: {
      type: String,
      required: false
    },

    // Hide or show fields
    showCounter: {
      type: Boolean,
      default: true
    },
    showMessage: {
      type: Boolean,
      default: true
    },
    showPhoneNumber: {
      type: Boolean,
      default: true
    },
    showCountry: {
      type: Boolean,
      default: false
    },
    showState: {
      type: Boolean,
      default: false
    },
    showPostcode: {
      type: Boolean,
      default: true
    },

    // Mandatory Fields
    isPhoneMandatory: {
      type: Boolean,
      default: true
    },

    // Buttons positions and contents
    signButtonValue: {
      type: String,
      default: "Submit"
    },
    viewMessageButtonValue: {
      type: String,
      default: "Here's the message we're sending"
    },
    viewMessagePosition: {
      type: String,
      default: "bottom"
    },

    stepupId: {
      type: String,
      required: false
    }
  },
  data: function data() {
    return {
      utmSourceParam: "",
      startcounter: 0,
      currentCounter: 0,
      firstName: "",
      lastName: "",
      email: "",
      postcode: "",
      phoneNumber: "",
      state: "",
      country: "Australia",
      message: "",
      isPure: true,
      isShake: false,
      countriesList: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers__["g" /* getCountriesList */])(),
      letterContent: null,
      timeout: null,
      isSaving: false,
      isFromRokt: false,
      origin: null,
      emailCheckSensis: {
        timeout: null,
        lastTimestamp: Date.now(),
        checkEmailLoading: false,
        emailRegex: /.+\@.+\..+/
      },
      progress: 0,
      curr: 100,
      subscriptions: [],

      formTouched: false
    };
  },
  methods: {
    onEmailInput: function onEmailInput() {
      var _this3 = this;

      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }

      // Only call if not input for 500 ms
      this.timeout = setTimeout(function () {
        _this3.checkEmailDuplicate().then(function (result) {
          if (!result.valid) {
            _this3.errors.add({
              field: "email",
              msg: "Your email has already been submitted"
            });
          }
        }).catch(function (err) {
          // If it fails, let the user free to continue
          console.log(err);
        });
      }, 500);
    },
    checkEmailDuplicate: function checkEmailDuplicate() {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this4.$store.dispatch("checkEmail", {
          campaignId: _this4.datalayerName,
          email: _this4.email
        }).then(function (result) {
          if (result) {
            resolve({
              valid: false,
              field: "email",
              data: { message: "Your email has already been submitted" }
            });
          } else {
            resolve({ valid: true });
          }
        });
      });
    },
    checkEmail: function checkEmail() {
      var _this5 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var timestamp = Date.now(); // timestamp for this api call
        _this5.emailCheckSensis.lastTimestamp = timestamp; // 1 , 2 , 3
        _this5.emailCheckSensis.checkEmailLoading = true;
        // Fetch Suggestions
        _this5.$store.dispatch("validateEmail", _this5.email).then(function (response) {
          if (response && timestamp >= _this5.emailCheckSensis.lastTimestamp) {
            _this5.emailCheckSensis.checkEmailLoading = false;
            resolve(response);
          }
        }).catch(function (err) {
          console.error(err);
          _this5.emailCheckSensis.checkEmailLoading = false;
          // If it fails, let the user free to continue
          resolve({ valid: true });
        });
      });
    },
    updatePercentage: function updatePercentage(val) {
      var curr = Math.abs(val);

      if (curr === this.curr) {
        return;
      }

      this.curr = curr;
      var percent = val / this.counterLimit * 100;
      if (percent > 100) {
        percent = 100;
      }
      this.progress = percent;
    },

    openReadLetterPage: function openReadLetterPage() {
      this.$store.commit("setPopupContent", {
        title: this.letterTitle,
        message: this.letterContent,
        shareButton: false,
        recommendedReading: false,
        component: null,
        componentparams: null
      });
      this.$store.commit("openPetitionMessagePopup", true);
    },
    save: function save() {
      var _this6 = this;

      // Exit the function if it's busy
      if (this.isSaving) {
        return;
      }
      this.isSaving = true;

      // If we have a supplier for the phone not mandatory, use it, otherwise, use the default one
      var iveSupplier = this.isPhoneMandatory ? this.iveSupplier : this.iveSupplierPhoneNotMandatory ? this.iveSupplierPhoneNotMandatory : this.iveSupplier;

      var postBody = {
        email: this.email,
        firstName: this.firstName,
        lastName: this.lastName,
        postcode: !this.hidepostcode ? this.postcode : null,
        programName: this.programName,
        message: this.message ? this.message : "",
        cookieID: this.$cookie.get("_mkto_trk"),
        keepData: this.keepData,
        scheduledLead: this.scheduledLead,
        phone: this.phoneNumber,
        state: this.state,
        country: this.country,
        isFromRokt: this.isFromRokt,
        utmSource: this.utmSourceParam,
        origin: this.origin,
        sendToIve: this.sendToIve,
        iveSupplier: iveSupplier,
        iveSource: this.iveSource,
        ssoId: this.$store.getters.ssoId
      };

      if (browser) {
        postBody.browsername = browser.name;
        postBody.browserversion = browser.version;
        postBody.browseros = browser.os;
      }

      this.$validator.validate().then(function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(result) {
          var el;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!result) {
                    _context2.next = 13;
                    break;
                  }

                  if (!(_this6.showMessage && _this6.message && _this6.message.length > 0)) {
                    _context2.next = 9;
                    break;
                  }

                  console.log("Purify Message");

                  _context2.next = 5;
                  return _this6.$store.dispatch("purifyText", _this6.message);

                case 5:
                  _this6.isPure = _context2.sent;


                  if (_this6.isPure) {
                    console.log("Message clean");
                    _this6.saveLead(postBody);

                    // Log step to Amplitude
                    _this6.$store.dispatch("logPetitionSupporter", {
                      id: postBody.programName,
                      postcode: postBody.postcode
                    });
                  } else {
                    console.log("Message not clean");
                    _this6.isSaving = false;
                  }
                  _context2.next = 11;
                  break;

                case 9:
                  _this6.saveLead(postBody);

                  // Log step to Amplitude
                  _this6.$store.dispatch("logPetitionSupporter", {
                    id: postBody.programName,
                    postcode: postBody.postcode
                  });

                case 11:
                  _context2.next = 20;
                  break;

                case 13:
                  console.log("Form invalid");
                  // GTM Tracking
                  if (window.dataLayer != undefined) {
                    window.dataLayer.push({
                      formName: _this6.datalayerName,
                      event: "formSubmitEvent"
                    });
                  }
                  _this6.isSaving = false;
                  _this6.isShake = true;

                  el = document.getElementById("form-scroll-to");

                  if (el) {
                    el.scrollIntoView({ behavior: "smooth" });
                  }

                  setTimeout(function () {
                    this.isShake = false;
                  }.bind(_this6), 500);

                case 20:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, _this6);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    saveLead: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(postBody) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return this.$store.dispatch("saveLead", {
                  campaignId: this.datalayerName,
                  lead: postBody
                });

              case 3:

                console.log("Petition - submit success");

                if (window.dataLayer != undefined) {
                  window.dataLayer.push({
                    formName: this.datalayerName,
                    event: "formSubmitSuccessEvent"
                  });
                }

                // Reset form
                this.firstName = "";
                this.lastName = "";
                this.email = "";
                this.postcode = "";
                this.message = "";
                this.phoneNumber = "";
                this.state = "";
                this.country = "Australia";
                this.isSaving = false;

                // Open thank you popup
                this.openThankYouPopup();

                // Log registration to Amplitude
                this.$store.dispatch("logPetitionComplete", {
                  id: this.programName,
                  count: this.currentCounter
                });
                _context3.next = 22;
                break;

              case 18:
                _context3.prev = 18;
                _context3.t0 = _context3["catch"](0);

                console.error("Petition submit failed");
                this.isSaving = false;

              case 22:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 18]]);
      }));

      function saveLead(_x2) {
        return _ref3.apply(this, arguments);
      }

      return saveLead;
    }(),
    openThankYouPopup: function openThankYouPopup() {
      var _this7 = this;

      var stepupId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers__["d" /* getParameterByName */])("stepup") || this.stepupId;
      // Check query params for step up override
      if (stepupId) {
        this.$store.dispatch("getContentMessageById", stepupId).then(function (response) {
          var title = response.description;
          var content = response.content;

          _this7.$store.commit("setPopupContent", {
            component: "step-up",
            componentparams: {
              id: stepupId,
              title: title,
              content: content
            }
          });

          _this7.$store.commit("openStepUpPopup", true);

          // Log to amplitude
          _this7.$store.dispatch("logStepUp", stepupId);
        }).catch(function (err) {
          console.error(err);
        });
      } else {
        // If no step up, continue with thank you popup
        this.$store.commit("setPopupContent", {
          title: this.thankYouTitle,
          message: this.thankYouMessage,
          shareButton: true,
          recommendedReading: false
        });
        this.$store.commit("openPetitionPopup", true);
      }
    },
    logFirstTouch: function logFirstTouch(fieldName) {
      if (!this.formTouched) {
        this.$store.dispatch("logPetitionBegin", {
          id: this.programName,
          fieldName: fieldName,
          count: this.currentCounter
        });
        this.formTouched = true;
      }
    }
  }
});

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "WorkplaceContactUs",

  data: function data() {
    return {
      isShake: false,
      serverErrors: false,
      firstName: "",
      lastName: "",
      emailAddress: "",
      phone: "",
      message: "",
      isLoading: false,
      showThankyou: false
    };
  },

  props: {
    description: {
      type: String,
      default: "Do you have any questions about workplace giving? Contact us and we’ll get back to you."
    },
    thankyouMessage: {
      type: String,
      default: "Thank you for your enquiry. We will be in touch with you very soon."
    },
    subjectLine: {
      type: String,
      default: "Workplace giving for employers"
    }
  },

  methods: {
    postTicket: function postTicket() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          if (!_this.isLoading) {
            _this.isLoading = true;
            // Enquiry will be sent to sek@wwf.org.au
            _this.$http.post(wwfconfigs.WEB_API + "/contact/workplace", {
              subject: _this.subjectLine,
              emailAddress: _this.emailAddress,
              firstName: _this.firstName,
              lastName: _this.lastName,
              phone: _this.phone,
              message: _this.message
            }).then(function (response) {
              _this.resetForm();
              _this.showThankyou = true;
              _this.serverErrors = false;
              _this.isLoading = false;
              console.log(response);
            }).catch(function (err) {
              _this.serverErrors = true;
              _this.isLoading = false;
              console.error(err);
            });
          }
        } else {
          _this.isShake = true;
          setTimeout(function () {
            this.isShake = false;
          }.bind(_this), 500);
        }
      });
    },
    resetForm: function resetForm() {
      this.firstName = "";
      this.lastName = "";
      this.emailAddress = "";
      this.phone = "";
      this.message = "";
    }
  }
});

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slick_carousel__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_slick_carousel__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "RaHubCarousel",
  components: {
    VueSlickCarousel: __WEBPACK_IMPORTED_MODULE_0_vue_slick_carousel___default.a
  },

  props: {
    slides: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      slideIndex: 0,

      settings: {
        "infinite": true,
        "responsive": [{
          "breakpoint": 640,
          "settings": {
            "centerMode": true,
            "arrows": false
          }
        }]
      }
    };
  },


  methods: {
    changeIndex: function changeIndex(slideIndex) {
      this.slideIndex = slideIndex;
    },
    handleClick: function handleClick(url) {
      this.$store.dispatch("logContentLink", url).then(function () {
        return window.location.href = url;
      });
    }
  }
});

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SolutionsButton__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SolutionsButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__SolutionsButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SolutionsContent__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SolutionsContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SolutionsContent__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "RaHubSolutions",
  components: {
    SolutionsButton: __WEBPACK_IMPORTED_MODULE_0__SolutionsButton___default.a,
    SolutionsContent: __WEBPACK_IMPORTED_MODULE_1__SolutionsContent___default.a
  },

  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      selected: 'Koalas Forever'
    };
  },


  methods: {
    setActive: function setActive(name) {
      // Only log to amplitude when value has changed
      if (this.selected !== name) {
        this.$store.dispatch('logTabView', name);
      }
      this.selected = name;
    },
    toggleActive: function toggleActive(name) {
      // Only log to amplitude when value has changed
      if (this.selected !== name) {
        this.$store.dispatch('logTabView', name);
      }
      this.selected !== name ? this.selected = name : this.selected = '';
    }
  }
});

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SolutionsButton",

  props: {
    item: {
      type: Object,
      required: true
    },
    isActive: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      isMobileView: false
    };
  },
  created: function created() {
    // To set click/toggle for collapsable list in mobile view
    var isMatch = window.matchMedia("(min-width: 768px)").matches;

    this.isMobileView = !isMatch;
  },

  methods: {
    setActive: function setActive() {
      this.$emit("setActive");
    },
    toggleActive: function toggleActive() {
      this.$emit("toggleActive");
    }
  }
});

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SolutionsContent",

  props: {
    item: {
      type: Object,
      required: true
    },
    isActive: {
      type: Boolean
    }
  },

  mounted: function mounted() {
    // Attach amplitude event to hyperlinks in copy
    try {
      var contentLink = this.$refs.articles.querySelector(".copy-text a");
      if (contentLink) {
        this.$refs.articles.querySelector(".copy-text a").addEventListener("click", this.handleClick);
      }
    } catch (err) {
      console.error(err);
    }
  },

  methods: {
    handleClick: function handleClick() {
      var _this = this;

      this.$store.dispatch('logTabAction', {
        name: this.item.name,
        link: this.item.readMoreLink
      }).then(function () {
        return window.location.href = _this.item.readMoreLink;
      });
    }
  }
});

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Card",

  computed: {
    daysLeft: function daysLeft() {
      var days = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.product.dueDate).diff(__WEBPACK_IMPORTED_MODULE_0_moment___default()(), "days");
      if (this.goalProgress === 100) return "Achieved!";
      if (days < 1 && this.goalProgress != 100) return "Completed";
      return days + " Days Left";
    },
    goalProgress: function goalProgress() {
      var progress = this.product.currentDonationAmount / this.product.goalAmount * 100;
      return progress <= 100 ? progress : 100;
    }
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    wide: {
      type: Boolean
    }
  },

  methods: {
    formatCurrency: function formatCurrency(num) {
      var currencyStr = num.toFixed(2).toString().replace(".00", "");

      if (num >= 10000) {
        // Format with comma - 10,000, 1,000,000, etc.
        return currencyStr.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      return currencyStr;
    }
  }
});

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__donation_Donate_vue__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__donation_Donate_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__donation_Donate_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ImpactDonateWrapper",
  components: {
    Donate: __WEBPACK_IMPORTED_MODULE_2__donation_Donate_vue___default.a
  },

  props: {
    productId: {
      type: String,
      required: true
    },
    redirectUrl: {
      type: String,
      default: null
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    isAchieved: function isAchieved() {
      var product = this.product;

      if (product && product.meta) {
        return product.meta.currentDonationAmount >= product.meta.goalAmount;
      }
      return false;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    product: function product(state) {
      return state.product.product;
    }
  }))
});

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Card_vue__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Card_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Card_vue__);



//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ImpactProject",
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_3__Card_vue___default.a
  },

  data: function data() {
    return {
      products: null
    };
  },

  props: {
    productIds: {
      type: Array,
      required: true
    }
  },

  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var data, metaProjects;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this.$store.dispatch("getProductsByIds", _this.productIds);

            case 3:
              data = _context.sent;
              metaProjects = [];


              data.forEach(function (product) {
                var meta = product && product.meta;
                if (meta && meta.projectTitle && meta.dueDate && typeof meta.goalAmount === "number") {
                  metaProjects.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, product.meta));
                }
              });

              _this.products = metaProjects;
              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);

              console.error(_context.t0);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 9]]);
    }))();
  }
});

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ImpactProjectHeader",

  props: {
    heading: {
      type: String,
      required: false
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    endDateText: function endDateText() {
      var days = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.product.meta.dueDate).diff(__WEBPACK_IMPORTED_MODULE_1_moment___default()(), "days");

      if (this.goalProgress === 100) return "Achieved!";
      if (days < 1 && this.goalProgress != 100) return "Completed";
      return "CLOSES " + __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.product.meta.dueDate).format("Do MMMM YYYY");
    },

    goalProgress: function goalProgress() {
      var progress = this.product.meta.currentDonationAmount / this.product.meta.goalAmount * 100;
      return progress <= 100 ? progress : 100;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])({
    product: function product(state) {
      return state.product.product;
    }
  })),

  methods: {
    formatCurrency: function formatCurrency(num) {
      var currencyStr = num.toFixed(2).toString().replace(".00", "");

      if (num >= 10000) {
        // Format with spaces - 10 000, 1 000 000, etc.
        return currencyStr.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      return currencyStr;
    }
  }
});

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_slick_carousel__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ImpactProjectMilestones",
  components: {
    VueSlickCarousel: __WEBPACK_IMPORTED_MODULE_2_vue_slick_carousel___default.a
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    milestones: function milestones() {
      return this.product.meta.milestones;
    },
    currentMile: function currentMile() {
      return this.product.meta.currentMilestone;
    },
    settings: function settings() {
      return {
        "infinite": false,
        "responsive": [{
          "breakpoint": 5000,
          "settings": "unslick"
        }, {
          "breakpoint": 1024,
          "settings": {
            "slidesToShow": 3,
            "initialSlide": this.calcStartIndex(3)
          }
        }, {
          "breakpoint": 600,
          "settings": {
            "slidesToShow": 1,
            "initialSlide": this.calcStartIndex(1)
          }
        }]
      };
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])({
    product: function product(state) {
      return state.product.product;
    }
  })),

  methods: {
    calcStartIndex: function calcStartIndex(slidesToShow) {
      // Calculate starting index for carousel so 'current milestone' is in view
      // Make sure there are enough slides to fill the screen
      var mileIndex = this.currentMile - 1;
      var totalSlideCount = this.milestones.length;
      var remainingSlideCount = totalSlideCount - mileIndex;

      if (totalSlideCount < slidesToShow) {
        return 0;
      }
      if (remainingSlideCount < slidesToShow) {
        return totalSlideCount - slidesToShow;
      }
      return mileIndex;
    },
    currentStepText: function currentStepText(mile) {
      var current = this.currentMile;
      var index = mile.index;


      if (index == current) {
        return 'Currently working on';
      }
      if (index < current) {
        return 'GOAL ACHIEVED';
      }
      if (index > current) {
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(mile.deadline).format("DD MMMM YYYY");
      }
    }
  }
});

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Selector__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Selector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Selector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_gtm__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vee_validate__ = __webpack_require__(8);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var _require = __webpack_require__(22),
    detect = _require.detect;

var browser = detect();

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "LeafReliefDetails",
  components: {
    Selector: __WEBPACK_IMPORTED_MODULE_5__Selector___default.a
  },

  data: function data() {
    return {
      isSaving: false,
      timeout: null,
      lastTimestamp: Date.now(),
      emailRegex: /.+\@.+\..+/,
      checkEmailLoading: false,
      isEmailInError: false,
      formTouched: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapGetters */])(["isDonation", "selection"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapState */])({
    supporter: function supporter(state) {
      return state.leafRelief.details;
    },
    donation: function donation(state) {
      return state.donation.donation;
    }
  })),
  props: {
    programName: {
      type: String
    },
    datalayerName: {
      type: String
    },

    // IVE
    sendToIve: {
      type: Boolean
    },
    iveSupplier: {
      type: String
    },
    iveSource: {
      type: String
    },

    // Selectors
    petitionSelector: {
      type: String
    },
    donationSelector: {
      type: String
    },

    petitionHandle: {
      type: String
    },

    duplicateEmailMessage: {
      type: String
    }
  },

  created: function created() {
    var _this = this;

    // If it's a petition, prevent 2 signatures
    // If it's a donation, allow multiple submissions
    var leafReliefCheckEmail = function leafReliefCheckEmail(email) {
      _this.isEmailInError = false;

      if (_this.isDonation) {
        return _this.checkEmail(email);
      } else {
        // Do not allow multiple submission for the petition
        return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([_this.checkEmailDuplicate(email), _this.checkEmail(email)]).then(function (results) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(results), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var r = _step.value;

                if (!r.valid) {
                  _this.isEmailInError = true;
                  return resolve(r);
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            _this.errors.remove("email");
            resolve({ valid: true });
          }).catch(function (err) {
            console.error(err);
            _this.errors.remove("email");
            resolve({ valid: true });
          });
        });
      }
    };

    __WEBPACK_IMPORTED_MODULE_8_vee_validate__["b" /* Validator */].extend("leafReliefCheckEmail", {
      validate: leafReliefCheckEmail,
      getMessage: function getMessage(field, params, data) {
        return data.message;
      }
    });
  },

  methods: {
    checkEmailDuplicate: function checkEmailDuplicate(email) {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this2.$store.dispatch("checkEmail", {
          campaignId: _this2.datalayerName,
          email: email
        }).then(function (result) {
          if (result) {
            resolve({
              valid: false,
              field: "email",
              data: { message: "Your email has already been submitted" }
            });
          } else {
            resolve({ valid: true });
          }
        });
      });
    },
    checkEmail: function checkEmail(email) {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (email.length > 0 && _this3.emailRegex.test(email)) {
          var timestamp = Date.now(); // timestamp for this api call
          _this3.lastTimestamp = timestamp; // 1 , 2 , 3
          _this3.checkEmailLoading = true;
          // Fetch Suggestions
          _this3.$store.dispatch("validateEmail", email).then(function (response) {
            if (response && timestamp >= _this3.lastTimestamp) {
              _this3.checkEmailLoading = false;
              _this3.donation.emailValidation = response;
              resolve(response);
            }
          }).catch(function (err) {
            console.error(err);
            _this3.checkEmailLoading = false;
            // If it fails, let the user free to continue
            resolve({ valid: true });
          });
        } else {
          resolve({
            valid: false,
            data: { message: "Email invalid" }
          });
        }
      });
    },
    next: function next() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this4.logFirstTouch('next');
                _context.prev = 1;

                if (!_this4.isSaving) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                _this4.isSaving = true;

                if (!_this4.isDonation) {
                  _context.next = 13;
                  break;
                }

                _context.next = 8;
                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([_this4.validate(), _this4.$refs.Selector.validate()]);

              case 8:
                _context.next = 10;
                return _this4.saveDonation();

              case 10:
                _this4.$store.dispatch("logLeafProduct", _this4.supporter.postcode);
                _context.next = 19;
                break;

              case 13:
                _context.next = 15;
                return _this4.validate();

              case 15:
                _context.next = 17;
                return _this4.savePetition();

              case 17:
                _this4.$store.dispatch("logLeafProduct", _this4.supporter.postcode);
                _this4.$store.commit("resetLeafRelief");

              case 19:

                _this4.$emit("next");
                _context.next = 26;
                break;

              case 22:
                _context.prev = 22;
                _context.t0 = _context["catch"](1);

                console.error(_context.t0);
                __WEBPACK_IMPORTED_MODULE_6__utils_gtm__["a" /* default */].formSubmitEvent(_this4.datalayerName);

              case 26:
                _context.prev = 26;

                _this4.isSaving = false;
                return _context.finish(26);

              case 29:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this4, [[1, 22, 26, 29]]);
      }))();
    },
    validate: function validate() {
      var _this5 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this5.$validator.validateAll().then(function (result) {
          // Will return true if valid and false if not
          if (result) {
            resolve(result);
          } else {
            console.error("Leaf Relief - Details not valid - result", result);
            reject(result);
          }
        }).catch(function (err) {
          console.error("Leaf Relief - Details - Error - ", err);
          reject(err);
        });
      });
    },
    savePetition: function savePetition() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var payload;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                payload = {
                  email: _this6.supporter.email,
                  firstName: _this6.supporter.firstName,
                  lastName: _this6.supporter.lastName,
                  postcode: _this6.supporter.postcode,
                  phone: _this6.supporter.phoneNumber,
                  agreesDisplayName: _this6.supporter.agreesDisplayName,
                  signatureType: _this6.selection,
                  cookieID: _this6.$cookie.get("_mkto_trk"),
                  keepData: true,
                  ssoId: _this6.$store.getters.ssoId,
                  programName: _this6.programName,
                  sendToIve: _this6.sendToIve,
                  iveSupplier: _this6.iveSupplier,
                  iveSource: _this6.iveSource
                };


                if (browser) {
                  payload.browsername = browser.name;
                  payload.browserversion = browser.version;
                  payload.browseros = browser.os;
                }

                console.log("Save petition payload", payload);

                _context2.next = 6;
                return _this6.$store.dispatch("saveLead", {
                  campaignId: _this6.datalayerName,
                  lead: payload,
                  saveSignature: _this6.supporter.agreesDisplayName
                });

              case 6:

                console.log("Leaf Relief Petition submit success");

                // GTM
                __WEBPACK_IMPORTED_MODULE_6__utils_gtm__["a" /* default */].formSubmitSuccessEvent(_this6.datalayerName);

                // Todo: Reset form
                _context2.next = 14;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](0);

                console.error("Leaf Relief Petition submit error");
                console.error(_context2.t0);

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this6, [[0, 10]]);
      }))();
    },
    saveDonation: function saveDonation() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this7.$refs.Selector.commit();

                  // Save pending donation
                  // Populate the actual donation store and then save it
                  _this7.donation.firstname = _this7.supporter.firstName;
                  _this7.donation.lastname = _this7.supporter.lastName;
                  _this7.donation.email = _this7.supporter.email;
                  _this7.donation.phone = _this7.supporter.phoneNumber;
                  _this7.donation.billing.country = null;
                  _this7.donation.billing.state = null;
                  _this7.donation.billing.postcode = _this7.supporter.postcode;

                  _this7.$store.dispatch("saveDonation", {
                    agreesDisplayName: _this7.supporter.agreesDisplayName
                  }).then(function (response) {
                    resolve();
                  }).catch(function (error) {
                    console.error("saveDonation error", error);
                    reject(error);
                  });
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this7);
      }))();
    },
    logFirstTouch: function logFirstTouch(fieldName) {
      if (!this.formTouched) {
        this.$store.dispatch("logLeafBegin", fieldName);
        this.formTouched = true;
      }
    }
  }
});

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase__ = __webpack_require__(32);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "LeafReliefHeader",

  data: function data() {
    return {
      currentCounter: 0,
      percent: 0,
      subscriptions: []
    };
  },

  props: {
    datalayerName: {
      type: String,
      required: true
    },
    counterLimit: {
      type: Number,
      default: 100
    },
    targetText: {
      type: String,
      default: "1 Million"
    },
    headerText: {
      type: String,
      default: "Join us in our quest to plant 2 billion trees and restore our unique habitat"
    }
  },

  created: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = this.subscriptions;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4_firebase__["a" /* default */].firestore().collection("campaigns").doc(this.datalayerName).onSnapshot(function (snapshot) {
                var data = snapshot.data();
                if (!!data) {
                  _this.setCounter(data.count);
                }
              }, function (error) {
                console.error(err);
              });

            case 3:
              _context.t1 = _context.sent;

              _context.t0.push.call(_context.t0, _context.t1);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _ref.apply(this, arguments);
    }

    return created;
  }(),
  methods: {
    setCounter: function setCounter(value) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var delta, increment, wait;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$store.commit("updateTreeCount", value);

                value = value > _this2.counterLimit ? _this2.counterLimit : value;
                _this2.percent = value / _this2.counterLimit * 100;
                delta = value - _this2.currentCounter;
                increment = delta / 351;
                wait = 2800 / 351;

              case 6:
                if (_this2.currentCounter + increment > value) {
                  _this2.currentCounter = value;
                } else {
                  _this2.currentCounter += increment;
                }
                _context2.next = 9;
                return _this2.sleep(wait);

              case 9:
                if (_this2.currentCounter < value) {
                  _context2.next = 6;
                  break;
                }

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    sleep: function sleep(time) {
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        return setTimeout(resolve, time);
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    // Unsubscript from all subscriptions
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.subscriptions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var s = _step.value;

        s();
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
});

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "leaf-relief-intent-popup",

  props: {
    image: {
      type: [String, Array]
    }
  },
  computed: {
    backgroundImage: function backgroundImage() {
      if (typeof this.image === "string") {
        return this.image;
      }

      // If array of images - first image is desktop, second image is mobile
      if (this.image && window.matchMedia("(max-width: 640px)").matches) {
        return this.image[1] || this.image[0];
      }
      if (this.image) {
        return this.image[0];
      }
    }
  },

  mounted: function mounted() {
    // Override popup overlay color
    this.setOverlayBg("transparent");
  },

  methods: {
    confirm: function confirm() {
      this.$store.dispatch("logPopupActioned");

      // Revert popup overlay color
      this.setOverlayBg();
    },
    decline: function decline() {
      this.$store.dispatch("logPopupDeclined");

      // Revert popup overlay color
      this.setOverlayBg();
    },
    setOverlayBg: function setOverlayBg() {
      var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

      $('.reveal-overlay').css("background-color", color);
    }
  }
});

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "last-signatures",

  data: function data() {
    return {
      signatures: [],
      updatingTimes: false,
      interval: null,
      subscriptions: []
    };
  },

  props: {
    campaigId: {
      type: String,
      required: true
    },
    numberOfSignatures: {
      type: Number,
      default: 5
    },
    classes: {
      type: String,
      required: false
    }
  },

  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = _this.subscriptions;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4_firebase__["a" /* default */].firestore().collection("signatures").where("campaigId", "==", _this.campaigId).orderBy("signatureDate", "desc").limit(_this.numberOfSignatures).onSnapshot(function (snapshot) {
                var datas = [];
                snapshot.forEach(function (e) {
                  return datas.push(e.data());
                });
                _this.signatures = _this.updateTimeDifference(datas, true);
              }, function (error) {
                console.error(error);
              });

            case 3:
              _context.t1 = _context.sent;

              _context.t0.push.call(_context.t0, _context.t1);

              // Update the time signed
              setInterval(function () {
                _this.signatures = _this.updateTimeDifference(_this.signatures);
              }, 60000);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.interval) {
      clearInterval(interval);
    }

    // Unsubscript from all subscriptions
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.subscriptions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var unsub = _step.value;

        unsub();
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  },


  methods: {
    updateTimeDifference: function updateTimeDifference(data, forced) {
      if (this.updatingTimes && !forced) {
        return data;
      }

      this.updatingTimes = true;
      var table = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data));
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(table), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var d = _step2.value;

          var timeDifference = __WEBPACK_IMPORTED_MODULE_5_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_5_moment___default()(d.signatureDate), "minutes");
          var difference = timeDifference + " minute" + (+timeDifference > 1 ? "s" : "") + " ago";
          if (timeDifference === 0) {
            difference = "now";
          } else if (timeDifference >= 60 && timeDifference < 1440) {
            timeDifference = __WEBPACK_IMPORTED_MODULE_5_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_5_moment___default()(d.signatureDate), "hours");
            difference = timeDifference + " hour" + (+timeDifference > 1 ? "s" : "") + " ago";
          } else if (timeDifference >= 1440) {
            timeDifference = __WEBPACK_IMPORTED_MODULE_5_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_5_moment___default()(d.signatureDate), "days");
            difference = timeDifference + " day" + (+timeDifference > 1 ? "s" : "") + " ago";
          }
          // Assign the value
          d.timeDifference = difference;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      this.updatingTimes = false;
      return table;
    },
    limitSize: function limitSize(input) {
      if (input && input.length > 32) {
        return input.substring(0, 32) + "...";
      } else {
        return input;
      }
    },
    hasName: function hasName(signature) {
      return signature.firstName && signature.lastName;
    }
  }
});

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Header__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Stepper_vue__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Stepper_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Stepper_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LastSignatures__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LastSignatures___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__LastSignatures__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_gtm__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(2);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: "LeafRelief",
  components: {
    LeafReliefHeader: __WEBPACK_IMPORTED_MODULE_3__Header___default.a,
    Stepper: __WEBPACK_IMPORTED_MODULE_4__Stepper_vue___default.a,
    LastSignatures: __WEBPACK_IMPORTED_MODULE_5__LastSignatures___default.a
  },

  data: function data() {
    return {
      defaultDonationType: null,
      isProcessing: false,
      showNames: false
    };
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* mapState */])({
    donation: function donation(state) {
      return state.donation.donation;
    },
    product: function product(state) {
      return state.product.product;
    },
    supporter: function supporter(state) {
      return state.leafRelief.details;
    }
  }),
  props: {
    productId: {
      type: String,
      required: true
    },
    datalayerName: {
      type: String,
      required: true
    },

    programName: {
      type: String,
      required: true
    },

    // IVE
    sendToIve: {
      type: Boolean,
      default: true
    },
    iveSupplier: {
      type: String,
      default: "WWF-Aus-leaf-relief-phone-mandatory"
    },
    iveSource: {
      type: String,
      default: "LeafRelief"
    },

    // Last signatures
    numberOfSignatures: {
      type: Number,
      default: 3
    },

    // Selectors
    petitionSelector: {
      type: String,
      default: "Plant a Tree"
    },
    donationSelector: {
      type: String,
      default: "Plant a Forest"
    },

    // Header
    targetText: {
      type: String,
      default: "1 Million"
    },
    headerText: {
      type: String,
      default: "Join us in our quest to plant 2 billion trees and restore our unique habitat"
    },
    counterLimit: {
      type: Number,
      default: 100
    },

    // Details
    petitionHandle: {
      type: String,
      default: "Show your support and we'll plant a tree today"
    },
    duplicateEmailMessage: {
      type: String,
      default: "You can donate multiple times with the same email but you can only submit the petition once."
    },

    // Thank You
    thankYouText: {
      type: String,
      default: "Thank you for helping repopulate our forests"
    },
    getSocialText: {
      type: String,
      default: "Share this opportunity with friends to let them plant their own seed"
    },

    // Thank You Popup
    raRgId: {
      type: String
    },
    raSgId: {
      type: String
    },
    edoId: {
      type: String
    },

    // Change to B form for A/B testing
    isBForm: {
      type: Boolean,
      default: false
    },

    // Exit Intent Popup
    disableExitPopup: {
      type: Boolean,
      default: false
    },
    exitPopupImage: {
      type: [String, Array]
    }
  },

  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var res;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([_this.$store.dispatch("getFeatureSwitch", "display-leaf-relief-names"), _this.$store.dispatch("getProductById", {
                id: _this.productId,
                source: window.location.href,
                appealid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("t"),
                fundid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("f")
              })]);

            case 2:
              res = _context.sent;


              _this.showNames = res[0];

              _this.checkPaypalCallback();
              _this.readQueryParams();
              _this.setDonationType();

              _this.$store.commit("enableBForm", _this.isBForm);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  mounted: function mounted() {
    var _this2 = this;

    if (!this.disableExitPopup) {
      // For mobile/tablet devices to trigger exit popup on back button
      if (window.matchMedia("(max-width: 1024px)").matches) {
        window.history.pushState({}, window.document.title, window.location.href);
        window.onpopstate = function () {
          var hasDonated = window.sessionStorage.getItem("leafReliefActioned") === "true";
          if (!hasDonated) {
            _this2.openExitPopup();
          }
        };
      }

      // Event to display exit popup if a user has not donated on leaf relief during session
      document.addEventListener('mouseout', function (e) {
        var hasDonated = window.sessionStorage.getItem("leafReliefActioned") === "true";

        // Only trigger popup when mouse has left the document and exited towards address bar
        if (!hasDonated && !e.toElement && !e.relatedTarget && e.clientY < 10) {
          _this2.openExitPopup();
        }
      });
    }
  },

  methods: {
    checkPaypalCallback: function checkPaypalCallback() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var paymentId, payerId, el, paypalDonation, querylessUrl, _el;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                // Check if there payment paypal pending to excecute
                paymentId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("token");
                payerId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("PayerID");

                if (!(payerId && paymentId)) {
                  _context2.next = 30;
                  break;
                }

                console.log("Paypal Callback - Payment found");

                _this3.isProcessing = true;

                // Move to top of the form
                el = document.getElementById("form-top");

                if (el) {
                  el.scrollIntoView({ behavior: "smooth" });
                }

                _context2.next = 10;
                return _this3.$store.dispatch("paymentPaypal", {
                  payerid: payerId,
                  paymentid: paymentId
                });

              case 10:
                paypalDonation = _context2.sent;


                console.log("Paypal Callback - Donaion", paypalDonation);

                if (!paypalDonation) {
                  _context2.next = 30;
                  break;
                }

                // Remove the query params from the URL
                querylessUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["e" /* removeURLParameter */])("token");

                querylessUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["e" /* removeURLParameter */])("PayerID", querylessUrl);
                window.history.pushState({}, document.title, querylessUrl);

                __WEBPACK_IMPORTED_MODULE_7__utils_gtm__["a" /* default */].pushPurchase(paypalDonation.key, paypalDonation.productname, paypalDonation.productid, paypalDonation.producttype, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["b" /* getNameByDonationType */])(paypalDonation.type), paypalDonation.amount, paypalDonation.postcode, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["c" /* getNameByPaymentType */])("wwf_paypal"));

                _this3.$store.dispatch("logFormPaySuccess", paypalDonation.key);

                // Set data and send to thank you page
                _this3.$store.commit("updateSelection", "donation");
                _this3.supporter.firstName = paypalDonation.firstname;
                _this3.supporter.lastName = paypalDonation.lastname;
                _this3.donation.amount = paypalDonation.amount;

                if (!paypalDonation.extra.agreesDisplayName) {
                  _context2.next = 25;
                  break;
                }

                _context2.next = 25;
                return _this3.$store.dispatch("saveSignature", {
                  campaigId: _this3.datalayerName,
                  firstName: _this3.supporter.firstName,
                  lastName: _this3.supporter.lastName,
                  isDonation: true
                });

              case 25:

                // Set session flag when donation complete to prevent exit popup from displaying
                window.sessionStorage.setItem("leafReliefActioned", "true");

                _this3.$store.dispatch("logLeafComplete");

                // Go to thank you page
                _this3.$store.commit("updateLeafRelief", {
                  field: "currentStep",
                  value: 2
                });

                // Move to top of the form
                _el = document.getElementById("form-top");

                if (_el) {
                  _el.scrollIntoView({ behavior: "smooth" });
                }

              case 30:
                _context2.next = 35;
                break;

              case 32:
                _context2.prev = 32;
                _context2.t0 = _context2["catch"](0);

                console.error("Paypal Callback - error", _context2.t0);

              case 35:
                _context2.prev = 35;

                _this3.isProcessing = false;
                return _context2.finish(35);

              case 38:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 32, 35, 38]]);
      }))();
    },
    readQueryParams: function readQueryParams() {
      var _this4 = this;

      // Check if there are some query string in URL to prefill the form, Query from donate widget
      var q = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("q");
      if (q) {
        var paramsPrefill = "?" + window.atob(q);
        console.log("paramsPrefill", paramsPrefill);

        var amount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("amount", paramsPrefill);
        var email = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("email", paramsPrefill);
        var firstname = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("firstname", paramsPrefill);
        var lastname = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("lastname", paramsPrefill);
        var salutation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("salutation", paramsPrefill);
        var wildcardCode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("wildcardCode", paramsPrefill);

        if (wildcardCode) {
          this.donation.packagecode = wildcardCode;
        }

        var dollarhandle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("dollarhandle", paramsPrefill) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("dollarhandle", paramsPrefill).replace("$", "") : undefined;
        var dollarhandles = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("dollarhandles", paramsPrefill);

        if (dollarhandles) {
          // get dollarhandles from query params
          dollarhandles = dollarhandles.replace(/[^0-9\. ]+/g, "").split(" ");
          var newDollarHandles = [];
          dollarhandles.forEach(function (v, index) {
            // Check if there is a product dollar handles index
            if (_this4.product.dollarhandles.Single[index]) {
              newDollarHandles.push({
                amount: v,
                img: _this4.product.dollarhandles.Single[index].img,
                text: _this4.product.dollarhandles.Single[index].text
              });
            }
          });
          this.product.dollarhandles.Single = newDollarHandles;
        }

        this.donation.dollarhandle = dollarhandle;
        this.donation.amount = amount;
        this.donation.title = salutation;

        this.supporter.email = email;
        this.supporter.firstName = firstname;
        this.supporter.lastName = lastname;
      }

      // Pre select Petition or donation (ST = Submission type)
      var st = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("st");
      if (!!st && (st === "petition" || st === "donation")) {
        this.$store.commit("updateSelection", st);
      }
    },
    setDonationType: function setDonationType() {
      var _this5 = this;

      // Set default donation type by query param
      var dt = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("dt");
      if (dt && (dt === "Single" || dt === "Regular")) {
        this.defaultDonationType = dt;
      }

      // DONATION TYPE - Pre-select the doallar handle and the package (rule: first item on the list)
      // As we only have Single and Regular, always set Single as the first option
      var defaultTypeExists = this.product.donationtypes.filter(function (e) {
        return e === _this5.defaultDonationType;
      }).length === 1;
      var defaultType = defaultTypeExists && this.defaultDonationType ? this.defaultDonationType : this.product.appealcodesetting.defaultdonationtype;

      // Reverse alphabetical order
      this.product.donationtypes = this.product.donationtypes.sort(function (a, b) {
        if (a === defaultType) {
          return -1;
        }
        if (b === defaultType) {
          return 1;
        }
        return 0;
      });

      this.donation.type = defaultType;
      var settings = this.product.donationsettings[defaultType];
      if (settings) {
        this.donation.campaignid = settings.campaignid;
        this.donation.fundid = settings.fundid;
      }

      // DOLLAR HANDLE - Select first element
      var handles = this.product.dollarhandles[defaultType];
      if (handles) {
        this.donation.amount = handles[0].amount;
        this.donation.dollarhandle = handles[0].amount;
      }
    },
    openExitPopup: function openExitPopup() {
      if (!this.$store.getters.content.isOpen) {
        this.$store.commit("setPopupContent", {
          component: "leaf-relief-intent-popup",
          componentparams: {
            image: this.exitPopupImage
          }
        });
        this.$store.commit("openCustomContentPopup", true);

        // Log to Amplitude
        this.$store.dispatch("logPopup");
      }
    }
  }
});

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__donation_CreditCard__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__donation_CreditCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__donation_CreditCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__donation_DirectDebit__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__donation_DirectDebit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__donation_DirectDebit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_gtm__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers__ = __webpack_require__(7);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Payment",
  components: {
    CreditCard: __WEBPACK_IMPORTED_MODULE_3__donation_CreditCard___default.a,
    DirectDebit: __WEBPACK_IMPORTED_MODULE_4__donation_DirectDebit___default.a
  },

  data: function data() {
    return {
      isLoading: false,
      processPayment: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    isCreditCard: function isCreditCard() {
      return this.donation.payementType === "wwf_purchasetokenise";
    },
    isDirectDebit: function isDirectDebit() {
      return this.donation.payementType === "wwf_directdebit";
    },
    isPayPal: function isPayPal() {
      return this.donation.payementType === "wwf_paypal";
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])({
    donation: function donation(state) {
      return state.donation.donation;
    },
    product: function product(state) {
      return state.product.product;
    },
    supporter: function supporter(state) {
      return state.leafRelief.details;
    }
  })),
  props: {
    datalayerName: {
      type: String,
      required: true
    }
  },

  methods: {
    checkoutPaypal: function checkoutPaypal() {
      var _this = this;

      this.isLoading = true;

      this.$store.dispatch("logFormPayAttempt");

      this.$store.dispatch("checkoutPaypal").then(function (response) {
        window.location.href = response;
      }).catch(function (error) {
        console.error("Checkout Paypal - Error - ", error);
        _this.$store.dispatch("logFormPayFail", "Paypal checkout error");
        _this.isLoading = false;
      });
    },
    selectPaymentType: function selectPaymentType(paymentType) {
      // Update donation with the payment type
      this.$store.commit("updateDonation", {
        field: "payementType",
        value: paymentType
      });
    },
    retry: function retry() {
      var _this2 = this;

      this.processPayment = false;
      this.$store.dispatch("retryDonation").then(function (response) {
        if (_this2.isCreditCard) {
          _this2.$refs.creditCardCheckout.reset();
        } else {
          _this2.$refs.directDebitCheckout.reset();
        }
      }).catch(function (error) {
        console.error("Retry donation error", error);
      });
    },
    processSuccess: function processSuccess(data) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var isRestrictedIP;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this3.processPayment) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _this3.processPayment = true;

                // Make the payment

                if (!_this3.isCreditCard) {
                  _context.next = 26;
                  break;
                }

                _context.prev = 4;
                _context.next = 7;
                return _this3.$store.dispatch("saveDonation");

              case 7:
                _context.next = 9;
                return _this3.$store.dispatch("paymentCreditCard", {
                  token: data.token,
                  cardHolderName: data.cardHolderName
                });

              case 9:

                console.log("Credit Card Payment success");
                _this3.$store.commit("setTransactionId", _this3.donation.key);
                _this3.$store.dispatch("logFormPaySuccess", _this3.donation.key);

                _this3.$refs.creditCardCheckout.reset();
                _this3.processPayment = false;
                _this3.next();
                _context.next = 24;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](4);

                console.error("Server Error", _context.t0);
                isRestrictedIP = _context.t0.status == 403 && _context.t0.body;

                _this3.$store.dispatch("logFormPayFail", "Server Error");
                _this3.$refs.creditCardCheckout.reset(isRestrictedIP ? _context.t0.body.message : "Oops something happened and we were not able to process your payment, please try again.");
                _this3.processPayment = false;

              case 24:
                _context.next = 45;
                break;

              case 26:
                _context.prev = 26;
                _context.next = 29;
                return _this3.$store.dispatch("saveDonation");

              case 29:
                _context.next = 31;
                return _this3.$store.dispatch("paymentDirectDebit", {
                  accno: data.accno,
                  accrouting: data.accrouting,
                  acctitle: data.acctitle
                });

              case 31:

                console.log("Direct Debit Payment success");
                _this3.$store.commit("setTransactionId", _this3.donation.key);
                _this3.$store.dispatch("logFormPaySuccess", _this3.donation.key);

                _this3.$refs.directDebitCheckout.reset();
                _this3.processPayment = false;
                _this3.next();
                _context.next = 45;
                break;

              case 39:
                _context.prev = 39;
                _context.t1 = _context["catch"](26);

                console.error("Server Error", _context.t1);
                _this3.$store.dispatch("logFormPayFail", "Server Error");
                _this3.$refs.directDebitCheckout.reset("Oops something happened and we were not able to process your payment, please try again.");
                _this3.processPayment = false;

              case 45:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3, [[4, 17], [26, 39]]);
      }))();
    },
    next: function next() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this4.supporter.agreesDisplayName) {
                  _context2.next = 3;
                  break;
                }

                _context2.next = 3;
                return _this4.$store.dispatch("saveSignature", {
                  campaigId: _this4.datalayerName,
                  firstName: _this4.supporter.firstName,
                  lastName: _this4.supporter.lastName,
                  isDonation: true
                });

              case 3:

                // Send data to Google Tag Manager
                __WEBPACK_IMPORTED_MODULE_6__utils_gtm__["a" /* default */].pushPurchase(_this4.donation.transactionid, _this4.product.productname, _this4.product.id, _this4.product.producttype, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers__["b" /* getNameByDonationType */])(_this4.donation.type), _this4.donation.amount, _this4.donation.billing.postcode, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers__["c" /* getNameByPaymentType */])(_this4.donation.payementType));

                _this4.$emit("next");

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    }
  }
});

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vee_validate__ = __webpack_require__(8);




var _extends2;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Selector",

  data: function data() {
    return {
      maxAmount: 75000,
      selectedDollarHandle: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(["isPetition", "isDonation", "isBForm"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])({
    donation: function donation(state) {
      return state.donation.donation;
    },
    currentDonationType: function currentDonationType(state) {
      return state.donation.donation.type;
    },
    currentDollarHandle: function currentDollarHandle(state) {
      return state.donation.donation.dollarhandle;
    },
    product: function product(state) {
      return state.product.product;
    }
  }), (_extends2 = {
    dollarHandles: function dollarHandles() {
      return this.product.dollarhandles[this.currentDonationType];
    },
    isDollarHandleSelected: function isDollarHandleSelected() {
      return this.selectedDollarHandle != null && this.selectedDollarHandle != "custom" && this.selectedDollarHandle != "";
    },
    isCustomSelected: function isCustomSelected() {
      return this.selectedDollarHandle != null && this.selectedDollarHandle === "custom";
    },
    showMaxAmountMessage: function showMaxAmountMessage() {
      return this.selectedDollarHandle === "custom" && !!this.donation.amount && !isNaN(this.donation.amount) && +this.donation.amount > this.maxAmount;
    },
    minAmount: function minAmount() {
      if (!!this.product && !!this.product.donationsettings && !!this.currentDonationType && !!this.product.donationsettings[this.currentDonationType]) {
        return this.product.donationsettings[this.currentDonationType].minimumAmount;
      } else {
        return null;
      }
    },
    proposeCustomAmount: function proposeCustomAmount() {
      return !(this.product.extrasetting && this.product.extrasetting.hidecustomhandle);
    },

    currentSelection: {
      get: function get() {
        return this.$store.state.leafRelief.selection;
      },
      set: function set(value) {
        this.$store.commit("updateSelection", value);
      }
    }
  }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_extends2, "minAmount", function minAmount() {
    if (!!this.product && !!this.product.donationsettings && !!this.currentDonationType && !!this.product.donationsettings[this.currentDonationType]) {
      return this.product.donationsettings[this.currentDonationType].minimumAmount;
    } else {
      return null;
    }
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_extends2, "bFormPetitionHandle", function bFormPetitionHandle() {
    return { text: this.petitionHandle };
  }), _extends2)),
  props: {
    // Selectors
    petitionSelector: {
      type: String,
      default: "Plant a tree"
    },
    donationSelector: {
      type: String,
      default: "Plant a forest"
    },

    petitionHandle: {
      type: String,
      default: "Show your support and we'll plant a tree today"
    }
  },
  watch: {
    selectedDollarHandle: function selectedDollarHandle(newVal, oldVal) {
      // For B form, change between petition and donation through dollar handle selection
      if (this.isBForm) {
        var isPetitionHandle = this.selectedDollarHandle.text === this.bFormPetitionHandle.text;
        this.updateSelection(isPetitionHandle ? 'petition' : 'donation');
      }

      if (this.isDollarHandleSelected) {
        this.donation.dollarhandle = this.selectedDollarHandle.amount;
        this.donation.amount = this.selectedDollarHandle.amount;
      } else {
        this.donation.dollarhandle = null;
        this.donation.amount = null;
        if (newVal === "custom") {
          // Give the focus to the input
          setTimeout(function () {
            this.$refs.customAmount.focus();
          }.bind(this), 1);
        }
      }
    },
    currentDonationType: function currentDonationType(newVal) {
      // Pre select the first dollar handle
      if (this.isBForm) {
        this.selectedDollarHandle = this.bFormPetitionHandle;
        return;
      }
      if (!!newVal && !!this.product && !!this.product.dollarhandles && !!this.product.dollarhandles[newVal]) {
        this.selectedDollarHandle = this.product.dollarhandles[newVal][0];
      }
    },
    currentDollarHandle: function currentDollarHandle(newVal) {
      // Listen for the changes from the widget
      if (!!this.dollarHandles) {
        var dh = this.dollarHandles.find(function (e) {
          return e.amount === newVal;
        });
        if (!!dh) {
          this.selectedDollarHandle = dh;
        }
      }
    }
  },

  created: function created() {
    var _this = this;

    // Custom validation for amount (regular/single)
    var leafReliefCustomAmountIsValid = function leafReliefCustomAmountIsValid(amount) {
      if (amount <= 0) {
        return {
          valid: false,
          data: { message: "The amount must be positive." }
        };
      }

      // Get the min amount from the settings of the selected type or the default one if not set
      var minimumAmount = !!_this.minAmount ? parseFloat(_this.minAmount) : _this.type === "Regular" ? 15 : 2;

      var inputAmount = parseInt(amount.replace(/ /g, ""));
      if (inputAmount < minimumAmount) {
        return {
          valid: false,
          data: { message: "The minimum amount is $" + minimumAmount }
        };
      } else if (inputAmount > _this.maxAmount) {
        return {
          valid: false,
          data: { message: "The maximum amount is $75,000" }
        };
      } else {
        return {
          valid: true
        };
      }
    };

    __WEBPACK_IMPORTED_MODULE_4_vee_validate__["b" /* Validator */].extend("leafReliefCustomAmountIsValid", {
      validate: leafReliefCustomAmountIsValid,
      getMessage: function getMessage(field, params, data) {
        return data.message;
      }
    });
  },
  mounted: function mounted() {
    // Pre select the first dollar handle
    if (!!this.product && !!this.product.dollarhandles && !!this.product.dollarhandles.Single) {
      this.selectedDollarHandle = this.product.dollarhandles.Single[0];
    }
  },

  methods: {
    updateSelection: function updateSelection(select) {
      this.currentSelection = select;
    },
    formatDollarHandle: function formatDollarHandle(handle) {
      return "$" + (handle.indexOf(".00") >= 0 ? handle.slice(0, -3) : handle);
    },
    validate: function validate() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this2.$validator.validateAll().then(function (result) {
          // Will return true if valid and false if not
          if (result) {
            resolve(result);
          } else {
            console.error("Form Selection not valid - result", result);
            reject(result);
          }
        }).catch(function (err) {
          console.error("Step 1 Validation - Error - ", err);
          reject(err);
        });
      });
    },
    commit: function commit() {
      // Add .00 if no . and add 0 if no 0 (eg 42.6)
      this.donation.amount = this.donation.amount.indexOf(".") == -1 ? this.donation.amount.concat(".00") : /^\d+(\.\d{1})+$/.test(this.donation.amount) ? this.donation.amount.concat("0") : this.donation.amount;
    },
    logFirstTouch: function logFirstTouch() {
      this.$emit("firstTouch");
    }
  }
});

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Details_vue__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Details_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Details_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Payment_vue__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Payment_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Payment_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ThankYou_vue__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ThankYou_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ThankYou_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 // Step 1
 // Step 2
 // Step 3




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Stepper",
  components: {
    LeafReliefDetails: __WEBPACK_IMPORTED_MODULE_1__Details_vue___default.a,
    Payment: __WEBPACK_IMPORTED_MODULE_2__Payment_vue___default.a,
    ThankYou: __WEBPACK_IMPORTED_MODULE_3__ThankYou_vue___default.a
  },

  data: function data() {
    return {
      isRg: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(["isDonation"]), {
    showStepper: function showStepper() {
      return this.currentStep > 0 && this.isDonation;
    },

    currentStep: {
      get: function get() {
        return this.$store.state.leafRelief.currentStep;
      },
      set: function set(value) {
        this.$store.commit("updateLeafRelief", { field: "currentStep", value: value });
      }
    }
  }),

  props: {
    programName: {
      type: String
    },
    datalayerName: {
      type: String
    },

    // IVE
    sendToIve: {
      type: Boolean
    },
    iveSupplier: {
      type: String
    },
    iveSource: {
      type: String
    },

    // Selectors
    petitionSelector: {
      type: String
    },
    donationSelector: {
      type: String
    },

    duplicateEmailMessage: {
      type: String
    },
    petitionHandle: {
      type: String
    },

    // Thank You
    thankYouText: {
      type: String
    },
    getSocialText: {
      type: String
    },

    // Thank You Popup
    raRgId: {
      type: String
    },
    raSgId: {
      type: String
    },
    edoId: {
      type: String
    }
  },

  created: function created() {
    var status = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers__["d" /* getParameterByName */])("s");
    if (!!status && status === "rg") {
      this.isRg = true;
    }
  },


  methods: {
    next: function next(oldStep) {
      if (this.isDonation && oldStep === 0) {
        // For a donation, step 2 is payment
        this.currentStep = 1;

        // Move to top of the form
        var el = document.getElementById("leaf-relief");
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      } else {
        // Original plan, showing a 3rd step with a thank you message
        // Then is changed to show a popuop with different mesages depending on the journey of the user

        // Set session flag when donation complete to prevent exit popup from displaying
        window.sessionStorage.setItem("leafReliefActioned", "true");

        // Amplitude
        this.$store.dispatch("logLeafComplete");

        // this.showThankYouStep();
        this.openThankYouPopup();
      }
    },
    showThankYouStep: function showThankYouStep() {
      // 3rd step - For petition or after donation step 2, show thank you
      this.currentStep = 2;

      // Move to top of the form
      var el = document.getElementById("leaf-relief");
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    },
    openThankYouPopup: function openThankYouPopup() {
      var _this = this;

      // Show Popup
      // Open thank you popup
      // Fetch the content then display the popup
      var id = this.mapThankYouContent();

      if (!!id) {
        this.$store.dispatch("getContentMessageById", id).then(function (response) {
          if (!!response) {
            var title = response.description;
            var content = response.content;

            _this.$store.commit("setPopupContent", {
              component: "step-up",
              componentparams: {
                id: id,
                title: title,
                content: content
              }
            });
            _this.$store.commit("openStepUpPopup", true);

            _this.$store.dispatch("logStepUp", id);

            // Once the popup is displayed, return to the beginning
            setTimeout(function () {
              _this.currentStep = 0;
            }, 200);
          } else {
            // if no content is returned
            _this.showThankYouStep();
          }
        }).catch(function (err) {
          console.error(err);
          _this.showThankYouStep();
        });
      } else {
        // If no ID is set
        this.showThankYouStep();
      }
    },
    mapThankYouContent: function mapThankYouContent() {
      // Check for query params for step up override
      var override = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers__["d" /* getParameterByName */])("stepup");
      if (override) {
        return override;
      }

      if (this.isDonation) {
        return this.edoId;
      } else {
        if (this.isRg) {
          return this.raSgId;
        } else {
          return this.raRgId;
        }
      }
    }
  }
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ThankYou",

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(["isDonation"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    supporter: function supporter(state) {
      return state.leafRelief.details;
    },
    donation: function donation(state) {
      return state.donation.donation;
    }
  })),
  props: {
    thankYouText: {
      type: String,
      default: "Thank you for helping repopulate our forests"
    },
    getSocialText: {
      type: String,
      default: "Share this opportunity with friends to let them plant their own seed"
    }
  }
});

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "leaf-relief-thank-you-popup",

  props: {
    // Content
    title: {
      type: String
    },
    content: {
      type: String
    }
  },

  computed: {},

  watch: {},

  created: function created() {},
  mounted: function mounted() {
    // Attach amplitude event to hyperlink button in content
    var stepupButton = this.$refs.stepup.querySelector("a");
    try {
      $(stepupButton).click({ callback: this.handleClick }, function (e) {
        e.preventDefault();
        e.data.callback(this.href);
      });
    } catch (err) {
      console.error(err);
    }
  },


  methods: {
    handleClose: function handleClose() {
      this.$store.dispatch("logStepUpDeclined");
    },
    handleClick: function handleClick(link) {
      this.$store.dispatch("logStepUpActioned", link).then(function () {
        return window.location.href = link;
      });
    }
  }
});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_gtm__ = __webpack_require__(10);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Details",

  data: function data() {
    return {
      firstName: null,
      lastName: null,
      phone: null,
      isStepOne: true,
      isLoadingConfirm: false
    };
  },
  props: {
    email: {
      type: String
    },
    showModal: {
      type: Boolean
    }
  },

  methods: {
    confirm: function confirm() {
      var _this = this;

      this.isLoadingConfirm = true;
      this.$validator.validateAll().then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(result) {
          var payload;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  console.log("result", result);

                  if (!result) {
                    _context.next = 11;
                    break;
                  }

                  payload = {
                    email: _this.email,
                    firstName: _this.firstName,
                    lastName: _this.lastName,
                    phone: _this.phone,
                    programName: _this.$config.NEWSLETTERSUBSCRIBELIST,
                    cookieID: _this.$cookie.get("_mkto_trk"),
                    ssoId: _this.$store.getters.ssoId
                  };


                  console.log("Newsletter payload", payload);

                  _context.next = 6;
                  return _this.$store.dispatch("saveLead", {
                    campaignId: "newsletter-signup",
                    lead: payload
                  });

                case 6:

                  console.log("Newsletter submit success");

                  // GTM Event Success
                  __WEBPACK_IMPORTED_MODULE_2__utils_gtm__["a" /* default */].formSubmitSuccessEvent("newsletter-signup");

                  _this.isStepOne = false;
                  _context.next = 12;
                  break;

                case 11:
                  // GTM Event Failure
                  __WEBPACK_IMPORTED_MODULE_2__utils_gtm__["a" /* default */].formSubmitEvent("newsletter-signup");

                case 12:

                  _this.isLoadingConfirm = false;

                case 13:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    closeModal: function closeModal() {
      this.isStepOne = true;
      this.isLoadingConfirm = false;

      // Reset form
      this.firstName = null;
      this.lastName = null;
      this.phone = null;

      this.$emit("closeModal");
    }
  }
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Details_vue__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Details_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Details_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vee_validate__ = __webpack_require__(8);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Newsletter",
  components: {
    NewsletterDetails: __WEBPACK_IMPORTED_MODULE_3__Details_vue___default.a
  },

  data: function data() {
    return {
      email: null,
      showModal: false,
      timeout: null,
      lastTimestamp: Date.now(),
      checkEmailLoading: false,
      emailRegex: /.+\@.+\..+/,
      isLoading: false,
      isLoadingConfirm: false
    };
  },

  created: function created() {
    var _this = this;

    var newsletterCheckEmail = function newsletterCheckEmail(email) {
      if (email.length > 0 && _this.emailRegex.test(email)) {
        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          var timestamp = Date.now(); // timestamp for this api call
          _this.lastTimestamp = timestamp; // 1 , 2 , 3
          _this.checkEmailLoading = true;
          // Fetch Suggestions
          _this.$store.dispatch("validateEmail", email).then(function (response) {
            if (response && timestamp >= _this.lastTimestamp) {
              _this.checkEmailLoading = false;
              resolve(response);
            }
          }).catch(function (err) {
            console.error(err);
            _this.checkEmailLoading = false;
            // If the call failed, do not keep the user from donating
            resolve({
              valid: true
            });
          });
        });
      } else {
        return {
          valid: false,
          data: { message: "Email invalid" }
        };
      }
    };

    __WEBPACK_IMPORTED_MODULE_4_vee_validate__["b" /* Validator */].extend("newsletterCheckEmail", {
      validate: newsletterCheckEmail,
      getMessage: function getMessage(field, params, data) {
        return data.message;
      }
    });
  },

  methods: {
    emailSubmit: function emailSubmit() {
      var _this2 = this;

      this.isLoading = true;
      this.$validator.validateAll().then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(result) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (result) {
                    _this2.showModal = true;
                  }

                  _this2.isLoading = false;

                case 2:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, _this2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    closeModal: function closeModal() {
      this.showModal = false;
      this.isLoading = false;

      // Reset form
      this.email = null;
    }
  }
});

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "DollarHandleWidget",
  data: function data() {
    return {
      //type: "Single"
    };
  },

  computed: {
    formWizardCurrentStep: function formWizardCurrentStep() {
      return this.$store.getters.donation.formWizardCurrentStep;
    },

    dollarhandle: {
      get: function get() {
        return this.$store.getters.donation.dollarhandle;
      },
      set: function set(value) {
        console.log("Widget::dollarhandle::setter", value);
        this.amount = value == "custom" ? null : value;
        this.$store.commit("updateDonation", { field: "dollarhandle", value: value });
      }
    },
    type: {
      get: function get() {
        return this.$store.getters.donation.type;
      },
      set: function set(value) {
        this.$store.commit("updateDonation", { field: "type", value: value });
      }
    },
    amount: {
      get: function get() {
        return this.$store.getters.donation.amount;
      },
      set: function set(value) {
        console.log("Widget::amout::setter", value);
        this.$store.commit("updateDonation", { field: "amount", value: value });
      }
    },
    product: function product() {
      return this.$store.getters.product;
    }
  },
  props: {
    productId: {
      // Attribute for the productID
      type: String,
      required: true
    },
    productVersion: {
      // Attribute for the version of the product
      type: String
    }
  }
});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'donateRgForm',
  props: {
    productIds: {
      // Attribute for the productID
      type: Array,
      required: true
    },
    emailprefill: {
      type: String,
      required: false,
      default: ''
    },
    currentpage: {
      type: Boolean,
      required: false,
      default: false
    },
    dollarhandleclick: {
      type: Boolean,
      required: false,
      default: false
    },
    isDark: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data: function data() {
    return {
      email: '',
      handle: '',
      productidsdetail: null,
      product: null
    };
  },

  created: function created() {
    var _this = this;

    // Get product data (+ packages details)
    this.$store.dispatch("getProductByIds", this.productIds).then(function (response) {
      console.log("getProductByIds", response);
      _this.productidsdetail = response;
      _this.product = _this.productidsdetail[0];
    }, function (error) {
      console.error("getProductByIds error", error);
    });
  },
  methods: {
    donateclick: function donateclick(dollar) {
      this.handle = dollar;
      this.donate();
    },
    donate: function donate() {
      var _this2 = this;

      this.$validator.validateAll().then(function (result) {

        if (result) {
          if (window.dataLayer != undefined) {
            window.dataLayer.push({ 'formName': 'donation', 'event': 'formSubmitSuccessEvent' });
          }

          window.open(wwfconfigs.DONATEURL + _this2.product.urlPath + '?t=' + _this2.product.appealcodesetting.appealid + '&f=' + _this2.product.appealcodesetting.fundid + '&q=' + window.btoa('email=' + (_this2.emailprefill != '' ? _this2.emailprefill : _this2.email) + '&dollarhandle=' + _this2.handle + '&amount=' + (_this2.handle == 'custom' ? '' : _this2.handle)), _this2.currentpage ? "_self" : "_blank");

          return;
        } else {
          if (window.dataLayer != undefined) {
            window.dataLayer.push({ 'formName': 'donation', 'event': 'formSubmitEvent' });
          }
        }
      });
    }
  }
});

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(7);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "DonationTitle",
  data: function data() {
    return {
      firstName: null,
      replacedText: ""
    };
  },
  props: {
    anonymousText: {
      default: "We're fundraising for the future of our planet"
    },
    customText: {
      default: "Hello {{firstName}}, we're fundraising for the future of our planet"
    }
  },
  created: function created() {
    var q = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* getParameterByName */])("q");
    if (q) {
      var decodeq = "?" + window.atob(q);
      this.firstName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* getParameterByName */])("firstname", decodeq);
    }

    if (this.firstName && this.firstName.trim() && this.firstName != "null" && this.firstName != "undefined") {
      this.replacedText = this.customText.replace(/{{firstName}}/gi, this.firstName);
    } else {
      this.replacedText = this.anonymousText;
    }
  }
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "DonateWidget",
  data: function data() {
    return {
      //productids: ['one-off-donation','monthly-donation','net-free-north'],
      productidsdetail: null,
      product: null,
      customamount: ""
    };
  },

  props: {
    productIds: {
      // Attribute for the productID
      type: Array,
      required: true
    }
  },
  created: function created() {
    var _this = this;

    // Get product data (+ packages details)
    this.$store.dispatch("getProductByIds", this.productIds).then(function (response) {
      console.log("getProductByIds", response);
      _this.productidsdetail = response;
      _this.product = _this.productidsdetail[0];
    }).catch(function (error) {
      console.error("getProductByIds error", error);
    });
  },
  methods: {
    redirect: function redirect(urlPath, dollarhandle, amount) {
      window.open(urlPath + "?q=" + window.btoa("dollarhandle=" + dollarhandle + "&amount=" + amount), "_self");
    }
  }
});

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Step1__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Step1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Step1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Step2__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Step2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Step2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Step3__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Step3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Step3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_gtm__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(2);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  name: "donation-listenner",
  components: {
    Step1: __WEBPACK_IMPORTED_MODULE_3__Step1___default.a, // Donation details (packages, handle, donation type, email, payement type)
    Step2: __WEBPACK_IMPORTED_MODULE_4__Step2___default.a, // Personnal details (name, address)
    Step3: __WEBPACK_IMPORTED_MODULE_5__Step3___default.a // Payment
  },
  data: function data() {
    return {
      isShake: false,
      stepIndex: 0,
      useNewCheckout: false,
      defaultDonationType: null
    };
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* mapState */])({
    donation: function donation(state) {
      return state.donation.donation;
    },
    product: function product(state) {
      return state.product.product;
    }
  }),
  props: {
    disabledGoogleAutocomplete: {
      type: Boolean,
      default: false
    },
    thankYouUrl: {
      type: String,
      default: null
    },
    className: {
      type: String,
      default: null
    },
    isEarthHour: {
      type: Boolean,
      default: false
    },
    useProductThankYouUrl: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    product: function product(newVal, oldVal) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var defaultTypeExists, defaultType, settings;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // Pre-select the doallar handle and the package (rule: first item on the list)
                // As we only have Single and Regular, always set Single as the first option
                defaultTypeExists = _this.product.donationtypes.filter(function (e) {
                  return e === _this.defaultDonationType;
                }).length === 1;
                defaultType = defaultTypeExists && _this.defaultDonationType ? _this.defaultDonationType : _this.product.appealcodesetting.defaultdonationtype;


                _this.product.donationtypes = _this.product.donationtypes.sort(function (a, b) {
                  if (a === defaultType) {
                    return -1;
                  }
                  if (b === defaultType) {
                    return 1;
                  }
                  return 0;
                }); // Reverse alphabetical order

                _this.donation.type = defaultType;
                settings = _this.product.donationsettings[defaultType];


                if (settings) {
                  _this.donation.campaignid = settings.campaignid;
                  _this.donation.fundid = settings.fundid;
                }

                if (!(_this.product.producttype != "wildcard")) {
                  _context.next = 10;
                  break;
                }

                // Pre-select the package (rule: first item on the list)
                _this.donation.packagecode = _this.product.packages && _this.product.packages.length > 0 ? _this.product.packages[0] : null;

                _context.next = 10;
                return _this.$store.dispatch("getAllPackagesForProduct");

              case 10:

                // Reset the doller handle
                _this.donation.dollarhandle = null;

                _this.setLoading(false);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  created: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var _this2 = this;

      var paymentid, payerid, excecutePayment, querylessUrl, q, decodeq, amount, email, firstname, lastname, salutation, wildcardCode, dollarhandle, dollarhandles, newDollarHandles, dt;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // LOADING
              this.setLoading(true);

              // FEATURE SWITCH - Get value for the switch for Custom Checkout
              _context2.prev = 1;
              _context2.next = 4;
              return this.$store.dispatch("getCustomCheckoutFeatureSwitch", this.productId);

            case 4:
              this.useNewCheckout = _context2.sent;
              _context2.next = 11;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](1);

              this.useNewCheckout = false;
              console.error("Cannot get feature switch - Back to old checkout");

            case 11:
              _context2.prev = 11;

              // Check if there payment paypal pending to excecute
              paymentid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("token");
              payerid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("PayerID");

              if (!(payerid && paymentid)) {
                _context2.next = 21;
                break;
              }

              console.log("excecutePayment found");
              _context2.next = 18;
              return this.$store.dispatch("paymentPaypal", {
                payerid: payerid,
                paymentid: paymentid
              });

            case 18:
              excecutePayment = _context2.sent;


              console.log("excecutePayment", excecutePayment);

              if (excecutePayment) {
                // Remove the query params from the URL
                querylessUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["e" /* removeURLParameter */])("token");

                querylessUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["e" /* removeURLParameter */])("PayerID", querylessUrl);
                window.history.pushState({}, document.title, querylessUrl);

                this.thanksUser(excecutePayment);
              }

            case 21:
              _context2.next = 26;
              break;

            case 23:
              _context2.prev = 23;
              _context2.t1 = _context2["catch"](11);

              console.log("Paypal execute error", _context2.t1);

            case 26:

              // QUERY PARAMS - Check if there are some query string in URL to prefill the form, Query from donate widget
              q = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("q");

              if (q) {
                decodeq = "?" + window.atob(q);

                console.log("decodeq", decodeq);
                amount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("amount", decodeq);
                email = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("email", decodeq);
                firstname = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("firstname", decodeq);
                lastname = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("lastname", decodeq);
                salutation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("salutation", decodeq);
                wildcardCode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("wildcardCode", decodeq);

                if (wildcardCode) {
                  this.donation.packagecode = wildcardCode;
                }

                dollarhandle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("dollarhandle", decodeq) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("dollarhandle", decodeq).replace("$", "") : undefined;
                dollarhandles = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("dollarhandles", decodeq);

                if (dollarhandles) {
                  // get dollarhandles from query params
                  dollarhandles = dollarhandles.replace(/[^0-9\. ]+/g, "").split(" ");

                  newDollarHandles = [];

                  dollarhandles.forEach(function (v, index) {
                    // Check if there is a product dollar handles index
                    if (_this2.product.dollarhandles.Single[index]) {
                      newDollarHandles.push({
                        amount: v,
                        img: _this2.product.dollarhandles.Single[index].img,
                        text: _this2.product.dollarhandles.Single[index].text
                      });
                    }
                  });

                  this.product.dollarhandles.Single = newDollarHandles;

                  // todo: select Regular as default donation ?
                }

                this.donation.dollarhandle = dollarhandle;
                this.donation.amount = amount;
                this.donation.email = email;
                this.donation.firstname = firstname;
                this.donation.lastname = lastname;
                this.donation.title = salutation;
              }

              // Set default donation type by query param
              dt = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("dt");

              if (dt && (dt === "Single" || dt === "Regular")) {
                this.defaultDonationType = dt;
              }
              this.setLoading(false);

            case 31:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[1, 7], [11, 23]]);
    }));

    function created() {
      return _ref.apply(this, arguments);
    }

    return created;
  }(),
  methods: {
    thanksUser: function thanksUser(donation) {
      var donateThankYouUrl = donation.thankYouUrl;

      if (this.useProductThankYouUrl && donateThankYouUrl || this.thankYouUrl) {
        var query = "firstname=" + donation.firstname;
        query += "&lastname=" + donation.lastname;
        query += "&frequency=" + donation.type;
        query += "&amount=" + donation.amount;
        query += "&source=" + document.URL;

        var params = "?q=" + window.btoa(query);
        var baseUrl = this.useProductThankYouUrl && donateThankYouUrl ? donateThankYouUrl : this.thankYouUrl;
        var url = baseUrl + params;

        // Send data to Google Tag Manager
        __WEBPACK_IMPORTED_MODULE_7__utils_gtm__["a" /* default */].pushPurchase(donation.key, donation.productname, donation.productid, donation.producttype, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["b" /* getNameByDonationType */])(donation.type), donation.amount, donation.postcode, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["c" /* getNameByPaymentType */])("wwf_paypal"), function () {
          setTimeout(function () {
            window.open(url, "_self");
          }, 1000);
        });
      } else {
        window.app.thankyou(donation.amount, donation.type, donation.key, donation.productname, donation.postcode, donation.firstname, donation.lastname, donation.producttype, donation.certificateurl, donation.productid, "wwf_paypal", donation.wildcard ? donation.wildcard.pdf : null);
      }
    },

    setFormStepState: function setFormStepState(previousStep, nextStep) {
      // When the user is going from the 1 to 0 step
      if (previousStep === 1 && nextStep === 0) {
        __WEBPACK_IMPORTED_MODULE_7__utils_gtm__["a" /* default */].pushRemoveFromCart(this.product.productname, this.product.id, this.donation.amount, this.product.producttype, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["b" /* getNameByDonationType */])(this.donation.type));
      }
      this.donation.formWizardCurrentStep = nextStep;
    },
    setLoading: function setLoading(value) {
      this.donation.isLoading = value;
    },
    validateStep: function validateStep(name) {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var refToValidate = _this3.$refs[name];
        var isValid = refToValidate.validate().then(function (response) {
          resolve(true);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    reset: function reset() {
      this.$refs.wizard.changeTab(2, 0);
      this.$store.dispatch("resetDonation");

      // Pre-select the doallar handle and the package (rule: first item on the list)
      this.donation.type = this.product.donationtypes && this.product.donationtypes.length > 0 ? this.product.donationtypes[0] : null;

      var settings = this.product.donationsettings[this.donation.type];
      if (settings) {
        this.donation.campaignid = settings.campaignid;
        this.donation.fundid = settings.fundid;
      }

      this.donation.packagecode = this.product.packages && this.product.packages.length > 0 ? this.product.packages[0] : null;

      console.log("reset");
    },
    retry: function retry() {
      var _this4 = this;

      this.setLoading(true);
      this.$store.dispatch("retryDonation").then(function (response) {
        _this4.$refs.wizard.activateAll();
        _this4.setLoading(false);
      }).catch(function (error) {
        console.error("saveDonation error", error);
      });
      console.log("retry");
    },
    disablesteps: function disablesteps() {
      this.$refs.wizard.desActivateAll();
    }
  }
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Step1__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Step1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Step1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Step2__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Step2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Step2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Step3__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Step3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Step3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_gtm__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(2);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["default"] = ({
  name: "FormProduct",
  components: {
    Step1: __WEBPACK_IMPORTED_MODULE_3__Step1___default.a, // Donation details (packages, handle, donation type, email, payement type)
    Step2: __WEBPACK_IMPORTED_MODULE_4__Step2___default.a, // Personnal details (name, address)
    Step3: __WEBPACK_IMPORTED_MODULE_5__Step3___default.a // Payment
  },
  data: function data() {
    return {
      isShake: false,
      stepIndex: 0,
      useNewCheckout: false,
      defaultDonationType: null
    };
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* mapState */])({
    donation: function donation(state) {
      return state.donation.donation;
    },
    product: function product(state) {
      return state.product.product;
    }
  }),
  props: {
    productId: {
      // Attribute for the productID
      type: String,
      required: true
    },
    productVersion: {
      type: String
    },
    disabledGoogleAutocomplete: {
      type: Boolean,
      default: false
    },
    thankYouUrl: {
      type: String,
      default: null
    },
    className: {
      type: String,
      default: null
    },
    isEarthHour: {
      type: Boolean,
      default: false
    },
    useProductThankYouUrl: {
      type: Boolean,
      default: false
    }
  },
  created: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _this = this;

      var paymentid, payerid, excecutePayment, querylessUrl, q, decodeq, amount, email, firstname, lastname, salutation, wildcardCode, dollarhandle, dollarhandles, newDollarHandles, dt, defaultTypeExists, defaultType, settings;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return this.$store.dispatch("getCustomCheckoutFeatureSwitch", this.productId);

            case 3:
              this.useNewCheckout = _context.sent;
              _context.next = 10;
              break;

            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](0);

              this.useNewCheckout = false;
              console.error("Cannot get feature switch - Back to old checkout");

            case 10:

              this.$on("retryDonation", function () {
                return _this.retry();
              });

              this.setLoading(true);

              _context.prev = 12;

              // Check if there payment paypal pending to excecute
              paymentid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("token");
              payerid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("PayerID");

              if (!(payerid && paymentid)) {
                _context.next = 22;
                break;
              }

              console.log("excecutePayment found");
              _context.next = 19;
              return this.$store.dispatch("paymentPaypal", {
                payerid: payerid,
                paymentid: paymentid
              });

            case 19:
              excecutePayment = _context.sent;


              console.log("excecutePayment", excecutePayment);

              if (excecutePayment) {
                // Remove the query params from the URL
                querylessUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["e" /* removeURLParameter */])("token");

                querylessUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["e" /* removeURLParameter */])("PayerID", querylessUrl);
                window.history.pushState({}, document.title, querylessUrl);

                this.thanksUser(excecutePayment);
              }

            case 22:
              _context.next = 27;
              break;

            case 24:
              _context.prev = 24;
              _context.t1 = _context["catch"](12);

              console.log("Paypal execute error", _context.t1);

            case 27:
              _context.next = 29;
              return this.$store.dispatch("getProductById", {
                id: this.productId,
                source: window.location.href,
                appealid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("t"),
                fundid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("f")
              });

            case 29:

              // PURL: Check if there are some query string in URL to prefill the form, Query from donate widget
              q = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("q");

              if (q) {
                decodeq = "?" + window.atob(q);

                console.log("decodeq", decodeq);
                amount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("amount", decodeq);
                email = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("email", decodeq);
                firstname = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("firstname", decodeq);
                lastname = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("lastname", decodeq);
                salutation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("salutation", decodeq);
                wildcardCode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("wildcardCode", decodeq);

                if (wildcardCode) {
                  this.donation.packagecode = wildcardCode;
                }

                dollarhandle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("dollarhandle", decodeq) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("dollarhandle", decodeq).replace("$", "") : undefined;
                dollarhandles = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("dollarhandles", decodeq);

                if (dollarhandles) {
                  // get dollarhandles from query params
                  dollarhandles = dollarhandles.replace(/[^0-9\. ]+/g, "").split(" ");

                  newDollarHandles = [];

                  dollarhandles.forEach(function (v, index) {
                    // Check if there is a product dollar handles index
                    if (_this.product.dollarhandles.Single[index]) {
                      newDollarHandles.push({
                        amount: v,
                        img: _this.product.dollarhandles.Single[index].img,
                        text: _this.product.dollarhandles.Single[index].text
                      });
                    }
                  });

                  this.product.dollarhandles.Single = newDollarHandles;

                  // todo: select Regular as default donation ?
                }

                this.donation.dollarhandle = dollarhandle;
                this.donation.amount = amount;
                this.donation.email = email;
                this.donation.firstname = firstname;
                this.donation.lastname = lastname;
                this.donation.title = salutation;
              }

              // Set default donation type by query param
              dt = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getParameterByName */])("dt");

              if (dt && (dt === "Single" || dt === "Regular")) {
                this.defaultDonationType = dt;
              }

              // Pre-select the doallar handle and the package (rule: first item on the list)
              // As we only have Single and Regular, always set Single as the first option
              defaultTypeExists = this.product.donationtypes.filter(function (e) {
                return e === _this.defaultDonationType;
              }).length === 1;
              defaultType = defaultTypeExists && this.defaultDonationType ? this.defaultDonationType : this.product.appealcodesetting.defaultdonationtype;


              this.product.donationtypes = this.product.donationtypes.sort(function (a, b) {
                if (a === defaultType) {
                  return -1;
                }
                if (b === defaultType) {
                  return 1;
                }
                return 0;
              }); // Reverse alphabetical order

              this.donation.type = defaultType;
              settings = this.product.donationsettings[defaultType];

              if (settings) {
                this.donation.campaignid = settings.campaignid;
                this.donation.fundid = settings.fundid;
              }

              if (!(this.product.producttype != "wildcard")) {
                _context.next = 43;
                break;
              }

              // Pre-select the package (rule: first item on the list)
              this.donation.packagecode = this.product.packages && this.product.packages.length > 0 ? this.product.packages[0] : null;

              _context.next = 43;
              return this.$store.dispatch("getAllPackagesForProduct");

            case 43:

              // GTM: Push datalayer add to cart
              __WEBPACK_IMPORTED_MODULE_7__utils_gtm__["a" /* default */].pushProductDetail(this.product.productname, this.product.id, this.product.producttype, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["b" /* getNameByDonationType */])(this.donation.type));
              this.setLoading(false);

            case 45:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[0, 6], [12, 24]]);
    }));

    function created() {
      return _ref.apply(this, arguments);
    }

    return created;
  }(),
  methods: {
    thanksUser: function thanksUser(donation) {
      var donateThankYouUrl = donation.thankYouUrl;

      if (this.useProductThankYouUrl && donateThankYouUrl || this.thankYouUrl) {
        var query = "firstname=" + donation.firstname;
        query += "&lastname=" + donation.lastname;
        query += "&frequency=" + donation.type;
        query += "&amount=" + donation.amount;
        query += "&source=" + document.URL;

        var params = "?q=" + window.btoa(query);
        var baseUrl = this.useProductThankYouUrl && donateThankYouUrl ? donateThankYouUrl : this.thankYouUrl;
        var url = baseUrl + params;

        // Send data to Google Tag Manager
        __WEBPACK_IMPORTED_MODULE_7__utils_gtm__["a" /* default */].pushPurchase(donation.key, donation.productname, donation.productid, donation.producttype, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["b" /* getNameByDonationType */])(donation.type), donation.amount, donation.postcode, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["c" /* getNameByPaymentType */])("wwf_paypal"), function () {
          setTimeout(function () {
            window.open(url, "_self");
          }, 1000);
        });
      } else {
        window.app.thankyou(donation.amount, donation.type, donation.key, donation.productname, donation.postcode, donation.firstname, donation.lastname, donation.producttype, donation.certificateurl, donation.productid, "wwf_paypal", donation.wildcard ? donation.wildcard.pdf : null);
      }
    },

    setFormStepState: function setFormStepState(previousStep, nextStep) {
      // When the user is going from the 1 to 0 step
      if (previousStep === 1 && nextStep === 0) {
        __WEBPACK_IMPORTED_MODULE_7__utils_gtm__["a" /* default */].pushRemoveFromCart(this.product.productname, this.product.id, this.donation.amount, this.product.producttype, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["b" /* getNameByDonationType */])(this.donation.type));
      }
      this.donation.formWizardCurrentStep = nextStep;
    },
    setLoading: function setLoading(value) {
      this.donation.isLoading = value;
    },
    validateStep: function validateStep(name) {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var refToValidate = _this2.$refs[name];
        var isValid = refToValidate.validate().then(function (response) {
          resolve(true);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    reset: function reset() {
      this.$refs.wizard.changeTab(2, 0);
      this.$store.dispatch("resetDonation");

      // Pre-select the doallar handle and the package (rule: first item on the list)
      this.donation.type = this.product.donationtypes && this.product.donationtypes.length > 0 ? this.product.donationtypes[0] : null;

      var settings = this.product.donationsettings[this.donation.type];
      if (settings) {
        this.donation.campaignid = settings.campaignid;
        this.donation.fundid = settings.fundid;
      }

      this.donation.packagecode = this.product.packages && this.product.packages.length > 0 ? this.product.packages[0] : null;

      console.log("reset");
    },
    retry: function retry() {
      var _this3 = this;

      this.setLoading(true);
      this.$store.dispatch("retryDonation").then(function (response) {
        _this3.$refs.wizard.activateAll();
        _this3.setLoading(false);
      }).catch(function (error) {
        console.error("saveDonation error", error);
      });
      console.log("retry");
    },
    disablesteps: function disablesteps() {
      this.$refs.wizard.desActivateAll();
    }
  }
});

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_gtm__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "product-selector",
  props: {
    productIds: {
      type: String,
      required: true
    }
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])({
    donation: function donation(state) {
      return state.donation.donation;
    },
    product: function product(state) {
      return state.product.product;
    },
    products: function products(state) {
      return state.product.products;
    }
  }),

  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var ids, p, product, i;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // Get the infos about the products
              ids = _this.productIds.split(",");
              _context.next = 3;
              return _this.$store.dispatch("loadMultipleProducts", ids);

            case 3:

              // QUERY PARAM - Read the query to select the default product
              p = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* getParameterByName */])("p");

              if (p) {
                product = _this.products.find(function (e) {
                  return e.id === p;
                });

                if (product) {
                  _this.select(product);
                } else {
                  _this.select(_this.products[0]);
                }
              } else {
                _this.select(_this.products[0]);
              }

              // Fire GTM events
              // For the primary product, fire a product detail
              // For the other one, fire a product impression
              // The product detail for the first item is fired in the "select" method already
              for (i = 1; i < _this.products.length; i++) {
                __WEBPACK_IMPORTED_MODULE_3__utils_gtm__["a" /* default */].pushProductImpression(_this.products[i].productname, _this.products[i].id, _this.products[i].producttype, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers__["b" /* getNameByDonationType */])(_this.donation.type));
              }

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    getProductTypeMapping: function getProductTypeMapping(type) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers__["i" /* getProductTypeMapping */])(type);
    },
    select: function select(product) {
      // Every time the use change the selection, fire new Producrt Detail
      __WEBPACK_IMPORTED_MODULE_3__utils_gtm__["a" /* default */].pushProductDetail(product.productname, product.id, product.producttype, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers__["b" /* getNameByDonationType */])(this.donation.type));

      this.$store.dispatch("getProductById", {
        id: product.id,
        source: window.location.href,
        appealid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* getParameterByName */])("t"),
        fundid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* getParameterByName */])("f")
      });
    }
  }
});

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TaxCalculator_vue__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TaxCalculator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TaxCalculator_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_gtm__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(2);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    TaxCalculator: __WEBPACK_IMPORTED_MODULE_3__TaxCalculator_vue___default.a
  },
  data: function data() {
    return {
      maxAmount: false,
      timeout: null,
      lastTimestamp: Date.now(),
      emailRegex: /.+\@.+\..+/,
      checkEmailLoading: false
    };
  },

  props: {
    useNewCheckout: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    var _this = this;

    // Custom validation for amount (regular/single)
    var donationAmountIsValid = function donationAmountIsValid(amount) {
      if (amount <= 0) {
        return {
          valid: false,
          data: { message: "The amount is invalid" }
        };
      };

      // Get the min amount from the settings of the selected type or the default one if not set
      var customMinAmount = _this.product.donationsettings[_this.donation.type] ? _this.product.donationsettings[_this.donation.type].minimumAmount : undefined;
      var minimumAmount = customMinAmount ? parseFloat(customMinAmount) : _this.type === "Regular" ? 15 : 2;
      var inputAmount = parseInt(_this.donation.amount.replace(/ /g, ''));
      if (amount < minimumAmount) {
        return {
          valid: false,
          data: { message: "The minimum amount is $" + minimumAmount }
        };
      } else if (inputAmount > 75000) {
        return {
          valid: false,
          data: { message: "The maximum amount is $75,000" }
        };
      } else {
        return {
          valid: true
        };
      }
    };

    __WEBPACK_IMPORTED_MODULE_2_vee_validate__["b" /* Validator */].extend("donationAmountIsValid", {
      validate: donationAmountIsValid,
      getMessage: function getMessage(field, params, data) {
        return data.message;
      }
    });

    var donationCheckEmail = function donationCheckEmail(email) {
      if (email.length > 0 && _this.emailRegex.test(email)) {
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          var timestamp = Date.now(); // timestamp for this api call
          _this.lastTimestamp = timestamp; // 1 , 2 , 3
          _this.checkEmailLoading = true;
          // Fetch Suggestions
          _this.$store.dispatch("validateEmail", email).then(function (response) {
            if (response && timestamp >= _this.lastTimestamp) {
              _this.checkEmailLoading = false;
              _this.donation.emailValidation = response;
              resolve(response);
            }
          }).catch(function (err) {
            console.error(err);
            _this.checkEmailLoading = false;
            // If the call failed, do not keep the user from donating
            resolve({
              valid: true
            });
          });
        });
      } else {
        return {
          valid: false,
          data: { message: "Email invalid" }
        };
      }
    };

    __WEBPACK_IMPORTED_MODULE_2_vee_validate__["b" /* Validator */].extend("donationCheckEmail", {
      validate: donationCheckEmail,
      getMessage: function getMessage(field, params, data) {
        return data.message;
      }
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    selectedDonationType: {
      get: function get() {
        return this.donation.type;
      },
      set: function set(newType) {
        this.maxAmount = false;

        this.$store.commit("updateDonation", { field: "type", value: newType });

        // Reset any previous selection like if it was new
        this.$store.commit("updateDonation", {
          field: "dollarhandle",
          value: ""
        });
        this.$store.commit("updateDonation", {
          field: "amount",
          value: ""
        });

        // Update the Campaign ID and the Fund ID with the one of the selected Donation Type
        var settings = this.product.donationsettings[newType];
        if (settings) {
          this.$store.commit("updateDonation", {
            field: "campaignid",
            value: settings.campaignid
          });
          this.$store.commit("updateDonation", {
            field: "fundid",
            value: settings.fundid
          });
        }
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])({
    donation: function donation(state) {
      return state.donation.donation;
    },
    dollarhandle: function dollarhandle(state) {
      return state.donation.donation.dollarhandle;
    },
    type: function type(state) {
      return state.donation.donation.type;
    },
    packagecode: function packagecode(state) {
      return state.donation.donation.packagecode;
    },
    product: function product(state) {
      return state.product.product;
    },
    packages: function packages(state) {
      return state.product.packagesProduct;
    }
  })),
  watch: {
    // When the dollar handle changed update the amount
    dollarhandle: function dollarhandle(newValue, oldValue) {
      this.donation.amount = newValue == "custom" ? null : newValue;
    },
    // When the packagecode changed update the img and pdf for wildcard (TODO)
    packagecode: function packagecode(newValue, oldValue) {
      console.log("packagecode changed", newValue);
      if (this.product.producttype == "wildcard") {
        console.log("packagecode wilcard", this.product.packages);
        this.donation.wildcard.img = this.product.packages.find(function (x) {
          return x.code == newValue;
        }).img;
        this.donation.wildcard.pdf = this.product.packages.find(function (x) {
          return x.code == newValue;
        }).pdf;
      }
    }
  },
  methods: {
    setFocus: function setFocus() {
      setTimeout(function () {
        this.$refs.customhandle[0].focus();
      }.bind(this), 500);
    },
    checkMaxAmount: function checkMaxAmount() {
      var inputAmount = parseInt(this.donation.amount.replace(/ /g, ''));
      if (inputAmount > 75000) {
        this.maxAmount = true;
      } else {
        this.maxAmount = false;
      }
    },
    validate: function validate() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this2.$validator.validateAll().then(function (result) {
          if (!result) {
            console.log("The form on step1 product is invalid");
            reject("The form on step1 product is invalid");
          } else {
            console.log("The form on step1 product is valid");

            // Add .00 if no . and add 0 if no 0 (eg 42.6)
            _this2.donation.amount = _this2.donation.amount.indexOf(".") == -1 ? _this2.donation.amount.concat(".00") : /^\d+(\.\d{1})+$/.test(_this2.donation.amount) ? _this2.donation.amount.concat("0") : _this2.donation.amount;

            _this2.$store.dispatch("saveDonationStep1").then(function (response) {
              // GTM: Push datalayer add to cart
              __WEBPACK_IMPORTED_MODULE_5__utils_gtm__["a" /* default */].pushAddToCart(_this2.product.productname, _this2.product.id, _this2.donation.amount, _this2.product.producttype, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers__["b" /* getNameByDonationType */])(_this2.donation.type));

              if (!_this2.useNewCheckout) {
                _this2.$store.dispatch("checkout").then(function (checkoutResponse) {
                  console.log("mounted: ", checkoutResponse);
                  resolve();
                });
              } else {
                resolve();
              }
            }).catch(function (error) {
              console.error("saveDonation1 error", error);
              reject(error);
            });
          }
        });
      });
    }
  }
});

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SensisAutocomplete__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SensisAutocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SensisAutocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_gtm__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(2);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  components: { SensisAutocomplete: __WEBPACK_IMPORTED_MODULE_3__SensisAutocomplete___default.a, Datepicker: __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker__["a" /* default */] },
  data: function data() {
    var _this = this;

    return {
      timeout: null,
      lastTimestamp: Date.now(),
      checkPhoneLoading: false,
      countriesList: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["g" /* getCountriesList */])(),
      payementType: "wwf_purchasetokenise",
      disabledFn: {
        customPredictor: function customPredictor(date) {
          if (_this.isEarthHour && (__WEBPACK_IMPORTED_MODULE_5_moment___default()(new Date()).isAfter(date, "day") || __WEBPACK_IMPORTED_MODULE_5_moment___default()(date).isAfter(__WEBPACK_IMPORTED_MODULE_5_moment___default()('28-03-2021', 'DD-MM-YYYY'), "day"))) {
            return true;
          } else if (__WEBPACK_IMPORTED_MODULE_5_moment___default()(new Date()).isAfter(date, "day")) {
            return true;
          }
        }
      },
      bequestCheckbox: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* mapState */])({
    donation: function donation(state) {
      return state.donation.donation;
    },
    product: function product(state) {
      return state.product.product;
    },
    packages: function packages(state) {
      return state.product.packagesProduct;
    }
  }), {
    addressSelected: {
      get: function get() {
        return this.$store.getters.step2Data.addressSelected;
      },
      set: function set(value) {
        this.$store.commit("updateStep2Data", {
          field: "addressSelected",
          value: value
        });
      }
    },
    addressgiftSelected: {
      get: function get() {
        return this.$store.getters.step2Data.addressgiftSelected;
      },
      set: function set(value) {
        this.$store.commit("updateStep2Data", {
          field: "addressgiftSelected",
          value: value
        });
      }
    },
    showAddressSuggestions: {
      get: function get() {
        return this.$store.getters.step2Data.showAddressSuggestions;
      },
      set: function set(value) {
        this.$store.commit("updateStep2Data", {
          field: "showAddressSuggestions",
          value: value
        });
      }
    },
    showAddressGiftSuggestions: {
      get: function get() {
        return this.$store.getters.step2Data.showAddressGiftSuggestions;
      },
      set: function set(value) {
        this.$store.commit("updateStep2Data", {
          field: "showAddressGiftSuggestions",
          value: value
        });
      }
    },
    showFullAddress: {
      get: function get() {
        return this.$store.getters.step2Data.showFullAddress;
      },
      set: function set(value) {
        this.$store.commit("updateStep2Data", {
          field: "showFullAddress",
          value: value
        });
      }
    },
    showFullAddressGifts: {
      get: function get() {
        return this.$store.getters.step2Data.showFullAddressGifts;
      },
      set: function set(value) {
        this.$store.commit("updateStep2Data", {
          field: "showFullAddressGifts",
          value: value
        });
      }
    }
  }),
  beforeMount: function beforeMount() {
    this.dynamicId = "shh-" + Date.now().toString();
  },
  created: function created() {
    var _this2 = this;

    var urlParams = new URLSearchParams(window.location.search);
    var param = urlParams.get("legacy");
    this.bequestCheckbox = param && param === 'false' ? false : true;

    var checkPhoneNumber = function checkPhoneNumber(phone) {
      // Only check for australian numbers
      if (_this2.donation.billing.country !== "Australia") {
        return { valid: true };
      } else if (phone.length > 0) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          var timestamp = Date.now(); // timestamp for this api call
          _this2.lastTimestamp = timestamp; // 1 , 2 , 3
          _this2.checkPhoneLoading = true;
          // Fetch Suggestions
          _this2.$store.dispatch("validatePhone", phone).then(function (response) {
            if (response && timestamp >= _this2.lastTimestamp) {
              _this2.checkPhoneLoading = false;
              resolve(response);
            }
          }).catch(function (err) {
            console.error(err);
            _this2.checkPhoneLoading = false;
            // If the call failed, do not keep the user from donating
            resolve({
              valid: true
            });
          });
        });
      } else {
        return {
          valid: false,
          data: { message: "Invalid phone number, try again" }
        };
      }
    };

    __WEBPACK_IMPORTED_MODULE_2_vee_validate__["b" /* Validator */].extend("checkPhoneNumber", {
      validate: checkPhoneNumber,
      getMessage: function getMessage(field, params, data) {
        return data.message;
      }
    });
  },

  props: {
    disabledGoogleAutocomplete: {
      // Attribute for the version of the product
      type: Boolean,
      default: false
    },
    thankYouUrl: {
      // Attribute for the version of the product
      type: String,
      default: null
    },
    useNewCheckout: {
      type: Boolean,
      default: false
    },
    isEarthHour: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getAddressData: function getAddressData(addressData, placeResultData, id) {
      this.donation.billing.unitnumber = addressData.subpremise || null;
      this.donation.billing.streetno = addressData.street_number;
      this.donation.billing.streetname = addressData.route;
      this.donation.billing.postcode = addressData.postal_code;
      this.donation.billing.state = addressData.administrative_area_level_1;
      this.donation.billing.suburb = addressData.locality;
      this.donation.billing.country = addressData.country;
      this.addressSelected = placeResultData.formatted_address || null;
      this.showFullAddress = true;
    },
    getAddressDataGift: function getAddressDataGift(addressData, placeResultData, id) {
      this.donation.gift.unitnumber = addressData.subpremise || null;
      this.donation.gift.streetno = addressData.street_number;
      this.donation.gift.streetname = addressData.route;
      this.donation.gift.postcode = addressData.postal_code;
      this.donation.gift.state = addressData.administrative_area_level_1;
      this.donation.gift.suburb = addressData.locality;
      this.donation.gift.country = addressData.country;
      this.addressgiftSelected = placeResultData.formatted_address || null;
      this.showFullAddressGifts = true;
    },
    countryChanged: function countryChanged() {
      // Sensis Austocomplete is only available for Australia
      if (this.donation.billing.country === "Australia") {
        this.showAddressSuggestions = true;
        this.showAddressGiftSuggestions = true;
        if (!this.addressSelected) {
          this.showFullAddress = false;
        }
        if (!this.addressgiftSelected) {
          this.showFullAddressGifts = false;
        }
      } else {
        this.showFullAddress = true;
        this.showFullAddressGifts = true;
        this.showAddressSuggestions = false;
        this.showAddressGiftSuggestions = false;
      }
    },
    sensisSelectedAddress: function sensisSelectedAddress(address, formattedAddress) {
      this.addressSelected = formattedAddress;
      this.donation.billing = address;
      this.showFullAddress = true;
    },
    sensisSelectedAddressGift: function sensisSelectedAddressGift(address, formattedAddress) {
      this.addressgiftSelected = formattedAddress;
      // Merge to two object, not override
      this.donation.gift = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.donation.gift, address);
      this.showFullAddressGifts = true;
    },
    validate: function validate() {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this3.$validator.validateAll().then(function (result) {
          if (!result) {
            reject("The form on step2 product is invalid");
          } else {
            console.log("Validate - showFullAddress", _this3.showFullAddress);
            var hasErrors = false;
            if (!_this3.showFullAddress && !_this3.disabledGoogleAutocomplete) {
              _this3.errors.add({
                field: _this3.dynamicId,
                msg: "Address required"
              });
              hasErrors = true;
            }

            if (_this3.donation.isGift && !_this3.showFullAddressGifts && !_this3.disabledGoogleAutocomplete && !_this3.donation.isSameAddress) {
              _this3.errors.add({
                field: "gift-map",
                msg: "Address required"
              });
              hasErrors = true;
            }

            if (hasErrors) {
              return reject("Address not entered");
            }

            var hasPayementHasChanged = _this3.payementType != _this3.donation.payementType;

            if (hasPayementHasChanged) {
              _this3.donation.payementType = _this3.payementType;
            }

            _this3.$store.dispatch("saveDonationStep2").then(function (response) {
              // push datalayer checkout
              __WEBPACK_IMPORTED_MODULE_7__utils_gtm__["a" /* default */].pushCheckout(_this3.product.productname, _this3.product.id, _this3.donation.amount, _this3.product.producttype, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["b" /* getNameByDonationType */])(_this3.donation.type));

              if (_this3.donation.payementType == "wwf_paypal") {
                _this3.$store.dispatch("checkoutPaypal").then(function (response) {
                  window.location.href = response;
                }).catch(function (error) {
                  console.error("checkout step 2", error);
                  reject(error);
                });
              } else if (!_this3.useNewCheckout && hasPayementHasChanged) {
                // OLD BAMBORA CHECKOUT
                _this3.$store.dispatch("checkout").then(function (response) {
                  if (response.body.method == "redirect") {
                    window.location.href = response.body.url;
                  } else {
                    resolve();
                  }
                }).catch(function (error) {
                  console.error("checkout step 2", error);
                  reject(error);
                });
              } else {
                resolve();
              }
            }).catch(function (error) {
              console.error("saveDonation2 error", error);
              reject(error);
            });
          }
        });
      });
    }
  }
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VueBamboraCustomCheckout__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VueBamboraCustomCheckout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__VueBamboraCustomCheckout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VueBamboraDirectDebit__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VueBamboraDirectDebit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__VueBamboraDirectDebit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_gtm__ = __webpack_require__(10);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// Helpers



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    VueBamboraCustomCheckout: __WEBPACK_IMPORTED_MODULE_1__VueBamboraCustomCheckout___default.a, // Donation details (packages, handle, donation type, email, payement type)
    VueBamboraDirectDebit: __WEBPACK_IMPORTED_MODULE_2__VueBamboraDirectDebit___default.a
  },
  data: function data() {
    return {
      isiframeLoading: false // OLD BAMBORA CHECKOUT
    };
  },

  props: {
    thankYouUrl: {
      type: String,
      default: null
    },
    useNewCheckout: {
      type: Boolean,
      default: false
    },
    useProductThankYouUrl: {
      type: Boolean,
      default: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    paymentform: function paymentform() {
      if (this.$store.state.donation.donation.payementType == "wwf_purchasetokenise") {
        return "vue-bambora-custom-checkout";
      } else {
        return "vue-bambora-direct-debit";
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])({
    donation: function donation(state) {
      return state.donation.donation;
    },
    packages: function packages(state) {
      return state.product.packagesProduct;
    },
    product: function product(state) {
      return state.product.product;
    }
  })),
  methods: {
    processSuccess: function processSuccess(data) {
      var _this = this;

      // Make the payment
      if (this.donation.payementType == "wwf_purchasetokenise") {
        // CREDIT CARD
        this.$store.dispatch("paymentCreditCard", {
          token: data.token,
          cardHolderName: data.cardHolderName
        }).then(function (result) {
          console.log("Payment success");
          _this.$store.commit("setTransactionId", _this.donation.key);
          _this.$refs.checkout.reset();

          _this.thanksUser();
        }).catch(function (error) {
          console.error("Server Error", error);
          var isRestrictedIP = error.status == 403 && error.body;
          _this.$refs.checkout.reset(isRestrictedIP ? error.body.message : "Oops something happened and we were not able to process your payment, please try again.");
        });
      } else {
        // DIRECT DEBIT
        this.$store.dispatch("paymentDirectDebit", {
          accno: data.accno,
          accrouting: data.accrouting,
          acctitle: data.acctitle
        }).then(function (result) {
          console.log("Payment success");
          _this.$store.commit("setTransactionId", _this.donation.key);
          _this.thanksUser();

          _this.$refs.checkout.reset();
        }).catch(function (error) {
          console.error("Server Error", error);
          _this.$refs.checkout.reset("Oops something happened and we were not able to process your payment, please try again.");
        });
      }
    },
    thanksUser: function thanksUser() {
      console.log("this.donation.thankYouUrl", this.donation.thankYouUrl);
      var donateThankYouUrl = this.donation.thankYouUrl;
      if (this.useProductThankYouUrl && donateThankYouUrl || this.thankYouUrl) {
        var query = "firstname=" + this.donation.firstname;
        query += "&lastname=" + this.donation.lastname;
        query += "&frequency=" + this.donation.type;
        query += "&amount=" + this.donation.amount;
        query += "&source=" + document.URL;

        var params = "?q=" + window.btoa(query);
        var baseUrl = this.useProductThankYouUrl && donateThankYouUrl ? donateThankYouUrl : this.thankYouUrl;
        var url = baseUrl + params;

        // Send data to Google Tag Manager
        __WEBPACK_IMPORTED_MODULE_5__utils_gtm__["a" /* default */].pushPurchase(this.donation.transactionid, this.product.productname, this.product.id, this.product.producttype, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers__["b" /* getNameByDonationType */])(this.donation.type), this.donation.amount, this.donation.billing.postcode, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers__["c" /* getNameByPaymentType */])(this.donation.payementType), function () {
          setTimeout(function () {
            window.open(url, "_self");
          }, 1000);
        });
      } else {
        this.$store.commit("openDonationPopup", true);
      }
    },

    retryPayment: function retryPayment() {
      var _this2 = this;

      this.$store.dispatch("retryDonation").then(function (response) {
        _this2.$refs.checkout.reset();
      }).catch(function (error) {
        console.error("Retry donation error", error);
      });
    },
    load: function load() {
      // OLD BAMBORA CHECKOUT
      this.isiframeLoading = true;
      console.log("src", this.donation.url);
      console.log("is loaded", this.isiframeLoading);
    }
  }
});

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "VueBamboraCustomCheckout",
  data: function data() {
    return {
      isCardNumberComplete: false,
      isCVVComplete: false,
      isExpiryComplete: false,
      isPayButtonDisabled: false,
      customCheckout: customcheckout(),
      cardHolderName: "",
      cardHolderNameError: undefined,
      cardNumberError: undefined,
      cardCVVError: undefined,
      cardExpiryError: undefined,
      serverError: undefined,
      bamboraInputs: {
        cardNumber: undefined,
        expiryTime: undefined,
        cvvNumber: undefined
      },
      failedPayment: false
    };
  },

  props: {
    submitButtonMessage: {
      type: String,
      default: "Pay Now"
    }
  },
  mounted: function mounted() {
    this.initForm();
    this.initCustomeCheckoutEvents();
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapState */])({
    donation: function donation(state) {
      return state.donation.donation;
    }
  }),
  methods: {
    initForm: function initForm() {
      // Set the font size for the inputs inside the injected iframes
      var style = {
        base: {
          fontSize: "15px"
        }
      };
      var options = {
        style: style
      };

      this.cardHolderName = "";

      // Create and mount the inputs
      options.placeholder = "Card number";
      this.bamboraInputs.cardNumber = this.customCheckout.create("card-number", options);
      this.bamboraInputs.cardNumber.mount("#card-number");

      options.placeholder = "CVV / CVC";
      this.bamboraInputs.cvvNumber = this.customCheckout.create("cvv", options);
      this.bamboraInputs.cvvNumber.mount("#card-cvv");

      options.placeholder = "MM / YY";
      this.bamboraInputs.expiryTime = this.customCheckout.create("expiry", options);
      this.bamboraInputs.expiryTime.mount("#card-expiry");
    },
    initCustomeCheckoutEvents: function initCustomeCheckoutEvents() {
      var _this = this;

      this.customCheckout.on("empty", function (event) {
        if (event.empty) {
          if (event.field === "card-number") {
            _this.ToggleCardNumberComplete(false);
          } else if (event.field === "cvv") {
            _this.ToggleCVVComplete(false);
          } else if (event.field === "expiry") {
            _this.ToggleExpiryComplete(false);
          }
        }
      });

      this.customCheckout.on("error", function (event) {
        if (event.field === "card-number") {
          console.log("Card number has errors: ", event);
          _this.cardNumberError = event.message;
        } else if (event.field === "cvv") {
          console.log("CVV has errors: ", event);
          _this.cardCVVError = event.message;
        } else if (event.field === "expiry") {
          console.log("Expiry has errors: ", event);
          _this.cardExpiryError = event.message;
        }
      });

      // Display card brand logo in the card number input
      this.customCheckout.on("brand", function (event) {
        var cardLogo = "none";
        if (event.brand && event.brand !== "unknown") {
          var filePath = "https://cdn.na.bambora.com/downloads/images/cards/" + event.brand + ".svg";
          cardLogo = "url(" + filePath + ")";
        }
        document.getElementById("card-number").style.backgroundImage = cardLogo;
      });

      this.customCheckout.on("complete", function (event) {
        if (event.field === "card-number") {
          _this.cardNumberError = undefined;
          _this.serverError = "";
          _this.ToggleCardNumberComplete(true);
          console.log("Card number is complete: ", event);
        } else if (event.field === "cvv") {
          _this.ToggleCVVComplete(true);
          _this.serverError = "";
          _this.cardCVVError = undefined;
          console.log("CVV is complete: ", event);
        } else if (event.field === "expiry") {
          _this.ToggleExpiryComplete(true);
          _this.cardExpiryError = undefined;
          _this.serverError = "";
          console.log("Expiry is complete: ", event);
        }
      });
    },
    resetForm: function resetForm() {
      this.bamboraInputs.expiryTime.clear();
      this.bamboraInputs.cardNumber.clear();
      this.bamboraInputs.cvvNumber.clear();
      this.cardHolderName = "";

      // No need to reset the "complete" flags. In case of copy paste of a good card, the "complete" trigger won't fire.
      // If the user enter a wrong card number, the "error" trigger will fire anyway.
      // Trying to pay with empty field will just fail the payment.

      document.getElementById("card-number").style.backgroundImage = "";
    },
    resetFormErrors: function resetFormErrors() {
      this.cardNumberError = undefined;
      this.cardCVVError = undefined;
      this.cardExpiryError = undefined;
      this.serverError = undefined;
      this.cardHolderName = "";
    },
    TogglePayButtonDisabled: function TogglePayButtonDisabled(value) {
      //disable pay-button
      this.isPayButtonDisabled = value;
    },
    cardHolderNameIsValid: function cardHolderNameIsValid() {
      return this.cardHolderName && this.cardHolderName.length > 3 ? true : false;
    },
    activatePayButton: function activatePayButton() {
      // Activate Pay Button only if all the field are complete and there is no errors
      return this.isCardNumberComplete && this.isExpiryComplete && this.isCVVComplete && !this.cardNumberError && !this.cardCVVError && !this.cardExpiryError && !this.serverError && this.cardHolderNameIsValid() && !this.isPayButtonDisabled;
    },
    ToggleCardNumberComplete: function ToggleCardNumberComplete(value) {
      this.isCardNumberComplete = value;
    },
    ToggleCVVComplete: function ToggleCVVComplete(value) {
      this.isCVVComplete = value;
    },
    ToggleExpiryComplete: function ToggleExpiryComplete(value) {
      this.isExpiryComplete = value;
    },
    Pay: function Pay() {
      this.TogglePayButtonDisabled(true);
      console.log("Pay::customCheckout.createOneTimeToken()");
      this.customCheckout.createOneTimeToken(wwfconfigs.MERCHANTID, this.processToken);
    },
    processToken: function processToken(result) {
      console.log("token result : ", result);
      if (result.error) {
        this.processTokenError(result.error);
      } else {
        this.processTokenSuccess(result.token);
      }
    },
    processTokenError: function processTokenError(error) {
      console.log("processTokenError: ", error);
      if (error.message) {
        this.serverError = error.message;
      } else {
        this.serverError = 'Unable to process transaction. Please try again later.';
      }
      this.TogglePayButtonDisabled(false);
      this.failedPayment = true;
    },
    processTokenSuccess: function processTokenSuccess(token) {
      console.log("processTokenSuccess: " + token);
      this.serverError = undefined;

      this.$emit("success", {
        token: token,
        cardHolderName: this.cardHolderName
      });
    },
    retry: function retry() {
      this.$emit("retry");
      this.resetForm();
      this.resetFormErrors();
    },

    reset: function reset(error) {
      this.resetForm();
      if (error) {
        this.serverError = error;
        this.failedPayment = true;
      } else {
        this.resetFormErrors();
        this.failedPayment = false;
      }
      this.TogglePayButtonDisabled(false);
    }
  }
});

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "VueBamboraDirectDebit",
  data: function data() {
    return {
      accno: "",
      accrouting: "",
      acctitle: "",
      serverError: "",
      failedPayment: false
    };
  },
  mounted: function mounted() {},

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    donation: function donation(state) {
      return state.donation.donation;
    }
  }),
  methods: {
    enablePayButton: function enablePayButton() {
      return this.acctitle && this.accno && this.accrouting && (!this.errors || !this.errors.items || this.errors.items.length === 0) ? true : false;
    },
    Pay: function Pay() {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.serverError = "";
        _this.$validator.validateAll().then(function (result) {
          if (!result) {
            reject("Direct Debit checkout is invalid.");
          } else {
            _this.$emit("success", {
              accno: _this.accno,
              accrouting: _this.accrouting,
              acctitle: _this.acctitle
            });
          }
        });
      });
    },
    retry: function retry() {
      this.$emit("retry");
      this.resetForm();
    },
    resetForm: function resetForm() {
      this.accno = "", this.accrouting = "";
      this.acctitle = "";
      this.serverError = undefined;
    },
    reset: function reset(error) {
      this.resetForm();
      if (error) {
        this.serverError = error;
        this.failedPayment = true;
      } else {
        this.failedPayment = false;
      }
    }
  }
});

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _name$props$data$comp;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = (_name$props$data$comp = {
  name: "SearchAutocomplete",

  props: {
    classname: String,
    id: String
  },

  data: function data() {
    return {
      userInput: "",
      suggestions: [],
      cursor: 1,
      displaySuggestions: false,
      isLoading: false,
      timeout: null,
      delay: 450, // ms
      minInputLength: 1,
      lastTimestamp: Date.now(),
      fetchingDetails: false
    };
  },

  computed: {
    searchInput: {
      get: function get() {
        return this.$store.getters.searchInput;
      },
      set: function set(value) {
        this.$store.commit("setSearchInput", value);
      }
    }
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$comp, "props", {
  displayIcon: {
    type: Boolean,
    default: false
  },
  displaySearchButton: {
    type: Boolean,
    default: false
  },
  id: {
    type: String,
    default: "search-autocomplete-input"
  },
  classname: {
    type: String,
    default: ""
  },
  // De we redirect the user to the search result page or not after selecting a suggestion
  redirectOnSearch: {
    type: Boolean,
    default: true
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$comp, "watch", {
  searchInput: function searchInput(newVal, oldVal) {
    this.userInput = this.searchInput;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$comp, "mounted", function mounted() {
  this.userInput = this.searchInput;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$props$data$comp, "methods", {
  clickOutside: function clickOutside() {
    this.displaySuggestions = false;
  },
  fetchSearchSuggestions: function fetchSearchSuggestions() {
    var _this = this;

    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }

    // In any case, if the input changed, the suggestions will change
    this.suggestions = [];

    if (this.userInput && this.userInput.length >= this.minInputLength) {
      this.isLoading = true;
      var timestamp = Date.now(); // timestamp for this api call
      this.lastTimestamp = timestamp; // 1 , 2 , 3
      this.timeout = setTimeout(function () {
        _this.displaySuggestions = true;

        // Fetch Suggestions
        _this.$store.dispatch("fetchSearchSuggestions", _this.userInput).then(function (response) {
          if (response && timestamp >= _this.lastTimestamp) {
            _this.suggestions = response.map(function (e, idx) {
              return {
                index: idx + 1,
                label: e
              };
            });

            _this.isLoading = false;
          }
        }).catch(function (err) {
          _this.isLoading = false;
          console.error(err);
        });
      }, this.delay);
    } else {
      this.displaySuggestions = false;
      this.isLoading = false;
    }
  },
  selectSearchSuggestion: function selectSearchSuggestion(item) {
    this.userInput = item;
    this.searchInput = this.userInput;
    this.displaySuggestions = false;
    this.isLoading = false;
    this.suggestions = [];
    this.fetchingDetails = true;

    this.fetchingDetails = false;
    this.$emit("search", item);
    this.$store.commit("emptySelectedFilter");

    // Log search input to Amplitude
    this.$store.dispatch('logSearchEnter', {
      searchValue: item
    });

    var inputElement = document.getElementById(this.id);
    if (inputElement) {
      inputElement.blur();
    }

    if (this.redirectOnSearch) {
      window.location.href = wwfconfigs.SEARCH_RESULTS + "?query=" + item;
    }
  },
  keyUp: function keyUp(event) {
    if (this.displaySuggestions) {
      event.preventDefault();
      if (this.cursor > 1) {
        this.cursor -= 1;
        this.scrollToIndex(this.cursor);
      } else if (this.cursor === 1) {
        this.cursor = this.suggestions.length;
        this.scrollToIndex(this.cursor);
      }
    }
  },
  keyDown: function keyDown() {
    if (this.displaySuggestions) {
      event.preventDefault();
      if (this.cursor < this.suggestions.length) {
        this.cursor += 1;
        this.scrollToIndex(this.cursor);
      } else if (this.cursor === this.suggestions.length) {
        this.cursor = 1;
        this.scrollToIndex(this.cursor);
      }
    }
  },
  keyEnter: function keyEnter() {
    if (this.displaySuggestions && this.suggestions[this.cursor - 1]) {
      this.selectSearchSuggestion(this.suggestions[this.cursor - 1].label);
      this.displaySuggestions = false;
    } else {
      this.selectSearchSuggestion(this.userInput);
    }
  },
  keyEscape: function keyEscape() {
    this.displaySuggestions = false;
    this.suggestions = [];
  },
  scrollToIndex: function scrollToIndex(index) {
    var listElement = document.getElementById("search-suggestion-list");
    var itemElement = document.querySelector("#search-suggestion-list .suggestion-item");
    var itemHeight = itemElement.offsetHeight;
    var scrollTop = listElement.scrollTop;
    var viewport = scrollTop + listElement.offsetHeight;
    var scrollOffset = itemHeight * index - itemHeight;

    if (scrollOffset < scrollTop || scrollOffset + itemHeight > viewport) {
      listElement.scrollTo({
        top: scrollOffset,
        behavior: "smooth"
      });
    }
  }
}), _name$props$data$comp);

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SearchFilter",

  data: function data() {
    return {
      showList: false,
      slicedValues: 9,
      expanded: false
    };
  },

  props: {
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])({
    filters: function filters(state) {
      return state.search.filters;
    },
    selection: function selection(state) {
      return state.search.filters.selection;
    },
    selected: function selected(state) {
      return state.search.filters.selected;
    }
  }), {
    selectedFilters: function selectedFilters() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.selected);
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapMutations */])(["addFilter", "removeFilter"]), {
    selectFilter: function selectFilter(item) {
      this.addFilter(item);

      // Log filter search to Amplitude
      this.$store.dispatch("logSearchFilter", item.label);
    },
    deleteFilter: function deleteFilter(item) {
      this.removeFilter(item);
    },
    toggleShowList: function toggleShowList() {
      this.showList = !this.showList;
    },
    reducedValues: function reducedValues(values) {
      return values.slice(0, this.slicedValues);
    },
    expandedValues: function expandedValues(values) {
      return values.slice(this.slicedValues);
    }
  })
});

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SearchItemWeb__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SearchItemWeb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__SearchItemWeb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SearchItemFaq__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SearchItemFaq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SearchItemFaq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SearchItemYoutube__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SearchItemYoutube___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SearchItemYoutube__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SearchItemTwitter__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SearchItemTwitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SearchItemTwitter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SearchItemInstagram__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SearchItemInstagram___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SearchItemInstagram__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SearchItem",
  components: {
    SearchItemWeb: __WEBPACK_IMPORTED_MODULE_0__SearchItemWeb___default.a,
    SearchItemFaq: __WEBPACK_IMPORTED_MODULE_1__SearchItemFaq___default.a,
    SearchItemYoutube: __WEBPACK_IMPORTED_MODULE_2__SearchItemYoutube___default.a,
    SearchItemTwitter: __WEBPACK_IMPORTED_MODULE_3__SearchItemTwitter___default.a,
    SearchItemInstagram: __WEBPACK_IMPORTED_MODULE_4__SearchItemInstagram___default.a
  },
  computed: {
    collection: function collection() {
      return this.item.collection;
    }
  },
  props: {
    item: {
      type: Object
    }
  }
});

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SearchItemFaq",
  computed: {
    collection: function collection() {
      return this.item.collection;
    }
  },
  props: {
    item: {
      type: Object
    }
  }
});

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SearchItemInstagram",
  computed: {
    collection: function collection() {
      return this.item.collection;
    },
    truncatedText: function truncatedText() {
      if (this.item.metaData.instagramCaption && this.item.metaData.instagramCaption.length > 440) {
        return this.item.metaData.instagramCaption.substring(0, 440) + "...";
      } else {
        return this.item.metaData.instagramCaption;
      }
    }
  },
  props: {
    item: {
      type: Object
    }
  }
});

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SearchItemTwitter",
  computed: {
    collection: function collection() {
      return this.item.collection;
    }
  },
  props: {
    item: {
      type: Object
    }
  }
});

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SearchItemWeb",
  computed: {
    collection: function collection() {
      return this.item.collection;
    }
  },
  props: {
    item: {
      type: Object
    }
  }
});

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SearchYoutubePlayer__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SearchYoutubePlayer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__SearchYoutubePlayer__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SearchItemYoutube",
  components: { SearchYoutubePlayer: __WEBPACK_IMPORTED_MODULE_0__SearchYoutubePlayer___default.a },
  data: function data() {
    return {
      showPlayer: false
    };
  },

  computed: {
    collection: function collection() {
      return this.item.collection;
    }
  },
  props: {
    item: {
      type: Object
    }
  },

  methods: {
    openPlayer: function openPlayer() {
      this.showPlayer = true;
    },
    closePlayer: function closePlayer() {
      this.showPlayer = false;
    }
  }
});

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SearchOption",
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    searchInput: function searchInput(state) {
      return state.search.searchInput;
    },
    options: function options(state) {
      return state.search.options;
    }
  }), {
    selectedSort: {
      get: function get() {
        return this.$store.getters.selectedSort;
      },
      set: function set(value) {
        this.$store.commit("setSelectedSort", value);
      }
    },
    selectedLimit: {
      get: function get() {
        return this.$store.getters.selectedLimit;
      },
      set: function set(value) {
        this.$store.commit("setselectedLimit", value);
      }
    }
  }),
  methods: {
    optionsChanged: function optionsChanged() {
      this.$emit("optionsChanged");
    }
  }
});

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SearchPaginator",
  data: function data() {
    return {
      maxPage: 10,
      pagesDisplayed: 5,
      pagesOnSide: 0, // Will be set in mounted based on pagesDisplayed
      pageLeftover: 0 // Will be set in mounted based on pagesDisplayed
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    currentPage: function currentPage(state) {
      return state.search.options.currentPage;
    },
    selectedLimit: function selectedLimit(state) {
      return state.search.options.selectedLimit;
    },
    totalResults: function totalResults(state) {
      return state.search.options.totalResults;
    }
  })),
  watch: {
    totalResults: function totalResults(newVal, oldVal) {
      this.setMaxPage();
    },
    selectedLimit: function selectedLimit(newVal, oldVal) {
      this.setMaxPage();
    }
  },
  mounted: function mounted() {
    this.maxPage = Math.ceil(this.totalResults / this.selectedLimit);
    this.pagesOnSide = Math.floor(this.pagesDisplayed / 2);
    this.pageLeftover = this.pagesDisplayed % this.pagesOnSide;
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapMutations */])(["setNewPage"]), {
    setMaxPage: function setMaxPage() {
      this.maxPage = Math.ceil(this.totalResults / this.selectedLimit);
      if (this.currentPage > this.maxPage) {
        this.setNewPage(this.maxPage);
      }
    },
    previous: function previous() {
      if (this.currentPage !== 1) {
        this.setNewPage(this.currentPage - 1);
      }
    },
    next: function next() {
      if (this.currentPage !== this.maxPage) {
        this.setNewPage(this.currentPage + 1);
      }
    },
    first: function first() {
      this.setNewPage(1);
    },
    last: function last() {
      console.log(this.maxPage);
      console.log(this.currentPage);
      this.setNewPage(this.maxPage);
    },
    getPageArray: function getPageArray() {
      var pages = [];
      var startPage = 1;
      var endPage = this.maxPage;

      if (this.maxPage <= this.pagesDisplayed) {
        // In this case, too few pages, so display them all
        startPage = 1;
        endPage = this.maxPage;
      } else if (this.currentPage <= this.pagesOnSide) {
        // In this case, currentPage is too close to the beginning
        endPage = 2 * this.pagesOnSide + this.pageLeftover;
      } else if (this.currentPage > this.maxPage - this.pagesOnSide) {
        // In this case, currentPage is too close to the end
        startPage = this.maxPage - this.pagesDisplayed + this.pageLeftover;
        endPage = this.maxPage;
      } else {
        startPage = this.currentPage - this.pagesOnSide;
        endPage = this.currentPage + this.pagesOnSide;
      }

      for (var i = startPage; i <= endPage; i++) {
        pages.push({
          label: i,
          isActive: this.currentPage === i
        });
      }
      // console.log("Start", this.startPage);
      // console.log("End", this.endPage);
      // console.log("pages", pages);

      return pages;
    }
  })
});

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SearchQuickLink",

  data: function data() {
    return {
      items: []
    };
  },
  created: function created() {
    var _this = this;

    this.$store.dispatch("fetchQuickLinks").then(function (response) {
      return _this.items = response;
    }).catch(function (err) {
      console.error(err);
    });
  }
});

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SearchAutocomplete__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SearchAutocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SearchAutocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SearchTabs__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SearchTabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SearchTabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SearchOption__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SearchOption___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SearchOption__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SearchPaginator__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SearchPaginator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SearchPaginator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SearchItem__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SearchItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__SearchItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SearchFilter__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SearchFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__SearchFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SearchQuickLink__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SearchQuickLink___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__SearchQuickLink__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/*
  Types/Tabs:
    response.facets[{name:"Tabs"}]
  Related search:
    response.resultPacket.contextualNavigation.categories
*/

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SearchResult",
  components: {
    SearchAutocomplete: __WEBPACK_IMPORTED_MODULE_1__SearchAutocomplete___default.a,
    SearchTabs: __WEBPACK_IMPORTED_MODULE_2__SearchTabs___default.a,
    SearchOption: __WEBPACK_IMPORTED_MODULE_3__SearchOption___default.a,
    SearchPaginator: __WEBPACK_IMPORTED_MODULE_4__SearchPaginator___default.a,
    SearchItem: __WEBPACK_IMPORTED_MODULE_5__SearchItem___default.a,
    SearchFilter: __WEBPACK_IMPORTED_MODULE_6__SearchFilter___default.a,
    SearchQuickLink: __WEBPACK_IMPORTED_MODULE_7__SearchQuickLink___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* mapState */])({
    currentPage: function currentPage(state) {
      return state.search.options.currentPage;
    },
    selectedTab: function selectedTab(state) {
      return state.search.tabs.selected;
    },
    selectedSort: function selectedSort(state) {
      return state.search.options.selectedSort;
    },
    selectedLimit: function selectedLimit(state) {
      return state.search.options.selectedLimit;
    },
    selectedFilters: function selectedFilters(state) {
      return state.search.filters.selected;
    },
    results: function results(state) {
      return state.search.results;
    }
  }), {
    searchInput: {
      get: function get() {
        return this.$store.getters.searchInput;
      },
      set: function set(value) {
        this.$store.commit("setSearchInput", value);
      }
    }
  }),
  watch: {
    currentPage: function currentPage(newVal, oldVal) {
      this.search();
    },
    selectedTab: function selectedTab(newVal, oldVal) {
      this.search();
    },
    selectedSort: function selectedSort(newVal, oldVal) {
      this.search();
    },
    selectedLimit: function selectedLimit(newVal, oldVal) {
      this.search();
    },
    selectedFilters: function selectedFilters(newVal, oldVal) {
      this.search();
    }
  },
  created: function created() {
    var uri = window.location.search.substring(1);
    if (uri.length > 0) {
      var params = new URLSearchParams(uri);
      var query = params.get("query");
      if (query) {
        this.searchInput = query;
        // Remove the query params from the URL
        var querylessUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helpers__["e" /* removeURLParameter */])("query");
        window.history.pushState({}, document.title, querylessUrl);
      }
    }
  },
  mounted: function mounted() {
    this.search();
  },


  methods: {
    search: function search() {
      this.$store.dispatch("fetchSearchResults").then(function (response) {}).catch(function (err) {
        console.error(err);
      });
    }
  }
});

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SearchTabs",
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    search: function search(state) {
      return state.search;
    },
    tabs: function tabs(state) {
      return state.search.tabs;
    },
    selected: function selected(state) {
      return state.search.tabs.selected;
    },
    selection: function selection(state) {
      return state.search.tabs.selection;
    }
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapMutations */])(["setNewTab"]))
});

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SearchYoutubePlayer",
  data: function data() {
    return {
      player: null
    };
  },

  computed: {
    videoId: function videoId() {
      return this.item.metaData.videoId;
    }
  },
  props: {
    item: {
      type: Object
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isOpen: function isOpen(newVal, oldVal) {
      if (newVal) {
        this.open();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    if (!this.reveal) {
      var el = $("#modal-ytvideo-" + this.videoId);
      this.reveal = new Foundation.Reveal(el, {
        animationIn: "fade-in-up fast"
      });

      el.on("closed.zf.reveal", function () {
        _this.player.stopVideo();
        _this.$emit("closed");
      });
    }
  },


  methods: {
    open: function open() {
      this.reveal.open();
    },
    close: function close() {
      this.player.stopVideo();
      this.$emit("closed");
    },
    ready: function ready(player) {
      this.player = player;
      this.player.playVideo();
    }
  }
});

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "amplitude",

  props: {
    id: {
      type: String,
      required: true
    }
  },
  computed: {
    htmlId: function htmlId() {
      return this.id.replaceAll(" ", "-");
    }
  },

  created: function created() {
    this.$store.dispatch("logLandingVisit", this.id);

    console.log('this.id', this.id);

    if (this.id === "earth-hour") {
      this.$store.dispatch("logEarthHourVisit", {
        id: this.id,
        eventName: 'EH homepage viewed'
      });
    }
    if (this.id === "earth-hour-register") {
      this.$store.dispatch("logEarthHourVisit", {
        id: this.id,
        eventName: 'EH registration page viewed'
      });
    }
  },
  mounted: function mounted() {
    if (this.id == "ra hub") {
      // Attach amplitude event for product clicks
      var cards = $(".ra-hub-cards a");
      cards.click({ callback: this.logProductClick }, function (e) {
        e.preventDefault();
        try {
          // Extract link filename for id
          var paths = this.pathname.split("/");
          var id = paths[paths.length - 1] || paths[paths.length - 2];
          e.data.callback({ id: id, link: this.href });
        } catch (err) {
          console.error(err);
        }
      });
    }

    // Attach amplitude event for FAQ clicks
    if (["native adoption", "international adoption"].includes(this.id)) {
      $("#faq .faq-accordian a").click({ callback: this.logFaqClick }, function (e) {
        e.preventDefault();
        try {
          var faqTitle = $(this).text();
          e.data.callback(faqTitle);
        } catch (err) {
          console.error(err);
        }
      });
    }

    if (this.id === "earth-hour") {
      $("a.eh-down").click({ callback: this.logDownArrow }, function (e) {
        e.preventDefault();
        try {
          e.data.callback(this.href);
        } catch (err) {
          console.error(err);
        }
      });
    }
  },


  methods: {
    logProductClick: function logProductClick(_ref) {
      var id = _ref.id,
          link = _ref.link;

      this.$store.dispatch("logProductLink", { id: id, link: link }).then(function () {
        return window.location.href = link;
      });
    },
    logFaqClick: function logFaqClick(faq) {
      this.$store.dispatch("logFaq", faq);
    },
    logDownArrow: function logDownArrow(link) {
      this.$store.dispatch("logEarthHourDownArrow", link);
    }
  }
});

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "last-signatures",

  data: function data() {
    return {
      signatures: [],
      updatingTimes: false,
      interval: null,
      subscriptions: []
    };
  },

  props: {
    campaigId: {
      type: String,
      required: true
    },
    numberOfSignatures: {
      type: Number,
      default: 5
    },
    iconSource: {
      type: String,
      default: "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/user-icon.png"
    },
    classes: {
      type: String,
      required: false
    },
    action: {
      type: String,
      default: "signed"
    }
  },

  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = _this.subscriptions;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4_firebase__["a" /* default */].firestore().collection("signatures").where("campaigId", "==", _this.campaigId).orderBy("signatureDate", "desc").limit(_this.numberOfSignatures).onSnapshot(function (snapshot) {
                var datas = [];
                snapshot.forEach(function (e) {
                  return datas.push(e.data());
                });
                _this.signatures = _this.updateTimeDifference(datas, true);
              }, function (error) {
                console.error(error);
              });

            case 3:
              _context.t1 = _context.sent;

              _context.t0.push.call(_context.t0, _context.t1);

              // Update the time signed
              setInterval(function () {
                _this.signatures = _this.updateTimeDifference(_this.signatures);
              }, 60000);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.interval) {
      clearInterval(interval);
    }

    // Unsubscript from all subscriptions
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.subscriptions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var unsub = _step.value;

        unsub();
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  },


  methods: {
    updateTimeDifference: function updateTimeDifference(data, forced) {
      if (this.updatingTimes && !forced) {
        return data;
      }

      this.updatingTimes = true;
      var table = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data));
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(table), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var d = _step2.value;

          var timeDifference = __WEBPACK_IMPORTED_MODULE_5_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_5_moment___default()(d.signatureDate), "minutes");
          var difference = timeDifference + " minute" + (+timeDifference > 1 ? "s" : "") + " ago";
          if (timeDifference === 0) {
            difference = "now";
          } else if (timeDifference >= 60 && timeDifference < 1440) {
            timeDifference = __WEBPACK_IMPORTED_MODULE_5_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_5_moment___default()(d.signatureDate), "hours");
            difference = timeDifference + " hour" + (+timeDifference > 1 ? "s" : "") + " ago";
          } else if (timeDifference >= 1440) {
            timeDifference = __WEBPACK_IMPORTED_MODULE_5_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_5_moment___default()(d.signatureDate), "days");
            difference = timeDifference + " day" + (+timeDifference > 1 ? "s" : "") + " ago";
          }
          // Assign the value
          d.timeDifference = difference;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      this.updatingTimes = false;
      return table;
    }
  }
});

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);





//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "rich-content-display",
  data: function data() {
    return {
      defaultContent: null,
      contents: [],
      currentContentId: null,
      currentContent: null
    };
  },

  props: {
    defaultContentId: {
      type: String,
      required: false
    }
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])({
    products: function products(state) {
      return state.product.products;
    },
    product: function product(state) {
      return state.product.product;
    },
    donationType: function donationType(state) {
      return state.donation.donation.type;
    }
  }),
  watch: {
    products: function products(newVal, oldVal) {
      var contentIds = newVal.map(function (e) {
        var keys = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(e.donationsettings);
        var data = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(keys), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var k = _step.value;

            if (e.donationsettings[k].contentMessageId) {
              data.push(e.donationsettings[k].contentMessageId);
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return data;
      });
      var ids = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(contentIds), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var i = _step2.value;

          ids.push.apply(ids, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(i));
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      this.fetchContents(ids);
    },
    product: function product(newVal, oldVal) {
      this.loadNewContent();
    },
    donationType: function donationType(newVal, oldVal) {
      this.loadNewContent();
    }
  },
  created: function created() {
    var _this = this;

    if (this.defaultContentId) {
      this.$store.dispatch("getContentMessageById", this.defaultContentId).then(function (value) {
        _this.defaultContent = value.content;
        _this.loadNewContent();
      });
    }
  },

  methods: {
    fetchContents: function fetchContents(ids) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.$store.dispatch("getContentMessageById", ids.join(",")).then(function (value) {
                  _this2.contents = value;
                  _this2.loadNewContent();
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    loadNewContent: function loadNewContent() {
      var settings = this.product ? this.product.donationsettings[this.donationType] : null;
      var id = null;

      // Load the selected product for the selected type if it's available for this product
      if (settings) {
        id = settings.contentMessageId;
      } else {
        // Otherwise, take the first type available
        var contentMessageId = this.product ? this.product.donationsettings[0].contentMessageId : null;
        if (contentMessageId) {
          id = contentMessageId;
        } else {
          id = this.defaultContentId;
        }
      }

      if (id) {
        this.currentContentId = id;
        var message = this.contents.find(function (e) {
          return e.id === id;
        });
        this.currentContent = message ? message.content : this.defaultContent;
      } else if (this.defaultContentId && this.defaultContent) {
        this.currentContentId = this.defaultContentId;
        this.currentContent = this.defaultContent;
      } else {
        this.currentContentId = null;
        this.currentContent = null;
      }
    }
  }
});

/***/ }),
/* 416 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 417 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 418 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 419 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 420 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 421 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 422 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 423 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 424 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 425 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 426 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 427 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 428 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 429 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 430 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 431 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 432 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 433 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 434 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 435 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 436 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 437 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 438 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 439 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 440 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 441 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 442 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 443 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 444 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 445 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 446 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 447 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 448 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 449 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 450 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 451 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 452 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 453 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 454 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 455 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 456 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 457 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 458 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 459 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 460 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 461 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 462 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 463 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 464 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 465 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 466 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 467 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 468 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 469 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 470 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 471 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 472 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 473 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 474 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 475 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 476 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 477 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 478 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 479 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 480 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 481 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 482 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 483 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 484 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 485 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 486 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 487 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 488 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 489 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 490 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 491 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 492 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 493 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 494 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 495 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 496 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 497 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 498 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 499 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 500 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 501 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 502 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 503 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 504 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 505 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 506 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 507 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 508 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 509 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 510 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 511 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 512 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 513 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 514 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 515 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 516 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 517 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 518 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 519 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 520 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 521 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 522 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 523 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 524 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 83,
	"./af.js": 83,
	"./ar": 90,
	"./ar-dz": 84,
	"./ar-dz.js": 84,
	"./ar-kw": 85,
	"./ar-kw.js": 85,
	"./ar-ly": 86,
	"./ar-ly.js": 86,
	"./ar-ma": 87,
	"./ar-ma.js": 87,
	"./ar-sa": 88,
	"./ar-sa.js": 88,
	"./ar-tn": 89,
	"./ar-tn.js": 89,
	"./ar.js": 90,
	"./az": 91,
	"./az.js": 91,
	"./be": 92,
	"./be.js": 92,
	"./bg": 93,
	"./bg.js": 93,
	"./bm": 94,
	"./bm.js": 94,
	"./bn": 95,
	"./bn.js": 95,
	"./bo": 96,
	"./bo.js": 96,
	"./br": 97,
	"./br.js": 97,
	"./bs": 98,
	"./bs.js": 98,
	"./ca": 99,
	"./ca.js": 99,
	"./cs": 100,
	"./cs.js": 100,
	"./cv": 101,
	"./cv.js": 101,
	"./cy": 102,
	"./cy.js": 102,
	"./da": 103,
	"./da.js": 103,
	"./de": 106,
	"./de-at": 104,
	"./de-at.js": 104,
	"./de-ch": 105,
	"./de-ch.js": 105,
	"./de.js": 106,
	"./dv": 107,
	"./dv.js": 107,
	"./el": 108,
	"./el.js": 108,
	"./en-au": 109,
	"./en-au.js": 109,
	"./en-ca": 110,
	"./en-ca.js": 110,
	"./en-gb": 111,
	"./en-gb.js": 111,
	"./en-ie": 112,
	"./en-ie.js": 112,
	"./en-il": 113,
	"./en-il.js": 113,
	"./en-nz": 114,
	"./en-nz.js": 114,
	"./eo": 115,
	"./eo.js": 115,
	"./es": 118,
	"./es-do": 116,
	"./es-do.js": 116,
	"./es-us": 117,
	"./es-us.js": 117,
	"./es.js": 118,
	"./et": 119,
	"./et.js": 119,
	"./eu": 120,
	"./eu.js": 120,
	"./fa": 121,
	"./fa.js": 121,
	"./fi": 122,
	"./fi.js": 122,
	"./fo": 123,
	"./fo.js": 123,
	"./fr": 126,
	"./fr-ca": 124,
	"./fr-ca.js": 124,
	"./fr-ch": 125,
	"./fr-ch.js": 125,
	"./fr.js": 126,
	"./fy": 127,
	"./fy.js": 127,
	"./gd": 128,
	"./gd.js": 128,
	"./gl": 129,
	"./gl.js": 129,
	"./gom-latn": 130,
	"./gom-latn.js": 130,
	"./gu": 131,
	"./gu.js": 131,
	"./he": 132,
	"./he.js": 132,
	"./hi": 133,
	"./hi.js": 133,
	"./hr": 134,
	"./hr.js": 134,
	"./hu": 135,
	"./hu.js": 135,
	"./hy-am": 136,
	"./hy-am.js": 136,
	"./id": 137,
	"./id.js": 137,
	"./is": 138,
	"./is.js": 138,
	"./it": 139,
	"./it.js": 139,
	"./ja": 140,
	"./ja.js": 140,
	"./jv": 141,
	"./jv.js": 141,
	"./ka": 142,
	"./ka.js": 142,
	"./kk": 143,
	"./kk.js": 143,
	"./km": 144,
	"./km.js": 144,
	"./kn": 145,
	"./kn.js": 145,
	"./ko": 146,
	"./ko.js": 146,
	"./ky": 147,
	"./ky.js": 147,
	"./lb": 148,
	"./lb.js": 148,
	"./lo": 149,
	"./lo.js": 149,
	"./lt": 150,
	"./lt.js": 150,
	"./lv": 151,
	"./lv.js": 151,
	"./me": 152,
	"./me.js": 152,
	"./mi": 153,
	"./mi.js": 153,
	"./mk": 154,
	"./mk.js": 154,
	"./ml": 155,
	"./ml.js": 155,
	"./mn": 156,
	"./mn.js": 156,
	"./mr": 157,
	"./mr.js": 157,
	"./ms": 159,
	"./ms-my": 158,
	"./ms-my.js": 158,
	"./ms.js": 159,
	"./mt": 160,
	"./mt.js": 160,
	"./my": 161,
	"./my.js": 161,
	"./nb": 162,
	"./nb.js": 162,
	"./ne": 163,
	"./ne.js": 163,
	"./nl": 165,
	"./nl-be": 164,
	"./nl-be.js": 164,
	"./nl.js": 165,
	"./nn": 166,
	"./nn.js": 166,
	"./pa-in": 167,
	"./pa-in.js": 167,
	"./pl": 168,
	"./pl.js": 168,
	"./pt": 170,
	"./pt-br": 169,
	"./pt-br.js": 169,
	"./pt.js": 170,
	"./ro": 171,
	"./ro.js": 171,
	"./ru": 172,
	"./ru.js": 172,
	"./sd": 173,
	"./sd.js": 173,
	"./se": 174,
	"./se.js": 174,
	"./si": 175,
	"./si.js": 175,
	"./sk": 176,
	"./sk.js": 176,
	"./sl": 177,
	"./sl.js": 177,
	"./sq": 178,
	"./sq.js": 178,
	"./sr": 180,
	"./sr-cyrl": 179,
	"./sr-cyrl.js": 179,
	"./sr.js": 180,
	"./ss": 181,
	"./ss.js": 181,
	"./sv": 182,
	"./sv.js": 182,
	"./sw": 183,
	"./sw.js": 183,
	"./ta": 184,
	"./ta.js": 184,
	"./te": 185,
	"./te.js": 185,
	"./tet": 186,
	"./tet.js": 186,
	"./tg": 187,
	"./tg.js": 187,
	"./th": 188,
	"./th.js": 188,
	"./tl-ph": 189,
	"./tl-ph.js": 189,
	"./tlh": 190,
	"./tlh.js": 190,
	"./tr": 191,
	"./tr.js": 191,
	"./tzl": 192,
	"./tzl.js": 192,
	"./tzm": 194,
	"./tzm-latn": 193,
	"./tzm-latn.js": 193,
	"./tzm.js": 194,
	"./ug-cn": 195,
	"./ug-cn.js": 195,
	"./uk": 196,
	"./uk.js": 196,
	"./ur": 197,
	"./ur.js": 197,
	"./uz": 199,
	"./uz-latn": 198,
	"./uz-latn.js": 198,
	"./uz.js": 199,
	"./vi": 200,
	"./vi.js": 200,
	"./x-pseudo": 201,
	"./x-pseudo.js": 201,
	"./yo": 202,
	"./yo.js": 202,
	"./zh-cn": 203,
	"./zh-cn.js": 203,
	"./zh-hk": 204,
	"./zh-hk.js": 204,
	"./zh-tw": 205,
	"./zh-tw.js": 205
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 525;

/***/ }),
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(482)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(702),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(488)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(328),
  /* template */
  __webpack_require__(709),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-93abe360",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(479)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(699),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7123de4e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(452)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(333),
  /* template */
  __webpack_require__(675),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-39f129be",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(334),
  /* template */
  __webpack_require__(648),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(499)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(335),
  /* template */
  __webpack_require__(721),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ac2ea378",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(336),
  /* template */
  __webpack_require__(653),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(432)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(337),
  /* template */
  __webpack_require__(655),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1b13e55e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(427)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(338),
  /* template */
  __webpack_require__(649),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-17aa62d2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(510)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(339),
  /* template */
  __webpack_require__(734),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d40f66d2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(438)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(341),
  /* template */
  __webpack_require__(661),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(450)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(342),
  /* template */
  __webpack_require__(673),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-37e25a2b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(472)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(344),
  /* template */
  __webpack_require__(693),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-599c586a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(494)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(351),
  /* template */
  __webpack_require__(716),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a7bf00da",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(426)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(352),
  /* template */
  __webpack_require__(647),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1592ef42",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(490)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(354),
  /* template */
  __webpack_require__(711),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-97e3dc60",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(418)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(355),
  /* template */
  __webpack_require__(639),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-051d9e96",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(518)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(356),
  /* template */
  __webpack_require__(740),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-edb4bdc4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(435)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(368),
  /* template */
  __webpack_require__(658),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-210be5ed",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(471)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(369),
  /* template */
  __webpack_require__(692),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-54bdb1ce",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(467)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(370),
  /* template */
  __webpack_require__(689),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5147ad48",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(420)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(375),
  /* template */
  __webpack_require__(641),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0c669cae",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(506)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(376),
  /* template */
  __webpack_require__(729),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c9b5995e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(504)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(378),
  /* template */
  __webpack_require__(727),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c79e8696",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(442)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(380),
  /* template */
  __webpack_require__(664),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-29bc5a72",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(468)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(381),
  /* template */
  __webpack_require__(690),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-515e5eba",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(455)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(382),
  /* template */
  __webpack_require__(677),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3ad51c86",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(417)
  __webpack_require__(416)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(383),
  /* template */
  __webpack_require__(638),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0047f2ce",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(449)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(385),
  /* template */
  __webpack_require__(672),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-35ece93e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(457)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(398),
  /* template */
  __webpack_require__(679),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(425)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(400),
  /* template */
  __webpack_require__(646),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-14bc5b22",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(478)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(401),
  /* template */
  __webpack_require__(698),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6744e1bd",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(473)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(402),
  /* template */
  __webpack_require__(694),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5a499d49",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(492)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(403),
  /* template */
  __webpack_require__(714),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9f5868b6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(430)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(404),
  /* template */
  __webpack_require__(652),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1a2c00a6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(451)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(405),
  /* template */
  __webpack_require__(674),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-38d8e2f2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(524)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(406),
  /* template */
  __webpack_require__(745),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fac4ad54",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(484)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(407),
  /* template */
  __webpack_require__(705),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-79a55cc2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(481)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(408),
  /* template */
  __webpack_require__(701),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7257abd7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(459)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(409),
  /* template */
  __webpack_require__(681),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3eeb4f66",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(441)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(411),
  /* template */
  __webpack_require__(663),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-27dd26b0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(498)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(412),
  /* template */
  __webpack_require__(720),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ab6b49ac",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(509)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(414),
  /* template */
  __webpack_require__(733),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ce8939f8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 638 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lr-thank-you",
    class: {
      'is-donation': _vm.isDonation
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.thankYouText))]), _vm._v(" "), (_vm.isDonation) ? _c('div', {
    staticClass: "lr-ty-donation"
  }, [_c('p', [_c('span', {
    staticClass: "in-focus"
  }, [_vm._v(_vm._s(_vm.supporter.firstName) + " " + _vm._s(_vm.supporter.lastName))]), _vm._v(", thank you for your donation of\n      "), _c('span', {
    staticClass: "in-focus"
  }, [_vm._v("$ " + _vm._s(_vm.donation.amount))])]), _vm._v(" "), _c('p', {
    staticClass: "minimal"
  }, [_vm._v("\n      Please check your email for confirmation. If you don’t receive an email,\n      please note that due to the high volume of donations we’ve received, it\n      may take longer than normal for us to process your payment receipt.\n    ")]), _vm._v(" "), _vm._m(0, false, false)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ls-ty-share"
  }, [_c('p', [_vm._v("\n      " + _vm._s(_vm.getSocialText) + "\n    ")])]), _vm._v(" "), _vm._m(1, false, false)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "minimal"
  }, [_vm._v("\n      For urgent questions, please call our supporter relations team on\n      "), _c('a', {
    attrs: {
      "href": "tel:1800032551"
    }
  }, [_vm._v("1800 032 551")]), _vm._v(".\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gs-wrapper"
  }, [_c('div', {
    staticClass: "getsocial gs-inline-group"
  })])
}]}

/***/ }),
/* 639 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selection"
  }, [_c('button', {
    class: _vm.selectedProductType === 'wildcard' ? 'selected' : '',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.changeTypeTo('wildcard')
      }
    }
  }, [_vm._v("\n    Wildcard\n  ")]), _vm._v(" "), _c('button', {
    class: _vm.selectedProductType === 'adoption' ? 'selected' : '',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.changeTypeTo('adoption')
      }
    }
  }, [_vm._v("\n    Adopt\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 640 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wwf-richmond-fc-form"
  }, [(_vm.showcounter) ? _c('div', {
    staticClass: "petition-counter"
  }, [_c('h2', [_c('count-to', {
    ref: "counter",
    attrs: {
      "startVal": _vm.startcounter,
      "end-val": _vm.endcounter,
      "autoplay": false,
      "duration": 7000
    }
  })], 1), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.countertitle))])]) : _vm._e(), _vm._v(" "), (_vm.isActive) ? _c('div', {
    staticClass: "petition-form wwf-form light"
  }, [_c('div', {
    staticClass: "flip-wrapper",
    class: {
      'formValidation-shake': _vm.isShake
    }
  }, [_c('div', {
    staticClass: "petition-form"
  }, [_c('h3', {
    staticClass: "form-intro"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "form-intro"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.intro)
    }
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "small-12 medium-6 columns left-field field-title"
  }, [_c('div', {
    staticClass: "field",
    class: this.firstName ? 'has-content' : ''
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true}"
    }],
    class: {
      'border-red': _vm.errors.has('firstName')
    },
    attrs: {
      "name": "firstName",
      "type": "text"
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "firstName"
    }
  }, [_vm._v("Parent's First name")])])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 medium-6 columns right-field field-title"
  }, [_c('div', {
    staticClass: "field",
    class: this.lastName ? 'has-content' : ''
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true}"
    }],
    class: {
      'border-red': _vm.errors.has('lastName')
    },
    attrs: {
      "name": "lastName",
      "type": "text"
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "lastName"
    }
  }, [_vm._v("Parent's surname")])])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 medium-6 columns left-field field-title"
  }, [_c('div', {
    staticClass: "field",
    class: this.childFirstName ? 'has-content' : ''
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.childFirstName),
      expression: "childFirstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true}"
    }],
    class: {
      'border-red': _vm.errors.has('childFirstName')
    },
    attrs: {
      "name": "childFirstName",
      "type": "text"
    },
    domProps: {
      "value": (_vm.childFirstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.childFirstName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "childFirstName"
    }
  }, [_vm._v("Child's First name")])])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 medium-6 columns right-field field-title"
  }, [_c('div', {
    staticClass: "field",
    class: this.childLastName ? 'has-content' : ''
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.childLastName),
      expression: "childLastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true}"
    }],
    class: {
      'border-red': _vm.errors.has('childLastName')
    },
    attrs: {
      "name": "childLastName",
      "type": "text"
    },
    domProps: {
      "value": (_vm.childLastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.childLastName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "childLastName"
    }
  }, [_vm._v("Child's surname")])])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 medium-6 columns left-field field-title"
  }, [_c('div', {
    staticClass: "field",
    class: this.childDob ? 'has-content' : ''
  }, [_c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "disabledDates": _vm.disabledFn,
      "name": "childDob",
      "minimumView": 'day',
      "format": 'dd/MM/yyyy',
      "input-class": {
        'border-red': _vm.errors.has('childDob')
      },
      "maximumView": 'year',
      "initialView": 'day'
    },
    model: {
      value: (_vm.childDob),
      callback: function($$v) {
        _vm.childDob = $$v
      },
      expression: "childDob"
    }
  }), _vm._v(" "), _vm._m(0, false, false)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "small-12 medium-6 columns right-field field-title"
  }, [_c('div', {
    staticClass: "field",
    class: this.postCode ? 'has-content' : ''
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postCode),
      expression: "postCode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true}"
    }],
    class: {
      'border-red': _vm.errors.has('postCode')
    },
    attrs: {
      "name": "postCode",
      "type": "number"
    },
    domProps: {
      "value": (_vm.postCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.postCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "postCode"
    }
  }, [_vm._v("Postcode")])])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 medium-6 columns left-field field-title"
  }, [_c('div', {
    staticClass: "field",
    class: this.email ? 'has-content' : ''
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        email: true
      }),
      expression: "{ required: true, email: true}"
    }],
    class: {
      'border-red': _vm.errors.has('email')
    },
    attrs: {
      "name": "email",
      "type": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")])])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 medium-6 columns right-field field-title"
  }, [_c('div', {
    staticClass: "field",
    class: this.phone ? 'has-content' : ''
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true}"
    }],
    class: {
      'border-red': _vm.errors.has('phone')
    },
    attrs: {
      "name": "phone",
      "type": "number",
      "min": "8",
      "max": "12"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Mobile")])])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 medium-12 columns field-title"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'border-red': _vm.errors.has('message')
    },
    attrs: {
      "name": "message",
      "placeholder": _vm.messageplaceholder,
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "word-count"
  }, [_vm._v(_vm._s(255 - (_vm.message ? _vm.message.length : 0) + ' Char'))])]), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "Submit"
    },
    on: {
      "click": _vm.save
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isProfanity),
      expression: "isProfanity"
    }],
    staticClass: "alert-box"
  }, [_vm._v("No bad words! Please change your message.")])])])])]) : _vm._e(), _vm._v(" "), (!_vm.isActive) ? _c('div', {
    staticClass: "form-closed"
  }, [_c('p', [_vm._v(_vm._s(_vm.closingmessage))])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "childDob"
    }
  }, [_vm._v("\n                Child's D.O.B\n                "), _c('i', {
    staticClass: "far fa-calendar-alt"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "privacy-statement small-12 medium-12 columns field-title"
  }, [_c('p', [_vm._v("\n              By signing you accept\n              "), _c('a', {
    attrs: {
      "href": "/privacy-policy/privacy-policy",
      "target": "_blank"
    }
  }, [_vm._v("WWF-Australia’s Privacy Policy.")])])])
}]}

/***/ }),
/* 641 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-content"
  }, [_c('Selector', {
    ref: "Selector",
    attrs: {
      "petitionSelector": _vm.petitionSelector,
      "donationSelector": _vm.donationSelector,
      "petitionHandle": _vm.petitionHandle
    },
    on: {
      "firstTouch": function($event) {
        _vm.logFirstTouch('leaf relief type')
      }
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "wwf-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supporter.firstName),
      expression: "supporter.firstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      error: _vm.errors.has('firstName'),
        empty: !_vm.supporter.firstName,
    },
    attrs: {
      "name": "firstName",
      "type": "text",
      "data-vv-as": "first name",
      "placeholder": " ",
      "autocomplete": "given-name"
    },
    domProps: {
      "value": (_vm.supporter.firstName)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('first name')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supporter, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "firstName"
    }
  }, [_vm._v("First Name*")]), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.has('firstName')) ? _c('p', [_vm._v("\n            " + _vm._s(_vm.errors.first("firstName")) + "\n          ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "wwf-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supporter.lastName),
      expression: "supporter.lastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      error: _vm.errors.has('lastName'),
        empty: !_vm.supporter.lastName,
    },
    attrs: {
      "name": "lastName",
      "type": "text",
      "data-vv-as": "last name",
      "placeholder": " ",
      "autocomplete": "family-name"
    },
    domProps: {
      "value": (_vm.supporter.lastName)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('last name')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supporter, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "lastName"
    }
  }, [_vm._v("Last Name*")]), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.has('lastName')) ? _c('p', [_vm._v("\n            " + _vm._s(_vm.errors.first("lastName")) + "\n          ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "wwf-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supporter.email),
      expression: "supporter.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        leafReliefCheckEmail: true
      }),
      expression: "{ required: true, leafReliefCheckEmail: true }"
    }],
    class: {
      error: _vm.errors.has('email'),
        empty: !_vm.supporter.email,
    },
    attrs: {
      "id": "email",
      "name": "email",
      "type": "email",
      "placeholder": " ",
      "autocomplete": "email"
    },
    domProps: {
      "value": (_vm.supporter.email)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('email')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supporter, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email*")]), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.has('email')) ? _c('p', [_vm._v("\n            " + _vm._s(_vm.errors.first("email")) + "\n          ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "wwf-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supporter.postcode),
      expression: "supporter.postcode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        alpha_num: true
      }),
      expression: "{ required: true, alpha_num: true }"
    }],
    class: {
      error: _vm.errors.has('postcode'),
        empty: !_vm.supporter.postcode,
    },
    attrs: {
      "name": "postcode",
      "type": "text",
      "data-vv-as": "postcode",
      "placeholder": " ",
      "autocomplete": "postal-code"
    },
    domProps: {
      "value": (_vm.supporter.postcode)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('postcode')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supporter, "postcode", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "postcode"
    }
  }, [_vm._v("Postcode*")]), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.has('postcode')) ? _c('p', [_vm._v("\n            " + _vm._s(_vm.errors.first("postcode")) + "\n          ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "wwf-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supporter.phoneNumber),
      expression: "supporter.phoneNumber"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      error: _vm.errors.has('phone'),
        empty: !_vm.supporter.phoneNumber,
    },
    attrs: {
      "name": "phone",
      "type": "tel",
      "min": "8",
      "max": "12",
      "data-vv-as": "phone",
      "placeholder": " ",
      "autocomplete": "tel"
    },
    domProps: {
      "value": (_vm.supporter.phoneNumber)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('phone')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supporter, "phoneNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Phone*")]), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.has('phone')) ? _c('p', [_vm._v("\n            " + _vm._s(_vm.errors.first("phone")) + "\n          ")]) : _vm._e()])]), _vm._v(" "), _c('label', {
    staticClass: "checkbox"
  }, [_vm._v("\n        Yes, display my name\n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supporter.agreesDisplayName),
      expression: "supporter.agreesDisplayName"
    }],
    attrs: {
      "type": "checkbox",
      "name": "displayName",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.supporter.agreesDisplayName) ? _vm._i(_vm.supporter.agreesDisplayName, null) > -1 : (_vm.supporter.agreesDisplayName)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('display my name')
      },
      "change": function($event) {
        var $$a = _vm.supporter.agreesDisplayName,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.supporter.agreesDisplayName = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.supporter.agreesDisplayName = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.supporter, "agreesDisplayName", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), (_vm.isEmailInError) ? _c('div', {
    staticClass: "submit-email-error"
  }, [_c('p', [_vm._v(_vm._s(_vm.duplicateEmailMessage))])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "plain",
    attrs: {
      "type": "button",
      "name": "stepOneNext",
      "href": "#form-top"
    },
    on: {
      "click": function($event) {
        _vm.next()
      }
    }
  }, [(!_vm.isSaving) ? _c('span', [_vm._v("\n        " + _vm._s(_vm.isDonation ? _vm.donationSelector : _vm.petitionSelector) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.isSaving) ? _c('span', [_c('i', {
    staticClass: "far fa-spinner-third fa-spin"
  })]) : _vm._e()]), _vm._v(" "), _vm._m(0, false, false)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "privacy-statement"
  }, [_c('p', [_vm._v("\n        By signing you accept\n        "), _c('a', {
    attrs: {
      "href": "/privacy-policy/privacy-policy",
      "target": "_blank"
    }
  }, [_vm._v("\n          WWF-Australia’s Privacy Policy.\n        ")])])])
}]}

/***/ }),
/* 642 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [(_vm.firstName) ? _c('span', [_vm._v(_vm._s(_vm.firstName) + ", ")]) : _vm._e(), _vm._v(" Thanks for your donation.\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "sub-text"
  }, [_c('p', [_vm._v("Thank you "), (_vm.firstName) ? _c('span', [_vm._v(_vm._s(_vm.firstName) + " ")]) : _vm._e(), (_vm.lastName) ? _c('span', [_vm._v(_vm._s(_vm.lastName))]) : _vm._e(), _vm._v(" for your\n    "), (_vm.frequency) ? _c('span', [_vm._v(_vm._s(_vm.frequency))]) : _vm._e(), _vm._v(" gift\n    "), (_vm.amount) ? _c('span', [_vm._v("\n      of "), _c('span', {
    staticClass: "amount"
  }, [_vm._v("$ " + _vm._s(_vm.amount))])]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 643 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "wwf-field"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.addressInput.country),
      expression: "donation.addressInput.country"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      error: _vm.errors.has('country'),
        empty: !_vm.donation.addressInput.country,
    },
    attrs: {
      "name": "country",
      "autocomplete": "country"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.donation.addressInput, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.countryList), function(countries) {
    return _c('option', {
      domProps: {
        "value": countries.name
      }
    }, [_vm._v("\n        " + _vm._s(countries.name) + "\n      ")])
  })), _vm._v(" "), _c('label', {
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Country")])]), _vm._v(" "), (_vm.isAutocompleteAvailable) ? _c('div', {
    attrs: {
      "id": "autocomplete-form"
    }
  }, [(!_vm.formattedAddress) ? _c('form', {
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('SensisAutocomplete', {
    ref: "donateSensisAutocomplete",
    attrs: {
      "id": "donate-sensis-autocomplete",
      "showNotFound": true,
      "placeholder": "Find address"
    },
    on: {
      "addressSelected": _vm.addressSelected
    }
  })], 1) : _vm._e(), _vm._v(" "), (!!_vm.formattedAddress) ? _c('div', [_c('label', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formattedAddress),
      expression: "formattedAddress"
    }],
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": (_vm.formattedAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formattedAddress = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "discreet",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.changeAddress()
      }
    }
  }, [_vm._v("\n        Change my address\n      ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isAutocompleteAvailable) ? _c('button', {
    staticClass: "discreet",
    attrs: {
      "name": "enter-manual-address",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.manualInput = true
      }
    }
  }, [_vm._v("\n    Enter address manually\n  ")]) : _vm._e(), _vm._v(" "), (_vm.showManualInput) ? _c('div', [_c('form', {
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "wwf-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.unitNumber),
      expression: "address.unitNumber"
    }],
    class: {
      empty: !_vm.address.unitNumber,
    },
    attrs: {
      "id": "unit-number",
      "name": "unit-number",
      "type": "text",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.address.unitNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.address, "unitNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "unit-number"
    }
  }, [_vm._v("Unit Number")])]), _vm._v(" "), _c('div', {
    staticClass: "wwf-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.streetNumber),
      expression: "address.streetNumber"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      error: _vm.errors.has('street-number'),
        empty: !_vm.address.streetNumber,
    },
    attrs: {
      "id": "street-number",
      "name": "street-number",
      "type": "text",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.address.streetNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.address, "streetNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "street-number"
    }
  }, [_vm._v("Street Number")])]), _vm._v(" "), _c('div', {
    staticClass: "wwf-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.streetName),
      expression: "address.streetName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      error: _vm.errors.has('street-name'),
        empty: !_vm.address.streetName,
    },
    attrs: {
      "id": "street-name",
      "name": "street-name",
      "type": "text",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.address.streetName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.address, "streetName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "street-name"
    }
  }, [_vm._v("Street Name")])]), _vm._v(" "), _c('div', {
    staticClass: "wwf-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.suburb),
      expression: "address.suburb"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      error: _vm.errors.has('suburb'), empty: !_vm.address.suburb
    },
    attrs: {
      "id": "suburb",
      "name": "suburb",
      "type": "text",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.address.suburb)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.address, "suburb", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "suburb"
    }
  }, [_vm._v("Suburb")])]), _vm._v(" "), _c('div', {
    staticClass: "wwf-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.postcode),
      expression: "address.postcode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        alpha_num: true
      }),
      expression: "{ required: true, alpha_num: true }"
    }],
    class: {
      error: _vm.errors.has('postcode'), empty: !_vm.address.postcode
    },
    attrs: {
      "id": "postcode",
      "name": "postcode",
      "type": "text",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.address.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.address, "postcode", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "postcode"
    }
  }, [_vm._v("Postcode")])]), _vm._v(" "), (_vm.isAustralia) ? _c('div', {
    staticClass: "wwf-field"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.state),
      expression: "address.state"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      error: _vm.errors.has('state'), empty: !_vm.address.state
    },
    attrs: {
      "name": "state",
      "autocomplete": "off"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.address, "state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("Select a state")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NSW"
    }
  }, [_vm._v("NSW")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ACT"
    }
  }, [_vm._v("ACT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NT"
    }
  }, [_vm._v("NT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SA"
    }
  }, [_vm._v("SA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "WA"
    }
  }, [_vm._v("WA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "VIC"
    }
  }, [_vm._v("VIC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "QLD"
    }
  }, [_vm._v("QLD")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TAS"
    }
  }, [_vm._v("TAS")])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "state"
    }
  }, [_vm._v("State")])]) : _vm._e(), _vm._v(" "), (!_vm.isAustralia) ? _c('div', {
    staticClass: "wwf-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.state),
      expression: "address.state"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: false
      }),
      expression: "{ required: false }"
    }],
    class: {
      error: _vm.errors.has('state'), empty: !_vm.address.state
    },
    attrs: {
      "id": "state",
      "name": "state",
      "type": "text",
      "placeholder": "State",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.address.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.address, "state", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "state"
    }
  }, [_vm._v("State")])]) : _vm._e()]), _vm._v(" "), (_vm.canFindMyAddress) ? _c('button', {
    staticClass: "discreet",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.manualInput = false
      }
    }
  }, [_vm._v("\n      Find my address\n    ")]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 644 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "petition-form wwf-form light"
  }, [_c('div', {
    staticClass: "flip-wrapper",
    class: {
      'formValidation-shake': _vm.isShake
    }
  }, [_c('div', {
    staticClass: "petition-form"
  }, [_c('h2', [_vm._v(_vm._s(_vm.titleText))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showThankyou),
      expression: "!showThankyou"
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true}"
    }],
    class: {
      'border-red': _vm.errors.has('name')
    },
    attrs: {
      "name": "name",
      "type": "text",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "small-12 medium-12 with-input-loading"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        email: true,
        partnershipCheckEmail: true
      }),
      expression: "{ required: true, email: true, partnershipCheckEmail: true}"
    }],
    class: {
      'border-red': _vm.errors.has('email') || _vm.errors.has('partnershipCheckEmail')
    },
    attrs: {
      "name": "email",
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.emailCheck.checkEmailLoading) ? _c('div', {
    staticClass: "input-loading"
  }, [_c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/loading-tail-spin.svg"
    }
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.firstByRule('email', 'partnershipCheckEmail')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first('email')))]) : _vm._e()])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('phone')
    },
    attrs: {
      "name": "phone",
      "type": "tel",
      "min": "8",
      "max": "12",
      "placeholder": "Phone",
      "autocomplete": "tel"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organisation),
      expression: "organisation"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('organisation')
    },
    attrs: {
      "name": "organisation",
      "type": "text",
      "placeholder": "Organisation",
      "autocomplete": "organization"
    },
    domProps: {
      "value": (_vm.organisation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.organisation = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.showEnquiry) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enquiry),
      expression: "enquiry"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('enquiry')
    },
    attrs: {
      "name": "enquiry",
      "placeholder": "Enquiry type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.enquiry = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Enquiry type")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Philanthropy"
    }
  }, [_vm._v("Philanthropy")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Business"
    }
  }, [_vm._v("Business")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Other"
    }
  }, [_vm._v("Other")])]) : _vm._e(), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    class: {
      'border-red': _vm.errors.has('message')
    },
    attrs: {
      "name": "message",
      "placeholder": _vm.messagePlaceholder,
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "word-count"
  }, [_vm._v(_vm._s(255 - (_vm.message ? _vm.message.length : 0) + ' Char'))]), _vm._v(" "), (_vm.showOptin) ? _c('div', {
    staticClass: "wwf-checkbox",
    attrs: {
      "checked": "checked"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optin),
      expression: "optin"
    }],
    attrs: {
      "type": "checkbox",
      "id": "opt-in",
      "name": "opt-in"
    },
    domProps: {
      "checked": Array.isArray(_vm.optin) ? _vm._i(_vm.optin, null) > -1 : (_vm.optin)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.optin,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.optin = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.optin = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.optin = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkbox"
  }), _vm._v("I would like to receive news and updates from WWF-Australia")])]) : _vm._e(), _vm._v(" "), (_vm.showOptin) ? _c('div', {
    staticClass: "wwf-checkbox",
    attrs: {
      "checked": "checked"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.largeProject),
      expression: "largeProject"
    }],
    attrs: {
      "type": "checkbox",
      "id": "largeProject",
      "name": "largeProject"
    },
    domProps: {
      "checked": Array.isArray(_vm.largeProject) ? _vm._i(_vm.largeProject, null) > -1 : (_vm.largeProject)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.largeProject,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.largeProject = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.largeProject = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.largeProject = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "checkbox"
  }), _vm._v("I would like to be contacted regarding impact projects ($50K+)\n            ")])]) : _vm._e(), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "Submit"
    },
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isProfanity),
      expression: "isProfanity"
    }],
    staticClass: "alert-box"
  }, [_vm._v("No bad words! Please change your message.")])])])])])
},staticRenderFns: []}

/***/ }),
/* 645 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.currentContent) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(this.currentContent)
    }
  }) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 646 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.selection && _vm.selection.length > 0) ? _c('div', {
    class: {
      'search-filters': true, 'mobile-filter': _vm.isMobile
    }
  }, [_c('div', {
    class: {
      'search-filters-header': true,
      'list-closed': _vm.isMobile && !_vm.showList,
    }
  }, [_c('h3', [_vm._v("Filters")]), _vm._v(" "), (_vm.isMobile) ? _c('div', {
    staticClass: "search-filters-header-icon wwf-no-select",
    on: {
      "click": function($event) {
        _vm.toggleShowList()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-bars fa-fw"
  })]) : _vm._e()]), _vm._v(" "), (!_vm.isMobile || _vm.showList) ? _c('div', {
    staticClass: "search-filters-container"
  }, [_c('div', {
    staticClass: "search-filters-tags"
  }, _vm._l((_vm.selected), function(item) {
    return _c('div', {
      staticClass: "search-filters-tag",
      on: {
        "click": function($event) {
          _vm.deleteFilter(item)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-times"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.label))])])
  })), _vm._v(" "), _vm._l((_vm.selection), function(filter) {
    return _c('div', {
      staticClass: "search-filter"
    }, [_c('h4', [_vm._v(_vm._s(filter.label))]), _vm._v(" "), _c('div', {
      staticClass: "search-filter-items"
    }, [_vm._l((_vm.reducedValues(filter.values)), function(item) {
      return _c('div', {
        staticClass: "search-filter-item"
      }, [_c('div', {
        staticClass: "search-filter-item-name",
        on: {
          "click": function($event) {
            _vm.selectFilter(item)
          }
        }
      }, [_vm._v("\n            " + _vm._s(item.label) + "\n          ")]), _vm._v(" "), _c('div', {
        staticClass: "search-filter-item-count",
        on: {
          "click": function($event) {
            _vm.selectFilter(item)
          }
        }
      }, [_vm._v("\n            " + _vm._s(item.count) + "\n          ")])])
    }), _vm._v(" "), _vm._l((_vm.expandedValues(filter.values)), function(item) {
      return (_vm.expanded) ? _c('div', {
        staticClass: "search-filter-item"
      }, [_c('div', {
        staticClass: "search-filter-item-name",
        on: {
          "click": function($event) {
            _vm.selectFilter(item)
          }
        }
      }, [_vm._v("\n            " + _vm._s(item.label) + "\n          ")]), _vm._v(" "), _c('div', {
        staticClass: "search-filter-item-count",
        on: {
          "click": function($event) {
            _vm.selectFilter(item)
          }
        }
      }, [_vm._v("\n            " + _vm._s(item.count) + "\n          ")])]) : _vm._e()
    }), _vm._v(" "), _c('button', {
      staticClass: "expand-button",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.expanded = !_vm.expanded
        }
      }
    }, [(!_vm.expanded) ? _c('span', [_vm._v("More")]) : _vm._e(), _vm._v(" "), (_vm.expanded) ? _c('span', [_vm._v("Less")]) : _vm._e()])], 2)])
  })], 2) : _vm._e()]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 647 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "category-list"
  }, _vm._l((_vm.categories[_vm.selectedProductType]), function(category) {
    return _c('div', {
      key: category.id,
      staticClass: "category-item",
      style: (_vm.isSingle ? _vm.singleChoice : '')
    }, [(_vm.isMultiple) ? _c('label', [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.isChecked(category)
      },
      on: {
        "change": function($event) {
          _vm.filterMultiple($event, category)
        }
      }
    }), _vm._v(" "), _c('span', [_vm._v("\n        " + _vm._s(category.name) + "\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.isSingle) ? _c('button', {
      class: _vm.isSelected(category.id) ? 'selected' : '',
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.filterSingle(category)
        }
      }
    }, [_vm._v("\n      " + _vm._s(category.name) + "\n    ")]) : _vm._e()])
  }))
},staticRenderFns: []}

/***/ }),
/* 648 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "donate-step2"
    }
  }, [_c(_vm.recipientForm, {
    tag: "component",
    on: {
      "success": _vm.processSuccess
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 649 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.ready) ? _c('div', {
    staticClass: "donate-carousel"
  }, [_c('h2', [_vm._v("Choose design")]), _vm._v(" "), _c('VueSlickCarousel', {
    attrs: {
      "infinite": false
    },
    on: {
      "afterChange": _vm.updateSelectedPackage
    }
  }, _vm._l((_vm.product.packages), function(item) {
    return _c('div', {
      key: item.code,
      staticClass: "slide"
    }, [_c('div', {
      staticClass: "product-pack",
      style: ('background-image: url(' + item.img + ')')
    })])
  }))], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 650 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "autocomplete"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputText),
      expression: "inputText"
    }],
    class: {
      'border-red': _vm.hasError, classname: _vm.classname
    },
    attrs: {
      "id": _vm.id,
      "name": "sensis-input",
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.inputText)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.inputText = $event.target.value
      }, _vm.checkAddress],
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        $event.preventDefault();
        _vm.keyEnter($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9, $event.key)) { return null; }
        $event.preventDefault();
        _vm.keyEnter($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "escape", undefined, $event.key)) { return null; }
        $event.preventDefault();
        _vm.keyEscape($event)
      }],
      "!keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key)) { return null; }
        _vm.keyUp($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key)) { return null; }
        _vm.keyDown($event)
      }],
      "click": function($event) {
        _vm.clickInside()
      }
    }
  }), _vm._v(" "), (_vm.fetchingDetails) ? _c('div', {
    staticClass: "input-loading"
  }, [_c('img', {
    attrs: {
      "alt": "Loading while fetching address' detail",
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/loading-tail-spin.svg"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.displaySuggestions) ? _c('div', {
    staticClass: "suggestions"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "suggestion-loading"
  }, [_c('img', {
    attrs: {
      "alt": "Loading while fetching suggestions",
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/loading-three-dots.svg"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.suggestions.length > 0) ? _c('div', {
    staticClass: "suggestion-list",
    attrs: {
      "id": "sensis-suggestion-list"
    }
  }, _vm._l((_vm.suggestions), function(p) {
    return _c('div', {
      staticClass: "suggestion-item",
      class: {
        'item-active': _vm.cursor === p.index
      },
      attrs: {
        "id": 'sensis-suggestion-item-' + p.index
      },
      on: {
        "click": function($event) {
          _vm.selectAddress(p)
        },
        "mouseover": function($event) {
          _vm.cursor = p.index
        }
      }
    }, [_vm._v("\n        " + _vm._s(p.formatted_address) + "\n      ")])
  })) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.suggestions.length == 0) ? _c('div', {
    staticClass: "suggestion-list"
  }, [_c('div', {
    staticClass: "suggestion-item empty",
    on: {
      "click": _vm.keyEscape
    }
  }, [_vm._v("\n        No Suggestions\n      ")])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 651 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "payment"
  }, [(!_vm.failedPayment) ? _c('div', [_c('div', {
    staticClass: "wwf-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accountTitle),
      expression: "accountTitle"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        regex: /^[a-zA-Z ]+$/
      }),
      expression: "{ required: true, regex: /^[a-zA-Z ]+$/ }"
    }],
    class: {
      'error': _vm.errors.has('acount-holder-name'), 'empty': !_vm.accountTitle
    },
    attrs: {
      "id": "acount-holder-name",
      "name": "acount-holder-name",
      "title": "Required",
      "type": "text",
      "data-vv-validate-on": "change",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.accountTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.accountTitle = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Bank account holder name")])]), _vm._v(" "), _c('div', {
    staticClass: "wwf-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accountRouting),
      expression: "accountRouting"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        regex: /^[0-9]{3}(-?)[0-9]{3}\b$/
      }),
      expression: "{ required: true, regex: /^[0-9]{3}(-?)[0-9]{3}\\b$/ }"
    }],
    class: {
      'error': _vm.errors.has('acount-bsb'), 'empty': !_vm.accountRouting
    },
    attrs: {
      "id": "acount-bsb",
      "name": "acount-bsb",
      "title": "Required",
      "type": "text",
      "data-vv-validate-on": "change",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.accountRouting)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.accountRouting = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Bank account BSB")])]), _vm._v(" "), _c('div', {
    staticClass: "wwf-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accountNumber),
      expression: "accountNumber"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        regex: /^[0-9]{6,10}$/
      }),
      expression: "{ required: true, regex: /^[0-9]{6,10}$/ }"
    }],
    class: {
      'error': _vm.errors.has('acount-number'), 'empty': !_vm.accountNumber
    },
    attrs: {
      "id": "acount-number",
      "name": "acount-number",
      "title": "Required",
      "type": "text",
      "data-vv-validate-on": "change",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.accountNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.accountNumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Bank account number")])])]) : _vm._e(), _vm._v(" "), (_vm.serverError) ? _c('div', {
    staticClass: "errors"
  }, [_c('label', [_vm._v(_vm._s(_vm.serverError))])]) : _vm._e(), _vm._v(" "), (!_vm.failedPayment) ? _c('div', {
    staticClass: "form-buttons"
  }, [_c('button', {
    staticClass: "pay-now",
    class: {
      disabled: !_vm.enablePayButton()
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.enablePayButton(),
      "href": "#form-top",
      "data-animation-duration": "300",
      "data-animation-easing": "swing",
      "id": "pay-button",
      "data-smooth-scroll": "",
      "data-threshold": "75"
    },
    on: {
      "click": _vm.pay
    }
  }, [_vm._v("\n      Pay Now\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.failedPayment) ? _c('div', {
    staticClass: "form-buttons"
  }, [_c('button', {
    staticClass: "pay-now",
    attrs: {
      "type": "button",
      "href": "#form-top",
      "data-animation-duration": "300",
      "data-animation-easing": "swing",
      "id": "retry-button",
      "data-smooth-scroll": "",
      "data-threshold": "75"
    },
    on: {
      "click": _vm.retry
    }
  }, [_vm._v("\n      Retry\n    ")])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 652 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-item-container search-item-twitter"
  }, [_c('div', {
    staticClass: "search-item-header"
  }, [_c('div', {
    staticClass: "search-item-title"
  }, [_c('h4', [_c('a', {
    attrs: {
      "href": _vm.item.liveUrl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.item.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "search-item-link"
  }, [_c('a', {
    attrs: {
      "href": _vm.item.liveUrl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.item.displayUrl))])])]), _vm._v(" "), _c('div', {
    staticClass: "search-item-content"
  }, [(_vm.item.metaData && _vm.item.metaData.image) ? _c('img', {
    attrs: {
      "src": _vm.item.metaData.image,
      "alt": 'Thumbnail for ' + _vm.item.title
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "search-item-date"
  }, [_vm._v(_vm._s(_vm.item.date) + " ")]), _vm._v(_vm._s(_vm.item.summary) + "\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 653 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.currentStep > 0) ? _c('div', {
    staticClass: "stepper-container"
  }, [_c('div', {
    staticClass: "step",
    class: {
      selected: _vm.currentStep >= 0
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.maxSteps === 4),
      expression: "maxSteps === 4"
    }],
    staticClass: "step",
    class: {
      selected: _vm.currentStep >= 1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "step",
    class: {
      selected: _vm.currentStep >= 2
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "step",
    class: {
      selected: _vm.currentStep >= 3
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.currentStep === 0) ? [_c('Selection', {
    on: {
      "next": function($event) {
        _vm.next(0)
      }
    }
  })] : _vm._e(), _vm._v(" "), (_vm.currentStep === 1) ? [_c('RecipientDetails', {
    on: {
      "next": function($event) {
        _vm.next(1)
      }
    }
  })] : _vm._e(), _vm._v(" "), (_vm.currentStep === 2) ? [_c('SupporterDetails', {
    attrs: {
      "blacklistUrl": _vm.blacklistUrl
    },
    on: {
      "next": function($event) {
        _vm.next(2)
      }
    }
  })] : _vm._e(), _vm._v(" "), (_vm.currentStep === 3) ? [_c('Payment', {
    attrs: {
      "thankYouUrl": _vm.thankYouUrl,
      "useProductThankYouUrl": _vm.useProductThankYouUrl
    },
    on: {
      "reset": _vm.reset,
      "next": function($event) {
        _vm.next(3)
      }
    }
  })] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 654 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "workplace-contact-us"
  }, [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("Contact us!")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.serverErrors),
      expression: "serverErrors"
    }],
    staticClass: "error-message text-center"
  }, [_vm._v("Unable to deliver message.")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.serverErrors && !_vm.showThankyou),
      expression: "!serverErrors && !showThankyou"
    }],
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.description))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.serverErrors && _vm.showThankyou),
      expression: "!serverErrors && showThankyou"
    }],
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.thankyouMessage))]), _vm._v(" "), _c('div', {
    staticClass: "wwf-form light"
  }, [_c('div', {
    staticClass: "flip-wrapper",
    class: {
      'formValidation-shake': _vm.isShake
    }
  }, [_c('div', {
    staticClass: "form-grid"
  }, [_c('label', [_vm._v("First name"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('firstName')
    },
    attrs: {
      "name": "firstName",
      "type": "text"
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("Last name"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('lastName')
    },
    attrs: {
      "name": "lastName",
      "type": "text"
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("Email"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailAddress),
      expression: "emailAddress"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    class: {
      'border-red': _vm.errors.has('emailAddress')
    },
    attrs: {
      "name": "emailAddress",
      "type": "email"
    },
    domProps: {
      "value": (_vm.emailAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.emailAddress = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("Phone\n            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "name": "phone",
      "type": "tel"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "span-fw"
  }, [_vm._v("Message"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('message')
    },
    attrs: {
      "name": "message",
      "type": "text"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('p', [_vm._v("Mandatory field(s) marked with *")]), _vm._v(" "), _c('input', {
    staticClass: "submit-btn",
    attrs: {
      "type": "button",
      "value": "Submit"
    },
    on: {
      "click": _vm.postTicket
    }
  })])])])])
},staticRenderFns: []}

/***/ }),
/* 655 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "donation-supporter-details",
    attrs: {
      "id": "donate-step2"
    }
  }, [_c('h2', [_vm._v("Your details")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "checkbox"
  }, [_vm._v("\n      " + _vm._s(_vm.product.producttype == "adoption" ? "Adopt" : "Donate") + " on behalf\n      of a business\n      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.isBehalfBusiness),
      expression: "donation.isBehalfBusiness"
    }],
    attrs: {
      "type": "checkbox",
      "id": "isBehalfBusiness",
      "name": "isBehalfBusiness"
    },
    domProps: {
      "checked": Array.isArray(_vm.donation.isBehalfBusiness) ? _vm._i(_vm.donation.isBehalfBusiness, null) > -1 : (_vm.donation.isBehalfBusiness)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.donation.isBehalfBusiness,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.donation.isBehalfBusiness = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.donation.isBehalfBusiness = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.donation, "isBehalfBusiness", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), (_vm.donation.isBehalfBusiness) ? _c('div', {
    staticClass: "wwf-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.bussiness.name),
      expression: "donation.bussiness.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      error: _vm.errors.has('businessName'),
        empty: !_vm.donation.bussiness.name,
    },
    attrs: {
      "name": "businessName",
      "type": "text",
      "autocomplete": "organization"
    },
    domProps: {
      "value": (_vm.donation.bussiness.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation.bussiness, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "businessName"
    }
  }, [_vm._v("Business Name")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wwf-field"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.title),
      expression: "donation.title"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      error: _vm.errors.has('title'), empty: !_vm.donation.title
    },
    attrs: {
      "name": "title",
      "autocomplete": "honorific-prefix"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.donation, "title", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Dr"
    }
  }, [_vm._v("Dr")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Miss"
    }
  }, [_vm._v("Miss")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Mr"
    }
  }, [_vm._v("Mr")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Mrs"
    }
  }, [_vm._v("Mrs")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Ms"
    }
  }, [_vm._v("Ms")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Mx"
    }
  }, [_vm._v("Mx")])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Select a title")])]), _vm._v(" "), _c('div', {
    staticClass: "wwf-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.firstname),
      expression: "donation.firstname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      error: _vm.errors.has('firstName'), empty: !_vm.donation.firstname
    },
    attrs: {
      "name": "firstName",
      "type": "text",
      "autocomplete": "given-name"
    },
    domProps: {
      "value": (_vm.donation.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation, "firstname", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "firstName"
    }
  }, [_vm._v("First Name")])]), _vm._v(" "), _c('div', {
    staticClass: "wwf-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.lastname),
      expression: "donation.lastname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      error: _vm.errors.has('lastName'), empty: !_vm.donation.lastname
    },
    attrs: {
      "name": "lastName",
      "type": "text",
      "autocomplete": "family-name"
    },
    domProps: {
      "value": (_vm.donation.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation, "lastname", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "lastName"
    }
  }, [_vm._v("Last Name")])]), _vm._v(" "), _c('div', {
    staticClass: "wwf-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.phone),
      expression: "donation.phone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        donationValidatePhone: true
      }),
      expression: "{ required: true, donationValidatePhone: true }"
    }],
    class: {
      error: _vm.errors.has('phone'),
        empty: !_vm.donation.phone,
    },
    attrs: {
      "name": "phone",
      "type": "tel",
      "min": "8",
      "max": "12",
      "autocomplete": "tel"
    },
    domProps: {
      "value": (_vm.donation.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.has('phone')) ? _c('p', [_vm._v("\n        " + _vm._s(_vm.errors.first("phone")) + "\n      ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "wwf-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.email),
      expression: "donation.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        donationValidateEmail: true
      }),
      expression: "{ required: true, donationValidateEmail: true }"
    }],
    class: {
      error: _vm.errors.has('email') || _vm.errors.has('donationValidateEmail'),
        empty: !_vm.donation.email,
    },
    attrs: {
      "id": "email",
      "name": "email",
      "type": "email",
      "autocomplete": "email"
    },
    domProps: {
      "value": (_vm.donation.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.firstByRule('email', 'donationValidateEmail')) ? _c('p', [_vm._v("\n        " + _vm._s(_vm.errors.first("email")) + "\n      ")]) : _vm._e()])]), _vm._v(" "), _c('label', {
    staticClass: "checkbox"
  }, [_vm._v("\n    Stay up to date by receiving emails\n    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.optin),
      expression: "donation.optin"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.donation.optin) ? _vm._i(_vm.donation.optin, null) > -1 : (_vm.donation.optin)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.donation.optin,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.donation.optin = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.donation.optin = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.donation, "optin", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), (!_vm.showCompliance) ? _c('label', {
    staticClass: "checkbox"
  }, [_vm._v("\n    Send me information about including WWF in my Will\n    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.bequest),
      expression: "donation.bequest"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.donation.bequest) ? _vm._i(_vm.donation.bequest, null) > -1 : (_vm.donation.bequest)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.donation.bequest,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.donation.bequest = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.donation.bequest = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.donation, "bequest", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]) : _vm._e(), _vm._v(" "), (_vm.showCompliance) ? _c('label', {
    staticClass: "checkbox"
  }, [_c('span', {
    staticClass: "statement"
  }, [_vm._v("\n      I declare that my core business is not engaged in the outlined "), _c('a', {
    attrs: {
      "href": _vm.blacklistUrl,
      "target": "_blank"
    }
  }, [_vm._v("black listed")]), _vm._v(" industries.\n    ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.compliance),
      expression: "donation.compliance"
    }],
    attrs: {
      "type": "checkbox",
      "name": "compliance"
    },
    domProps: {
      "checked": Array.isArray(_vm.donation.compliance) ? _vm._i(_vm.donation.compliance, null) > -1 : (_vm.donation.compliance)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.donation.compliance,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.donation.compliance = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.donation.compliance = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.donation, "compliance", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark",
    class: {
      complianceError: _vm.errors.has('compliance')
    }
  })]) : _vm._e(), _vm._v(" "), _c('h2', [_vm._v("Your address")]), _vm._v(" "), (_vm.showRecipientCheckbox) ? _c('label', {
    staticClass: "checkbox"
  }, [_vm._v("\n    Same as Recipient\n    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.isSameAddress),
      expression: "donation.isSameAddress"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.donation.isSameAddress) ? _vm._i(_vm.donation.isSameAddress, null) > -1 : (_vm.donation.isSameAddress)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.donation.isSameAddress,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.donation.isSameAddress = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.donation.isSameAddress = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.donation, "isSameAddress", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]) : _vm._e(), _vm._v(" "), (_vm.cannotDeliver) ? _c('div', {
    staticClass: "cannot-deliver"
  }, [_vm._v("\n    We're sorry, gifts and toy products can only be delivered within\n    Australia.\n  ")]) : _vm._e(), _vm._v(" "), _c('AddressInput', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showRecipientCheckbox || !_vm.donation.isSameAddress),
      expression: "!showRecipientCheckbox || !donation.isSameAddress"
    }],
    ref: "AddressInput"
  }), _vm._v(" "), _c('button', {
    class: {
      plain: !_vm.isSaving
    },
    style: ([_vm.isSaving ? {
      'background-color': 'var(--wwfBlue)'
    } : {}]),
    attrs: {
      "name": "goto-payment",
      "type": "button",
      "disabled": _vm.isSaving,
      "href": "#form-top"
    },
    on: {
      "click": function($event) {
        _vm.next()
      }
    }
  }, [(_vm.donation.payementType === 'wwf_paypal' && !_vm.isSaving) ? _c('span', [_vm._v("Pay with PayPal")]) : _vm._e(), _vm._v(" "), (_vm.donation.payementType !== 'wwf_paypal' && !_vm.isSaving) ? _c('span', [_vm._v("Go to Payment")]) : _vm._e(), _vm._v(" "), (!_vm.isSaving) ? _c('i', {
    staticClass: "fas fa-arrow-right"
  }) : _c('img', {
    staticClass: "center loading resize",
    attrs: {
      "alt": "Loading while checking details",
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/loading-three-dots.svg"
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 656 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.logos) ? _c('div', {
    staticClass: "cards-container"
  }, [_c('div', {
    staticClass: "cards"
  }, _vm._l((_vm.logos), function(logo) {
    return _c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "img-container",
      style: ({
        'background-image': 'url(\'' + logo.url + '\')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "name-container"
    }, [_c('span', [_vm._v(_vm._s(logo.name))])])])
  })), _vm._v(" "), (_vm.showLoadMore) ? _c('div', {
    staticClass: "load-more-container"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.fetching
    },
    on: {
      "click": _vm.fetchLogos
    }
  }, [(!_vm.fetching) ? _c('span', [_vm._v("Show More")]) : _vm._e(), _vm._v(" "), (_vm.fetching) ? _c('span', [_c('i', {
    staticClass: "fas fa-globe fa-spin"
  })]) : _vm._e()])]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 657 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    on: {
      "click": function($event) {
        _vm.countryListModel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" Australia\n")])
},staticRenderFns: []}

/***/ }),
/* 658 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', _vm._g({
    staticClass: "solution-icon",
    class: {
      active: _vm.isActive
    },
    attrs: {
      "type": "button"
    }
  }, _vm.isMobileView ? {
    click: _vm.toggleActive
  } : {
    mouseover: _vm.setActive
  }), [_c('div', {
    staticClass: "icon-wrapper"
  }, [(_vm.item.icon == 'koala') ? _c('svg', {
    attrs: {
      "version": "1.0",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "547.000000pt",
      "height": "547.000000pt",
      "viewBox": "0 0 547.000000 547.000000",
      "preserveAspectRatio": "xMidYMid meet"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(0.000000,547.000000) scale(0.100000,-0.100000)",
      "stroke": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M2423 4225 c-47 -24 -134 -111 -160 -160 -6 -11 -20 -66 -32 -123\n      -19 -94 -19 -109 -7 -180 22 -128 81 -209 180 -252 l49 -20 -5 -78 c-9 -144\n      -74 -219 -358 -409 -300 -202 -394 -299 -502 -520 -84 -172 -98 -247 -98 -515\n      0 -205 0 -208 30 -289 73 -199 188 -298 432 -369 57 -16 127 -39 156 -50 36\n      -14 76 -20 128 -20 61 0 81 -4 102 -20 16 -13 38 -20 58 -18 20 1 41 -5 53\n      -16 26 -24 51 -14 51 19 l0 26 45 -26 c24 -15 49 -24 55 -20 28 17 -8 117 -48\n      132 -28 11 -82 57 -82 71 0 57 127 -40 178 -136 38 -72 39 -82 7 -130 -31 -48\n      -55 -116 -55 -158 0 -28 4 -34 21 -34 11 0 32 9 46 20 14 11 29 20 32 20 4 0\n      7 -21 7 -47 -1 -45 1 -48 27 -51 23 -3 36 5 67 41 55 62 128 107 173 107 47 0\n      100 -45 123 -105 40 -106 108 -4 70 105 -13 38 -13 47 -2 58 32 33 133 4 185\n      -52 14 -14 35 -26 48 -26 19 0 23 5 23 29 0 17 -4 33 -10 36 -5 3 -10 13 -10\n      21 0 23 46 16 79 -12 17 -14 35 -23 41 -19 16 10 11 78 -8 110 -26 42 -180\n      124 -247 132 -27 3 -62 12 -77 19 -30 15 -69 77 -88 139 -7 22 -36 92 -66 155\n      -40 87 -56 135 -64 194 l-11 79 29 31 c16 17 36 44 44 60 l15 29 33 -59 c19\n      -33 70 -115 114 -184 104 -164 136 -233 147 -322 11 -92 14 -100 44 -128 16\n      -15 30 -20 42 -15 10 4 37 7 60 6 26 -2 56 6 85 20 34 18 69 25 163 31 66 5\n      134 8 150 7 17 0 48 -1 70 -2 36 -2 40 0 43 24 4 34 -56 89 -97 89 -15 0 -43\n      8 -62 17 -24 12 -66 19 -139 21 -58 2 -108 7 -112 11 -14 13 -29 116 -38 271\n      -7 123 -15 176 -39 255 -35 120 -66 356 -52 400 5 17 21 57 36 89 27 57 28 64\n      22 168 -5 77 -14 130 -33 186 -14 42 -23 88 -21 102 3 14 24 77 47 140 23 63\n      47 142 54 174 11 56 14 60 46 69 19 5 49 22 67 38 22 19 45 29 65 29 69 0 149\n      133 149 249 0 31 0 72 1 91 2 43 -6 103 -16 118 -4 6 -2 21 4 32 9 16 8 25 -2\n      37 -7 9 -12 24 -10 34 2 9 -2 20 -8 24 -5 3 -10 19 -10 36 0 17 -5 29 -13 29\n      -7 0 -26 14 -42 30 -26 27 -34 30 -95 30 -36 0 -93 -7 -125 -15 -75 -20 -165\n      -87 -181 -136 -12 -36 -44 -59 -82 -59 -12 0 -55 10 -95 22 -59 18 -98 22\n      -221 22 l-149 1 -28 35 c-19 23 -31 53 -36 85 -13 102 -79 145 -222 145 -73 0\n      -95 -4 -138 -25z"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.item.icon == 'tree') ? _c('svg', {
    attrs: {
      "version": "1.0",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "1042.000000pt",
      "height": "1042.000000pt",
      "viewBox": "0 0 1042.000000 1042.000000",
      "preserveAspectRatio": "xMidYMid meet"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(0.000000,1042.000000) scale(0.100000,-0.100000)",
      "stroke": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M3366 9754 c-31 -31 -19 -56 70 -138 117 -110 144 -146 436 -576 139 -206 298 -436 352 -510 270 -369 625 -1147 730 -1603 48 -206 58 -324 76 -868 9 -299 7 -420 -20 -1009 -5 -118 -10 -244 -10 -280 0 -79 -11 -70 -40 33 -29 106 -130 403 -173 509 l-35 87 28 68 c82 204 111 434 74 611 -44 217 -163 384 -370 519 -102 66 -633 336 -804 408 -448 188 -825 283 -942 236 -66 -25 -22 -73 178 -194 364 -222 883 -613 1181 -888 213 -197 424 -471 538 -698 29 -58 160 -441 277 -811 l71 -224 -7 -201 c-4 -110 -9 -201 -11 -203 -1 -2 -42 25 -91 59 -125 87 -319 202 -440 261 -98 48 -194 73 -194 51 0 -6 25 -27 55 -46 136 -91 227 -281 255 -536 31 -284 138 -470 314 -547 l66 -28 0 -56 c0 -82 -20 -565 -26 -637 -5 -60 -7 -62 -39 -73 -53 -17 -153 -86 -223 -154 -85 -81 -186 -206 -322 -401 -149 -212 -203 -278 -275 -336 -161 -132 -343 -186 -705 -209 -282 -18 -446 -58 -632 -151 -165 -82 -368 -241 -402 -314 -16 -34 -16 -38 -1 -61 21 -32 60 -48 188 -79 464 -109 1318 -203 2242 -245 456 -21 1197 -11 1605 20 793 62 1439 226 1514 385 39 81 -10 129 -345 339 -371 233 -449 268 -804 366 -175 48 -296 94 -415 158 -227 121 -458 261 -690 416 -153 103 -294 189 -352 216 l-98 45 0 387 0 387 53 34 c60 39 113 96 133 143 18 43 18 140 0 190 -30 85 35 348 134 545 59 115 99 165 257 315 381 363 544 493 895 712 187 117 314 206 322 228 8 20 -12 22 -134 13 -63 -5 -275 -13 -470 -19 -236 -6 -384 -15 -440 -25 -293 -53 -486 -136 -655 -282 l-85 -73 0 130 0 130 46 93 c206 411 482 875 667 1122 147 196 565 569 932 832 420 302 979 600 1345 718 137 45 290 131 290 164 0 29 -41 34 -170 22 -63 -6 -187 -15 -275 -21 -225 -15 -612 -67 -806 -110 -457 -99 -922 -402 -1254 -815 -164 -204 -309 -447 -349 -584 -35 -121 -12 -229 54 -254 17 -6 30 -15 30 -19 0 -4 -46 -78 -103 -165 -57 -87 -166 -257 -242 -378 -75 -121 -143 -226 -150 -234 -10 -11 -14 62 -17 375 -5 407 -17 568 -72 954 l-23 165 27 35 c249 325 259 813 26 1280 -286 573 -741 966 -1411 1218 -88 34 -177 68 -197 76 -49 21 -122 21 -142 0z m1951 -5615 l32 -24 -39 -105 c-22 -58 -47 -132 -56 -165 l-17 -60 -38 44 -39 44 0 208 0 208 63 -63 c34 -34 77 -74 94 -87z"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.item.icon == 'renewable') ? _c('svg', {
    attrs: {
      "version": "1.0",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "1042.000000pt",
      "height": "1042.000000pt",
      "viewBox": "0 0 1042.000000 1042.000000",
      "preserveAspectRatio": "xMidYMid meet"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(0.000000,1042.000000) scale(0.100000,-0.100000)",
      "stroke": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M9468 8802 c-53 -48 -108 -100 -121 -117 -31 -40 -617 -912 -617 -919 0 -3 20 -6 45 -6 92 0 202 -56 251 -128 l21 -31 126 237 c234 440 363 723 393 862 15 71 18 158 6 177 -5 7 -40 -18 -104 -75z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3302 7586 l-441 -271 -3 -197 -3 -196 -155 93 c-85 52 -161 94 -167 95 -7 0 -273 -164 -590 -363 l-578 -364 -6 -294 c-3 -162 -7 -1111 -9 -2109 -1 -998 -5 -1862 -9 -1919 l-6 -105 -435 -205 -434 -206 427 -3 427 -2 1943 886 c1068 487 1947 888 1954 891 6 3 871 -396 1922 -886 l1910 -891 452 2 452 3 -529 256 -529 255 -3 2183 -2 2183 -168 279 -167 279 -5 -1392 -5 -1393 -175 -3 -176 -2 -129 -130 -130 -130 233 0 232 0 0 -37 0 -37 68 67 c37 37 71 67 75 67 4 0 7 -396 7 -880 0 -484 -3 -880 -7 -880 -4 0 -227 106 -495 236 l-488 237 0 333 0 334 -105 0 -105 0 0 -281 c0 -255 -1 -281 -16 -275 -9 4 -275 131 -590 284 l-574 277 0 242 0 243 -110 0 -110 0 0 -189 0 -190 -272 133 c-150 73 -305 147 -344 165 l-71 33 -288 -136 c-158 -75 -291 -136 -296 -136 -5 0 -9 508 -9 1165 0 641 2 1165 4 1165 2 0 184 -101 405 -225 221 -124 404 -225 407 -225 2 0 3 44 2 97 l-3 97 -405 233 c-223 127 -411 232 -417 232 -7 1 -266 -152 -575 -338 l-563 -339 -3 -1207 -2 -1206 -103 -49 -102 -49 -3 1327 c-1 730 0 1332 2 1337 2 6 99 68 215 139 l211 129 0 924 c0 507 4 923 8 923 5 0 145 -74 311 -165 166 -91 309 -169 318 -172 14 -6 15 2 9 67 -3 41 -8 75 -9 76 -1 1 -144 87 -318 192 l-316 189 -441 -271z m-437 -849 l310 -194 0 -1859 0 -1859 -310 -147 c-170 -81 -313 -147 -317 -147 -5 -1 -8 989 -8 2199 0 1210 4 2200 8 2200 4 0 147 -87 317 -193z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8040 7583 c-243 -13 -569 -36 -635 -44 -106 -13 -252 -52 -314 -83 -56 -29 -66 -40 -48 -54 28 -22 211 -83 294 -96 140 -24 472 -47 871 -62 l182 -7 -7 34 c-10 44 -10 200 0 267 l8 52 -148 -2 c-81 -1 -173 -3 -203 -5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8645 7576 c-42 -18 -82 -68 -95 -117 -19 -70 6 -140 67 -186 31 -24 46 -28 103 -28 58 0 71 4 104 29 42 32 76 95 76 141 0 38 -31 104 -61 132 -48 43 -132 56 -194 29z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M9036 7192 c-18 -54 -132 -116 -246 -131 -39 -5 -54 -11 -52 -21 7 -31 572 -860 627 -919 33 -35 94 -91 135 -124 l75 -60 3 91 c3 84 0 96 -34 184 -36 89 -461 946 -488 984 -13 17 -14 17 -20 -4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8218 6960 c-52 -47 -105 -118 -257 -344 -105 -157 -191 -287 -191 -290 0 -3 10 -6 21 -6 43 0 103 -25 137 -57 32 -30 36 -32 47 -16 26 35 234 450 270 537 26 64 38 110 42 163 3 40 4 73 2 73 -2 0 -34 -27 -71 -60z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7175 6199 c-253 -16 -395 -42 -450 -83 -19 -14 -18 -16 26 -35 105 -47 248 -65 609 -79 l185 -7 0 108 0 107 -120 -1 c-66 -1 -178 -6 -250 -10z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7704 6199 c-28 -14 -54 -60 -54 -96 0 -113 157 -148 205 -46 45 95 -55 188 -151 142z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7935 5940 c-27 -28 -88 -53 -151 -62 -19 -3 3 -39 175 -292 162 -240 207 -299 261 -345 l65 -55 3 60 c2 53 -2 73 -36 150 -41 92 -208 429 -259 521 l-29 53 -29 -30z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7650 5010 l0 -820 -28 0 c-22 0 -50 -24 -150 -130 l-123 -130 228 0 228 0 130 130 130 130 -98 0 -97 0 0 642 0 642 -106 178 c-59 98 -108 178 -110 178 -2 0 -4 -369 -4 -820z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5501 4550 l-133 -130 228 0 229 0 130 130 130 130 -225 0 -225 -1 -134 -129z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M6080 4550 l-122 -130 229 0 228 0 130 130 130 130 -237 0 -236 0 -122 -130z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M6670 4549 l-124 -129 232 0 232 0 0 -37 0 -38 130 130 c121 120 130 132 130 167 l0 38 -237 -1 -238 -2 -125 -128z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5117 4182 c-147 -147 -157 -160 -157 -195 l0 -37 230 0 230 0 0 38 c0 32 7 45 51 87 28 28 96 98 151 158 l100 107 -224 0 -223 0 -158 -158z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5723 4178 c-145 -144 -163 -165 -163 -195 l0 -33 220 0 220 0 0 37 c0 35 10 48 157 195 l158 158 -215 0 -215 0 -162 -162z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M6303 4174 c-118 -125 -159 -173 -161 -195 l-3 -29 240 0 240 0 145 158 c133 144 146 160 146 195 l0 37 -224 0 -224 0 -159 -166z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M6898 4063 l-133 -128 225 -3 225 -2 130 130 130 130 -222 0 -221 0 -134 -127z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M6512 3692 c-145 -140 -163 -160 -162 -189 l0 -33 235 0 235 0 0 35 c0 30 14 49 118 157 64 68 130 138 146 156 l30 32 -220 0 -219 -1 -163 -157z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7117 3692 c-138 -138 -157 -161 -157 -190 l0 -32 220 0 220 0 0 35 c0 31 15 50 151 190 l151 155 -213 0 -214 0 -158 -158z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7697 3686 c-120 -125 -157 -170 -157 -190 l0 -26 243 0 242 1 135 149 c120 134 135 154 138 190 l3 40 -224 0 -224 0 -156 -164z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4770 2245 l0 -195 195 0 195 0 0 195 0 195 -195 0 -195 0 0 -195z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5300 2245 l0 -195 195 0 195 0 0 195 0 195 -195 0 -195 0 0 -195z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4770 1735 l0 -195 195 0 195 0 0 195 0 195 -195 0 -195 0 0 -195z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5300 1735 l0 -195 195 0 195 0 0 195 0 195 -195 0 -195 0 0 -195z"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.item.icon == 'innovate') ? _c('svg', {
    attrs: {
      "version": "1.0",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "1042.000000pt",
      "height": "1042.000000pt",
      "viewBox": "0 0 1042.000000 1042.000000",
      "preserveAspectRatio": "xMidYMid meet"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(0.000000,1042.000000) scale(0.100000,-0.100000)",
      "stroke": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M5034 8799 c-482 -37 -937 -217 -1289 -510 -390 -325 -674 -753 -790 -1192 -48 -182 -67 -320 -72 -542 -8 -338 31 -588 134 -855 97 -252 225 -461 466 -760 48 -59 90 -128 137 -225 135 -276 190 -502 240 -995 41 -398 52 -451 114 -516 65 -67 102 -74 434 -81 l282 -6 0 900 0 900 -29 44 c-17 24 -48 62 -70 84 -41 39 -41 39 -70 22 -42 -25 -137 -47 -202 -47 -70 0 -191 30 -261 66 -98 49 -165 112 -252 234 -215 301 -297 423 -290 430 12 12 174 57 269 75 44 9 132 18 195 21 195 9 329 -26 441 -116 146 -117 219 -266 219 -445 l0 -80 93 -90 c72 -69 96 -100 105 -131 9 -30 12 -282 12 -953 l0 -911 60 0 60 0 0 1328 0 1328 -29 45 c-16 24 -58 73 -94 107 l-64 64 -69 -25 c-194 -70 -370 -52 -531 52 -113 73 -206 184 -298 356 -56 105 -193 311 -300 450 -41 54 -72 101 -70 106 3 4 40 16 83 26 107 25 403 25 554 0 298 -50 435 -104 553 -220 57 -57 81 -90 113 -157 58 -123 66 -165 67 -335 l0 -151 90 -80 c111 -100 120 -111 140 -157 13 -32 15 -194 15 -1387 l0 -1350 55 0 55 0 2 1523 3 1522 27 46 c15 25 44 61 65 79 21 18 57 51 81 72 l43 40 -15 62 c-20 78 -20 233 -1 305 59 222 279 404 576 476 173 42 357 58 579 52 107 -3 203 -8 213 -12 15 -7 10 -22 -49 -133 -142 -270 -295 -486 -459 -647 -104 -103 -171 -150 -273 -191 -116 -47 -281 -55 -409 -20 l-52 14 -67 -70 c-115 -123 -104 64 -104 -1635 l0 -1483 60 0 60 0 0 1103 c0 1045 1 1104 19 1142 10 23 54 74 103 120 l86 80 -5 70 c-18 259 134 450 432 541 82 26 104 28 245 28 172 0 276 -16 417 -63 46 -16 87 -31 90 -34 9 -10 -80 -156 -162 -265 -257 -344 -599 -560 -810 -513 -31 7 -77 27 -104 46 l-49 33 -35 -37 c-72 -75 -67 18 -67 -1177 l0 -1077 303 6 c180 3 321 10 349 17 26 7 65 27 86 46 76 65 100 154 132 484 49 516 113 779 256 1060 63 124 118 208 229 350 263 336 408 650 476 1035 19 109 23 165 23 350 0 220 -5 280 -45 485 -50 255 -189 588 -338 810 -322 479 -811 829 -1355 970 -260 68 -501 89 -762 69z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4103 3007 c-108 -22 -172 -149 -127 -255 22 -53 60 -89 113 -106 150 -48 1521 -59 2113 -17 131 9 187 33 223 95 52 88 23 213 -60 262 l-43 25 -1091 2 c-600 1 -1107 -1 -1128 -6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4225 2481 c-149 -69 -149 -275 0 -342 38 -18 90 -19 981 -19 l940 0 50 25 c60 30 93 76 101 142 10 88 -28 161 -101 194 -39 18 -87 19 -986 19 -899 0 -947 -1 -985 -19z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4520 2011 c-91 -14 -112 -50 -70 -118 72 -119 223 -208 420 -248 179 -37 574 -29 748 16 186 47 372 205 360 307 -6 52 2 52 -733 51 -374 -1 -700 -5 -725 -8z"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.item.icon == 'rewilding') ? _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 -90 433 433"
    }
  }, [_c('path', {
    attrs: {
      "d": "M270.36,199.46c-6.2-.27-10.74-.36-16.13-.58-5.76-.23-10.57-1.48-8.63-7.15,1.35-2.7,5.32-3.39,8-4.27-.54-6.92-5.75-9.44-11.1-14.92-3.06-2.7-6-5.31-9.26-7.87a15.32,15.32,0,0,0-4-2.2c-1.6-.55-15.06-1.31-19.55-6-5.62-7.33.92-11.29,5.53-16.72,6.39-7.54,9.93-10.79,16.49-21.27a12.19,12.19,0,0,1,4.35-4.34c2.4-.78,4.7.89,5.81,3a11.88,11.88,0,0,1,2.88-3.55c4.19-3.29,8.68-1.17,11,3.19,1.74,3,1.85,12.25,5.84,13.08,6.7,1.8,12.49-3.68,16.18-3.91,5.3-.34,7.36,1.37,12.63,2a24.73,24.73,0,0,0,.1-4.46,8.36,8.36,0,0,1,.11-2.83c0-.26.09-.52.12-.7a20.44,20.44,0,0,1-1.32-1.73,1.92,1.92,0,0,1-.37-1.28,1.81,1.81,0,0,0-1-2.14,2.5,2.5,0,0,1-1.23-1.85,1.68,1.68,0,0,0-.9-1.39,5.67,5.67,0,0,1-2.71-3,4.07,4.07,0,0,0-.3-.63c-.51-.83-1-1.71-2.24-1.3a.78.78,0,0,1-.56,0,7.21,7.21,0,0,1-2.25-2.22l.78-.38c-.07-1.15-.07-1.15-1.22-1.54a1.57,1.57,0,0,0-.33.26.66.66,0,0,1-1,.12,1.15,1.15,0,0,1-.31-.89,6.91,6.91,0,0,0-.18-2.52,5.19,5.19,0,0,1,0-1.47,6.66,6.66,0,0,1,.22-.88l-.19,0-1.1-2.24c-.16.37-.32.72-.51,1.13-.82,0-1.32-.61-1.93-1s-.6-1.44-1.59-1.69c-.09.79-.17,1.53-.27,2.37-.5-.41-.9-.94-1.53-.41A10.65,10.65,0,0,1,267,89.13c-.3-.19-.69-.32-.85-.58a5.71,5.71,0,0,1-.73-1.75,2.73,2.73,0,0,0-1.89-2.12,2.2,2.2,0,0,1-.86-3.24c.12-.18.25-.35.42-.58-.83-.8-1.62-1.52-2.83-1.35a1.15,1.15,0,0,1-1.08-.56c-.39-.49-.62-1.2-1.49-.87-.06,0-.18-.14-.28-.18a5.7,5.7,0,0,0-1.14-.44A1.81,1.81,0,0,1,254.77,76c0-.26-.06-.52-.08-.77-1.1-.43-2.6,0-2.91-1.74a1.82,1.82,0,0,1-2.28-.27c-.71-.6-1.49-1.11-2.18-1.71a1.32,1.32,0,0,1-.38-.91c0-.86.16-1.73.23-2.6a1,1,0,0,0-.68-1.12l-.52.58a1.39,1.39,0,0,1-.59-1.74,8,8,0,0,0-.25-5.76c-.32-.7-.59-1.42-.92-2.23-.81.12-1.19-.52-1.57-1.16a5.8,5.8,0,0,0-.62-1,2.51,2.51,0,0,1-.59-2.37,4.74,4.74,0,0,0-.32-2.59c-.39-1.12-1.15-2.25-.49-3.54,0-.06,0-.19,0-.22-.62-.64,0-1.2.15-1.82l-1.15-.82c-.37-.27-.74-.54-1.09-.83-.51-.4-1-.83-1.48-1.25-.25-.22-.65-.43-.69-.69-.11-.72-.65-1-1.09-1.4-.48.19-.92.34-1.33.55s-.71.46-1.07.69a1.22,1.22,0,0,1-2-.48,2.66,2.66,0,0,1-.31-1,4,4,0,0,0-.77-2.15,1.94,1.94,0,0,1-.31-2,1.38,1.38,0,0,0,.07-1,3.9,3.9,0,0,1-.29-2.15c0-.73,0-1.38-.87-1.54.28-2.14-.35-2.82-1.86-3.46.07-.73.16-1.5.24-2.35-1.17-.1-1.49-1-1.68-2a6.23,6.23,0,0,1-.1-1.61,3.36,3.36,0,0,0-1.2-2.89,18.71,18.71,0,0,1-1.32-1.35c-1.66,1.62-1.65,1.62-2.2,3.87-.14.57-.31,1.13-.5,1.67a3.28,3.28,0,0,0-.18,2.44,2.11,2.11,0,0,0-1.73,1.45,2,2,0,0,0,.87,2.57,5.78,5.78,0,0,1-.58.86,2.73,2.73,0,0,0-.68,3.27,1.3,1.3,0,0,1-.32,1.47,3,3,0,0,0-.43,3.55,2.35,2.35,0,0,1,.18,1.44,8.94,8.94,0,0,0,.27,4.36,2.77,2.77,0,0,1-.13,2.33,10.64,10.64,0,0,0-1.14,4.46,11.42,11.42,0,0,1-1.78,5.33,6.78,6.78,0,0,0-.49.92c-.26.64-.49,1.29-.73,1.94s-.42,1.17-.69,1.72a1.45,1.45,0,0,1-.62.63c-.93.47-1.88.91-2.84,1.31a2.4,2.4,0,0,1-2.42-.28,10,10,0,0,0-.9-.52c-.87-.42-1.76-.79-2.61-1.24a3.1,3.1,0,0,1-1.67-2,2.45,2.45,0,0,0-2.48-1.87,7.27,7.27,0,0,1-5.77-2.93,4.4,4.4,0,0,0-1.34-1.07c-1-.56-2-1-2.94-1.6a2.27,2.27,0,0,0-2-.41.94.94,0,0,1-.95-.25c-.83-.69-1.72-1.32-2.5-2.07a22.29,22.29,0,0,0-4.83-3.59c-.65-.35-1-1.16-.66-1.65.78-1,1.1-2.34,2.13-3.27a4.71,4.71,0,0,0,1.51-3.65c-.37-.24-.76-.35-.88-.6-.47-.94.38-2.82,1.39-2.85.6,0,.88-.4,1.33-.54a.8.8,0,0,1,.28,0l.44.75c.53-.6.92-1.12.68-1.92a1.25,1.25,0,0,1,.44-1.26A15.48,15.48,0,0,0,186.16,29a2.47,2.47,0,0,0,.8-1.63,6,6,0,0,1-1.46-.55,5.55,5.55,0,0,1-1-1.28l-1.38.28a6.85,6.85,0,0,1,.1,1c0,.32,0,.75-.23.93a1.93,1.93,0,0,1-1.72.71c-.17-.6-.35-1.21-.53-1.82-1.1.32-1.1.32-1.64-.38.18-.43.92-.49.75-1.31a8.22,8.22,0,0,0-1.11.48,6.23,6.23,0,0,0-1,.73c-1.22,1.07-2.4.83-3.61-.06a2.5,2.5,0,0,0-2.21-.35c-.29.07-.71.16-.89,0-.49-.4-.93-.14-1.39.06l-.81-1.24-.84.14-.66-.8c-.41,0-.76.11-1.1.11-1.49,0-3,.09-3.78-1.64-.37-.81-.81-.88-1.6-.44a.88.88,0,0,1-1.22-.18c-.51-.51-1.07-1-1.62-1.47-.21.24-.33.39-.47.52s-.27.25-.4.36c-1.28-.93-1.28-.93-2-.32.25.27.51.53.74.81a1,1,0,0,0,1.23.37,2.26,2.26,0,0,1,.78-.16c1-.06,1.4.29,1.55,1.29.07.42.15.84.25,1.25.28,1.18.25,1.31-.83,1.95a5,5,0,0,1-1.28.4,8.43,8.43,0,0,1-1,.2c-.33.06-.66.09-1,.12a14.32,14.32,0,0,0-1.47.11c-1.07.2-2.09.31-2.72-.86,0-.06-.12-.08-.24-.15-.35.72-1,.31-1.58.37-.05.4-.09.75-.11.92l-1.34,1.2-.72-.48c-.54.49-.5,1.35-1.26,1.53-.55.12-.72.49-.84,1a1.25,1.25,0,0,1-.42.65c-.88.63-1.05.82-.4,1.92.32.54.2.89-.27,1.16s-1.26.62-2,1c-.17.65-.34,1.49-.63,2.29a2,2,0,0,1-.73,1,4.66,4.66,0,0,0-1.59,1.8.76.76,0,0,0,.34,1.15,5,5,0,0,0,.85.34l.79,2c-.84.33-.07,1.19-.57,1.83l-2-1.41-.52,1.49a2.26,2.26,0,0,0-1.57-1.46,23.44,23.44,0,0,0-2.46-.65c-1-.2-1.23,0-1.13,1.05a1.24,1.24,0,0,1,0,.31,7.65,7.65,0,0,0-1.46,1.06,5.93,5.93,0,0,0-.71,1.45l-.27-.09c.21-1.44.42-2.88.62-4.21-.66-.65-1.27-1.18-1.8-1.78-.67-.76-1.29-1.55-1.9-2.35a2.36,2.36,0,0,0-1.81-1.1,1.68,1.68,0,0,1-1.15-.39c-.57-.79-1.26-.7-2-.57a2,2,0,0,1-1.31,2.66c-.83-1.34-.87-1.34-1.69-.11,0,0-.13,0-.2,0-.8-1.52-1-1.63-1.66-.72l1,.68a6.78,6.78,0,0,0-.74,1.09,6.72,6.72,0,0,0-.25,1.2.66.66,0,0,1-.2.28,1,1,0,0,1-1.76-.46,13.2,13.2,0,0,1-.44-1.25l-.21.05c-.07.43-.13.87-.2,1.32a3.12,3.12,0,0,0-.49.06,2,2,0,0,0-1.45,3c.15.33.29.67.54,1.25-1.07-.48-1.94-.88-2.81-.22,0,.91,0,.89.82,1.17.45.16.43.47.12.86l-1.85-.88a7.24,7.24,0,0,0-.73,1c-.29.6-.86.11-1.21.35a1.75,1.75,0,0,0,.23,2.24,2.53,2.53,0,0,1,.34,1.3c0,.14-.17.44-.27.44-.74,0-.69.55-.8,1a11,11,0,0,1-.42,1.12,5.19,5.19,0,0,1-.72-.62,1.13,1.13,0,0,0-1.35-.42c-.68.3-1.06.19-1.39-.47-.22-.43-.68-.38-1-.15a.52.52,0,0,0-.05.89c.51.45.3.78-.11,1.14a6.79,6.79,0,0,0-.55.62c.62.63,1.2,1.28,1.85,1.85s.86,1,.35,2.11l-1.29-.78c-.4.91.15,2-.65,2.91-1.45-2.3-2.69-4.54-3.85-6.84-.14.1-.24.13-.26.19-.34.89-.33,2.06-1.72,2.1-.14.92-1.1,1-1.6,1.51-1.45,1.55-1.5,1.65-1.29,3.81a4.85,4.85,0,0,0,.11,1,3.83,3.83,0,0,0,.63,1.18c.51.57.6.79.18,1.38a3.2,3.2,0,0,1-.73.74c-.74.56-1.51,1.08-2.27,1.61-.32.22-.65.41-.54.91,0,.14-.11.34-.2.5-.4.74-.88,1.45-1.21,2.22A8.76,8.76,0,0,1,85,76.28a16.77,16.77,0,0,1-5.77,2,4.85,4.85,0,0,0-1.41.5,2.26,2.26,0,0,1-2,.1c-.24-.11-.52-.16-.76-.27a1.48,1.48,0,0,0-2.11.53,3.67,3.67,0,0,1-2.62,1.54A7.73,7.73,0,0,0,69,81a10.54,10.54,0,0,0-2.43,1,6.79,6.79,0,0,1-2.91,1.46,3.14,3.14,0,0,1-2.1-.17,1.09,1.09,0,0,0-.76-.16,1.45,1.45,0,0,1-1.92-.65c-1.27.8-2.12,2.27-3.74,1.91a7.55,7.55,0,0,1-.83,1.08c-.68.63-1.43,1.17-2.11,1.79a13.41,13.41,0,0,1-4.95,2.93A4.31,4.31,0,0,0,44.91,92a8.36,8.36,0,0,0-1.52,3.62L41.9,95.5a9.39,9.39,0,0,1-.36-2.23,10.73,10.73,0,0,1,.6-2.21,1.5,1.5,0,0,0-1.26.91c-.55,1.2-1.12,2.38-1.62,3.59a1.57,1.57,0,0,0-.09,1.12,11.35,11.35,0,0,1,.6,4.21,3.6,3.6,0,0,1-1.05,2.61,8.13,8.13,0,0,0-.77,1.14,8.38,8.38,0,0,0-.87,3.45,2.34,2.34,0,0,0,.52,2,7,7,0,0,1,1.35,3,4.86,4.86,0,0,0,.44,1c.28.5.64,1,.91,1.47a12.1,12.1,0,0,0,1.48,2.74,1.27,1.27,0,0,1,.28.74c.11.92.18,1.85.25,2.77a1.43,1.43,0,0,1-1,1.5l-1-2.57-.75.62c-.09-.39-.14-.68-.23-.95-.27-.84-.52-1.68-.84-2.5-.19-.47-.55-.47-1-.1.38,1.27.4,2.7,1.69,3.61a2.15,2.15,0,0,1,.89,2.24c-.11.7-.42,1.13-.91,1.17s-.79-.33-1-1.08-.45-1.3-.7-2c-1,1-1,1.18-.23,2a21.05,21.05,0,0,1,2.27,2.76c.82,1.4,1.4,2.93,2.12,4.39a3.84,3.84,0,0,1,.34,2.24,3.18,3.18,0,0,0,.5,2.33c.69,1,1.37,2,2,3a4.07,4.07,0,0,1,.5,1.38,2.78,2.78,0,0,0,.65,1.56,6.51,6.51,0,0,1,1.64,4.78,40.21,40.21,0,0,0,.22,4.39c.38,2.93,1.82,5.5,3.16,8.06a14.09,14.09,0,0,1,1.71,5.12,6.45,6.45,0,0,1-.45,3.86,3.43,3.43,0,0,0-.39,2.22,16.14,16.14,0,0,0,.32,2.18,3.56,3.56,0,0,1-1,3.5c-1.13,1.29-1.62,1.39-3.18.57-.05,0-.14,0-.27,0a12.14,12.14,0,0,0,.72,5.71,2.55,2.55,0,0,1,3,.62c.91.82,1.66,1.81,2.5,2.71a2.25,2.25,0,0,0,.72.51c1,.41,1.92.79,2.89,1.16a5.79,5.79,0,0,0,1.09.27c.22,0,.51-.07.67,0a2.77,2.77,0,0,0,2.25.12,3.19,3.19,0,0,1,1.68.12c1.07.27,2.23.86,3.22-.26.07-.07.21-.08.32-.12a6.37,6.37,0,0,0,3.33-2.14.66.66,0,0,1,.34-.28,3.23,3.23,0,0,0,1.73-1.3,1.4,1.4,0,0,1,1.66-.47,1.58,1.58,0,0,0,2-.64,5.88,5.88,0,0,0,.65-1.07,5.07,5.07,0,0,1,2.64-2.5,1.14,1.14,0,0,1,.77-.13,5.92,5.92,0,0,0,4-.21,13.89,13.89,0,0,1,6.66-.15,2.31,2.31,0,0,0,1.11-.07c.79-.25,1-.2,1.3.55s.69.91,1.23.5a7.47,7.47,0,0,1,3-.92,2.57,2.57,0,0,1,2.51.49.78.78,0,0,0,1,.05,2.75,2.75,0,0,1,1.15-.41,1.77,1.77,0,0,0,1.38-.7,13.17,13.17,0,0,1,1.32-1.46,2.23,2.23,0,0,0,.85-1.7,4.43,4.43,0,0,1,1.18-2.59,2.42,2.42,0,0,1,1.87-1,4.08,4.08,0,0,0,1.3-.4c.85-.37,1.69-.77,2.51-1.2,1.1-.57,2.18-1.17,3.26-1.76S117,166.4,118,166a2.75,2.75,0,0,1,1.34-.17c.84.07,1.68.28,2.52.35a11.72,11.72,0,0,0,5.58-.81c.7-.29,1.45-.49,2.18-.72.29-.1.61-.12.89-.24a25.74,25.74,0,0,0,5.15-2.35,2.23,2.23,0,0,1,.85-.37,30.47,30.47,0,0,1,3.77-.6c2.36-.14,4.72-.15,7.08-.18a3,3,0,0,0,2.19-.56,1.11,1.11,0,0,1,1.38-.11,18.68,18.68,0,0,1,5.17,3,2.08,2.08,0,0,0,2.61.52,2.6,2.6,0,0,1,3.18.61,2.33,2.33,0,0,0,3,.55,1.68,1.68,0,0,1,2.1.42,3.39,3.39,0,0,1,.66.8,2.71,2.71,0,0,0,1.45,1.23c1.18.48,1.39.94,1.22,2.15l-1.06.12c-.25,1,.61,1.43.95,2.08a3.19,3.19,0,0,0,1,.94.51.51,0,0,0,.45,0c.61-.3.93.13,1.29.48a3,3,0,0,1,1,2.27,1.69,1.69,0,0,0,.73,1.46,5.58,5.58,0,0,1,2.23,3.54,8.17,8.17,0,0,0,1,3.41c0,.05-.07.18-.14.38l-1.41-1a7.4,7.4,0,0,0,4.82,3.11c0-.33.08-.69.13-1l-.9-.49c.23-.72.23-1.51,1.17-1.71a.66.66,0,0,0,.36-.28c.57-.9,1.17-1.79,1.69-2.73a4.76,4.76,0,0,1,1.8-1.92,5.15,5.15,0,0,0,.95-.65,2.22,2.22,0,0,1,1.55-.68,1.27,1.27,0,0,0,.7-.31,3.44,3.44,0,0,0,1.29-2.1,3.73,3.73,0,0,1,2-3,1.58,1.58,0,0,0,.85-1.54v-.81l.28,0c.38,1.19.74,2.37,1.11,3.55l-1.18.6c.17.43.29.76.42,1.08a2.32,2.32,0,0,1-.56,2.64c-1.59,1.75-2.61,3.71-1.91,6.2a2.15,2.15,0,0,1,0,.8c-.12.8-.25,1.59-.4,2.47a17.12,17.12,0,0,0-1.87-.08c-.31,0-.82.13-.9.34a4.62,4.62,0,0,0-.53,2.46l3.44-1.3c1.51.52,1.69.41,2.11-1.33.31-1.28.6-2.56.93-3.83a4.43,4.43,0,0,1,1.18-2.26c.24.49.39.86.59,1.22a17.79,17.79,0,0,0,1.51,2.58,2.84,2.84,0,0,1,.52,2.91,8.83,8.83,0,0,0-.43,1.56,2.26,2.26,0,0,1-1.17,1.85l-.39.25c-.49.29-.61.67-.23,1.23.8-.1,1.73.2,2.41-.43a1.57,1.57,0,0,1,2.33-.19c0-1.06.71-1.41,1.4-1.77a.65.65,0,0,1,.93.15,1.23,1.23,0,0,1,.12.95,2.71,2.71,0,0,1-.8.78,4.5,4.5,0,0,1-.58.38c.28.29.48.52.69.74A10.82,10.82,0,0,1,204,195.1a17.75,17.75,0,0,1,1.79,4.88,2.24,2.24,0,0,1-.29,1.53c-.18.29-.46.63-.43.92.17,1.39.4,2.78,1.63,3.7a6.14,6.14,0,0,1,1.85,2.48,6.7,6.7,0,0,0,.62,1.11,3,3,0,0,0,2.28,1.39c1.73.16,3.33.65,4.24,2.37.29.55,1,.48,1.54,0a1.12,1.12,0,0,1,.75-.37,6.39,6.39,0,0,1,1.89.47,2.37,2.37,0,0,0,1.31.24,2.89,2.89,0,0,1,2.29.55,5.37,5.37,0,0,0,2.55,1.49,1.64,1.64,0,0,1,.51.26c1,.54,1.93,1.08,3,1.65l3.08-2.68a16,16,0,0,1,1.66-1.42c.74-.5,1.57-.88,2.38-1.32-.15-.72-1-.42-1.52-.83a18,18,0,0,1,1.68-1.2,1.82,1.82,0,0,1,2.46.6,1.17,1.17,0,0,1,.22.85,5.45,5.45,0,0,1-1,1.56c-.2.21-.69.14-1,.2.73,1.18,1.52,1.24,2.28.18.14-.19.21-.42.35-.6a1.28,1.28,0,0,1,1.25-.46.74.74,0,0,1,.42,1.29,2.18,2.18,0,0,1-.51.33c.68,1.59.83,1.7,2.51,1.93l.73,1.46c1.87-.66,2.17.87,2.74,2,.9-.37.93-.5.52-1.58-1.15,0-1.26-.14-1.05-1.7a12,12,0,0,1,1.47,0c1.62.2,2.71-.75,3.75-1.74.86-.82,1.64-1.74,2.45-2.62.18-.2.52-.48.47-.61-.21-.59.26-.73.56-1s.76-.65,1.22-1a3.61,3.61,0,0,0,2.86-.09,3.67,3.67,0,0,1,1.69-.28,13.76,13.76,0,0,0,5-.16c1.34-.15,2.51-.58,2.83-2.07,1.32,0,1.4-.1,1.3-1.29-.07-.82.09-5.22.07-6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M255.8,234.33c1.17.33,1.17.33,1.73-.51.38.12.79.22,1.18.37a1.36,1.36,0,0,1,1,1.53c-.08,1.3-.25,2.6-.23,3.91s.21,2.61.32,3.92l.15,1.91-.23.09-.56-.77c-.89.4-1,1.22-1.08,1.94a6.65,6.65,0,0,1-.67,2.52,4.77,4.77,0,0,0-.33,2.16c0,.21.35.43.59.7v2l-1.2.38a2.07,2.07,0,0,1-.81-1.83l1,.15c0-.23.06-.54-.05-.63a3.32,3.32,0,0,0-.9-.46.57.57,0,0,0-.82.4c0,.06-.09.17-.14.17-1.65,0-1.31,1.49-1.8,2.36a2,2,0,0,0-.13.37c-.15,0-.3,0-.44,0a3.09,3.09,0,0,1-.43-.14c0,.06-.11.13-.1.17a1.4,1.4,0,0,1-.2,1.32,2.88,2.88,0,0,0-.36.82c-.27.79-.79,1.18-1.48.82a9.76,9.76,0,0,0-3-.59,1.8,1.8,0,0,1-1.7-1.67c0-.18-.15-.49-.22-.49-1,0-1.27-1-1.77-1.58a12.12,12.12,0,0,1-2.86-7.24l1.61,1.46c.29-.62-.22-.85-.37-1.18a4.9,4.9,0,0,0-.7-1c-.1-.13-.32-.22-.34-.35a7.36,7.36,0,0,0-1.54-3.22,12.89,12.89,0,0,1-2.12-5.46,3.85,3.85,0,0,1,.38-2.92,4.47,4.47,0,0,1,1.23-1c.07-.06.32.11.62.23-.22.15-.33.22-.43.3a2.1,2.1,0,0,0-.24.27c.07.1.12.22.21.27s.46.28.64.24c1.64-.44,2.67.94,4,1.32a4.19,4.19,0,0,1,1,.53,7.33,7.33,0,0,0,4.4,1.07,1.67,1.67,0,0,0,.83-.34,4.08,4.08,0,0,1,3.24-.91,2.51,2.51,0,0,0,2.59-.89,4.21,4.21,0,0,1,.57-.48"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M191.39,191.6l.16,1c.9.57,2.11.17,2.93,1.12a2.36,2.36,0,0,1-1.53.13,1.54,1.54,0,0,0-1.65.82c-.26.5-.57.48-1,.36a5.55,5.55,0,0,0-1.57-.15c-.58,0-1.15.16-1.73.23-1.22.13-1.8-.4-1.87-1.82.66-.28,1.35-.61,2.07-.86a25.23,25.23,0,0,1,2.66-.78,8.12,8.12,0,0,1,1.57,0"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M291.42,111.11c.18.7.37,1.32.49,2a1.81,1.81,0,0,1-.1.89c-.43,1.15-.89,2.29-1.35,3.43a5.26,5.26,0,0,1-.39.65c-.62-.66-.4-1.35-.36-2a4.73,4.73,0,0,1,.22-1.12,2,2,0,0,1,.43-.89c.65-.6,1-1.21.51-2.11-.2-.36,0-.65.55-.81"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M259.72,227.39c.19,1.29-.05,1.13-1.27,1.76-.09,0-.25-.06-.28-.13a22.44,22.44,0,0,0-1.39-2.31c-.43-.68.4-1,.62-1.52.8.76,1.51,1.42,2.32,2.2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M232.65,224.32a8.46,8.46,0,0,1,.43,1.78,2.7,2.7,0,0,1-.41,1.37c-.16.25-.6.32-.94.47-.7-2.25-.49-3.1.92-3.62"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M35.48,120.35a3.91,3.91,0,0,1-1-3.75c.19.75.3,1.36.5,2s.49,1.15.75,1.73l-.27.07"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M260.32,230.56c-.57.14-1.13.3-1.71.41-.08,0-.24-.18-.3-.3s0-.29.08-.31a6.77,6.77,0,0,1,1.32-.35c.2,0,.42.2.63.32a1.79,1.79,0,0,1,0,.23"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M253.37,255.64c0,.29.07.57.13,1-.21-.14-.36-.19-.36-.24a7,7,0,0,1,0-.79l.2,0"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M310.19,163.58a1.68,1.68,0,0,0-1.54,2.55,5.13,5.13,0,0,0,3,2.63,1.5,1.5,0,0,0,2.14-1.32c.1-1.54-2-3.84-3.6-3.86m-39.26-23.66a2.81,2.81,0,0,0-2.49,1.31,2.51,2.51,0,0,0,1,2.86,8.81,8.81,0,0,1,1.12.76,2.07,2.07,0,0,0,2.91,0,1.8,1.8,0,0,0,.68-1,3.68,3.68,0,0,0-3.24-3.88m39.4,6.78a8.69,8.69,0,0,0,.54,1.3,4.86,4.86,0,0,0,2.33,2c1.46.64,2.12.51,3.18-.69a1.52,1.52,0,0,0-.05-2.29,19.73,19.73,0,0,0-3.37-2.13c-1-.48-2.54.69-2.63,1.83M326,178.31a7.38,7.38,0,0,0-.05-.79c-.13-.78-.29-1.57-1.19-1.85a2.18,2.18,0,0,0-2.33.7,4.71,4.71,0,0,0-.79,5.15,1.87,1.87,0,0,0,1.23.83,2.32,2.32,0,0,0,2.27-.93,4.29,4.29,0,0,0,.86-3.11m-45.2-47a2.53,2.53,0,0,0-2.49,1.27,2.33,2.33,0,0,0,.39,2.61,3.83,3.83,0,0,0,4.29,1.19,2.44,2.44,0,0,0,1.61-1.68,1.18,1.18,0,0,0-.07-.93,5.33,5.33,0,0,0-3.73-2.46m-12,51a3.25,3.25,0,0,0-2.79,2.44l-.3.94c-.66,2.09-1.33,4.17-2,6.35.82-.07,1.54-.15,2.27-.19a3.09,3.09,0,0,0,2.88-2.1,10.17,10.17,0,0,0,0-7.44M262.44,155c1.63,0,4.24-2,4.6-3.6.21-.89,0-1.65-.6-2a5.44,5.44,0,0,0-5.38-.08,3.48,3.48,0,0,0-1.54,3.61,3.06,3.06,0,0,0,2.92,2M297,142.72c0-.07,0-.14.07-.22a5.52,5.52,0,0,0,3.23-.93,1.86,1.86,0,0,0,1-1.84,1.75,1.75,0,0,0-1.31-1.69,14.89,14.89,0,0,0-6.15-.58,2,2,0,0,0-1.65,1.75,1.82,1.82,0,0,0,1,2.17c1.24.53,2.55.9,3.83,1.34m27,25.93a4.44,4.44,0,0,0-3.27-4.43,2.75,2.75,0,0,0-3.19,1.17,4,4,0,0,0,1.55,5.73,3.14,3.14,0,0,0,3.38.24,3.3,3.3,0,0,0,1.53-2.71m-43.84-5.55a4.14,4.14,0,0,0-.11-.67,4.89,4.89,0,0,0-6.61-3.26,2.76,2.76,0,0,0-1.65,3.88,5.79,5.79,0,0,0,4.6,3.53,3.28,3.28,0,0,0,3.77-3.48m1.65-16.74a6.35,6.35,0,0,0,4.32,5.83c2.06.51,3.81-.77,3.59-2.68a7.66,7.66,0,0,0-2.82-5.28,3,3,0,0,0-3.38-.62,3.08,3.08,0,0,0-1.71,2.75m29.49,5.69a12.53,12.53,0,0,0-2.25.8,2.84,2.84,0,0,0-1.21,3.92,7.51,7.51,0,0,0,5.61,3.87c1.94.24,3.49-.61,3.52-2.79a6,6,0,0,0-5.67-5.8m-4.17-5.21c0-2.19-1.46-3.33-3.24-2.75a8.6,8.6,0,0,0-5.75,5.7,3.53,3.53,0,0,0,.72,3.59,2,2,0,0,0,2.9.47,20.86,20.86,0,0,0,3.28-2.79,7.92,7.92,0,0,0,2.09-4.22m-21.69,16.84a4.36,4.36,0,0,0,1,2.94,2.58,2.58,0,0,0,2.87.89,18.38,18.38,0,0,0,2.85-1.22,8.48,8.48,0,0,0,2-1.38,3.07,3.07,0,0,0-1.34-5.36c-.65-.2-1.35-.21-2-.38a4.41,4.41,0,0,0-5.38,4.51m-35.74-49.07c2.07.26,3.31,1.92,3.71,4s.78,4.33,1.17,6.49a19.92,19.92,0,0,0,.49,2.69c.86,2.69,2.54,4.57,5.47,5.07,1.62.28,3.23.61,4.87.81a4,4,0,0,0,1.83-.31c2.48-1,5-1.9,7.38-3a15,15,0,0,1,10.62-.66,99.56,99.56,0,0,1,28.56,12.8,21.77,21.77,0,0,1,9.59,13.87c.58,2.64,1.33,5.24,2,7.86a18,18,0,0,0,5.54,8.9A36,36,0,0,0,347.28,182a41.38,41.38,0,0,0,7.45.85c8.24.29,16.47.38,24.7.69a77.08,77.08,0,0,1,15.31,1.65c4.5,1.08,8.94,2.4,13.38,3.69a7.6,7.6,0,0,1,1.88,1.29v1.22a3.35,3.35,0,0,1-3,1.51l-9.09.66c-4.63.33-9.25.73-13.87,1-2.86.14-5.73-.08-8.6,0-5,.1-9.92.33-14.88.43-4.16.08-8.32.15-12.48,0-5.29-.13-10.57-.5-15.86-.63-3.88-.09-7.76,0-11.64.06s-7.69.31-11.54.48a1.48,1.48,0,0,0-.83.29,5.71,5.71,0,0,1-4.11,1.51q-8.94,0-17.88-.16a3.13,3.13,0,0,1-1.81-.77,3.28,3.28,0,0,0-1.86-.89c-1.2-.16-2.4-.36-3.59-.62a1.84,1.84,0,0,1-1.58-1.45,2,2,0,0,1,1.12-2.15,2.56,2.56,0,0,1,.91-.33l8.52-1,2.21-.25c-3.39-1.69-6.94-3-9.45-6.06-.19.32-.32.56-.46.79l-5.92,10.17a5.78,5.78,0,0,1-3.8,3.11H269a8.83,8.83,0,0,0-1-.16,38.69,38.69,0,0,1-4.32-.28c-3.45-.6-6.91-.34-10.38-.26a21.31,21.31,0,0,1-4-.41,1.62,1.62,0,0,1-1.33-1.41,1.75,1.75,0,0,1,.9-1.79,10.37,10.37,0,0,1,1.25-.72,14,14,0,0,1,5.3-1.2c1.35-.08,1.89-.59,1.72-1.91-.21-1.75-.58-3.49-.83-5.24a8.23,8.23,0,0,0-2.5-4.75c-1-1-1.93-2-2.9-2.91q-6.84-6.72-13.7-13.41a13.31,13.31,0,0,0-9.18-4c-1.9-.07-3.8-.19-5.68-.43a13.17,13.17,0,0,1-5.88-2,18.34,18.34,0,0,0-4.35-1.88,4.27,4.27,0,0,1-2.05-4.39c.25-1.93,1-2.33,2.26-3a5.3,5.3,0,0,0,1.22-.89c1.19-1.1,2.43-2.17,3.52-3.37,3.07-3.4,6.14-6.81,9.1-10.31,2.2-2.6,4.52-5.14,5.9-8.35.57-1.32,1.26-2.59,1.92-3.88a6.74,6.74,0,0,1,.88-1.4,2.79,2.79,0,0,1,3-.72c.87.43,1.16,1.29.91,2.64-.14.72-.26,1.44-.4,2.24h2.4a1.8,1.8,0,0,0,1.54-.83c1.2-1.69,2.42-3.37,3.59-5.09.73-1.07,1.38-2,2.72-2.28a4.21,4.21,0,0,1,1,0"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('h4', {
    staticClass: "wwf-font"
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _vm._m(1, false, false)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "arrow-open"
  }, [_c('i', {
    staticClass: "fas fa-chevron-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "arrow-more"
  }, [_c('i', {
    staticClass: "fas fa-chevron-down"
  })])
}]}

/***/ }),
/* 659 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.product) ? _c('div', {
    staticClass: "product-header",
    attrs: {
      "id": "impact-product-header"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.heading || "Help Make an Impact"))]), _vm._v(" "), _c('p', {
    staticClass: "tagline"
  }, [_vm._v(_vm._s(_vm.product.meta.description))]), _vm._v(" "), _c('div', {
    staticClass: "goal-wrapper"
  }, [_c('div', {
    staticClass: "progress-bar"
  }, [_c('div', {
    staticClass: "progress-bar-wrapper"
  }, [_c('div', {
    staticClass: "progress-bar-inner",
    style: ({
      width: _vm.goalProgress + '%'
    })
  })])]), _vm._v(" "), _c('p', {
    staticClass: "goal"
  }, [_vm._v("\n      $" + _vm._s(_vm.formatCurrency(_vm.product.meta.currentDonationAmount)) + " of $" + _vm._s(_vm.formatCurrency(_vm.product.meta.goalAmount)) + "\n      raised\n    ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "deadline"
  }, [_vm._v(_vm._s(_vm.endDateText))])])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 660 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "social-icons"
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/social-media/icon-facebook.svg"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.instagram.com"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/social-media/icon-instagram.svg"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.linkedin.com"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/social-media/icon-linkedin.svg"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.twitter.com"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/social-media/icon-twitter.svg"
    }
  })])])])
}]}

/***/ }),
/* 661 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "twentytwenty-container",
    style: (_vm.containerStyle),
    on: {
      "touchstart": _vm.startSlide,
      "mousedown": _vm.startSlide
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.after,
      "alt": "after"
    },
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
      },
      "load": _vm.setDimensions
    }
  }), _vm._v(" "), _c('img', {
    style: (_vm.beforeImgStyle),
    attrs: {
      "src": _vm.before,
      "alt": "before"
    },
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
      }
    }
  }), _vm._v(" "), (_vm.overlay) ? _c('div', {
    staticClass: "twentytwenty-overlay",
    style: (_vm.overlayStyle)
  }, [(_vm.beforeLabel) ? _c('div', {
    staticClass: "twentytwenty-before-label"
  }, [_vm._v(_vm._s(_vm.beforeLabel))]) : _vm._e(), _vm._v(" "), (_vm.afterLabel) ? _c('div', {
    staticClass: "twentytwenty-after-label"
  }, [_vm._v(_vm._s(_vm.afterLabel))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "twentytwenty-handle",
    style: (_vm.handleStyle),
    attrs: {
      "tabindex": "0"
    },
    on: {
      "keydown": _vm.handleArrowNavigation
    }
  }, [_c('div', {
    staticClass: "twentytwenty-arrow-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "twentytwenty-arrow-right"
  })])])
},staticRenderFns: []}

/***/ }),
/* 662 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wwf-form wwf-form-product",
    class: [{
      'formValidation-shake': _vm.isShake
    }, _vm.className]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.donation.isLoading),
      expression: "donation.isLoading"
    }],
    staticClass: "wwf-loading-container"
  }, [_vm._m(0, false, false)]), _vm._v(" "), _c('form-wizard', {
    ref: "wizard",
    attrs: {
      "shape": "tab",
      "start-index": _vm.stepIndex
    },
    on: {
      "on-loading": _vm.setLoading,
      "update:startIndex": function($event) {
        _vm.stepIndex = $event
      },
      "on-change": _vm.setFormStepState
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function(props) {
        return [_c('div', {
          staticClass: "form-buttons prev"
        }, [_c('a', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (props.activeTabIndex == 1),
            expression: "props.activeTabIndex == 1"
          }],
          style: (props.fillButtonStyle),
          attrs: {
            "href": "#form-top",
            "id": "Previous",
            "data-animation-duration": "300",
            "data-animation-easing": "swing",
            "data-smooth-scroll": "",
            "data-threshold": "75"
          },
          on: {
            "click": function($event) {
              props.prevTab()
            }
          }
        }, [_vm._v("Previous")])]), _vm._v(" "), _c('div', {
          staticClass: "form-buttons next"
        }, [_c('a', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (props.activeTabIndex != 2),
            expression: "props.activeTabIndex != 2"
          }],
          class: props.activeTabIndex != 0 && _vm.donation.payementType == 'wwf_paypal' ?
            'paypal-button' :
            '',
          style: (props.fillButtonStyle),
          attrs: {
            "href": "#form-top",
            "id": "Next",
            "data-animation-duration": "300",
            "data-animation-easing": "swing",
            "data-smooth-scroll": "",
            "data-threshold": "75"
          },
          on: {
            "click": function($event) {
              props.nextTab()
            }
          }
        }, [_vm._v(_vm._s(props.activeTabIndex == 0 ?
          "Next" :
          _vm.donation.payementType == "wwf_paypal" ?
          "Pay with PayPal" :
          "Go to payment"))])])]
      }
    }])
  }, [_c('h2', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }), _vm._v(" "), _c('tab-content', {
    attrs: {
      "title": "Choose",
      "before-change": function () { return _vm.validateStep('step1'); }
    }
  }, [_c('Step1', {
    ref: "step1",
    attrs: {
      "useNewCheckout": _vm.useNewCheckout
    }
  })], 1), _vm._v(" "), _c('tab-content', {
    attrs: {
      "title": "Details",
      "before-change": function () { return _vm.validateStep('step2'); }
    }
  }, [_c('Step2', {
    ref: "step2",
    attrs: {
      "disabledGoogleAutocomplete": _vm.disabledGoogleAutocomplete,
      "thankYouUrl": _vm.thankYouUrl,
      "useNewCheckout": _vm.useNewCheckout,
      "isEarthHour": _vm.isEarthHour
    }
  })], 1), _vm._v(" "), _c('tab-content', {
    attrs: {
      "title": "Payment"
    }
  }, [_c('Step3', {
    attrs: {
      "thankYouUrl": _vm.thankYouUrl,
      "useNewCheckout": _vm.useNewCheckout,
      "useProductThankYouUrl": _vm.useProductThankYouUrl
    }
  })], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wwf-loading"
  }, [_c('span')])
}]}

/***/ }),
/* 663 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.selection) ? _c('div', {
    staticClass: "search-tabs"
  }, _vm._l((_vm.selection), function(s) {
    return _c('button', {
      staticClass: "search-tab",
      class: {
        'active-type': s.label === _vm.selected.label
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setNewTab(s)
        }
      }
    }, [_vm._v("\n    " + _vm._s(s.label) + " (" + _vm._s(s.numberOfResults) + ")\n  ")])
  })) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 664 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lr-payment"
  }, [_c('div', {
    staticClass: "payment-type-selector"
  }, [_c('button', {
    class: {
      selected: _vm.isCreditCard
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.selectPaymentType('wwf_purchasetokenise')
      }
    }
  }, [_c('span', [_vm._v("Donate by Credit Card")])]), _vm._v(" "), _c('button', {
    class: {
      selected: _vm.isPayPal
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.selectPaymentType('wwf_paypal')
      }
    }
  }, [_c('span', [_vm._v("Donate by Paypal")])]), _vm._v(" "), _c('button', {
    class: {
      selected: _vm.isDirectDebit
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.selectPaymentType('wwf_directdebit')
      }
    }
  }, [_c('span', [_vm._v("Donate by Direct Debit")])])]), _vm._v(" "), _c('div', {
    staticClass: "summary-container"
  }, [_c('div', {
    staticClass: "summary"
  }, [_c('div', {
    staticClass: "amount"
  }, [_vm._v("$" + _vm._s(_vm.donation.amount))]), _vm._v(" "), _vm._m(0, false, false)]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "payment-form"
  }, [_c('CreditCard', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCreditCard),
      expression: "isCreditCard"
    }],
    ref: "creditCardCheckout",
    on: {
      "success": _vm.processSuccess,
      "retry": _vm.retry
    }
  }), _vm._v(" "), _c('DirectDebit', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDirectDebit),
      expression: "isDirectDebit"
    }],
    ref: "directDebitCheckout",
    on: {
      "success": _vm.processSuccess,
      "retry": _vm.retry
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isPayPal),
      expression: "isPayPal"
    }],
    staticClass: "paypal-payment"
  }, [(!_vm.isLoading) ? _c('a', {
    staticClass: "paypal-button",
    on: {
      "click": _vm.checkoutPaypal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('div', [_c('i', {
    staticClass: "far fa-spinner-third fa-spin"
  })]) : _vm._e()])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "secure"
  }, [_c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/secure-icon.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v("Secure")]), _vm._v(" "), _c('p', [_vm._v("payment")])])])
}]}

/***/ }),
/* 665 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_vm._v("\n  " + _vm._s(_vm.replacedText) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 666 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "taxt-calculator"
  }, [(_vm.isCalculator) ? _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        checkifvalid: true,
        regex: /^\d+(\.\d{1,2})?$/
      }),
      expression: "{required: true, checkifvalid: true, regex: /^\\d+(\\.\\d{1,2})?$/}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.amount),
      expression: "amount"
    }],
    class: {
      'border-red': _vm.errors.has('amount')
    },
    attrs: {
      "autocomplete": "off",
      "type": "tel",
      "name": "amount",
      "id": "amount",
      "placeholder": "Donation amount",
      "data-vv-as": "amount"
    },
    domProps: {
      "value": (_vm.amount)
    },
    on: {
      "focus": function($event) {
        _vm.setShowResult(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.amount = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.first('amount')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first('amount')))]) : _vm._e()]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "Calculate"
    },
    on: {
      "click": _vm.calculate
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.isCalculator || _vm.isShowResult) ? _c('div', [_c('h2', [_vm._v("How much tax does that save you?")]), _vm._v(" "), _c('table', {
    staticClass: "tg"
  }, [_c('tbody', [_vm._m(1, false, false), _vm._v(" "), _vm._l((_vm.getTaxBrackeList), function(tax) {
    return _c('tr', [_c('td', {
      staticClass: "tg-yw4l"
    }, [_vm._v(_vm._s(tax.bracket))]), _vm._v(" "), _c('td', {
      staticClass: "tg-yw4l"
    }, [_vm._v(_vm._s((_vm.amount * tax.tax).toFixed(2)))])])
  })], 2)]), _vm._v(" "), (_vm.isCalculator) ? _c('a', {
    staticClass: "bttn-lrg-arrw",
    attrs: {
      "href": "#/"
    },
    on: {
      "click": _vm.donate
    }
  }, [_vm._v("Donate $" + _vm._s((_vm.amount && _vm.amount.indexOf('.00') >= 0) ? _vm.amount.slice(0, -3) : _vm.amount))]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("Use our tax deduction calculator to estimate your savings "), _c('span', {
    staticClass: "wwf-tooltip"
  }, [_c('p', [_vm._v("This table is based upon 2017-2018 ATO individual Income Tax rates. The above rates do not include the Medicare Levy of 2%. The exact level of your tax deductibility will vary depending on your present financial circumstances. Please seek assistance from an independent taxation professional for formal guidelines.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "tg-yw4l"
  }, [_vm._v("Income")]), _vm._v(" "), _c('th', {
    staticClass: "tg-yw4l"
  }, [_vm._v("Savings")])])
}]}

/***/ }),
/* 667 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "impact-donate-wrapper"
    }
  }, [(!_vm.isAchieved) ? _c('Donate', {
    attrs: {
      "productId": _vm.productId
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isAchieved) ? _c('div', {
    staticClass: "wwf-form donation-form donate-impact-wrapper"
  }, [_c('div', [_c('h2', [_vm._v(_vm._s(_vm.product.meta.projectTitle) + " has reached its funding goal!")]), _vm._v(" "), _c('p', {
    staticClass: "tagline"
  }, [_vm._v("Check out this other similar project that you may be interested in!")]), _vm._v(" "), _c('a', {
    staticClass: "project-button",
    attrs: {
      "href": _vm.redirectUrl
    }
  }, [_vm._v("Similar Project")])])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 668 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gathered-here-content"
  }, [_c('div', {
    staticClass: "img credit-c",
    style: ('background-image: url(' + _vm.image + ')')
  }, [_c('p', {
    staticClass: "credit"
  }, [_vm._v(_vm._s(_vm.credit))])]), _vm._v(" "), _c('div', {
    staticClass: "txt text-center"
  }, [_c('h4', [_vm._v("Write your Will for free with")]), _vm._v(" "), _c('div', {
    staticClass: "title-logo"
  }, [_c('a', {
    attrs: {
      "href": _vm.redirectUrl
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.ghLogo,
      "alt": "Gathered Here logo"
    }
  })])]), _vm._v(" "), _c('h5', [_vm._v("WWF-Australia is delighted to offer you an opportunity to create your Will for free. We've partnered with "), _c('a', {
    attrs: {
      "href": _vm.redirectUrl
    }
  }, [_vm._v("Gathered Here")]), _vm._v(", a step-by-step online Will writing service. You can have an incredible impact on our precious wildlife and the places they call home.")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isInvalid),
      expression: "isInvalid"
    }],
    staticClass: "error-message text-center"
  }, [_vm._v("Invalid email address.")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('email'),
      expression: "'email'"
    }],
    staticClass: "gathered-here-email",
    class: {
      'border-red': _vm.errors.has('email')
    },
    attrs: {
      "type": "email",
      "name": "email",
      "placeholder": "Enter email address",
      "disabled": _vm.isSubmitting
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "privacy-caption"
  }, [_vm._v("* Any information shared is protected by our "), _c('a', {
    attrs: {
      "href": _vm.privacyPolicyUrl
    }
  }, [_vm._v("Privacy Policy.")])]), _vm._v(" "), _c('button', {
    staticClass: "bttn-lrg-arrw",
    attrs: {
      "disabled": _vm.isSubmitting
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Create my free will")])]), _vm._v(" "), (_vm.showGraphic) ? _c('svg', {
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 50 50",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M9.9,18.7c0.1-0.7,0-2.5,0.7-2.9c0.5-0.4,1.2-0.2,1.4,0.1c0.4,0.3,0.3,1.8,0.6,1.8c-0.1,0.5,0.1,1.9-0.4,2.4\n          c-0.3,0.5-0.8,0-1.4-0.1C10.2,19.8,9.8,19.5,9.9,18.7z M21.3,10.2c0.8-0.6,0.5-2.4,0.5-3.4c0,0-0.3-2.4-1.6-1.1\n          c-0.6,0.7-1,2.4-0.8,3.3C19.4,10,20.3,10.9,21.3,10.2z M30.7,8.5c0.8-0.9,1.1-2.1,1-3.1c-0.2-0.7-0.8-2.3-1.8-1.6\n          c-0.6,0.5-0.7,2.4-0.7,3.3S29.6,9.6,30.7,8.5z M39,21c1.2-0.1,1.3-1.1,1.2-2.1c0-0.8,0.2-2.9-1.2-2.6c-1.2,0.2-1.2,1.9-1.2,2.8\n          S37.9,21.1,39,21z M43.1,27.4c-0.3-1.7-0.4-3.5-2-4.5c-1.4-0.9-2.9-0.5-4.2,0.2c-2.6,1.7-3.5,4.8-3.1,7.8c0.3,2.4,2.5,7.8,5.8,5.9\n          c1.5-0.9,2.2-2.8,2.8-4.2C43,31,43.4,29.1,43.1,27.4z M27.2,23.9c1.1,0.8,2.3,2.2,3.7,2.2c1.2-0.1,2.3-0.6,3-1.7\n          c1.4-2.1,1.7-5.5,1.6-8.1c0-2.4-1-6-3.9-6c-2.7,0-4.6,2.6-5.3,5.1c-0.6,1.4-0.7,2.9-0.4,4.4C26,21.3,25.9,23,27.2,23.9z M21.6,27.5\n          c0.5-0.5,1-0.7,1.3-1.3c0.5-0.5,0.6-1.6,0.9-2.3c0.6-1.7,0.8-3.4,0.7-5.3c0.1-1.5-0.6-4-2-4.6c-0.7-0.5-1.9-0.4-2.7-0.3\n          c-0.7,0-1.2,0.1-1.8,0.4c-2.8,1.7-2.8,6.4-2.3,9.5C16.3,26.2,18.6,30.4,21.6,27.5z M16,27.5c-0.1-1-0.6-2-1-2.8\n          c-0.4-0.7-0.6-1.5-1.1-2c-0.5-0.5-1.7-0.2-2.4-0.2c-0.7,0-1.5-0.1-2.2,0.1c-0.8,0.4-1,1.1-1.3,1.8c-0.5,0.7-1,1.1-1.1,1.8\n          c-0.1,0.7-0.1,1.7-0.2,2.6c0,0.8-0.1,1.9,0.3,2.7c0.2,0.7,0.6,1.3,1,1.8c1.1,1.1,2,1.7,3.5,2.2c0.5,0.1,1.1,0.6,1.7,0.2\n          c0.5-0.2,1.3-0.8,1.6-1.3c0.3-0.7,0.1-1.2,0.2-1.5c0-0.8,0.6-1.7,0.7-2.6S16.1,28.3,16,27.5z M35,35.7c-0.9-0.8-1.6-1.3-2.2-2.4\n          c-0.6-1-0.5-2.2-1-3.2c-0.4-0.8-1.6-1.6-2.5-2.1c-4-1.8-8.2,2-9,5.9c-0.1,0.9-0.2,1.9-0.9,2.6c-0.6,0.7-1.5,1.3-2.1,2\n          c-1.6,2-1,3.4,0.6,5.2c1.4,1.4,3.4,3,5.6,2.6c1.2-0.2,1.8-0.8,2.6-1.5c1-0.7,1.8-0.3,2.9,0.2c1.7,0.6,3.4,1,5.1-0.3\n          c2-1.3,1.8-3.8,2-5.9c-0.3-0.1-0.3-1.5-0.4-1.8C35.7,36.5,35.3,36,35,35.7z"
    }
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 669 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.product) ? _c('div', _vm._l((_vm.product.donationtypes), function(donationtype) {
    return _c('ul', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.type == donationtype),
        expression: "type == donationtype"
      }],
      key: donationtype,
      staticClass: "donation-widget"
    }, _vm._l((_vm.product.dollarhandles[donationtype]), function(handle, index) {
      return _c('li', {
        key: index,
        staticClass: "dollar-handle-container",
        class: {
          'active': handle.amount == _vm.dollarhandle
        }
      }, [_c('div', {
        staticClass: "selector"
      }, [_c('label', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.dollarhandle),
          expression: "dollarhandle"
        }],
        attrs: {
          "disabled": (_vm.formWizardCurrentStep != 0),
          "type": "radio",
          "name": 'handle-widget-' + donationtype
        },
        domProps: {
          "value": handle.amount,
          "checked": _vm._q(_vm.dollarhandle, handle.amount)
        },
        on: {
          "change": function($event) {
            _vm.dollarhandle = handle.amount
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "amount"
      }, [_vm._v("\n            $" + _vm._s(parseInt(handle.amount)) + "\n          ")])]), _vm._v(" "), _c('span', {
        staticClass: "selector-image",
        style: ('background-image: url(' + handle.img + ')')
      })]), _vm._v(" "), _c('div', {
        staticClass: "description"
      }, [_c('h4', [_c('span', {
        on: {
          "click": function($event) {
            _vm.updateDollarHandle(handle.amount)
          }
        }
      }, [_vm._v(_vm._s(handle.header))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(handle.text))])])])
    }))
  })) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 670 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "petition-counter"
  }, [_c('h5', [_vm._v("You have")]), _vm._v(" "), _c('h2', [_vm._v("\n       " + _vm._s(this.$store.getters.points) + " points\n     ")])]), _vm._v(" "), (_vm.isActive) ? _c('div', {
    staticClass: "petition-form wwf-form light"
  }, [_c('div', {
    staticClass: "flip-wrapper",
    class: {
      'formValidation-shake': _vm.isShake
    }
  }, [_c('div', {
    staticClass: "petition-form"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true}"
    }],
    class: {
      'border-red': _vm.errors.has('firstName')
    },
    attrs: {
      "name": "firstName",
      "type": "text",
      "placeholder": "First name"
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true}"
    }],
    class: {
      'border-red': _vm.errors.has('lastName')
    },
    attrs: {
      "name": "lastName",
      "type": "text",
      "placeholder": "Last name"
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        email: true
      }),
      expression: "{ required: true, email: true}"
    }],
    class: {
      'border-red': _vm.errors.has('email')
    },
    attrs: {
      "name": "email",
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "name": "phone",
      "type": "text",
      "placeholder": "Phone"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true}"
    }],
    class: {
      'border-red': _vm.errors.has('address')
    },
    attrs: {
      "name": "address",
      "type": "text",
      "placeholder": "Address"
    },
    domProps: {
      "value": (_vm.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address = $event.target.value
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rewardid),
      expression: "rewardid"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true}"
    }],
    class: {
      'border-red': _vm.errors.has('rewards')
    },
    attrs: {
      "name": "rewards"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.rewardid = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a reward")]), _vm._v(" "), _vm._l((this.$store.getters.rewards), function(reward) {
    return _c('option', {
      domProps: {
        "value": reward.code
      }
    }, [_vm._v(_vm._s(reward.name) + " (" + _vm._s(reward.points) + " points)")])
  })], 2), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "Submit"
    },
    on: {
      "click": _vm.save
    }
  }), _vm._v(" "), _vm._m(0, false, false)])])])]) : _vm._e(), _vm._v(" "), (!_vm.isActive) ? _c('div', {
    staticClass: "form-closed"
  }, [_c('p', [_vm._v(_vm._s(_vm.closingmessage))])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "privacy-statement"
  }, [_c('p', [_vm._v("By signing you accept\n               "), _c('a', {
    attrs: {
      "href": "/privacy-policy/privacy-policy",
      "target": "_blank"
    }
  }, [_vm._v("WWF-Australia’s Privacy Policy.")])])])
}]}

/***/ }),
/* 671 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.product) ? _c('div', {
    staticClass: "milestones donate-carousel",
    attrs: {
      "id": "impact-project-milestones"
    }
  }, [_c('VueSlickCarousel', _vm._b({
    staticClass: "milestones-wrapper"
  }, 'VueSlickCarousel', _vm.settings, false), _vm._l((_vm.milestones), function(mile) {
    return _c('div', {
      key: mile.index,
      staticClass: "mile",
      class: {
        active: mile.index == _vm.currentMile, 'mile-lg': _vm.milestones.length > 4
      }
    }, [_c('div', {
      staticClass: "mile-inner-box"
    }, [_c('div', {
      staticClass: "location-wrapper"
    }, [_c('i', {
      staticClass: "fas fa-map-marker-alt"
    })]), _vm._v(" "), _c('p', {
      staticClass: "mile-index wwf-font"
    }, [_vm._v(_vm._s(mile.index))]), _vm._v(" "), _c('p', {
      staticClass: "description"
    }, [_vm._v(_vm._s(mile.description))]), _vm._v(" "), _c('p', {
      staticClass: "mile-step wwf-font"
    }, [_vm._v(_vm._s(_vm.currentStepText(mile)))])])])
  }))], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 672 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal",
    class: {
      visible: _vm.showModal
    },
    attrs: {
      "id": "ra-modal"
    }
  }, [_c('div', {
    staticClass: "frame",
    class: {
      visible: _vm.isStepOne
    },
    attrs: {
      "id": "ra-modal-step1"
    }
  }, [_c('div', {
    staticClass: "close ra-modal-close",
    on: {
      "click": _vm.closeModal
    }
  }, [_c('i', {
    staticClass: "fa far fa-times"
  })]), _vm._v(" "), _c('h2', [_vm._v("Get Updates")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "fields"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      error: _vm.errors.has('firstName')
    },
    attrs: {
      "type": "text",
      "placeholder": "First name",
      "name": "firstName",
      "autocomplete": "given-name"
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      error: _vm.errors.has('lastName')
    },
    attrs: {
      "type": "text",
      "placeholder": "Last name",
      "name": "lastName",
      "autocomplete": "family-name"
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Phone (optional)",
      "name": "phone",
      "autocomplete": "tel"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    attrs: {
      "id": "ra-modal-confirm",
      "type": "button"
    },
    on: {
      "click": _vm.confirm
    }
  }, [(!_vm.isLoadingConfirm) ? _c('span', [_vm._v("Confirm")]) : _vm._e(), _vm._v(" "), (_vm.isLoadingConfirm) ? _c('span', [_c('i', {
    staticClass: "far fa-spinner-third fa-spin"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "frame",
    class: {
      visible: !_vm.isStepOne
    },
    attrs: {
      "id": "ra-modal-step2"
    }
  }, [_c('div', {
    staticClass: "close ra-modal-close",
    on: {
      "click": _vm.closeModal
    }
  }, [_c('i', {
    staticClass: "fa far fa-times"
  })]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://www.wwf.org.au/images/UserUploadedImages/389/WWF_Logo_CMYK-01.svg",
      "alt": "WWF Logo"
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n      Your registration for "), _c('span', {
    attrs: {
      "id": "aa-modal-email2"
    }
  }, [_vm._v(_vm._s(_vm.email))]), _vm._v(" is\n      confirmed.\n    ")]), _vm._v(" "), _c('button', {
    attrs: {
      "id": "ra-modal-back",
      "type": "button"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("\n      Back to WWF\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n      Confirm your registration for "), _c('br'), _c('span', {
    attrs: {
      "id": "ra-modal-email1"
    }
  })])
}]}

/***/ }),
/* 673 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.content) ? _c('div', {
    staticClass: "dynamic-content",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 674 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-item-container search-item-web"
  }, [_c('div', {
    staticClass: "search-item-header"
  }, [_c('div', {
    staticClass: "search-item-title"
  }, [_c('h4', [_c('a', {
    attrs: {
      "href": _vm.item.liveUrl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.item.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "search-item-link"
  }, [_c('a', {
    attrs: {
      "href": _vm.item.liveUrl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.item.displayUrl))])]), _vm._v(" "), _c('div', {
    staticClass: "search-item-header-date"
  }, [_vm._v("\n      " + _vm._s(_vm.item.date) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "search-item-content"
  }, [(_vm.item.metaData && _vm.item.metaData.image) ? _c('img', {
    attrs: {
      "src": _vm.item.metaData.image,
      "alt": 'Thumbnail for ' + _vm.item.title
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "search-item-date"
  }, [_vm._v(_vm._s(_vm.item.date) + " ")]), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.item.summary)
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 675 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "payment"
  }, [_c('div', {
    staticClass: "summary"
  }, [_c('div', {
    staticClass: "product-selection"
  }, [_c('span', [_vm._v("$" + _vm._s(_vm.donation.amount))]), _vm._v(" /\n      "), _c('span', [_vm._v(_vm._s(_vm.getFrequency(_vm.donation.type)))])]), _vm._v(" "), _vm._m(0, false, false)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h2', [_vm._v("Enter Payment Details")]), _vm._v(" "), _c(_vm.paymentform, {
    ref: "checkout",
    tag: "component",
    on: {
      "success": _vm.processSuccess,
      "retry": _vm.retryPayment
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "secure"
  }, [_c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/secure-icon.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v("Secure")]), _vm._v(" "), _c('p', [_vm._v("payment")])])])
}]}

/***/ }),
/* 676 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "payment"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.failedPayment),
      expression: "!failedPayment"
    }]
  }, [_c('div', {
    staticClass: "wwf-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cardHolderName),
      expression: "cardHolderName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        ccPaymentCardHolderValidation: true
      }),
      expression: "{ required: true, ccPaymentCardHolderValidation: true }"
    }],
    ref: "cardHolderName",
    class: {
      error:
        _vm.errors.has('cardHolderName') ||
        _vm.errors.has('ccPaymentCardHolderValidation'),
        empty: !_vm.cardHolderName,
    },
    attrs: {
      "id": "cardHolderName",
      "name": "cardHolderName",
      "aria-label": "Card holder name",
      "type": "text",
      "autocomplete": "cc-name",
      "data-vv-validate-on": "change"
    },
    domProps: {
      "value": (_vm.cardHolderName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cardHolderName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Card holder name")]), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(
    _vm.errors.firstByRule(
      'cardHolderName',
      'ccPaymentCardHolderValidation'
    )
  ) ? _c('p', [_vm._v("\n          " + _vm._s(_vm.errors.first("cardHolderName")) + "\n        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "wwf-field"
  }, [_c('div', {
    staticClass: "input",
    class: {
      error: _vm.cardNumberError,
        empty: _vm.isCardNumberEmpty,
        focus: _vm.isCardNumberFocused,
    },
    attrs: {
      "id": "card-number"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Card Number")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "wwf-field"
  }, [_c('div', {
    staticClass: "input",
    class: {
      error: _vm.cardExpiryError,
        empty: _vm.isExpiryEmpty,
        focus: _vm.isExpiryFocused,
    },
    attrs: {
      "id": "card-expiry"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "title"
    }
  }, [_vm._v("MM / YY")])]), _vm._v(" "), _c('div', {
    staticClass: "wwf-field"
  }, [_c('div', {
    staticClass: "input",
    class: {
      error: _vm.cardCVVError,
        empty: _vm.isCVVEmpty,
        focus: _vm.isCVVFocused,
    },
    attrs: {
      "id": "card-cvv"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "title"
    }
  }, [_vm._v("CVV / CVC")])])])]), _vm._v(" "), (_vm.hasErrors) ? _c('div', {
    staticClass: "errors"
  }, [_c('label', {
    attrs: {
      "for": "card-number",
      "id": "card-number-error"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.cardNumberError) + "\n    ")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "card-cvv",
      "id": "card-cvv-error"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.cardCVVError) + "\n    ")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "card-expiry",
      "id": "card-expiry-error"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.cardExpiryError) + "\n    ")]), _vm._v(" "), (_vm.errors.has('cardHolderName')) ? _c('label', {
    attrs: {
      "for": "cardHolderName",
      "id": "cardHolderName-error"
    }
  }, [_vm._v("\n      Card holder name incorrect\n    ")]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.serverError))])]) : _vm._e(), _vm._v(" "), (!_vm.failedPayment) ? _c('div', {
    staticClass: "form-buttons"
  }, [_c('button', {
    staticClass: "pay-now",
    class: {
      disabled: !_vm.canSubmit
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.canSubmit,
      "href": "#form-top",
      "id": "pay-button"
    },
    on: {
      "click": _vm.pay
    }
  }, [(!_vm.isLoading) ? _c('span', [_vm._v(_vm._s(_vm.submitButtonMessage))]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('span', [_c('i', {
    staticClass: "far fa-spinner-third fa-spin"
  })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.failedPayment) ? _c('div', {
    staticClass: "form-buttons"
  }, [_c('button', {
    staticClass: "pay-now",
    class: {
      disabled: _vm.isLoading
    },
    attrs: {
      "type": "button",
      "href": "#form-top",
      "id": "retry-button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.retry
    }
  }, [(!_vm.isLoading) ? _c('span', [_vm._v("Retry")]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('span', [_c('i', {
    staticClass: "far fa-spinner-third fa-spin"
  })]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 677 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showStepper) ? _c('div', {
    staticClass: "stepper-container"
  }, [_c('div', {
    staticClass: "step",
    class: {
      selected: _vm.currentStep >= 0
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDonation),
      expression: "isDonation"
    }],
    staticClass: "step",
    class: {
      selected: _vm.currentStep >= 1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "step",
    class: {
      selected: _vm.currentStep >= 2
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.currentStep === 0) ? _c('LeafReliefDetails', {
    attrs: {
      "petitionSelector": _vm.petitionSelector,
      "donationSelector": _vm.donationSelector,
      "programName": _vm.programName,
      "datalayerName": _vm.datalayerName,
      "duplicateEmailMessage": _vm.duplicateEmailMessage,
      "sendToIve": _vm.sendToIve,
      "iveSupplier": _vm.iveSupplier,
      "iveSource": _vm.iveSource
    },
    on: {
      "next": function($event) {
        _vm.next(0)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentStep === 1) ? _c('Payment', {
    attrs: {
      "datalayerName": _vm.datalayerName
    },
    on: {
      "next": function($event) {
        _vm.next(1)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('ThankYou', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 2),
      expression: "currentStep === 2"
    }],
    attrs: {
      "thankYouText": _vm.thankYouText,
      "getSocialText": _vm.getSocialText
    },
    on: {
      "next": function($event) {
        _vm.next(2)
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 678 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (
    _vm.donation.formWizardCurrentStep === 0 && _vm.products && _vm.products.length > 0
  ) ? _c('div', {
    staticClass: "product-selector"
  }, _vm._l((_vm.products), function(p) {
    return _c('div', {
      staticClass: "product",
      class: {
        isActive: _vm.product && p.id == _vm.product.id
      },
      on: {
        "click": function($event) {
          _vm.select(p)
        }
      }
    }, [_vm._v("\n    " + _vm._s(_vm.getProductTypeMapping(p.producttype)) + "\n  ")])
  })) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 679 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "payment-apis"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.failedPayment),
      expression: "!failedPayment"
    }],
    staticClass: "form-group field",
    class: _vm.acctitle ? 'has-content' : ''
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.acctitle),
      expression: "acctitle"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        regex: /^[a-zA-Z ]+$/
      }),
      expression: "{required: true, regex: /^[a-zA-Z ]+$/}"
    }],
    staticClass: "form-control input-lg acctitle",
    class: {
      'border-red': _vm.errors.has('direct-debit-holder-name')
    },
    attrs: {
      "name": "direct-debit-holder-name",
      "type": "text",
      "id": "direct-debit-holder-name",
      "title": "Required",
      "placeholder": "Bank Account Holder Name",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.acctitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.acctitle = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "direct-debit-holder-name"
    }
  }, [_vm._v("Bank Account Holder Name " + _vm._s(_vm.errors.first('direct-debit-holder-name') ? (_vm.acctitle && _vm.acctitle.length > 0 ? 'invalid' : 'required') : ''))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.failedPayment),
      expression: "!failedPayment"
    }],
    staticClass: "form-group field",
    class: _vm.accrouting ? 'has-content' : ''
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accrouting),
      expression: "accrouting"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        regex: /^[0-9]{3}(-?)[0-9]{3}\b$/
      }),
      expression: "{required: true, regex: /^[0-9]{3}(-?)[0-9]{3}\\b$/}"
    }],
    staticClass: "form-control input-lg accrouting",
    class: {
      'border-red': _vm.errors.has('direct-debit-BSB')
    },
    attrs: {
      "name": "direct-debit-BSB",
      "id": "direct-debit-bsb",
      "title": "Required",
      "type": "text",
      "placeholder": "Bank Account BSB"
    },
    domProps: {
      "value": (_vm.accrouting)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.accrouting = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "direct-debit-BSB"
    }
  }, [_vm._v("Bank Account BSB " + _vm._s(_vm.errors.first('direct-debit-BSB') ? (_vm.accrouting && _vm.accrouting.length > 0 ? 'invalid' : 'required') : ''))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.failedPayment),
      expression: "!failedPayment"
    }],
    staticClass: "form-group field",
    class: _vm.accno ? 'has-content' : ''
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accno),
      expression: "accno"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        regex: /^[0-9]{6,10}$/
      }),
      expression: "{required: true, regex: /^[0-9]{6,10}$/}"
    }],
    staticClass: "form-control input-lg accno",
    class: {
      'border-red': _vm.errors.has('direct-debit-account-number')
    },
    attrs: {
      "name": "direct-debit-account-number",
      "id": "direct-debit-account-number",
      "title": "Required",
      "type": "text",
      "placeholder": "Bank Account Number"
    },
    domProps: {
      "value": (_vm.accno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.accno = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "direct-debit-account-number"
    }
  }, [_vm._v("Bank Account Number " + _vm._s(_vm.errors.first('direct-debit-account-number') ? (_vm.accno && _vm.accno.length > 0 ? 'invalid' : 'required') : ''))])]), _vm._v(" "), (_vm.serverError) ? _c('div', {
    staticClass: "errors"
  }, [_c('label', [_vm._v(_vm._s(_vm.serverError))])]) : _vm._e(), _vm._v(" "), (!_vm.failedPayment) ? _c('div', {
    staticClass: "form-buttons"
  }, [_c('button', {
    staticClass: "pay-now",
    class: {
      'disabled': !_vm.enablePayButton()
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.enablePayButton(),
      "href": "#form-top",
      "data-animation-duration": "300",
      "data-animation-easing": "swing",
      "id": "pay-button",
      "data-smooth-scroll": "",
      "data-threshold": "75"
    },
    on: {
      "click": _vm.Pay
    }
  }, [_vm._v("Pay Now")])]) : _vm._e(), _vm._v(" "), (_vm.failedPayment) ? _c('div', {
    staticClass: "form-buttons"
  }, [_c('button', {
    staticClass: "pay-now",
    attrs: {
      "type": "button",
      "href": "#form-top",
      "data-animation-duration": "300",
      "data-animation-easing": "swing",
      "id": "retry-button",
      "data-smooth-scroll": "",
      "data-threshold": "75"
    },
    on: {
      "click": _vm.retry
    }
  }, [_vm._v("Retry")])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 680 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "file-input-container"
  }, [_c('div', {
    staticClass: "file-input-wrapper"
  }, [_c('div', {
    staticClass: "input-label"
  }, [_vm._v("Choose your file:")]), _vm._v(" "), _c('input', {
    ref: "videoInput",
    attrs: {
      "type": "file",
      "name": "videoInput",
      "id": "videoInput",
      "size": _vm.maxSize,
      "accept": _vm.extensions.join(',')
    },
    on: {
      "change": function($event) {
        _vm.filesChange($event.target.files)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "file-label",
    attrs: {
      "for": "logoInput"
    }
  }, [(_vm.isClean) ? _c('span', [_c('i', {
    staticClass: "fas fa-file"
  }), _vm._v(" Choose a file... (Max\n          " + _vm._s(_vm.maxFileSize) + "Mb)\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.isClean) ? _c('span', [_vm._v(_vm._s(_vm.fileName) + " selected... ")]) : _vm._e(), _vm._v(" "), (_vm.hasError) ? _c('span', {
    staticClass: "alert-box"
  }, [_vm._v("\n          " + _vm._s(_vm.error) + "\n        ")]) : _vm._e()])]), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "preview-container"
  }, [_c('div', {
    staticClass: "vid-delete",
    attrs: {
      "title": "Delete video"
    }
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clearVideo
    }
  }, [_c('i', {
    staticClass: "fas fa-times fw"
  })])]), _vm._v(" "), (!_vm.isImage) ? _c('video', {
    key: _vm.fileKey,
    attrs: {
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.source,
      "type": _vm.sourceType,
      "id": "videoPreview"
    }
  }), _vm._v("\n        Your browser does not support HTML5 video.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.isImage) ? _c('img', {
    staticClass: "preview-image",
    attrs: {
      "src": _vm.source
    }
  }) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.isSuccessful) ? _c('div', {
    staticClass: "success-message"
  }, [_c('p', [_vm._v("Thanks for submitting your creation to defend the Unburnt Six.")]), _vm._v(" "), _c('p', [_vm._v("Take the next step in helping us to Regenerate Australia by signing up to plant a native tree.")]), _vm._v(" "), _c('a', {
    staticClass: "success-link",
    attrs: {
      "href": "https://www.wwf.org.au/what-we-do/regenerate-australia/regenerate-australia-hub"
    }
  }, [_vm._v("Plant a tree")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "submit-container"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isClean || _vm.hasError || _vm.isUploading
    },
    on: {
      "click": _vm.uploadVideo
    }
  }, [(!_vm.isUploading) ? _c('span', [_vm._v("Submit")]) : _vm._e(), _vm._v(" "), (_vm.isUploading) ? _c('span', [_c('i', {
    staticClass: "fas fa-spinner fa-spin"
  })]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 681 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.items && _vm.items.length > 0) ? _c('div', {
    staticClass: "search-qls"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "search-ql-container"
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      staticClass: "search-ql"
    }, [_c('a', {
      attrs: {
        "href": item.link
      }
    }, [_vm._v(_vm._s(item.label))])])
  }))]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-ql-header"
  }, [_c('h3', [_vm._v("Quick Links")])])
}]}

/***/ }),
/* 682 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lr-intent-popup"
  }, [_c('div', {
    staticClass: "popup-container"
  }, [_c('div', {
    staticClass: "intent-close"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "data-close": ""
    },
    on: {
      "click": _vm.decline
    }
  }, [_c('i', {
    staticClass: "fal fa-times"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "popup-image",
    style: ('background-image: url(' + _vm.backgroundImage + ')')
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-message"
  }, [_c('h2', [_vm._v("Please don't go yet!")]), _vm._v(" "), _c('p', [_vm._v("Just your signature will help save my home.")]), _vm._v(" "), _c('button', {
    staticClass: "action-btn",
    attrs: {
      "type": "button",
      "data-close": ""
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("Ok let's do this!")]), _vm._v(" "), _c('button', {
    staticClass: "decline-btn",
    attrs: {
      "type": "button",
      "data-close": ""
    },
    on: {
      "click": _vm.decline
    }
  }, [_vm._v("Sorry I can't help")])])])])
},staticRenderFns: []}

/***/ }),
/* 683 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "ra-section newsletter dark"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "subject"
  }, [_vm._v("Get updates")]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        email: true,
        newsletterCheckEmail: true,
      }),
      expression: "{\n              required: true,\n              email: true,\n              newsletterCheckEmail: true,\n            }"
    }],
    class: {
      error: _vm.errors.has('email')
    },
    attrs: {
      "id": "ra-email",
      "type": "email",
      "placeholder": "Your email address",
      "name": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.has('email')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first("email")))]) : _vm._e()]), _vm._v(" "), _c('button', {
    attrs: {
      "id": "ra-newsletter-button",
      "type": "button"
    },
    on: {
      "click": _vm.emailSubmit
    }
  }, [(!_vm.isLoading) ? _c('span', [_vm._v("Subscribe")]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('span', [_c('i', {
    staticClass: "far fa-spinner-third fa-spin"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n          Subscribe to the WWF newsletter and stay up-to-date with the latest\n          news on WWF’s work.\n        ")])])])]), _vm._v(" "), (_vm.showModal) ? _c('NewsletterDetails', {
    attrs: {
      "email": _vm.email,
      "showModal": _vm.showModal
    },
    on: {
      "closeModal": _vm.closeModal
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 684 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "ecommerce-filter"
    }
  }, [_c('EcommerceFilterHeader', {
    attrs: {
      "checkboxesPosition": _vm.checkboxesPosition,
      "categorySelection": _vm.categorySelection,
      "productType": _vm.productType,
      "preSelectedCategories": _vm.preSelectedCategories
    }
  }), _vm._v(" "), _c('EcommerceFilterResultList', {
    attrs: {
      "numberOfRows": Number(_vm.numberOfRows),
      "numberOfColumns": Number(_vm.numberOfColumns)
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 685 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wwf-petition-progress-container"
  }, [_c('div', {
    attrs: {
      "id": "wwf-petition-bar"
    }
  }, [_c('div', {
    attrs: {
      "id": "wwf-petition-progress"
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 600 160"
    }
  }, [_c('clipPath', {
    attrs: {
      "id": "myClip"
    }
  }, [_c('rect', {
    attrs: {
      "x": "0",
      "y": "0",
      "width": (_vm.revdirection) ? '100%' : '0%',
      "height": "100%"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "width",
      "from": (_vm.revdirection) ? '100%' : '0%',
      "to": (_vm.revdirection) ? (100 - _vm.percentage) + '%' : _vm.percentage + '%',
      "dur": "3.5s",
      "fill": "freeze"
    }
  })])]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "straw",
      "d": "M2,125.9h433.1v31.2H2V125.9z M490.4,136.5l107-111.3l-21.3-22L468.4,114.5L490.4,136.5z M460.6,121.6\n        l17.7,26.2l5-3.5l-18.4-26.2L460.6,121.6z M451.4,125.9l10.6,29.8l5-2.1l-10.6-29.8L451.4,125.9z M441.5,125.9h5.7v31.9h-5.7V125.9z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "strawColoured",
      "d": "M2,125.9h433.1v31.2H2V125.9z M490.4,136.5l107-111.3l-21.3-22L468.4,114.5L490.4,136.5z M460.6,121.6\n        l17.7,26.2l5-3.5l-18.4-26.2L460.6,121.6z M451.4,125.9l10.6,29.8l5-2.1l-10.6-29.8L451.4,125.9z M441.5,125.9h5.7v31.9h-5.7V125.9z",
      "fill": "#00728f"
    }
  }), _vm._v(" "), _c('use', {
    attrs: {
      "clip-path": "url(#myClip)",
      "xlink:href": "#straw",
      "fill": "#00ACCD"
    }
  })])]), _vm._v(" "), _c('div')])])
},staticRenderFns: []}

/***/ }),
/* 686 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.colorThemes
  }, [(_vm.showCounter) ? _c('div', {
    staticClass: "petition-counter"
  }, [_c('h2', [_c('count-to', {
    ref: "counter",
    attrs: {
      "startVal": _vm.startcounter,
      "end-val": _vm.endcounter,
      "autoplay": false,
      "duration": 7000
    }
  })], 1), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.counterTitle))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "form-intro"
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "petition-form wwf-form light"
  }, [_c('div', {
    staticClass: "flip-wrapper",
    class: {
      'formValidation-shake': _vm.isShake
    }
  }, [_c('p', {
    staticClass: "form-intro"
  }, [_vm._v(_vm._s(_vm.intro))]), _vm._v(" "), (_vm.viewMessagePosition === 'top') ? _c('input', {
    staticClass: "read-letter",
    attrs: {
      "type": "button",
      "value": _vm.viewMessageButtonValue
    },
    on: {
      "click": _vm.openReadLetterPage
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true }"
    }],
    class: {
      'border-red': _vm.errors.has('firstName')
    },
    attrs: {
      "name": "firstName",
      "type": "text",
      "placeholder": "First name",
      "autocomplete": "given-name"
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('first name')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true }"
    }],
    class: {
      'border-red': _vm.errors.has('lastName')
    },
    attrs: {
      "name": "lastName",
      "type": "text",
      "placeholder": "Last name",
      "autocomplete": "family-name"
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('last name')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "with-input-loading"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        petitionEmailIsValid: true,
        email: true,
      }),
      expression: "{\n              required: true,\n              petitionEmailIsValid: true,\n              email: true,\n            }"
    }],
    class: {
      'border-red': _vm.errors.has('email')
    },
    attrs: {
      "name": "email",
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }, function($event) {
        _vm.onEmailInput()
      }],
      "focus": function($event) {
        _vm.logFirstTouch('email')
      }
    }
  }), _vm._v(" "), (_vm.emailCheckSensis.checkEmailLoading) ? _c('div', {
    staticClass: "input-loading"
  }, [_c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/loading-tail-spin.svg"
    }
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.has('email')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first("email")))]) : _vm._e()])]), _vm._v(" "), ((_vm.country == 'Australia' ? 'number' : 'text') === 'checkbox' && (_vm.showPostcode)) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postcode),
      expression: "postcode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        alpha_num: true
      }),
      expression: "{ required: true, alpha_num: true }"
    }],
    class: {
      'border-red': _vm.errors.has('postcode')
    },
    attrs: {
      "name": "postcode",
      "placeholder": "Postcode",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.postcode) ? _vm._i(_vm.postcode, null) > -1 : (_vm.postcode)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('postcode')
      },
      "change": function($event) {
        var $$a = _vm.postcode,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.postcode = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.postcode = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.postcode = $$c
        }
      }
    }
  }) : ((_vm.country == 'Australia' ? 'number' : 'text') === 'radio' && (_vm.showPostcode)) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postcode),
      expression: "postcode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        alpha_num: true
      }),
      expression: "{ required: true, alpha_num: true }"
    }],
    class: {
      'border-red': _vm.errors.has('postcode')
    },
    attrs: {
      "name": "postcode",
      "placeholder": "Postcode",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.postcode, null)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('postcode')
      },
      "change": function($event) {
        _vm.postcode = null
      }
    }
  }) : (_vm.showPostcode) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postcode),
      expression: "postcode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        alpha_num: true
      }),
      expression: "{ required: true, alpha_num: true }"
    }],
    class: {
      'border-red': _vm.errors.has('postcode')
    },
    attrs: {
      "name": "postcode",
      "placeholder": "Postcode",
      "type": _vm.country == 'Australia' ? 'number' : 'text'
    },
    domProps: {
      "value": (_vm.postcode)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('postcode')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.postcode = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.firstByRule('postcode')) ? _c('p', [_vm._v("\n            " + _vm._s(_vm.errors.first("postcode")) + "\n          ")]) : _vm._e()]), _vm._v(" "), (_vm.showPhoneNumber) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phoneNumber),
      expression: "phoneNumber"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.isPhoneMandatory,
        petitionPhoneNumberIsValid: true,
      }),
      expression: "{\n            required: isPhoneMandatory,\n            petitionPhoneNumberIsValid: true,\n          }"
    }],
    class: {
      'border-red': _vm.errors.has('phoneNumber')
    },
    attrs: {
      "name": "phoneNumber",
      "type": "tel",
      "placeholder": "Phone Number"
    },
    domProps: {
      "value": (_vm.phoneNumber)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('phone')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phoneNumber = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(
    _vm.errors.firstByRule('phoneNumber', 'petitionPhoneNumberIsValid')
  ) ? _c('p', [_vm._v("\n            " + _vm._s(_vm.errors.first("phoneNumber")) + "\n          ")]) : _vm._e()]), _vm._v(" "), (_vm.showState) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.state),
      expression: "state"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('state')
    },
    attrs: {
      "name": "state",
      "placeholder": "State"
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('state')
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ACT"
    }
  }, [_vm._v("ACT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NSW"
    }
  }, [_vm._v("NSW")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NT"
    }
  }, [_vm._v("NT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "QLD"
    }
  }, [_vm._v("QLD")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TAS"
    }
  }, [_vm._v("TAS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "VIC"
    }
  }, [_vm._v("VIC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SA"
    }
  }, [_vm._v("SA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "WA"
    }
  }, [_vm._v("WA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Outside Australia"
    }
  }, [_vm._v("Outside Australia")])]) : _vm._e(), _vm._v(" "), (_vm.showCountry) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.country),
      expression: "country"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('country')
    },
    attrs: {
      "name": "country",
      "autocomplete": "country",
      "placeholder": "Country"
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('country')
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.country = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.countriesList), function(countries, index) {
    return _c('option', {
      domProps: {
        "value": countries.name
      }
    }, [_vm._v("\n            " + _vm._s(countries.name) + "\n          ")])
  })) : _vm._e(), _vm._v(" "), (_vm.showMessage) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    class: {
      'border-red': _vm.errors.has('message')
    },
    attrs: {
      "name": "message",
      "placeholder": _vm.messagePlaceholder,
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('message')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showMessage) ? _c('p', {
    staticClass: "word-count"
  }, [_vm._v("\n          " + _vm._s(255 - (_vm.message ? _vm.message.length : 0) + " Char") + "\n        ")]) : _vm._e(), _vm._v(" "), _c('input', {
    staticClass: "btn-submit",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving,
      "value": _vm.isSaving ? 'Loading...' : _vm.signButtonValue
    },
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }), _vm._v(" "), (_vm.viewMessagePosition === 'bottom') ? _c('input', {
    staticClass: "read-letter",
    attrs: {
      "type": "button",
      "value": _vm.viewMessageButtonValue
    },
    on: {
      "click": _vm.openReadLetterPage
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isPure),
      expression: "!isPure"
    }],
    staticClass: "alert-box"
  }, [_vm._v("\n          No bad words! Please change your message.\n        ")]), _vm._v(" "), _vm._m(0, false, false)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "privacy-statement"
  }, [_c('p', [_vm._v("\n            By signing you accept\n            "), _c('a', {
    attrs: {
      "href": "/privacy-policy/privacy-policy",
      "target": "_blank"
    }
  }, [_vm._v("\n              WWF-Australia’s Privacy Policy.\n            ")])])])
}]}

/***/ }),
/* 687 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.productIds.length >= 1) ? _c('div', {
    staticClass: "donate-pre-form wwf-form row small-collapse medium-uncollapse",
    class: {
      'dark': _vm.isDark, 'light': !_vm.isDark
    }
  }, [_c('div', [(this.productIds.length > 1) ? _c('div', {
    staticClass: "small-12 columns first-column"
  }, [_c('div', {
    staticClass: "row small-collapse"
  }, [_c('ul', {
    staticClass: "type-tab wwf-radio-bttns"
  }, _vm._l((_vm.productidsdetail), function(productdetail) {
    return _c('li', [_c('label', {
      staticClass: "wwf-controls radio",
      attrs: {
        "for": 'product-' + productdetail.productname
      }
    }, [_vm._v(_vm._s(productdetail.productname) + "\n              "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product),
        expression: "product"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      attrs: {
        "type": "radio",
        "name": "product",
        "id": 'product-' + productdetail.productname
      },
      domProps: {
        "value": productdetail,
        "checked": _vm._q(_vm.product, productdetail)
      },
      on: {
        "change": function($event) {
          _vm.product = productdetail
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "control__indicator"
    })])])
  })), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('product')),
      expression: "errors.has('product')"
    }],
    staticClass: "alert-box"
  }, [_vm._v(_vm._s(_vm.errors.first('product')))])])]) : _vm._e(), _vm._v(" "), (!_vm.emailprefill) ? _c('div', {
    staticClass: "small-12 medium-8 medium-centered columns"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "name": "email",
      "type": "text",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "small-12 columns dollar-handles"
  }, [(_vm.product) ? _c('div', [_vm._l((_vm.product.dollarhandles[_vm.product.donationtypes[0]]), function(dollarhandle, index) {
    return _c('label', {
      staticClass: "wwf-controls radio",
      attrs: {
        "for": "handle0"
      }
    }, [_c('span', {
      class: {
        selected: dollarhandle.amount === _vm.handle
      }
    }, [_vm._v("$" + _vm._s((dollarhandle.amount.indexOf('.00') >= 0) ? dollarhandle.amount.slice(0, -3) : dollarhandle.amount))]), _vm._v(" "), (!_vm.dollarhandleclick) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.handle),
        expression: "handle"
      }],
      attrs: {
        "type": "radio",
        "name": 'handle' + index,
        "id": 'handle' + index
      },
      domProps: {
        "value": dollarhandle.amount,
        "checked": _vm._q(_vm.handle, dollarhandle.amount)
      },
      on: {
        "change": function($event) {
          _vm.handle = dollarhandle.amount
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.dollarhandleclick) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.handle),
        expression: "handle"
      }],
      attrs: {
        "type": "radio",
        "name": 'handle' + index,
        "id": 'handle' + index
      },
      domProps: {
        "value": dollarhandle.amount,
        "checked": _vm._q(_vm.handle, dollarhandle.amount)
      },
      on: {
        "click": function($event) {
          _vm.donateclick(dollarhandle.amount)
        },
        "change": function($event) {
          _vm.handle = dollarhandle.amount
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "control__indicator"
    })])
  }), _vm._v(" "), _c('label', {
    staticClass: "wwf-controls radio",
    attrs: {
      "for": "handle4"
    }
  }, [_c('i', {
    staticClass: "fas fa-pencil-alt",
    class: {
      selected: _vm.handle === 'custom'
    }
  }), _vm._v(" "), (!_vm.dollarhandleclick) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.handle),
      expression: "handle"
    }],
    attrs: {
      "type": "radio",
      "name": "handle",
      "value": "custom",
      "id": "handle4"
    },
    domProps: {
      "checked": _vm._q(_vm.handle, "custom")
    },
    on: {
      "change": function($event) {
        _vm.handle = "custom"
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dollarhandleclick) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.handle),
      expression: "handle"
    }],
    attrs: {
      "type": "radio",
      "name": "handle",
      "value": "custom",
      "id": "handle4"
    },
    domProps: {
      "checked": _vm._q(_vm.handle, "custom")
    },
    on: {
      "click": function($event) {
        _vm.donateclick('custom')
      },
      "change": function($event) {
        _vm.handle = "custom"
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "control__indicator"
  })])], 2) : _vm._e()]), _vm._v(" "), (!this.dollarhandleclick) ? _c('div', {
    staticClass: "small-12 columns"
  }, [_c('a', {
    staticClass: "bttn-lrg-arrw",
    attrs: {
      "href": "#/"
    },
    on: {
      "click": _vm.donate
    }
  }, [_vm._v("Donate")])]) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 688 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-results"
  }, [_c('div', {
    staticClass: "search-input"
  }, [_c('search-autocomplete', {
    attrs: {
      "displayIcon": true,
      "displaySearchButton": true,
      "redirectOnSearch": false
    },
    on: {
      "search": _vm.search
    }
  })], 1), _vm._v(" "), (_vm.results && _vm.results.length > 0) ? _c('div', {
    staticClass: "search-result-tabs"
  }, [_c('search-tabs')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "search-result-row"
  }, [_c('div', {
    staticClass: "search-result-col-left"
  }, [(_vm.results && _vm.results.length > 0) ? _c('div', {
    staticClass: "search-quick-link"
  }, [_c('search-quick-link')], 1) : _vm._e(), _vm._v(" "), (_vm.results && _vm.results.length > 0) ? _c('search-filter') : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "search-result-col-middle"
  }, [(_vm.results && _vm.results.length > 0) ? _c('div', {
    staticClass: "search-result-options"
  }, [_c('search-option')], 1) : _vm._e(), _vm._v(" "), (_vm.results && _vm.results.length > 0) ? _c('div', {
    staticClass: "search-result-list"
  }, _vm._l((_vm.results), function(r) {
    return _c('search-item', {
      key: r.rank,
      attrs: {
        "item": r
      }
    })
  })) : _vm._e(), _vm._v(" "), (_vm.results && _vm.results.length > 0) ? _c('div', {
    staticClass: "search-result-pagination"
  }, [_c('search-paginator')], 1) : _vm._e()])]), _vm._v(" "), (_vm.results && _vm.results.length === 0) ? _c('div', {
    staticClass: "search-result-empty"
  }, [_c('p', [_vm._v("No results... Please try another search.")])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 689 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "link-wrapper",
    attrs: {
      "href": _vm.product.productUrl
    }
  }, [_c('div', {
    staticClass: "campaign-card",
    class: {
      wide: _vm.wide
    }
  }, [_c('div', {
    staticClass: "image",
    style: ('background-image: url(' + _vm.product.image + ')')
  }), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('h4', [_vm._v("\n        " + _vm._s(_vm.product.projectTitle) + "\n        "), _vm._m(0, false, false)]), _vm._v(" "), _c('p', {
    staticClass: "countdown"
  }, [_vm._v(_vm._s(_vm.daysLeft))]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_c('p', [_c('span', [_vm._v(_vm._s(_vm.product.description))])]), _vm._v(" "), _c('a', {
    staticClass: "lnk-arrw ra-cta",
    attrs: {
      "href": _vm.product.productUrl
    }
  }, [_vm._v("Learn more")])]), _vm._v(" "), _c('div', {
    staticClass: "goal-wrapper"
  }, [_c('div', {
    staticClass: "progress-bar"
  }, [_c('div', {
    staticClass: "progress-bar-wrapper"
  }, [_c('div', {
    staticClass: "progress-bar-inner",
    style: ({
      width: _vm.goalProgress + '%'
    })
  })])]), _vm._v(" "), _c('p', [_vm._v("\n          $" + _vm._s(_vm.formatCurrency(_vm.product.currentDonationAmount)) + " of $" + _vm._s(_vm.formatCurrency(_vm.product.goalAmount))), _c('span', {
    staticClass: "hide-mobile"
  }, [_vm._v(" raised")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "card-arrow"
  }, [_c('i', {
    staticClass: "fas fa-chevron-right"
  })])
}]}

/***/ }),
/* 690 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selector"
  }, [(!_vm.isBForm) ? _c('div', {
    staticClass: "tab-selector"
  }, [_c('div', {
    staticClass: "tab",
    class: {
      selected: _vm.isPetition
    },
    on: {
      "click": function($event) {
        _vm.updateSelection('petition');
        _vm.logFirstTouch()
      }
    }
  }, [_c('div', {
    staticClass: "select-img"
  }, [(_vm.isPetition) ? _c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/ra-tree-plain.svg"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isPetition) ? _c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/ra-tree-hollow.svg"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "cell"
  }, [_vm._v("\n        " + _vm._s(_vm.petitionSelector) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    class: {
      selected: !_vm.isPetition
    },
    on: {
      "click": function($event) {
        _vm.updateSelection('donation');
        _vm.logFirstTouch()
      }
    }
  }, [_c('div', {
    staticClass: "select-img"
  }, [(!_vm.isPetition) ? _c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/ra-forest-plain.svg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isPetition) ? _c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/ra-forest-hollow.svg"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "cell"
  }, [_vm._v("\n        " + _vm._s(_vm.donationSelector) + "\n      ")])])]) : _vm._e(), _vm._v(" "), (_vm.isPetition && !_vm.isBForm) ? _c('div', {
    staticClass: "petition-handle"
  }, [_vm._v(_vm._s(_vm.petitionHandle))]) : _vm._e(), _vm._v(" "), (_vm.isDonation || _vm.isBForm) ? _c('div', [_c('div', {
    staticClass: "dollar-handle-selector"
  }, [(_vm.isBForm) ? _c('label', {
    attrs: {
      "for": "handle-petition"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedDollarHandle),
      expression: "selectedDollarHandle"
    }],
    attrs: {
      "type": "radio",
      "name": "handle-petition",
      "id": "handle-petition",
      "data-vv-as": "amount"
    },
    domProps: {
      "value": _vm.bFormPetitionHandle,
      "checked": _vm._q(_vm.selectedDollarHandle, _vm.bFormPetitionHandle)
    },
    on: {
      "change": function($event) {
        _vm.selectedDollarHandle = _vm.bFormPetitionHandle
      }
    }
  }), _vm._v(" "), _vm._m(0, false, false)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.dollarHandles), function(dollarHandle) {
    return _c('label', {
      attrs: {
        "for": 'handle-' + _vm.currentDonationType + '-' + dollarHandle.amount
      }
    }, [_c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedDollarHandle),
        expression: "selectedDollarHandle"
      }],
      attrs: {
        "type": "radio",
        "name": 'handle-' + _vm.currentDonationType,
        "id": 'handle-' + _vm.currentDonationType + '-' + dollarHandle.amount,
        "data-vv-as": "amount"
      },
      domProps: {
        "value": dollarHandle,
        "checked": _vm._q(_vm.selectedDollarHandle, dollarHandle)
      },
      on: {
        "focus": function($event) {
          _vm.logFirstTouch()
        },
        "change": function($event) {
          _vm.selectedDollarHandle = dollarHandle
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "amount"
    }, [_c('span', [_vm._v(_vm._s(_vm.formatDollarHandle(dollarHandle.amount)))])])])
  }), _vm._v(" "), (_vm.proposeCustomAmount) ? _c('label', {
    attrs: {
      "for": 'handle-' + _vm.currentDonationType + '-custom'
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedDollarHandle),
      expression: "selectedDollarHandle"
    }],
    attrs: {
      "type": "radio",
      "name": 'handle-' + _vm.currentDonationType,
      "id": 'handle-' + _vm.currentDonationType + '-custom',
      "value": "custom"
    },
    domProps: {
      "checked": _vm._q(_vm.selectedDollarHandle, "custom")
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch()
      },
      "change": function($event) {
        _vm.selectedDollarHandle = "custom"
      }
    }
  }), _vm._v(" "), _vm._m(1, false, false)]) : _vm._e()], 2), _vm._v(" "), (_vm.isCustomSelected) ? _c('div', [_c('div', {
    staticClass: "wwf-field icon"
  }, [_vm._m(2, false, false), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.amount),
      expression: "donation.amount"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        leafReliefCustomAmountIsValid: true,
      }),
      expression: "{\n            required: true,\n            leafReliefCustomAmountIsValid: true,\n          }"
    }],
    ref: "customAmount",
    class: {
      'border-red': _vm.errors.has('custom-amount')
    },
    attrs: {
      "id": "custom-amount",
      "name": "custom-amount",
      "type": "number",
      "data-vv-as": "custom amount"
    },
    domProps: {
      "value": (_vm.donation.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation, "amount", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'handle-' + _vm.currentDonationType + '-custom'
    }
  }, [_vm._v("\n          Custom amount\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(
    _vm.errors.has(
      'custom-amount',
      'leafReliefCustomAmountIsValid'
    )
  ) ? _c('p', [_vm._v("\n            " + _vm._s(_vm.errors.first("custom-amount")) + "\n          ")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMaxAmountMessage),
      expression: "showMaxAmountMessage"
    }],
    staticClass: "message-max-amount"
  }, [_c('p', [_vm._v("\n        For donations above $75,000 please contact our Impact Partnerships\n        team, so we can be sure your gift benefits the area of conservation\n        you are most passionate about.\n      ")]), _vm._v(" "), _vm._m(3, false, false)]), _vm._v(" "), (_vm.isDollarHandleSelected) ? _c('div', {
    staticClass: "dollar-handle-selected"
  }, [_c('span', [_vm._v(_vm._s(_vm.selectedDollarHandle.text))])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.first('handle-' + _vm.currentDonationType)) ? _c('p', [_vm._v("\n        Please choose your donation amount\n      ")]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "amount"
  }, [_c('span', [_vm._v("Free")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "amount"
  }, [_c('span', [_vm._v("$_")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('div', [_vm._v("$_")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n        Please email\n        "), _c('a', {
    attrs: {
      "href": "mailto:partnerships@wwf.org.au",
      "target": "_blank"
    }
  }, [_vm._v("\n          partnerships@wwf.org.au\n        ")]), _vm._v("\n        . Thank you so much for your kindness!\n      ")])
}]}

/***/ }),
/* 691 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "payment-apis"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.failedPayment),
      expression: "!failedPayment"
    }]
  }, [_c('div', {
    staticClass: "form-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cardHolderName),
      expression: "cardHolderName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "cardHolderName",
    class: {
      'input-error': _vm.errors.has('cardHolderName')
    },
    attrs: {
      "id": "card-holder-name",
      "name": "card-holder-name",
      "aria-label": "Card holder name",
      "type": "text",
      "placeholder": "Card holder name"
    },
    domProps: {
      "value": (_vm.cardHolderName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cardHolderName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-field"
  }, [_c('div', {
    class: {
      'input-error': _vm.cardNumberError
    },
    attrs: {
      "id": "card-number"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cvv-form-field"
  }, [_c('div', {
    class: {
      'input-error': _vm.cardExpiryError
    },
    attrs: {
      "id": "card-expiry"
    }
  }), _vm._v(" "), _c('div', {
    class: {
      'input-error': _vm.cardCVVError
    },
    attrs: {
      "id": "card-cvv"
    }
  })])]), _vm._v(" "), (_vm.cardNumberError || _vm.cardCVVError || _vm.cardExpiryError || _vm.serverError) ? _c('div', {
    staticClass: "errors"
  }, [_c('label', {
    attrs: {
      "for": "card-number",
      "id": "card-number-error"
    }
  }, [_vm._v(_vm._s(_vm.cardNumberError))]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "card-cvv",
      "id": "card-cvv-error"
    }
  }, [_vm._v(_vm._s(_vm.cardCVVError))]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "card-expiry",
      "id": "card-expiry-error"
    }
  }, [_vm._v(_vm._s(_vm.cardExpiryError))]), _vm._v(" "), (_vm.errors.has('cardHolderName')) ? _c('label', {
    attrs: {
      "for": "card-holder-name",
      "id": "card-holder-name-error"
    }
  }, [_vm._v("Card holder name incorrect")]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.serverError))])]) : _vm._e(), _vm._v(" "), (!_vm.failedPayment) ? _c('div', {
    staticClass: "form-buttons"
  }, [_c('button', {
    staticClass: "pay-now",
    class: {
      'disabled': !_vm.activatePayButton()
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.activatePayButton(),
      "href": "#form-top",
      "data-animation-duration": "300",
      "data-animation-easing": "swing",
      "id": "pay-button",
      "data-smooth-scroll": "",
      "data-threshold": "75"
    },
    on: {
      "click": _vm.Pay
    }
  }, [_vm._v(_vm._s(_vm.submitButtonMessage))])]) : _vm._e(), _vm._v(" "), (_vm.failedPayment) ? _c('div', {
    staticClass: "form-buttons"
  }, [_c('button', {
    staticClass: "pay-now",
    attrs: {
      "type": "button",
      "href": "#form-top",
      "data-animation-duration": "300",
      "data-animation-easing": "swing",
      "id": "retry-button",
      "data-smooth-scroll": "",
      "data-threshold": "75"
    },
    on: {
      "click": _vm.retry
    }
  }, [_vm._v("Retry")])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 692 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "solution-content",
    class: {
      hidden: !_vm.isActive
    }
  }, [_c('div', {
    staticClass: "solution-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.item.image
    }
  })]), _vm._v(" "), _c('h5', {
    staticClass: "solution-heading wwf-font"
  }, [_vm._v(_vm._s(_vm.item.title))]), _vm._v(" "), _c('div', {
    staticClass: "solution-text"
  }, [_c('p', [_vm._v(_vm._s(_vm.item.text))]), _vm._v(" "), _c('div', {
    ref: "articles",
    staticClass: "solution-links"
  }, _vm._l((_vm.item.content), function(copy, i) {
    return _c('p', {
      key: 'copy' + i
    }, [_c('span', {
      staticClass: "copy-text",
      domProps: {
        "innerHTML": _vm._s(copy)
      }
    })])
  })), _vm._v(" "), _c('div', {
    staticClass: "solution-readmore"
  }, [_c('a', {
    staticClass: "wwf-font",
    on: {
      "click": _vm.handleClick
    }
  }, [_vm._v("Learn more "), _c('i', {
    staticClass: "fas fa-chevron-right"
  })])])])])
},staticRenderFns: []}

/***/ }),
/* 693 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.content) ? _c('div', {
    staticClass: "dynamic-header"
  }, [(_vm.useSlider) ? _c('BeforeAfterSlider', {
    staticClass: "header-bg",
    attrs: {
      "before": _vm.content.bgImage,
      "after": _vm.content.bgImage2
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.hasVideo && !_vm.useSlider) ? _c('div', {
    staticClass: "header-bg",
    style: ('background-image: url(' + _vm.content.bgImage + ')')
  }) : _vm._e(), _vm._v(" "), (_vm.hasVideo && !_vm.useSlider) ? _c('div', {
    staticClass: "header-bg"
  }, [_c('video', {
    attrs: {
      "autoplay": "",
      "muted": "",
      "loop": ""
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.content.bgWebm,
      "type": "video/webm"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": _vm.content.bgMp4,
      "type": "video/mp4"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": _vm.content.bgOgg,
      "type": "video/ogg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.content.bgImage
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "header-content"
  }, [_c('div', [_c('h1', [_vm._v(_vm._s(_vm.content.heading))]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v(_vm._s(_vm.content.subHeading))])])])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 694 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-item-container search-item-FAQ"
  }, [_c('div', {
    staticClass: "search-item-header"
  }, [_c('div', {
    staticClass: "search-item-title"
  }, [_c('h4', [_c('a', {
    attrs: {
      "href": _vm.item.liveUrl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.item.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "search-item-link"
  }, [_c('a', {
    attrs: {
      "href": _vm.item.liveUrl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.item.displayUrl))])]), _vm._v(" "), _c('div', {
    staticClass: "search-item-header-date"
  }, [_vm._v("\n      " + _vm._s(_vm.item.date) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "search-item-content"
  }, [(_vm.item.metaData && _vm.item.metaData.image) ? _c('img', {
    attrs: {
      "src": _vm.item.metaData.image,
      "alt": 'Thumbnail for ' + _vm.item.title
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "search-item-date"
  }, [_vm._v(_vm._s(_vm.item.date) + " ")]), _vm._v(_vm._s(_vm.item.summary) + "\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 695 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isThankYou) ? _c('div', {
    class: _vm.colorThemes
  }, [(_vm.showcounter) ? _c('div', {
    staticClass: "petition-counter"
  }, [_c('h2', [_c('count-to', {
    ref: "counter",
    attrs: {
      "startVal": _vm.startcounter,
      "end-val": _vm.endcounter,
      "autoplay": false,
      "duration": 7000
    },
    on: {
      "callbackCounter": _vm.updatePercentage
    }
  })], 1), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.countertitle))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "form-intro"
  }, [_vm._v("\n           " + _vm._s(_vm.title) + "   \n       ")])]) : _vm._e(), _vm._v(" "), (_vm.showprogressbar) ? _c('div', {
    staticClass: "petition-progressbar"
  }, [_c('progressbar', {
    attrs: {
      "percentage": _vm.percentage,
      "revdirection": _vm.revdirection
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isActive) ? _c('div', {
    staticClass: "petition-form wwf-form light"
  }, [_c('div', {
    staticClass: "flip-wrapper",
    class: {
      'formValidation-shake': _vm.isShake
    }
  }, [_c('div', {
    staticClass: "petition-form"
  }, [_c('p', {
    staticClass: "form-intro"
  }), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.intro)
    }
  }), _vm._v(" "), _c('p'), _vm._v(" "), (!_vm.seeMessageButtonBottom) ? _c('input', {
    staticClass: "read-letter",
    attrs: {
      "type": "button",
      "value": "View the petition"
    },
    on: {
      "click": _vm.openReadLetterPage
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true}"
    }],
    class: {
      'border-red': _vm.errors.has('firstName')
    },
    attrs: {
      "name": "firstName",
      "type": "text",
      "placeholder": "First name",
      "autocomplete": "given-name"
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('first name')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true}"
    }],
    class: {
      'border-red': _vm.errors.has('lastName')
    },
    attrs: {
      "name": "lastName",
      "type": "text",
      "placeholder": "Last name",
      "autocomplete": "family-name"
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('last name')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "with-input-loading"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        petitionEmailIsValid: true,
        email: true
      }),
      expression: "{ required: true, petitionEmailIsValid: true, email: true }"
    }],
    class: {
      'border-red': _vm.errors.has('email')
    },
    attrs: {
      "name": "email",
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }, function($event) {
        _vm.onEmailInput()
      }],
      "focus": function($event) {
        _vm.logFirstTouch('email')
      }
    }
  }), _vm._v(" "), (_vm.emailCheckSensis.checkEmailLoading) ? _c('div', {
    staticClass: "input-loading"
  }, [_c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/loading-tail-spin.svg"
    }
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.has('email')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first('email')))]) : _vm._e()])]), _vm._v(" "), (((_vm.country == 'Australia') ? 'number' : 'text') === 'checkbox' && (!_vm.hidepostcode && _vm.extraMandatoryFields.indexOf('postCode') == -1)) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postCode),
      expression: "postCode"
    }],
    attrs: {
      "name": "postCode",
      "placeholder": "Postcode",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.postCode) ? _vm._i(_vm.postCode, null) > -1 : (_vm.postCode)
    },
    on: {
      "input": function($event) {
        _vm.postcodeUpdated()
      },
      "focus": function($event) {
        _vm.logFirstTouch('postcode')
      },
      "change": function($event) {
        var $$a = _vm.postCode,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.postCode = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.postCode = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.postCode = $$c
        }
      }
    }
  }) : (((_vm.country == 'Australia') ? 'number' : 'text') === 'radio' && (!_vm.hidepostcode && _vm.extraMandatoryFields.indexOf('postCode') == -1)) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postCode),
      expression: "postCode"
    }],
    attrs: {
      "name": "postCode",
      "placeholder": "Postcode",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.postCode, null)
    },
    on: {
      "input": function($event) {
        _vm.postcodeUpdated()
      },
      "focus": function($event) {
        _vm.logFirstTouch('postcode')
      },
      "change": function($event) {
        _vm.postCode = null
      }
    }
  }) : (!_vm.hidepostcode && _vm.extraMandatoryFields.indexOf('postCode') == -1) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postCode),
      expression: "postCode"
    }],
    attrs: {
      "name": "postCode",
      "placeholder": "Postcode",
      "type": (_vm.country == 'Australia') ? 'number' : 'text'
    },
    domProps: {
      "value": (_vm.postCode)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.postCode = $event.target.value
      }, function($event) {
        _vm.postcodeUpdated()
      }],
      "focus": function($event) {
        _vm.logFirstTouch('postcode')
      }
    }
  }) : _vm._e(), _vm._v(" "), (((_vm.country == 'Australia') ? 'number' : 'text') === 'checkbox' && (!_vm.hidepostcode && _vm.extraMandatoryFields.indexOf('postCode') > -1)) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postCode),
      expression: "postCode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        petitionPostCodeIsValid: true
      }),
      expression: "{ required: true, petitionPostCodeIsValid: true }"
    }],
    class: {
      'border-red': _vm.errors.has('postCode')
    },
    attrs: {
      "name": "postCode",
      "placeholder": "Postcode",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.postCode) ? _vm._i(_vm.postCode, null) > -1 : (_vm.postCode)
    },
    on: {
      "input": function($event) {
        _vm.postcodeUpdated()
      },
      "focus": function($event) {
        _vm.logFirstTouch('postcode')
      },
      "change": function($event) {
        var $$a = _vm.postCode,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.postCode = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.postCode = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.postCode = $$c
        }
      }
    }
  }) : (((_vm.country == 'Australia') ? 'number' : 'text') === 'radio' && (!_vm.hidepostcode && _vm.extraMandatoryFields.indexOf('postCode') > -1)) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postCode),
      expression: "postCode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        petitionPostCodeIsValid: true
      }),
      expression: "{ required: true, petitionPostCodeIsValid: true }"
    }],
    class: {
      'border-red': _vm.errors.has('postCode')
    },
    attrs: {
      "name": "postCode",
      "placeholder": "Postcode",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.postCode, null)
    },
    on: {
      "input": function($event) {
        _vm.postcodeUpdated()
      },
      "focus": function($event) {
        _vm.logFirstTouch('postcode')
      },
      "change": function($event) {
        _vm.postCode = null
      }
    }
  }) : (!_vm.hidepostcode && _vm.extraMandatoryFields.indexOf('postCode') > -1) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postCode),
      expression: "postCode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        petitionPostCodeIsValid: true
      }),
      expression: "{ required: true, petitionPostCodeIsValid: true }"
    }],
    class: {
      'border-red': _vm.errors.has('postCode')
    },
    attrs: {
      "name": "postCode",
      "placeholder": "Postcode",
      "type": (_vm.country == 'Australia') ? 'number' : 'text'
    },
    domProps: {
      "value": (_vm.postCode)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.postCode = $event.target.value
      }, function($event) {
        _vm.postcodeUpdated()
      }],
      "focus": function($event) {
        _vm.logFirstTouch('postcode')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.firstByRule('postCode', 'petitionPostCodeIsValid') || _vm.errors.firstByRule('postCode')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first('postCode')))]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phoneNumber),
      expression: "phoneNumber"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        petitionPhoneNumberIsValid: true
      }),
      expression: "{ required: true, petitionPhoneNumberIsValid: true }"
    }],
    class: {
      'border-red': _vm.errors.has('phoneNumber')
    },
    attrs: {
      "name": "phoneNumber",
      "type": "tel",
      "placeholder": "Phone Number"
    },
    domProps: {
      "value": (_vm.phoneNumber)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('phone')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phoneNumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.firstByRule('phoneNumber', 'petitionPhoneNumberIsValid')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first('phoneNumber')))]) : _vm._e()]), _vm._v(" "), (_vm.showstate) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.state),
      expression: "state"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('state')
    },
    attrs: {
      "name": "state",
      "placeholder": "State"
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('state')
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ACT"
    }
  }, [_vm._v("ACT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NSW"
    }
  }, [_vm._v("NSW")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NT"
    }
  }, [_vm._v("NT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "QLD"
    }
  }, [_vm._v("QLD")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TAS"
    }
  }, [_vm._v("TAS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "VIC"
    }
  }, [_vm._v("VIC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SA"
    }
  }, [_vm._v("SA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "WA"
    }
  }, [_vm._v("WA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Outside Australia"
    }
  }, [_vm._v("Outside Australia")])]) : _vm._e(), _vm._v(" "), (_vm.showrecipientslist && _vm.recipients != null) ? _c('div', {
    staticClass: "recipients-list"
  }, [_c('div', {
    staticClass: "recipients-title"
  }, [_vm._v("You will be contacting")]), _vm._v(" "), (_vm.recipients.mainMP) ? _c('div', {
    staticClass: "recipient"
  }, [_vm._v("• " + _vm._s(_vm.recipients.mainMP.salutation) + " " + _vm._s(_vm.recipients.mainMP.name))]) : _vm._e(), _vm._v(" "), (_vm.recipients.senators.length > 1) ? _c('div', {
    staticClass: "senators-list"
  }, [_c('div', [_vm._v("Select your Senator")]), _vm._v(" "), _c('div', {
    staticClass: "wwf-radio-bttns senator-item"
  }, _vm._l((_vm.recipients.senators), function(senator) {
    return _c('label', {
      attrs: {
        "for": 'senator-' + senator.email
      }
    }, [_c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedSenator),
        expression: "selectedSenator"
      }],
      attrs: {
        "type": "radio",
        "name": "selectedSenator",
        "id": 'senator-' + senator.email
      },
      domProps: {
        "value": senator,
        "checked": _vm._q(_vm.selectedSenator, senator)
      },
      on: {
        "change": function($event) {
          _vm.selectedSenator = senator
        }
      }
    }), _vm._v("\n                     " + _vm._s(senator.salutation) + " " + _vm._s(senator.name) + "\n                     "), _c('span', {
      staticClass: "wwf-radio"
    })])
  }))]) : _vm._e(), _vm._v(" "), (_vm.recipients.senators.length === 1 && _vm.selectedSenator != null) ? _c('div', {
    staticClass: "recipient"
  }, [_vm._v("• " + _vm._s(_vm.selectedSenator.salutation) + " " + _vm._s(_vm.selectedSenator.name))]) : _vm._e(), _vm._v(" "), (_vm.recipients.mps.length > 1) ? _c('div', {
    staticClass: "mps-list"
  }, [_c('div', [_vm._v("Select your MP")]), _vm._v(" "), _c('div', {
    staticClass: "wwf-radio-bttns mp-item"
  }, _vm._l((_vm.recipients.mps), function(mp) {
    return _c('label', {
      attrs: {
        "for": 'mp-' + mp.email
      }
    }, [_c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedMP),
        expression: "selectedMP"
      }],
      attrs: {
        "type": "radio",
        "name": "selectedMP",
        "id": 'mp-' + mp.email
      },
      domProps: {
        "value": mp,
        "checked": _vm._q(_vm.selectedMP, mp)
      },
      on: {
        "change": function($event) {
          _vm.selectedMP = mp
        }
      }
    }), _vm._v("\n                     " + _vm._s(mp.salutation) + " " + _vm._s(mp.name) + ", MP\n                     "), _c('span', {
      staticClass: "wwf-radio"
    })])
  }))]) : _vm._e(), _vm._v(" "), (_vm.recipients.mps.length === 1 && _vm.selectedMP != null) ? _c('div', {
    staticClass: "recipient"
  }, [_vm._v("• " + _vm._s(_vm.selectedMP.salutation) + " " + _vm._s(_vm.selectedMP.name) + ", MP")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showmessage) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    class: {
      'border-red': _vm.errors.has('message')
    },
    attrs: {
      "name": "message",
      "placeholder": _vm.messageplaceholder,
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showmessage) ? _c('p', {
    staticClass: "word-count"
  }, [_vm._v(_vm._s(255 - (_vm.message ? _vm.message.length : 0) + ' Char'))]) : _vm._e(), _vm._v(" "), (_vm.showcountry) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.country),
      expression: "country"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('country')
    },
    attrs: {
      "name": "country",
      "autocomplete": "country",
      "placeholder": "Country"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.country = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.countriesList), function(countries, index) {
    return _c('option', {
      domProps: {
        "value": countries.name
      }
    }, [_vm._v(_vm._s(countries.name))])
  })) : _vm._e(), _vm._v(" "), (_vm.showpermission) ? _c('div', [_vm._v("\n                 Do you give permission for your submission to be published on the EPBC Act Review website?"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.permission),
      expression: "permission"
    }],
    class: {
      'border-red': _vm.errors.has('permissionyes')
    },
    attrs: {
      "type": "radio",
      "name": "permissionyes",
      "id": "permissionyes",
      "value": "Yes"
    },
    domProps: {
      "checked": _vm._q(_vm.permission, "Yes")
    },
    on: {
      "change": function($event) {
        _vm.permission = "Yes"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "permissionyes"
    }
  }, [_vm._v("Yes – with my name")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.permission),
      expression: "permission"
    }],
    class: {
      'border-red': _vm.errors.has('permissionyes')
    },
    attrs: {
      "type": "radio",
      "name": "permissionanonymous",
      "id": "permissionanonymous",
      "value": "Anonymous"
    },
    domProps: {
      "checked": _vm._q(_vm.permission, "Anonymous")
    },
    on: {
      "change": function($event) {
        _vm.permission = "Anonymous"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "permissionanonymous"
    }
  }, [_vm._v("Yes – anonymously ")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.permission),
      expression: "permission"
    }],
    class: {
      'border-red': _vm.errors.has('permissionyes')
    },
    attrs: {
      "type": "radio",
      "name": "permissionno",
      "id": "permissionno",
      "value": "No"
    },
    domProps: {
      "checked": _vm._q(_vm.permission, "No")
    },
    on: {
      "change": function($event) {
        _vm.permission = "No"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "permissionno"
    }
  }, [_vm._v("No – please keep my submission confidential")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getextracampaignsList), function(extracampaign, index) {
    return _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedCampaign),
        expression: "selectedCampaign"
      }],
      attrs: {
        "type": "checkbox",
        "name": 'extracampaign' + index,
        "id": 'extracampaign' + index
      },
      domProps: {
        "value": extracampaign,
        "checked": Array.isArray(_vm.selectedCampaign) ? _vm._i(_vm.selectedCampaign, extracampaign) > -1 : (_vm.selectedCampaign)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selectedCampaign,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = extracampaign,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedCampaign = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedCampaign = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedCampaign = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'extracampaign' + index
      }
    }, [_vm._v("Add my name to " + _vm._s(extracampaign.title) + " too!")])])
  }), _vm._v(" "), _c('input', {
    staticClass: "btn-submit",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving,
      "value": _vm.isSaving ? 'Loading...' : 'Sign the petition'
    },
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }), _vm._v(" "), (_vm.seeMessageButtonBottom) ? _c('input', {
    staticClass: "read-letter",
    attrs: {
      "type": "button",
      "value": "View the petition"
    },
    on: {
      "click": _vm.openReadLetterPage
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isProfanity),
      expression: "isProfanity"
    }],
    staticClass: "alert-box"
  }, [_vm._v("No bad words! Please change your message.")]), _vm._m(0, false, false)], 2)])])]) : _vm._e(), _vm._v(" "), (!_vm.isActive) ? _c('div', {
    staticClass: "form-closed"
  }, [_c('p', [_vm._v(_vm._s(_vm.closingmessage))])]) : _vm._e()]) : (_vm.isThankYou) ? _c('div', [_c('div', {
    staticClass: "petition-header petition-thank-you-header"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('h4', [_vm._v("Thank you for adding your voice! Make even more impact with a donation that will support:")]), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.donateNow()
      }
    }
  }, [_vm._v("Donate Now")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(3, false, false)])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "privacy-statement"
  }, [_c('p', [_vm._v("By signing you accept\n               "), _c('a', {
    attrs: {
      "href": "/privacy-policy/privacy-policy",
      "target": "_blank"
    }
  }, [_vm._v("WWF-Australia’s Privacy Policy.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "petition-header-img"
  }, [_c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/paws.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Injured Wildlife Response - recovery at scale")]), _vm._v(" "), _c('li', [_vm._v("Restoring forests and damaged wildlife habitat")]), _vm._v(" "), _c('li', [_vm._v("Future-proofing Australia - long-term security and climate preparedness for people and nature.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gs-wrapper"
  }, [_c('div', {
    staticClass: "getsocial gs-inline-group"
  })])
}]}

/***/ }),
/* 696 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row small-collapse",
    class: {
      'formValidation-shake': _vm.isShake
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.intro))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.iAmA == 'individual'),
      expression: "this.iAmA == 'individual'"
    }],
    staticClass: "read-letter",
    attrs: {
      "type": "button",
      "value": "Here's the message we're sending"
    },
    on: {
      "click": _vm.openReadLetterPage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "small-6 columns left-field"
  }, [_c('label', {
    attrs: {
      "for": "firstName"
    }
  }, [_vm._v("\n        First name\n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lead.firstName),
      expression: "lead.firstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('firstName')
    },
    attrs: {
      "type": "text",
      "name": "firstName",
      "id": "firstName",
      "data-vv-as": "first name"
    },
    domProps: {
      "value": (_vm.lead.firstName)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('first name')
      },
      "blur": function($event) {
        _vm.logProvided('Fname provided', _vm.lead.firstName)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.lead, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('firstName')) ? _c('span', {
    staticClass: "form-error-area"
  }, [_c('p', [_vm._v(_vm._s(_vm.errors.first("firstName")))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "small-6 columns right-field"
  }, [_c('label', {
    attrs: {
      "for": "lastName"
    }
  }, [_vm._v("\n        Last name\n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lead.lastName),
      expression: "lead.lastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('lastName')
    },
    attrs: {
      "type": "text",
      "name": "lastName",
      "id": "lastName",
      "data-vv-as": "last name"
    },
    domProps: {
      "value": (_vm.lead.lastName)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('last name')
      },
      "blur": function($event) {
        _vm.logProvided('Lname provided', _vm.lead.lastName)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.lead, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('lastName')) ? _c('span', {
    staticClass: "form-error-area"
  }, [_c('p', [_vm._v(_vm._s(_vm.errors.first("lastName")))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "small-6 left-field columns"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("\n        Email\n        "), _c('div', {
    staticClass: "with-input-loading"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lead.email),
      expression: "lead.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        earthhourEmailIsValid: true,
        email: true,
      }),
      expression: "{\n              required: true,\n              earthhourEmailIsValid: true,\n              email: true,\n            }"
    }],
    class: {
      'border-red': _vm.errors.has('email')
    },
    attrs: {
      "type": "email",
      "name": "email",
      "id": "email",
      "data-vv-as": "email"
    },
    domProps: {
      "value": (_vm.lead.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.lead, "email", $event.target.value)
      }, function($event) {
        _vm.onEmailInput()
      }],
      "focus": function($event) {
        _vm.logFirstTouch('email')
      },
      "blur": function($event) {
        _vm.logProvided('Email provided', _vm.lead.email)
      }
    }
  }), _vm._v(" "), (
    _vm.emailCheckSensis.checkEmailLoading ||
    _vm.emailCheckDuplicate.checkEmailLoading
  ) ? _c('div', {
    staticClass: "input-loading"
  }, [_c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/loading-tail-spin.svg"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.errors.first('email')) ? _c('span', {
    staticClass: "form-error-area"
  }, [_c('p', [_vm._v(_vm._s(_vm.errors.first("email")))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "small-6 right-field columns"
  }, [_c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("\n        Phone\n        "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        earthhourPhoneNumberIsValid: true
      }),
      expression: "{ required: true, earthhourPhoneNumberIsValid: true }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.lead.phone),
      expression: "lead.phone"
    }],
    class: {
      'border-red':
      _vm.errors.has('phone') ||
        _vm.errors.has('earthhourPhoneNumberIsValid'),
    },
    attrs: {
      "type": "tel",
      "name": "phone",
      "id": "phone",
      "data-vv-as": "phone"
    },
    domProps: {
      "value": (_vm.lead.phone)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('phone')
      },
      "blur": function($event) {
        _vm.logProvided('Phone provided', _vm.lead.phone)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.lead, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('phone')) ? _c('span', {
    staticClass: "form-error-area"
  }, [_c('p', [_vm._v(_vm._s(_vm.errors.first("phone")))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "small-6 columns left-field"
  }, [_c('label', {
    attrs: {
      "for": "postcode"
    }
  }, [_vm._v("\n        Postcode\n        "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.lead.postCode),
      expression: "lead.postCode"
    }],
    class: {
      'border-red': _vm.errors.has('postcode')
    },
    attrs: {
      "type": "tel",
      "name": "postcode",
      "id": "postcode",
      "data-vv-as": "postcode"
    },
    domProps: {
      "value": (_vm.lead.postCode)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('postcode')
      },
      "blur": function($event) {
        _vm.logFilled('Post code', _vm.lead.postCode)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.lead, "postCode", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('postcode')) ? _c('span', {
    staticClass: "form-error-area"
  }, [_c('p', [_vm._v(_vm._s(_vm.errors.first("postcode")))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "small-6 columns right-field"
  }, [_c('label', {
    attrs: {
      "for": "iAmA"
    }
  }, [_vm._v("\n        I am " + _vm._s(_vm.iAmA == "individual" || _vm.iAmA == "organisation" ? "an" : "a") + "\n        "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.iAmA),
      expression: "iAmA"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('iAmA')
    },
    attrs: {
      "name": "iAmA",
      "data-vv-as": "I am"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.iAmA = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.removeImage],
      "focus": function($event) {
        _vm.logFirstTouch('iAmA')
      },
      "blur": function($event) {
        _vm.logFilled('User category', _vm.iAmA)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("Select")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "individual"
    }
  }, [_vm._v("Individual")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "school"
    }
  }, [_vm._v("School")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "council"
    }
  }, [_vm._v("Council")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "business"
    }
  }, [_vm._v("Business")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "landmark"
    }
  }, [_vm._v("Landmark")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "organisation"
    }
  }, [_vm._v("Organisation")])]), _vm._v(" "), (_vm.errors.first('iAmA')) ? _c('span', {
    staticClass: "form-error-area"
  }, [_c('p', [_vm._v(_vm._s(_vm.errors.first("iAmA")))])]) : _vm._e()])]), _vm._v(" "), (_vm.showCompetition && _vm.iAmA && _vm.iAmA == 'individual') ? _c('div', {
    staticClass: "small-12 columns"
  }, [_c('div', {
    staticClass: "wwf-checkbox",
    attrs: {
      "checked": "checked"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isInCompetition),
      expression: "isInCompetition"
    }],
    attrs: {
      "type": "checkbox",
      "id": "in-competition",
      "name": "in-competition"
    },
    domProps: {
      "checked": Array.isArray(_vm.isInCompetition) ? _vm._i(_vm.isInCompetition, null) > -1 : (_vm.isInCompetition)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isInCompetition,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isInCompetition = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isInCompetition = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isInCompetition = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkbox"
  }), _vm._v("\n          " + _vm._s(_vm.competitionText) + "\n        ")])])]) : _vm._e(), _vm._v(" "), (_vm.showCompetition && _vm.iAmA && _vm.iAmA == 'individual') ? _c('div', {
    staticClass: "small-12 columns"
  }, [_c('div', {
    staticClass: "wwf-checkbox",
    attrs: {
      "checked": "checked"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.acceptContactFromPartner),
      expression: "acceptContactFromPartner"
    }],
    attrs: {
      "type": "checkbox",
      "id": "accept-contact-From-Partner",
      "name": "accept-contact-from-Partner"
    },
    domProps: {
      "checked": Array.isArray(_vm.acceptContactFromPartner) ? _vm._i(_vm.acceptContactFromPartner, null) > -1 : (_vm.acceptContactFromPartner)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.acceptContactFromPartner,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.acceptContactFromPartner = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.acceptContactFromPartner = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.acceptContactFromPartner = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkbox"
  }), _vm._v("\n          " + _vm._s(_vm.partnerOptinLabel) + "\n        ")])])]) : _vm._e(), _vm._v(" "), (_vm.iAmA && _vm.iAmA != 'individual') ? _c('div', {
    staticClass: "small-12 columns"
  }, [_c('label', {
    attrs: {
      "for": "othername"
    }
  }, [_vm._v("\n        Name of the " + _vm._s(_vm.iAmA) + "\n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.othername),
      expression: "othername"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('othername')
    },
    attrs: {
      "type": "text",
      "name": "othername",
      "id": "othername",
      "data-vv-as": 'name of the ' + this.iAmA
    },
    domProps: {
      "value": (_vm.othername)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('othername')
      },
      "blur": function($event) {
        _vm.logProvided('Oname provided', _vm.othername)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.othername = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.first('othername')) ? _c('span', {
    staticClass: "form-error-area"
  }, [_c('p', [_vm._v(_vm._s(_vm.errors.first("othername")))])]) : _vm._e()]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "logoInput"
    }
  }, [_vm._v("\n        Upload your logo here (Not mandatory)\n\n        "), _vm._v(" "), _c('input', {
    ref: "logoInput",
    attrs: {
      "type": "file",
      "name": "logoInput",
      "id": "logoInput",
      "size": _vm.fileUpload.maxSize,
      "accept": ".png, .jpg, .jpeg, .gif",
      "disabled": _vm.isSaving
    },
    on: {
      "change": function($event) {
        _vm.filesChange($event.target.files)
      },
      "focus": function($event) {
        _vm.logFirstTouch('logo')
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "file-label",
    attrs: {
      "for": "logoInput"
    }
  }, [(_vm.isClean) ? _c('span', [_c('i', {
    staticClass: "fas fa-file"
  }), _vm._v(" Choose a file... (Max 1Mb)\n          ")]) : _vm._e(), _vm._v(" "), (!_vm.isClean) ? _c('span', [_vm._v(_vm._s(_vm.fileUpload.fileName) + " selected... ")]) : _vm._e(), _vm._v(" "), (_vm.hasError) ? _c('span', {
    staticClass: "alert-box"
  }, [_vm._v("\n            " + _vm._s(_vm.fileUpload.error) + "\n          ")]) : _vm._e()])]), _vm._v(" "), (!_vm.isClean && _vm.fileUpload.source) ? _c('div', {
    staticClass: "preview-container"
  }, [_c('div', {
    staticClass: "img-delete"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.removeImage
    }
  }, [_c('i', {
    staticClass: "fas fa-times fw"
  })])]), _vm._v(" "), _c('img', {
    staticClass: "preview-image",
    attrs: {
      "src": _vm.fileUpload.source
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isProfanity),
      expression: "isProfanity"
    }],
    staticClass: "small-12 columns"
  }, [_c('span', {
    staticClass: "alert-box"
  }, [_vm._v(" No bad words! Please change your name. ")])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }, [_c('div', {
    staticClass: "submit-bttn bttn-lrg"
  }, [_c('input', {
    attrs: {
      "type": "button",
      "value": !_vm.isSaving ? _vm.buttontitle : 'Loading...'
    },
    on: {
      "click": _vm.save
    }
  })])]), _vm._v(" "), (_vm.showcounter) ? _c('div', {
    staticClass: "small-12 columns counter-area"
  }, [_c('h2', [_c('count-to', {
    ref: "counter",
    attrs: {
      "startVal": _vm.startcounter,
      "end-val": _vm.endcounter,
      "autoplay": false,
      "duration": 7000
    }
  })], 1), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.countertitle))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "privacy-statement"
  }, [_vm._m(0, false, false), _vm._v(" "), (_vm.showCompetition && _vm.iAmA && _vm.iAmA == 'individual') ? _c('p', [_vm._v("\n      Read the competiton\n      "), _c('a', {
    attrs: {
      "href": _vm.competitionPrivacyPolicy,
      "target": "_blank"
    }
  }, [_vm._v("\n        Terms and Conditions.\n      ")])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n      By signing you accept\n      "), _c('a', {
    attrs: {
      "href": "/privacy-policy/privacy-policy",
      "target": "_blank"
    }
  }, [_vm._v("\n        WWF-Australia’s Privacy Policy.\n      ")])])
}]}

/***/ }),
/* 697 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "donate-carousel ra-hub-carousel"
  }, [_c('VueSlickCarousel', _vm._b({
    on: {
      "afterChange": _vm.changeIndex
    }
  }, 'VueSlickCarousel', _vm.settings, false), _vm._l((_vm.slides), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "slide"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.handleClick(item.link)
        }
      }
    }, [_c('div', {
      staticClass: "slide-image",
      style: ('background-image: url(' + item.image + ')')
    })])])
  })), _vm._v(" "), _c('div', {
    staticClass: "slide-copy"
  }, [_c('h4', [_vm._v(_vm._s(_vm.slides[_vm.slideIndex].title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.slides[_vm.slideIndex].text))])])], 1)
},staticRenderFns: []}

/***/ }),
/* 698 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-item"
  }, [(_vm.collection === 'wwf-au-web') ? _c('search-item-web', {
    attrs: {
      "item": _vm.item
    }
  }) : (_vm.collection === 'wwf-au-faq') ? _c('search-item-faq', {
    attrs: {
      "item": _vm.item
    }
  }) : (_vm.collection === 'wwf-au-youtube') ? _c('search-item-youtube', {
    attrs: {
      "item": _vm.item
    }
  }) : (_vm.collection === 'wwf-au-instagram') ? _c('search-item-instagram', {
    attrs: {
      "item": _vm.item
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 699 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "donation-adoption-recipient"
  }, [_c('h2', [_vm._v("Recipient details")]), _vm._v(" "), _c('div', {
    staticClass: "wwf-field"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.gift.title),
      expression: "donation.gift.title"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      error: _vm.errors.has('title'), empty: !_vm.donation.gift.title
    },
    attrs: {
      "name": "title",
      "autocomplete": "honorific-prefix"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.donation.gift, "title", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("Select a title")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Dr"
    }
  }, [_vm._v("Dr")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Miss"
    }
  }, [_vm._v("Miss")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Mr"
    }
  }, [_vm._v("Mr")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Mrs"
    }
  }, [_vm._v("Mrs")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Ms"
    }
  }, [_vm._v("Ms")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Mx"
    }
  }, [_vm._v("Mx")])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Select a title")])]), _vm._v(" "), _c('div', {
    staticClass: "wwf-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.gift.firstname),
      expression: "donation.gift.firstname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      error: _vm.errors.has('firstName'),
        empty: !_vm.donation.gift.firstname,
    },
    attrs: {
      "name": "firstName",
      "type": "text",
      "autocomplete": "given-name"
    },
    domProps: {
      "value": (_vm.donation.gift.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation.gift, "firstname", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "firstName"
    }
  }, [_vm._v("First Name")])]), _vm._v(" "), _c('div', {
    staticClass: "wwf-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.gift.lastname),
      expression: "donation.gift.lastname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      error: _vm.errors.has('lastName'),
        empty: !_vm.donation.gift.lastname,
    },
    attrs: {
      "name": "lastName",
      "type": "text",
      "autocomplete": "family-name"
    },
    domProps: {
      "value": (_vm.donation.gift.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation.gift, "lastname", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "lastName"
    }
  }, [_vm._v("Last Name")])]), _vm._v(" "), _c('h2', [_vm._v("Recipient address")]), _vm._v(" "), (_vm.cannotDeliver) ? _c('div', {
    staticClass: "cannot-deliver"
  }, [_vm._v("\n    We're sorry, gifts and toy products can only be delivered within\n    Australia.\n  ")]) : _vm._e(), _vm._v(" "), _c('AddressInput', {
    ref: "AddressInput"
  }), _vm._v(" "), _c('button', {
    staticClass: "plain",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.next()
      }
    }
  }, [_c('span', [_vm._v("Next")]), _vm._v(" "), _vm._m(0, false, false)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fas fa-arrow-right"
  })])
}]}

/***/ }),
/* 700 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showCounter) ? _c('div', {
    staticClass: "petition-counter"
  }, [_c('div', {
    staticClass: "edo-progress-bar"
  }, [_c('div', {
    staticClass: "progress-bar-wrapper"
  }, [_c('div', {
    staticClass: "progress-bar-inner",
    style: ({
      width: 100 - _vm.progress + '%'
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "edo-tree-icon",
    style: ({
      left: 'calc(' + _vm.progress + '% - 32px)'
    })
  }, [_c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/edo-tree-icon.svg"
    }
  })])]), _vm._v(" "), (_vm.showCounter) ? _c('h2', [_c('count-to', {
    ref: "counter",
    attrs: {
      "startVal": _vm.startcounter,
      "end-val": _vm.currentCounter,
      "autoplay": false,
      "duration": 7000
    },
    on: {
      "callbackCounter": _vm.updatePercentage
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "form-scroll-to"
    }
  }, [_vm._v(_vm._s(_vm.counterTitle))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "petition-form wwf-form light"
  }, [_c('div', {
    staticClass: "flip-wrapper",
    class: {
      'formValidation-shake': _vm.isShake
    }
  }, [(_vm.intro) ? _c('p', {
    staticClass: "form-intro"
  }, [_vm._v(_vm._s(_vm.intro))]) : _vm._e(), _vm._v(" "), (_vm.viewMessagePosition === 'top') ? _c('input', {
    staticClass: "read-letter",
    attrs: {
      "type": "button",
      "value": _vm.viewMessageButtonValue
    },
    on: {
      "click": _vm.openReadLetterPage
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true }"
    }],
    class: {
      'border-red': _vm.errors.has('firstName')
    },
    attrs: {
      "name": "firstName",
      "type": "text",
      "placeholder": "First name",
      "autocomplete": "given-name"
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('first name')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.has('firstName')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first("firstName")))]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true }"
    }],
    class: {
      'border-red': _vm.errors.has('lastName')
    },
    attrs: {
      "name": "lastName",
      "type": "text",
      "placeholder": "Last name",
      "autocomplete": "family-name"
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('last name')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.has('lastName')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first("lastName")))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "with-input-loading"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        petitionEmailIsValid: true,
        email: true,
      }),
      expression: "{\n              required: true,\n              petitionEmailIsValid: true,\n              email: true,\n            }"
    }],
    class: {
      'border-red': _vm.errors.has('email')
    },
    attrs: {
      "name": "email",
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }, function($event) {
        _vm.onEmailInput()
      }],
      "focus": function($event) {
        _vm.logFirstTouch('email')
      }
    }
  }), _vm._v(" "), (_vm.emailCheckSensis.checkEmailLoading) ? _c('div', {
    staticClass: "input-loading"
  }, [_c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/loading-tail-spin.svg"
    }
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.has('email')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first("email")))]) : _vm._e()])]), _vm._v(" "), ((_vm.country == 'Australia' ? 'number' : 'text') === 'checkbox' && (_vm.showPostcode)) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postcode),
      expression: "postcode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        alpha_num: true,
        length: _vm.country == 'Australia' ? 4 : false
      }),
      expression: "{ required: true, alpha_num: true, length: country == 'Australia' ? 4 : false }"
    }],
    class: {
      'border-red': _vm.errors.has('postcode')
    },
    attrs: {
      "name": "postcode",
      "placeholder": "Postcode",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.postcode) ? _vm._i(_vm.postcode, null) > -1 : (_vm.postcode)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('postcode')
      },
      "change": function($event) {
        var $$a = _vm.postcode,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.postcode = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.postcode = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.postcode = $$c
        }
      }
    }
  }) : ((_vm.country == 'Australia' ? 'number' : 'text') === 'radio' && (_vm.showPostcode)) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postcode),
      expression: "postcode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        alpha_num: true,
        length: _vm.country == 'Australia' ? 4 : false
      }),
      expression: "{ required: true, alpha_num: true, length: country == 'Australia' ? 4 : false }"
    }],
    class: {
      'border-red': _vm.errors.has('postcode')
    },
    attrs: {
      "name": "postcode",
      "placeholder": "Postcode",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.postcode, null)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('postcode')
      },
      "change": function($event) {
        _vm.postcode = null
      }
    }
  }) : (_vm.showPostcode) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postcode),
      expression: "postcode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        alpha_num: true,
        length: _vm.country == 'Australia' ? 4 : false
      }),
      expression: "{ required: true, alpha_num: true, length: country == 'Australia' ? 4 : false }"
    }],
    class: {
      'border-red': _vm.errors.has('postcode')
    },
    attrs: {
      "name": "postcode",
      "placeholder": "Postcode",
      "type": _vm.country == 'Australia' ? 'number' : 'text'
    },
    domProps: {
      "value": (_vm.postcode)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('postcode')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.postcode = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.has('postcode')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first("postcode")))]) : _vm._e()]), _vm._v(" "), (_vm.showPhoneNumber) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phoneNumber),
      expression: "phoneNumber"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.isPhoneMandatory,
        petitionPhoneNumberIsValid: true,
      }),
      expression: "{\n            required: isPhoneMandatory,\n            petitionPhoneNumberIsValid: true,\n          }"
    }],
    class: {
      'border-red': _vm.errors.has('phoneNumber')
    },
    attrs: {
      "name": "phoneNumber",
      "type": "tel",
      "placeholder": "Phone Number"
    },
    domProps: {
      "value": (_vm.phoneNumber)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('phone')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phoneNumber = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.has('phoneNumber')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first("phoneNumber")))]) : _vm._e()]), _vm._v(" "), (_vm.showState) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.state),
      expression: "state"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('state')
    },
    attrs: {
      "name": "state",
      "placeholder": "State"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ACT"
    }
  }, [_vm._v("ACT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NSW"
    }
  }, [_vm._v("NSW")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NT"
    }
  }, [_vm._v("NT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "QLD"
    }
  }, [_vm._v("QLD")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TAS"
    }
  }, [_vm._v("TAS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "VIC"
    }
  }, [_vm._v("VIC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SA"
    }
  }, [_vm._v("SA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "WA"
    }
  }, [_vm._v("WA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Outside Australia"
    }
  }, [_vm._v("Outside Australia")])]) : _vm._e(), _vm._v(" "), (_vm.showCountry) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.country),
      expression: "country"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('country')
    },
    attrs: {
      "name": "country",
      "autocomplete": "country",
      "placeholder": "Country"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.country = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.countriesList), function(countries, index) {
    return _c('option', {
      domProps: {
        "value": countries.name
      }
    }, [_vm._v("\n            " + _vm._s(countries.name) + "\n          ")])
  })) : _vm._e(), _vm._v(" "), (_vm.showMessage) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    class: {
      'border-red': _vm.errors.has('message')
    },
    attrs: {
      "name": "message",
      "placeholder": "Your message. Writing a personalised message makes it harder for our politicians to ignore",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('message')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showMessage) ? _c('p', {
    staticClass: "word-count"
  }, [_vm._v("\n          " + _vm._s(255 - (_vm.message ? _vm.message.length : 0) + " Char") + "\n        ")]) : _vm._e(), _vm._v(" "), _c('input', {
    staticClass: "btn-submit",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving,
      "value": _vm.isSaving ? 'Loading...' : _vm.signButtonValue
    },
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }), _vm._v(" "), (_vm.viewMessagePosition === 'bottom') ? _c('input', {
    staticClass: "read-letter",
    attrs: {
      "type": "button",
      "value": _vm.viewMessageButtonValue
    },
    on: {
      "click": _vm.openReadLetterPage
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isPure),
      expression: "!isPure"
    }],
    staticClass: "alert-box"
  }, [_vm._v("\n          No bad words! Please change your message.\n        ")]), _vm._v(" "), _vm._m(0, false, false)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "privacy-statement"
  }, [_c('p', [_vm._v("\n            By signing you accept\n            "), _c('a', {
    attrs: {
      "href": "/privacy-policy/privacy-policy",
      "target": "_blank"
    }
  }, [_vm._v("\n              WWF-Australia’s Privacy Policy.\n            ")])])])
}]}

/***/ }),
/* 701 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-paginator"
  }, [_c('button', {
    staticClass: "page-button",
    attrs: {
      "type": "button",
      "disabled": _vm.currentPage === 1
    },
    on: {
      "click": function($event) {
        _vm.first()
      }
    }
  }, [_vm._m(0, false, false)]), _vm._v(" "), _c('button', {
    staticClass: "page-button",
    attrs: {
      "type": "button",
      "disabled": _vm.currentPage === 1
    },
    on: {
      "click": function($event) {
        _vm.previous()
      }
    }
  }, [_vm._m(1, false, false)]), _vm._v(" "), _vm._l((_vm.getPageArray()), function(p) {
    return _c('button', {
      staticClass: "page-button",
      class: {
        'active-page': p.isActive
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setNewPage(p.label)
        }
      }
    }, [_vm._v("\n    " + _vm._s(p.label) + "\n  ")])
  }), _vm._v(" "), _c('button', {
    staticClass: "page-button",
    attrs: {
      "type": "button",
      "disabled": _vm.currentPage === _vm.maxPage
    },
    on: {
      "click": function($event) {
        _vm.next()
      }
    }
  }, [_vm._m(2, false, false)]), _vm._v(" "), _c('button', {
    staticClass: "page-button",
    attrs: {
      "type": "button",
      "disabled": _vm.currentPage === _vm.maxPage
    },
    on: {
      "click": function($event) {
        _vm.last()
      }
    }
  }, [_vm._m(3, false, false)])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fas fa-chevron-double-left fa-fw"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fas fa-chevron-left fa-fw"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fas fa-chevron-right fa-fw"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fas fa-chevron-double-right fa-fw"
  })])
}]}

/***/ }),
/* 702 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "row expanded small-up-2 medium-up-3 large-up-4"
  }, _vm._l((_vm.countriesList), function(countries, index) {
    return _c('li', {
      staticClass: "column column-block",
      attrs: {
        "value": countries.name
      }
    }, [_c('a', {
      attrs: {
        "target": "_blank",
        "href": countries.wwfurl + '/?referer=wwfau'
      }
    }, [_vm._v("\n        " + _vm._s(countries.name) + "\n      ")])])
  }))
},staticRenderFns: []}

/***/ }),
/* 703 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.products) ? _c('div', {
    staticClass: "ecommerce-carousel donate-carousel",
    attrs: {
      "id": "ecommerce-carousel"
    }
  }, [_c('VueSlickCarousel', _vm._b({}, 'VueSlickCarousel', _vm.settings, false), _vm._l((_vm.products), function(product) {
    return _c('div', {
      key: product.id,
      staticClass: "product-slide"
    }, [_c('a', {
      attrs: {
        "href": product.url
      }
    }, [_c('div', {
      staticClass: "product-card"
    }, [_c('div', {
      staticClass: "product-image",
      style: ('background-image: url(' + product.image + ')')
    }), _vm._v(" "), _c('p', {
      staticClass: "product-label"
    }, [_vm._v(_vm._s(product.name) + " "), _c('span', {
      staticClass: "card-arrow"
    }, [_c('i', {
      staticClass: "fas fa-chevron-right"
    })])])])])])
  }))], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 704 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wwf-form donation-form",
    attrs: {
      "id": "donate-form"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.donation.isLoading),
      expression: "donation.isLoading"
    }],
    staticClass: "wwf-loading-container"
  }, [_vm._m(0, false, false)]), _vm._v(" "), _c('Stepper', {
    attrs: {
      "thankYouUrl": _vm.thankYouUrl,
      "useProductThankYouUrl": _vm.useProductThankYouUrl,
      "blacklistUrl": _vm.blacklistUrl
    },
    on: {
      "reset": _vm.reset
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wwf-loading"
  }, [_c('span')])
}]}

/***/ }),
/* 705 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-options"
  }, [_c('div', {
    staticClass: "search-options-indexes"
  }, [_c('span', [_vm._v(_vm._s(_vm.options.indexStart))]), _vm._v(" to\n    "), _c('span', [_vm._v(_vm._s(_vm.options.indexEnd))]), _vm._v(" of\n    "), _c('span', [_vm._v(_vm._s(_vm.options.totalResults))]), _vm._v(" for "), _c('span', [_vm._v(_vm._s(_vm.searchInput))])]), _vm._v(" "), _c('div', {
    staticClass: "search-options-selections"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedSort),
      expression: "selectedSort"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedSort = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.options.sorts), function(o) {
    return _c('option', {
      domProps: {
        "value": o
      }
    }, [_vm._v("\n        " + _vm._s(o.label) + "\n      ")])
  })), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedLimit),
      expression: "selectedLimit"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedLimit = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.options.limits), function(l) {
    return _c('option', {
      domProps: {
        "value": l
      }
    }, [_vm._v(_vm._s(l))])
  }))])])
},staticRenderFns: []}

/***/ }),
/* 706 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dynamic-petition"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "wwf-loading-container"
  }, [_vm._m(0, false, false)]), _vm._v(" "), _c('header', {
    staticClass: "header-container"
  }, [_c('DynamicHeader', {
    attrs: {
      "content": _vm.headerContent
    }
  })], 1), _vm._v(" "), _c('main', [_c('div', {
    staticClass: "petition-container"
  }, [_c('section', {
    staticClass: "form-section"
  }, [(!_vm.isLoading) ? _c('div', {
    staticClass: "form-wrapper"
  }, [_c('PetitionBio', {
    attrs: {
      "datalayerName": _vm.datalayerName,
      "programName": _vm.programName,
      "counterLimit": _vm.counterLimit,
      "counterTitle": _vm.counterTitle,
      "signButtonValue": _vm.signButtonValue,
      "viewMessageButtonValue": _vm.viewMessageButtonValue,
      "viewMessagePosition": _vm.viewMessagePosition,
      "letterTitle": _vm.letterTitle,
      "letterMessage": _vm.letterMessage,
      "stepupId": _vm.stepupId,
      "sendToIve": _vm.sendToIve,
      "iveSupplier": _vm.iveSupplier,
      "iveSource": _vm.iveSource
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "content-section"
  }, [_c('DynamicContent', {
    attrs: {
      "content": _vm.mainContent
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wwf-loading"
  }, [_c('span')])
}]}

/***/ }),
/* 707 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lr-ty-popup"
  }, [_c('div', [_c('div', {
    staticClass: "popup-header"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "popup-close-button",
    attrs: {
      "data-close": "",
      "type": "button"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_c('span', {
    staticClass: "popup-close-button-span"
  }, [_vm._v("Close")])])])]), _vm._v(" "), _c('div', {
    ref: "stepup",
    staticClass: "wwf-content"
  }, [_c('h3', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup-header-logo"
  }, [_c('img', {
    staticClass: "popup-logo",
    attrs: {
      "src": "https://www.wwf.org.au/ecThemes/3/Images/WWF-RA-lockup-logo.svg"
    }
  })])
}]}

/***/ }),
/* 708 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wwf-form donation-form leaf-relief-form",
    attrs: {
      "id": "leaf-relief"
    }
  }, [_c('LeafReliefHeader', {
    attrs: {
      "datalayerName": _vm.datalayerName,
      "counterLimit": _vm.counterLimit,
      "targetText": _vm.targetText,
      "headerText": _vm.headerText
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "processing-container"
  }, [(_vm.isProcessing) ? _c('div', {
    staticClass: "processing"
  }, [_c('i', {
    staticClass: "fas fa-sync-alt fa-spin"
  })]) : _vm._e(), _vm._v(" "), (!!_vm.product) ? _c('Stepper', {
    attrs: {
      "petitionSelector": _vm.petitionSelector,
      "donationSelector": _vm.donationSelector,
      "petitionHandle": _vm.petitionHandle,
      "programName": _vm.programName,
      "datalayerName": _vm.datalayerName,
      "thankYouText": _vm.thankYouText,
      "getSocialText": _vm.getSocialText,
      "duplicateEmailMessage": _vm.duplicateEmailMessage,
      "raRgId": _vm.raRgId,
      "raSgId": _vm.raSgId,
      "edoId": _vm.edoId,
      "sendToIve": _vm.sendToIve,
      "iveSupplier": _vm.iveSupplier,
      "iveSource": _vm.iveSource
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.showNames) ? _c('div', {
    staticClass: "last-signatures"
  }, [_c('div', {
    staticClass: "ls-title"
  }, [_vm._v("Trees planted")]), _vm._v(" "), _c('LastSignatures', {
    attrs: {
      "campaigId": "leaf-relief",
      "classes": "ra-last-signatures",
      "numberOfSignatures": _vm.numberOfSignatures
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 709 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.ready) ? _c('div', {
    staticClass: "donate-carousel"
  }, [_c('h2', [_vm._v("Choose your pack")]), _vm._v(" "), (_vm.packages.length > 1) ? _c('div', {
    staticClass: "wwf-radio-bttns"
  }, [_vm._l((_vm.packages), function(item, index) {
    return _c('label', {
      attrs: {
        "for": 'package-' + item.code
      }
    }, [_vm._v("\n      " + _vm._s(item.display) + "\n      "), _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (_vm.donation.packagecode),
        expression: "donation.packagecode"
      }],
      attrs: {
        "type": "radio",
        "name": "package",
        "id": 'package-' + item.code
      },
      domProps: {
        "value": item.code,
        "checked": index == 0 ? 'checked' : '',
        "checked": _vm._q(_vm.donation.packagecode, item.code)
      },
      on: {
        "change": [function($event) {
          _vm.$set(_vm.donation, "packagecode", item.code)
        }, function($event) {
          _vm.radioChanged(index)
        }]
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "wwf-radio"
    })])
  }), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.first('package')) ? _c('p', [_vm._v("Please choose your pack")]) : _vm._e()])], 2) : _vm._e(), _vm._v(" "), _c('VueSlickCarousel', {
    ref: "adoptionCarousel",
    attrs: {
      "infinite": false,
      "arrows": false
    },
    on: {
      "afterChange": _vm.updateSelectedPackage
    }
  }, _vm._l((_vm.packages), function(item) {
    return _c('div', {
      key: item.code
    }, [_c('div', {
      staticClass: "slide"
    }, [_c('div', {
      staticClass: "product-pack",
      style: ('background-image: url(' + item.pack.image + ')')
    }), _vm._v(" "), (item.toy) ? _c('div', {
      staticClass: "product-toy",
      style: ('background-image: url(' + item.toy.image + ')')
    }) : _vm._e()])])
  })), _vm._v(" "), _c('div', {
    staticClass: "product-label"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.selectedPackage.display))]), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.selectedPackage.pack.text) + "\n      "), (_vm.selectedPackage.toy) ? _c('span', [_vm._v(_vm._s(_vm.selectedPackage.toy.text))]) : _vm._e()])])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 710 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.product) ? _c('div', _vm._l((_vm.product.donationtypes), function(donationtype) {
    return _c('ul', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.type == donationtype),
        expression: "type == donationtype"
      }],
      staticClass: "widget-dollar-handles dollar-handles"
    }, _vm._l((_vm.product.dollarhandles[donationtype]), function(index) {
      return _c('li', {
        attrs: {
          "for": 'handle-' + donationtype + '-' + index.amount
        }
      }, [_c('div', {
        staticClass: "inner"
      }, [_c('div', {
        staticClass: "img"
      }, [_c('span', {
        style: ('background-image: url(' + index.img + ')')
      }), _vm._v(" "), _c('div', {
        staticClass: "handle-container"
      }, [_c('label', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.dollarhandle),
          expression: "dollarhandle"
        }],
        attrs: {
          "disabled": (_vm.formWizardCurrentStep != 0),
          "type": "radio",
          "name": 'handle-widget-' + donationtype,
          "id": 'handle-widget-' + donationtype + '-' + index.amount
        },
        domProps: {
          "value": index.amount,
          "checked": _vm._q(_vm.dollarhandle, index.amount)
        },
        on: {
          "change": function($event) {
            _vm.dollarhandle = index.amount
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "amount",
        class: {
          'has-cents': !(index.amount.indexOf('.00') >= 0)
        }
      }, [_c('span', [_vm._v("$" + _vm._s((index.amount.indexOf('.00') >= 0) ? index.amount.slice(0, -3) : index.amount))])]), _vm._v(" "), _c('span', {
        staticClass: "handle"
      }), _vm._v(" "), _c('span', {
        staticClass: "svg-circle"
      }, [_c('svg', {
        staticStyle: {
          "width": "100%",
          "height": "100%"
        }
      }, [_c('circle', {
        attrs: {
          "cx": "50%",
          "cy": "50%",
          "r": "40%",
          "stroke-width": "3"
        }
      })])])])])]), _vm._v(" "), _c('div', {
        staticClass: "desc"
      }, [_c('div', {
        staticClass: "desc-inner"
      }, [_c('h5', [_vm._v(_vm._s(index.text))])])])])])
    }))
  })) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 711 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.checkboxesPosition === 'right-side' || _vm.productType) ? _c('div', {
    staticClass: "filter-header-web right-side"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Filter by:")]), _vm._v(" "), (!_vm.productType) ? _c('div', [_c('EcommerceFilterProductType')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "categories"
  }, [_c('EcommerceFilterCategories', {
    attrs: {
      "categorySelection": _vm.categorySelection,
      "preSelectedCategories": _vm.preSelectedCategories
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.checkboxesPosition === 'below' && !_vm.productType) ? _c('div', {
    staticClass: "filter-header-web below"
  }, [_c('div', {
    staticClass: "product-type"
  }, [_c('div', [_vm._v("Filter by:")]), _vm._v(" "), _c('div', [_c('EcommerceFilterProductType')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "categories"
  }, [_c('EcommerceFilterCategories', {
    attrs: {
      "preSelectedCategories": _vm.preSelectedCategories
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "filter-header-mobile"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showMobileFilter = !_vm.showMobileFilter
      }
    }
  }, [_c('span', [_vm._v("Filter")]), _vm._v(" "), (_vm.showMobileFilter) ? _c('span', [_c('i', {
    staticClass: "fas fa-chevron-down"
  })]) : _vm._e(), _vm._v(" "), (!_vm.showMobileFilter) ? _c('span', [_c('i', {
    staticClass: "fas fa-chevron-up"
  })]) : _vm._e()])]), _vm._v(" "), (_vm.showMobileFilter) ? _c('div', [(!_vm.productType) ? _c('EcommerceFilterProductType') : _vm._e(), _vm._v(" "), _c('EcommerceFilterCategories', {
    attrs: {
      "categorySelection": _vm.categorySelection
    }
  })], 1) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 712 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isActive) ? _c('div', {
    staticClass: "petition-form wwf-form light"
  }, [_c('div', {
    staticClass: "flip-wrapper",
    class: {
      'formValidation-shake': _vm.isShake
    }
  }, [_c('div', {
    staticClass: "petition-form"
  }, [(_vm.title) ? _c('h2', [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), (_vm.intro) ? _c('p', {
    staticClass: "form-intro",
    domProps: {
      "innerHTML": _vm._s(_vm.intro)
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('firstName')
    },
    attrs: {
      "name": "firstName",
      "type": "text",
      "placeholder": "First name"
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('lastName')
    },
    attrs: {
      "name": "lastName",
      "type": "text",
      "placeholder": "Last name"
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.twitchName),
      expression: "twitchName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('twitchName')
    },
    attrs: {
      "name": "twitchName",
      "type": "text",
      "placeholder": "Twitch name"
    },
    domProps: {
      "value": (_vm.twitchName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.twitchName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    class: {
      'border-red': _vm.errors.has('email')
    },
    attrs: {
      "name": "email",
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('numeric'),
      expression: "'numeric'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    class: {
      'border-red': _vm.errors.has('phone')
    },
    attrs: {
      "name": "phone",
      "type": "number",
      "placeholder": "Phone"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postCode),
      expression: "postCode"
    }],
    attrs: {
      "name": "postCode",
      "type": "number",
      "placeholder": "Postcode"
    },
    domProps: {
      "value": (_vm.postCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.postCode = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "Submit"
    },
    on: {
      "click": _vm.save
    }
  })])])]) : _vm._e(), _vm._v(" "), (!_vm.isActive) ? _c('div', {
    staticClass: "form-closed"
  }, [_c('p', [_vm._v(_vm._s(_vm.closingmessage))])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "privacy-statement"
  }, [_c('p', [_vm._v("By signing you accept\n            "), _c('a', {
    attrs: {
      "href": "/privacy-policy/privacy-policy",
      "target": "_blank"
    }
  }, [_vm._v("WWF-Australia’s Privacy Policy.")])])])
}]}

/***/ }),
/* 713 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.products) ? _c('div', {
    staticClass: "impact-container",
    attrs: {
      "id": "impact-project"
    }
  }, [_c('Card', {
    staticClass: "main-card",
    attrs: {
      "product": _vm.products[0],
      "wide": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cards-wrapper"
  }, _vm._l((_vm.products.slice(1)), function(item, index) {
    return _c('Card', {
      key: index,
      attrs: {
        "product": item
      }
    })
  }))], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 714 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-item-container search-item-instagram"
  }, [_c('div', {
    staticClass: "search-item-header"
  }, [_c('div', {
    staticClass: "search-item-title"
  }, [_c('h4', [_c('a', {
    attrs: {
      "href": _vm.item.liveUrl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.item.metaData.instagramCaption))])])]), _vm._v(" "), _c('div', {
    staticClass: "search-item-link"
  }, [_c('a', {
    attrs: {
      "href": _vm.item.liveUrl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.item.displayUrl))])]), _vm._v(" "), _c('div', {
    staticClass: "search-item-header-date"
  }, [_vm._v("\n      " + _vm._s(_vm.item.date) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "search-item-content"
  }, [_c('a', {
    attrs: {
      "href": _vm.item.liveUrl,
      "target": "_blank"
    }
  }, [(
    _vm.item.metaData &&
    _vm.item.metaData.instagramMediaType === 'IMAGE' &&
    _vm.item.metaData.instagramMediaUrl
  ) ? _c('img', {
    attrs: {
      "src": _vm.item.metaData.instagramMediaUrl,
      "alt": 'Thumbnail for ' + _vm.item.title
    }
  }) : _vm._e(), _vm._v(" "), (
    _vm.item.metaData &&
    _vm.item.metaData.instagramMediaType === 'VIDEO' &&
    _vm.item.metaData.instagramThumbnailUrl
  ) ? _c('img', {
    attrs: {
      "src": _vm.item.metaData.instagramThumbnailUrl,
      "alt": 'Thumbnail for ' + _vm.item.title
    }
  }) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "search-item-date"
  }, [_vm._v(_vm._s(_vm.item.date) + " ")]), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.truncatedText)
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 715 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "solution-menu"
  }, [_vm._l((_vm.items), function(item, i) {
    return [_c('SolutionsButton', {
      key: 'button' + i,
      attrs: {
        "item": item,
        "isActive": _vm.selected == item.name
      },
      on: {
        "setActive": function($event) {
          _vm.setActive(item.name)
        },
        "toggleActive": function($event) {
          _vm.toggleActive(item.name)
        }
      }
    }), _vm._v(" "), _c('SolutionsContent', {
      key: 'content' + i,
      attrs: {
        "item": item,
        "isActive": _vm.selected == item.name
      }
    })]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 716 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "card",
    on: {
      "click": function($event) {
        _vm.redirectTo(_vm.product.url)
      }
    }
  }, [_c('div', {
    staticClass: "card-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.product.image
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-name"
  }, [_c('span', [_vm._v(_vm._s(_vm.product.name))]), _vm._v(" "), _vm._m(0, false, false)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fas fa-chevron-right"
  })])
}]}

/***/ }),
/* 717 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "text-center"
  }, [_c('ul', {
    staticClass: "type-tab wwf-radio-bttns"
  }, _vm._l((_vm.productidsdetail), function(productdetail) {
    return _c('li', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product),
        expression: "product"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      attrs: {
        "type": "radio",
        "name": "product",
        "id": 'id-' + productdetail.productname
      },
      domProps: {
        "value": productdetail,
        "checked": _vm._q(_vm.product, productdetail)
      },
      on: {
        "change": function($event) {
          _vm.product = productdetail
        }
      }
    }), _vm._v("\n          " + _vm._s(productdetail.productname) + "\n          "), _c('span', {
      staticClass: "wwf-radio"
    })])])
  }))]), _vm._v(" "), (_vm.product != null) ? _c('ul', {
    staticClass: "widget-dollar-handles"
  }, [_vm._l((_vm.product.dollarhandles[_vm.product.donationtypes[0]]), function(dollarhandle) {
    return _c('li', [_c('div', {
      staticClass: "inner"
    }, [_c('div', {
      staticClass: "img"
    }, [_c('span', {
      style: ('background-image: url(' + dollarhandle.img + ')')
    })]), _vm._v(" "), _c('div', {
      staticClass: "desc"
    }, [_c('h2', [_vm._v("$" + _vm._s((dollarhandle.amount.indexOf('.00') >= 0) ? dollarhandle.amount.slice(0, -3) : dollarhandle.amount))]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(dollarhandle.text))])]), _vm._v(" "), _c('p', {
      staticClass: "donate-amount",
      on: {
        "click": function($event) {
          _vm.redirect(_vm.product.urlPath, dollarhandle.amount, dollarhandle.amount)
        }
      }
    }, [_vm._v("Donate $" + _vm._s((dollarhandle.amount.indexOf('.00') >= 0) ? dollarhandle.amount.slice(0, -3) : dollarhandle.amount))])])])
  }), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "inner"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_c('div', {
    staticClass: "other-amount",
    class: _vm.customamount ? 'has-other-content' : ''
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customamount),
      expression: "customamount"
    }],
    attrs: {
      "type": "tel"
    },
    domProps: {
      "value": (_vm.customamount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customamount = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1, false, false)]), _vm._v(" "), _c('h5', [_vm._v("choose your own amount")])]), _vm._v(" "), _vm._v("\",customamount)\"\n          class=\"donate-amount\"\n        >Donate $" + _vm._s((_vm.customamount && _vm.customamount.indexOf('.00') >= 0) ? _vm.customamount.slice(0, -3) : _vm.customamount)), _c('p')])])], 2) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img"
  }, [_c('span', {
    staticClass: "dh-misc-img"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pencil"
  }, [_c('i', {
    staticClass: "fas fa-pencil-alt"
  }), _vm._v(" "), _c('span')])
}]}

/***/ }),
/* 718 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.logos) ? _c('div', {
    staticClass: "cards-container"
  }, [_c('div', {
    staticClass: "cards"
  }, _vm._l((_vm.logos), function(logo) {
    return _c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "img-container",
      style: ({
        'background-image': 'url(\'' + logo.url + '\')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "name-container"
    }, [_c('span', [_vm._v(_vm._s(logo.organisationName))])])])
  })), _vm._v(" "), (_vm.showLoadMore) ? _c('div', {
    staticClass: "load-more-container"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.fetching
    },
    on: {
      "click": _vm.fetchLogos
    }
  }, [(!_vm.fetching) ? _c('span', [_vm._v("Show More")]) : _vm._e(), _vm._v(" "), (_vm.fetching) ? _c('span', [_c('i', {
    staticClass: "fas fa-globe fa-spin"
  })]) : _vm._e()])]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 719 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showcounter) ? _c('div', {
    staticClass: "petition-counter"
  }, [_c('h2', [_c('count-to', {
    ref: "counter",
    attrs: {
      "startVal": _vm.startcounter,
      "end-val": _vm.endcounter,
      "autoplay": false,
      "duration": 7000
    },
    on: {
      "callbackCounter": _vm.updatePercentage
    }
  })], 1), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.countertitle))])]) : _vm._e(), _vm._v(" "), (_vm.showprogressbar) ? _c('div', {
    staticClass: "petition-progressbar"
  }, [_c('progressbar', {
    attrs: {
      "percentage": _vm.percentage,
      "revdirection": _vm.revdirection
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isActive) ? _c('div', {
    staticClass: "petition-form wwf-form light"
  }, [_c('div', {
    staticClass: "flip-wrapper",
    class: {
      'formValidation-shake': _vm.isShake
    }
  }, [_c('div', {
    staticClass: "petition-form"
  }, [_c('p', {
    staticClass: "form-intro"
  }, [_c('strong', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('p', {
    staticClass: "form-intro"
  }), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.intro)
    }
  }), _vm._v(" "), _c('p'), _vm._v(" "), (!_vm.seeMessageButtonBottom) ? _c('input', {
    staticClass: "read-letter",
    attrs: {
      "type": "button",
      "value": "Here's the message we're sending"
    },
    on: {
      "click": _vm.openReadLetterPage
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true}"
    }],
    class: {
      'border-red': _vm.errors.has('firstName')
    },
    attrs: {
      "name": "firstName",
      "type": "text",
      "placeholder": "First name",
      "autocomplete": "given-name"
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('first name')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true}"
    }],
    class: {
      'border-red': _vm.errors.has('lastName')
    },
    attrs: {
      "name": "lastName",
      "type": "text",
      "placeholder": "Last name",
      "autocomplete": "family-name"
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('last name')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "with-input-loading"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        petitionEmailIsValid: true,
        email: true
      }),
      expression: "{ required: true, petitionEmailIsValid: true, email: true }"
    }],
    class: {
      'border-red': _vm.errors.has('email')
    },
    attrs: {
      "name": "email",
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }, function($event) {
        _vm.onEmailInput()
      }],
      "focus": function($event) {
        _vm.logFirstTouch('email')
      }
    }
  }), _vm._v(" "), (_vm.emailCheckSensis.checkEmailLoading) ? _c('div', {
    staticClass: "input-loading"
  }, [_c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/loading-tail-spin.svg"
    }
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.has('email')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first('email')))]) : _vm._e()])]), _vm._v(" "), (((_vm.country == 'Australia') ? 'number' : 'text') === 'checkbox' && (!_vm.hidepostcode && _vm.extraMandatoryFields.indexOf('postCode') == -1)) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postCode),
      expression: "postCode"
    }],
    attrs: {
      "name": "postCode",
      "placeholder": "Postcode",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.postCode) ? _vm._i(_vm.postCode, null) > -1 : (_vm.postCode)
    },
    on: {
      "input": function($event) {
        _vm.postcodeUpdated()
      },
      "focus": function($event) {
        _vm.logFirstTouch('postcode')
      },
      "change": function($event) {
        var $$a = _vm.postCode,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.postCode = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.postCode = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.postCode = $$c
        }
      }
    }
  }) : (((_vm.country == 'Australia') ? 'number' : 'text') === 'radio' && (!_vm.hidepostcode && _vm.extraMandatoryFields.indexOf('postCode') == -1)) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postCode),
      expression: "postCode"
    }],
    attrs: {
      "name": "postCode",
      "placeholder": "Postcode",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.postCode, null)
    },
    on: {
      "input": function($event) {
        _vm.postcodeUpdated()
      },
      "focus": function($event) {
        _vm.logFirstTouch('postcode')
      },
      "change": function($event) {
        _vm.postCode = null
      }
    }
  }) : (!_vm.hidepostcode && _vm.extraMandatoryFields.indexOf('postCode') == -1) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postCode),
      expression: "postCode"
    }],
    attrs: {
      "name": "postCode",
      "placeholder": "Postcode",
      "type": (_vm.country == 'Australia') ? 'number' : 'text'
    },
    domProps: {
      "value": (_vm.postCode)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.postCode = $event.target.value
      }, function($event) {
        _vm.postcodeUpdated()
      }],
      "focus": function($event) {
        _vm.logFirstTouch('postcode')
      }
    }
  }) : _vm._e(), _vm._v(" "), (((_vm.country == 'Australia') ? 'number' : 'text') === 'checkbox' && (!_vm.hidepostcode && _vm.extraMandatoryFields.indexOf('postCode') > -1)) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postCode),
      expression: "postCode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        petitionPostCodeIsValid: true
      }),
      expression: "{ required: true, petitionPostCodeIsValid: true }"
    }],
    class: {
      'border-red': _vm.errors.has('postCode')
    },
    attrs: {
      "name": "postCode",
      "placeholder": "Postcode",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.postCode) ? _vm._i(_vm.postCode, null) > -1 : (_vm.postCode)
    },
    on: {
      "input": function($event) {
        _vm.postcodeUpdated()
      },
      "focus": function($event) {
        _vm.logFirstTouch('postcode')
      },
      "change": function($event) {
        var $$a = _vm.postCode,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.postCode = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.postCode = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.postCode = $$c
        }
      }
    }
  }) : (((_vm.country == 'Australia') ? 'number' : 'text') === 'radio' && (!_vm.hidepostcode && _vm.extraMandatoryFields.indexOf('postCode') > -1)) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postCode),
      expression: "postCode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        petitionPostCodeIsValid: true
      }),
      expression: "{ required: true, petitionPostCodeIsValid: true }"
    }],
    class: {
      'border-red': _vm.errors.has('postCode')
    },
    attrs: {
      "name": "postCode",
      "placeholder": "Postcode",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.postCode, null)
    },
    on: {
      "input": function($event) {
        _vm.postcodeUpdated()
      },
      "focus": function($event) {
        _vm.logFirstTouch('postcode')
      },
      "change": function($event) {
        _vm.postCode = null
      }
    }
  }) : (!_vm.hidepostcode && _vm.extraMandatoryFields.indexOf('postCode') > -1) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postCode),
      expression: "postCode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        petitionPostCodeIsValid: true
      }),
      expression: "{ required: true, petitionPostCodeIsValid: true }"
    }],
    class: {
      'border-red': _vm.errors.has('postCode')
    },
    attrs: {
      "name": "postCode",
      "placeholder": "Postcode",
      "type": (_vm.country == 'Australia') ? 'number' : 'text'
    },
    domProps: {
      "value": (_vm.postCode)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.postCode = $event.target.value
      }, function($event) {
        _vm.postcodeUpdated()
      }],
      "focus": function($event) {
        _vm.logFirstTouch('postcode')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.firstByRule('postCode', 'petitionPostCodeIsValid') || _vm.errors.firstByRule('postCode')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first('postCode')))]) : _vm._e()]), _vm._v(" "), (_vm.showphonenumber && _vm.extraMandatoryFields.indexOf('phoneNumber') == -1 && _vm.manatoryFields.indexOf('phoneNumber') == -1) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phoneNumber),
      expression: "phoneNumber"
    }],
    attrs: {
      "name": "phoneNumber",
      "type": "tel",
      "placeholder": "Phone Number"
    },
    domProps: {
      "value": (_vm.phoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phoneNumber = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showphonenumber && (_vm.extraMandatoryFields.indexOf('phoneNumber') > -1 || _vm.manatoryFields.indexOf('phoneNumber') > -1)) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phoneNumber),
      expression: "phoneNumber"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        petitionPhoneNumberIsValid: true
      }),
      expression: "{ required: true, petitionPhoneNumberIsValid: true }"
    }],
    class: {
      'border-red': _vm.errors.has('phoneNumber')
    },
    attrs: {
      "name": "phoneNumber",
      "type": "tel",
      "placeholder": "Phone Number"
    },
    domProps: {
      "value": (_vm.phoneNumber)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('phone')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phoneNumber = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.firstByRule('phoneNumber', 'petitionPhoneNumberIsValid')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first('phoneNumber')))]) : _vm._e()]), _vm._v(" "), (_vm.showstate) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.state),
      expression: "state"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('state')
    },
    attrs: {
      "name": "state",
      "placeholder": "State"
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('state')
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ACT"
    }
  }, [_vm._v("ACT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NSW"
    }
  }, [_vm._v("NSW")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NT"
    }
  }, [_vm._v("NT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "QLD"
    }
  }, [_vm._v("QLD")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TAS"
    }
  }, [_vm._v("TAS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "VIC"
    }
  }, [_vm._v("VIC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SA"
    }
  }, [_vm._v("SA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "WA"
    }
  }, [_vm._v("WA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Outside Australia"
    }
  }, [_vm._v("Outside Australia")])]) : _vm._e(), _vm._v(" "), (_vm.showrecipientslist && _vm.recipients != null) ? _c('div', {
    staticClass: "recipients-list"
  }, [_c('div', {
    staticClass: "recipients-title"
  }, [_vm._v("You will be contacting")]), _vm._v(" "), (_vm.recipients.mainMP) ? _c('div', {
    staticClass: "recipient"
  }, [_vm._v("• " + _vm._s(_vm.recipients.mainMP.salutation) + " " + _vm._s(_vm.recipients.mainMP.name))]) : _vm._e(), _vm._v(" "), (_vm.recipients.senators.length > 1) ? _c('div', {
    staticClass: "senators-list"
  }, [_c('div', [_vm._v("Select your Senator")]), _vm._v(" "), _c('div', {
    staticClass: "wwf-radio-bttns senator-item"
  }, _vm._l((_vm.recipients.senators), function(senator) {
    return _c('label', {
      attrs: {
        "for": 'senator-' + senator.email
      }
    }, [_c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedSenator),
        expression: "selectedSenator"
      }],
      attrs: {
        "type": "radio",
        "name": "selectedSenator",
        "id": 'senator-' + senator.email
      },
      domProps: {
        "value": senator,
        "checked": _vm._q(_vm.selectedSenator, senator)
      },
      on: {
        "change": function($event) {
          _vm.selectedSenator = senator
        }
      }
    }), _vm._v("\n                     " + _vm._s(senator.salutation) + " " + _vm._s(senator.name) + "\n                     "), _c('span', {
      staticClass: "wwf-radio"
    })])
  }))]) : _vm._e(), _vm._v(" "), (_vm.recipients.senators.length === 1 && _vm.selectedSenator != null) ? _c('div', {
    staticClass: "recipient"
  }, [_vm._v("• " + _vm._s(_vm.selectedSenator.salutation) + " " + _vm._s(_vm.selectedSenator.name))]) : _vm._e(), _vm._v(" "), (_vm.recipients.mps.length > 1) ? _c('div', {
    staticClass: "mps-list"
  }, [_c('div', [_vm._v("Select your MP")]), _vm._v(" "), _c('div', {
    staticClass: "wwf-radio-bttns mp-item"
  }, _vm._l((_vm.recipients.mps), function(mp) {
    return _c('label', {
      attrs: {
        "for": 'mp-' + mp.email
      }
    }, [_c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedMP),
        expression: "selectedMP"
      }],
      attrs: {
        "type": "radio",
        "name": "selectedMP",
        "id": 'mp-' + mp.email
      },
      domProps: {
        "value": mp,
        "checked": _vm._q(_vm.selectedMP, mp)
      },
      on: {
        "change": function($event) {
          _vm.selectedMP = mp
        }
      }
    }), _vm._v("\n                     " + _vm._s(mp.salutation) + " " + _vm._s(mp.name) + ", MP\n                     "), _c('span', {
      staticClass: "wwf-radio"
    })])
  }))]) : _vm._e(), _vm._v(" "), (_vm.recipients.mps.length === 1 && _vm.selectedMP != null) ? _c('div', {
    staticClass: "recipient"
  }, [_vm._v("• " + _vm._s(_vm.selectedMP.salutation) + " " + _vm._s(_vm.selectedMP.name) + ", MP")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showmessage) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    class: {
      'border-red': _vm.errors.has('message')
    },
    attrs: {
      "name": "message",
      "placeholder": _vm.messageplaceholder,
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showmessage) ? _c('p', {
    staticClass: "word-count"
  }, [_vm._v(_vm._s(255 - (_vm.message ? _vm.message.length : 0) + ' Char'))]) : _vm._e(), _vm._v(" "), (_vm.showcountry) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.country),
      expression: "country"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('country')
    },
    attrs: {
      "name": "country",
      "autocomplete": "country",
      "placeholder": "Country"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.country = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.countriesList), function(countries, index) {
    return _c('option', {
      domProps: {
        "value": countries.name
      }
    }, [_vm._v(_vm._s(countries.name))])
  })) : _vm._e(), _vm._v(" "), (_vm.seeMessageButtonBottom) ? _c('input', {
    staticClass: "read-letter",
    attrs: {
      "type": "button",
      "value": "Here's the message we're sending"
    },
    on: {
      "click": _vm.openReadLetterPage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showpermission) ? _c('div', [_vm._v("\n                 Do you give permission for your submission to be published on the EPBC Act Review website?"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.permission),
      expression: "permission"
    }],
    class: {
      'border-red': _vm.errors.has('permissionyes')
    },
    attrs: {
      "type": "radio",
      "name": "permissionyes",
      "id": "permissionyes",
      "value": "Yes"
    },
    domProps: {
      "checked": _vm._q(_vm.permission, "Yes")
    },
    on: {
      "change": function($event) {
        _vm.permission = "Yes"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "permissionyes"
    }
  }, [_vm._v("Yes – with my name")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.permission),
      expression: "permission"
    }],
    class: {
      'border-red': _vm.errors.has('permissionyes')
    },
    attrs: {
      "type": "radio",
      "name": "permissionanonymous",
      "id": "permissionanonymous",
      "value": "Anonymous"
    },
    domProps: {
      "checked": _vm._q(_vm.permission, "Anonymous")
    },
    on: {
      "change": function($event) {
        _vm.permission = "Anonymous"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "permissionanonymous"
    }
  }, [_vm._v("Yes – anonymously ")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.permission),
      expression: "permission"
    }],
    class: {
      'border-red': _vm.errors.has('permissionyes')
    },
    attrs: {
      "type": "radio",
      "name": "permissionno",
      "id": "permissionno",
      "value": "No"
    },
    domProps: {
      "checked": _vm._q(_vm.permission, "No")
    },
    on: {
      "change": function($event) {
        _vm.permission = "No"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "permissionno"
    }
  }, [_vm._v("No – please keep my submission confidential")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getextracampaignsList), function(extracampaign, index) {
    return _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedCampaign),
        expression: "selectedCampaign"
      }],
      attrs: {
        "type": "checkbox",
        "name": 'extracampaign' + index,
        "id": 'extracampaign' + index
      },
      domProps: {
        "value": extracampaign,
        "checked": Array.isArray(_vm.selectedCampaign) ? _vm._i(_vm.selectedCampaign, extracampaign) > -1 : (_vm.selectedCampaign)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selectedCampaign,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = extracampaign,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedCampaign = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedCampaign = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedCampaign = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'extracampaign' + index
      }
    }, [_vm._v("Add my name to " + _vm._s(extracampaign.title) + " too!")])])
  }), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('input', {
    staticClass: "btn-submit",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving,
      "value": _vm.isSaving ? 'Loading...' : 'Submit'
    },
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isProfanity),
      expression: "isProfanity"
    }],
    staticClass: "alert-box"
  }, [_vm._v("No bad words! Please change your message.")])], 2)])])]) : _vm._e(), _vm._v(" "), (!_vm.isActive) ? _c('div', {
    staticClass: "form-closed"
  }, [_c('p', [_vm._v(_vm._s(_vm.closingmessage))])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "privacy-statement"
  }, [_c('p', [_vm._v("By signing you accept\n               "), _c('a', {
    attrs: {
      "href": "/privacy-policy/privacy-policy",
      "target": "_blank"
    }
  }, [_vm._v("WWF-Australia’s Privacy Policy.")])])])
}]}

/***/ }),
/* 720 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reveal large",
    attrs: {
      "id": 'modal-ytvideo-' + _vm.videoId,
      "data-reveal": ""
    }
  }, [_c('div', {
    staticClass: "responsive-embed widescreen content"
  }, [(_vm.isOpen) ? _c('youtube', {
    attrs: {
      "video-id": _vm.videoId
    },
    on: {
      "ready": _vm.ready
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm._m(0, false, false)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close-button",
    attrs: {
      "data-close": "",
      "aria-label": "Close modal",
      "type": "button"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}

/***/ }),
/* 721 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.product) ? _c('div', {
    staticClass: "donation-selection",
    attrs: {
      "id": "donate-step1"
    }
  }, [_c(_vm.packageCarousel, {
    tag: "component"
  }), _vm._v(" "), (!_vm.isAdoption && !_vm.isWildcard) ? _c('div', {
    staticClass: "tab-selector"
  }, _vm._l((_vm.product.donationtypes), function(donationType) {
    return _c('div', {
      staticClass: "single-tab",
      class: {
        selected: donationType === _vm.currentDonationType
      },
      on: {
        "click": function($event) {
          _vm.selectDonationType(donationType);
          _vm.logFirstTouch('donation type')
        }
      }
    }, [_vm._v("\n      " + _vm._s(donationType == "Regular" ? "Give monthly" : "Give once") + "\n    ")])
  })) : _vm._e(), _vm._v(" "), (_vm.isAdoption) ? _c('div', {
    staticClass: "tab-selector"
  }, [_c('div', {
    staticClass: "single-tab",
    class: {
      selected: !_vm.isGiftSelected
    },
    on: {
      "click": function($event) {
        _vm.toggleIsGift(false);
        _vm.logFirstTouch('gift')
      }
    }
  }, [_vm._v("\n      For you\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "single-tab",
    class: {
      selected: _vm.isGiftSelected
    },
    on: {
      "click": function($event) {
        _vm.toggleIsGift(true);
        _vm.logFirstTouch('gift')
      }
    }
  }, [_vm._v("\n      As a gift\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.isAdoption || _vm.isWildcard) ? _c('h2', [_vm._v("\n    " + _vm._s(_vm.donation.type == "Regular" ? "Give monthly" : "Give once") + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dollar-handle-selector"
  }, [_vm._l((_vm.dollarHandles), function(dollarHandle) {
    return _c('label', {
      attrs: {
        "for": 'handle-' + _vm.currentDonationType + '-' + dollarHandle.amount
      }
    }, [_c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedDollarHandle),
        expression: "selectedDollarHandle"
      }],
      attrs: {
        "type": "radio",
        "name": 'handle-' + _vm.currentDonationType,
        "id": 'handle-' + _vm.currentDonationType + '-' + dollarHandle.amount,
        "data-vv-as": "amount"
      },
      domProps: {
        "value": dollarHandle,
        "checked": _vm._q(_vm.selectedDollarHandle, dollarHandle)
      },
      on: {
        "focus": function($event) {
          _vm.logFirstTouch('dollar handle')
        },
        "change": function($event) {
          _vm.selectedDollarHandle = dollarHandle
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "amount"
    }, [_c('span', [_vm._v(_vm._s(_vm.formatDollarHandle(dollarHandle.amount)))])])])
  }), _vm._v(" "), (_vm.proposeCustomAmount) ? _c('label', {
    attrs: {
      "for": 'handle-' + _vm.currentDonationType + '-custom'
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedDollarHandle),
      expression: "selectedDollarHandle"
    }],
    attrs: {
      "type": "radio",
      "name": 'handle-' + _vm.currentDonationType,
      "id": 'handle-' + _vm.currentDonationType + '-custom',
      "value": "custom"
    },
    domProps: {
      "checked": _vm._q(_vm.selectedDollarHandle, "custom")
    },
    on: {
      "change": function($event) {
        _vm.selectedDollarHandle = "custom"
      }
    }
  }), _vm._v(" "), _vm._m(0, false, false)]) : _vm._e()], 2), _vm._v(" "), (_vm.isCustomSelected) ? _c('div', [(_vm.proposeCustomAmount) ? _c('div', {
    staticClass: "wwf-field icon"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.amount),
      expression: "donation.amount"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        donationCustomAmountIsValid: true
      }),
      expression: "{ required: true, donationCustomAmountIsValid: true }"
    }],
    ref: "customAmount",
    class: {
      empty: !_vm.donation.amount,
        error:
        _vm.errors.has('customAmount') ||
        _vm.errors.has('donationCustomAmountIsValid'),
    },
    attrs: {
      "id": "customAmount",
      "name": "customAmount",
      "type": "number",
      "data-vv-validate-on": "change",
      "data-vv-as": "Custom Amount"
    },
    domProps: {
      "value": (_vm.donation.amount)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('dollar handle')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation, "amount", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'handle-' + _vm.currentDonationType + '-custom'
    }
  }, [_vm._v("\n        Custom amount\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(
    _vm.errors.has('customAmount') ||
    _vm.errors.has('donationCustomAmountIsValid')
  ) ? _c('p', [_vm._v("\n          " + _vm._s(_vm.errors.first("customAmount")) + "\n        ")]) : _vm._e()])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMaxAmountMessage),
      expression: "showMaxAmountMessage"
    }],
    staticClass: "message-max-amount"
  }, [_c('p', [_vm._v("\n      For donations above $75,000 please contact our Impact Partnerships team,\n      so we can be sure your gift benefits the area of conservation you are\n      most passionate about.\n    ")]), _vm._v(" "), _vm._m(2, false, false)]), _vm._v(" "), (_vm.isDollarHandleSelected) ? _c('div', {
    staticClass: "dollar-handle-selected"
  }, [_c('span', [_vm._v(_vm._s(_vm.selectedDollarHandle.text))])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.first('handle-' + _vm.currentDonationType)) ? _c('p', [_vm._v("\n      Please choose your donation amount\n    ")]) : _vm._e()]), _vm._v(" "), (_vm.showTaxCalculator) ? _c('tax-calculator', {
    attrs: {
      "amount": _vm.donation.amount
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "payment-type-selector"
  }, [_c('button', {
    staticClass: "plain",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.selectPaymentType('wwf_purchasetokenise')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.paymentTypeText) + " Credit Card")]), _vm._v(" "), _vm._m(3, false, false)]), _vm._v(" "), (_vm.isPayPalAvailable) ? _c('button', {
    staticClass: "plain",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.selectPaymentType('wwf_paypal')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.paymentTypeText) + " Paypal")]), _vm._v(" "), _vm._m(4, false, false)]) : _vm._e(), _vm._v(" "), (_vm.isDirectDebitAvailable) ? _c('button', {
    staticClass: "plain",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.selectPaymentType('wwf_directdebit')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.paymentTypeText) + " Direct Debit")]), _vm._v(" "), _vm._m(5, false, false)]) : _vm._e()])], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "amount"
  }, [_c('span', [_vm._v("$_")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('div', [_vm._v("$_")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n      Please email\n      "), _c('a', {
    attrs: {
      "href": "mailto:partnerships@wwf.org.au",
      "target": "_blank"
    }
  }, [_vm._v("partnerships@wwf.org.au")]), _vm._v(". Thank you so much for your kindness!\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fas fa-arrow-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fas fa-arrow-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fas fa-arrow-right"
  })])
}]}

/***/ }),
/* 722 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "vue-newsletter-signup"
    }
  }, [_c('div', {
    staticClass: "row expanded newsletter bg-dgrey img-txt-pnls",
    attrs: {
      "data-equalizer": ""
    }
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "small-12 large-6 large-pull-6 columns pddxy-50 txt",
    attrs: {
      "data-equalizer-watch": ""
    }
  }, [_vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "row small-collapse medium-uncollapse wwf-form dark"
  }, [_c('div', {
    staticClass: "small-12 medium-6 columns ng-invalid"
  }, [_c('span', {
    staticClass: "input-border"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('firstName')
    },
    attrs: {
      "name": "firstName",
      "placeholder": "First name",
      "type": "text",
      "data-vv-as": "First name",
      "id": "target-newsletter"
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "alert-box-c"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('firstName')),
      expression: "errors.has('firstName')"
    }],
    staticClass: "alert-box"
  }, [_vm._v(_vm._s(_vm.errors.first('firstName')))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 medium-6 columns ng-invalid"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('lastName')
    },
    attrs: {
      "name": "lastName",
      "placeholder": "Last name",
      "type": "text",
      "data-vv-as": "Last name"
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "alert-box-c"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('lastName')),
      expression: "errors.has('lastName')"
    }],
    staticClass: "alert-box"
  }, [_vm._v(_vm._s(_vm.errors.first('lastName')))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 medium-6 columns ng-invalid"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        email: true,
        newsletterCheckEmail: true
      }),
      expression: "{required: true, email: true, newsletterCheckEmail: true}"
    }],
    class: {
      'border-red': _vm.errors.has('email') || _vm.errors.has('newsletterCheckEmail')
    },
    attrs: {
      "name": "email",
      "placeholder": "Email",
      "type": "text"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.checkEmailLoading) ? _c('div', {
    staticClass: "input-loading"
  }, [_c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/loading-tail-spin.svg"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "alert-box-c"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "alert-box"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 medium-6 columns ng-invalid"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postCode),
      expression: "postCode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }],
    class: {
      'border-red': _vm.errors.has('postCode')
    },
    attrs: {
      "name": "postCode",
      "placeholder": "Postcode",
      "type": "text",
      "data-vv-as": "Postcode"
    },
    domProps: {
      "value": (_vm.postCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.postCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "alert-box-c"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('postCode')),
      expression: "errors.has('postCode')"
    }],
    staticClass: "alert-box"
  }, [_vm._v(_vm._s(_vm.errors.first('postCode')))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 columns"
  }, [_c('a', {
    staticClass: "bttn-lrg-arrw",
    on: {
      "click": _vm.postForm
    }
  }, [_vm._v("SIGNUP")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small-12 large-6 large-push-6 columns credit-c img",
    attrs: {
      "data-equalizer-watch": ""
    }
  }, [_c('span', {
    staticClass: "span-image"
  }), _vm._v(" "), _c('p', {
    staticClass: "credit"
  }, [_vm._v("© Troy Mayne")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row small-collapse medium-uncollapse white-text"
  }, [_c('div', {
    staticClass: "small-12 columns"
  }, [_c('h2', [_vm._v("Get updates")]), _vm._v(" "), _c('p', {
    staticClass: "get-updates"
  }, [_vm._v("Sign up and we’ll keep you up-to-date with the latest news on WWF’s work to protect endangered wildlife and habitats and how you can help make a real difference to their future.")])])])
}]}

/***/ }),
/* 723 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-autocomplete"
  }, [_c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.clickOutside),
      expression: "clickOutside"
    }],
    staticClass: "autocomplete"
  }, [_c('div', {
    staticClass: "input-wrapper"
  }, [(_vm.displayIcon) ? _c('div', {
    staticClass: "search-autocomplete-icon",
    on: {
      "click": _vm.keyEnter
    }
  }, [_c('i', {
    staticClass: "fas fa-search fa-fw"
  })]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInput),
      expression: "userInput"
    }],
    class: {
      classname: _vm.classname, 'has-icon': _vm.displayIcon
    },
    attrs: {
      "id": _vm.id,
      "name": "search",
      "type": "search",
      "placeholder": "I'm looking for ...",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.userInput)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.userInput = $event.target.value
      }, _vm.fetchSearchSuggestions],
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        $event.preventDefault();
        _vm.keyEnter($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9, $event.key)) { return null; }
        $event.preventDefault();
        _vm.keyEnter($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "escape", undefined, $event.key)) { return null; }
        $event.preventDefault();
        _vm.keyEscape($event)
      }],
      "!keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key)) { return null; }
        _vm.keyUp($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key)) { return null; }
        _vm.keyDown($event)
      }]
    }
  }), _vm._v(" "), (_vm.fetchingDetails) ? _c('div', {
    staticClass: "input-loading"
  }, [_c('img', {
    attrs: {
      "alt": "Loading while fetching the search result selected",
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/loading-tail-spin.svg"
    }
  })]) : _vm._e()]), _vm._v(" "), (_vm.displaySuggestions) ? _c('div', {
    staticClass: "suggestions"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "suggestion-loading"
  }, [_c('img', {
    attrs: {
      "alt": "Loading while fetching suggestions",
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/loading-three-dots.svg"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.suggestions.length > 0) ? _c('div', {
    staticClass: "suggestion-list",
    attrs: {
      "id": "search-suggestion-list"
    }
  }, _vm._l((_vm.suggestions), function(p) {
    return _c('div', {
      staticClass: "suggestion-item",
      class: {
        'item-active': _vm.cursor === p.index
      },
      attrs: {
        "id": 'search-suggestion-item-' + p.index
      },
      on: {
        "click": function($event) {
          _vm.selectSearchSuggestion(p.label)
        },
        "mouseover": function($event) {
          _vm.cursor = p.index
        }
      }
    }, [_vm._v("\n          " + _vm._s(p.label) + "\n        ")])
  })) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.suggestions.length == 0) ? _c('div', {
    staticClass: "suggestion-list"
  }, [_c('div', {
    staticClass: "suggestion-item empty",
    on: {
      "click": function($event) {
        _vm.selectSearchSuggestion(_vm.userInput)
      }
    }
  }, [_vm._v("\n          No Suggestions\n        ")])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.displaySearchButton) ? _c('button', {
    staticClass: "search-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.selectSearchSuggestion(_vm.userInput)
      }
    }
  }, [_vm._v("\n    Search\n  ")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 724 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row small-collapse",
    class: {
      'formValidation-shake': _vm.isShake
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.intro))]), _vm._v(" "), _c('div', {
    staticClass: "small-6 columns left-field"
  }, [_c('label', {
    attrs: {
      "for": "firstName"
    }
  }, [_vm._v("\n        First name\n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('firstName')
    },
    attrs: {
      "type": "text",
      "name": "firstName",
      "id": "firstName",
      "data-vv-as": "first name"
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.first('firstName')) ? _c('span', {
    staticClass: "form-error-area"
  }, [_c('p', [_vm._v(_vm._s(_vm.errors.first("firstName")))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "small-6 columns right-field"
  }, [_c('label', {
    attrs: {
      "for": "lastName"
    }
  }, [_vm._v("\n        Last name\n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('lastName')
    },
    attrs: {
      "type": "text",
      "name": "lastName",
      "id": "lastName",
      "data-vv-as": "last name"
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.first('lastName')) ? _c('span', {
    staticClass: "form-error-area"
  }, [_c('p', [_vm._v(_vm._s(_vm.errors.first("lastName")))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 left-field columns"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("\n        Email\n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    class: {
      'border-red': _vm.errors.has('email')
    },
    attrs: {
      "type": "email",
      "name": "email",
      "id": "email",
      "data-vv-as": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.first('email')) ? _c('span', {
    staticClass: "form-error-area"
  }, [_c('p', [_vm._v(_vm._s(_vm.errors.first("email")))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "small-6 left-field columns"
  }, [_c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("\n        Phone\n        "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('numeric'),
      expression: "'numeric'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    class: {
      'border-red': _vm.errors.has('phone')
    },
    attrs: {
      "type": "tel",
      "name": "phone",
      "id": "phone",
      "data-vv-as": "phone"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.first('phone')) ? _c('span', {
    staticClass: "form-error-area"
  }, [_c('p', [_vm._v(_vm._s(_vm.errors.first("phone")))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "small-6 right-field columns"
  }, [_c('label', {
    attrs: {
      "for": "postcode"
    }
  }, [_vm._v("\n        Postcode\n        "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.postCode),
      expression: "postCode"
    }],
    class: {
      'border-red': _vm.errors.has('postcode')
    },
    attrs: {
      "type": "tel",
      "name": "postcode",
      "id": "postcode",
      "data-vv-as": "postcode"
    },
    domProps: {
      "value": (_vm.postCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.postCode = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.first('postcode')) ? _c('span', {
    staticClass: "form-error-area"
  }, [_c('p', [_vm._v(_vm._s(_vm.errors.first("postcode")))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "optin-area"
  }, [_c('div', [_c('span', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optIns),
      expression: "optIns"
    }],
    attrs: {
      "type": "checkbox",
      "id": "optinIntrepidTravel",
      "name": "optinIntrepidTravel",
      "value": "IntrepidTravel"
    },
    domProps: {
      "checked": Array.isArray(_vm.optIns) ? _vm._i(_vm.optIns, "IntrepidTravel") > -1 : (_vm.optIns)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.optIns,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "IntrepidTravel",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.optIns = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.optIns = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.optIns = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "optinIntrepidTravel"
    }
  }, [_vm._v("Yes! Sign me up to the Intrepid newsletter to receive exclusive\n            offers, travel inspiration & more!")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }, [_c('div', {
    staticClass: "submit-bttn bttn-lrg"
  }, [_c('input', {
    attrs: {
      "type": "button",
      "value": _vm.buttontitle
    },
    on: {
      "click": _vm.save
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "privacy-statement"
  }, [_c('p', [_vm._v("\n      By signing you accept\n      "), _c('a', {
    attrs: {
      "href": "/privacy-policy/privacy-policy",
      "target": "_blank"
    }
  }, [_vm._v("WWF-Australia’s Privacy Policy.")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.termsandconditionurl,
      "target": "_blank"
    }
  }, [_vm._v("View terms & conditions")])])])])
},staticRenderFns: []}

/***/ }),
/* 725 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "amplitude",
    attrs: {
      "id": 'amplitude-' + _vm.htmlId
    }
  })
},staticRenderFns: []}

/***/ }),
/* 726 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row wwf-form"
  }, [(!_vm.isInitialRequest) ? _c('div', [(!_vm.isInitialSubmitted) ? _c('div', [_c('div', {
    staticClass: "field",
    class: _vm.email ? 'has-content' : ''
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    class: {
      'border-red': _vm.errors.has('emailDetails')
    },
    attrs: {
      "type": "email",
      "name": "emailDetails",
      "id": "emailDetails",
      "placeholder": "Email",
      "data-vv-as": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "emailDetails"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.first('emailDetails')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first('emailDetails')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-buttons next single"
  }, [_c('input', {
    attrs: {
      "type": "button",
      "size": "sm",
      "variant": "primary",
      "value": "Submit"
    },
    on: {
      "click": _vm.updateDetails
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.isInitialSubmitted) ? _c('div', {
    staticClass: "alert-box"
  }, [_c('p', [_vm._v("Thank you, check your email and follow the instructions.")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isInitialRequest) ? _c('div', [(!_vm.isInitialSubmitted) ? _c('div', [_c('div', {
    staticClass: "text-center",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h2', [_vm._v("Update your details")])]), _vm._v(" "), _c('div', {
    staticClass: "small-collapse"
  }, [_c('div', {
    staticClass: "small-12 columns"
  }, [_c('div', {
    staticClass: "field",
    class: _vm.email ? 'has-content' : ''
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    class: {
      'border-red': _vm.errors.has('email')
    },
    attrs: {
      "disabled": "",
      "type": "email",
      "id": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.first('email')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first('email')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 medium-6 columns left-field"
  }, [_c('div', {
    staticClass: "field",
    class: _vm.title ? 'has-content' : ''
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('title')
    },
    attrs: {
      "name": "title",
      "placeholder": "Title",
      "id": "title"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.title = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("Select a title")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Mr"
    }
  }, [_vm._v("Mr")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Mrs"
    }
  }, [_vm._v("Mrs")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Ms"
    }
  }, [_vm._v("Ms")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Miss"
    }
  }, [_vm._v("Miss")])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.first('title')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first('title')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 medium-6 columns right-field"
  }, [_c('div', {
    staticClass: "field",
    class: _vm.firstname ? 'has-content' : ''
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstname),
      expression: "firstname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('firstName')
    },
    attrs: {
      "type": "text",
      "placeholder": "First name",
      "id": "firstName",
      "name": "firstName"
    },
    domProps: {
      "value": (_vm.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstname = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "firstName"
    }
  }, [_vm._v("First name")]), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.first('firstName')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first('firstName')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 medium-6 columns left-field"
  }, [_c('div', {
    staticClass: "field",
    class: _vm.lastname ? 'has-content' : ''
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastname),
      expression: "lastname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('lastName')
    },
    attrs: {
      "type": "text",
      "placeholder": "Last name",
      "id": "lastName",
      "name": "lastName"
    },
    domProps: {
      "value": (_vm.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastname = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "lastName"
    }
  }, [_vm._v("Last name")]), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.first('lastName')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first('lastName')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 medium-6 columns right-field"
  }, [_c('div', {
    staticClass: "field",
    class: _vm.phone ? 'has-content' : ''
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('phone')
    },
    attrs: {
      "type": "tel",
      "placeholder": "Phone",
      "id": "phone",
      "name": "phone"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.first('phone')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first('phone')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 medium-6 columns left-field"
  }, [_c('div', {
    staticClass: "field",
    class: _vm.address ? 'has-content' : ''
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('address')
    },
    attrs: {
      "type": "text",
      "placeholder": "Address",
      "id": "address",
      "name": "address"
    },
    domProps: {
      "value": (_vm.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Address")]), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.first('address')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first('address')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 medium-6 columns right-field"
  }, [_c('div', {
    staticClass: "field",
    class: _vm.city ? 'has-content' : ''
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.city),
      expression: "city"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'is-invalid': _vm.errors.has('city')
    },
    attrs: {
      "type": "tel",
      "placeholder": "City",
      "name": "city",
      "id": "city"
    },
    domProps: {
      "value": (_vm.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.city = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "city"
    }
  }, [_vm._v("City")]), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.first('city')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first('city')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 medium-6 columns left-field"
  }, [_c('div', {
    staticClass: "field",
    class: _vm.postcode ? 'has-content' : ''
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postcode),
      expression: "postcode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        alpha_num: true
      }),
      expression: "{ required: true, alpha_num: true }"
    }],
    class: {
      'is-invalid': _vm.errors.has('postcode')
    },
    attrs: {
      "type": "tel",
      "placeholder": "Postcode",
      "name": "postcode",
      "id": "postcode"
    },
    domProps: {
      "value": (_vm.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.postcode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "postcode"
    }
  }, [_vm._v("Postcode")]), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.first('postcode')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first('postcode')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 medium-6 columns right-field"
  }, [_c('div', {
    staticClass: "field",
    class: _vm.state ? 'has-content' : ''
  }, [_c('label', {
    attrs: {
      "for": "dateBirth"
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.state),
      expression: "state"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'is-invalid': _vm.errors.has('state')
    },
    attrs: {
      "placeholder": "Title",
      "id": "state",
      "name": "state"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("Select a state")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NSW"
    }
  }, [_vm._v("NSW")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ACT"
    }
  }, [_vm._v("ACT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NT"
    }
  }, [_vm._v("NT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SA"
    }
  }, [_vm._v("SA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "WA"
    }
  }, [_vm._v("WA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "VIC"
    }
  }, [_vm._v("VIC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "QLD"
    }
  }, [_vm._v("QLD")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TAS"
    }
  }, [_vm._v("TAS")])]), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.first('state')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first('state')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 medium-6 columns left-field end"
  }, [_c('div', {
    staticClass: "field",
    class: _vm.country ? 'has-content' : ''
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.country),
      expression: "country"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'is-invalid': _vm.errors.has('country')
    },
    attrs: {
      "type": "text",
      "placeholder": "Country",
      "name": "country",
      "id": "country"
    },
    domProps: {
      "value": (_vm.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.country = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "country"
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.first('country')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first('country')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 columns ud-row"
  }, [(_vm.hasCredidCardChanged) ? _c('div', {
    staticClass: "updated-card"
  }, [_c('div', {
    staticClass: "card-info-head"
  }, [_vm._v("New Card")]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("Card Number:")]), _vm._v(" " + _vm._s(_vm.maskedcard))]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("Card Holder Name:")]), _vm._v(" " + _vm._s(_vm.name))]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("Expiry Date:")]), _vm._v(" " + _vm._s(_vm.date))]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("Card Type:")]), _vm._v(" " + _vm._s(_vm.type))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.updateCreditCard
    }
  }, [_vm._v("Update credit card")]), _vm._v(" "), _c('div', {
    staticClass: "alert-box red updatedetails alert-box-credit"
  }, [_vm._v("\n                  You haven't saved your changes, please click 'update details' when you're finished.\n              ")])]) : _vm._e(), _vm._v(" "), (!_vm.hasCredidCardChanged) ? _c('div', [_c('a', {
    staticClass: "ud-bttn",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.updateCreditCard
    }
  }, [_vm._v("Update credit card")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "small-12 columns"
  }, [_c('div', {
    staticClass: "form-buttons next single"
  }, [_c('input', {
    attrs: {
      "type": "button",
      "size": "sm",
      "variant": "primary",
      "value": "Update details"
    },
    on: {
      "click": _vm.saveDetails
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.isInitialSubmitted) ? _c('div', {
    staticClass: "alert-box"
  }, [_c('p', [_vm._v("Thank you for updating your details.")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "reveal ty-popup ud-popup thank-you-update",
    attrs: {
      "id": "reveal-dialog-credit-card",
      "data-reveal": "",
      "data-animation-in": "fade-in",
      "data-animation-out": "fade-out"
    }
  }, [_c('div', {
    staticClass: "close"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "row small-collapse popup-content wwf-popup open"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-12 columns text-center"
  }, [_c('h2', [_vm._v("Update card details")]), _vm._v(" "), (_vm.useNewCheckout && _vm.isPopupOpen) ? _c('vue-bambora-custom-checkout', {
    attrs: {
      "submit-button-message": "Update"
    },
    on: {
      "success": _vm.processSuccess
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.useNewCheckout) ? _c('iframe', {
    attrs: {
      "height": "450px",
      "width": "400px",
      "src": _vm.iframeSrc
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _vm._m(0, false, false)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close-button",
    attrs: {
      "data-close": "",
      "aria-label": "Close modal",
      "type": "button"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}

/***/ }),
/* 727 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, _vm._l((_vm.signatures), function(s) {
    return _c('div', {
      staticClass: "signature"
    }, [_c('div', {
      staticClass: "user-icon"
    }, [(s.isDonation) ? _c('img', {
      attrs: {
        "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/ra-ls-forest.svg"
      }
    }) : _vm._e(), _vm._v(" "), (!s.isDonation) ? _c('img', {
      attrs: {
        "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/ra-ls-tree.svg"
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "user-name"
    }, [(_vm.hasName(s)) ? _c('div', {
      staticClass: "signature-name"
    }, [_vm._v("\n        " + _vm._s(_vm.limitSize(s.firstName)) + " " + _vm._s(_vm.limitSize(s.lastName)) + "\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.hasName(s)) ? _c('div', {
      staticClass: "signature-name"
    }, [_vm._v("Someone")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "signature-time"
    }, [_vm._v("\n        planted a " + _vm._s(s.isDonation ? "forest" : "tree") + "\n        " + _vm._s(s.timeDifference) + "\n      ")])])])
  }))
},staticRenderFns: []}

/***/ }),
/* 728 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "wrapper"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Want to pass on your feedback, thoughts or concerns?")]), _vm._v(" "), _c('div', {
    staticClass: "petition-form wwf-form light",
    class: {
      'hide': _vm.step2
    }
  }, [_c('div', {
    staticClass: "flip-wrapper",
    class: {
      'formValidation-shake': _vm.isShake
    }
  }, [_c('div', {
    staticClass: "petition-form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailAddress),
      expression: "emailAddress"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    class: {
      'border-red': _vm.errors.has('emailAddress')
    },
    attrs: {
      "name": "emailAddress",
      "type": "email",
      "placeholder": "Email Address"
    },
    domProps: {
      "value": (_vm.emailAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.emailAddress = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subject),
      expression: "subject"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('subject')
    },
    attrs: {
      "name": "subject",
      "type": "text",
      "placeholder": "Subject"
    },
    domProps: {
      "value": (_vm.subject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.subject = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('phone')
    },
    attrs: {
      "name": "phone",
      "type": "text",
      "placeholder": "Phone"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('message')
    },
    attrs: {
      "name": "message",
      "type": "text",
      "placeholder": "Message"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "Submit"
    },
    on: {
      "click": _vm.postTicket
    }
  })])])]), _vm._v(" "), _c('div', {
    class: {
      'hide': _vm.step1 || (_vm.step2 && _vm.serverErrors)
    }
  }, [_c('p', [_vm._v("Your message has been received by our team and we will respond as soon as possible.")])]), _vm._v(" "), _c('div', {
    class: {
      'hide': _vm.step1 || (_vm.step2 && !_vm.serverErrors)
    }
  }, [_vm._v("\n      We are sorry, an error has occurred and your request could not be submitted. Alternatively, you can contact us by email at enquiries@wwf.org.au\n      "), _c('p', {
    staticClass: "text-center hide-for-large"
  }, [_vm._v("Please tap on the orange question mark on the bottom-right of your screen")])]), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('p', {
    staticClass: "text-center hide-for-large"
  }, [_vm._v("Please tap on the orange question mark on the bottom-right of your screen")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "title"
  }, [_c('em', {
    staticClass: "far fa-life-ring"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center show-for-large"
  }, [_vm._v("\n      WWF-Australia takes all complaints and feedback seriously. For information about our Complaint Handling Process, please\n      "), _c('a', {
    staticClass: "document pdf",
    attrs: {
      "href": "/ArticleDocuments/391/doc-complaint-form-related-to-privacy-policy-13mar14.pdf.aspx?OverrideExpiry=Y",
      "target": "_blank"
    }
  }, [_vm._v("\n        click here\n        "), _c('span', {
    staticClass: "file-info"
  }, [_vm._v("\n           (\n          "), _c('span', {
    staticClass: "file-type"
  }, [_vm._v("PDF")]), _vm._v(" \n          "), _c('span', {
    staticClass: "file-size"
  }, [_vm._v("380.6KB")]), _vm._v(")\n        ")])]), _vm._v(".\n    ")])
}]}

/***/ }),
/* 729 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-header"
  }, [_c('div', {
    staticClass: "target"
  }, [_c('div', {
    staticClass: "sub-text"
  }, [_vm._v("Our target")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.targetText))])]), _vm._v(" "), _c('div', {
    staticClass: "progress-bar"
  }, [_c('div', {
    staticClass: "progress-bar-wrapper"
  }, [_c('div', {
    staticClass: "progress-bar-inner",
    style: ({
      width: 100 - _vm.percent + '%'
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "edo-tree-icon",
    style: ({
      left: 'calc(' + _vm.percent + '% - (' + _vm.percent / 100 + '* 64px))',
    })
  }, [_c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/LR - Progress bar icon.svg"
    }
  })])]), _vm._v(" "), _c('h2', {
    staticClass: "counter"
  }, [_vm._v("\n    " + _vm._s(Math.ceil(_vm.currentCounter)) + "\n  ")]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.headerText))])])
},staticRenderFns: []}

/***/ }),
/* 730 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    style: ({
      color: _vm.titleColor
    })
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "sub-text"
  }, [_c('p', {
    style: ({
      color: _vm.textColor
    })
  }, [_vm._v(_vm._s(_vm.replacedText))])])])
},staticRenderFns: []}

/***/ }),
/* 731 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row expanded small-collapse img-txt-pnls"
  }, [_c('div', {
    staticClass: "small-12 large-6 columns img video"
  }, [_c('a', {
    on: {
      "click": _vm.play
    }
  }, [_c('span', [_c('span', {
    staticClass: "vd-aspct",
    style: ({
      backgroundImage: "url(" + _vm.img + ")"
    })
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 large-6 columns txt"
  }, [_c('div', {
    staticClass: "pddxy-50"
  }, [_c('h3', [_vm._v("In video:")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("truncate")(_vm.description, 150, '...')))]), _vm._v(" "), _c('p', [_vm._v(" ")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "bttn-lrg",
    attrs: {
      "href": "#/"
    },
    on: {
      "click": _vm.play
    }
  }, [_vm._v("Watch video")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "reveal large",
    attrs: {
      "id": "modal-ytvideo",
      "data-reveal": ""
    }
  }, [_c('div', {
    staticClass: "responsive-embed widescreen"
  }, [_c('youtube', {
    attrs: {
      "video-id": _vm.videoId
    },
    on: {
      "ready": _vm.ready,
      "ended": _vm.ended
    }
  })], 1), _vm._v(" "), _vm._m(0, false, false)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close-button",
    attrs: {
      "data-close": "",
      "aria-label": "Close modal",
      "type": "button"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}

/***/ }),
/* 732 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edo-popup"
  }, [(_vm.layout === 'edo') ? _c('div', {
    staticClass: "edo-layout"
  }, [_vm._m(0, false, false), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "edo-content"
  }, [_c('h3', [_vm._v("Thanks for protecting the Unburnt Six!")]), _vm._v(" "), _c('p', [_vm._v("\n        Defending these precious habitats is crucial in the fight against\n        extinction. Your voice is vital to ensuring they are protected.\n      ")]), _vm._v(" "), _c('h4', [_vm._v("Take the next step with EDO")]), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.edoDonateUrl
    }
  }, [_vm._v("Donate to EDO")])]), _vm._v(" "), _vm._m(3, false, false)]) : _vm._e(), _vm._v(" "), (_vm.layout === 'wwf') ? _c('div', [_vm._m(4, false, false), _vm._v(" "), _vm._m(5, false, false)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close-button",
    attrs: {
      "data-close": "",
      "aria-label": "Close modal",
      "type": "button"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edo-header-img"
  }, [_c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/edo-popup-header.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n        Environmental Defenders Office is at the forefront of the legal battle\n        to protect our wildlife, climate and communities.\n        "), _c('span', [_vm._v("But winning this fight depends on people like you.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "edo-close popup-close-button",
    attrs: {
      "data-close": "",
      "type": "button"
    }
  }, [_c('span', {
    staticClass: "popup-close-button-span"
  }, [_vm._v("Close")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup-header"
  }, [_c('div', {
    staticClass: "popup-header-logo"
  }, [_c('img', {
    staticClass: "popup-logo",
    attrs: {
      "src": "https://www.wwf.org.au/ecThemes/3/Images/wwf-logo.svg"
    }
  })]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "popup-close-button",
    attrs: {
      "data-close": "",
      "type": "button"
    }
  }, [_c('span', {
    staticClass: "popup-close-button-span"
  }, [_vm._v("Close")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wwf-content"
  }, [_c('h3', [_vm._v("Thank you. Every signature speaks volumes.")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": "/images/UserUploadedImages/403/img-koalas-thumbnail.jpg"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Want to make a bigger impact?")]), _vm._v("Australia has the worst mammal extinction rate of any country in the\n          world, and with last year’s bushfires having pushed so many more\n          species to the brink of extinction, our wildlife urgently needs your\n          help, now more than ever.\n          "), _c('br'), _vm._v(" "), _c('br'), _vm._v("Your generosity today will help those remaining survive by\n          protecting their forest homes.\n          "), _c('br'), _vm._v("Thank you.\n          "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "bttn-mdm-arrw",
    attrs: {
      "href": "http://donate.wwf.org.au/donate/one-off-donation/defending-the-unburnt-six"
    }
  }, [_vm._v("DONATE TODAY")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Take part in the #DefendTheUnburnt video!")]), _vm._v("Make your voice heard. Help us amplify our collective voice and be\n          part of a WWF video to defend the Unburnt Six.\n          "), _c('a', {
    attrs: {
      "href": "https://www.wwf.org.au/what-we-do/2-billion-trees/defending-the-unburnt-six/submit-video/submit-video"
    }
  }, [_vm._v("Click here to upload your video")])])])])
}]}

/***/ }),
/* 733 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, _vm._l((_vm.signatures), function(s) {
    return _c('div', {
      staticClass: "signature"
    }, [_c('div', {
      staticClass: "user-icon"
    }, [_c('img', {
      attrs: {
        "src": _vm.iconSource
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "user-name"
    }, [_c('div', {
      staticClass: "signature-name"
    }, [_vm._v(_vm._s(s.firstName) + " " + _vm._s(s.lastName))]), _vm._v(" "), _c('div', {
      staticClass: "signature-time"
    }, [_vm._v(_vm._s(_vm.action) + " " + _vm._s(s.timeDifference))])])])
  }))
},staticRenderFns: []}

/***/ }),
/* 734 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "donation-wildcard-recipient"
  }, [_c('h2', [_vm._v("Personalise")]), _vm._v(" "), _c('div', {
    staticClass: "wildcard"
  }, [_c('div', {
    staticClass: "card",
    style: ('background-image: url(' + _vm.donation.wildcard.img + ')')
  })]), _vm._v(" "), _c('div', {
    staticClass: "wwf-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.wildcard.dear),
      expression: "donation.wildcard.dear"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      error: _vm.errors.has('dear'), empty: !_vm.donation.wildcard.dear
    },
    attrs: {
      "name": "dear",
      "type": "text",
      "autocomplete": "given-name"
    },
    domProps: {
      "value": (_vm.donation.wildcard.dear)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation.wildcard, "dear", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "dear"
    }
  }, [_vm._v("Dear")])]), _vm._v(" "), _c('div', {
    staticClass: "wwf-field"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.wildcard.message),
      expression: "donation.wildcard.message"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      error: _vm.errors.has('message'),
        empty: !_vm.donation.wildcard.message,
    },
    attrs: {
      "name": "message",
      "type": "text"
    },
    domProps: {
      "value": (_vm.donation.wildcard.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation.wildcard, "message", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "message"
    }
  }, [_vm._v("Your personal message")])]), _vm._v(" "), _c('h2', [_vm._v("Recipient details")]), _vm._v(" "), _c('div', {
    staticClass: "wwf-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.wildcard.email),
      expression: "donation.wildcard.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    class: {
      error: _vm.errors.has('recepientsemail'),
        empty: !_vm.donation.wildcard.email,
    },
    attrs: {
      "id": "recepientsemail",
      "name": "recepientsemail",
      "type": "email",
      "autocomplete": "email"
    },
    domProps: {
      "value": (_vm.donation.wildcard.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation.wildcard, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "recepientsemail"
    }
  }, [_vm._v("Recipients email")])]), _vm._v(" "), _c('div', {
    staticClass: "date-field"
  }, [_c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "disabledDates": _vm.disabledFn,
      "name": "scheduledate",
      "minimumView": 'day',
      "format": 'dd/MM/yyyy',
      "input-class": {
        'border-red': _vm.errors.has('scheduledate')
      },
      "maximumView": 'month',
      "initialView": 'day',
      "placeholder": "Date to send"
    },
    model: {
      value: (_vm.donation.wildcard.scheduledate),
      callback: function($$v) {
        _vm.$set(_vm.donation.wildcard, "scheduledate", $$v)
      },
      expression: "donation.wildcard.scheduledate"
    }
  }), _vm._v(" "), _vm._m(0, false, false)], 1), _vm._v(" "), _c('button', {
    staticClass: "plain",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.next()
      }
    }
  }, [_c('span', [_vm._v("Next")]), _vm._v(" "), _vm._m(1, false, false)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "scheduledate"
    }
  }, [_c('i', {
    staticClass: "far fa-calendar-alt"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fas fa-arrow-right"
  })])
}]}

/***/ }),
/* 735 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "donate-layout"
  }, [_c('div', {
    staticClass: "earth-hour-header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.text))])]), _vm._v(" "), _c('div', {
    staticClass: "sign-img",
    style: ({
      'background-image': 'url(\'' + _vm.imageUrl + '\')',
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.donate()
      }
    }
  }, [_vm._v(_vm._s(_vm.buttonLabel))])])])])
},staticRenderFns: []}

/***/ }),
/* 736 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wwf-form wwf-form-product",
    class: [{
      'formValidation-shake': _vm.isShake
    }, _vm.className]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.donation.isLoading),
      expression: "donation.isLoading"
    }],
    staticClass: "wwf-loading-container"
  }, [_vm._m(0, false, false)]), _vm._v(" "), _c('form-wizard', {
    ref: "wizard",
    attrs: {
      "shape": "tab",
      "start-index": _vm.stepIndex
    },
    on: {
      "on-loading": _vm.setLoading,
      "update:startIndex": function($event) {
        _vm.stepIndex = $event
      },
      "on-change": _vm.setFormStepState
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function(props) {
        return [_c('div', {
          staticClass: "form-buttons prev"
        }, [_c('a', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (props.activeTabIndex == 1),
            expression: "props.activeTabIndex == 1"
          }],
          style: (props.fillButtonStyle),
          attrs: {
            "href": "#form-top",
            "id": "Previous",
            "data-animation-duration": "300",
            "data-animation-easing": "swing",
            "data-smooth-scroll": "",
            "data-threshold": "75"
          },
          on: {
            "click": function($event) {
              props.prevTab()
            }
          }
        }, [_vm._v("Previous")])]), _vm._v(" "), _c('div', {
          staticClass: "form-buttons next"
        }, [_c('a', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (props.activeTabIndex != 2),
            expression: "props.activeTabIndex != 2"
          }],
          class: props.activeTabIndex != 0 && _vm.donation.payementType == 'wwf_paypal' ?
            'paypal-button' :
            '',
          style: (props.fillButtonStyle),
          attrs: {
            "href": "#form-top",
            "id": "Next",
            "data-animation-duration": "300",
            "data-animation-easing": "swing",
            "data-smooth-scroll": "",
            "data-threshold": "75"
          },
          on: {
            "click": function($event) {
              props.nextTab()
            }
          }
        }, [_vm._v(_vm._s(props.activeTabIndex == 0 ?
          "Next" :
          _vm.donation.payementType == "wwf_paypal" ?
          "Pay with PayPal" :
          "Go to payment"))])])]
      }
    }])
  }, [_c('h2', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }), _vm._v(" "), _c('tab-content', {
    attrs: {
      "title": "Choose",
      "before-change": function () { return _vm.validateStep('step1'); }
    }
  }, [_c('Step1', {
    ref: "step1",
    attrs: {
      "useNewCheckout": _vm.useNewCheckout
    }
  })], 1), _vm._v(" "), _c('tab-content', {
    attrs: {
      "title": "Details",
      "before-change": function () { return _vm.validateStep('step2'); }
    }
  }, [_c('Step2', {
    ref: "step2",
    attrs: {
      "disabledGoogleAutocomplete": _vm.disabledGoogleAutocomplete,
      "thankYouUrl": _vm.thankYouUrl,
      "useNewCheckout": _vm.useNewCheckout,
      "isEarthHour": _vm.isEarthHour
    }
  })], 1), _vm._v(" "), _c('tab-content', {
    attrs: {
      "title": "Payment"
    }
  }, [_c('Step3', {
    attrs: {
      "thankYouUrl": _vm.thankYouUrl,
      "useNewCheckout": _vm.useNewCheckout,
      "useProductThankYouUrl": _vm.useProductThankYouUrl
    }
  })], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wwf-loading"
  }, [_c('span')])
}]}

/***/ }),
/* 737 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showHeader) ? _c('div', {
    staticClass: "petition-counter"
  }, [_c('div', {
    staticClass: "edo-progress-bar"
  }, [_c('div', {
    staticClass: "progress-bar-wrapper"
  }, [_c('div', {
    staticClass: "progress-bar-inner",
    style: ({
      width: 100 - _vm.progress + '%'
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "edo-tree-icon",
    style: ({
      left: 'calc(' + _vm.progress + '% - 32px)'
    })
  }, [_c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/edo-tree-icon.svg"
    }
  })])]), _vm._v(" "), (_vm.showCounter) ? _c('h2', [_c('count-to', {
    ref: "counter",
    attrs: {
      "startVal": _vm.startcounter,
      "end-val": _vm.currentCounter,
      "autoplay": false,
      "duration": 7000
    },
    on: {
      "callbackCounter": _vm.updatePercentage
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.counterTitle))])]) : _vm._e(), _vm._v(" "), (_vm.isActive) ? _c('div', {
    staticClass: "petition-form wwf-form light"
  }, [_c('div', {
    staticClass: "flip-wrapper",
    class: {
      'formValidation-shake': _vm.isShake
    }
  }, [_c('div', {
    staticClass: "petition-form"
  }, [(_vm.intro) ? _c('p', {
    staticClass: "form-intro"
  }, [_vm._v("\n          " + _vm._s(_vm.intro) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true }"
    }],
    class: {
      'border-red': _vm.errors.has('firstName')
    },
    attrs: {
      "name": "firstName",
      "type": "text",
      "placeholder": "First name",
      "autocomplete": "given-name"
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('first name')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true }"
    }],
    class: {
      'border-red': _vm.errors.has('lastName')
    },
    attrs: {
      "name": "lastName",
      "type": "text",
      "placeholder": "Last name",
      "autocomplete": "family-name"
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('last name')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "with-input-loading"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        edoEmailIsValid: true,
        email: true,
      }),
      expression: "{\n                required: true,\n                edoEmailIsValid: true,\n                email: true,\n              }"
    }],
    class: {
      'border-red': _vm.errors.has('email')
    },
    attrs: {
      "name": "email",
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }, function($event) {
        _vm.onEmailInput()
      }],
      "focus": function($event) {
        _vm.logFirstTouch('email')
      }
    }
  }), _vm._v(" "), (_vm.emailCheckSensis.checkEmailLoading) ? _c('div', {
    staticClass: "input-loading"
  }, [_c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/loading-tail-spin.svg"
    }
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.has('email')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first("email")))]) : _vm._e()])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lead.postcode),
      expression: "lead.postcode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true }"
    }],
    class: {
      'border-red': _vm.errors.has('postcode')
    },
    attrs: {
      "name": "postcode",
      "type": "number",
      "placeholder": "Postcode"
    },
    domProps: {
      "value": (_vm.lead.postcode)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('postcode')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.lead, "postcode", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phoneNumber),
      expression: "phoneNumber"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        edoPhoneNumberIsValid: true
      }),
      expression: "{ required: true, edoPhoneNumberIsValid: true }"
    }],
    class: {
      'border-red': _vm.errors.has('phoneNumber')
    },
    attrs: {
      "name": "phoneNumber",
      "type": "tel",
      "placeholder": "Phone Number"
    },
    domProps: {
      "value": (_vm.phoneNumber)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('phone')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phoneNumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lead.message),
      expression: "lead.message"
    }],
    class: {
      'border-red': _vm.errors.has('message')
    },
    attrs: {
      "name": "message",
      "placeholder": "Your message. Writing a personalised message makes it harder for our politicians to ignore",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.lead.message)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('message')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.lead, "message", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "word-count"
  }, [_vm._v("\n            " + _vm._s(255 - (_vm.lead.message ? _vm.lead.message.length : 0) + " Char") + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "input-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.acceptToUseMessage),
      expression: "acceptToUseMessage"
    }],
    attrs: {
      "id": "useMessage",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.acceptToUseMessage) ? _vm._i(_vm.acceptToUseMessage, null) > -1 : (_vm.acceptToUseMessage)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.acceptToUseMessage,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.acceptToUseMessage = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.acceptToUseMessage = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.acceptToUseMessage = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "useMessage"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.concentUseMessage) + "\n            ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn-submit",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving
    },
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [(_vm.isSaving) ? _c('span', [_vm._v("Loading...")]) : _vm._e(), _vm._v(" "), (!_vm.isSaving) ? _c('span', [_vm._v(_vm._s(_vm.submitButtonText))]) : _vm._e()]), _vm._v(" "), _c('input', {
    staticClass: "read-letter",
    attrs: {
      "type": "button",
      "value": _vm.viewLetterText
    },
    on: {
      "click": _vm.openReadLetterPage
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "signatures-title"
  }, [_vm._v("Recent defenders")]), _vm._v(" "), _c('last-signatures', {
    attrs: {
      "campaigId": "edo",
      "numberOfSignatures": _vm.numberOfSignatures,
      "iconSource": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/edo-signature-icon.png",
      "classes": "edo-signatures",
      "action": "became a defender"
    }
  })], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "privacy-statement"
  }, [(!_vm.isFromEDO) ? _c('p', [_vm._v("\n              By signing you accept\n              "), _c('a', {
    attrs: {
      "href": "/privacy-policy/privacy-policy",
      "target": "_blank"
    }
  }, [_vm._v("\n                WWF-Australia’s Privacy Policy.\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.isFromEDO) ? _c('p', [_vm._v("\n              By signing up to Defend the Unburnt Six you accept WWF’s project\n              partner EDO’s\n              "), _c('a', {
    attrs: {
      "href": "https://www.edo.org.au/privacy-policy/",
      "target": "_blank"
    }
  }, [_vm._v("\n                privacy policy\n              ")])]) : _vm._e()])])])])]) : _vm._e(), _vm._v(" "), (!_vm.isActive) ? _c('div', {
    staticClass: "form-closed"
  }, [_c('p', [_vm._v(_vm._s(_vm.closingmessage))])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 738 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "donate-stepup-popup"
  }, [_c('div', [_c('div', {
    staticClass: "popup-header"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "popup-close-button",
    attrs: {
      "data-close": "",
      "type": "button"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_c('span', {
    staticClass: "popup-close-button-span"
  }, [_vm._v("Close")])])])]), _vm._v(" "), _c('div', {
    ref: "stepup",
    staticClass: "donate-stepup-content"
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('h3', {
    staticClass: "donate-stepup-title"
  }, [(_vm.thankyouText) ? _c('span', [_vm._v(_vm._s(_vm.thankyouText))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "cms-stepup-content",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup-header-logo"
  }, [_c('img', {
    staticClass: "popup-logo",
    attrs: {
      "src": "https://www.wwf.org.au/ecThemes/3/Images/WWF-RA-lockup-logo.svg"
    }
  })])
}]}

/***/ }),
/* 739 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wwf-form light"
  }, [_c('h3', [_vm._v("Get in touch")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true }"
    }],
    class: {
      'border-red': _vm.errors.has('firstName')
    },
    attrs: {
      "name": "firstName",
      "type": "text",
      "placeholder": "First name",
      "autocomplete": "given-name"
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true }"
    }],
    class: {
      'border-red': _vm.errors.has('lastName')
    },
    attrs: {
      "name": "lastName",
      "type": "text",
      "placeholder": "Last name",
      "autocomplete": "family-name"
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "small-12 medium-12 with-input-loading"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        email: true,
        bequestCheckEmail: true
      }),
      expression: "{ required: true, email: true, bequestCheckEmail: true }"
    }],
    class: {
      'border-red': _vm.errors.has('email') || _vm.errors.has('bequestCheckEmail'),
    },
    attrs: {
      "name": "email",
      "type": "email",
      "placeholder": "Email",
      "autocomplete": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.checkEmailLoading) ? _c('div', {
    staticClass: "input-loading"
  }, [_c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/loading-tail-spin.svg"
    }
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.firstByRule('email', 'bequestCheckEmail')) ? _c('p', [_vm._v("\n        " + _vm._s(_vm.errors.first("email")) + "\n      ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 medium-12 with-input-loading"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        bequestCheckPhone: true
      }),
      expression: "{ required: true, bequestCheckPhone: true }"
    }],
    class: {
      'border-red': _vm.errors.has('phone') || _vm.errors.has('bequestCheckPhone'),
    },
    attrs: {
      "name": "phone",
      "type": "tel",
      "placeholder": "Phone",
      "autocomplete": "phone"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.phoneCheck.checkPhoneLoading) ? _c('div', {
    staticClass: "input-loading"
  }, [_c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/loading-tail-spin.svg"
    }
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.firstByRule('phone', 'bequestCheckPhone')) ? _c('p', [_vm._v("\n        " + _vm._s(_vm.errors.first("phone")) + "\n      ")]) : _vm._e()])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postcode),
      expression: "postcode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        alpha_num: true
      }),
      expression: "{ required: true, alpha_num: true }"
    }],
    class: {
      'border-red': _vm.errors.has('postcode')
    },
    attrs: {
      "name": "postcode",
      "type": "text",
      "placeholder": "Postcode",
      "autocomplete": "postal-code"
    },
    domProps: {
      "value": (_vm.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.postcode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }],
    attrs: {
      "name": "address",
      "type": "text",
      "placeholder": "Postal address (optional)"
    },
    domProps: {
      "value": (_vm.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address = $event.target.value
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enquiryType),
      expression: "enquiryType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true }"
    }],
    class: {
      'border-red': _vm.errors.has('enquiryType')
    },
    attrs: {
      "name": "enquiryType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.enquiryType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.enquiryLabel))]), _vm._v(" "), _vm._l((_vm.enquiryOptions), function(option, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": option
      }
    }, [_vm._v("\n      " + _vm._s(option) + "\n    ")])
  })], 2), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comments),
      expression: "comments"
    }],
    attrs: {
      "name": "comments",
      "placeholder": "Additional comments (optional)"
    },
    domProps: {
      "value": (_vm.comments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comments = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), _c('input', {
    staticClass: "btn-submit",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving,
      "value": _vm.isSaving ? 'Loading...' : 'Submit'
    },
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }), _vm._v(" "), _vm._m(3, false, false)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "p-presentation"
  }, [_vm._v("\n    Complete the form to get in touch with Carrie, or contact her directly on\n    "), _c('a', {
    attrs: {
      "href": "tel:0862310239"
    }
  }, [_vm._v("08 6231 0239")]), _vm._v(",\n    "), _c('a', {
    attrs: {
      "href": "mailto:giftsinwills@wwf.org.au"
    }
  }, [_vm._v("giftsinwills@wwf.org.au")]), _vm._v(".\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "p-presentation"
  }, [_c('span', {
    staticClass: "details-statement"
  }, [_vm._v("\n      Your details will be treated with the strictest confidence and without\n      any obligation\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "privacy-statement"
  }, [_c('p', [_vm._v("\n      Any information shared is protected by our\n      "), _c('a', {
    attrs: {
      "href": "/privacy-policy",
      "target": "_blank"
    }
  }, [_vm._v(" Privacy Policy. ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('ul', [_c('li', {
    attrs: {
      "id": "round-thumb"
    }
  }, [_c('img', {
    staticStyle: {
      "border-radius": "50%",
      "max-width": "65%"
    },
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/img-carrie-alexander-thumb.jpg",
      "alt": "Carrie Alexander profile photo © WWF-Aus"
    }
  }), _vm._v(" "), _c('div', [_vm._v("Your contact, Carrie Alexander")]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "tel:0862310239"
    }
  }, [_vm._v("08 6231 0239")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:giftsinwills@wwf.org.au"
    }
  }, [_vm._v("giftsinwills@wwf.org.au")])])])])])
}]}

/***/ }),
/* 740 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result-list"
  }, [_c('div', {
    staticClass: "cards",
    style: (_vm.gridConfig)
  }, _vm._l((_vm.shownFilteredProducts), function(product) {
    return _c('EcommerceFilterCard', {
      key: product.id,
      attrs: {
        "product": product
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "cards-mobile"
  }, _vm._l((_vm.shownFilteredProducts), function(product) {
    return _c('EcommerceFilterCard', {
      key: product.id,
      attrs: {
        "product": product
      }
    })
  })), _vm._v(" "), (_vm.shownFilteredProducts.length < _vm.filteredProducts.length && !_vm.isSeeingAll) ? _c('div', {
    staticClass: "see-all",
    on: {
      "click": function($event) {
        _vm.$store.dispatch('updateIsSeeingAll', true)
      }
    }
  }, [_vm._v("\n    See All\n  ")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 741 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "Step3"
    }
  }, [_c('div', {
    staticClass: "small-12 columns payment-summary"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Payment summary")]), _vm._v(" "), (_vm.packages.length > 1) ? _c('div', {
    staticClass: "summary-pack"
  }, [(
    this.packages.find(function (x) { return x.code == _vm.donation.packagecode; }) != null &&
    _vm.packages.find(function (x) { return x.code == _vm.donation.packagecode; }).pack != null
  ) ? _c('div', {
    staticClass: "pack",
    style: ('background-image:url(' +
      _vm.packages.find(function (x) { return x.code == _vm.donation.packagecode; }).pack.image +
      ')')
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.packages.length > 1) ? _c('div', {
    staticClass: "summary-pack",
    class: _vm.packages.find(function (x) { return x.code == _vm.donation.packagecode; }) != null &&
      _vm.packages.find(function (x) { return x.code == _vm.donation.packagecode; }).toy != null ?
      'has-toy' :
      ''
  }, [_c('div', {
    staticClass: "toy",
    style: (_vm.packages.find(function (x) { return x.code == _vm.donation.packagecode; }) != null &&
      _vm.packages.find(function (x) { return x.code == _vm.donation.packagecode; }).toy != null ?
      'background-image:url(' +
      _vm.packages.find(function (x) { return x.code == _vm.donation.packagecode; }).toy.image +
      ')' :
      '')
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "items"
  }, [_c('p', {
    staticClass: "product"
  }, [_vm._v(_vm._s(_vm.donation.productname))]), _vm._v(" "), _c('p', {
    staticClass: "amount"
  }, [_vm._v("$" + _vm._s(_vm.donation.amount))]), _vm._v(" "), _c('p', {
    staticClass: "frequency"
  }, [(_vm.donation.type === 'Regular') ? [_vm._v("Monthly")] : (_vm.donation.type === 'Single') ? [_vm._v("One-off")] : (_vm.donation.type === 'Annual') ? [_vm._v("Annually")] : _vm._e()], 2)])]), _vm._v(" "), _c('h2', [_vm._v("Enter payment details")]), _vm._v(" "), (_vm.useNewCheckout) ? _c('div', [_vm._m(0, false, false), _vm._v(" "), _c(_vm.paymentform, {
    ref: "checkout",
    tag: "component",
    on: {
      "success": _vm.processSuccess,
      "retry": _vm.retryPayment
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.useNewCheckout) ? _c('div', [_c('div', {
    staticClass: "iframe-loader"
  }, [(_vm.donation.url) ? _c('iframe', {
    ref: "frame",
    attrs: {
      "frameborder": "0",
      "scrolling": "no",
      "src": _vm.donation.url
    },
    on: {
      "load": _vm.load
    }
  }) : _vm._e()])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "secure"
  }, [_c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/secure-icon.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v("Secure")]), _vm._v(" "), _c('p', [_vm._v("payment")])])])
}]}

/***/ }),
/* 742 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.product) ? _c('div', {
    staticClass: "small-collapse",
    attrs: {
      "id": "Step2"
    }
  }, [(_vm.product.producttype == 'adoption') ? _c('div', {
    staticClass: "wwf-checkbox"
  }, [_c('label', [_vm._v("\n      Make this a gift for someone\n      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.isGift),
      expression: "donation.isGift"
    }],
    attrs: {
      "type": "checkbox",
      "id": "isGift-step-2",
      "name": "isGift"
    },
    domProps: {
      "checked": Array.isArray(_vm.donation.isGift) ? _vm._i(_vm.donation.isGift, null) > -1 : (_vm.donation.isGift)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.donation.isGift,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.donation.isGift = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.donation.isGift = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.donation, "isGift", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkbox"
  })])]) : _vm._e(), _vm._v(" "), (_vm.product.producttype == 'wildcard') ? _c('div', {
    staticClass: "small-collapse small-12 columns"
  }, [_c('h2', [_vm._v("Who is this for?")]), _vm._v(" "), _c('div', {
    staticClass: "small-12 columns"
  }, [_c('div', {
    staticClass: "wilcards--selected"
  }, [_c('img', {
    staticClass: "tooltipstered",
    attrs: {
      "src": _vm.product.packages.find(function (x) { return x.code == _vm.donation.packagecode; }) ? _vm.product.packages.find(function (x) { return x.code == _vm.donation.packagecode; }).img : null
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 columns"
  }, [_c('div', {
    staticClass: "field",
    class: _vm.donation.wildcard.dear ? 'has-content' : ''
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.wildcard.dear),
      expression: "donation.wildcard.dear"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('dear')
    },
    attrs: {
      "name": "dear",
      "type": "text",
      "placeholder": "Enter the name"
    },
    domProps: {
      "value": (_vm.donation.wildcard.dear)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation.wildcard, "dear", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "dear"
    }
  }, [_vm._v("Dear " + _vm._s(_vm.errors.first('dear') ? 'required' : ''))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 columns"
  }, [_c('div', {
    staticClass: "field",
    class: _vm.donation.wildcard.message ? 'has-content' : ''
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.wildcard.message),
      expression: "donation.wildcard.message"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('message')
    },
    attrs: {
      "name": "message",
      "type": "text",
      "placeholder": "Enter the message"
    },
    domProps: {
      "value": (_vm.donation.wildcard.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation.wildcard, "message", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "message"
    }
  }, [_vm._v("Your personal message " + _vm._s(_vm.errors.first('message') ? 'required' : ''))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 columns"
  }, [_c('div', {
    staticClass: "field",
    class: _vm.donation.wildcard.email ? 'has-content' : ''
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.wildcard.email),
      expression: "donation.wildcard.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    class: {
      'border-red': _vm.errors.has('recepientsemail')
    },
    attrs: {
      "type": "email",
      "name": "recepientsemail",
      "id": "recepientsemail",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.donation.wildcard.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation.wildcard, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "recepientsemail"
    }
  }, [_vm._v("Recipients email " + _vm._s(_vm.errors.firstByRule('recepientsemail', 'required') ? 'required' : '') + " " + _vm._s(_vm.errors.firstByRule('recepientsemail', 'email') ? 'invalid' : ''))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 columns"
  }, [_c('h2', [_vm._v("When do you want it sent?")]), _vm._v(" "), _c('div', {
    staticClass: "field",
    class: _vm.donation.wildcard.scheduledate ? 'has-content' : ''
  }, [_c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "disabledDates": _vm.disabledFn,
      "name": "scheduledate",
      "minimumView": 'day',
      "format": 'dd/MM/yyyy',
      "input-class": {
        'border-red': _vm.errors.has('scheduledate')
      },
      "maximumView": 'month',
      "initialView": 'day',
      "placeholder": "Enter your date"
    },
    model: {
      value: (_vm.donation.wildcard.scheduledate),
      callback: function($$v) {
        _vm.$set(_vm.donation.wildcard, "scheduledate", $$v)
      },
      expression: "donation.wildcard.scheduledate"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "scheduledate"
    }
  }, [_vm._v("\n          Choose a date " + _vm._s(_vm.errors.first('scheduledate') ? 'required' : '') + "\n          "), _c('i', {
    staticClass: "far fa-calendar-alt"
  })])], 1)])]) : _vm._e(), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "wwf-checkbox"
  }, [_c('label', [_vm._v("\n      This donation is on behalf of a business\n      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.isBehalfBusiness),
      expression: "donation.isBehalfBusiness"
    }],
    attrs: {
      "type": "checkbox",
      "id": "isBehalfBusiness",
      "name": "isBehalfBusiness"
    },
    domProps: {
      "checked": Array.isArray(_vm.donation.isBehalfBusiness) ? _vm._i(_vm.donation.isBehalfBusiness, null) > -1 : (_vm.donation.isBehalfBusiness)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.donation.isBehalfBusiness,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.donation.isBehalfBusiness = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.donation.isBehalfBusiness = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.donation, "isBehalfBusiness", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkbox"
  })])]), _vm._v(" "), (_vm.donation.isBehalfBusiness) ? _c('div', {
    staticClass: "small-collapse small-12 columns field-businessname"
  }, [_c('div', {
    staticClass: "small-12 columns"
  }, [_c('div', {
    staticClass: "field",
    class: _vm.donation.bussiness.name ? 'has-content' : ''
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.bussiness.name),
      expression: "donation.bussiness.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('businessName')
    },
    attrs: {
      "name": "businessName",
      "type": "text",
      "placeholder": "Enter your business name",
      "autocomplete": "organization"
    },
    domProps: {
      "value": (_vm.donation.bussiness.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation.bussiness, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "businessName"
    }
  }, [_vm._v("Business name " + _vm._s(_vm.errors.first('businessName') ? 'required' : ''))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-6 medium-3 columns left-field field-title"
  }, [_c('div', {
    staticClass: "field",
    class: _vm.donation.title ? 'has-content' : ''
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.title),
      expression: "donation.title"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('title')
    },
    attrs: {
      "name": "title",
      "placeholder": "Title",
      "autocomplete": "honorific-prefix"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.donation, "title", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("Select a title")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Dr"
    }
  }, [_vm._v("Dr")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Miss"
    }
  }, [_vm._v("Miss")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Mr"
    }
  }, [_vm._v("Mr")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Mrs"
    }
  }, [_vm._v("Mrs")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Ms"
    }
  }, [_vm._v("Ms")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Mx"
    }
  }, [_vm._v("Mx")])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title")])])]), _vm._v(" "), _c('div', {
    staticClass: "title-required"
  }, [_vm._v(_vm._s(_vm.errors.first('title') ? 'Title required' : ''))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-12 medium-6 columns left-field field-firstname"
  }, [_c('div', {
    staticClass: "field",
    class: _vm.donation.firstname ? 'has-content' : ''
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.firstname),
      expression: "donation.firstname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('firstname')
    },
    attrs: {
      "name": "firstname",
      "type": "text",
      "placeholder": "Enter your first name",
      "autocomplete": "given-name"
    },
    domProps: {
      "value": (_vm.donation.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation, "firstname", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "firstname"
    }
  }, [_vm._v("First name " + _vm._s(_vm.errors.first('firstname') ? 'required' : ''))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 medium-6 right-field columns field-lastname"
  }, [_c('div', {
    staticClass: "field",
    class: _vm.donation.lastname ? 'has-content' : ''
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.lastname),
      expression: "donation.lastname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('lastname')
    },
    attrs: {
      "name": "lastname",
      "type": "text",
      "placeholder": "Enter your last name",
      "autocomplete": "family-name"
    },
    domProps: {
      "value": (_vm.donation.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation, "lastname", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "lastname"
    }
  }, [_vm._v("Last name " + _vm._s(_vm.errors.first('lastname') ? 'required' : ''))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-6 medium-6 left-field columns"
  }, [_c('div', {
    staticClass: "field",
    class: _vm.donation.billing.country ? 'has-content' : ''
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.billing.country),
      expression: "donation.billing.country"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('country')
    },
    attrs: {
      "name": "country",
      "autocomplete": "country"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.donation.billing, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.countryChanged]
    }
  }, _vm._l((_vm.countriesList), function(countries, index) {
    return _c('option', {
      domProps: {
        "value": countries.name
      }
    }, [_vm._v(_vm._s(countries.name))])
  })), _vm._v(" "), _c('label', {
    attrs: {
      "for": "country"
    }
  }, [_vm._v("Country " + _vm._s(_vm.errors.first('country') ? 'required' : ''))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.donation.billing.country != 'Australia' && _vm.product.producttype == 'adoption'),
      expression: "donation.billing.country != 'Australia' && product.producttype == 'adoption'"
    }],
    staticClass: "small-12 columns alert"
  }, [_c('p', [_vm._v("We're sorry, gifts and toy products can only be delivered within Australia.")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(!_vm.showFullAddress && !_vm.disabledGoogleAutocomplete && _vm.showAddressSuggestions) ? _c('div', {
    staticClass: "small-12 columns field-address"
  }, [_c('div', {
    staticClass: "field has-content"
  }, [_c('form', {
    attrs: {
      "autocomplete": "off",
      "onkeydown": "return event.key != 'Enter';"
    }
  }, [_c('sensis-autocomplete', {
    staticClass: "form-control",
    attrs: {
      "id": _vm.dynamicId,
      "classname": _vm.errors.has(_vm.dynamicId) ? 'border-red' : ''
    },
    on: {
      "addressSelected": _vm.sensisSelectedAddress
    }
  })], 1), _vm._v(" "), _c('label', {
    attrs: {
      "for": _vm.dynamicId
    }
  }, [_vm._v("Enter your address")]), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert-address"
  }, [(_vm.errors.first(_vm.dynamicId)) ? _c('p', [_vm._v("\n            We cannot find your address.\n            "), _c('a', {
    on: {
      "click": function($event) {
        _vm.showFullAddress = true
      }
    }
  }, [_vm._v("Please click here to enter your address manually.")])]) : _vm._e(), _vm._v(" "), (!_vm.errors.first(_vm.dynamicId)) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.showFullAddress = true
      }
    }
  }, [_vm._v("If you don't find your address or don't live in Australia, please click here to enter your address manually.")]) : _vm._e()])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.showFullAddress || _vm.disabledGoogleAutocomplete) ? _c('div', {
    staticClass: "small-12 columns small-collapse"
  }, [(_vm.addressSelected) ? _c('div', {
    staticClass: "small-12 columns field-address-readonly"
  }, [_c('div', {
    staticClass: "field has-content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addressSelected),
      expression: "addressSelected"
    }],
    attrs: {
      "name": "addressSelected",
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.addressSelected)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addressSelected = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": _vm.dynamicId
    }
  }, [_vm._v("Your address")])])]) : _vm._e(), _vm._v(" "), (!_vm.addressSelected) ? _c('div', {
    staticClass: "small-12 columns"
  }, [_c('h2', [_vm._v("Enter your address")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "small-6 columns left-field"
  }, [_c('div', {
    staticClass: "field",
    class: _vm.donation.billing.unitnumber ? 'has-content' : 'unit-no-border'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.billing.unitnumber),
      expression: "donation.billing.unitnumber"
    }],
    class: {
      'border-red': _vm.errors.has('unitnumber')
    },
    attrs: {
      "name": "unitnumber",
      "type": "tel",
      "placeholder": "Unit #"
    },
    domProps: {
      "value": (_vm.donation.billing.unitnumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation.billing, "unitnumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "unitnumber"
    }
  }, [_vm._v("Unit number")])])]), _vm._v(" "), _c('div', {
    staticClass: "small-6 columns right-field unit-no-alert-container"
  }, [_c('div', [_c('div', {
    staticClass: "unit-no-alert",
    class: _vm.donation.billing.unitnumber ? 'fadeaway' : ''
  }, [_c('p', [_vm._v("Please enter unit number if applicable")])])])]), _vm._v(" "), _c('div', {
    staticClass: "small-6 columns left-field"
  }, [_c('div', {
    staticClass: "field",
    class: _vm.donation.billing.streetno ? 'has-content' : ''
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.billing.streetno),
      expression: "donation.billing.streetno"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('streetno')
    },
    attrs: {
      "name": "streetno",
      "type": "text",
      "placeholder": "Street #",
      "autocomplete": "no"
    },
    domProps: {
      "value": (_vm.donation.billing.streetno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation.billing, "streetno", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "streetno"
    }
  }, [_vm._v("Street number " + _vm._s(_vm.errors.first('streetno') ? 'required' : ''))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-6 columns right-field"
  }, [_c('div', {
    staticClass: "field",
    class: _vm.donation.billing.streetname ? 'has-content' : ''
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.billing.streetname),
      expression: "donation.billing.streetname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('streetname')
    },
    attrs: {
      "name": "streetname",
      "type": "text",
      "placeholder": "Street Name",
      "autocomplete": "address-line1"
    },
    domProps: {
      "value": (_vm.donation.billing.streetname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation.billing, "streetname", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "streetname"
    }
  }, [_vm._v("Street name " + _vm._s(_vm.errors.first('streetname') ? 'required' : ''))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-6 columns left-field"
  }, [_c('div', {
    staticClass: "field",
    class: _vm.donation.billing.postcode ? 'has-content' : ''
  }, [(_vm.donation.billing.country == 'Australia') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.billing.postcode),
      expression: "donation.billing.postcode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        numeric: true
      }),
      expression: "{ required: true, numeric: true }"
    }],
    class: {
      'border-red': _vm.errors.has('postcode')
    },
    attrs: {
      "name": "postcode",
      "type": "tel",
      "placeholder": "Postcode",
      "maxlength": "4",
      "autocomplete": "postal-code"
    },
    domProps: {
      "value": (_vm.donation.billing.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation.billing, "postcode", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.donation.billing.country != 'Australia') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.billing.postcode),
      expression: "donation.billing.postcode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        alpha_num: true
      }),
      expression: "{ required: true, alpha_num: true }"
    }],
    class: {
      'border-red': _vm.errors.has('postcode')
    },
    attrs: {
      "name": "postcode",
      "type": "tel",
      "placeholder": "Postcode",
      "autocomplete": "postal-code"
    },
    domProps: {
      "value": (_vm.donation.billing.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation.billing, "postcode", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('label', {
    attrs: {
      "for": "postcode"
    }
  }, [_vm._v("Postcode " + _vm._s(_vm.errors.first('postcode') ? 'required' : ''))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-6 columns right-field"
  }, [_c('div', {
    staticClass: "field",
    class: _vm.donation.billing.state ? 'has-content' : ''
  }, [(_vm.donation.billing.country == 'Australia') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.billing.state),
      expression: "donation.billing.state"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('state')
    },
    attrs: {
      "name": "state"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.donation.billing, "state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("Select a state")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NSW"
    }
  }, [_vm._v("NSW")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ACT"
    }
  }, [_vm._v("ACT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NT"
    }
  }, [_vm._v("NT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SA"
    }
  }, [_vm._v("SA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "WA"
    }
  }, [_vm._v("WA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "VIC"
    }
  }, [_vm._v("VIC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "QLD"
    }
  }, [_vm._v("QLD")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TAS"
    }
  }, [_vm._v("TAS")])]) : _vm._e(), _vm._v(" "), (_vm.donation.billing.country != 'Australia') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.billing.state),
      expression: "donation.billing.state"
    }],
    class: {
      'border-red': _vm.errors.has('state')
    },
    attrs: {
      "name": "state",
      "type": "text",
      "placeholder": "State"
    },
    domProps: {
      "value": (_vm.donation.billing.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation.billing, "state", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('label', {
    attrs: {
      "for": "state"
    }
  }, [_vm._v("State " + _vm._s(_vm.errors.first('state') ? 'required' : ''))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-6 columns left-field"
  }, [_c('div', {
    staticClass: "field",
    class: _vm.donation.billing.suburb ? 'has-content' : ''
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.billing.suburb),
      expression: "donation.billing.suburb"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('suburb')
    },
    attrs: {
      "name": "suburb",
      "type": "text",
      "placeholder": "Suburb"
    },
    domProps: {
      "value": (_vm.donation.billing.suburb)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation.billing, "suburb", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "suburb"
    }
  }, [_vm._v("Suburb " + _vm._s(_vm.errors.first('suburb') ? 'required' : ''))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 medium-6 columns right-field field-phone"
  }, [_c('div', {
    staticClass: "field",
    class: _vm.donation.phone ? 'has-content' : ''
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.phone),
      expression: "donation.phone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        checkPhoneNumber: true
      }),
      expression: "{ required: true, checkPhoneNumber: true }"
    }],
    class: {
      'border-red': _vm.errors.has('phone') || _vm.errors.has('checkPhoneNumber')
    },
    attrs: {
      "name": "phone",
      "type": "tel",
      "min": "8",
      "max": "12",
      "placeholder": "Enter your phone",
      "autocomplete": "tel"
    },
    domProps: {
      "value": (_vm.donation.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.checkPhoneLoading) ? _c('div', {
    staticClass: "input-loading"
  }, [_c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/loading-tail-spin.svg"
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.has('phone')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first('phone')))]) : _vm._e()])])])]) : _vm._e()]), _vm._v(" "), (_vm.bequestCheckbox) ? _c('div', {
    staticClass: "wwf-checkbox bequest-checkbox",
    attrs: {
      "checked": "checked"
    }
  }, [_c('label', [_vm._v("\n      Please send me information about including wildlife and WWF in my Will.\n      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.bequest),
      expression: "donation.bequest"
    }],
    attrs: {
      "type": "checkbox",
      "id": "opt-in-step-2",
      "name": "opt-in"
    },
    domProps: {
      "checked": Array.isArray(_vm.donation.bequest) ? _vm._i(_vm.donation.bequest, null) > -1 : (_vm.donation.bequest)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.donation.bequest,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.donation.bequest = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.donation.bequest = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.donation, "bequest", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkbox"
  })])]) : _vm._e(), _vm._v(" "), (_vm.donation.isGift) ? _c('div', [_c('div', {
    staticClass: "small-collapse"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-6 medium-3 columns left-field"
  }, [_c('div', {
    staticClass: "field",
    class: _vm.donation.gift.title ? 'has-content' : ''
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.gift.title),
      expression: "donation.gift.title"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('gift-title')
    },
    attrs: {
      "name": "gift-title",
      "placeholder": "Title"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.donation.gift, "title", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("Select a title")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Mr"
    }
  }, [_vm._v("Mr")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Mrs"
    }
  }, [_vm._v("Mrs")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Ms"
    }
  }, [_vm._v("Ms")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Miss"
    }
  }, [_vm._v("Miss")])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "gift-title"
    }
  }, [_vm._v("Title")])])]), _vm._v(" "), _c('div', {
    staticClass: "title-required title-required-gift"
  }, [_vm._v(_vm._s(_vm.errors.first('gift-title') ? 'Title required' : ''))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-12 medium-6 columns left-field"
  }, [_c('div', {
    staticClass: "field",
    class: _vm.donation.gift.firstname ? 'has-content' : ''
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.gift.firstname),
      expression: "donation.gift.firstname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('gift-firstname')
    },
    attrs: {
      "name": "gift-firstname",
      "type": "text",
      "placeholder": "Enter the first name"
    },
    domProps: {
      "value": (_vm.donation.gift.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation.gift, "firstname", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "gift-firstname"
    }
  }, [_vm._v("First name " + _vm._s(_vm.errors.first('gift-firstname') ? 'required' : ''))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 medium-6 columns right-field"
  }, [_c('div', {
    staticClass: "field",
    class: _vm.donation.gift.lastname ? 'has-content' : ''
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.gift.lastname),
      expression: "donation.gift.lastname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('gift-lastname')
    },
    attrs: {
      "name": "gift-lastname",
      "type": "text",
      "placeholder": "Enter your last name"
    },
    domProps: {
      "value": (_vm.donation.gift.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation.gift, "lastname", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "gift-lastname"
    }
  }, [_vm._v("Last name " + _vm._s(_vm.errors.first('gift-lastname') ? 'required' : ''))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "wwf-checkbox"
  }, [_c('label', [_vm._v("\n        This gift is to be delivered to the same billing address\n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.isSameAddress),
      expression: "donation.isSameAddress"
    }],
    attrs: {
      "type": "checkbox",
      "name": "isSameAddress"
    },
    domProps: {
      "checked": Array.isArray(_vm.donation.isSameAddress) ? _vm._i(_vm.donation.isSameAddress, null) > -1 : (_vm.donation.isSameAddress)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.donation.isSameAddress,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.donation.isSameAddress = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.donation.isSameAddress = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.donation, "isSameAddress", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkbox"
  })])]), _vm._v(" "), (!_vm.donation.isSameAddress) ? _c('div', {
    staticClass: "small-collapse"
  }, [(!_vm.showFullAddressGifts && !_vm.disabledGoogleAutocomplete && _vm.showAddressGiftSuggestions) ? _c('div', {
    staticClass: "small-12 columns"
  }, [_c('div', {
    staticClass: "field has-content"
  }, [_c('form', {
    attrs: {
      "autocomplete": "off",
      "onkeydown": "return event.key != 'Enter';"
    }
  }, [_c('sensis-autocomplete', {
    staticClass: "form-control",
    attrs: {
      "id": "gift-map",
      "classname": _vm.errors.has('gift-map') ? 'border-red' : ''
    },
    on: {
      "addressSelected": _vm.sensisSelectedAddressGift
    }
  })], 1), _vm._v(" "), _c('label', {
    attrs: {
      "for": "gift-map"
    }
  }, [_vm._v("Enter the address")]), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert-address"
  }, [(_vm.errors.first('gift-map')) ? _c('p', [_vm._v("\n              We cannot find the address.\n              "), _c('a', {
    on: {
      "click": function($event) {
        _vm.showFullAddressGifts = true
      }
    }
  }, [_vm._v("Please click here to enter your address manually.")])]) : _vm._e(), _vm._v(" "), (!_vm.errors.first('gift-map')) ? _c('a', {
    staticClass: "wwf-alert-address-href",
    on: {
      "click": function($event) {
        _vm.showFullAddressGifts = true
      }
    }
  }, [_vm._v("If you don't find your address or don't live in Australia, please click here to enter your address manually.")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.showFullAddressGifts || _vm.disabledGoogleAutocomplete) ? _c('div', {
    staticClass: "row small-collapse"
  }, [(_vm.addressgiftSelected) ? _c('div', {
    staticClass: "small-12 columns field-address-readonly"
  }, [_c('div', {
    staticClass: "field has-content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addressgiftSelected),
      expression: "addressgiftSelected"
    }],
    attrs: {
      "name": "addressgiftSelected",
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.addressgiftSelected)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addressgiftSelected = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": _vm.addressgiftSelected
    }
  }, [_vm._v("The recipients address")])])]) : _vm._e(), _vm._v(" "), (!_vm.addressgiftSelected) ? _c('div', {
    staticClass: "small-12 columns"
  }, [_c('h2', [_vm._v("Enter recipients address")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "small-6 columns left-field"
  }, [_c('div', {
    staticClass: "field",
    class: _vm.donation.gift.unitnumber ? 'has-content' : ''
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.gift.unitnumber),
      expression: "donation.gift.unitnumber"
    }],
    class: {
      'border-red': _vm.errors.has('gift-unitnumber')
    },
    attrs: {
      "name": "gift-unitnumber",
      "type": "tel",
      "placeholder": "Unit #"
    },
    domProps: {
      "value": (_vm.donation.gift.unitnumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation.gift, "unitnumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "gift-unitnumber"
    }
  }, [_vm._v("Unit number")])])]), _vm._v(" "), _c('div', {
    staticClass: "small-6 columns right-field"
  }, [_c('div', {
    staticClass: "field",
    class: _vm.donation.gift.streetno ? 'has-content' : ''
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.gift.streetno),
      expression: "donation.gift.streetno"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('gift-streetno')
    },
    attrs: {
      "name": "gift-streetno",
      "type": "text",
      "placeholder": "Street #",
      "autocomplete": "no"
    },
    domProps: {
      "value": (_vm.donation.gift.streetno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation.gift, "streetno", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "gift-streetno"
    }
  }, [_vm._v("Street number " + _vm._s(_vm.errors.first('gift-streetno') ? 'required' : ''))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-6 columns left-field"
  }, [_c('div', {
    staticClass: "field",
    class: _vm.donation.gift.streetname ? 'has-content' : ''
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.gift.streetname),
      expression: "donation.gift.streetname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('gift-streetname')
    },
    attrs: {
      "name": "gift-streetname",
      "type": "text",
      "placeholder": "Street Name"
    },
    domProps: {
      "value": (_vm.donation.gift.streetname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation.gift, "streetname", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "gift-streetname"
    }
  }, [_vm._v("Street name " + _vm._s(_vm.errors.first('gift-streetname') ? 'required' : ''))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-6 columns right-field"
  }, [_c('div', {
    staticClass: "field",
    class: _vm.donation.gift.postcode ? 'has-content' : ''
  }, [(_vm.donation.gift.country == 'Australia') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.gift.postcode),
      expression: "donation.gift.postcode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('gift-postcode')
    },
    attrs: {
      "name": "gift-postcode",
      "type": "tel",
      "maxlength": "4",
      "placeholder": "Postcode"
    },
    domProps: {
      "value": (_vm.donation.gift.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation.gift, "postcode", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.donation.gift.country != 'Australia') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.gift.postcode),
      expression: "donation.gift.postcode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('gift-postcode')
    },
    attrs: {
      "name": "gift-postcode",
      "type": "text",
      "placeholder": "Postcode"
    },
    domProps: {
      "value": (_vm.donation.gift.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation.gift, "postcode", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('label', {
    attrs: {
      "for": "gift-postcode"
    }
  }, [_vm._v("Postcode " + _vm._s(_vm.errors.first('gift-postcode') ? 'required' : ''))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-6 columns left-field"
  }, [_c('div', {
    staticClass: "field",
    class: _vm.donation.gift.state ? 'has-content' : ''
  }, [(_vm.donation.gift.country == 'Australia') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.gift.state),
      expression: "donation.gift.state"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('gift-state')
    },
    attrs: {
      "name": "gift-state"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.donation.gift, "state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("Select a state")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NSW"
    }
  }, [_vm._v("NSW")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ACT"
    }
  }, [_vm._v("ACT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NT"
    }
  }, [_vm._v("NT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SA"
    }
  }, [_vm._v("SA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "WA"
    }
  }, [_vm._v("WA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "VIC"
    }
  }, [_vm._v("VIC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "QLD"
    }
  }, [_vm._v("QLD")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TAS"
    }
  }, [_vm._v("TAS")])]) : _vm._e(), _vm._v(" "), (_vm.donation.gift.country != 'Australia') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.gift.state),
      expression: "donation.gift.state"
    }],
    class: {
      'border-red': _vm.errors.has('gift-state')
    },
    attrs: {
      "name": "gift-state",
      "type": "text",
      "placeholder": "State"
    },
    domProps: {
      "value": (_vm.donation.gift.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation.gift, "state", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('label', {
    attrs: {
      "for": "gift-state"
    }
  }, [_vm._v("State " + _vm._s(_vm.errors.first('gift-state') ? 'required' : ''))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-6 columns right-field"
  }, [_c('div', {
    staticClass: "field",
    class: _vm.donation.gift.suburb ? 'has-content' : ''
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.gift.suburb),
      expression: "donation.gift.suburb"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('gift-suburb')
    },
    attrs: {
      "name": "gift-suburb",
      "type": "text",
      "placeholder": "Suburb"
    },
    domProps: {
      "value": (_vm.donation.gift.suburb)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation.gift, "suburb", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "gift-suburb"
    }
  }, [_vm._v("Suburb " + _vm._s(_vm.errors.first('gift-suburb') ? 'required' : ''))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-6 columns left-field end"
  }, [_c('div', {
    staticClass: "field",
    class: _vm.donation.gift.country ? 'has-content' : ''
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.gift.country),
      expression: "donation.gift.country"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('gift-country')
    },
    attrs: {
      "name": "gift-country"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.donation.gift, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.countriesList), function(countries, index) {
    return _c('option', {
      domProps: {
        "value": countries.name
      }
    }, [_vm._v(_vm._s(countries.name))])
  })), _vm._v(" "), _c('label', {
    attrs: {
      "for": "gift-country"
    }
  }, [_vm._v("Country " + _vm._s(_vm.errors.first('gift-country') ? 'required' : ''))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.donation.gift.country != 'Australia' && _vm.product.producttype == 'adoption'),
      expression: "donation.gift.country != 'Australia' && product.producttype == 'adoption'"
    }],
    staticClass: "small-12 columns alert"
  }, [_c('p', [_vm._v("We're sorry, gifts and toy products can only be delivered within Australia.")])])]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "small-12 columns payment-type"
  }, [_c('h2', [_vm._v("Choose payment type")]), _vm._v(" "), _c('ul', {
    staticClass: "wwf-radio-bttns payment-type--radio"
  }, [_c('li', [_c('label', [_c('span', {
    staticClass: "cc-title"
  }, [_vm._v("Credit card")]), _vm._v(" "), _c('img', {
    staticClass: "paymentType paymentType--visa",
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/cards/cc-visa.svg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "paymentType paymentType--mc",
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/cards/cc-mastercard.svg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "paymentType paymentType--amex",
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/cards/cc-amex-alt.svg"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payementType),
      expression: "payementType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "paymentType",
      "value": "wwf_purchasetokenise",
      "id": "payementTypeCC",
      "data-vv-as": "payment type"
    },
    domProps: {
      "checked": _vm._q(_vm.payementType, "wwf_purchasetokenise")
    },
    on: {
      "change": [function($event) {
        _vm.payementType = "wwf_purchasetokenise"
      }, function($event) {
        _vm.donation.payementType = null
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "wwf-radio"
  })])]), _vm._v(" "), (_vm.product.producttype != 'wildcard') ? _c('li', [_c('label', [_c('span', {
    staticClass: "cc-title"
  }, [_vm._v("Direct debit")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payementType),
      expression: "payementType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "paymentType",
      "value": "wwf_directdebit",
      "id": "payementTypeDD",
      "data-vv-as": "payment type"
    },
    domProps: {
      "checked": _vm._q(_vm.payementType, "wwf_directdebit")
    },
    on: {
      "change": [function($event) {
        _vm.payementType = "wwf_directdebit"
      }, function($event) {
        _vm.donation.payementType = null
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "wwf-radio"
  })])]) : _vm._e(), _vm._v(" "), (_vm.donation.type == 'Single') ? _c('li', [_c('label', [_c('span', {
    staticClass: "cc-title"
  }, [_vm._v("PayPal")]), _vm._v(" "), _c('img', {
    staticClass: "paymentType paymentType--PayPal",
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/cards/PayPal.png"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payementType),
      expression: "payementType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "paymentType",
      "value": "wwf_paypal",
      "id": "payementTypePP",
      "data-vv-as": "payment type"
    },
    domProps: {
      "checked": _vm._q(_vm.payementType, "wwf_paypal")
    },
    on: {
      "change": [function($event) {
        _vm.payementType = "wwf_paypal"
      }, function($event) {
        _vm.donation.payementType = _vm.payementType
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "wwf-radio"
  })])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.first('paymentType')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first('paymentType')))]) : _vm._e()])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small-12 columns"
  }, [_c('h2', [_vm._v("Enter your details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small-12 columns"
  }, [_c('h2', [_vm._v("Enter recipients details")])])
}]}

/***/ }),
/* 743 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.product) ? _c('div', {
    attrs: {
      "id": "Step1"
    }
  }, [(_vm.product.producttype == 'adoption') ? _c('div', {
    staticClass: "wwf-checkbox"
  }, [_c('label', [_vm._v("\n      Make this a gift for someone\n      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.isGift),
      expression: "donation.isGift"
    }],
    attrs: {
      "type": "checkbox",
      "id": "isGift-step-1",
      "name": "isGift"
    },
    domProps: {
      "checked": Array.isArray(_vm.donation.isGift) ? _vm._i(_vm.donation.isGift, null) > -1 : (_vm.donation.isGift)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.donation.isGift,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.donation.isGift = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.donation.isGift = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.donation, "isGift", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkbox"
  })])]) : _vm._e(), _vm._v(" "), (_vm.packages.length > 1 && _vm.product.producttype != 'wildcard') ? _c('h2', [_vm._v(_vm._s(_vm.donation.isGift ? 'Select your adoption pack to gift to someone' : 'Select your pack'))]) : _vm._e(), _vm._v(" "), (_vm.packages.length > 1 && _vm.product.producttype != 'wildcard') ? _c('div', {
    staticClass: "wwf-radio-bttns"
  }, [_vm._l((_vm.packages), function(item, index) {
    return _c('label', {
      attrs: {
        "for": 'package-' + item.code
      }
    }, [_vm._v("\n      " + _vm._s(item.display) + "\n      "), _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (_vm.donation.packagecode),
        expression: "donation.packagecode"
      }],
      attrs: {
        "type": "radio",
        "name": "package",
        "id": 'package-' + item.code
      },
      domProps: {
        "value": item.code,
        "checked": index == 0 ? 'checked' : '',
        "checked": _vm._q(_vm.donation.packagecode, item.code)
      },
      on: {
        "change": function($event) {
          _vm.$set(_vm.donation, "packagecode", item.code)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "wwf-radio"
    })])
  }), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.first('package')) ? _c('p', [_vm._v("Please choose your pack")]) : _vm._e()])], 2) : _vm._e(), _vm._v(" "), (_vm.packages.length > 0 && _vm.product.producttype != 'wildcard') ? _c('div', {
    staticClass: "wwf-packs"
  }, [_c('div', {
    staticClass: "packs"
  }, [(_vm.packages.find(function (x) { return x.code == _vm.donation.packagecode; }) != null && _vm.packages.find(function (x) { return x.code == _vm.donation.packagecode; }).pack != null) ? _c('div', {
    staticClass: "pack",
    style: ('background-image:url(' + _vm.packages.find(function (x) { return x.code == _vm.donation.packagecode; }).pack.image + ')')
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "toy",
    class: _vm.packages.find(function (x) { return x.code == _vm.donation.packagecode; }) != null && _vm.packages.find(function (x) { return x.code == _vm.donation.packagecode; }).toy != null ? 'has-toy' : 'has-no-toy',
    style: (_vm.packages.find(function (x) { return x.code == _vm.donation.packagecode; }) != null && _vm.packages.find(function (x) { return x.code == _vm.donation.packagecode; }).toy != null ? 'background-image:url(' + _vm.packages.find(function (x) { return x.code == _vm.donation.packagecode; }).toy.image + ')' : '')
  })]), _vm._v(" "), _c('div', {
    staticClass: "message"
  }, [_c('p', [(_vm.packages.find(function (x) { return x.code == _vm.donation.packagecode; }) != null && _vm.packages.find(function (x) { return x.code == _vm.donation.packagecode; }).pack != null) ? _c('span', [_vm._v(_vm._s(_vm.packages.find(function (x) { return x.code == _vm.donation.packagecode; }).pack.text))]) : _vm._e(), _vm._v(" "), (_vm.packages.find(function (x) { return x.code == _vm.donation.packagecode; }) != null && _vm.packages.find(function (x) { return x.code == _vm.donation.packagecode; }).toy != null) ? _c('span', [_vm._v(_vm._s(_vm.packages.find(function (x) { return x.code == _vm.donation.packagecode; }).toy.text))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.product.packages && _vm.product.packages.length > 1 && _vm.product.producttype == 'wildcard') ? _c('h2', [_vm._v("Choose your design")]) : _vm._e(), _vm._v(" "), (_vm.product.packages && _vm.product.packages.length > 1 && _vm.product.producttype == 'wildcard') ? _c('div', {
    staticClass: "wwf-packs wildcard--select"
  }, [_vm._l((_vm.product.packages), function(item, index) {
    return _c('label', {
      attrs: {
        "for": 'package-' + item.code
      }
    }, [_c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (_vm.donation.packagecode),
        expression: "donation.packagecode"
      }],
      attrs: {
        "type": "radio",
        "name": "package",
        "id": 'package-' + item.code
      },
      domProps: {
        "value": item.code,
        "checked": index == 0 ? 'checked' : '',
        "checked": _vm._q(_vm.donation.packagecode, item.code)
      },
      on: {
        "change": function($event) {
          _vm.$set(_vm.donation, "packagecode", item.code)
        }
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "tooltipstered",
      staticStyle: {
        "margin-bottom": "15px"
      },
      attrs: {
        "src": item.img
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "wwf-radio"
    })])
  }), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.first('package')) ? _c('p', [_vm._v("Please choose your design")]) : _vm._e()])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wwf-radio-bttns donation-type-tabs",
    class: {
      'single-tabs': _vm.product.donationtypes.length === 1
    }
  }, [_vm._l((_vm.product.donationtypes), function(donationtype, index) {
    return _c('label', {
      staticClass: "donation-type-tab",
      attrs: {
        "for": 'selection-' + donationtype
      }
    }, [_vm._v("\n      " + _vm._s((donationtype == "Regular") ? 'Give monthly' : 'Give once') + "\n      "), _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedDonationType),
        expression: "selectedDonationType"
      }],
      attrs: {
        "type": "radio",
        "name": "selectedDonationType",
        "id": 'selection-' + donationtype
      },
      domProps: {
        "value": donationtype,
        "checked": index == 0 ? 'checked' : '',
        "checked": _vm._q(_vm.selectedDonationType, donationtype)
      },
      on: {
        "change": function($event) {
          _vm.selectedDonationType = donationtype
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "wwf-radio"
    })])
  }), _vm._v(" "), _vm._m(0, false, false)], 2), _vm._v(" "), _vm._l((_vm.product.donationtypes), function(donationtype) {
    return (_vm.donation.type == donationtype) ? _c('div', {
      staticClass: "dollar-handles"
    }, [_vm._l((_vm.product.dollarhandles[donationtype]), function(index) {
      return _c('label', {
        attrs: {
          "for": 'handle-' + donationtype + '-' + index.amount
        }
      }, [_c('input', {
        directives: [{
          name: "validate",
          rawName: "v-validate",
          value: ('required'),
          expression: "'required'"
        }, {
          name: "model",
          rawName: "v-model",
          value: (_vm.donation.dollarhandle),
          expression: "donation.dollarhandle"
        }],
        attrs: {
          "type": "radio",
          "name": 'handle-' + donationtype,
          "id": 'handle-' + donationtype + '-' + index.amount,
          "data-vv-as": "amount"
        },
        domProps: {
          "value": index.amount,
          "checked": _vm._q(_vm.donation.dollarhandle, index.amount)
        },
        on: {
          "change": function($event) {
            _vm.$set(_vm.donation, "dollarhandle", index.amount)
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "amount",
        class: {
          'has-cents': !(index.amount.indexOf('.00') >= 0)
        }
      }, [_c('span', [_vm._v("$" + _vm._s((index.amount.indexOf('.00') >= 0) ? index.amount.slice(0, -3) : index.amount))])]), _vm._v(" "), _c('span', {
        staticClass: "handle"
      }), _vm._v(" "), _c('span', {
        staticClass: "svg-circle"
      }, [_c('svg', {
        staticStyle: {
          "width": "100%",
          "height": "100%"
        }
      }, [_c('circle', {
        attrs: {
          "cx": "50%",
          "cy": "50%",
          "r": "40%",
          "stroke-width": "3"
        }
      })])])])
    }), _vm._v(" "), (!(_vm.product.extrasetting && _vm.product.extrasetting.hidecustomhandle)) ? _c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.donation.dollarhandle),
        expression: "donation.dollarhandle"
      }],
      attrs: {
        "type": "radio",
        "name": 'handle-' + donationtype,
        "value": "custom",
        "id": 'handle-custom-' + donationtype
      },
      domProps: {
        "checked": _vm._q(_vm.donation.dollarhandle, "custom")
      },
      on: {
        "click": function($event) {
          _vm.setFocus()
        },
        "change": function($event) {
          _vm.$set(_vm.donation, "dollarhandle", "custom")
        }
      }
    }), _vm._v(" "), _vm._m(1, true, false), _vm._v(" "), _c('span', {
      staticClass: "handle"
    }), _vm._v(" "), _c('span', {
      staticClass: "svg-circle"
    }, [_c('svg', {
      staticStyle: {
        "width": "100%",
        "height": "100%"
      }
    }, [_c('circle', {
      attrs: {
        "cx": "50%",
        "cy": "50%",
        "r": "40%",
        "stroke-width": "3"
      }
    })])])]) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.donation.dollarhandle == 'custom'),
        expression: "donation.dollarhandle=='custom'"
      }],
      staticClass: "field other-amount-form",
      class: _vm.donation.amount ? 'has-content' : ''
    }, [_c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: true,
          donationAmountIsValid: true,
          regex: /^\d+(\.\d{1,2})?$/
        }),
        expression: "{required: true, donationAmountIsValid: true, regex: /^\\d+(\\.\\d{1,2})?$/}"
      }, {
        name: "model",
        rawName: "v-model",
        value: (_vm.donation.amount),
        expression: "donation.amount"
      }],
      ref: "customhandle",
      refInFor: true,
      class: {
        'border-red': _vm.errors.has('custom-handle')
      },
      attrs: {
        "type": "tel",
        "name": "custom-handle",
        "id": "custom-handle",
        "placeholder": "Choose an amount",
        "data-vv-as": "amount"
      },
      domProps: {
        "value": (_vm.donation.amount)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.donation, "amount", $event.target.value)
        }, function($event) {
          _vm.checkMaxAmount()
        }]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": "custom-handle"
      }
    }, [_vm._v("Choose an amount")]), _vm._v(" "), _c('span', {
      staticClass: "wwf-alert"
    }, [(_vm.errors.firstByRule('custom-handle', 'donationAmountIsValid')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first('custom-handle')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.maxAmount),
        expression: "maxAmount"
      }],
      staticClass: "message-big-amount"
    }, [_c('p', [_vm._v("\n        For donations above $75,000 please contact our Impact Partnerships team, so we can be sure your gift benefits the area of conservation you are most passionate about. \n      ")]), _vm._v(" "), _vm._m(2, true, false)]), _vm._v(" "), (_vm.donation.dollarhandle != null && _vm.donation.dollarhandle != 'custom' && _vm.donation.dollarhandle != '') ? _c('div', {
      staticClass: "dollar-handles-desc",
      class: {
        'has-amount': (_vm.donation.dollarhandle != null), 'addToolPos-': false
      }
    }, [_c('p', [_vm._v(_vm._s(_vm.product.dollarhandles[donationtype].find(function (x) { return x.amount == _vm.donation.dollarhandle; }) ? _vm.product.dollarhandles[donationtype].find(function (x) { return x.amount == _vm.donation.dollarhandle; }).text : ""))])]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "wwf-alert"
    }, [(_vm.errors.first('handle-' + donationtype)) ? _c('p', [_vm._v("Please choose your donation amount")]) : _vm._e()]), _vm._v(" "), (_vm.donation.amount && _vm.product.extrasetting && _vm.product.extrasetting.displaytaxcalculator) ? _c('tax-calculator', {
      attrs: {
        "amount": _vm.donation.amount
      }
    }) : _vm._e()], 2) : _vm._e()
  }), _vm._v(" "), _c('h2', [_vm._v("Enter your email")]), _vm._v(" "), _c('div', {
    staticClass: "field",
    class: _vm.donation.email ? 'has-content' : ''
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.email),
      expression: "donation.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        donationCheckEmail: true
      }),
      expression: "{ required: true, donationCheckEmail: true }"
    }],
    class: {
      'border-red': _vm.errors.has('email') || _vm.errors.has('donationCheckEmail')
    },
    attrs: {
      "type": "email",
      "name": "email",
      "id": "email",
      "placeholder": "Email",
      "autocomplete": "email"
    },
    domProps: {
      "value": (_vm.donation.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.checkEmailLoading) ? _c('div', {
    staticClass: "input-loading"
  }, [_c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3593/dist/assets/img/loading-tail-spin.svg"
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email " + _vm._s(_vm.errors.firstByRule('email', 'required') ? 'required' : ''))]), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.firstByRule('email', 'donationCheckEmail')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first('email')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "wwf-checkbox",
    attrs: {
      "checked": "checked"
    }
  }, [_c('label', [_vm._v("\n      Send me emails about important conservation news and how I can help WWF protect the diversity of life on Earth.\n      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.optin),
      expression: "donation.optin"
    }],
    attrs: {
      "type": "checkbox",
      "id": "opt-in-step-1",
      "name": "opt-in"
    },
    domProps: {
      "checked": Array.isArray(_vm.donation.optin) ? _vm._i(_vm.donation.optin, null) > -1 : (_vm.donation.optin)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.donation.optin,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.donation.optin = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.donation.optin = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.donation, "optin", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkbox"
  })])])], 2) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "wwf-tooltip"
  }, [_c('p', [_vm._v("Donations of $2 or more are tax deductible. For adoptions, the toy value cannot be claimed as a tax deductible gift.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "amount"
  }, [_c('i', {
    staticClass: "fas fa-pencil-alt"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n        Please email  "), _c('a', {
    attrs: {
      "href": "mailto:partnerships@wwf.org.au",
      "target": "_blank"
    }
  }, [_vm._v("partnerships@wwf.org.au")]), _vm._v(". Thank you so much for your kindness!\n      ")])
}]}

/***/ }),
/* 744 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ecommerce-slider donate-carousel",
    attrs: {
      "id": "ecommerce-slider"
    }
  }, [_c('VueSlickCarousel', _vm._b({
    staticClass: "slides-container"
  }, 'VueSlickCarousel', _vm.settings, false), _vm._l((_vm.images), function(image, i) {
    return _c('div', {
      key: i,
      staticClass: "product-slide",
      class: i > 0 ? 'slide-sub' : 'slide-main'
    }, [_c('img', {
      attrs: {
        "src": image,
        "alt": "product"
      }
    })])
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 745 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-item-container search-item-youtube"
  }, [_c('div', {
    staticClass: "search-item-header"
  }, [_c('div', {
    staticClass: "search-item-title"
  }, [_c('h4', [_c('a', {
    attrs: {
      "href": _vm.item.liveUrl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.item.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "search-item-link"
  }, [_c('a', {
    attrs: {
      "href": _vm.item.liveUrl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.item.displayUrl))])]), _vm._v(" "), _c('div', {
    staticClass: "search-item-header-date"
  }, [_vm._v("\n      " + _vm._s(_vm.item.date) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "search-item-content"
  }, [_c('div', {
    staticClass: "search-item-image-wrapper"
  }, [(_vm.item.metaData && _vm.item.metaData.image) ? _c('img', {
    attrs: {
      "src": _vm.item.metaData.image,
      "alt": 'Thumbnail for ' + _vm.item.title
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "youtube-player-icon",
    on: {
      "click": _vm.openPlayer
    }
  }, [_c('i', {
    staticClass: "fas fa-play fa-fw"
  })])]), _vm._v(" "), _c('span', {
    staticClass: "search-item-date"
  }, [_vm._v(_vm._s(_vm.item.date) + " ")]), _vm._v(_vm._s(_vm.item.summary) + "\n  ")]), _vm._v(" "), _c('search-youtube-player', {
    attrs: {
      "item": _vm.item,
      "isOpen": _vm.showPlayer
    },
    on: {
      "closed": _vm.closePlayer
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 746 */
/***/ (function(module, exports) {

module.exports = {
	"NSW": [
		[
			1000,
			1999
		],
		[
			2000,
			2566
		],
		[
			2619,
			2899
		],
		[
			2921,
			2999
		]
	],
	"ACT": [
		[
			200,
			299
		],
		[
			2600,
			2618
		],
		[
			2900,
			2920
		]
	],
	"VIC": [
		[
			3000,
			3999
		],
		[
			8000,
			8999
		]
	],
	"QLD": [
		[
			4000,
			4999
		],
		[
			9000,
			9999
		]
	],
	"SA": [
		[
			5000,
			5799
		],
		[
			5800,
			5999
		]
	],
	"WA": [
		[
			6000,
			6797
		],
		[
			6800,
			6999
		]
	],
	"TAS": [
		[
			7000,
			7799
		],
		[
			7800,
			7999
		]
	],
	"NT": [
		[
			800,
			899
		],
		[
			900,
			999
		]
	]
};

/***/ }),
/* 747 */
/***/ (function(module, exports) {

module.exports = [
	{
		"name": "Afghanistan",
		"code": "AF"
	},
	{
		"name": "Åland Islands",
		"code": "AX"
	},
	{
		"name": "Albania",
		"code": "AL"
	},
	{
		"name": "Algeria",
		"code": "DZ"
	},
	{
		"name": "American Samoa",
		"code": "AS"
	},
	{
		"name": "Andorra",
		"code": "AD"
	},
	{
		"name": "Angola",
		"code": "AO"
	},
	{
		"name": "Anguilla",
		"code": "AI"
	},
	{
		"name": "Antarctica",
		"code": "AQ"
	},
	{
		"name": "Antigua and Barbuda",
		"code": "AG"
	},
	{
		"name": "Argentina",
		"code": "AR"
	},
	{
		"name": "Armenia",
		"code": "AM"
	},
	{
		"name": "Aruba",
		"code": "AW"
	},
	{
		"name": "Australia",
		"code": "AU"
	},
	{
		"name": "Austria",
		"code": "AT"
	},
	{
		"name": "Azerbaijan",
		"code": "AZ"
	},
	{
		"name": "Bahamas",
		"code": "BS"
	},
	{
		"name": "Bahrain",
		"code": "BH"
	},
	{
		"name": "Bangladesh",
		"code": "BD"
	},
	{
		"name": "Barbados",
		"code": "BB"
	},
	{
		"name": "Belarus",
		"code": "BY"
	},
	{
		"name": "Belgium",
		"code": "BE"
	},
	{
		"name": "Belize",
		"code": "BZ"
	},
	{
		"name": "Benin",
		"code": "BJ"
	},
	{
		"name": "Bermuda",
		"code": "BM"
	},
	{
		"name": "Bhutan",
		"code": "BT"
	},
	{
		"name": "Bolivia",
		"code": "BO"
	},
	{
		"name": "Bosnia and Herzegovina",
		"code": "BA"
	},
	{
		"name": "Botswana",
		"code": "BW"
	},
	{
		"name": "Bouvet Island",
		"code": "BV"
	},
	{
		"name": "Brazil",
		"code": "BR"
	},
	{
		"name": "British Indian Ocean Territory",
		"code": "IO"
	},
	{
		"name": "Brunei Darussalam",
		"code": "BN"
	},
	{
		"name": "Bulgaria",
		"code": "BG"
	},
	{
		"name": "Burkina Faso",
		"code": "BF"
	},
	{
		"name": "Burundi",
		"code": "BI"
	},
	{
		"name": "Cambodia",
		"code": "KH"
	},
	{
		"name": "Cameroon",
		"code": "CM"
	},
	{
		"name": "Canada",
		"code": "CA"
	},
	{
		"name": "Cape Verde",
		"code": "CV"
	},
	{
		"name": "Cayman Islands",
		"code": "KY"
	},
	{
		"name": "Central African Republic",
		"code": "CF"
	},
	{
		"name": "Chad",
		"code": "TD"
	},
	{
		"name": "Chile",
		"code": "CL"
	},
	{
		"name": "China",
		"code": "CN"
	},
	{
		"name": "Christmas Island",
		"code": "CX"
	},
	{
		"name": "Cocos (Keeling) Islands",
		"code": "CC"
	},
	{
		"name": "Colombia",
		"code": "CO"
	},
	{
		"name": "Comoros",
		"code": "KM"
	},
	{
		"name": "Congo",
		"code": "CG"
	},
	{
		"name": "Congo, The Democratic Republic of the",
		"code": "CD"
	},
	{
		"name": "Cook Islands",
		"code": "CK"
	},
	{
		"name": "Costa Rica",
		"code": "CR"
	},
	{
		"name": "Cote D\"Ivoire",
		"code": "CI"
	},
	{
		"name": "Croatia",
		"code": "HR"
	},
	{
		"name": "Cuba",
		"code": "CU"
	},
	{
		"name": "Cyprus",
		"code": "CY"
	},
	{
		"name": "Czech Republic",
		"code": "CZ"
	},
	{
		"name": "Denmark",
		"code": "DK"
	},
	{
		"name": "Djibouti",
		"code": "DJ"
	},
	{
		"name": "Dominica",
		"code": "DM"
	},
	{
		"name": "Dominican Republic",
		"code": "DO"
	},
	{
		"name": "Ecuador",
		"code": "EC"
	},
	{
		"name": "Egypt",
		"code": "EG"
	},
	{
		"name": "El Salvador",
		"code": "SV"
	},
	{
		"name": "Equatorial Guinea",
		"code": "GQ"
	},
	{
		"name": "Eritrea",
		"code": "ER"
	},
	{
		"name": "Estonia",
		"code": "EE"
	},
	{
		"name": "Ethiopia",
		"code": "ET"
	},
	{
		"name": "Falkland Islands (Malvinas)",
		"code": "FK"
	},
	{
		"name": "Faroe Islands",
		"code": "FO"
	},
	{
		"name": "Fiji",
		"code": "FJ"
	},
	{
		"name": "Finland",
		"code": "FI"
	},
	{
		"name": "France",
		"code": "FR"
	},
	{
		"name": "French Guiana",
		"code": "GF"
	},
	{
		"name": "French Polynesia",
		"code": "PF"
	},
	{
		"name": "French Southern Territories",
		"code": "TF"
	},
	{
		"name": "Gabon",
		"code": "GA"
	},
	{
		"name": "Gambia",
		"code": "GM"
	},
	{
		"name": "Georgia",
		"code": "GE"
	},
	{
		"name": "Germany",
		"code": "DE"
	},
	{
		"name": "Ghana",
		"code": "GH"
	},
	{
		"name": "Gibraltar",
		"code": "GI"
	},
	{
		"name": "Greece",
		"code": "GR"
	},
	{
		"name": "Greenland",
		"code": "GL"
	},
	{
		"name": "Grenada",
		"code": "GD"
	},
	{
		"name": "Guadeloupe",
		"code": "GP"
	},
	{
		"name": "Guam",
		"code": "GU"
	},
	{
		"name": "Guatemala",
		"code": "GT"
	},
	{
		"name": "Guernsey",
		"code": "GG"
	},
	{
		"name": "Guinea",
		"code": "GN"
	},
	{
		"name": "Guinea-Bissau",
		"code": "GW"
	},
	{
		"name": "Guyana",
		"code": "GY"
	},
	{
		"name": "Haiti",
		"code": "HT"
	},
	{
		"name": "Heard Island and Mcdonald Islands",
		"code": "HM"
	},
	{
		"name": "Holy See (Vatican City State)",
		"code": "VA"
	},
	{
		"name": "Honduras",
		"code": "HN"
	},
	{
		"name": "Hong Kong",
		"code": "HK"
	},
	{
		"name": "Hungary",
		"code": "HU"
	},
	{
		"name": "Iceland",
		"code": "IS"
	},
	{
		"name": "India",
		"code": "IN"
	},
	{
		"name": "Indonesia",
		"code": "ID"
	},
	{
		"name": "Iran, Islamic Republic Of",
		"code": "IR"
	},
	{
		"name": "Iraq",
		"code": "IQ"
	},
	{
		"name": "Ireland",
		"code": "IE"
	},
	{
		"name": "Isle of Man",
		"code": "IM"
	},
	{
		"name": "Israel",
		"code": "IL"
	},
	{
		"name": "Italy",
		"code": "IT"
	},
	{
		"name": "Jamaica",
		"code": "JM"
	},
	{
		"name": "Japan",
		"code": "JP"
	},
	{
		"name": "Jersey",
		"code": "JE"
	},
	{
		"name": "Jordan",
		"code": "JO"
	},
	{
		"name": "Kazakhstan",
		"code": "KZ"
	},
	{
		"name": "Kenya",
		"code": "KE"
	},
	{
		"name": "Kiribati",
		"code": "KI"
	},
	{
		"name": "Korea, Democratic People\"S Republic of",
		"code": "KP"
	},
	{
		"name": "Korea, Republic of",
		"code": "KR"
	},
	{
		"name": "Kuwait",
		"code": "KW"
	},
	{
		"name": "Kyrgyzstan",
		"code": "KG"
	},
	{
		"name": "Lao People\"S Democratic Republic",
		"code": "LA"
	},
	{
		"name": "Latvia",
		"code": "LV"
	},
	{
		"name": "Lebanon",
		"code": "LB"
	},
	{
		"name": "Lesotho",
		"code": "LS"
	},
	{
		"name": "Liberia",
		"code": "LR"
	},
	{
		"name": "Libyan Arab Jamahiriya",
		"code": "LY"
	},
	{
		"name": "Liechtenstein",
		"code": "LI"
	},
	{
		"name": "Lithuania",
		"code": "LT"
	},
	{
		"name": "Luxembourg",
		"code": "LU"
	},
	{
		"name": "Macao",
		"code": "MO"
	},
	{
		"name": "Macedonia, The Former Yugoslav Republic of",
		"code": "MK"
	},
	{
		"name": "Madagascar",
		"code": "MG"
	},
	{
		"name": "Malawi",
		"code": "MW"
	},
	{
		"name": "Malaysia",
		"code": "MY"
	},
	{
		"name": "Maldives",
		"code": "MV"
	},
	{
		"name": "Mali",
		"code": "ML"
	},
	{
		"name": "Malta",
		"code": "MT"
	},
	{
		"name": "Marshall Islands",
		"code": "MH"
	},
	{
		"name": "Martinique",
		"code": "MQ"
	},
	{
		"name": "Mauritania",
		"code": "MR"
	},
	{
		"name": "Mauritius",
		"code": "MU"
	},
	{
		"name": "Mayotte",
		"code": "YT"
	},
	{
		"name": "Mexico",
		"code": "MX"
	},
	{
		"name": "Micronesia, Federated States of",
		"code": "FM"
	},
	{
		"name": "Moldova, Republic of",
		"code": "MD"
	},
	{
		"name": "Monaco",
		"code": "MC"
	},
	{
		"name": "Mongolia",
		"code": "MN"
	},
	{
		"name": "Montserrat",
		"code": "MS"
	},
	{
		"name": "Morocco",
		"code": "MA"
	},
	{
		"name": "Mozambique",
		"code": "MZ"
	},
	{
		"name": "Myanmar",
		"code": "MM"
	},
	{
		"name": "Namibia",
		"code": "NA"
	},
	{
		"name": "Nauru",
		"code": "NR"
	},
	{
		"name": "Nepal",
		"code": "NP"
	},
	{
		"name": "Netherlands",
		"code": "NL"
	},
	{
		"name": "Netherlands Antilles",
		"code": "AN"
	},
	{
		"name": "New Caledonia",
		"code": "NC"
	},
	{
		"name": "New Zealand",
		"code": "NZ"
	},
	{
		"name": "Nicaragua",
		"code": "NI"
	},
	{
		"name": "Niger",
		"code": "NE"
	},
	{
		"name": "Nigeria",
		"code": "NG"
	},
	{
		"name": "Niue",
		"code": "NU"
	},
	{
		"name": "Norfolk Island",
		"code": "NF"
	},
	{
		"name": "Northern Mariana Islands",
		"code": "MP"
	},
	{
		"name": "Norway",
		"code": "NO"
	},
	{
		"name": "Oman",
		"code": "OM"
	},
	{
		"name": "Pakistan",
		"code": "PK"
	},
	{
		"name": "Palau",
		"code": "PW"
	},
	{
		"name": "Palestinian Territory, Occupied",
		"code": "PS"
	},
	{
		"name": "Panama",
		"code": "PA"
	},
	{
		"name": "Papua New Guinea",
		"code": "PG"
	},
	{
		"name": "Paraguay",
		"code": "PY"
	},
	{
		"name": "Peru",
		"code": "PE"
	},
	{
		"name": "Philippines",
		"code": "PH"
	},
	{
		"name": "Pitcairn",
		"code": "PN"
	},
	{
		"name": "Poland",
		"code": "PL"
	},
	{
		"name": "Portugal",
		"code": "PT"
	},
	{
		"name": "Puerto Rico",
		"code": "PR"
	},
	{
		"name": "Qatar",
		"code": "QA"
	},
	{
		"name": "Reunion",
		"code": "RE"
	},
	{
		"name": "Romania",
		"code": "RO"
	},
	{
		"name": "Russian Federation",
		"code": "RU"
	},
	{
		"name": "RWANDA",
		"code": "RW"
	},
	{
		"name": "Saint Helena",
		"code": "SH"
	},
	{
		"name": "Saint Kitts and Nevis",
		"code": "KN"
	},
	{
		"name": "Saint Lucia",
		"code": "LC"
	},
	{
		"name": "Saint Pierre and Miquelon",
		"code": "PM"
	},
	{
		"name": "Saint Vincent and the Grenadines",
		"code": "VC"
	},
	{
		"name": "Samoa",
		"code": "WS"
	},
	{
		"name": "San Marino",
		"code": "SM"
	},
	{
		"name": "Sao Tome and Principe",
		"code": "ST"
	},
	{
		"name": "Saudi Arabia",
		"code": "SA"
	},
	{
		"name": "Senegal",
		"code": "SN"
	},
	{
		"name": "Serbia and Montenegro",
		"code": "CS"
	},
	{
		"name": "Seychelles",
		"code": "SC"
	},
	{
		"name": "Sierra Leone",
		"code": "SL"
	},
	{
		"name": "Singapore",
		"code": "SG"
	},
	{
		"name": "Slovakia",
		"code": "SK"
	},
	{
		"name": "Slovenia",
		"code": "SI"
	},
	{
		"name": "Solomon Islands",
		"code": "SB"
	},
	{
		"name": "Somalia",
		"code": "SO"
	},
	{
		"name": "South Africa",
		"code": "ZA"
	},
	{
		"name": "South Georgia and the South Sandwich Islands",
		"code": "GS"
	},
	{
		"name": "Spain",
		"code": "ES"
	},
	{
		"name": "Sri Lanka",
		"code": "LK"
	},
	{
		"name": "Sudan",
		"code": "SD"
	},
	{
		"name": "Suriname",
		"code": "SR"
	},
	{
		"name": "Svalbard and Jan Mayen",
		"code": "SJ"
	},
	{
		"name": "Swaziland",
		"code": "SZ"
	},
	{
		"name": "Sweden",
		"code": "SE"
	},
	{
		"name": "Switzerland",
		"code": "CH"
	},
	{
		"name": "Syrian Arab Republic",
		"code": "SY"
	},
	{
		"name": "Taiwan",
		"code": "TW"
	},
	{
		"name": "Tajikistan",
		"code": "TJ"
	},
	{
		"name": "Tanzania, United Republic of",
		"code": "TZ"
	},
	{
		"name": "Thailand",
		"code": "TH"
	},
	{
		"name": "Timor-Leste",
		"code": "TL"
	},
	{
		"name": "Togo",
		"code": "TG"
	},
	{
		"name": "Tokelau",
		"code": "TK"
	},
	{
		"name": "Tonga",
		"code": "TO"
	},
	{
		"name": "Trinidad and Tobago",
		"code": "TT"
	},
	{
		"name": "Tunisia",
		"code": "TN"
	},
	{
		"name": "Turkey",
		"code": "TR"
	},
	{
		"name": "Turkmenistan",
		"code": "TM"
	},
	{
		"name": "Turks and Caicos Islands",
		"code": "TC"
	},
	{
		"name": "Tuvalu",
		"code": "TV"
	},
	{
		"name": "Uganda",
		"code": "UG"
	},
	{
		"name": "Ukraine",
		"code": "UA"
	},
	{
		"name": "United Arab Emirates",
		"code": "AE"
	},
	{
		"name": "United Kingdom",
		"code": "GB"
	},
	{
		"name": "United States",
		"code": "US"
	},
	{
		"name": "United States Minor Outlying Islands",
		"code": "UM"
	},
	{
		"name": "Uruguay",
		"code": "UY"
	},
	{
		"name": "Uzbekistan",
		"code": "UZ"
	},
	{
		"name": "Vanuatu",
		"code": "VU"
	},
	{
		"name": "Venezuela",
		"code": "VE"
	},
	{
		"name": "Viet Nam",
		"code": "VN"
	},
	{
		"name": "Virgin Islands, British",
		"code": "VG"
	},
	{
		"name": "Virgin Islands, U.S.",
		"code": "VI"
	},
	{
		"name": "Wallis and Futuna",
		"code": "WF"
	},
	{
		"name": "Western Sahara",
		"code": "EH"
	},
	{
		"name": "Yemen",
		"code": "YE"
	},
	{
		"name": "Zambia",
		"code": "ZM"
	},
	{
		"name": "Zimbabwe",
		"code": "ZW"
	}
];

/***/ }),
/* 748 */
/***/ (function(module, exports) {

module.exports = [
	{
		"wwfurl": "http://wwf.panda.org",
		"name": "WWF Global"
	},
	{
		"wwfurl": "http://www.vidasilvestre.org.ar",
		"name": "Argentina"
	},
	{
		"wwfurl": "http://armenia.panda.org",
		"name": "Armenia"
	},
	{
		"wwfurl": "http://www.wwf.at",
		"name": "Austria"
	},
	{
		"wwfurl": "",
		"name": "Australia"
	},
	{
		"wwfurl": "http://www.wwf.be",
		"name": "Belgium"
	},
	{
		"wwfurl": "http://www.wwfbhutan.org",
		"name": "Bhutan"
	},
	{
		"wwfurl": "http://bolivia.panda.org",
		"name": "Bolivia"
	},
	{
		"wwfurl": "http://www.panda.org/what_we_do/where_we_work/borneo_forests",
		"name": "Borneo"
	},
	{
		"wwfurl": "http://www.wwf.org.br",
		"name": "Brasil"
	},
	{
		"wwfurl": "http://www.wwf.bg",
		"name": "Bulgaria"
	},
	{
		"wwfurl": "http://cambodia.panda.org",
		"name": "Cambodia"
	},
	{
		"wwfurl": "http://www.wwf.ca",
		"name": "Canada"
	},
	{
		"wwfurl": "http://www.panda.org/what_we_do/where_we_work/black_sea_basin/caucasus",
		"name": "Caucasus"
	},
	{
		"wwfurl": "http://www.wwfca.org",
		"name": "Central America"
	},
	{
		"wwfurl": "http://chile.panda.org",
		"name": "Chile"
	},
	{
		"wwfurl": "http://en.wwfchina.org",
		"name": "China"
	},
	{
		"wwfurl": "http://www.wwf.org.co",
		"name": "Colombia"
	},
	{
		"wwfurl": "http://croatia.panda.org",
		"name": "Croatia"
	},
	{
		"wwfurl": "http://www.wwf.dk",
		"name": "Denmark"
	},
	{
		"wwfurl": "http://www.wwf.org.ec",
		"name": "Ecuador"
	},
	{
		"wwfurl": "http://www.wwf.eu",
		"name": "European Policy Office"
	},
	{
		"wwfurl": "http://www.wwf.fi",
		"name": "Finland"
	},
	{
		"wwfurl": "http://www.wwf.fr",
		"name": "France"
	},
	{
		"wwfurl": "http://www.wwf.de",
		"name": "Germany"
	},
	{
		"wwfurl": "http://www.panda.org/what_we_do/where_we_work/project/projects_in_depth/mekong_river",
		"name": "Greater Mekong"
	},
	{
		"wwfurl": "http://www.wwf.gr",
		"name": "Greece"
	},
	{
		"wwfurl": "http://www.wwfguianas.org",
		"name": "Guianas"
	},
	{
		"wwfurl": "http://www.wwf.org.hk",
		"name": "Hong Kong"
	},
	{
		"wwfurl": "http://www.wwf.hu",
		"name": "Hungary"
	},
	{
		"wwfurl": "http://www.wwfindia.org",
		"name": "India"
	},
	{
		"wwfurl": "http://www.wwf.or.id",
		"name": "Indonesia"
	},
	{
		"wwfurl": "http://www.wwf.it",
		"name": "Italy"
	},
	{
		"wwfurl": "http://www.wwf.or.jp",
		"name": "Japan"
	},
	{
		"wwfurl": "http://wwfkorea.or.kr",
		"name": "Korea"
	},
	{
		"wwfurl": "http://www.panda.org/who_we_are/wwf_offices/laos",
		"name": "Laos"
	},
	{
		"wwfurl": "http://www.wwf.mg",
		"name": "Madagascar"
	},
	{
		"wwfurl": "http://www.wwf.org.my",
		"name": "Malaysia"
	},
	{
		"wwfurl": "http://mediterranean.panda.org",
		"name": "Mediterranean"
	},
	{
		"wwfurl": "http://www.wwf.org.mx",
		"name": "Mexico"
	},
	{
		"wwfurl": "http://mongolia.panda.org",
		"name": "Mongolia"
	},
	{
		"wwfurl": "http://www.wwf.org.mz",
		"name": "Mozambique"
	},
	{
		"wwfurl": "http://nepal.panda.org",
		"name": "Nepal"
	},
	{
		"wwfurl": "http://www.wnf.nl",
		"name": "Netherlands"
	},
	{
		"wwfurl": "http://www.wwf.org.nz",
		"name": "New Zealand"
	},
	{
		"wwfurl": "http://www.wwf.no",
		"name": "Norway"
	},
	{
		"wwfurl": "http://www.wwfpak.org",
		"name": "Pakistan"
	},
	{
		"wwfurl": "http://www.panda.org/who_we_are/wwf_offices/papua_new_guinea",
		"name": "Papua New Guinea"
	},
	{
		"wwfurl": "http://www.wwf.org.py",
		"name": "Paraguay"
	},
	{
		"wwfurl": "http://peru.panda.org",
		"name": "Peru"
	},
	{
		"wwfurl": "http://www.wwf.org.ph",
		"name": "Philippines"
	},
	{
		"wwfurl": "http://www.wwf.pl",
		"name": "Poland"
	},
	{
		"wwfurl": "http://www.wwf.pt",
		"name": "Portugal"
	},
	{
		"wwfurl": "http://romania.panda.org",
		"name": "Romania"
	},
	{
		"wwfurl": "http://www.wwf.ru",
		"name": "Russia"
	},
	{
		"wwfurl": "http://www.panda.org/who_we_are/wwf_offices/senegal",
		"name": "Senegal"
	},
	{
		"wwfurl": "http://www.panda.org/sr",
		"name": "Serbia"
	},
	{
		"wwfurl": "http://www.wwf.sg",
		"name": "Singapore"
	},
	{
		"wwfurl": "http://www.wwf.org.za",
		"name": "South Africa"
	},
	{
		"wwfurl": "http://www.wwfpacific.org",
		"name": "South Pacific"
	},
	{
		"wwfurl": "http://www.wwf.es",
		"name": "Spain"
	},
	{
		"wwfurl": "http://www.wwfguianas.org",
		"name": "Suriname"
	},
	{
		"wwfurl": "http://www.wwf.se",
		"name": "Sweden"
	},
	{
		"wwfurl": "http://www.wwf.ch",
		"name": "Switzerland"
	},
	{
		"wwfurl": "http://www.panda.org/who_we_are/wwf_offices/tanzania",
		"name": "Tanzania"
	},
	{
		"wwfurl": "http://www.wwf.or.th",
		"name": "Thailand"
	},
	{
		"wwfurl": "http://www.wwf.org.tr",
		"name": "Turkey"
	},
	{
		"wwfurl": "http://www.panda.org/uk",
		"name": "Ukraine"
	},
	{
		"wwfurl": "http://uae.panda.org",
		"name": "United Arab Emirates"
	},
	{
		"wwfurl": "http://www.wwf.org.uk",
		"name": "United Kingdom"
	},
	{
		"wwfurl": "http://www.worldwildlife.org",
		"name": "United States"
	},
	{
		"wwfurl": "http://vietnam.panda.org",
		"name": "Vietnam"
	}
];

/***/ }),
/* 749 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[307]);


// WEBPACK FOOTER //
// js/wwfapp.3ac80fc487e625938b43.js